import x, { forwardRef as ee, createElement as Mo, useRef as j, useCallback as ie, useState as q, useContext as U, useEffect as re, createContext as G, useMemo as H, version as _5, cloneElement as _c } from "react";
import Pu, { flushSync as di, createPortal as U5 } from "react-dom";
var yl = { exports: {} }, ha = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qs;
function W5() {
  if (qs) return ha;
  qs = 1;
  var e = x, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(o, u, s) {
    var d, c = {}, f = null, b = null;
    s !== void 0 && (f = "" + s), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (d in u) r.call(u, d) && !l.hasOwnProperty(d) && (c[d] = u[d]);
    if (o && o.defaultProps) for (d in u = o.defaultProps, u) c[d] === void 0 && (c[d] = u[d]);
    return { $$typeof: t, type: o, key: f, ref: b, props: c, _owner: a.current };
  }
  return ha.Fragment = n, ha.jsx = i, ha.jsxs = i, ha;
}
var ma = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xs;
function G5() {
  return Xs || (Xs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = x, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), p = Symbol.iterator, h = "@@iterator";
    function m(N) {
      if (N === null || typeof N != "object")
        return null;
      var Y = p && N[p] || N[h];
      return typeof Y == "function" ? Y : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(N) {
      {
        for (var Y = arguments.length, le = new Array(Y > 1 ? Y - 1 : 0), he = 1; he < Y; he++)
          le[he - 1] = arguments[he];
        w("error", N, le);
      }
    }
    function w(N, Y, le) {
      {
        var he = v.ReactDebugCurrentFrame, Ae = he.getStackAddendum();
        Ae !== "" && (Y += "%s", le = le.concat([Ae]));
        var Ve = le.map(function(Pe) {
          return String(Pe);
        });
        Ve.unshift("Warning: " + Y), Function.prototype.apply.call(console[N], console, Ve);
      }
    }
    var C = !1, D = !1, P = !1, R = !1, V = !1, L;
    L = Symbol.for("react.module.reference");
    function A(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === r || N === l || V || N === a || N === s || N === d || R || N === b || C || D || P || typeof N == "object" && N !== null && (N.$$typeof === f || N.$$typeof === c || N.$$typeof === i || N.$$typeof === o || N.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === L || N.getModuleId !== void 0));
    }
    function $(N, Y, le) {
      var he = N.displayName;
      if (he)
        return he;
      var Ae = Y.displayName || Y.name || "";
      return Ae !== "" ? le + "(" + Ae + ")" : le;
    }
    function S(N) {
      return N.displayName || "Context";
    }
    function T(N) {
      if (N == null)
        return null;
      if (typeof N.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof N == "function")
        return N.displayName || N.name || null;
      if (typeof N == "string")
        return N;
      switch (N) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case l:
          return "Profiler";
        case a:
          return "StrictMode";
        case s:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case o:
            var Y = N;
            return S(Y) + ".Consumer";
          case i:
            var le = N;
            return S(le._context) + ".Provider";
          case u:
            return $(N, N.render, "ForwardRef");
          case c:
            var he = N.displayName || null;
            return he !== null ? he : T(N.type) || "Memo";
          case f: {
            var Ae = N, Ve = Ae._payload, Pe = Ae._init;
            try {
              return T(Pe(Ve));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, K = 0, g, B, k, I, O, F, z;
    function Z() {
    }
    Z.__reactDisabledLog = !0;
    function te() {
      {
        if (K === 0) {
          g = console.log, B = console.info, k = console.warn, I = console.error, O = console.group, F = console.groupCollapsed, z = console.groupEnd;
          var N = {
            configurable: !0,
            enumerable: !0,
            value: Z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: N,
            log: N,
            warn: N,
            error: N,
            group: N,
            groupCollapsed: N,
            groupEnd: N
          });
        }
        K++;
      }
    }
    function ue() {
      {
        if (K--, K === 0) {
          var N = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, N, {
              value: g
            }),
            info: M({}, N, {
              value: B
            }),
            warn: M({}, N, {
              value: k
            }),
            error: M({}, N, {
              value: I
            }),
            group: M({}, N, {
              value: O
            }),
            groupCollapsed: M({}, N, {
              value: F
            }),
            groupEnd: M({}, N, {
              value: z
            })
          });
        }
        K < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var be = v.ReactCurrentDispatcher, ce;
    function X(N, Y, le) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (Ae) {
            var he = Ae.stack.trim().match(/\n( *(at )?)/);
            ce = he && he[1] || "";
          }
        return `
` + ce + N;
      }
    }
    var pe = !1, ve;
    {
      var W = typeof WeakMap == "function" ? WeakMap : Map;
      ve = new W();
    }
    function se(N, Y) {
      if (!N || pe)
        return "";
      {
        var le = ve.get(N);
        if (le !== void 0)
          return le;
      }
      var he;
      pe = !0;
      var Ae = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ve;
      Ve = be.current, be.current = null, te();
      try {
        if (Y) {
          var Pe = function() {
            throw Error();
          };
          if (Object.defineProperty(Pe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Pe, []);
            } catch (kt) {
              he = kt;
            }
            Reflect.construct(N, [], Pe);
          } else {
            try {
              Pe.call();
            } catch (kt) {
              he = kt;
            }
            N.call(Pe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (kt) {
            he = kt;
          }
          N();
        }
      } catch (kt) {
        if (kt && he && typeof kt.stack == "string") {
          for (var we = kt.stack.split(`
`), Dt = he.stack.split(`
`), Ye = we.length - 1, nt = Dt.length - 1; Ye >= 1 && nt >= 0 && we[Ye] !== Dt[nt]; )
            nt--;
          for (; Ye >= 1 && nt >= 0; Ye--, nt--)
            if (we[Ye] !== Dt[nt]) {
              if (Ye !== 1 || nt !== 1)
                do
                  if (Ye--, nt--, nt < 0 || we[Ye] !== Dt[nt]) {
                    var Ut = `
` + we[Ye].replace(" at new ", " at ");
                    return N.displayName && Ut.includes("<anonymous>") && (Ut = Ut.replace("<anonymous>", N.displayName)), typeof N == "function" && ve.set(N, Ut), Ut;
                  }
                while (Ye >= 1 && nt >= 0);
              break;
            }
        }
      } finally {
        pe = !1, be.current = Ve, ue(), Error.prepareStackTrace = Ae;
      }
      var Ir = N ? N.displayName || N.name : "", hr = Ir ? X(Ir) : "";
      return typeof N == "function" && ve.set(N, hr), hr;
    }
    function fe(N, Y, le) {
      return se(N, !1);
    }
    function We(N) {
      var Y = N.prototype;
      return !!(Y && Y.isReactComponent);
    }
    function ye(N, Y, le) {
      if (N == null)
        return "";
      if (typeof N == "function")
        return se(N, We(N));
      if (typeof N == "string")
        return X(N);
      switch (N) {
        case s:
          return X("Suspense");
        case d:
          return X("SuspenseList");
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case u:
            return fe(N.render);
          case c:
            return ye(N.type, Y, le);
          case f: {
            var he = N, Ae = he._payload, Ve = he._init;
            try {
              return ye(Ve(Ae), Y, le);
            } catch {
            }
          }
        }
      return "";
    }
    var st = Object.prototype.hasOwnProperty, $t = {}, Q = v.ReactDebugCurrentFrame;
    function ae(N) {
      if (N) {
        var Y = N._owner, le = ye(N.type, N._source, Y ? Y.type : null);
        Q.setExtraStackFrame(le);
      } else
        Q.setExtraStackFrame(null);
    }
    function ge(N, Y, le, he, Ae) {
      {
        var Ve = Function.call.bind(st);
        for (var Pe in N)
          if (Ve(N, Pe)) {
            var we = void 0;
            try {
              if (typeof N[Pe] != "function") {
                var Dt = Error((he || "React class") + ": " + le + " type `" + Pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof N[Pe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Dt.name = "Invariant Violation", Dt;
              }
              we = N[Pe](Y, Pe, he, le, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ye) {
              we = Ye;
            }
            we && !(we instanceof Error) && (ae(Ae), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", he || "React class", le, Pe, typeof we), ae(null)), we instanceof Error && !(we.message in $t) && ($t[we.message] = !0, ae(Ae), y("Failed %s type: %s", le, we.message), ae(null));
          }
      }
    }
    var Se = Array.isArray;
    function xt(N) {
      return Se(N);
    }
    function cr(N) {
      {
        var Y = typeof Symbol == "function" && Symbol.toStringTag, le = Y && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return le;
      }
    }
    function Hn(N) {
      try {
        return Vt(N), !1;
      } catch {
        return !0;
      }
    }
    function Vt(N) {
      return "" + N;
    }
    function _t(N) {
      if (Hn(N))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", cr(N)), Vt(N);
    }
    var It = v.ReactCurrentOwner, fr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _n, br;
    function pa(N) {
      if (st.call(N, "ref")) {
        var Y = Object.getOwnPropertyDescriptor(N, "ref").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return N.ref !== void 0;
    }
    function pt(N) {
      if (st.call(N, "key")) {
        var Y = Object.getOwnPropertyDescriptor(N, "key").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return N.key !== void 0;
    }
    function pr(N, Y) {
      typeof N.ref == "string" && It.current;
    }
    function Zi(N, Y) {
      {
        var le = function() {
          _n || (_n = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        le.isReactWarning = !0, Object.defineProperty(N, "key", {
          get: le,
          configurable: !0
        });
      }
    }
    function ml(N, Y) {
      {
        var le = function() {
          br || (br = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        le.isReactWarning = !0, Object.defineProperty(N, "ref", {
          get: le,
          configurable: !0
        });
      }
    }
    var vl = function(N, Y, le, he, Ae, Ve, Pe) {
      var we = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: N,
        key: Y,
        ref: le,
        props: Pe,
        // Record the component responsible for creating this element.
        _owner: Ve
      };
      return we._store = {}, Object.defineProperty(we._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(we, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.defineProperty(we, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ae
      }), Object.freeze && (Object.freeze(we.props), Object.freeze(we)), we;
    };
    function gl(N, Y, le, he, Ae) {
      {
        var Ve, Pe = {}, we = null, Dt = null;
        le !== void 0 && (_t(le), we = "" + le), pt(Y) && (_t(Y.key), we = "" + Y.key), pa(Y) && (Dt = Y.ref, pr(Y, Ae));
        for (Ve in Y)
          st.call(Y, Ve) && !fr.hasOwnProperty(Ve) && (Pe[Ve] = Y[Ve]);
        if (N && N.defaultProps) {
          var Ye = N.defaultProps;
          for (Ve in Ye)
            Pe[Ve] === void 0 && (Pe[Ve] = Ye[Ve]);
        }
        if (we || Dt) {
          var nt = typeof N == "function" ? N.displayName || N.name || "Unknown" : N;
          we && Zi(Pe, nt), Dt && ml(Pe, nt);
        }
        return vl(N, we, Dt, Ae, he, It.current, Pe);
      }
    }
    var Yi = v.ReactCurrentOwner, Hs = v.ReactDebugCurrentFrame;
    function Vr(N) {
      if (N) {
        var Y = N._owner, le = ye(N.type, N._source, Y ? Y.type : null);
        Hs.setExtraStackFrame(le);
      } else
        Hs.setExtraStackFrame(null);
    }
    var qi;
    qi = !1;
    function Xi(N) {
      return typeof N == "object" && N !== null && N.$$typeof === t;
    }
    function _s() {
      {
        if (Yi.current) {
          var N = T(Yi.current.type);
          if (N)
            return `

Check the render method of \`` + N + "`.";
        }
        return "";
      }
    }
    function M5(N) {
      return "";
    }
    var Us = {};
    function N5(N) {
      {
        var Y = _s();
        if (!Y) {
          var le = typeof N == "string" ? N : N.displayName || N.name;
          le && (Y = `

Check the top-level render call using <` + le + ">.");
        }
        return Y;
      }
    }
    function Ws(N, Y) {
      {
        if (!N._store || N._store.validated || N.key != null)
          return;
        N._store.validated = !0;
        var le = N5(Y);
        if (Us[le])
          return;
        Us[le] = !0;
        var he = "";
        N && N._owner && N._owner !== Yi.current && (he = " It was passed a child from " + T(N._owner.type) + "."), Vr(N), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', le, he), Vr(null);
      }
    }
    function Gs(N, Y) {
      {
        if (typeof N != "object")
          return;
        if (xt(N))
          for (var le = 0; le < N.length; le++) {
            var he = N[le];
            Xi(he) && Ws(he, Y);
          }
        else if (Xi(N))
          N._store && (N._store.validated = !0);
        else if (N) {
          var Ae = m(N);
          if (typeof Ae == "function" && Ae !== N.entries)
            for (var Ve = Ae.call(N), Pe; !(Pe = Ve.next()).done; )
              Xi(Pe.value) && Ws(Pe.value, Y);
        }
      }
    }
    function V5(N) {
      {
        var Y = N.type;
        if (Y == null || typeof Y == "string")
          return;
        var le;
        if (typeof Y == "function")
          le = Y.propTypes;
        else if (typeof Y == "object" && (Y.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Y.$$typeof === c))
          le = Y.propTypes;
        else
          return;
        if (le) {
          var he = T(Y);
          ge(le, N.props, "prop", he, N);
        } else if (Y.PropTypes !== void 0 && !qi) {
          qi = !0;
          var Ae = T(Y);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ae || "Unknown");
        }
        typeof Y.getDefaultProps == "function" && !Y.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function I5(N) {
      {
        for (var Y = Object.keys(N.props), le = 0; le < Y.length; le++) {
          var he = Y[le];
          if (he !== "children" && he !== "key") {
            Vr(N), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", he), Vr(null);
            break;
          }
        }
        N.ref !== null && (Vr(N), y("Invalid attribute `ref` supplied to `React.Fragment`."), Vr(null));
      }
    }
    var Zs = {};
    function Ys(N, Y, le, he, Ae, Ve) {
      {
        var Pe = A(N);
        if (!Pe) {
          var we = "";
          (N === void 0 || typeof N == "object" && N !== null && Object.keys(N).length === 0) && (we += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Dt = M5();
          Dt ? we += Dt : we += _s();
          var Ye;
          N === null ? Ye = "null" : xt(N) ? Ye = "array" : N !== void 0 && N.$$typeof === t ? (Ye = "<" + (T(N.type) || "Unknown") + " />", we = " Did you accidentally export a JSX literal instead of a component?") : Ye = typeof N, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ye, we);
        }
        var nt = gl(N, Y, le, Ae, Ve);
        if (nt == null)
          return nt;
        if (Pe) {
          var Ut = Y.children;
          if (Ut !== void 0)
            if (he)
              if (xt(Ut)) {
                for (var Ir = 0; Ir < Ut.length; Ir++)
                  Gs(Ut[Ir], N);
                Object.freeze && Object.freeze(Ut);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Gs(Ut, N);
        }
        if (st.call(Y, "key")) {
          var hr = T(N), kt = Object.keys(Y).filter(function(H5) {
            return H5 !== "key";
          }), Ji = kt.length > 0 ? "{key: someKey, " + kt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Zs[hr + Ji]) {
            var L5 = kt.length > 0 ? "{" + kt.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ji, hr, L5, hr), Zs[hr + Ji] = !0;
          }
        }
        return N === r ? I5(nt) : V5(nt), nt;
      }
    }
    function O5(N, Y, le) {
      return Ys(N, Y, le, !0);
    }
    function z5(N, Y, le) {
      return Ys(N, Y, le, !1);
    }
    var K5 = z5, j5 = O5;
    ma.Fragment = r, ma.jsx = K5, ma.jsxs = j5;
  }()), ma;
}
var Js;
function Z5() {
  return Js || (Js = 1, process.env.NODE_ENV === "production" ? yl.exports = W5() : yl.exports = G5()), yl.exports;
}
var E = Z5();
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y5 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Uc = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var q5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X5 = ee(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: a = "",
    children: l,
    iconNode: i,
    ...o
  }, u) => Mo(
    "svg",
    {
      ref: u,
      ...q5,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Uc("lucide", a),
      ...o
    },
    [
      ...i.map(([s, d]) => Mo(s, d)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kt = (e, t) => {
  const n = ee(
    ({ className: r, ...a }, l) => Mo(X5, {
      ref: l,
      iconNode: t,
      className: Uc(`lucide-${Y5(e)}`, r),
      ...a
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J5 = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Q5 = Kt("ArrowUp", J5);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ex = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], Wc = Kt("Calendar", ex);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tx = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], ku = Kt("Check", tx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nx = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Qa = Kt("ChevronDown", nx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rx = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Qs = Kt("ChevronLeft", rx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ax = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Oa = Kt("ChevronRight", ax);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lx = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], ix = Kt("ChevronUp", lx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ox = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], ux = Kt("CircleAlert", ox);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sx = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], dx = Kt("Info", sx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cx = [["path", { d: "M5 12h14", key: "1ays0h" }]], fx = Kt("Minus", cx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bx = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], px = Kt("Search", bx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hx = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], mx = Kt("TriangleAlert", hx);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vx = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Su = Kt("X", vx), Ce = typeof document < "u" ? x.useLayoutEffect : () => {
};
function Re(e) {
  const t = j(null);
  return Ce(() => {
    t.current = e;
  }, [
    e
  ]), ie((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
function gx(e) {
  let [t, n] = q(e), r = j(null), a = Re(() => {
    if (!r.current) return;
    let i = r.current.next();
    if (i.done) {
      r.current = null;
      return;
    }
    t === i.value ? a() : n(i.value);
  });
  Ce(() => {
    r.current && a();
  });
  let l = Re((i) => {
    r.current = i(t), a();
  });
  return [
    t,
    l
  ];
}
const zl = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Gc = /* @__PURE__ */ x.createContext(zl), yx = /* @__PURE__ */ x.createContext(!1);
let $x = !!(typeof window < "u" && window.document && window.document.createElement), Qi = /* @__PURE__ */ new WeakMap();
function xx(e = !1) {
  let t = U(Gc), n = j(null);
  if (n.current === null && !e) {
    var r, a;
    let l = (a = x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (r = a.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (l) {
      let i = Qi.get(l);
      i == null ? Qi.set(l, {
        id: t.current,
        state: l.memoizedState
      }) : l.memoizedState !== i.state && (t.current = i.id, Qi.delete(l));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Dx(e) {
  let t = U(Gc);
  t === zl && !$x && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = xx(!!e), r = t === zl && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Cx(e) {
  let t = x.useId(), [n] = q(vn()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${zl.prefix}`;
  return e || `${r}-${t}`;
}
const Ex = typeof x.useId == "function" ? Cx : Dx;
function wx() {
  return !1;
}
function Px() {
  return !0;
}
function kx(e) {
  return () => {
  };
}
function vn() {
  return typeof x.useSyncExternalStore == "function" ? x.useSyncExternalStore(kx, wx, Px) : U(yx);
}
let Sx = !!(typeof window < "u" && window.document && window.document.createElement), Wr = /* @__PURE__ */ new Map(), Ba;
typeof FinalizationRegistry < "u" && (Ba = new FinalizationRegistry((e) => {
  Wr.delete(e);
}));
function Ee(e) {
  let [t, n] = q(e), r = j(null), a = Ex(t), l = j(null);
  if (Ba && Ba.register(l, a), Sx) {
    const i = Wr.get(a);
    i && !i.includes(r) ? i.push(r) : Wr.set(a, [
      r
    ]);
  }
  return Ce(() => {
    let i = a;
    return () => {
      Ba && Ba.unregister(l), Wr.delete(i);
    };
  }, [
    a
  ]), re(() => {
    let i = r.current;
    return i && n(i), () => {
      i && (r.current = null);
    };
  }), a;
}
function Bx(e, t) {
  if (e === t) return e;
  let n = Wr.get(e);
  if (n)
    return n.forEach((a) => a.current = t), t;
  let r = Wr.get(t);
  return r ? (r.forEach((a) => a.current = e), e) : t;
}
function pn(e = []) {
  let t = Ee(), [n, r] = gx(t), a = ie(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return Ce(a, [
    t,
    a,
    ...e
  ]), n;
}
function At(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const ke = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, vt = (e) => e && "window" in e && e.window === e ? e : ke(e).defaultView || window;
function Fx(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function Ax(e) {
  return Fx(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let Tx = !1, Rx = !1;
function Kl() {
  return Tx;
}
function ci() {
  return Rx;
}
function _e(e, t) {
  if (!ci()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : Ax(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const ft = (e = document) => {
  var t;
  if (!ci()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function Be(e) {
  return ci() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
class Mx {
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!_e(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, a = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const i = r, o = this._doc.createTreeWalker(i, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(o), o.currentNode = a, this._currentSetFor.add(o), r = a = i.host;
    } else r = r.parentNode;
    const l = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(l), l.currentNode = a, this._currentSetFor.add(l), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return _e(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        var n;
        let a;
        if (typeof this.filter == "function" ? a = this.filter(t) : !((n = this.filter) === null || n === void 0) && n.acceptNode && (a = this.filter.acceptNode(t)), a === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let l = this.nextNode();
        return l && (this.currentNode = l), l;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.nextNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let a = this.previousNode();
          return a && (this.currentNode = a), a;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        var r;
        let l;
        if (typeof this.filter == "function" ? l = this.filter(n) : !((r = this.filter) === null || r === void 0) && r.acceptNode && (l = this.filter.acceptNode(n)), l === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let i = this.lastChild();
        return i && (this.currentNode = i), i;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let a = this.previousNode();
      return a && (this.currentNode = a), a;
    } else return null;
  }
  /**
   * @deprecated
   */
  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  parentNode() {
    return null;
  }
  constructor(t, n, r, a) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (i) => {
      if (i.nodeType === Node.ELEMENT_NODE) {
        const u = i.shadowRoot;
        if (u) {
          const s = this._doc.createTreeWalker(u, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(s), NodeFilter.FILTER_ACCEPT;
        } else {
          var o;
          if (typeof this.filter == "function") return this.filter(i);
          if (!((o = this.filter) === null || o === void 0) && o.acceptNode) return this.filter.acceptNode(i);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = a ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const l = n.shadowRoot;
    if (l) {
      const i = this._doc.createTreeWalker(l, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(i);
    }
  }
}
function Nx(e, t, n, r) {
  return ci() ? new Mx(e, t, n, r) : e.createTreeWalker(t, n, r);
}
function Zc(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Zc(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Vx() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Zc(e)) && (r && (r += " "), r += t);
  return r;
}
function _(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let a in r) {
      let l = t[a], i = r[a];
      typeof l == "function" && typeof i == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = At(l, i) : (a === "className" || a === "UNSAFE_className") && typeof l == "string" && typeof i == "string" ? t[a] = Vx(l, i) : a === "id" && l && i ? t.id = Bx(l, i) : t[a] = i !== void 0 ? i : l;
    }
  }
  return t;
}
function gn(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    for (let n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
const Ix = /* @__PURE__ */ new Set([
  "id"
]), Ox = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), zx = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Kx = /^(data-.*)$/;
function J(e, t = {}) {
  let { labelable: n, isLink: r, propNames: a } = t, l = {};
  for (const i in e) Object.prototype.hasOwnProperty.call(e, i) && (Ix.has(i) || n && Ox.has(i) || r && zx.has(i) || a != null && a.has(i) || Kx.test(i)) && (l[i] = e[i]);
  return l;
}
function Et(e) {
  if (jx()) e.focus({
    preventScroll: !0
  });
  else {
    let t = Lx(e);
    e.focus(), Hx(t);
  }
}
let $l = null;
function jx() {
  if ($l == null) {
    $l = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return $l = !0, !0;
        }
      });
    } catch {
    }
  }
  return $l;
}
function Lx(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function Hx(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function fi(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function Bu(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function On(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Rn = On(function() {
  return Bu(/^Mac/i);
}), Yc = On(function() {
  return Bu(/^iPhone/i);
}), qc = On(function() {
  return Bu(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Rn() && navigator.maxTouchPoints > 1;
}), Ar = On(function() {
  return Yc() || qc();
}), Al = On(function() {
  return Rn() || Ar();
}), Fu = On(function() {
  return fi(/AppleWebKit/i) && !Xc();
}), Xc = On(function() {
  return fi(/Chrome/i);
}), Er = On(function() {
  return fi(/Android/i);
}), _x = On(function() {
  return fi(/Firefox/i);
}), Ux = /* @__PURE__ */ G({
  isNative: !0,
  open: Zx,
  useHref: (e) => e
});
function Tr() {
  return U(Ux);
}
function Wx(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function wr(e, t, n = !0) {
  var r, a;
  let { metaKey: l, ctrlKey: i, altKey: o, shiftKey: u } = t;
  _x() && (!((a = window.event) === null || a === void 0 || (r = a.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (Rn() ? l = !0 : i = !0);
  let s = Fu() && Rn() && !qc() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: l,
    ctrlKey: i,
    altKey: o,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: l,
    ctrlKey: i,
    altKey: o,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  wr.isOpening = n, Et(e), e.dispatchEvent(s), wr.isOpening = !1;
}
wr.isOpening = !1;
function Gx(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function Zx(e, t) {
  Gx(e, (n) => wr(n, t));
}
function Au(e) {
  let t = Tr();
  var n;
  const r = t.useHref((n = e.href) !== null && n !== void 0 ? n : "");
  return {
    "data-href": e.href ? r : void 0,
    "data-target": e.target,
    "data-rel": e.rel,
    "data-download": e.download,
    "data-ping": e.ping,
    "data-referrer-policy": e.referrerPolicy
  };
}
function bi(e) {
  let t = Tr();
  var n;
  const r = t.useHref((n = e == null ? void 0 : e.href) !== null && n !== void 0 ? n : "");
  return {
    href: e != null && e.href ? r : void 0,
    target: e == null ? void 0 : e.target,
    rel: e == null ? void 0 : e.rel,
    download: e == null ? void 0 : e.download,
    ping: e == null ? void 0 : e.ping,
    referrerPolicy: e == null ? void 0 : e.referrerPolicy
  };
}
let jr = /* @__PURE__ */ new Map(), No = /* @__PURE__ */ new Set();
function ed() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let a = jr.get(r.target);
    a || (a = /* @__PURE__ */ new Set(), jr.set(r.target, a), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), a.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let a = jr.get(r.target);
    if (a && (a.delete(r.propertyName), a.size === 0 && (r.target.removeEventListener("transitioncancel", n), jr.delete(r.target)), jr.size === 0)) {
      for (let l of No) l();
      No.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? ed() : document.addEventListener("DOMContentLoaded", ed));
function Jc(e) {
  requestAnimationFrame(() => {
    jr.size === 0 ? e() : No.add(e);
  });
}
function yn() {
  let e = j(/* @__PURE__ */ new Map()), t = ie((a, l, i, o) => {
    let u = o != null && o.once ? (...s) => {
      e.current.delete(i), i(...s);
    } : i;
    e.current.set(i, {
      type: l,
      eventTarget: a,
      fn: u,
      options: o
    }), a.addEventListener(l, u, o);
  }, []), n = ie((a, l, i, o) => {
    var u;
    let s = ((u = e.current.get(i)) === null || u === void 0 ? void 0 : u.fn) || i;
    a.removeEventListener(l, s, o), e.current.delete(i);
  }, []), r = ie(() => {
    e.current.forEach((a, l) => {
      n(a.eventTarget, a.type, l, a.options);
    });
  }, [
    n
  ]);
  return re(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function Ot(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": a } = e;
  return n = Ee(n), a && r ? a = [
    .../* @__PURE__ */ new Set([
      n,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !r && !a && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": a
  };
}
function Ne(e) {
  const t = j(null);
  return H(() => ({
    get current() {
      return t.current;
    },
    set current(n) {
      t.current = n, typeof e == "function" ? e(n) : e && (e.current = n);
    }
  }), [
    e
  ]);
}
function za(e, t) {
  const n = j(!0), r = j(null);
  re(() => (n.current = !0, () => {
    n.current = !1;
  }), []), re(() => {
    let a = r.current;
    n.current ? n.current = !1 : (!a || t.some((l, i) => !Object.is(l, a[i]))) && e(), r.current = t;
  }, t);
}
function td(e, t) {
  const n = j(!0), r = j(null);
  Ce(() => (n.current = !0, () => {
    n.current = !1;
  }), []), Ce(() => {
    n.current ? n.current = !1 : (!r.current || t.some((a, l) => !Object.is(a, r[l]))) && e(), r.current = t;
  }, t);
}
function Yx() {
  return typeof window.ResizeObserver < "u";
}
function Pr(e) {
  const { ref: t, box: n, onResize: r } = e;
  re(() => {
    let a = t == null ? void 0 : t.current;
    if (a)
      if (Yx()) {
        const l = new window.ResizeObserver((i) => {
          i.length && r();
        });
        return l.observe(a, {
          box: n
        }), () => {
          a && l.unobserve(a);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    t,
    n
  ]);
}
function Tu(e, t) {
  Ce(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function ea(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
}
function ht(e, t) {
  let n = e;
  for (ea(n, t) && (n = n.parentElement); n && !ea(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function qx(e, t) {
  const n = [];
  for (; e && e !== document.documentElement; )
    ea(e, t) && n.push(e), e = e.parentElement;
  return n;
}
let Gt = typeof document < "u" && window.visualViewport;
function Xx() {
  let e = vn(), [t, n] = q(() => e ? {
    width: 0,
    height: 0
  } : nd());
  return re(() => {
    let r = () => {
      n((a) => {
        let l = nd();
        return l.width === a.width && l.height === a.height ? a : l;
      });
    };
    return Gt ? Gt.addEventListener("resize", r) : window.addEventListener("resize", r), () => {
      Gt ? Gt.removeEventListener("resize", r) : window.removeEventListener("resize", r);
    };
  }, []), t;
}
function nd() {
  return {
    width: Gt && (Gt == null ? void 0 : Gt.width) || window.innerWidth,
    height: Gt && (Gt == null ? void 0 : Gt.height) || window.innerHeight
  };
}
let Jx = 0;
const eo = /* @__PURE__ */ new Map();
function $n(e) {
  let [t, n] = q();
  return Ce(() => {
    if (!e) return;
    let r = eo.get(e);
    if (r)
      n(r.element.id);
    else {
      let a = `react-aria-description-${Jx++}`;
      n(a);
      let l = document.createElement("div");
      l.id = a, l.style.display = "none", l.textContent = e, document.body.appendChild(l), r = {
        refCount: 0,
        element: l
      }, eo.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), eo.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function qt(e, t, n, r) {
  let a = Re(n), l = n == null;
  re(() => {
    if (l || !e.current) return;
    let i = e.current;
    return i.addEventListener(t, a, r), () => {
      i.removeEventListener(t, a, r);
    };
  }, [
    e,
    t,
    r,
    l,
    a
  ]);
}
function Qc(e, t) {
  let n = rd(e, t, "left"), r = rd(e, t, "top"), a = t.offsetWidth, l = t.offsetHeight, i = e.scrollLeft, o = e.scrollTop, { borderTopWidth: u, borderLeftWidth: s, scrollPaddingTop: d, scrollPaddingRight: c, scrollPaddingBottom: f, scrollPaddingLeft: b } = getComputedStyle(e), p = i + parseInt(s, 10), h = o + parseInt(u, 10), m = p + e.clientWidth, v = h + e.clientHeight, y = parseInt(d, 10) || 0, w = parseInt(f, 10) || 0, C = parseInt(c, 10) || 0, D = parseInt(b, 10) || 0;
  n <= i + D ? i = n - parseInt(s, 10) - D : n + a > m - C && (i += n + a - m + C), r <= h + y ? o = r - parseInt(u, 10) - y : r + l > v - w && (o += r + l - v + w), e.scrollLeft = i, e.scrollTop = o;
}
function rd(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let a = 0;
  for (; t.offsetParent && (a += t[r], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      a -= e[r];
      break;
    }
    t = t.offsetParent;
  }
  return a;
}
function mt(e, t) {
  if (e && document.contains(e)) {
    let i = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(i).overflow === "hidden") {
      let u = qx(e);
      for (let s of u) Qc(s, e);
    } else {
      var n;
      let { left: u, top: s } = e.getBoundingClientRect();
      e == null || (n = e.scrollIntoView) === null || n === void 0 || n.call(e, {
        block: "nearest"
      });
      let { left: d, top: c } = e.getBoundingClientRect();
      if (Math.abs(u - d) > 1 || Math.abs(s - c) > 1) {
        var r, a, l;
        t == null || (a = t.containingElement) === null || a === void 0 || (r = a.scrollIntoView) === null || r === void 0 || r.call(a, {
          block: "center",
          inline: "center"
        }), (l = e.scrollIntoView) === null || l === void 0 || l.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function Vo(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Er() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Qx(e) {
  return !Er() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function ef(e, t) {
  let n = j(null);
  return e && n.current && t(e, n.current) && (e = n.current), n.current = e, e;
}
function zn(e, t, n) {
  let r = j(t), a = Re(() => {
    n && n(r.current);
  });
  re(() => {
    var l;
    let i = e == null || (l = e.current) === null || l === void 0 ? void 0 : l.form;
    return i == null || i.addEventListener("reset", a), () => {
      i == null || i.removeEventListener("reset", a);
    };
  }, [
    e,
    a
  ]);
}
function e6(e) {
  const t = _5.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
const t6 = "react-aria-clear-focus", n6 = "react-aria-focus";
function Lr(e) {
  return Rn() ? e.metaKey : e.ctrlKey;
}
function pi(e, t = !0) {
  let [n, r] = q(!0), a = n && t;
  return Ce(() => {
    if (a && e.current && "getAnimations" in e.current)
      for (let l of e.current.getAnimations()) l instanceof CSSTransition && l.cancel();
  }, [
    e,
    a
  ]), tf(e, a, ie(() => r(!1), [])), a;
}
function jl(e, t) {
  let [n, r] = q(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let a = n === "exiting";
  return tf(e, a, ie(() => {
    r((l) => l === "exiting" ? "closed" : l);
  }, [])), a;
}
function tf(e, t, n) {
  Ce(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let a = !1;
      return Promise.all(r.map((l) => l.finished)).then(() => {
        a || di(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        a = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Ru = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], r6 = Ru.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Ru.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const a6 = Ru.join(':not([hidden]):not([tabindex="-1"]),');
function Mu(e) {
  return e.matches(r6);
}
function l6(e) {
  return e.matches(a6);
}
function Me(e, t, n) {
  let [r, a] = q(e || t), l = j(e !== void 0), i = e !== void 0;
  re(() => {
    let s = l.current;
    s !== i && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${s ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}.`), l.current = i;
  }, [
    i
  ]);
  let o = i ? e : r, u = ie((s, ...d) => {
    let c = (f, ...b) => {
      n && (Object.is(o, f) || n(f, ...b)), i || (o = f);
    };
    typeof s == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a((b, ...p) => {
      let h = s(i ? o : b, ...p);
      return c(h, ...d), i ? b : h;
    })) : (i || a(s), c(s, ...d));
  }, [
    i,
    o,
    n
  ]);
  return [
    o,
    u
  ];
}
function Qe(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function xl(e, t) {
  let n = e, r = t.toString(), a = r.indexOf("."), l = a >= 0 ? r.length - a : 0;
  if (l > 0) {
    let i = Math.pow(10, l);
    n = Math.round(n * i) / i;
  }
  return n;
}
function lt(e, t, n, r) {
  t = Number(t), n = Number(n);
  let a = (e - (isNaN(t) ? 0 : t)) % r, l = xl(Math.abs(a) * 2 >= r ? e + Math.sign(a) * (r - Math.abs(a)) : e - a, r);
  return isNaN(t) ? !isNaN(n) && l > n && (l = Math.floor(xl(n / r, r)) * r) : l < t ? l = t : !isNaN(n) && l > n && (l = t + Math.floor(xl((n - t) / r, r)) * r), l = xl(l, r), l;
}
function it(e, t, n = 10) {
  const r = Math.pow(n, t);
  return Math.round(e * r) / r;
}
function Nu(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function nf(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function rf(e) {
  let t = j({
    isFocused: !1,
    observer: null
  });
  Ce(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = Re((r) => {
    e == null || e(r);
  });
  return ie((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r.target, l = (i) => {
        if (t.current.isFocused = !1, a.disabled) {
          let o = Nu(i);
          n(o);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", l, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var i;
          (i = t.current.observer) === null || i === void 0 || i.disconnect();
          let o = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: o
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: o
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let Ll = !1;
function ad(e) {
  for (; e && !Mu(e); ) e = e.parentElement;
  let t = vt(e), n = t.document.activeElement;
  if (!n || n === e) return;
  Ll = !0;
  let r = !1, a = (d) => {
    (d.target === n || r) && d.stopImmediatePropagation();
  }, l = (d) => {
    (d.target === n || r) && (d.stopImmediatePropagation(), !e && !r && (r = !0, Et(n), u()));
  }, i = (d) => {
    (d.target === e || r) && d.stopImmediatePropagation();
  }, o = (d) => {
    (d.target === e || r) && (d.stopImmediatePropagation(), r || (r = !0, Et(n), u()));
  };
  t.addEventListener("blur", a, !0), t.addEventListener("focusout", l, !0), t.addEventListener("focusin", o, !0), t.addEventListener("focus", i, !0);
  let u = () => {
    cancelAnimationFrame(s), t.removeEventListener("blur", a, !0), t.removeEventListener("focusout", l, !0), t.removeEventListener("focusin", o, !0), t.removeEventListener("focus", i, !0), Ll = !1, r = !1;
  }, s = requestAnimationFrame(u);
  return u;
}
let Hr = "default", Io = "", Tl = /* @__PURE__ */ new WeakMap();
function Oo(e) {
  if (Ar()) {
    if (Hr === "default") {
      const t = ke(e);
      Io = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Hr = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Tl.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Rl(e) {
  if (Ar()) {
    if (Hr !== "disabled") return;
    Hr = "restoring", setTimeout(() => {
      Jc(() => {
        if (Hr === "restoring") {
          const t = ke(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = Io || ""), Io = "", Hr = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Tl.has(e)) {
    let t = Tl.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Tl.delete(e);
  }
}
const Ka = x.createContext({
  register: () => {
  }
});
Ka.displayName = "PressResponderContext";
function i6(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function af(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function o6(e, t) {
  var n = af(e, t, "get");
  return i6(e, n);
}
function u6(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function el(e, t, n) {
  u6(e, t), t.set(e, n);
}
function s6(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function ld(e, t, n) {
  var r = af(e, t, "set");
  return s6(e, r, n), n;
}
function d6(e) {
  let t = U(Ka);
  if (t) {
    let { register: n, ...r } = t;
    e = _(r, e), n();
  }
  return Tu(t, e.ref), e;
}
var Dl = /* @__PURE__ */ new WeakMap();
class Cl {
  continuePropagation() {
    ld(this, Dl, !1);
  }
  get shouldStopPropagation() {
    return o6(this, Dl);
  }
  constructor(t, n, r, a) {
    el(this, Dl, {
      writable: !0,
      value: void 0
    }), ld(this, Dl, !0);
    var l;
    let i = (l = a == null ? void 0 : a.target) !== null && l !== void 0 ? l : r.currentTarget;
    const o = i == null ? void 0 : i.getBoundingClientRect();
    let u, s = 0, d, c = null;
    r.clientX != null && r.clientY != null && (d = r.clientX, c = r.clientY), o && (d != null && c != null ? (u = d - o.left, s = c - o.top) : (u = o.width / 2, s = o.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = u, this.y = s;
  }
}
const id = Symbol("linkClicked");
function Tt(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: a, onPressUp: l, onClick: i, isDisabled: o, isPressed: u, preventFocusOnPress: s, shouldCancelOnPointerExit: d, allowTextSelectionOnPress: c, ref: f, ...b } = d6(e), [p, h] = q(!1), m = j({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: v, removeAllGlobalListeners: y } = yn(), w = Re(($, S) => {
    let T = m.current;
    if (o || T.didFirePressStart) return !1;
    let M = !0;
    if (T.isTriggeringEvent = !0, r) {
      let K = new Cl("pressstart", S, $);
      r(K), M = K.shouldStopPropagation;
    }
    return n && n(!0), T.isTriggeringEvent = !1, T.didFirePressStart = !0, h(!0), M;
  }), C = Re(($, S, T = !0) => {
    let M = m.current;
    if (!M.didFirePressStart) return !1;
    M.didFirePressStart = !1, M.isTriggeringEvent = !0;
    let K = !0;
    if (a) {
      let g = new Cl("pressend", S, $);
      a(g), K = g.shouldStopPropagation;
    }
    if (n && n(!1), h(!1), t && T && !o) {
      let g = new Cl("press", S, $);
      t(g), K && (K = g.shouldStopPropagation);
    }
    return M.isTriggeringEvent = !1, K;
  }), D = Re(($, S) => {
    let T = m.current;
    if (o) return !1;
    if (l) {
      T.isTriggeringEvent = !0;
      let M = new Cl("pressup", S, $);
      return l(M), T.isTriggeringEvent = !1, M.shouldStopPropagation;
    }
    return !0;
  }), P = Re(($) => {
    let S = m.current;
    if (S.isPressed && S.target) {
      S.didFirePressStart && S.pointerType != null && C(Or(S.target, $), S.pointerType, !1), S.isPressed = !1, S.isOverTarget = !1, S.activePointerId = null, S.pointerType = null, y(), c || Rl(S.target);
      for (let T of S.disposables) T();
      S.disposables = [];
    }
  }), R = Re(($) => {
    d && P($);
  }), V = Re(($) => {
    i == null || i($);
  }), L = Re(($, S) => {
    if (i) {
      let T = new MouseEvent("click", $);
      nf(T, S), i(Nu(T));
    }
  }), A = H(() => {
    let $ = m.current, S = {
      onKeyDown(M) {
        if (to(M.nativeEvent, M.currentTarget) && _e(M.currentTarget, Be(M.nativeEvent))) {
          var K;
          sd(Be(M.nativeEvent), M.key) && M.preventDefault();
          let g = !0;
          if (!$.isPressed && !M.repeat) {
            $.target = M.currentTarget, $.isPressed = !0, $.pointerType = "keyboard", g = w(M, "keyboard");
            let B = M.currentTarget, k = (I) => {
              to(I, B) && !I.repeat && _e(B, Be(I)) && $.target && D(Or($.target, I), "keyboard");
            };
            v(ke(M.currentTarget), "keyup", At(k, T), !0);
          }
          g && M.stopPropagation(), M.metaKey && Rn() && ((K = $.metaKeyEvents) === null || K === void 0 || K.set(M.key, M.nativeEvent));
        } else M.key === "Meta" && ($.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(M) {
        if (!(M && !_e(M.currentTarget, Be(M.nativeEvent))) && M && M.button === 0 && !$.isTriggeringEvent && !wr.isOpening) {
          let K = !0;
          if (o && M.preventDefault(), !$.ignoreEmulatedMouseEvents && !$.isPressed && ($.pointerType === "virtual" || Vo(M.nativeEvent))) {
            let g = w(M, "virtual"), B = D(M, "virtual"), k = C(M, "virtual");
            V(M), K = g && B && k;
          } else if ($.isPressed && $.pointerType !== "keyboard") {
            let g = $.pointerType || M.nativeEvent.pointerType || "virtual";
            K = C(Or(M.currentTarget, M), g, !0), $.isOverTarget = !1, V(M), P(M);
          }
          $.ignoreEmulatedMouseEvents = !1, K && M.stopPropagation();
        }
      }
    }, T = (M) => {
      var K;
      if ($.isPressed && $.target && to(M, $.target)) {
        var g;
        sd(Be(M), M.key) && M.preventDefault();
        let k = Be(M), I = _e($.target, Be(M));
        C(Or($.target, M), "keyboard", I), I && L(M, $.target), y(), M.key !== "Enter" && Vu($.target) && _e($.target, k) && !M[id] && (M[id] = !0, wr($.target, M, !1)), $.isPressed = !1, (g = $.metaKeyEvents) === null || g === void 0 || g.delete(M.key);
      } else if (M.key === "Meta" && (!((K = $.metaKeyEvents) === null || K === void 0) && K.size)) {
        var B;
        let k = $.metaKeyEvents;
        $.metaKeyEvents = void 0;
        for (let I of k.values()) (B = $.target) === null || B === void 0 || B.dispatchEvent(new KeyboardEvent("keyup", I));
      }
    };
    if (typeof PointerEvent < "u") {
      S.onPointerDown = (g) => {
        if (g.button !== 0 || !_e(g.currentTarget, Be(g.nativeEvent))) return;
        if (Qx(g.nativeEvent)) {
          $.pointerType = "virtual";
          return;
        }
        $.pointerType = g.pointerType;
        let B = !0;
        if (!$.isPressed) {
          $.isPressed = !0, $.isOverTarget = !0, $.activePointerId = g.pointerId, $.target = g.currentTarget, c || Oo($.target), B = w(g, $.pointerType);
          let k = Be(g.nativeEvent);
          "releasePointerCapture" in k && k.releasePointerCapture(g.pointerId), v(ke(g.currentTarget), "pointerup", M, !1), v(ke(g.currentTarget), "pointercancel", K, !1);
        }
        B && g.stopPropagation();
      }, S.onMouseDown = (g) => {
        if (_e(g.currentTarget, Be(g.nativeEvent)) && g.button === 0) {
          if (s) {
            let B = ad(g.target);
            B && $.disposables.push(B);
          }
          g.stopPropagation();
        }
      }, S.onPointerUp = (g) => {
        !_e(g.currentTarget, Be(g.nativeEvent)) || $.pointerType === "virtual" || g.button === 0 && D(g, $.pointerType || g.pointerType);
      }, S.onPointerEnter = (g) => {
        g.pointerId === $.activePointerId && $.target && !$.isOverTarget && $.pointerType != null && ($.isOverTarget = !0, w(Or($.target, g), $.pointerType));
      }, S.onPointerLeave = (g) => {
        g.pointerId === $.activePointerId && $.target && $.isOverTarget && $.pointerType != null && ($.isOverTarget = !1, C(Or($.target, g), $.pointerType, !1), R(g));
      };
      let M = (g) => {
        if (g.pointerId === $.activePointerId && $.isPressed && g.button === 0 && $.target) {
          if (_e($.target, Be(g)) && $.pointerType != null) {
            let B = !1, k = setTimeout(() => {
              $.isPressed && $.target instanceof HTMLElement && (B ? P(g) : (Et($.target), $.target.click()));
            }, 80);
            v(g.currentTarget, "click", () => B = !0, !0), $.disposables.push(() => clearTimeout(k));
          } else P(g);
          $.isOverTarget = !1;
        }
      }, K = (g) => {
        P(g);
      };
      S.onDragStart = (g) => {
        _e(g.currentTarget, Be(g.nativeEvent)) && P(g);
      };
    } else if (process.env.NODE_ENV === "test") {
      S.onMouseDown = (g) => {
        if (g.button !== 0 || !_e(g.currentTarget, Be(g.nativeEvent))) return;
        if ($.ignoreEmulatedMouseEvents) {
          g.stopPropagation();
          return;
        }
        if ($.isPressed = !0, $.isOverTarget = !0, $.target = g.currentTarget, $.pointerType = Vo(g.nativeEvent) ? "virtual" : "mouse", di(() => w(g, $.pointerType)) && g.stopPropagation(), s) {
          let k = ad(g.target);
          k && $.disposables.push(k);
        }
        v(ke(g.currentTarget), "mouseup", M, !1);
      }, S.onMouseEnter = (g) => {
        if (!_e(g.currentTarget, Be(g.nativeEvent))) return;
        let B = !0;
        $.isPressed && !$.ignoreEmulatedMouseEvents && $.pointerType != null && ($.isOverTarget = !0, B = w(g, $.pointerType)), B && g.stopPropagation();
      }, S.onMouseLeave = (g) => {
        if (!_e(g.currentTarget, Be(g.nativeEvent))) return;
        let B = !0;
        $.isPressed && !$.ignoreEmulatedMouseEvents && $.pointerType != null && ($.isOverTarget = !1, B = C(g, $.pointerType, !1), R(g)), B && g.stopPropagation();
      }, S.onMouseUp = (g) => {
        _e(g.currentTarget, Be(g.nativeEvent)) && !$.ignoreEmulatedMouseEvents && g.button === 0 && D(g, $.pointerType || "mouse");
      };
      let M = (g) => {
        if (g.button === 0) {
          if ($.ignoreEmulatedMouseEvents) {
            $.ignoreEmulatedMouseEvents = !1;
            return;
          }
          $.target && $.target.contains(g.target) && $.pointerType != null || P(g), $.isOverTarget = !1;
        }
      };
      S.onTouchStart = (g) => {
        if (!_e(g.currentTarget, Be(g.nativeEvent))) return;
        let B = c6(g.nativeEvent);
        if (!B) return;
        $.activePointerId = B.identifier, $.ignoreEmulatedMouseEvents = !0, $.isOverTarget = !0, $.isPressed = !0, $.target = g.currentTarget, $.pointerType = "touch", c || Oo($.target), w(Un($.target, g), $.pointerType) && g.stopPropagation(), v(vt(g.currentTarget), "scroll", K, !0);
      }, S.onTouchMove = (g) => {
        if (!_e(g.currentTarget, Be(g.nativeEvent))) return;
        if (!$.isPressed) {
          g.stopPropagation();
          return;
        }
        let B = od(g.nativeEvent, $.activePointerId), k = !0;
        B && ud(B, g.currentTarget) ? !$.isOverTarget && $.pointerType != null && ($.isOverTarget = !0, k = w(Un($.target, g), $.pointerType)) : $.isOverTarget && $.pointerType != null && ($.isOverTarget = !1, k = C(Un($.target, g), $.pointerType, !1), R(Un($.target, g))), k && g.stopPropagation();
      }, S.onTouchEnd = (g) => {
        if (!_e(g.currentTarget, Be(g.nativeEvent))) return;
        if (!$.isPressed) {
          g.stopPropagation();
          return;
        }
        let B = od(g.nativeEvent, $.activePointerId), k = !0;
        B && ud(B, g.currentTarget) && $.pointerType != null ? (D(Un($.target, g), $.pointerType), k = C(Un($.target, g), $.pointerType), L(g.nativeEvent, $.target)) : $.isOverTarget && $.pointerType != null && (k = C(Un($.target, g), $.pointerType, !1)), k && g.stopPropagation(), $.isPressed = !1, $.activePointerId = null, $.isOverTarget = !1, $.ignoreEmulatedMouseEvents = !0, $.target && !c && Rl($.target), y();
      }, S.onTouchCancel = (g) => {
        _e(g.currentTarget, Be(g.nativeEvent)) && (g.stopPropagation(), $.isPressed && P(Un($.target, g)));
      };
      let K = (g) => {
        $.isPressed && _e(Be(g), $.target) && P({
          currentTarget: $.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      S.onDragStart = (g) => {
        _e(g.currentTarget, Be(g.nativeEvent)) && P(g);
      };
    }
    return S;
  }, [
    v,
    o,
    s,
    y,
    c,
    P,
    R,
    C,
    w,
    D,
    V,
    L
  ]);
  return re(() => {
    let $ = f == null ? void 0 : f.current;
    $ && $ instanceof vt($).Element && vt($).getComputedStyle($).touchAction === "auto" && ($.style.touchAction = "pan-x pan-y pinch-zoom");
  }, [
    f
  ]), re(() => {
    let $ = m.current;
    return () => {
      var S;
      c || Rl((S = $.target) !== null && S !== void 0 ? S : void 0);
      for (let T of $.disposables) T();
      $.disposables = [];
    };
  }, [
    c
  ]), {
    isPressed: u || p,
    pressProps: _(b, A)
  };
}
function Vu(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function to(e, t) {
  const { key: n, code: r } = e, a = t, l = a.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(a instanceof vt(a).HTMLInputElement && !lf(a, n) || a instanceof vt(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((l === "link" || !l && Vu(a)) && n !== "Enter");
}
function c6(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function od(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    if (a.identifier === t) return a;
  }
  return null;
}
function Un(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Or(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function f6(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function b6(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function ud(e, t) {
  let n = t.getBoundingClientRect(), r = f6(e);
  return b6(n, r);
}
function p6(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Vu(e);
}
function sd(e, t) {
  return e instanceof HTMLInputElement ? !lf(e, t) : p6(e);
}
const h6 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function lf(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : h6.has(e.type);
}
let Mn = null, ja = /* @__PURE__ */ new Set(), Na = /* @__PURE__ */ new Map(), kr = !1, zo = !1;
const m6 = {
  Tab: !0,
  Escape: !0
};
function hi(e, t) {
  for (let n of ja) n(e, t);
}
function v6(e) {
  return !(e.metaKey || !Rn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Hl(e) {
  kr = !0, v6(e) && (Mn = "keyboard", hi("keyboard", e));
}
function Yt(e) {
  Mn = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (kr = !0, hi("pointer", e));
}
function of(e) {
  Vo(e) && (kr = !0, Mn = "virtual");
}
function uf(e) {
  e.target === window || e.target === document || Ll || !e.isTrusted || (!kr && !zo && (Mn = "virtual", hi("virtual", e)), kr = !1, zo = !1);
}
function sf() {
  Ll || (kr = !1, zo = !0);
}
function _l(e) {
  if (typeof window > "u" || Na.get(vt(e))) return;
  const t = vt(e), n = ke(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    kr = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Hl, !0), n.addEventListener("keyup", Hl, !0), n.addEventListener("click", of, !0), t.addEventListener("focus", uf, !0), t.addEventListener("blur", sf, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Yt, !0), n.addEventListener("pointermove", Yt, !0), n.addEventListener("pointerup", Yt, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Yt, !0), n.addEventListener("mousemove", Yt, !0), n.addEventListener("mouseup", Yt, !0)), t.addEventListener("beforeunload", () => {
    df(e);
  }, {
    once: !0
  }), Na.set(t, {
    focus: r
  });
}
const df = (e, t) => {
  const n = vt(e), r = ke(e);
  t && r.removeEventListener("DOMContentLoaded", t), Na.has(n) && (n.HTMLElement.prototype.focus = Na.get(n).focus, r.removeEventListener("keydown", Hl, !0), r.removeEventListener("keyup", Hl, !0), r.removeEventListener("click", of, !0), n.removeEventListener("focus", uf, !0), n.removeEventListener("blur", sf, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Yt, !0), r.removeEventListener("pointermove", Yt, !0), r.removeEventListener("pointerup", Yt, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Yt, !0), r.removeEventListener("mousemove", Yt, !0), r.removeEventListener("mouseup", Yt, !0)), Na.delete(n));
};
function g6(e) {
  const t = ke(e);
  let n;
  return t.readyState !== "loading" ? _l(e) : (n = () => {
    _l(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => df(e, n);
}
typeof document < "u" && g6();
function Nn() {
  return Mn !== "pointer";
}
function ta() {
  return Mn;
}
function Iu(e) {
  Mn = e, hi(e, null);
}
function Ou() {
  _l();
  let [e, t] = q(Mn);
  return re(() => {
    let n = () => {
      t(Mn);
    };
    return ja.add(n), () => {
      ja.delete(n);
    };
  }, []), vn() ? null : e;
}
const y6 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $6(e, t, n) {
  let r = ke(n == null ? void 0 : n.target);
  const a = typeof window < "u" ? vt(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, l = typeof window < "u" ? vt(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, i = typeof window < "u" ? vt(n == null ? void 0 : n.target).HTMLElement : HTMLElement, o = typeof window < "u" ? vt(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof a && !y6.has(r.activeElement.type) || r.activeElement instanceof l || r.activeElement instanceof i && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof o && !m6[n.key]);
}
function x6(e, t, n) {
  _l(), re(() => {
    let r = (a, l) => {
      $6(!!(n != null && n.isTextInput), a, l) && e(Nn());
    };
    return ja.add(r), () => {
      ja.delete(r);
    };
  }, t);
}
function He(e) {
  const t = ke(e), n = ft(t);
  if (ta() === "virtual") {
    let r = n;
    Jc(() => {
      ft(t) === r && e.isConnected && Et(e);
    });
  } else Et(e);
}
function na(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const l = ie((u) => {
    if (u.target === u.currentTarget)
      return r && r(u), a && a(!1), !0;
  }, [
    r,
    a
  ]), i = rf(l), o = ie((u) => {
    const s = ke(u.target), d = s ? ft(s) : ft();
    u.target === u.currentTarget && d === Be(u.nativeEvent) && (n && n(u), a && a(!0), i(u));
  }, [
    a,
    n,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? o : void 0,
      onBlur: !t && (r || a) ? l : void 0
    }
  };
}
function dd(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function la(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: dd(e.onKeyDown),
      onKeyUp: dd(e.onKeyUp)
    }
  };
}
let Ul = /* @__PURE__ */ x.createContext(null);
function D6(e) {
  let t = U(Ul) || {};
  Tu(t, e);
  let { ref: n, ...r } = t;
  return r;
}
const C6 = /* @__PURE__ */ x.forwardRef(function(t, n) {
  let { children: r, ...a } = t, l = Ne(n), i = {
    ...a,
    ref: l
  };
  return /* @__PURE__ */ x.createElement(Ul.Provider, {
    value: i
  }, r);
});
function un(e, t) {
  let { focusProps: n } = na(e), { keyboardProps: r } = la(e), a = _(n, r), l = D6(t), i = e.isDisabled ? {} : l, o = j(e.autoFocus);
  re(() => {
    o.current && t.current && He(t.current), o.current = !1;
  }, [
    t
  ]);
  let u = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (u = void 0), {
    focusableProps: _({
      ...a,
      tabIndex: u
    }, i)
  };
}
const E6 = /* @__PURE__ */ ee(({ children: e, ...t }, n) => {
  n = Ne(n);
  let { focusableProps: r } = un(t, n), a = x.Children.only(e);
  re(() => {
    if (process.env.NODE_ENV === "production") return;
    let i = n.current;
    if (!i || !(i instanceof vt(i).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!t.isDisabled && !Mu(i)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (i.localName !== "button" && i.localName !== "input" && i.localName !== "select" && i.localName !== "textarea" && i.localName !== "a" && i.localName !== "area" && i.localName !== "summary" && i.localName !== "img" && i.localName !== "svg") {
      let o = i.getAttribute("role");
      o ? (
        // https://w3c.github.io/aria/#widget_roles
        o !== "application" && o !== "button" && o !== "checkbox" && o !== "combobox" && o !== "gridcell" && o !== "link" && o !== "menuitem" && o !== "menuitemcheckbox" && o !== "menuitemradio" && o !== "option" && o !== "radio" && o !== "searchbox" && o !== "separator" && o !== "slider" && o !== "spinbutton" && o !== "switch" && o !== "tab" && o !== "tabpanel" && o !== "textbox" && o !== "treeitem" && // aria-describedby is also announced on these roles
        o !== "img" && o !== "meter" && o !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${o}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    t.isDisabled
  ]);
  let l = parseInt(x.version, 10) < 19 ? a.ref : a.props.ref;
  return /* @__PURE__ */ x.cloneElement(a, {
    ..._(r, a.props),
    // @ts-ignore
    ref: gn(l, n)
  });
}), w6 = /* @__PURE__ */ x.forwardRef(({ children: e, ...t }, n) => {
  let r = j(!1), a = U(Ka);
  n = Ne(n || (a == null ? void 0 : a.ref));
  let l = _(a || {}, {
    ...t,
    ref: n,
    register() {
      r.current = !0, a && a.register();
    }
  });
  return Tu(a, n), re(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ x.createElement(Ka.Provider, {
    value: l
  }, e);
});
function P6({ children: e }) {
  let t = H(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ x.createElement(Ka.Provider, {
    value: t
  }, e);
}
function jt(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, l = j({
    isFocusWithin: !1
  }), { addGlobalListener: i, removeAllGlobalListeners: o } = yn(), u = ie((c) => {
    c.currentTarget.contains(c.target) && l.current.isFocusWithin && !c.currentTarget.contains(c.relatedTarget) && (l.current.isFocusWithin = !1, o(), n && n(c), a && a(!1));
  }, [
    n,
    a,
    l,
    o
  ]), s = rf(u), d = ie((c) => {
    if (!c.currentTarget.contains(c.target)) return;
    const f = ke(c.target), b = ft(f);
    if (!l.current.isFocusWithin && b === Be(c.nativeEvent)) {
      r && r(c), a && a(!0), l.current.isFocusWithin = !0, s(c);
      let p = c.currentTarget;
      i(f, "focus", (h) => {
        if (l.current.isFocusWithin && !_e(p, h.target)) {
          let m = new f.defaultView.FocusEvent("blur", {
            relatedTarget: h.target
          });
          nf(m, p);
          let v = Nu(m);
          u(v);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    a,
    s,
    i,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: d,
      onBlur: u
    }
  };
}
let Wl = !1, no = 0;
function Ko() {
  Wl = !0, setTimeout(() => {
    Wl = !1;
  }, 50);
}
function cd(e) {
  e.pointerType === "touch" && Ko();
}
function k6() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", cd) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", Ko), no++, () => {
      no--, !(no > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", cd) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", Ko));
    };
}
function Ie(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [l, i] = q(!1), o = j({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  re(k6, []);
  let { addGlobalListener: u, removeAllGlobalListeners: s } = yn(), { hoverProps: d, triggerHoverEnd: c } = H(() => {
    let f = (h, m) => {
      if (o.pointerType = m, a || m === "touch" || o.isHovered || !h.currentTarget.contains(h.target)) return;
      o.isHovered = !0;
      let v = h.currentTarget;
      o.target = v, u(ke(h.target), "pointerover", (y) => {
        o.isHovered && o.target && !_e(o.target, y.target) && b(y, y.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: v,
        pointerType: m
      }), n && n(!0), i(!0);
    }, b = (h, m) => {
      let v = o.target;
      o.pointerType = "", o.target = null, !(m === "touch" || !o.isHovered || !v) && (o.isHovered = !1, s(), r && r({
        type: "hoverend",
        target: v,
        pointerType: m
      }), n && n(!1), i(!1));
    }, p = {};
    return typeof PointerEvent < "u" ? (p.onPointerEnter = (h) => {
      Wl && h.pointerType === "mouse" || f(h, h.pointerType);
    }, p.onPointerLeave = (h) => {
      !a && h.currentTarget.contains(h.target) && b(h, h.pointerType);
    }) : process.env.NODE_ENV === "test" && (p.onTouchStart = () => {
      o.ignoreEmulatedMouseEvents = !0;
    }, p.onMouseEnter = (h) => {
      !o.ignoreEmulatedMouseEvents && !Wl && f(h, "mouse"), o.ignoreEmulatedMouseEvents = !1;
    }, p.onMouseLeave = (h) => {
      !a && h.currentTarget.contains(h.target) && b(h, "mouse");
    }), {
      hoverProps: p,
      triggerHoverEnd: b
    };
  }, [
    t,
    n,
    r,
    a,
    o,
    u,
    s
  ]);
  return re(() => {
    a && c({
      currentTarget: o.target
    }, o.pointerType);
  }, [
    a
  ]), {
    hoverProps: d,
    isHovered: l
  };
}
function S6(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: a } = e, l = j({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), i = Re((u) => {
    n && El(u, t) && (a && a(u), l.current.isPointerDown = !0);
  }), o = Re((u) => {
    n && n(u);
  });
  re(() => {
    let u = l.current;
    if (r) return;
    const s = t.current, d = ke(s);
    if (typeof PointerEvent < "u") {
      let c = (f) => {
        u.isPointerDown && El(f, t) && o(f), u.isPointerDown = !1;
      };
      return d.addEventListener("pointerdown", i, !0), d.addEventListener("pointerup", c, !0), () => {
        d.removeEventListener("pointerdown", i, !0), d.removeEventListener("pointerup", c, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let c = (b) => {
        u.ignoreEmulatedMouseEvents ? u.ignoreEmulatedMouseEvents = !1 : u.isPointerDown && El(b, t) && o(b), u.isPointerDown = !1;
      }, f = (b) => {
        u.ignoreEmulatedMouseEvents = !0, u.isPointerDown && El(b, t) && o(b), u.isPointerDown = !1;
      };
      return d.addEventListener("mousedown", i, !0), d.addEventListener("mouseup", c, !0), d.addEventListener("touchstart", i, !0), d.addEventListener("touchend", f, !0), () => {
        d.removeEventListener("mousedown", i, !0), d.removeEventListener("mouseup", c, !0), d.removeEventListener("touchstart", i, !0), d.removeEventListener("touchend", f, !0);
      };
    }
  }, [
    t,
    r,
    i,
    o
  ]);
}
function El(e, t) {
  if (e.button > 0) return !1;
  if (e.target) {
    const n = e.target.ownerDocument;
    if (!n || !n.documentElement.contains(e.target) || e.target.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
function Sr(e) {
  let { onMoveStart: t, onMove: n, onMoveEnd: r } = e, a = j({
    didMove: !1,
    lastPosition: null,
    id: null
  }), { addGlobalListener: l, removeGlobalListener: i } = yn(), o = Re((d, c, f, b) => {
    f === 0 && b === 0 || (a.current.didMove || (a.current.didMove = !0, t == null || t({
      type: "movestart",
      pointerType: c,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey
    })), n == null || n({
      type: "move",
      pointerType: c,
      deltaX: f,
      deltaY: b,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey
    }));
  }), u = Re((d, c) => {
    Rl(), a.current.didMove && (r == null || r({
      type: "moveend",
      pointerType: c,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey
    }));
  });
  return {
    moveProps: H(() => {
      let d = {}, c = () => {
        Oo(), a.current.didMove = !1;
      };
      if (typeof PointerEvent > "u" && process.env.NODE_ENV === "test") {
        let b = (v) => {
          if (v.button === 0) {
            var y, w, C, D;
            o(v, "mouse", v.pageX - ((C = (y = a.current.lastPosition) === null || y === void 0 ? void 0 : y.pageX) !== null && C !== void 0 ? C : 0), v.pageY - ((D = (w = a.current.lastPosition) === null || w === void 0 ? void 0 : w.pageY) !== null && D !== void 0 ? D : 0)), a.current.lastPosition = {
              pageX: v.pageX,
              pageY: v.pageY
            };
          }
        }, p = (v) => {
          v.button === 0 && (u(v, "mouse"), i(window, "mousemove", b, !1), i(window, "mouseup", p, !1));
        };
        d.onMouseDown = (v) => {
          v.button === 0 && (c(), v.stopPropagation(), v.preventDefault(), a.current.lastPosition = {
            pageX: v.pageX,
            pageY: v.pageY
          }, l(window, "mousemove", b, !1), l(window, "mouseup", p, !1));
        };
        let h = (v) => {
          let y = [
            ...v.changedTouches
          ].findIndex(({ identifier: R }) => R === a.current.id);
          if (y >= 0) {
            var w, C;
            let { pageX: R, pageY: V } = v.changedTouches[y];
            var D, P;
            o(v, "touch", R - ((D = (w = a.current.lastPosition) === null || w === void 0 ? void 0 : w.pageX) !== null && D !== void 0 ? D : 0), V - ((P = (C = a.current.lastPosition) === null || C === void 0 ? void 0 : C.pageY) !== null && P !== void 0 ? P : 0)), a.current.lastPosition = {
              pageX: R,
              pageY: V
            };
          }
        }, m = (v) => {
          [
            ...v.changedTouches
          ].findIndex(({ identifier: w }) => w === a.current.id) >= 0 && (u(v, "touch"), a.current.id = null, i(window, "touchmove", h), i(window, "touchend", m), i(window, "touchcancel", m));
        };
        d.onTouchStart = (v) => {
          if (v.changedTouches.length === 0 || a.current.id != null) return;
          let { pageX: y, pageY: w, identifier: C } = v.changedTouches[0];
          c(), v.stopPropagation(), v.preventDefault(), a.current.lastPosition = {
            pageX: y,
            pageY: w
          }, a.current.id = C, l(window, "touchmove", h, !1), l(window, "touchend", m, !1), l(window, "touchcancel", m, !1);
        };
      } else {
        let b = (h) => {
          if (h.pointerId === a.current.id) {
            var m, v;
            let C = h.pointerType || "mouse";
            var y, w;
            o(h, C, h.pageX - ((y = (m = a.current.lastPosition) === null || m === void 0 ? void 0 : m.pageX) !== null && y !== void 0 ? y : 0), h.pageY - ((w = (v = a.current.lastPosition) === null || v === void 0 ? void 0 : v.pageY) !== null && w !== void 0 ? w : 0)), a.current.lastPosition = {
              pageX: h.pageX,
              pageY: h.pageY
            };
          }
        }, p = (h) => {
          if (h.pointerId === a.current.id) {
            let m = h.pointerType || "mouse";
            u(h, m), a.current.id = null, i(window, "pointermove", b, !1), i(window, "pointerup", p, !1), i(window, "pointercancel", p, !1);
          }
        };
        d.onPointerDown = (h) => {
          h.button === 0 && a.current.id == null && (c(), h.stopPropagation(), h.preventDefault(), a.current.lastPosition = {
            pageX: h.pageX,
            pageY: h.pageY
          }, a.current.id = h.pointerId, l(window, "pointermove", b, !1), l(window, "pointerup", p, !1), l(window, "pointercancel", p, !1));
        };
      }
      let f = (b, p, h) => {
        c(), o(b, "keyboard", p, h), u(b, "keyboard");
      };
      return d.onKeyDown = (b) => {
        switch (b.key) {
          case "Left":
          case "ArrowLeft":
            b.preventDefault(), b.stopPropagation(), f(b, -1, 0);
            break;
          case "Right":
          case "ArrowRight":
            b.preventDefault(), b.stopPropagation(), f(b, 1, 0);
            break;
          case "Up":
          case "ArrowUp":
            b.preventDefault(), b.stopPropagation(), f(b, 0, -1);
            break;
          case "Down":
          case "ArrowDown":
            b.preventDefault(), b.stopPropagation(), f(b, 0, 1);
            break;
        }
      }, d;
    }, [
      a,
      l,
      i,
      o,
      u
    ])
  };
}
function cf(e, t) {
  let { onScroll: n, isDisabled: r } = e, a = ie((l) => {
    l.ctrlKey || (l.preventDefault(), l.stopPropagation(), n && n({
      deltaX: l.deltaX,
      deltaY: l.deltaY
    }));
  }, [
    n
  ]);
  qt(t, "wheel", r ? void 0 : a);
}
const B6 = 500;
function ff(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: a, threshold: l = B6, accessibilityDescription: i } = e;
  const o = j(void 0);
  let { addGlobalListener: u, removeGlobalListener: s } = yn(), { pressProps: d } = Tt({
    isDisabled: t,
    onPressStart(f) {
      if (f.continuePropagation(), (f.pointerType === "mouse" || f.pointerType === "touch") && (n && n({
        ...f,
        type: "longpressstart"
      }), o.current = setTimeout(() => {
        f.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), ke(f.target).activeElement !== f.target && Et(f.target), a && a({
          ...f,
          type: "longpress"
        }), o.current = void 0;
      }, l), f.pointerType === "touch")) {
        let b = (p) => {
          p.preventDefault();
        };
        u(f.target, "contextmenu", b, {
          once: !0
        }), u(window, "pointerup", () => {
          setTimeout(() => {
            s(f.target, "contextmenu", b);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(f) {
      o.current && clearTimeout(o.current), r && (f.pointerType === "mouse" || f.pointerType === "touch") && r({
        ...f,
        type: "longpressend"
      });
    }
  }), c = $n(a && !t ? i : void 0);
  return {
    longPressProps: _(d, c)
  };
}
function F6(e, t) {
  let { elementType: n = "a", onPress: r, onPressStart: a, onPressEnd: l, onClick: i, isDisabled: o, ...u } = e, s = {};
  n !== "a" && (s = {
    role: "link",
    tabIndex: o ? void 0 : 0
  });
  let { focusableProps: d } = un(e, t), { pressProps: c, isPressed: f } = Tt({
    onPress: r,
    onPressStart: a,
    onPressEnd: l,
    onClick: i,
    isDisabled: o,
    ref: t
  }), b = J(u, {
    labelable: !0
  }), p = _(d, c), h = Tr(), m = bi(e);
  return {
    isPressed: f,
    linkProps: _(b, m, {
      ...p,
      ...s,
      "aria-disabled": o || void 0,
      "aria-current": e["aria-current"],
      onClick: (v) => {
        var y;
        (y = c.onClick) === null || y === void 0 || y.call(c, v), !h.isNative && v.currentTarget instanceof HTMLAnchorElement && v.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
        !v.isDefaultPrevented() && Wx(v.currentTarget, v) && e.href && (v.preventDefault(), h.open(v.currentTarget, v, e.href, e.routerOptions));
      }
    })
  };
}
var bf = {};
bf = {
  breadcrumbs: "عناصر الواجهة"
};
var pf = {};
pf = {
  breadcrumbs: "Трохи хляб"
};
var hf = {};
hf = {
  breadcrumbs: "Popis cesty"
};
var mf = {};
mf = {
  breadcrumbs: "Brødkrummer"
};
var vf = {};
vf = {
  breadcrumbs: "Breadcrumbs"
};
var gf = {};
gf = {
  breadcrumbs: "Πλοηγήσεις breadcrumb"
};
var yf = {};
yf = {
  breadcrumbs: "Breadcrumbs"
};
var $f = {};
$f = {
  breadcrumbs: "Migas de pan"
};
var xf = {};
xf = {
  breadcrumbs: "Lingiread"
};
var Df = {};
Df = {
  breadcrumbs: "Navigointilinkit"
};
var Cf = {};
Cf = {
  breadcrumbs: "Chemin de navigation"
};
var Ef = {};
Ef = {
  breadcrumbs: "שבילי ניווט"
};
var wf = {};
wf = {
  breadcrumbs: "Navigacijski putovi"
};
var Pf = {};
Pf = {
  breadcrumbs: "Morzsamenü"
};
var kf = {};
kf = {
  breadcrumbs: "Breadcrumb"
};
var Sf = {};
Sf = {
  breadcrumbs: "パンくずリスト"
};
var Bf = {};
Bf = {
  breadcrumbs: "탐색 표시"
};
var Ff = {};
Ff = {
  breadcrumbs: "Naršymo kelias"
};
var Af = {};
Af = {
  breadcrumbs: "Atpakaļceļi"
};
var Tf = {};
Tf = {
  breadcrumbs: "Navigasjonsstier"
};
var Rf = {};
Rf = {
  breadcrumbs: "Broodkruimels"
};
var Mf = {};
Mf = {
  breadcrumbs: "Struktura nawigacyjna"
};
var Nf = {};
Nf = {
  breadcrumbs: "Caminho detalhado"
};
var Vf = {};
Vf = {
  breadcrumbs: "Categorias"
};
var If = {};
If = {
  breadcrumbs: "Miez de pâine"
};
var Of = {};
Of = {
  breadcrumbs: "Навигация"
};
var zf = {};
zf = {
  breadcrumbs: "Navigačné prvky Breadcrumbs"
};
var Kf = {};
Kf = {
  breadcrumbs: "Drobtine"
};
var jf = {};
jf = {
  breadcrumbs: "Putanje navigacije"
};
var Lf = {};
Lf = {
  breadcrumbs: "Sökvägar"
};
var Hf = {};
Hf = {
  breadcrumbs: "İçerik haritaları"
};
var _f = {};
_f = {
  breadcrumbs: "Навігаційна стежка"
};
var Uf = {};
Uf = {
  breadcrumbs: "导航栏"
};
var Wf = {};
Wf = {
  breadcrumbs: "導覽列"
};
var Gf = {};
Gf = {
  "ar-AE": bf,
  "bg-BG": pf,
  "cs-CZ": hf,
  "da-DK": mf,
  "de-DE": vf,
  "el-GR": gf,
  "en-US": yf,
  "es-ES": $f,
  "et-EE": xf,
  "fi-FI": Df,
  "fr-FR": Cf,
  "he-IL": Ef,
  "hr-HR": wf,
  "hu-HU": Pf,
  "it-IT": kf,
  "ja-JP": Sf,
  "ko-KR": Bf,
  "lt-LT": Ff,
  "lv-LV": Af,
  "nb-NO": Tf,
  "nl-NL": Rf,
  "pl-PL": Mf,
  "pt-BR": Nf,
  "pt-PT": Vf,
  "ro-RO": If,
  "ru-RU": Of,
  "sk-SK": zf,
  "sl-SI": Kf,
  "sr-SP": jf,
  "sv-SE": Lf,
  "tr-TR": Hf,
  "uk-UA": _f,
  "zh-CN": Uf,
  "zh-TW": Wf
};
const A6 = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), T6 = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function R6(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return A6.has(n.script);
  }
  let t = e.split("-")[0];
  return T6.has(t);
}
const M6 = Symbol.for("react-aria.i18n.locale");
function Zf() {
  let e = typeof window < "u" && window[M6] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: R6(e) ? "rtl" : "ltr"
  };
}
let jo = Zf(), Fa = /* @__PURE__ */ new Set();
function fd() {
  jo = Zf();
  for (let e of Fa) e(jo);
}
function N6() {
  let e = vn(), [t, n] = q(jo);
  return re(() => (Fa.size === 0 && window.addEventListener("languagechange", fd), Fa.add(n), () => {
    Fa.delete(n), Fa.size === 0 && window.removeEventListener("languagechange", fd);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const V6 = /* @__PURE__ */ x.createContext(null);
function me() {
  let e = N6();
  return U(V6) || e;
}
const I6 = Symbol.for("react-aria.i18n.locale"), O6 = Symbol.for("react-aria.i18n.strings");
let zr;
class Jt {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let a = this.getStringsForLocale(n)[t];
    if (!a) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = z6(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[I6];
    if (zr === void 0) {
      let a = window[O6];
      if (!a) return null;
      zr = {};
      for (let l in a) zr[l] = new Jt({
        [n]: a[l]
      }, n);
    }
    let r = zr == null ? void 0 : zr[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function z6(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = K6(e);
  if (t[r]) return t[r];
  for (let a in t)
    if (a.startsWith(r + "-")) return t[a];
  return t[n];
}
function K6(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const bd = /* @__PURE__ */ new Map(), pd = /* @__PURE__ */ new Map();
class zu {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let a = n["=" + t];
    if (a) return typeof a == "function" ? a() : a;
    let l = this.locale + ":" + r, i = bd.get(l);
    i || (i = new Intl.PluralRules(this.locale, {
      type: r
    }), bd.set(l, i));
    let o = i.select(t);
    return a = n[o] || n.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let n = pd.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), pd.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
}
const hd = /* @__PURE__ */ new WeakMap();
function j6(e) {
  let t = hd.get(e);
  return t || (t = new Jt(e), hd.set(e, t)), t;
}
function Yf(e, t) {
  return t && Jt.getGlobalDictionaryForPackage(t) || j6(e);
}
function Oe(e, t) {
  let { locale: n } = me(), r = Yf(e, t);
  return H(() => new zu(n, r), [
    n,
    r
  ]);
}
function Gr(e, t) {
  return e - t * Math.floor(e / t);
}
const qf = 1721426;
function $r(e, t, n, r) {
  t = tl(e, t);
  let a = t - 1, l = -2;
  return n <= 2 ? l = 0 : Qn(t) && (l = -1), qf - 1 + 365 * a + Math.floor(a / 4) - Math.floor(a / 100) + Math.floor(a / 400) + Math.floor((367 * n - 362) / 12 + l + r);
}
function Qn(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function tl(e, t) {
  return e === "BC" ? 1 - t : t;
}
function mi(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const L6 = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class wt {
  fromJulianDay(t) {
    let n = t, r = n - qf, a = Math.floor(r / 146097), l = Gr(r, 146097), i = Math.floor(l / 36524), o = Gr(l, 36524), u = Math.floor(o / 1461), s = Gr(o, 1461), d = Math.floor(s / 365), c = a * 400 + i * 100 + u * 4 + d + (i !== 4 && d !== 4 ? 1 : 0), [f, b] = mi(c), p = n - $r(f, b, 1, 1), h = 2;
    n < $r(f, b, 3, 1) ? h = 0 : Qn(b) && (h = 1);
    let m = Math.floor(((p + h) * 12 + 373) / 367), v = n - $r(f, b, m, 1) + 1;
    return new ot(f, b, m, v);
  }
  toJulianDay(t) {
    return $r(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return L6[Qn(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return Qn(t.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const H6 = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Xe(e, t) {
  return t = Ue(t, e.calendar), e.era === t.era && e.year === t.year && e.month === t.month && e.day === t.day;
}
function _6(e, t) {
  return t = Ue(t, e.calendar), e = Br(e), t = Br(t), e.era === t.era && e.year === t.year && e.month === t.month;
}
function Lo(e, t) {
  return vi(e.calendar, t.calendar) && Xe(e, t);
}
function vi(e, t) {
  var n, r, a, l;
  return (l = (a = (n = e.isEqual) === null || n === void 0 ? void 0 : n.call(e, t)) !== null && a !== void 0 ? a : (r = t.isEqual) === null || r === void 0 ? void 0 : r.call(t, e)) !== null && l !== void 0 ? l : e.identifier === t.identifier;
}
function U6(e, t) {
  return Xe(e, gi(t));
}
const W6 = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6
};
function Ku(e, t, n) {
  let r = e.calendar.toJulianDay(e), a = n ? W6[n] : J6(t), l = Math.ceil(r + 1 - a) % 7;
  return l < 0 && (l += 7), l;
}
function Xf(e) {
  return Sn(Date.now(), e);
}
function gi(e) {
  return Ct(Xf(e));
}
function Jf(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function Qf(e, t) {
  return md(e) - md(t);
}
function md(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let ro = null;
function yi() {
  return ro == null && (ro = new Intl.DateTimeFormat().resolvedOptions().timeZone), ro;
}
function Br(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function Gl(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function G6(e) {
  return Br(e.subtract({
    months: e.month - 1
  }));
}
function Z6(e) {
  return e.calendar.getMinimumMonthInYear ? e.calendar.getMinimumMonthInYear(e) : 1;
}
function Y6(e) {
  return e.calendar.getMinimumDayInMonth ? e.calendar.getMinimumDayInMonth(e) : 1;
}
function La(e, t, n) {
  let r = Ku(e, t, n);
  return e.subtract({
    days: r
  });
}
function q6(e, t, n) {
  return La(e, t, n).add({
    days: 6
  });
}
const vd = /* @__PURE__ */ new Map();
function X6(e) {
  if (Intl.Locale) {
    let n = vd.get(e);
    return n || (n = new Intl.Locale(e).maximize().region, n && vd.set(e, n)), n;
  }
  let t = e.split("-")[1];
  return t === "u" ? void 0 : t;
}
function J6(e) {
  let t = X6(e);
  return t && H6[t] || 0;
}
function e4(e, t, n) {
  let r = e.calendar.getDaysInMonth(e);
  return Math.ceil((Ku(Br(e), t, n) + r) / 7);
}
function ju(e, t) {
  return e && t ? e.compare(t) <= 0 ? e : t : e || t;
}
function Lu(e, t) {
  return e && t ? e.compare(t) >= 0 ? e : t : e || t;
}
function ra(e) {
  e = Ue(e, new wt());
  let t = tl(e.era, e.year);
  return t4(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function t4(e, t, n, r, a, l, i) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(r, a, l, i), o.setUTCFullYear(e, t - 1, n), o.getTime();
}
function Ho(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === yi()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: n, month: r, day: a, hour: l, minute: i, second: o } = n4(e, t);
  return t4(n, r, a, l, i, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const gd = /* @__PURE__ */ new Map();
function n4(e, t) {
  let n = gd.get(t);
  n || (n = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), gd.set(t, n));
  let r = n.formatToParts(new Date(e)), a = {};
  for (let l of r) l.type !== "literal" && (a[l.type] = l.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: a.era === "BC" || a.era === "B" ? -a.year + 1 : +a.year,
    month: +a.month,
    day: +a.day,
    hour: a.hour === "24" ? 0 : +a.hour,
    minute: +a.minute,
    second: +a.second
  };
}
const yd = 864e5;
function Q6(e, t, n, r) {
  return (n === r ? [
    n
  ] : [
    n,
    r
  ]).filter((l) => eD(e, t, l));
}
function eD(e, t, n) {
  let r = n4(n, t);
  return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function Pn(e, t, n = "compatible") {
  let r = an(e);
  if (t === "UTC") return ra(r);
  if (t === yi() && n === "compatible") {
    r = Ue(r, new wt());
    let u = /* @__PURE__ */ new Date(), s = tl(r.era, r.year);
    return u.setFullYear(s, r.month - 1, r.day), u.setHours(r.hour, r.minute, r.second, r.millisecond), u.getTime();
  }
  let a = ra(r), l = Ho(a - yd, t), i = Ho(a + yd, t), o = Q6(r, t, a - l, a - i);
  if (o.length === 1) return o[0];
  if (o.length > 1) switch (n) {
    // 'compatible' means 'earlier' for "fall back" transitions
    case "compatible":
    case "earlier":
      return o[0];
    case "later":
      return o[o.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (n) {
    case "earlier":
      return Math.min(a - l, a - i);
    // 'compatible' means 'later' for "spring forward" transitions
    case "compatible":
    case "later":
      return Math.max(a - l, a - i);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function r4(e, t, n = "compatible") {
  return new Date(Pn(e, t, n));
}
function Sn(e, t) {
  let n = Ho(e, t), r = new Date(e + n), a = r.getUTCFullYear(), l = r.getUTCMonth() + 1, i = r.getUTCDate(), o = r.getUTCHours(), u = r.getUTCMinutes(), s = r.getUTCSeconds(), d = r.getUTCMilliseconds();
  return new _a(a < 1 ? "BC" : "AD", a < 1 ? -a + 1 : a, l, i, t, n, o, u, s, d);
}
function Ct(e) {
  return new ot(e.calendar, e.era, e.year, e.month, e.day);
}
function an(e, t) {
  let n = 0, r = 0, a = 0, l = 0;
  if ("timeZone" in e) ({ hour: n, minute: r, second: a, millisecond: l } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: n, minute: r, second: a, millisecond: l } = t), new Zl(e.calendar, e.era, e.year, e.month, e.day, n, r, a, l);
}
function $d(e) {
  return new nl(e.hour, e.minute, e.second, e.millisecond);
}
function Ue(e, t) {
  if (vi(e.calendar, t)) return e;
  let n = t.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
  return r.calendar = t, r.era = n.era, r.year = n.year, r.month = n.month, r.day = n.day, Fr(r), r;
}
function a4(e, t, n) {
  if (e instanceof _a)
    return e.timeZone === t ? e : nD(e, t);
  let r = Pn(e, t, n);
  return Sn(r, t);
}
function tD(e) {
  let t = ra(e) - e.offset;
  return new Date(t);
}
function nD(e, t) {
  let n = ra(e) - e.offset;
  return Ue(Sn(n, t), e.calendar);
}
const va = 36e5;
function $i(e, t) {
  let n = e.copy(), r = "hour" in n ? u4(n, t) : 0;
  _o(n, t.years || 0), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e), n.month += t.months || 0, Uo(n), l4(n), n.day += (t.weeks || 0) * 7, n.day += t.days || 0, n.day += r, rD(n), n.calendar.balanceDate && n.calendar.balanceDate(n), n.year < 1 && (n.year = 1, n.month = 1, n.day = 1);
  let a = n.calendar.getYearsInEra(n);
  if (n.year > a) {
    var l, i;
    let u = (l = (i = n.calendar).isInverseEra) === null || l === void 0 ? void 0 : l.call(i, n);
    n.year = a, n.month = u ? 1 : n.calendar.getMonthsInYear(n), n.day = u ? 1 : n.calendar.getDaysInMonth(n);
  }
  n.month < 1 && (n.month = 1, n.day = 1);
  let o = n.calendar.getMonthsInYear(n);
  return n.month > o && (n.month = o, n.day = n.calendar.getDaysInMonth(n)), n.day = Math.max(1, Math.min(n.calendar.getDaysInMonth(n), n.day)), n;
}
function _o(e, t) {
  var n, r;
  !((n = (r = e.calendar).isInverseEra) === null || n === void 0) && n.call(r, e) && (t = -t), e.year += t;
}
function Uo(e) {
  for (; e.month < 1; )
    _o(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, _o(e, 1);
}
function rD(e) {
  for (; e.day < 1; )
    e.month--, Uo(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Uo(e);
}
function l4(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function Fr(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), l4(e);
}
function Hu(e) {
  let t = {};
  for (let n in e) typeof e[n] == "number" && (t[n] = -e[n]);
  return t;
}
function i4(e, t) {
  return $i(e, Hu(t));
}
function _u(e, t) {
  let n = e.copy();
  return t.era != null && (n.era = t.era), t.year != null && (n.year = t.year), t.month != null && (n.month = t.month), t.day != null && (n.day = t.day), Fr(n), n;
}
function Ha(e, t) {
  let n = e.copy();
  return t.hour != null && (n.hour = t.hour), t.minute != null && (n.minute = t.minute), t.second != null && (n.second = t.second), t.millisecond != null && (n.millisecond = t.millisecond), o4(n), n;
}
function aD(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = wl(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = wl(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = wl(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = wl(e.hour, 24), t;
}
function o4(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function wl(e, t) {
  let n = e % t;
  return n < 0 && (n += t), n;
}
function u4(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, aD(e);
}
function s4(e, t) {
  let n = e.copy();
  return u4(n, t), n;
}
function lD(e, t) {
  return s4(e, Hu(t));
}
function Uu(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "era": {
      let o = e.calendar.getEras(), u = o.indexOf(e.era);
      if (u < 0) throw new Error("Invalid era: " + e.era);
      u = Bn(u, n, 0, o.length - 1, r == null ? void 0 : r.round), a.era = o[u], Fr(a);
      break;
    }
    case "year":
      var l, i;
      !((l = (i = a.calendar).isInverseEra) === null || l === void 0) && l.call(i, a) && (n = -n), a.year = Bn(e.year, n, -1 / 0, 9999, r == null ? void 0 : r.round), a.year === -1 / 0 && (a.year = 1), a.calendar.balanceYearMonth && a.calendar.balanceYearMonth(a, e);
      break;
    case "month":
      a.month = Bn(e.month, n, 1, e.calendar.getMonthsInYear(e), r == null ? void 0 : r.round);
      break;
    case "day":
      a.day = Bn(e.day, n, 1, e.calendar.getDaysInMonth(e), r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(a), Fr(a), a;
}
function Wu(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "hour": {
      let l = e.hour, i = 0, o = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let u = l >= 12;
        i = u ? 12 : 0, o = u ? 23 : 11;
      }
      a.hour = Bn(l, n, i, o, r == null ? void 0 : r.round);
      break;
    }
    case "minute":
      a.minute = Bn(e.minute, n, 0, 59, r == null ? void 0 : r.round);
      break;
    case "second":
      a.second = Bn(e.second, n, 0, 59, r == null ? void 0 : r.round);
      break;
    case "millisecond":
      a.millisecond = Bn(e.millisecond, n, 0, 999, r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return a;
}
function Bn(e, t, n, r, a = !1) {
  if (a) {
    e += Math.sign(t), e < n && (e = r);
    let l = Math.abs(t);
    t > 0 ? e = Math.ceil(e / l) * l : e = Math.floor(e / l) * l, e > r && (e = n);
  } else
    e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
  return e;
}
function d4(e, t) {
  let n;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let a = $i(an(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    n = Pn(a, e.timeZone);
  } else
    n = ra(e) - e.offset;
  n += t.milliseconds || 0, n += (t.seconds || 0) * 1e3, n += (t.minutes || 0) * 6e4, n += (t.hours || 0) * 36e5;
  let r = Sn(n, e.timeZone);
  return Ue(r, e.calendar);
}
function iD(e, t) {
  return d4(e, Hu(t));
}
function oD(e, t, n, r) {
  switch (t) {
    case "hour": {
      let a = 0, l = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let p = e.hour >= 12;
        a = p ? 12 : 0, l = p ? 23 : 11;
      }
      let i = an(e), o = Ue(Ha(i, {
        hour: a
      }), new wt()), u = [
        Pn(o, e.timeZone, "earlier"),
        Pn(o, e.timeZone, "later")
      ].filter((p) => Sn(p, e.timeZone).day === o.day)[0], s = Ue(Ha(i, {
        hour: l
      }), new wt()), d = [
        Pn(s, e.timeZone, "earlier"),
        Pn(s, e.timeZone, "later")
      ].filter((p) => Sn(p, e.timeZone).day === s.day).pop(), c = ra(e) - e.offset, f = Math.floor(c / va), b = c % va;
      return c = Bn(f, n, Math.floor(u / va), Math.floor(d / va), r == null ? void 0 : r.round) * va + b, Ue(Sn(c, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Wu(e, t, n, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let a = Uu(an(e), t, n, r), l = Pn(a, e.timeZone);
      return Ue(Sn(l, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function uD(e, t, n) {
  let r = an(e), a = Ha(_u(r, t), t);
  if (a.compare(r) === 0) return e;
  let l = Pn(a, e.timeZone, n);
  return Ue(Sn(l, e.timeZone), e.calendar);
}
function c4(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function f4(e) {
  let t = Ue(e, new wt()), n;
  return t.era === "BC" ? n = t.year === 1 ? "0000" : "-" + String(Math.abs(1 - t.year)).padStart(6, "00") : n = String(t.year).padStart(4, "0"), `${n}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function b4(e) {
  return `${f4(e)}T${c4(e)}`;
}
function sD(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let n = Math.floor(e / 36e5), r = e % 36e5 / 6e4;
  return `${t}${String(n).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}
function dD(e) {
  return `${b4(e)}${sD(e.offset)}[${e.timeZone}]`;
}
function Gu(e) {
  let t = typeof e[0] == "object" ? e.shift() : new wt(), n;
  if (typeof e[0] == "string") n = e.shift();
  else {
    let i = t.getEras();
    n = i[i.length - 1];
  }
  let r = e.shift(), a = e.shift(), l = e.shift();
  return [
    t,
    n,
    r,
    a,
    l
  ];
}
var cD = /* @__PURE__ */ new WeakMap();
class ot {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ot(this.calendar, this.era, this.year, this.month, this.day) : new ot(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return $i(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return i4(this, t);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return _u(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Uu(this, t, n, r);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(t) {
    return r4(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return f4(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return Jf(this, t);
  }
  constructor(...t) {
    el(this, cD, {
      writable: !0,
      value: void 0
    });
    let [n, r, a, l, i] = Gu(t);
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, Fr(this);
  }
}
var fD = /* @__PURE__ */ new WeakMap();
class nl {
  /** Returns a copy of this time. */
  copy() {
    return new nl(this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `Time` with the given duration added to it. */
  add(t) {
    return s4(this, t);
  }
  /** Returns a new `Time` with the given duration subtracted from it. */
  subtract(t) {
    return lD(this, t);
  }
  /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return Ha(this, t);
  }
  /**
  * Returns a new `Time` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Wu(this, t, n, r);
  }
  /** Converts the time to an ISO 8601 formatted string. */
  toString() {
    return c4(this);
  }
  /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */
  compare(t) {
    return Qf(this, t);
  }
  constructor(t = 0, n = 0, r = 0, a = 0) {
    el(this, fD, {
      writable: !0,
      value: void 0
    }), this.hour = t, this.minute = n, this.second = r, this.millisecond = a, o4(this);
  }
}
var bD = /* @__PURE__ */ new WeakMap();
class Zl {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Zl(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Zl(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return $i(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return i4(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return _u(Ha(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Uu(this, t, n, r);
      default:
        return Wu(this, t, n, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, n) {
    return r4(this, t, n);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return b4(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    let n = Jf(this, t);
    return n === 0 ? Qf(this, an(t)) : n;
  }
  constructor(...t) {
    el(this, bD, {
      writable: !0,
      value: void 0
    });
    let [n, r, a, l, i] = Gu(t);
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, Fr(this);
  }
}
var pD = /* @__PURE__ */ new WeakMap();
class _a {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new _a(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new _a(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return d4(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return iD(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t, n) {
    return uD(this, t, n);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return oD(this, t, n, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return tD(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return dD(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return this.toDate().getTime() - a4(t, this.timeZone).toDate().getTime();
  }
  constructor(...t) {
    el(this, pD, {
      writable: !0,
      value: void 0
    });
    let [n, r, a, l, i] = Gu(t), o = t.shift(), u = t.shift();
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, this.timeZone = o, this.offset = u, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, Fr(this);
  }
}
const Zr = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], hD = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], Ml = [
  1867,
  1911,
  1925,
  1988,
  2018
], Xn = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function xd(e) {
  const t = Zr.findIndex(([n, r, a]) => e.year < n || e.year === n && e.month < r || e.year === n && e.month === r && e.day < a);
  return t === -1 ? Zr.length - 1 : t === 0 ? 0 : t - 1;
}
function ao(e) {
  let t = Ml[Xn.indexOf(e.era)];
  if (!t) throw new Error("Unknown era: " + e.era);
  return new ot(e.year + t, e.month, e.day);
}
class mD extends wt {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = xd(n);
    return new ot(this, Xn[r], n.year - Ml[r], n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(ao(t));
  }
  balanceDate(t) {
    let n = ao(t), r = xd(n);
    Xn[r] !== t.era && (t.era = Xn[r], t.year = n.year - Ml[r]), this.constrainDate(t);
  }
  constrainDate(t) {
    let n = Xn.indexOf(t.era), r = hD[n];
    if (r != null) {
      let [a, l, i] = r, o = a - Ml[n];
      t.year = Math.max(1, Math.min(o, t.year)), t.year === o && (t.month = Math.min(l, t.month), t.month === l && (t.day = Math.min(i, t.day)));
    }
    if (t.year === 1 && n >= 0) {
      let [, a, l] = Zr[n];
      t.month = Math.max(a, t.month), t.month === a && (t.day = Math.max(l, t.day));
    }
  }
  getEras() {
    return Xn;
  }
  getYearsInEra(t) {
    let n = Xn.indexOf(t.era), r = Zr[n], a = Zr[n + 1];
    if (a == null)
      return 9999 - r[0] + 1;
    let l = a[0] - r[0];
    return (t.month < a[1] || t.month === a[1] && t.day < a[2]) && l++, l;
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(ao(t));
  }
  getMinimumMonthInYear(t) {
    let n = Dd(t);
    return n ? n[1] : 1;
  }
  getMinimumDayInMonth(t) {
    let n = Dd(t);
    return n && t.month === n[1] ? n[2] : 1;
  }
  constructor(...t) {
    super(...t), this.identifier = "japanese";
  }
}
function Dd(e) {
  if (e.year === 1) {
    let t = Xn.indexOf(e.era);
    return Zr[t];
  }
}
const p4 = -543;
class vD extends wt {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = tl(n.era, n.year);
    return new ot(this, r - p4, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Cd(t));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Cd(t));
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "buddhist";
  }
}
function Cd(e) {
  let [t, n] = mi(e.year + p4);
  return new ot(t, n, e.month, e.day);
}
const Yl = 1911;
function h4(e) {
  return e.era === "minguo" ? e.year + Yl : 1 - e.year + Yl;
}
function Ed(e) {
  let t = e - Yl;
  return t > 0 ? [
    "minguo",
    t
  ] : [
    "before_minguo",
    1 - t
  ];
}
class gD extends wt {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = tl(n.era, n.year), [a, l] = Ed(r);
    return new ot(this, a, l, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(wd(t));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(t) {
    let [n, r] = Ed(h4(t));
    t.era = n, t.year = r;
  }
  isInverseEra(t) {
    return t.era === "before_minguo";
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(wd(t));
  }
  getYearsInEra(t) {
    return t.era === "before_minguo" ? 9999 : 9999 - Yl;
  }
  constructor(...t) {
    super(...t), this.identifier = "roc";
  }
}
function wd(e) {
  let [t, n] = mi(h4(e));
  return new ot(t, n, e.month, e.day);
}
const Pd = 1948320, kd = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class yD {
  fromJulianDay(t) {
    let n = t - Pd, r = 1 + Math.floor((33 * n + 3) / 12053), a = 365 * (r - 1) + Math.floor((8 * r + 21) / 33), l = n - a, i = l < 216 ? Math.floor(l / 31) : Math.floor((l - 6) / 30), o = l - kd[i] + 1;
    return new ot(this, r, i + 1, o);
  }
  toJulianDay(t) {
    let n = Pd - 1 + 365 * (t.year - 1) + Math.floor((8 * t.year + 21) / 33);
    return n += kd[t.month - 1], n += t.day, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(t) {
    return t.month <= 6 ? 31 : t.month <= 11 || Gr(25 * t.year + 11, 33) < 8 ? 30 : 29;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const lo = 78, Sd = 80;
class $D extends wt {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = n.year - lo, a = t - $r(n.era, n.year, 1, 1), l;
    a < Sd ? (r--, l = Qn(n.year - 1) ? 31 : 30, a += l + 155 + 90 + 10) : (l = Qn(n.year) ? 31 : 30, a -= Sd);
    let i, o;
    if (a < l)
      i = 1, o = a + 1;
    else {
      let u = a - l;
      u < 155 ? (i = Math.floor(u / 31) + 2, o = u % 31 + 1) : (u -= 155, i = Math.floor(u / 30) + 7, o = u % 30 + 1);
    }
    return new ot(this, r, i, o);
  }
  toJulianDay(t) {
    let n = t.year + lo, [r, a] = mi(n), l, i;
    return Qn(a) ? (l = 31, i = $r(r, a, 3, 21)) : (l = 30, i = $r(r, a, 3, 22)), t.month === 1 ? i + t.day - 1 : (i += l + Math.min(t.month - 2, 5) * 31, t.month >= 8 && (i += (t.month - 7) * 30), i += t.day - 1, i);
  }
  getDaysInMonth(t) {
    return t.month === 1 && Qn(t.year + lo) || t.month >= 2 && t.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "indian";
  }
}
const ql = 1948440, Bd = 1948439, Zt = 1300, Kr = 1600, xD = 460322;
function Xl(e, t, n, r) {
  return r + Math.ceil(29.5 * (n - 1)) + (t - 1) * 354 + Math.floor((3 + 11 * t) / 30) + e - 1;
}
function m4(e, t, n) {
  let r = Math.floor((30 * (n - t) + 10646) / 10631), a = Math.min(12, Math.ceil((n - (29 + Xl(t, r, 1, 1))) / 29.5) + 1), l = n - Xl(t, r, a, 1) + 1;
  return new ot(e, r, a, l);
}
function Fd(e) {
  return (14 + 11 * e) % 30 < 11;
}
class Zu {
  fromJulianDay(t) {
    return m4(this, ql, t);
  }
  toJulianDay(t) {
    return Xl(ql, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = 29 + t.month % 2;
    return t.month === 12 && Fd(t.year) && n++, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(t) {
    return Fd(t.year) ? 355 : 354;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class DD extends Zu {
  fromJulianDay(t) {
    return m4(this, Bd, t);
  }
  toJulianDay(t) {
    return Xl(Bd, t.year, t.month, t.day);
  }
  constructor(...t) {
    super(...t), this.identifier = "islamic-tbla";
  }
}
const CD = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let Wo, Yr;
function Nl(e) {
  return xD + Yr[e - Zt];
}
function Aa(e, t) {
  let n = e - Zt, r = 1 << 11 - (t - 1);
  return Wo[n] & r ? 30 : 29;
}
function Ad(e, t) {
  let n = Nl(e);
  for (let r = 1; r < t; r++) n += Aa(e, r);
  return n;
}
function Td(e) {
  return Yr[e + 1 - Zt] - Yr[e - Zt];
}
class ED extends Zu {
  fromJulianDay(t) {
    let n = t - ql, r = Nl(Zt), a = Nl(Kr);
    if (n < r || n > a) return super.fromJulianDay(t);
    {
      let l = Zt - 1, i = 1, o = 1;
      for (; o > 0; ) {
        l++, o = n - Nl(l) + 1;
        let u = Td(l);
        if (o === u) {
          i = 12;
          break;
        } else if (o < u) {
          let s = Aa(l, i);
          for (i = 1; o > s; )
            o -= s, i++, s = Aa(l, i);
          break;
        }
      }
      return new ot(this, l, i, n - Ad(l, i) + 1);
    }
  }
  toJulianDay(t) {
    return t.year < Zt || t.year > Kr ? super.toJulianDay(t) : ql + Ad(t.year, t.month) + (t.day - 1);
  }
  getDaysInMonth(t) {
    return t.year < Zt || t.year > Kr ? super.getDaysInMonth(t) : Aa(t.year, t.month);
  }
  getDaysInYear(t) {
    return t.year < Zt || t.year > Kr ? super.getDaysInYear(t) : Td(t.year);
  }
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", Wo || (Wo = new Uint16Array(Uint8Array.from(atob(CD), (t) => t.charCodeAt(0)).buffer)), !Yr) {
      Yr = new Uint32Array(Kr - Zt + 1);
      let t = 0;
      for (let n = Zt; n <= Kr; n++) {
        Yr[n - Zt] = t;
        for (let r = 1; r <= 12; r++) t += Aa(n, r);
      }
    }
  }
}
const Rd = 347997, v4 = 1080, g4 = 24 * v4, wD = 29, PD = 12 * v4 + 793, kD = wD * g4 + PD;
function yr(e) {
  return Gr(e * 7 + 1, 19) < 7;
}
function Vl(e) {
  let t = Math.floor((235 * e - 234) / 19), n = 12084 + 13753 * t, r = t * 29 + Math.floor(n / 25920);
  return Gr(3 * (r + 1), 7) < 3 && (r += 1), r;
}
function SD(e) {
  let t = Vl(e - 1), n = Vl(e);
  return Vl(e + 1) - n === 356 ? 2 : n - t === 382 ? 1 : 0;
}
function Va(e) {
  return Vl(e) + SD(e);
}
function y4(e) {
  return Va(e + 1) - Va(e);
}
function BD(e) {
  let t = y4(e);
  switch (t > 380 && (t -= 30), t) {
    case 353:
      return 0;
    // deficient
    case 354:
      return 1;
    // normal
    case 355:
      return 2;
  }
}
function Pl(e, t) {
  if (t >= 6 && !yr(e) && t++, t === 4 || t === 7 || t === 9 || t === 11 || t === 13) return 29;
  let n = BD(e);
  return t === 2 ? n === 2 ? 30 : 29 : t === 3 ? n === 0 ? 29 : 30 : t === 6 ? yr(e) ? 30 : 0 : 30;
}
class FD {
  fromJulianDay(t) {
    let n = t - Rd, r = n * g4 / kD, a = Math.floor((19 * r + 234) / 235) + 1, l = Va(a), i = Math.floor(n - l);
    for (; i < 1; )
      a--, l = Va(a), i = Math.floor(n - l);
    let o = 1, u = 0;
    for (; u < i; )
      u += Pl(a, o), o++;
    o--, u -= Pl(a, o);
    let s = i - u;
    return new ot(this, a, o, s);
  }
  toJulianDay(t) {
    let n = Va(t.year);
    for (let r = 1; r < t.month; r++) n += Pl(t.year, r);
    return n + t.day + Rd;
  }
  getDaysInMonth(t) {
    return Pl(t.year, t.month);
  }
  getMonthsInYear(t) {
    return yr(t.year) ? 13 : 12;
  }
  getDaysInYear(t) {
    return y4(t.year);
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(t, n) {
    n.year !== t.year && (yr(n.year) && !yr(t.year) && n.month > 6 ? t.month-- : !yr(n.year) && yr(t.year) && n.month > 6 && t.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const Go = 1723856, Md = 1824665, Zo = 5500;
function Jl(e, t, n, r) {
  return e + 365 * t + Math.floor(t / 4) + 30 * (n - 1) + r - 1;
}
function Yu(e, t) {
  let n = Math.floor(4 * (t - e) / 1461), r = 1 + Math.floor((t - Jl(e, n, 1, 1)) / 30), a = t + 1 - Jl(e, n, r, 1);
  return [
    n,
    r,
    a
  ];
}
function $4(e) {
  return Math.floor(e % 4 / 3);
}
function x4(e, t) {
  return t % 13 !== 0 ? 30 : $4(e) + 5;
}
class qu {
  fromJulianDay(t) {
    let [n, r, a] = Yu(Go, t), l = "AM";
    return n <= 0 && (l = "AA", n += Zo), new ot(this, l, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "AA" && (n -= Zo), Jl(Go, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    return x4(t.year, t.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(t) {
    return 365 + $4(t.year);
  }
  getYearsInEra(t) {
    return t.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class AD extends qu {
  fromJulianDay(t) {
    let [n, r, a] = Yu(Go, t);
    return n += Zo, new ot(this, "AA", n, r, a);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...t) {
    super(...t), this.identifier = "ethioaa";
  }
}
class TD extends qu {
  fromJulianDay(t) {
    let [n, r, a] = Yu(Md, t), l = "CE";
    return n <= 0 && (l = "BCE", n = 1 - n), new ot(this, l, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), Jl(Md, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), x4(n, t.month);
  }
  isInverseEra(t) {
    return t.era === "BCE";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BCE" ? "CE" : "BCE", t.year = 1 - t.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(t) {
    return t.era === "BCE" ? 9999 : 9715;
  }
  constructor(...t) {
    super(...t), this.identifier = "coptic";
  }
}
function xi(e) {
  switch (e) {
    case "buddhist":
      return new vD();
    case "ethiopic":
      return new qu();
    case "ethioaa":
      return new AD();
    case "coptic":
      return new TD();
    case "hebrew":
      return new FD();
    case "indian":
      return new $D();
    case "islamic-civil":
      return new Zu();
    case "islamic-tbla":
      return new DD();
    case "islamic-umalqura":
      return new ED();
    case "japanese":
      return new mD();
    case "persian":
      return new yD();
    case "roc":
      return new gD();
    case "gregory":
    default:
      return new wt();
  }
}
let io = /* @__PURE__ */ new Map();
class Xt {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, n) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(n)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(t), a = this.formatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return ND() && (this.resolvedHourCycle || (this.resolvedHourCycle = VD(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
  constructor(t, n = {}) {
    this.formatter = D4(t, n), this.options = n;
  }
}
const RD = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function D4(e, t = {}) {
  if (typeof t.hour12 == "boolean" && MD()) {
    t = {
      ...t
    };
    let a = RD[String(t.hour12)][e.split("-")[0]], l = t.hour12 ? "h12" : "h23";
    t.hourCycle = a ?? l, delete t.hour12;
  }
  let n = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (io.has(n)) return io.get(n);
  let r = new Intl.DateTimeFormat(e, t);
  return io.set(n, r), r;
}
let oo = null;
function MD() {
  return oo == null && (oo = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), oo;
}
let uo = null;
function ND() {
  return uo == null && (uo = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), uo;
}
function VD(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let n = D4(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(n.formatToParts(new Date(2020, 2, 3, 0)).find((l) => l.type === "hour").value, 10), a = parseInt(n.formatToParts(new Date(2020, 2, 3, 23)).find((l) => l.type === "hour").value, 10);
  if (r === 0 && a === 23) return "h23";
  if (r === 24 && a === 23) return "h24";
  if (r === 0 && a === 11) return "h11";
  if (r === 12 && a === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
function fn(e) {
  e = ef(e ?? {}, ID);
  let { locale: t } = me();
  return H(() => new Xt(t, e), [
    t,
    e
  ]);
}
function ID(e, t) {
  if (e === t) return !0;
  let n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let a of n)
    if (t[a] !== e[a]) return !1;
  return !0;
}
let so = /* @__PURE__ */ new Map(), Yo = !1;
try {
  Yo = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Ql = !1;
try {
  Ql = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const C4 = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class ar {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!Yo && this.options.signDisplay != null ? n = zD(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !Ql) {
      var r;
      let { unit: a, unitDisplay: l = "short", locale: i } = this.resolvedOptions();
      if (!a) return n;
      let o = (r = C4[a]) === null || r === void 0 ? void 0 : r[l];
      n += o[i] || o.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), a = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !Yo && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !Ql && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = OD(t, n), this.options = n;
  }
}
function OD(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Ql) {
    var r;
    let { unit: i, unitDisplay: o = "short" } = t;
    if (!i) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = C4[i]) === null || r === void 0) && r[o])) throw new Error(`Unsupported unit ${i} with unitDisplay = ${o}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let a = e + (t ? Object.entries(t).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : "");
  if (so.has(a)) return so.get(a);
  let l = new Intl.NumberFormat(e, t);
  return so.set(a, l), l;
}
function zD(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let a = e.format(-n), l = e.format(n), i = a.replace(l, "").replace(/\u200e|\u061C/, "");
      return [
        ...i
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(l, "!!!").replace(i, "+").replace("!!!", l);
    } else return e.format(n);
  }
}
const KD = new RegExp("^.*\\(.*\\).*$"), jD = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng"
];
class Xu {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return co(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, n, r) {
    return co(this.locale, this.options, t).isValidPartialNumber(t, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return co(this.locale, this.options, t).options.numberingSystem;
  }
  constructor(t, n = {}) {
    this.locale = t, this.options = n;
  }
}
const Nd = /* @__PURE__ */ new Map();
function co(e, t, n) {
  let r = Vd(e, t);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let a of jD) if (a !== r.options.numberingSystem) {
      let l = Vd(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + a, t);
      if (l.isValidPartialNumber(n)) return l;
    }
  }
  return r;
}
function Vd(e, t) {
  let n = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : ""), r = Nd.get(n);
  return r || (r = new LD(e, t), Nd.set(n, r)), r;
}
class LD {
  parse(t) {
    let n = this.sanitize(t);
    if (this.symbols.group && (n = ga(n, this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let i = n.indexOf("-");
      n = n.replace("-", "");
      let o = n.indexOf(".");
      o === -1 && (o = n.length), n = n.replace(".", ""), o - 2 === 0 ? n = `0.${n}` : o - 2 === -1 ? n = `0.0${n}` : o - 2 === -2 ? n = "0.00" : n = `${n.slice(0, o - 2)}.${n.slice(o - 2)}`, i > -1 && (n = `-${n}`);
    }
    let r = n ? +n : NaN;
    if (isNaN(r)) return NaN;
    if (this.options.style === "percent") {
      var a, l;
      let i = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((a = this.options.minimumFractionDigits) !== null && a !== void 0 ? a : 0) + 2, 20),
        maximumFractionDigits: Math.min(((l = this.options.maximumFractionDigits) !== null && l !== void 0 ? l : 0) + 2, 20)
      };
      return new Xu(this.locale, i).parse(new ar(this.locale, i).format(r));
    }
    return this.options.currencySign === "accounting" && KD.test(t) && (r = -1 * r), r;
  }
  sanitize(t) {
    return t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = t.replace(",", this.symbols.decimal), t = t.replace("،", this.symbols.decimal)), this.symbols.group && (t = ga(t, ".", this.symbols.group))), this.options.locale === "fr-FR" && this.symbols.group && (t = ga(t, " ", this.symbols.group), t = ga(t, /\u00A0/g, this.symbols.group)), t;
  }
  isValidPartialNumber(t, n = -1 / 0, r = 1 / 0) {
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && n < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && r > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.group && t.startsWith(this.symbols.group) || this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (t = ga(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
  constructor(t, n = {}) {
    this.locale = t, this.formatter = new Intl.NumberFormat(t, n), this.options = this.formatter.resolvedOptions(), this.symbols = _D(t, this.formatter, this.options, n);
    var r, a;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((a = this.options.maximumFractionDigits) !== null && a !== void 0 ? a : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const Id = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), HD = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function _D(e, t, n, r) {
  var a, l, i, o;
  let u = new Intl.NumberFormat(e, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand"
  }), s = u.formatToParts(-10000.111), d = u.formatToParts(10000.111), c = HD.map((A) => u.formatToParts(A));
  var f;
  let b = (f = (a = s.find((A) => A.type === "minusSign")) === null || a === void 0 ? void 0 : a.value) !== null && f !== void 0 ? f : "-", p = (l = d.find((A) => A.type === "plusSign")) === null || l === void 0 ? void 0 : l.value;
  !p && ((r == null ? void 0 : r.signDisplay) === "exceptZero" || (r == null ? void 0 : r.signDisplay) === "always") && (p = "+");
  let m = (i = new Intl.NumberFormat(e, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((A) => A.type === "decimal")) === null || i === void 0 ? void 0 : i.value, v = (o = s.find((A) => A.type === "group")) === null || o === void 0 ? void 0 : o.value, y = s.filter((A) => !Id.has(A.type)).map((A) => Od(A.value)), w = c.flatMap((A) => A.filter(($) => !Id.has($.type)).map(($) => Od($.value))), C = [
    .../* @__PURE__ */ new Set([
      ...y,
      ...w
    ])
  ].sort((A, $) => $.length - A.length), D = C.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${C.join("|")}|[\\p{White_Space}]`, "gu"), P = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), R = new Map(P.map((A, $) => [
    A,
    $
  ])), V = new RegExp(`[${P.join("")}]`, "g");
  return {
    minusSign: b,
    plusSign: p,
    decimal: m,
    group: v,
    literals: D,
    numeral: V,
    index: (A) => String(R.get(A))
  };
}
function ga(e, t, n) {
  return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function Od(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function ei(e = {}) {
  let { locale: t } = me();
  return H(() => new ar(t, e), [
    t,
    e
  ]);
}
let fo = /* @__PURE__ */ new Map();
function Rr(e) {
  let { locale: t } = me(), n = t + (e ? Object.entries(e).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (fo.has(n)) return fo.get(n);
  let r = new Intl.Collator(t, e);
  return fo.set(n, r), r;
}
function E4(e) {
  let t = Rr({
    usage: "search",
    ...e
  }), n = ie((l, i) => i.length === 0 ? !0 : (l = l.normalize("NFC"), i = i.normalize("NFC"), t.compare(l.slice(0, i.length), i) === 0), [
    t
  ]), r = ie((l, i) => i.length === 0 ? !0 : (l = l.normalize("NFC"), i = i.normalize("NFC"), t.compare(l.slice(-i.length), i) === 0), [
    t
  ]), a = ie((l, i) => {
    if (i.length === 0) return !0;
    l = l.normalize("NFC"), i = i.normalize("NFC");
    let o = 0, u = i.length;
    for (; o + u <= l.length; o++) {
      let s = l.slice(o, o + u);
      if (t.compare(i, s) === 0) return !0;
    }
    return !1;
  }, [
    t
  ]);
  return H(() => ({
    startsWith: n,
    endsWith: r,
    contains: a
  }), [
    n,
    r,
    a
  ]);
}
function UD(e) {
  return e && e.__esModule ? e.default : e;
}
function WD(e) {
  let { "aria-label": t, ...n } = e, r = Oe(UD(Gf), "@react-aria/breadcrumbs");
  return {
    navProps: {
      ...J(n, {
        labelable: !0
      }),
      "aria-label": t || r.format("breadcrumbs")
    }
  };
}
function Ju(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: a, onPressStart: l, onPressEnd: i, onPressUp: o, onPressChange: u, preventFocusOnPress: s, allowFocusWhenDisabled: d, onClick: c, href: f, target: b, rel: p, type: h = "button" } = e, m;
  n === "button" ? m = {
    type: h,
    disabled: r
  } : m = {
    role: "button",
    href: n === "a" && !r ? f : void 0,
    target: n === "a" ? b : void 0,
    type: n === "input" ? h : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? p : void 0
  };
  let { pressProps: v, isPressed: y } = Tt({
    onPressStart: l,
    onPressEnd: i,
    onPressChange: u,
    onPress: a,
    onPressUp: o,
    onClick: c,
    isDisabled: r,
    preventFocusOnPress: s,
    ref: t
  }), { focusableProps: w } = un(e, t);
  d && (w.tabIndex = r ? -1 : w.tabIndex);
  let C = _(w, v, J(e, {
    labelable: !0
  }));
  return {
    isPressed: y,
    buttonProps: _(m, C, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"]
    })
  };
}
function w4(e, t, n) {
  const { isSelected: r } = t, { isPressed: a, buttonProps: l } = Ju({
    ...e,
    onPress: At(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: a,
    isSelected: r,
    isDisabled: e.isDisabled || !1,
    buttonProps: _(l, {
      "aria-pressed": r
    })
  };
}
function GD(e) {
  const t = vt(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: l } = e.ownerDocument.defaultView;
    let { display: i, visibility: o } = l(e);
    a = i !== "none" && o !== "hidden" && o !== "collapse";
  }
  return a;
}
function ZD(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function P4(e, t) {
  return e.nodeName !== "#comment" && GD(e) && ZD(e, t) && (!e.parentElement || P4(e.parentElement, e));
}
const zd = /* @__PURE__ */ x.createContext(null), qo = "react-aria-focus-scope-restore";
let Ke = null;
function rl(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: a } = e, l = j(null), i = j(null), o = j([]), { parentNode: u } = U(zd) || {}, s = H(() => new Jo({
    scopeRef: o
  }), [
    o
  ]);
  Ce(() => {
    let f = u || rt.root;
    if (rt.getTreeNode(f.scopeRef) && Ke && !ti(Ke, f.scopeRef)) {
      let b = rt.getTreeNode(Ke);
      b && (f = b);
    }
    f.addChild(s), rt.addNode(s);
  }, [
    s,
    u
  ]), Ce(() => {
    let f = rt.getTreeNode(o);
    f && (f.contain = !!n);
  }, [
    n
  ]), Ce(() => {
    var f;
    let b = (f = l.current) === null || f === void 0 ? void 0 : f.nextSibling, p = [], h = (m) => m.stopPropagation();
    for (; b && b !== i.current; )
      p.push(b), b.addEventListener(qo, h), b = b.nextSibling;
    return o.current = p, () => {
      for (let m of p) m.removeEventListener(qo, h);
    };
  }, [
    t
  ]), QD(o, r, n), qD(o, n), e2(o, r, n), JD(o, a), re(() => {
    const f = ft(ke(o.current ? o.current[0] : void 0));
    let b = null;
    if (Qt(f, o.current)) {
      for (let p of rt.traverse()) p.scopeRef && Qt(f, p.scopeRef.current) && (b = p);
      b === rt.getTreeNode(o) && (Ke = b.scopeRef);
    }
  }, [
    o
  ]), Ce(() => () => {
    var f, b, p;
    let h = (p = (b = rt.getTreeNode(o)) === null || b === void 0 || (f = b.parent) === null || f === void 0 ? void 0 : f.scopeRef) !== null && p !== void 0 ? p : null;
    (o === Ke || ti(o, Ke)) && (!h || rt.getTreeNode(h)) && (Ke = h), rt.removeTreeNode(o);
  }, [
    o
  ]);
  let d = H(() => YD(o), []), c = H(() => ({
    focusManager: d,
    parentNode: s
  }), [
    s,
    d
  ]);
  return /* @__PURE__ */ x.createElement(zd.Provider, {
    value: c
  }, /* @__PURE__ */ x.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: l
  }), t, /* @__PURE__ */ x.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: i
  }));
}
function YD(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: a, wrap: l, accept: i } = t;
      var o;
      let u = r || ft(ke((o = n[0]) !== null && o !== void 0 ? o : void 0)), s = n[0].previousElementSibling, d = xr(n), c = Je(d, {
        tabbable: a,
        accept: i
      }, n);
      c.currentNode = Qt(u, n) ? u : s;
      let f = c.nextNode();
      return !f && l && (c.currentNode = s, f = c.nextNode()), f && Ft(f, !0), f;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: a, wrap: l, accept: i } = t;
      var o;
      let u = r || ft(ke((o = n[0]) !== null && o !== void 0 ? o : void 0)), s = n[n.length - 1].nextElementSibling, d = xr(n), c = Je(d, {
        tabbable: a,
        accept: i
      }, n);
      c.currentNode = Qt(u, n) ? u : s;
      let f = c.previousNode();
      return !f && l && (c.currentNode = s, f = c.previousNode()), f && Ft(f, !0), f;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: a } = t, l = xr(n), i = Je(l, {
        tabbable: r,
        accept: a
      }, n);
      i.currentNode = n[0].previousElementSibling;
      let o = i.nextNode();
      return o && Ft(o, !0), o;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: a } = t, l = xr(n), i = Je(l, {
        tabbable: r,
        accept: a
      }, n);
      i.currentNode = n[n.length - 1].nextElementSibling;
      let o = i.previousNode();
      return o && Ft(o, !0), o;
    }
  };
}
function xr(e) {
  return e[0].parentElement;
}
function Ta(e) {
  let t = rt.getTreeNode(Ke);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function qD(e, t) {
  let n = j(void 0), r = j(void 0);
  Ce(() => {
    let a = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const l = ke(a ? a[0] : void 0);
    let i = (s) => {
      if (s.key !== "Tab" || s.altKey || s.ctrlKey || s.metaKey || !Ta(e) || s.isComposing) return;
      let d = ft(l), c = e.current;
      if (!c || !Qt(d, c)) return;
      let f = xr(c), b = Je(f, {
        tabbable: !0
      }, c);
      if (!d) return;
      b.currentNode = d;
      let p = s.shiftKey ? b.previousNode() : b.nextNode();
      p || (b.currentNode = s.shiftKey ? c[c.length - 1].nextElementSibling : c[0].previousElementSibling, p = s.shiftKey ? b.previousNode() : b.nextNode()), s.preventDefault(), p && Ft(p, !0);
    }, o = (s) => {
      (!Ke || ti(Ke, e)) && Qt(Be(s), e.current) ? (Ke = e, n.current = Be(s)) : Ta(e) && !er(Be(s), e) ? n.current ? n.current.focus() : Ke && Ke.current && Xo(Ke.current) : Ta(e) && (n.current = Be(s));
    }, u = (s) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let d = ta(), c = (d === "virtual" || d === null) && Er() && Xc(), f = ft(l);
        if (!c && f && Ta(e) && !er(f, e)) {
          Ke = e;
          let p = Be(s);
          if (p && p.isConnected) {
            var b;
            n.current = p, (b = n.current) === null || b === void 0 || b.focus();
          } else Ke.current && Xo(Ke.current);
        }
      });
    };
    return l.addEventListener("keydown", i, !1), l.addEventListener("focusin", o, !1), a == null || a.forEach((s) => s.addEventListener("focusin", o, !1)), a == null || a.forEach((s) => s.addEventListener("focusout", u, !1)), () => {
      l.removeEventListener("keydown", i, !1), l.removeEventListener("focusin", o, !1), a == null || a.forEach((s) => s.removeEventListener("focusin", o, !1)), a == null || a.forEach((s) => s.removeEventListener("focusout", u, !1));
    };
  }, [
    e,
    t
  ]), Ce(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function k4(e) {
  return er(e);
}
function Qt(e, t) {
  return !e || !t ? !1 : t.some((n) => n.contains(e));
}
function er(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of rt.traverse(rt.getTreeNode(t)))
    if (n && Qt(e, n.current)) return !0;
  return !1;
}
function XD(e) {
  return er(e, Ke);
}
function ti(e, t) {
  var n;
  let r = (n = rt.getTreeNode(t)) === null || n === void 0 ? void 0 : n.parent;
  for (; r; ) {
    if (r.scopeRef === e) return !0;
    r = r.parent;
  }
  return !1;
}
function Ft(e, t = !1) {
  if (e != null && !t) try {
    He(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function S4(e, t = !0) {
  let n = e[0].previousElementSibling, r = xr(e), a = Je(r, {
    tabbable: t
  }, e);
  a.currentNode = n;
  let l = a.nextNode();
  return t && !l && (r = xr(e), a = Je(r, {
    tabbable: !1
  }, e), a.currentNode = n, l = a.nextNode()), l;
}
function Xo(e, t = !0) {
  Ft(S4(e, t));
}
function JD(e, t) {
  const n = x.useRef(t);
  re(() => {
    if (n.current) {
      Ke = e;
      const r = ke(e.current ? e.current[0] : void 0);
      !Qt(ft(r), Ke.current) && e.current && Xo(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function QD(e, t, n) {
  Ce(() => {
    if (t || n) return;
    let r = e.current;
    const a = ke(r ? r[0] : void 0);
    let l = (i) => {
      let o = Be(i);
      Qt(o, e.current) ? Ke = e : k4(o) || (Ke = null);
    };
    return a.addEventListener("focusin", l, !1), r == null || r.forEach((i) => i.addEventListener("focusin", l, !1)), () => {
      a.removeEventListener("focusin", l, !1), r == null || r.forEach((i) => i.removeEventListener("focusin", l, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function Kd(e) {
  let t = rt.getTreeNode(Ke);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return (t == null ? void 0 : t.scopeRef) === e;
}
function e2(e, t, n) {
  const r = j(typeof document < "u" ? ft(ke(e.current ? e.current[0] : void 0)) : null);
  Ce(() => {
    let a = e.current;
    const l = ke(a ? a[0] : void 0);
    if (!t || n) return;
    let i = () => {
      (!Ke || ti(Ke, e)) && Qt(ft(l), e.current) && (Ke = e);
    };
    return l.addEventListener("focusin", i, !1), a == null || a.forEach((o) => o.addEventListener("focusin", i, !1)), () => {
      l.removeEventListener("focusin", i, !1), a == null || a.forEach((o) => o.removeEventListener("focusin", i, !1));
    };
  }, [
    e,
    n
  ]), Ce(() => {
    const a = ke(e.current ? e.current[0] : void 0);
    if (!t) return;
    let l = (i) => {
      if (i.key !== "Tab" || i.altKey || i.ctrlKey || i.metaKey || !Ta(e) || i.isComposing) return;
      let o = a.activeElement;
      if (!er(o, e) || !Kd(e)) return;
      let u = rt.getTreeNode(e);
      if (!u) return;
      let s = u.nodeToRestore, d = Je(a.body, {
        tabbable: !0
      });
      d.currentNode = o;
      let c = i.shiftKey ? d.previousNode() : d.nextNode();
      if ((!s || !s.isConnected || s === a.body) && (s = void 0, u.nodeToRestore = void 0), (!c || !er(c, e)) && s) {
        d.currentNode = s;
        do
          c = i.shiftKey ? d.previousNode() : d.nextNode();
        while (er(c, e));
        i.preventDefault(), i.stopPropagation(), c ? Ft(c, !0) : k4(s) ? Ft(s, !0) : o.blur();
      }
    };
    return n || a.addEventListener("keydown", l, !0), () => {
      n || a.removeEventListener("keydown", l, !0);
    };
  }, [
    e,
    t,
    n
  ]), Ce(() => {
    const a = ke(e.current ? e.current[0] : void 0);
    if (!t) return;
    let l = rt.getTreeNode(e);
    if (l) {
      var i;
      return l.nodeToRestore = (i = r.current) !== null && i !== void 0 ? i : void 0, () => {
        let o = rt.getTreeNode(e);
        if (!o) return;
        let u = o.nodeToRestore, s = ft(a);
        if (t && u && (s && er(s, e) || s === a.body && Kd(e))) {
          let d = rt.clone();
          requestAnimationFrame(() => {
            if (a.activeElement === a.body) {
              let c = d.getTreeNode(e);
              for (; c; ) {
                if (c.nodeToRestore && c.nodeToRestore.isConnected) {
                  jd(c.nodeToRestore);
                  return;
                }
                c = c.parent;
              }
              for (c = d.getTreeNode(e); c; ) {
                if (c.scopeRef && c.scopeRef.current && rt.getTreeNode(c.scopeRef)) {
                  let f = S4(c.scopeRef.current, !0);
                  jd(f);
                  return;
                }
                c = c.parent;
              }
            }
          });
        }
      };
    }
  }, [
    e,
    t
  ]);
}
function jd(e) {
  e.dispatchEvent(new CustomEvent(qo, {
    bubbles: !0,
    cancelable: !0
  })) && Ft(e);
}
function Je(e, t, n) {
  let r = t != null && t.tabbable ? l6 : Mu, a = (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE ? e : null, l = ke(a), i = Nx(l, e || l, NodeFilter.SHOW_ELEMENT, {
    acceptNode(o) {
      var u;
      return !(t == null || (u = t.from) === null || u === void 0) && u.contains(o) ? NodeFilter.FILTER_REJECT : r(o) && P4(o) && (!n || Qt(o, n)) && (!(t != null && t.accept) || t.accept(o)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t != null && t.from && (i.currentNode = t.from), i;
}
function ia(e, t = {}) {
  return {
    focusNext(n = {}) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: l = t.tabbable, wrap: i = t.wrap, accept: o = t.accept } = n, u = a || ft(ke(r)), s = Je(r, {
        tabbable: l,
        accept: o
      });
      r.contains(u) && (s.currentNode = u);
      let d = s.nextNode();
      return !d && i && (s.currentNode = r, d = s.nextNode()), d && Ft(d, !0), d;
    },
    focusPrevious(n = t) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: l = t.tabbable, wrap: i = t.wrap, accept: o = t.accept } = n, u = a || ft(ke(r)), s = Je(r, {
        tabbable: l,
        accept: o
      });
      if (r.contains(u)) s.currentNode = u;
      else {
        let c = bo(s);
        return c && Ft(c, !0), c ?? null;
      }
      let d = s.previousNode();
      if (!d && i) {
        s.currentNode = r;
        let c = bo(s);
        if (!c)
          return null;
        d = c;
      }
      return d && Ft(d, !0), d ?? null;
    },
    focusFirst(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: l = t.accept } = n, o = Je(r, {
        tabbable: a,
        accept: l
      }).nextNode();
      return o && Ft(o, !0), o;
    },
    focusLast(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: l = t.accept } = n, i = Je(r, {
        tabbable: a,
        accept: l
      }), o = bo(i);
      return o && Ft(o, !0), o ?? null;
    }
  };
}
function bo(e) {
  let t, n;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
class Qu {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let a = this.fastMap.get(n ?? null);
    if (!a) return;
    let l = new Jo({
      scopeRef: t
    });
    a.addChild(l), l.parent = a, this.fastMap.set(t, l), r && (l.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let l of this.traverse()) l !== n && n.nodeToRestore && l.nodeToRestore && n.scopeRef && n.scopeRef.current && Qt(l.nodeToRestore, n.scopeRef.current) && (l.nodeToRestore = n.nodeToRestore);
    let a = n.children;
    r && (r.removeChild(n), a.size > 0 && a.forEach((l) => r && r.addChild(l))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new Qu();
    var r;
    for (let a of this.traverse()) n.addTreeNode(a.scopeRef, (r = (t = a.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, a.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Jo({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class Jo {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
let rt = new Qu();
function Fe(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, a = j({
    isFocused: !1,
    isFocusVisible: t || Nn()
  }), [l, i] = q(!1), [o, u] = q(() => a.current.isFocused && a.current.isFocusVisible), s = ie(() => u(a.current.isFocused && a.current.isFocusVisible), []), d = ie((b) => {
    a.current.isFocused = b, i(b), s();
  }, [
    s
  ]);
  x6((b) => {
    a.current.isFocusVisible = b, s();
  }, [], {
    isTextInput: n
  });
  let { focusProps: c } = na({
    isDisabled: r,
    onFocusChange: d
  }), { focusWithinProps: f } = jt({
    isDisabled: !r,
    onFocusWithinChange: d
  });
  return {
    isFocused: l,
    isFocusVisible: o,
    focusProps: r ? f : c
  };
}
function es(e, t) {
  let n = t == null ? void 0 : t.isDisabled, [r, a] = q(!1);
  return Ce(() => {
    if (e != null && e.current && !n) {
      let l = () => {
        if (e.current) {
          let o = Je(e.current, {
            tabbable: !0
          });
          a(!!o.nextNode());
        }
      };
      l();
      let i = new MutationObserver(l);
      return i.observe(e.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        i.disconnect();
      };
    }
  }), n ? !1 : r;
}
function B4(e) {
  let t = n2(ke(e));
  t !== e && (t && t2(t, e), e && F4(e, t));
}
function t2(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function F4(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function n2(e) {
  let t = ft(e), n = t == null ? void 0 : t.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
function r2(e, t) {
  const { "aria-label": n, "aria-labelledby": r, orientation: a = "horizontal" } = e;
  let [l, i] = q(!1);
  Ce(() => {
    var p;
    i(!!(t.current && (!((p = t.current.parentElement) === null || p === void 0) && p.closest('[role="toolbar"]'))));
  });
  const { direction: o } = me(), u = o === "rtl" && a === "horizontal";
  let s = ia(t);
  const d = (p) => {
    if (p.currentTarget.contains(p.target)) {
      if (a === "horizontal" && p.key === "ArrowRight" || a === "vertical" && p.key === "ArrowDown")
        u ? s.focusPrevious() : s.focusNext();
      else if (a === "horizontal" && p.key === "ArrowLeft" || a === "vertical" && p.key === "ArrowUp")
        u ? s.focusNext() : s.focusPrevious();
      else if (p.key === "Tab") {
        p.stopPropagation(), c.current = document.activeElement, p.shiftKey ? s.focusFirst() : s.focusLast();
        return;
      } else
        return;
      p.stopPropagation(), p.preventDefault();
    }
  }, c = j(null), f = (p) => {
    !p.currentTarget.contains(p.relatedTarget) && !c.current && (c.current = p.target);
  }, b = (p) => {
    var h;
    if (c.current && !p.currentTarget.contains(p.relatedTarget) && (!((h = t.current) === null || h === void 0) && h.contains(p.target))) {
      var m;
      (m = c.current) === null || m === void 0 || m.focus(), c.current = null;
    }
  };
  return {
    toolbarProps: {
      ...J(e, {
        labelable: !0
      }),
      role: l ? "group" : "toolbar",
      "aria-orientation": a,
      "aria-label": n,
      "aria-labelledby": n == null ? r : void 0,
      onKeyDownCapture: l ? void 0 : d,
      onFocusCapture: l ? void 0 : b,
      onBlurCapture: l ? void 0 : f
    }
  };
}
function a2(e, t, n) {
  let { isDisabled: r } = e, { toolbarProps: a } = r2(e, n);
  return {
    groupProps: {
      ...a,
      role: t.selectionMode === "single" ? "radiogroup" : a.role,
      "aria-disabled": r
    }
  };
}
function l2(e, t, n) {
  let r = {
    isSelected: t.selectedKeys.has(e.id),
    setSelected(u) {
      t.setSelected(e.id, u);
    },
    toggle() {
      t.toggleKey(e.id);
    }
  }, { isPressed: a, isSelected: l, isDisabled: i, buttonProps: o } = w4({
    ...e,
    id: void 0,
    isDisabled: e.isDisabled || t.isDisabled
  }, r, n);
  return t.selectionMode === "single" && (o.role = "radio", o["aria-checked"] = r.isSelected, delete o["aria-pressed"]), {
    isPressed: a,
    isSelected: l,
    isDisabled: i,
    buttonProps: o
  };
}
var A4 = {};
A4 = {
  dateRange: (e) => `${e.startDate} إلى ${e.endDate}`,
  dateSelected: (e) => `${e.date} المحدد`,
  finishRangeSelectionPrompt: "انقر لإنهاء عملية تحديد نطاق التاريخ",
  maximumDate: "آخر تاريخ متاح",
  minimumDate: "أول تاريخ متاح",
  next: "التالي",
  previous: "السابق",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.dateRange}`,
  startRangeSelectionPrompt: "انقر لبدء عملية تحديد نطاق التاريخ",
  todayDate: (e) => `اليوم، ${e.date}`,
  todayDateSelected: (e) => `اليوم، ${e.date} محدد`
};
var T4 = {};
T4 = {
  dateRange: (e) => `${e.startDate} до ${e.endDate}`,
  dateSelected: (e) => `Избрано е ${e.date}`,
  finishRangeSelectionPrompt: "Натиснете, за да довършите избора на времеви интервал",
  maximumDate: "Последна налична дата",
  minimumDate: "Първа налична дата",
  next: "Напред",
  previous: "Назад",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натиснете, за да пристъпите към избора на времеви интервал",
  todayDate: (e) => `Днес, ${e.date}`,
  todayDateSelected: (e) => `Днес, ${e.date} са избрани`
};
var R4 = {};
R4 = {
  dateRange: (e) => `${e.startDate} až ${e.endDate}`,
  dateSelected: (e) => `Vybráno ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výběr rozsahu dat",
  maximumDate: "Poslední dostupné datum",
  minimumDate: "První dostupné datum",
  next: "Další",
  previous: "Předchozí",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím zahájíte výběr rozsahu dat",
  todayDate: (e) => `Dnes, ${e.date}`,
  todayDateSelected: (e) => `Dnes, vybráno ${e.date}`
};
var M4 = {};
M4 = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klik for at fuldføre valg af datoområde",
  maximumDate: "Sidste ledige dato",
  minimumDate: "Første ledige dato",
  next: "Næste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik for at starte valg af datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var N4 = {};
N4 = {
  dateRange: (e) => `${e.startDate} bis ${e.endDate}`,
  dateSelected: (e) => `${e.date} ausgewählt`,
  finishRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  maximumDate: "Letztes verfügbares Datum",
  minimumDate: "Erstes verfügbares Datum",
  next: "Weiter",
  previous: "Zurück",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  todayDate: (e) => `Heute, ${e.date}`,
  todayDateSelected: (e) => `Heute, ${e.date} ausgewählt`
};
var V4 = {};
V4 = {
  dateRange: (e) => `${e.startDate} έως ${e.endDate}`,
  dateSelected: (e) => `Επιλέχθηκε ${e.date}`,
  finishRangeSelectionPrompt: "Κάντε κλικ για να ολοκληρώσετε την επιλογή εύρους ημερομηνιών",
  maximumDate: "Τελευταία διαθέσιμη ημερομηνία",
  minimumDate: "Πρώτη διαθέσιμη ημερομηνία",
  next: "Επόμενο",
  previous: "Προηγούμενο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.dateRange}`,
  startRangeSelectionPrompt: "Κάντε κλικ για να ξεκινήσετε την επιλογή εύρους ημερομηνιών",
  todayDate: (e) => `Σήμερα, ${e.date}`,
  todayDateSelected: (e) => `Σήμερα, επιλέχτηκε ${e.date}`
};
var I4 = {};
I4 = {
  previous: "Previous",
  next: "Next",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.dateRange}`,
  todayDate: (e) => `Today, ${e.date}`,
  todayDateSelected: (e) => `Today, ${e.date} selected`,
  dateSelected: (e) => `${e.date} selected`,
  startRangeSelectionPrompt: "Click to start selecting date range",
  finishRangeSelectionPrompt: "Click to finish selecting date range",
  minimumDate: "First available date",
  maximumDate: "Last available date",
  dateRange: (e) => `${e.startDate} to ${e.endDate}`
};
var O4 = {};
O4 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} seleccionado`,
  finishRangeSelectionPrompt: "Haga clic para terminar de seleccionar rango de fechas",
  maximumDate: "Última fecha disponible",
  minimumDate: "Primera fecha disponible",
  next: "Siguiente",
  previous: "Anterior",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo seleccionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Haga clic para comenzar a seleccionar un rango de fechas",
  todayDate: (e) => `Hoy, ${e.date}`,
  todayDateSelected: (e) => `Hoy, ${e.date} seleccionado`
};
var z4 = {};
z4 = {
  dateRange: (e) => `${e.startDate} kuni ${e.endDate}`,
  dateSelected: (e) => `${e.date} valitud`,
  finishRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimise lõpetamiseks",
  maximumDate: "Viimane saadaolev kuupäev",
  minimumDate: "Esimene saadaolev kuupäev",
  next: "Järgmine",
  previous: "Eelmine",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimiseks",
  todayDate: (e) => `Täna, ${e.date}`,
  todayDateSelected: (e) => `Täna, ${e.date} valitud`
};
var K4 = {};
K4 = {
  dateRange: (e) => `${e.startDate} – ${e.endDate}`,
  dateSelected: (e) => `${e.date} valittu`,
  finishRangeSelectionPrompt: "Lopeta päivämääräalueen valinta napsauttamalla tätä.",
  maximumDate: "Viimeinen varattavissa oleva päivämäärä",
  minimumDate: "Ensimmäinen varattavissa oleva päivämäärä",
  next: "Seuraava",
  previous: "Edellinen",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.dateRange}`,
  startRangeSelectionPrompt: "Aloita päivämääräalueen valinta napsauttamalla tätä.",
  todayDate: (e) => `Tänään, ${e.date}`,
  todayDateSelected: (e) => `Tänään, ${e.date} valittu`
};
var j4 = {};
j4 = {
  dateRange: (e) => `${e.startDate} à ${e.endDate}`,
  dateSelected: (e) => `${e.date} sélectionné`,
  finishRangeSelectionPrompt: "Cliquer pour finir de sélectionner la plage de dates",
  maximumDate: "Dernière date disponible",
  minimumDate: "Première date disponible",
  next: "Suivant",
  previous: "Précédent",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.dateRange}`,
  startRangeSelectionPrompt: "Cliquer pour commencer à sélectionner la plage de dates",
  todayDate: (e) => `Aujourd'hui, ${e.date}`,
  todayDateSelected: (e) => `Aujourd’hui, ${e.date} sélectionné`
};
var L4 = {};
L4 = {
  dateRange: (e) => `${e.startDate} עד ${e.endDate}`,
  dateSelected: (e) => `${e.date} נבחר`,
  finishRangeSelectionPrompt: "חץ כדי לסיים את בחירת טווח התאריכים",
  maximumDate: "תאריך פנוי אחרון",
  minimumDate: "תאריך פנוי ראשון",
  next: "הבא",
  previous: "הקודם",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.dateRange}`,
  startRangeSelectionPrompt: "לחץ כדי להתחיל בבחירת טווח התאריכים",
  todayDate: (e) => `היום, ${e.date}`,
  todayDateSelected: (e) => `היום, ${e.date} נבחר`
};
var H4 = {};
H4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} odabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite raspon odabranih datuma",
  maximumDate: "Posljednji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sljedeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete raspon odabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, odabran ${e.date}`
};
var _4 = {};
_4 = {
  dateRange: (e) => `${e.startDate}–${e.endDate}`,
  dateSelected: (e) => `${e.date} kiválasztva`,
  finishRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének befejezéséhez",
  maximumDate: "Utolsó elérhető dátum",
  minimumDate: "Az első elérhető dátum",
  next: "Következő",
  previous: "Előző",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének indításához",
  todayDate: (e) => `Ma, ${e.date}`,
  todayDateSelected: (e) => `Ma, ${e.date} kijelölve`
};
var U4 = {};
U4 = {
  dateRange: (e) => `Da ${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selezionata`,
  finishRangeSelectionPrompt: "Fai clic per completare la selezione dell’intervallo di date",
  maximumDate: "Ultima data disponibile",
  minimumDate: "Prima data disponibile",
  next: "Successivo",
  previous: "Precedente",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: ${e.dateRange}`,
  startRangeSelectionPrompt: "Fai clic per selezionare l’intervallo di date",
  todayDate: (e) => `Oggi, ${e.date}`,
  todayDateSelected: (e) => `Oggi, ${e.date} selezionata`
};
var W4 = {};
W4 = {
  dateRange: (e) => `${e.startDate} から ${e.endDate}`,
  dateSelected: (e) => `${e.date} を選択`,
  finishRangeSelectionPrompt: "クリックして日付範囲の選択を終了",
  maximumDate: "最終利用可能日",
  minimumDate: "最初の利用可能日",
  next: "次へ",
  previous: "前へ",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.dateRange}`,
  startRangeSelectionPrompt: "クリックして日付範囲の選択を開始",
  todayDate: (e) => `本日、${e.date}`,
  todayDateSelected: (e) => `本日、${e.date} を選択`
};
var G4 = {};
G4 = {
  dateRange: (e) => `${e.startDate} ~ ${e.endDate}`,
  dateSelected: (e) => `${e.date} 선택됨`,
  finishRangeSelectionPrompt: "날짜 범위 선택을 완료하려면 클릭하십시오.",
  maximumDate: "마지막으로 사용 가능한 일자",
  minimumDate: "처음으로 사용 가능한 일자",
  next: "다음",
  previous: "이전",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.dateRange}`,
  startRangeSelectionPrompt: "날짜 범위 선택을 시작하려면 클릭하십시오.",
  todayDate: (e) => `오늘, ${e.date}`,
  todayDateSelected: (e) => `오늘, ${e.date} 선택됨`
};
var Z4 = {};
Z4 = {
  dateRange: (e) => `Nuo ${e.startDate} iki ${e.endDate}`,
  dateSelected: (e) => `Pasirinkta ${e.date}`,
  finishRangeSelectionPrompt: "Spustelėkite, kad baigtumėte pasirinkti datų intervalą",
  maximumDate: "Paskutinė galima data",
  minimumDate: "Pirmoji galima data",
  next: "Paskesnis",
  previous: "Ankstesnis",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: ${e.dateRange}`,
  startRangeSelectionPrompt: "Spustelėkite, kad pradėtumėte pasirinkti datų intervalą",
  todayDate: (e) => `Šiandien, ${e.date}`,
  todayDateSelected: (e) => `Šiandien, pasirinkta ${e.date}`
};
var Y4 = {};
Y4 = {
  dateRange: (e) => `No ${e.startDate} līdz ${e.endDate}`,
  dateSelected: (e) => `Atlasīts: ${e.date}`,
  finishRangeSelectionPrompt: "Noklikšķiniet, lai pabeigtu datumu diapazona atlasi",
  maximumDate: "Pēdējais pieejamais datums",
  minimumDate: "Pirmais pieejamais datums",
  next: "Tālāk",
  previous: "Atpakaļ",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: ${e.dateRange}`,
  startRangeSelectionPrompt: "Noklikšķiniet, lai sāktu datumu diapazona atlasi",
  todayDate: (e) => `Šodien, ${e.date}`,
  todayDateSelected: (e) => `Atlasīta šodiena, ${e.date}`
};
var q4 = {};
q4 = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klikk for å fullføre valg av datoområde",
  maximumDate: "Siste tilgjengelige dato",
  minimumDate: "Første tilgjengelige dato",
  next: "Neste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klikk for å starte valg av datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var X4 = {};
X4 = {
  dateRange: (e) => `${e.startDate} tot ${e.endDate}`,
  dateSelected: (e) => `${e.date} geselecteerd`,
  finishRangeSelectionPrompt: "Klik om de selectie van het datumbereik te voltooien",
  maximumDate: "Laatste beschikbare datum",
  minimumDate: "Eerste beschikbare datum",
  next: "Volgende",
  previous: "Vorige",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik om het datumbereik te selecteren",
  todayDate: (e) => `Vandaag, ${e.date}`,
  todayDateSelected: (e) => `Vandaag, ${e.date} geselecteerd`
};
var J4 = {};
J4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Wybrano ${e.date}`,
  finishRangeSelectionPrompt: "Kliknij, aby zakończyć wybór zakresu dat",
  maximumDate: "Ostatnia dostępna data",
  minimumDate: "Pierwsza dostępna data",
  next: "Dalej",
  previous: "Wstecz",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknij, aby rozpocząć wybór zakresu dat",
  todayDate: (e) => `Dzisiaj, ${e.date}`,
  todayDateSelected: (e) => `Dzisiaj wybrano ${e.date}`
};
var Q4 = {};
Q4 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para concluir a seleção do intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para iniciar a seleção do intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var eb = {};
eb = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para terminar de selecionar o intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para começar a selecionar o intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var tb = {};
tb = {
  dateRange: (e) => `De la ${e.startDate} până la ${e.endDate}`,
  dateSelected: (e) => `${e.date} selectată`,
  finishRangeSelectionPrompt: "Apăsaţi pentru a finaliza selecţia razei pentru dată",
  maximumDate: "Ultima dată disponibilă",
  minimumDate: "Prima dată disponibilă",
  next: "Următorul",
  previous: "Înainte",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: ${e.dateRange}`,
  startRangeSelectionPrompt: "Apăsaţi pentru a începe selecţia razei pentru dată",
  todayDate: (e) => `Astăzi, ${e.date}`,
  todayDateSelected: (e) => `Azi, ${e.date} selectată`
};
var nb = {};
nb = {
  dateRange: (e) => `С ${e.startDate} по ${e.endDate}`,
  dateSelected: (e) => `Выбрано ${e.date}`,
  finishRangeSelectionPrompt: "Щелкните, чтобы завершить выбор диапазона дат",
  maximumDate: "Последняя доступная дата",
  minimumDate: "Первая доступная дата",
  next: "Далее",
  previous: "Назад",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Щелкните, чтобы начать выбор диапазона дат",
  todayDate: (e) => `Сегодня, ${e.date}`,
  todayDateSelected: (e) => `Сегодня, выбрано ${e.date}`
};
var rb = {};
rb = {
  dateRange: (e) => `Od ${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Vybratý dátum ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výber rozsahu dátumov",
  maximumDate: "Posledný dostupný dátum",
  minimumDate: "Prvý dostupný dátum",
  next: "Nasledujúce",
  previous: "Predchádzajúce",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím spustíte výber rozsahu dátumov",
  todayDate: (e) => `Dnes ${e.date}`,
  todayDateSelected: (e) => `Vybratý dnešný dátum ${e.date}`
};
var ab = {};
ab = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izbrano`,
  finishRangeSelectionPrompt: "Kliknite za dokončanje izbire datumskega obsega",
  maximumDate: "Zadnji razpoložljivi datum",
  minimumDate: "Prvi razpoložljivi datum",
  next: "Naprej",
  previous: "Nazaj",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite za začetek izbire datumskega obsega",
  todayDate: (e) => `Danes, ${e.date}`,
  todayDateSelected: (e) => `Danes, ${e.date} izbrano`
};
var lb = {};
lb = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite opseg izabranih datuma",
  maximumDate: "Zadnji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sledeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani period: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete opseg izabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, izabran ${e.date}`
};
var ib = {};
ib = {
  dateRange: (e) => `${e.startDate} till ${e.endDate}`,
  dateSelected: (e) => `${e.date} har valts`,
  finishRangeSelectionPrompt: "Klicka för att avsluta val av datumintervall",
  maximumDate: "Sista tillgängliga datum",
  minimumDate: "Första tillgängliga datum",
  next: "Nästa",
  previous: "Föregående",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicka för att välja datumintervall",
  todayDate: (e) => `Idag, ${e.date}`,
  todayDateSelected: (e) => `Idag, ${e.date} har valts`
};
var ob = {};
ob = {
  dateRange: (e) => `${e.startDate} - ${e.endDate}`,
  dateSelected: (e) => `${e.date} seçildi`,
  finishRangeSelectionPrompt: "Tarih aralığı seçimini tamamlamak için tıklayın",
  maximumDate: "Son müsait tarih",
  minimumDate: "İlk müsait tarih",
  next: "Sonraki",
  previous: "Önceki",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.dateRange}`,
  startRangeSelectionPrompt: "Tarih aralığı seçimini başlatmak için tıklayın",
  todayDate: (e) => `Bugün, ${e.date}`,
  todayDateSelected: (e) => `Bugün, ${e.date} seçildi`
};
var ub = {};
ub = {
  dateRange: (e) => `${e.startDate} — ${e.endDate}`,
  dateSelected: (e) => `Вибрано ${e.date}`,
  finishRangeSelectionPrompt: "Натисніть, щоб завершити вибір діапазону дат",
  maximumDate: "Остання доступна дата",
  minimumDate: "Перша доступна дата",
  next: "Наступний",
  previous: "Попередній",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натисніть, щоб почати вибір діапазону дат",
  todayDate: (e) => `Сьогодні, ${e.date}`,
  todayDateSelected: (e) => `Сьогодні, вибрано ${e.date}`
};
var sb = {};
sb = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已选择 ${e.date}`,
  finishRangeSelectionPrompt: "单击以完成选择日期范围",
  maximumDate: "最后一个可用日期",
  minimumDate: "第一个可用日期",
  next: "下一页",
  previous: "上一页",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.dateRange}`,
  startRangeSelectionPrompt: "单击以开始选择日期范围",
  todayDate: (e) => `今天，即 ${e.date}`,
  todayDateSelected: (e) => `已选择今天，即 ${e.date}`
};
var db = {};
db = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已選取 ${e.date}`,
  finishRangeSelectionPrompt: "按一下以完成選取日期範圍",
  maximumDate: "最後一個可用日期",
  minimumDate: "第一個可用日期",
  next: "下一頁",
  previous: "上一頁",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.dateRange}`,
  startRangeSelectionPrompt: "按一下以開始選取日期範圍",
  todayDate: (e) => `今天，${e.date}`,
  todayDateSelected: (e) => `已選取今天，${e.date}`
};
var al = {};
al = {
  "ar-AE": A4,
  "bg-BG": T4,
  "cs-CZ": R4,
  "da-DK": M4,
  "de-DE": N4,
  "el-GR": V4,
  "en-US": I4,
  "es-ES": O4,
  "et-EE": z4,
  "fi-FI": K4,
  "fr-FR": j4,
  "he-IL": L4,
  "hr-HR": H4,
  "hu-HU": _4,
  "it-IT": U4,
  "ja-JP": W4,
  "ko-KR": G4,
  "lt-LT": Z4,
  "lv-LV": Y4,
  "nb-NO": q4,
  "nl-NL": X4,
  "pl-PL": J4,
  "pt-BR": Q4,
  "pt-PT": eb,
  "ro-RO": tb,
  "ru-RU": nb,
  "sk-SK": rb,
  "sl-SI": ab,
  "sr-SP": lb,
  "sv-SE": ib,
  "tr-TR": ob,
  "uk-UA": ub,
  "zh-CN": sb,
  "zh-TW": db
};
function cb(e) {
  return e && e.__esModule ? e.default : e;
}
const ts = /* @__PURE__ */ new WeakMap();
function Ua(e) {
  return (e == null ? void 0 : e.calendar.identifier) === "gregory" && e.era === "BC" ? "short" : void 0;
}
function i2(e) {
  let t = Oe(cb(al), "@react-aria/calendar"), n, r;
  var a;
  "highlightedRange" in e ? { start: n, end: r } = e.highlightedRange || {} : n = r = (a = e.value) !== null && a !== void 0 ? a : void 0;
  let l = fn({
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: Ua(n) || Ua(r),
    timeZone: e.timeZone
  }), i = "anchorDate" in e ? e.anchorDate : null;
  return H(() => {
    if (!i && n && r)
      if (Xe(n, r)) {
        let o = l.format(n.toDate(e.timeZone));
        return t.format("selectedDateDescription", {
          date: o
        });
      } else {
        let o = eu(l, t, n, r, e.timeZone);
        return t.format("selectedRangeDescription", {
          dateRange: o
        });
      }
    return "";
  }, [
    n,
    r,
    i,
    e.timeZone,
    t,
    l
  ]);
}
function Qo(e, t, n, r) {
  let a = Oe(cb(al), "@react-aria/calendar"), l = Ua(e) || Ua(t), i = fn({
    month: "long",
    year: "numeric",
    era: l,
    calendar: e.calendar.identifier,
    timeZone: n
  }), o = fn({
    month: "long",
    year: "numeric",
    day: "numeric",
    era: l,
    calendar: e.calendar.identifier,
    timeZone: n
  });
  return H(() => {
    if (Xe(e, Br(e))) {
      let u = e, s = t;
      if (e.calendar.getFormattableMonth && (u = e.calendar.getFormattableMonth(e)), t.calendar.getFormattableMonth && (s = t.calendar.getFormattableMonth(t)), Xe(t, Gl(e))) return i.format(u.toDate(n));
      if (Xe(t, Gl(t))) return r ? eu(i, a, u, s, n) : i.formatRange(u.toDate(n), s.toDate(n));
    }
    return r ? eu(o, a, e, t, n) : o.formatRange(e.toDate(n), t.toDate(n));
  }, [
    e,
    t,
    i,
    o,
    a,
    n,
    r
  ]);
}
function eu(e, t, n, r, a) {
  let l = e.formatRangeToParts(n.toDate(a), r.toDate(a)), i = -1;
  for (let s = 0; s < l.length; s++) {
    let d = l[s];
    if (d.source === "shared" && d.type === "literal") i = s;
    else if (d.source === "endRange") break;
  }
  let o = "", u = "";
  for (let s = 0; s < l.length; s++)
    s < i ? o += l[s].value : s > i && (u += l[s].value);
  return t.format("dateRange", {
    startDate: o,
    endDate: u
  });
}
const fb = 7e3;
let Wt = null;
function hn(e, t = "assertive", n = fb) {
  Wt ? Wt.announce(e, t, n) : (Wt = new u2(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? Wt.announce(e, t, n) : setTimeout(() => {
    Wt != null && Wt.isAttached() && (Wt == null || Wt.announce(e, t, n));
  }, 100));
}
function o2(e) {
  Wt && Wt.clear(e);
}
class u2 {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = fb) {
    var a, l;
    if (!this.node) return;
    let i = document.createElement("div");
    typeof t == "object" ? (i.setAttribute("role", "img"), i.setAttribute("aria-labelledby", t["aria-labelledby"])) : i.textContent = t, n === "assertive" ? (a = this.assertiveLog) === null || a === void 0 || a.appendChild(i) : (l = this.politeLog) === null || l === void 0 || l.appendChild(i), t !== "" && setTimeout(() => {
      i.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function s2(e) {
  return e && e.__esModule ? e.default : e;
}
function bb(e, t) {
  let n = Oe(s2(al), "@react-aria/calendar"), r = J(e), a = Qo(t.visibleRange.start, t.visibleRange.end, t.timeZone, !1), l = Qo(t.visibleRange.start, t.visibleRange.end, t.timeZone, !0);
  za(() => {
    t.isFocused || hn(l);
  }, [
    l
  ]);
  let i = i2(t);
  za(() => {
    i && hn(i, "polite", 4e3);
  }, [
    i
  ]);
  let o = pn([
    !!e.errorMessage,
    e.isInvalid,
    e.validationState
  ]);
  ts.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: e["aria-labelledby"],
    errorMessageId: o,
    selectedDateDescription: i
  });
  let [u, s] = q(!1), d = e.isDisabled || t.isNextVisibleRangeInvalid();
  d && u && (s(!1), t.setFocused(!0));
  let [c, f] = q(!1), b = e.isDisabled || t.isPreviousVisibleRangeInvalid();
  b && c && (f(!1), t.setFocused(!0));
  let p = Ot({
    id: e.id,
    "aria-label": [
      e["aria-label"],
      l
    ].filter(Boolean).join(", "),
    "aria-labelledby": e["aria-labelledby"]
  });
  return {
    calendarProps: _(r, p, {
      role: "application",
      "aria-describedby": e["aria-describedby"] || void 0
    }),
    nextButtonProps: {
      onPress: () => t.focusNextPage(),
      "aria-label": n.format("next"),
      isDisabled: d,
      onFocusChange: s
    },
    prevButtonProps: {
      onPress: () => t.focusPreviousPage(),
      "aria-label": n.format("previous"),
      isDisabled: b,
      onFocusChange: f
    },
    errorMessageProps: {
      id: o
    },
    title: a
  };
}
function d2(e, t) {
  return bb(e, t);
}
function c2(e, t, n) {
  let r = bb(e, t), a = j(!1), l = j(typeof window < "u" ? window : null);
  return qt(l, "pointerdown", (o) => {
    a.current = o.width === 0 && o.height === 0;
  }), qt(l, "pointerup", (o) => {
    if (a.current) {
      a.current = !1;
      return;
    }
    if (t.setDragging(!1), !t.anchorDate) return;
    let u = o.target;
    n.current && n.current.contains(document.activeElement) && (!n.current.contains(u) || !u.closest('button, [role="button"]')) && t.selectFocusedDate();
  }), r.calendarProps.onBlur = (o) => {
    n.current && (!o.relatedTarget || !n.current.contains(o.relatedTarget)) && t.anchorDate && t.selectFocusedDate();
  }, qt(n, "touchmove", (o) => {
    t.isDragging && o.preventDefault();
  }, {
    passive: !1,
    capture: !0
  }), r;
}
function f2(e, t) {
  let { startDate: n = t.visibleRange.start, endDate: r = t.visibleRange.end, firstDayOfWeek: a } = e, { direction: l } = me(), i = (h) => {
    switch (h.key) {
      case "Enter":
      case " ":
        h.preventDefault(), t.selectFocusedDate();
        break;
      case "PageUp":
        h.preventDefault(), h.stopPropagation(), t.focusPreviousSection(h.shiftKey);
        break;
      case "PageDown":
        h.preventDefault(), h.stopPropagation(), t.focusNextSection(h.shiftKey);
        break;
      case "End":
        h.preventDefault(), h.stopPropagation(), t.focusSectionEnd();
        break;
      case "Home":
        h.preventDefault(), h.stopPropagation(), t.focusSectionStart();
        break;
      case "ArrowLeft":
        h.preventDefault(), h.stopPropagation(), l === "rtl" ? t.focusNextDay() : t.focusPreviousDay();
        break;
      case "ArrowUp":
        h.preventDefault(), h.stopPropagation(), t.focusPreviousRow();
        break;
      case "ArrowRight":
        h.preventDefault(), h.stopPropagation(), l === "rtl" ? t.focusPreviousDay() : t.focusNextDay();
        break;
      case "ArrowDown":
        h.preventDefault(), h.stopPropagation(), t.focusNextRow();
        break;
      case "Escape":
        "setAnchorDate" in t && (h.preventDefault(), t.setAnchorDate(null));
        break;
    }
  }, o = Qo(n, r, t.timeZone, !0), { ariaLabel: u, ariaLabelledBy: s } = ts.get(t), d = Ot({
    "aria-label": [
      u,
      o
    ].filter(Boolean).join(", "),
    "aria-labelledby": s
  }), c = fn({
    weekday: e.weekdayStyle || "narrow",
    timeZone: t.timeZone
  }), { locale: f } = me(), b = H(() => {
    let h = La(gi(t.timeZone), f, a);
    return [
      ...new Array(7).keys()
    ].map((m) => {
      let y = h.add({
        days: m
      }).toDate(t.timeZone);
      return c.format(y);
    });
  }, [
    f,
    t.timeZone,
    c,
    a
  ]), p = e4(n, f, a);
  return {
    gridProps: _(d, {
      role: "grid",
      "aria-readonly": t.isReadOnly || void 0,
      "aria-disabled": t.isDisabled || void 0,
      "aria-multiselectable": "highlightedRange" in t || void 0,
      onKeyDown: i,
      onFocus: () => t.setFocused(!0),
      onBlur: () => t.setFocused(!1)
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      "aria-hidden": !0
    },
    weekDays: b,
    weeksInMonth: p
  };
}
function b2(e) {
  return e && e.__esModule ? e.default : e;
}
function p2(e, t, n) {
  let { date: r, isDisabled: a } = e, { errorMessageId: l, selectedDateDescription: i } = ts.get(t), o = Oe(b2(al), "@react-aria/calendar"), u = fn({
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    era: Ua(r),
    timeZone: t.timeZone
  }), s = t.isSelected(r), d = t.isCellFocused(r);
  a = a || t.isCellDisabled(r);
  let c = t.isCellUnavailable(r), f = !a && !c, b = t.isValueInvalid && !!("highlightedRange" in t ? !t.anchorDate && t.highlightedRange && r.compare(t.highlightedRange.start) >= 0 && r.compare(t.highlightedRange.end) <= 0 : t.value && Xe(t.value, r));
  b && (s = !0), r = ef(r, Lo);
  let p = H(() => r.toDate(t.timeZone), [
    r,
    t.timeZone
  ]), h = U6(r, t.timeZone), m = H(() => {
    let $ = "";
    return "highlightedRange" in t && t.value && !t.anchorDate && (Xe(r, t.value.start) || Xe(r, t.value.end)) && ($ = i + ", "), $ += u.format(p), h ? $ = o.format(s ? "todayDateSelected" : "todayDate", {
      date: $
    }) : s && ($ = o.format("dateSelected", {
      date: $
    })), t.minValue && Xe(r, t.minValue) ? $ += ", " + o.format("minimumDate") : t.maxValue && Xe(r, t.maxValue) && ($ += ", " + o.format("maximumDate")), $;
  }, [
    u,
    p,
    o,
    s,
    h,
    r,
    t,
    i
  ]), v = "";
  "anchorDate" in t && d && !t.isReadOnly && f && (t.anchorDate ? v = o.format("finishRangeSelectionPrompt") : v = o.format("startRangeSelectionPrompt"));
  let y = $n(v), w = j(!1), C = j(!1), D = j(void 0), { pressProps: P, isPressed: R } = Tt({
    // When dragging to select a range, we don't want dragging over the original anchor
    // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
    shouldCancelOnPointerExit: "anchorDate" in t && !!t.anchorDate,
    preventFocusOnPress: !0,
    isDisabled: !f || t.isReadOnly,
    onPressStart($) {
      if (t.isReadOnly) {
        t.setFocusedDate(r);
        return;
      }
      if ("highlightedRange" in t && !t.anchorDate && ($.pointerType === "mouse" || $.pointerType === "touch")) {
        if (t.highlightedRange && !b) {
          if (Xe(r, t.highlightedRange.start)) {
            t.setAnchorDate(t.highlightedRange.end), t.setFocusedDate(r), t.setDragging(!0), C.current = !0;
            return;
          } else if (Xe(r, t.highlightedRange.end)) {
            t.setAnchorDate(t.highlightedRange.start), t.setFocusedDate(r), t.setDragging(!0), C.current = !0;
            return;
          }
        }
        let S = () => {
          t.setDragging(!0), D.current = void 0, t.selectDate(r), t.setFocusedDate(r), w.current = !0;
        };
        $.pointerType === "touch" ? D.current = setTimeout(S, 200) : S();
      }
    },
    onPressEnd() {
      C.current = !1, w.current = !1, clearTimeout(D.current), D.current = void 0;
    },
    onPress() {
      !("anchorDate" in t) && !t.isReadOnly && (t.selectDate(r), t.setFocusedDate(r));
    },
    onPressUp($) {
      if (!t.isReadOnly && ("anchorDate" in t && D.current && (t.selectDate(r), t.setFocusedDate(r)), "anchorDate" in t))
        if (C.current)
          t.setAnchorDate(r);
        else if (t.anchorDate && !w.current)
          t.selectDate(r), t.setFocusedDate(r);
        else if ($.pointerType === "keyboard" && !t.anchorDate) {
          t.selectDate(r);
          let S = r.add({
            days: 1
          });
          t.isInvalid(S) && (S = r.subtract({
            days: 1
          })), t.isInvalid(S) || t.setFocusedDate(S);
        } else $.pointerType === "virtual" && (t.selectDate(r), t.setFocusedDate(r));
    }
  }), V;
  a || (V = Xe(r, t.focusedDate) ? 0 : -1), re(() => {
    d && n.current && (Et(n.current), ta() !== "pointer" && document.activeElement === n.current && mt(n.current, {
      containingElement: ht(n.current)
    }));
  }, [
    d,
    n
  ]);
  let L = fn({
    day: "numeric",
    timeZone: t.timeZone,
    calendar: r.calendar.identifier
  }), A = H(() => L.formatToParts(p).find(($) => $.type === "day").value, [
    L,
    p
  ]);
  return {
    cellProps: {
      role: "gridcell",
      "aria-disabled": !f || void 0,
      "aria-selected": s || void 0,
      "aria-invalid": b || void 0
    },
    buttonProps: _(P, {
      onFocus() {
        a || t.setFocusedDate(r);
      },
      tabIndex: V,
      role: "button",
      "aria-disabled": !f || void 0,
      "aria-label": m,
      "aria-invalid": b || void 0,
      "aria-describedby": [
        b ? l : void 0,
        y["aria-describedby"]
      ].filter(Boolean).join(" ") || void 0,
      onPointerEnter($) {
        "highlightDate" in t && ($.pointerType !== "touch" || t.isDragging) && f && t.highlightDate(r);
      },
      onPointerDown($) {
        "releasePointerCapture" in $.target && $.target.releasePointerCapture($.pointerId);
      },
      onContextMenu($) {
        $.preventDefault();
      }
    }),
    isPressed: R,
    isFocused: d,
    isSelected: s,
    isDisabled: a,
    isUnavailable: c,
    isOutsideVisibleRange: r.compare(t.visibleRange.start) < 0 || r.compare(t.visibleRange.end) > 0,
    isInvalid: b,
    formattedDate: A
  };
}
const Di = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, pb = {
  ...Di,
  customError: !0,
  valid: !1
}, Jn = {
  isInvalid: !1,
  validationDetails: Di,
  validationErrors: []
}, hb = G({}), mn = "__formValidationState" + Date.now();
function en(e) {
  if (e[mn]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: a, commitValidation: l } = e[mn];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: a,
      commitValidation: l
    };
  }
  return h2(e);
}
function h2(e) {
  let { isInvalid: t, validationState: n, name: r, value: a, builtinValidation: l, validate: i, validationBehavior: o = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let u = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: pb
  } : null, s = H(() => {
    if (!i || a == null) return null;
    let A = m2(i, a);
    return Ld(A);
  }, [
    i,
    a
  ]);
  l != null && l.validationDetails.valid && (l = void 0);
  let d = U(hb), c = H(() => r ? Array.isArray(r) ? r.flatMap((A) => tu(d[A])) : tu(d[r]) : [], [
    d,
    r
  ]), [f, b] = q(d), [p, h] = q(!1);
  d !== f && (b(d), h(!1));
  let m = H(() => Ld(p ? [] : c), [
    p,
    c
  ]), v = j(Jn), [y, w] = q(Jn), C = j(Jn), D = () => {
    if (!P) return;
    R(!1);
    let A = s || l || v.current;
    po(A, C.current) || (C.current = A, w(A));
  }, [P, R] = q(!1);
  return re(D), {
    realtimeValidation: u || m || s || l || Jn,
    displayValidation: o === "native" ? u || m || y : u || m || s || l || y,
    updateValidation(A) {
      o === "aria" && !po(y, A) ? w(A) : v.current = A;
    },
    resetValidation() {
      let A = Jn;
      po(A, C.current) || (C.current = A, w(A)), o === "native" && R(!1), h(!0);
    },
    commitValidation() {
      o === "native" && R(!0), h(!0);
    }
  };
}
function tu(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function m2(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return tu(n);
  }
  return [];
}
function Ld(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: pb
  } : null;
}
function po(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
function Wa(...e) {
  let t = /* @__PURE__ */ new Set(), n = !1, r = {
    ...Di
  };
  for (let i of e) {
    var a, l;
    for (let o of i.validationErrors) t.add(o);
    n || (n = i.isInvalid);
    for (let o in r) (a = r)[l = o] || (a[l] = i.validationDetails[o]);
  }
  return r.valid = !n, {
    isInvalid: n,
    validationErrors: [
      ...t
    ],
    validationDetails: r
  };
}
function ll(e, t, n) {
  let { validationBehavior: r, focus: a } = e;
  Ce(() => {
    if (r === "native" && (n != null && n.current) && !n.current.disabled) {
      let u = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(u), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(g2(n.current));
    }
  });
  let l = Re(() => {
    t.resetValidation();
  }), i = Re((u) => {
    var s;
    t.displayValidation.isInvalid || t.commitValidation();
    let d = n == null || (s = n.current) === null || s === void 0 ? void 0 : s.form;
    if (!u.defaultPrevented && n && d && y2(d) === n.current) {
      var c;
      a ? a() : (c = n.current) === null || c === void 0 || c.focus(), Iu("keyboard");
    }
    u.preventDefault();
  }), o = Re(() => {
    t.commitValidation();
  });
  re(() => {
    let u = n == null ? void 0 : n.current;
    if (!u) return;
    let s = u.form;
    return u.addEventListener("invalid", i), u.addEventListener("change", o), s == null || s.addEventListener("reset", l), () => {
      u.removeEventListener("invalid", i), u.removeEventListener("change", o), s == null || s.removeEventListener("reset", l);
    };
  }, [
    n,
    i,
    o,
    l,
    r
  ]);
}
function v2(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function g2(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: v2(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function y2(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (!n.validity.valid) return n;
  }
  return null;
}
function mb(e, t, n) {
  let { isDisabled: r = !1, isReadOnly: a = !1, value: l, name: i, children: o, "aria-label": u, "aria-labelledby": s, validationState: d = "valid", isInvalid: c } = e, f = (P) => {
    P.stopPropagation(), t.setSelected(P.target.checked);
  }, b = o != null, p = u != null || s != null;
  !b && !p && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: h, isPressed: m } = Tt({
    isDisabled: r
  }), { pressProps: v, isPressed: y } = Tt({
    onPress() {
      var P;
      t.toggle(), (P = n.current) === null || P === void 0 || P.focus();
    },
    isDisabled: r || a
  }), { focusableProps: w } = un(e, n), C = _(h, w), D = J(e, {
    labelable: !0
  });
  return zn(n, t.isSelected, t.setSelected), {
    labelProps: _(v, {
      onClick: (P) => P.preventDefault()
    }),
    inputProps: _(D, {
      "aria-invalid": c || d === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": a || void 0,
      onChange: f,
      disabled: r,
      ...l == null ? {} : {
        value: l
      },
      name: i,
      type: "checkbox",
      ...C
    }),
    isSelected: t.isSelected,
    isPressed: m || y,
    isDisabled: r,
    isReadOnly: a,
    isInvalid: c || d === "invalid"
  };
}
function vb(e, t, n) {
  let r = en({
    ...e,
    value: t.isSelected
  }), { isInvalid: a, validationErrors: l, validationDetails: i } = r.displayValidation, { labelProps: o, inputProps: u, isSelected: s, isPressed: d, isDisabled: c, isReadOnly: f } = mb({
    ...e,
    isInvalid: a
  }, t, n);
  ll(e, r, n);
  let { isIndeterminate: b, isRequired: p, validationBehavior: h = "aria" } = e;
  re(() => {
    n.current && (n.current.indeterminate = !!b);
  });
  let { pressProps: m } = Tt({
    isDisabled: c || f,
    onPress() {
      let { [mn]: v } = e, { commitValidation: y } = v || r;
      y();
    }
  });
  return {
    labelProps: _(o, m),
    inputProps: {
      ...u,
      checked: s,
      "aria-required": p && h === "aria" || void 0,
      required: p && h === "native"
    },
    isSelected: s,
    isPressed: d,
    isDisabled: c,
    isReadOnly: f,
    isInvalid: a,
    validationErrors: l,
    validationDetails: i
  };
}
const gb = /* @__PURE__ */ new WeakMap();
function il(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": a, labelElementType: l = "label" } = e;
  t = Ee(t);
  let i = Ee(), o = {};
  n ? (r = r ? `${i} ${r}` : i, o = {
    id: i,
    htmlFor: l === "label" ? t : void 0
  }) : !r && !a && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = Ot({
    id: t,
    "aria-label": a,
    "aria-labelledby": r
  });
  return {
    labelProps: o,
    fieldProps: u
  };
}
function or(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: a } = e, { labelProps: l, fieldProps: i } = il(e), o = pn([
    !!t,
    !!n,
    r,
    a
  ]), u = pn([
    !!t,
    !!n,
    r,
    a
  ]);
  return i = _(i, {
    "aria-describedby": [
      o,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      u,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: l,
    fieldProps: i,
    descriptionProps: {
      id: o
    },
    errorMessageProps: {
      id: u
    }
  };
}
function $2(e, t) {
  let { isDisabled: n, name: r, validationBehavior: a = "aria" } = e, { isInvalid: l, validationErrors: i, validationDetails: o } = t.displayValidation, { labelProps: u, fieldProps: s, descriptionProps: d, errorMessageProps: c } = or({
    ...e,
    // Checkbox group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: l,
    errorMessage: e.errorMessage || i
  });
  gb.set(t, {
    name: r,
    descriptionId: d.id,
    errorMessageId: c.id,
    validationBehavior: a
  });
  let f = J(e, {
    labelable: !0
  }), { focusWithinProps: b } = jt({
    onBlurWithin: e.onBlur,
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  });
  return {
    groupProps: _(f, {
      role: "group",
      "aria-disabled": n || void 0,
      ...s,
      ...b
    }),
    labelProps: u,
    descriptionProps: d,
    errorMessageProps: c,
    isInvalid: l,
    validationErrors: i,
    validationDetails: o
  };
}
function Ci(e = {}) {
  let { isReadOnly: t } = e, [n, r] = Me(e.isSelected, e.defaultSelected || !1, e.onChange);
  function a(i) {
    t || r(i);
  }
  function l() {
    t || r(!n);
  }
  return {
    isSelected: n,
    setSelected: a,
    toggle: l
  };
}
function x2(e) {
  let { selectionMode: t = "single", disallowEmptySelection: n, isDisabled: r = !1 } = e, [a, l] = Me(H(() => e.selectedKeys ? new Set(e.selectedKeys) : void 0, [
    e.selectedKeys
  ]), H(() => e.defaultSelectedKeys ? new Set(e.defaultSelectedKeys) : /* @__PURE__ */ new Set(), [
    e.defaultSelectedKeys
  ]), e.onSelectionChange);
  return {
    selectionMode: t,
    isDisabled: r,
    selectedKeys: a,
    setSelectedKeys: l,
    toggleKey(i) {
      let o;
      t === "multiple" ? (o = new Set(a), o.has(i) && (!n || o.size > 1) ? o.delete(i) : o.add(i)) : o = new Set(a.has(i) && !n ? [] : [
        i
      ]), l(o);
    },
    setSelected(i, o) {
      o !== a.has(i) && this.toggleKey(i);
    }
  };
}
function D2(e, t, n) {
  const r = Ci({
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isSelected: t.isSelected(e.value),
    onChange(m) {
      m ? t.addValue(e.value) : t.removeValue(e.value), e.onChange && e.onChange(m);
    }
  });
  let { name: a, descriptionId: l, errorMessageId: i, validationBehavior: o } = gb.get(t);
  var u;
  o = (u = e.validationBehavior) !== null && u !== void 0 ? u : o;
  let { realtimeValidation: s } = en({
    ...e,
    value: r.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), d = j(Jn), c = () => {
    t.setInvalid(e.value, s.isInvalid ? s : d.current);
  };
  re(c);
  let f = t.realtimeValidation.isInvalid ? t.realtimeValidation : s, b = o === "native" ? t.displayValidation : f;
  var p;
  let h = vb({
    ...e,
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isDisabled: e.isDisabled || t.isDisabled,
    name: e.name || a,
    isRequired: (p = e.isRequired) !== null && p !== void 0 ? p : t.isRequired,
    validationBehavior: o,
    [mn]: {
      realtimeValidation: f,
      displayValidation: b,
      resetValidation: t.resetValidation,
      commitValidation: t.commitValidation,
      updateValidation(m) {
        d.current = m, c();
      }
    }
  }, r, n);
  return {
    ...h,
    inputProps: {
      ...h.inputProps,
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? i : null,
        l
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
var yb = {};
yb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "أداة انتقاء اللون",
  colorSwatch: "تغيير الألوان",
  transparent: "شفاف",
  twoDimensionalSlider: "مُنزلق 2D"
};
var $b = {};
$b = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Средство за избиране на цвят",
  colorSwatch: "цветна мостра",
  transparent: "прозрачен",
  twoDimensionalSlider: "2D плъзгач"
};
var xb = {};
xb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Výběr barvy",
  colorSwatch: "barevný vzorek",
  transparent: "průhledný",
  twoDimensionalSlider: "2D posuvník"
};
var Db = {};
Db = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Farvevælger",
  colorSwatch: "farveprøve",
  transparent: "gennemsigtig",
  twoDimensionalSlider: "2D-skyder"
};
var Cb = {};
Cb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Farbwähler",
  colorSwatch: "Farbfeld",
  transparent: "transparent",
  twoDimensionalSlider: "2D-Schieberegler"
};
var Eb = {};
Eb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Επιλογέας χρωμάτων",
  colorSwatch: "χρωματικό δείγμα",
  transparent: "διαφανές",
  twoDimensionalSlider: "Ρυθμιστικό 2D"
};
var wb = {};
wb = {
  colorPicker: "Color picker",
  twoDimensionalSlider: "2D slider",
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorSwatch: "color swatch",
  transparent: "transparent"
};
var Pb = {};
Pb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selector de color",
  colorSwatch: "muestra de color",
  transparent: "transparente",
  twoDimensionalSlider: "Regulador 2D"
};
var kb = {};
kb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Värvivalija",
  colorSwatch: "värvinäidis",
  transparent: "läbipaistev",
  twoDimensionalSlider: "2D-liugur"
};
var Sb = {};
Sb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Värimuokkain",
  colorSwatch: "värimalli",
  transparent: "läpinäkyvä",
  twoDimensionalSlider: "2D-liukusäädin"
};
var Bb = {};
Bb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name} : ${e.value}`,
  colorPicker: "Sélecteur de couleurs",
  colorSwatch: "Échantillon de couleurs",
  transparent: "Transparent",
  twoDimensionalSlider: "Curseur 2D"
};
var Fb = {};
Fb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "בוחר הצבעים",
  colorSwatch: "דוגמית צבע",
  transparent: "שקוף",
  twoDimensionalSlider: "מחוון דו מימדי"
};
var Ab = {};
Ab = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Odabir boje",
  colorSwatch: "uzorak boje",
  transparent: "transparentno",
  twoDimensionalSlider: "2D klizač"
};
var Tb = {};
Tb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Színválasztó",
  colorSwatch: "színtár",
  transparent: "átlátszó",
  twoDimensionalSlider: "2D-csúszka"
};
var Rb = {};
Rb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selettore colore",
  colorSwatch: "campione di colore",
  transparent: "trasparente",
  twoDimensionalSlider: "Cursore 2D"
};
var Mb = {};
Mb = {
  colorInputLabel: (e) => `${e.label}、${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name} : ${e.value}`,
  colorPicker: "カラーピッカー",
  colorSwatch: "カラースウォッチ",
  transparent: "透明",
  twoDimensionalSlider: "2D スライダー"
};
var Nb = {};
Nb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "색상 피커",
  colorSwatch: "색상 견본",
  transparent: "투명도",
  twoDimensionalSlider: "2D 슬라이더"
};
var Vb = {};
Vb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Spalvų parinkiklis",
  colorSwatch: "spalvų pavyzdys",
  transparent: "skaidrus",
  twoDimensionalSlider: "2D slankiklis"
};
var Ib = {};
Ib = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Krāsu atlasītājs",
  colorSwatch: "krāsu paraugs",
  transparent: "caurspīdīgs",
  twoDimensionalSlider: "2D slīdnis"
};
var Ob = {};
Ob = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Fargevelger",
  colorSwatch: "fargekart",
  transparent: "gjennomsiktig",
  twoDimensionalSlider: "2D-glidebryter"
};
var zb = {};
zb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Kleurkiezer",
  colorSwatch: "kleurstaal",
  transparent: "transparant",
  twoDimensionalSlider: "2D-schuifregelaar"
};
var Kb = {};
Kb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Próbnik kolorów",
  colorSwatch: "próbka koloru",
  transparent: "przezroczysty",
  twoDimensionalSlider: "Suwak 2D"
};
var jb = {};
jb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cores",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var Lb = {};
Lb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cor",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var Hb = {};
Hb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selector de culori",
  colorSwatch: "specimen de culoare",
  transparent: "transparent",
  twoDimensionalSlider: "Glisor 2D"
};
var _b = {};
_b = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Палитра цветов",
  colorSwatch: "цветовой образец",
  transparent: "прозрачный",
  twoDimensionalSlider: "Ползунок 2D"
};
var Ub = {};
Ub = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Výber farieb",
  colorSwatch: "vzorkovník farieb",
  transparent: "transparentný",
  twoDimensionalSlider: "2D jazdec"
};
var Wb = {};
Wb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Izbirnik barv",
  colorSwatch: "barvna paleta",
  transparent: "prozorno",
  twoDimensionalSlider: "2D drsnik"
};
var Gb = {};
Gb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Birač boja",
  colorSwatch: "Uzorak boje",
  transparent: "providno",
  twoDimensionalSlider: "2D klizač"
};
var Zb = {};
Zb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Färgväljaren",
  colorSwatch: "färgruta",
  transparent: "genomskinlig",
  twoDimensionalSlider: "2D-reglage"
};
var Yb = {};
Yb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Renk Seçici",
  colorSwatch: "renk örneği",
  transparent: "saydam",
  twoDimensionalSlider: "2D sürgü"
};
var qb = {};
qb = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Палітра кольорів",
  colorSwatch: "зразок кольору",
  transparent: "прозорий",
  twoDimensionalSlider: "Повзунок 2D"
};
var Xb = {};
Xb = {
  colorInputLabel: (e) => `${e.label}、${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}：${e.value}`,
  colorPicker: "拾色器",
  colorSwatch: "颜色色板",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑块"
};
var Jb = {};
Jb = {
  colorInputLabel: (e) => `${e.label}，${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}：${e.value}`,
  colorPicker: "檢色器",
  colorSwatch: "色票",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑桿"
};
var ns = {};
ns = {
  "ar-AE": yb,
  "bg-BG": $b,
  "cs-CZ": xb,
  "da-DK": Db,
  "de-DE": Cb,
  "el-GR": Eb,
  "en-US": wb,
  "es-ES": Pb,
  "et-EE": kb,
  "fi-FI": Sb,
  "fr-FR": Bb,
  "he-IL": Fb,
  "hr-HR": Ab,
  "hu-HU": Tb,
  "it-IT": Rb,
  "ja-JP": Mb,
  "ko-KR": Nb,
  "lt-LT": Vb,
  "lv-LV": Ib,
  "nb-NO": Ob,
  "nl-NL": zb,
  "pl-PL": Kb,
  "pt-BR": jb,
  "pt-PT": Lb,
  "ro-RO": Hb,
  "ru-RU": _b,
  "sk-SK": Ub,
  "sl-SI": Wb,
  "sr-SP": Gb,
  "sv-SE": Zb,
  "tr-TR": Yb,
  "uk-UA": qb,
  "zh-CN": Xb,
  "zh-TW": Jb
};
var Qb = {};
Qb = {
  alpha: "ألفا",
  black: "أسود",
  blue: "أزرق",
  "blue purple": "أرجواني مزرق",
  brightness: "السطوع",
  brown: "بني",
  "brown yellow": "أصفر بني",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "سماوي",
  "cyan blue": "أزرق سماوي",
  dark: "داكن",
  gray: "رمادي",
  grayish: "مائل للرمادي",
  green: "أخضر",
  "green cyan": "سماوي مخضر",
  hue: "درجة اللون",
  light: "فاتح",
  lightness: "الإضاءة",
  magenta: "أرجواني",
  "magenta pink": "أرجواني وردي",
  orange: "برتقالي",
  "orange yellow": "أصفر برتقالي",
  pale: "باهت",
  pink: "وردي",
  "pink red": "أحمر وردي",
  purple: "أرجواني",
  "purple magenta": "بنفسجي",
  red: "أحمر",
  "red orange": "برتقالي محمر",
  saturation: "التشبع",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} شفاف`,
  "very dark": "داكن جدًا",
  "very light": "فاتح جدًا",
  vibrant: "ساطع",
  white: "أبيض",
  yellow: "أصفر",
  "yellow green": "أخضر مصفر"
};
var e0 = {};
e0 = {
  alpha: "Алфа",
  black: "черно",
  blue: "Синьо",
  "blue purple": "синьо лилаво",
  brightness: "Яркост",
  brown: "кафяво",
  "brown yellow": "кафяво жълто",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "циан",
  "cyan blue": "циан синьо",
  dark: "тъмно",
  gray: "сиво",
  grayish: "сивкав",
  green: "Зелено",
  "green cyan": "зелен циан",
  hue: "Оттенък",
  light: "светло",
  lightness: "Лекота",
  magenta: "магента",
  "magenta pink": "магента розово",
  orange: "оранжево",
  "orange yellow": "оранжево жълто",
  pale: "бледо",
  pink: "розово",
  "pink red": "розово червено",
  purple: "лилаво",
  "purple magenta": "лилаво магента",
  red: "Червено",
  "red orange": "червен портокал",
  saturation: "Наситеност",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} прозрачен`,
  "very dark": "много тъмно",
  "very light": "много светло",
  vibrant: " ярко",
  white: "бяло",
  yellow: "жълто",
  "yellow green": "жълто зелен"
};
var t0 = {};
t0 = {
  alpha: "Alfa",
  black: "černá",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnědá",
  "brown yellow": "hnědožlutá",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "tyrkysová",
  "cyan blue": "tyrkysovomodrá",
  dark: "tmavá",
  gray: "šedá",
  grayish: "našedlá",
  green: "Zelená",
  "green cyan": "zelenotyrkysová",
  hue: "Odstín",
  light: "světlá",
  lightness: "Světlost",
  magenta: "purpurová",
  "magenta pink": "purpurově růžová",
  orange: "oranžová",
  "orange yellow": "oranžovožlutá",
  pale: "bledá",
  pink: "růžová",
  "pink red": "růžovočervená",
  purple: "fialová",
  "purple magenta": "fialově purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sytost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} průhledné`,
  "very dark": "velmi tmavá",
  "very light": "velmi světlá",
  vibrant: "zářivá",
  white: "bílá",
  yellow: "žlutá",
  "yellow green": "žlutozelená"
};
var n0 = {};
n0 = {
  alpha: "Alfa",
  black: "sort",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyan blå",
  dark: "mørk",
  gray: "grå",
  grayish: "grålig",
  green: "Grøn",
  "green cyan": "grøn cyan",
  hue: "Tone",
  light: "lys",
  lightness: "Lyshed",
  magenta: "magenta",
  "magenta pink": "magenta pink",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "bleg",
  pink: "lyserød",
  "pink red": "lyserødlig rød",
  purple: "lilla",
  "purple magenta": "lilla magenta",
  red: "Rød",
  "red orange": "rødorange",
  saturation: "Farvemætning",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} gennemsigtig`,
  "very dark": "meget mørk",
  "very light": "meget lys",
  vibrant: "klar",
  white: "hvid",
  yellow: "gul",
  "yellow green": "gulgrøn"
};
var r0 = {};
r0 = {
  alpha: "Alpha",
  black: "Schwarz",
  blue: "Blau",
  "blue purple": "Blaulila",
  brightness: "Helligkeit",
  brown: "Braun",
  "brown yellow": "Braungelb",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "Cyan",
  "cyan blue": "Cyanblau",
  dark: "dunkles",
  gray: "Grau",
  grayish: "gräuliches",
  green: "Grün",
  "green cyan": "Grüncyan",
  hue: "Farbton",
  light: "helles",
  lightness: "Leuchtkraft",
  magenta: "Magenta",
  "magenta pink": "Magentarosa",
  orange: "Orange",
  "orange yellow": "Orangegelb",
  pale: "blasses",
  pink: "Rosa",
  "pink red": "Rosarot",
  purple: "Lila",
  "purple magenta": "Lilamagenta",
  red: "Rot",
  "red orange": "Rotorange",
  saturation: "Sättigung",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, zu ${e.percentTransparent} transparent`,
  "very dark": "sehr dunkles",
  "very light": "sehr helles",
  vibrant: "lebhaftes",
  white: "Weiß",
  yellow: "Gelb",
  "yellow green": "Gelbgrün"
};
var a0 = {};
a0 = {
  alpha: "Άλφα",
  black: "μαύρο",
  blue: "Μπλε",
  "blue purple": "μπλε μωβ",
  brightness: "Φωτεινότητα",
  brown: "καφέ",
  "brown yellow": "καφέ κίτρινο",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "κυανό",
  "cyan blue": "κυανό μπλε",
  dark: "σκούρο",
  gray: "γκρι",
  grayish: "γκριζωπό",
  green: "Πράσινο",
  "green cyan": "πράσινο κυανό",
  hue: "Τόνος",
  light: "ανοιχτό",
  lightness: "Φωτεινότητα",
  magenta: "ματζέντα",
  "magenta pink": "ματζέντα ροζ",
  orange: "πορτοκαλί",
  "orange yellow": "πορτοκαλί κίτρινο",
  pale: "ανοιχτό",
  pink: "ροζ",
  "pink red": "ροζ κόκκινο",
  purple: "μωβ",
  "purple magenta": "μωβ ματζέντα",
  red: "Κόκκινο",
  "red orange": "κόκκινο πορτοκαλί",
  saturation: "Κορεσμός",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} διαφανές`,
  "very dark": "πολύ σκούρο",
  "very light": "πολύ ανοιχτό",
  vibrant: "έντονο",
  white: "λευκό",
  yellow: "κίτρινο",
  "yellow green": "κίτρινο πράσινο"
};
var l0 = {};
l0 = {
  hue: "Hue",
  saturation: "Saturation",
  lightness: "Lightness",
  brightness: "Brightness",
  red: "Red",
  green: "Green",
  blue: "Blue",
  alpha: "Alpha",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "very dark",
  dark: "dark",
  light: "light",
  "very light": "very light",
  pale: "pale",
  grayish: "grayish",
  vibrant: "vibrant",
  black: "black",
  white: "white",
  gray: "gray",
  pink: "pink",
  "pink red": "pink red",
  "red orange": "red orange",
  brown: "brown",
  orange: "orange",
  "orange yellow": "orange yellow",
  "brown yellow": "brown yellow",
  yellow: "yellow",
  "yellow green": "yellow green",
  "green cyan": "green cyan",
  cyan: "cyan",
  "cyan blue": "cyan blue",
  "blue purple": "blue purple",
  purple: "purple",
  "purple magenta": "purple magenta",
  magenta: "magenta",
  "magenta pink": "magenta pink"
};
var i0 = {};
i0 = {
  alpha: "Alpha",
  black: "negro",
  blue: "Azul",
  "blue purple": "púrpura azulado",
  brightness: "Brillo",
  brown: "marrón",
  "brown yellow": "amarillo amarronado",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cian",
  "cyan blue": "azul cian",
  dark: "oscuro",
  gray: "gris",
  grayish: "grisáceo",
  green: "Verde",
  "green cyan": "cian verdoso",
  hue: "Tono",
  light: "claro",
  lightness: "Luminosidad",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "naranja",
  "orange yellow": "amarillo anaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rojo rosado",
  purple: "morado",
  "purple magenta": "magenta violáceo",
  red: "Rojo",
  "red orange": "naranja rojizo",
  saturation: "Saturación",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muy oscuro",
  "very light": "muy claro",
  vibrant: "intenso",
  white: "blanco",
  yellow: "amarillo",
  "yellow green": "verde amarillento"
};
var o0 = {};
o0 = {
  alpha: "Alfa",
  black: "must",
  blue: "Sinine",
  "blue purple": "sinakaslilla",
  brightness: "Heledus",
  brown: "pruun",
  "brown yellow": "pruunikaskollane",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "tsüaan",
  "cyan blue": "tsüaansinine",
  dark: "tume",
  gray: "hall",
  grayish: "hallikas",
  green: "Roheline",
  "green cyan": "tsüaanroheline",
  hue: "Värv",
  light: "valgus",
  lightness: "Valgus",
  magenta: "magentapunane",
  "magenta pink": "magentaroosa",
  orange: "oranž",
  "orange yellow": "oranžikaskollane",
  pale: "kahvatu",
  pink: "roosa",
  "pink red": "vaarikapunane",
  purple: "lilla",
  "purple magenta": "purpurne magenta",
  red: "Punane",
  "red orange": "punakasoranž",
  saturation: "Küllastus",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} läbipaistev`,
  "very dark": "väga tume",
  "very light": "väga hele",
  vibrant: "ere",
  white: "valge",
  yellow: "kollane",
  "yellow green": "kollakasroheline"
};
var u0 = {};
u0 = {
  alpha: "Alpha",
  black: "musta",
  blue: "Sininen",
  "blue purple": "sinivioletti",
  brightness: "Kirkkaus",
  brown: "ruskea",
  "brown yellow": "ruskeankeltainen",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "syaani",
  "cyan blue": "syaaninsininen",
  dark: "tumma",
  gray: "harmaa",
  grayish: "harmahtava",
  green: "Vihreä",
  "green cyan": "vihreänsyaani",
  hue: "Sävy",
  light: "vaalea",
  lightness: "Valomäärä",
  magenta: "magenta",
  "magenta pink": "magentapinkki",
  orange: "oranssi",
  "orange yellow": "oranssinkeltainen",
  pale: "vaalea",
  pink: "pinkki",
  "pink red": "vaaleanpunainen",
  purple: "violetti",
  "purple magenta": "violettimagenta",
  red: "Punainen",
  "red orange": "punaoranssi",
  saturation: "Värikylläisyys",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} läpinäkyvä`,
  "very dark": "hyvin tumma",
  "very light": "erittäin vaalea",
  vibrant: "eloisa",
  white: "valkea",
  yellow: "keltainen",
  "yellow green": "keltavihreä"
};
var s0 = {};
s0 = {
  alpha: "Alpha",
  black: "Noir",
  blue: "Bleu",
  "blue purple": "Violet bleu",
  brightness: "Luminosité",
  brown: "Brun",
  "brown yellow": "Jaune brun",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "Cyan",
  "cyan blue": "Bleu cyan",
  dark: "Sombre",
  gray: "Gris",
  grayish: "Grisâtre",
  green: "Vert",
  "green cyan": "Cyan vert",
  hue: "Teinte",
  light: "Clair",
  lightness: "Luminosité",
  magenta: "Magenta",
  "magenta pink": "Rose magenta",
  orange: "Orange",
  "orange yellow": "Jaune orangé",
  pale: "Pâle",
  pink: "Rose",
  "pink red": "Rouge rosé",
  purple: "Violet",
  "purple magenta": "Magenta violet",
  red: "Rouge",
  "red orange": "Orange rouge",
  saturation: "Saturation",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "Très sombre",
  "very light": "Très clair",
  vibrant: "Vif",
  white: "Blanc",
  yellow: "Jaune",
  "yellow green": "Vert jaune"
};
var d0 = {};
d0 = {
  alpha: "אלפא",
  black: "שחור",
  blue: "כחול",
  "blue purple": "כחול סגול",
  brightness: "בהירות",
  brown: "חום",
  "brown yellow": "חום צהוב",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "טורקיז",
  "cyan blue": "כחול ציאן",
  dark: "כהה",
  gray: "אפור",
  grayish: "אפרפר",
  green: "ירוק",
  "green cyan": "ציאן ירוק",
  hue: "גוון",
  light: "אור",
  lightness: "כמות אור",
  magenta: "מג'נטה",
  "magenta pink": "ורוד מג'נטה",
  orange: "כתום",
  "orange yellow": "כתום צהוב",
  pale: "חיוור",
  pink: "ורוד",
  "pink red": "ורוד אדום",
  purple: "סגול",
  "purple magenta": "מג'נטה סגול",
  red: "אדום",
  "red orange": "כתום אדום",
  saturation: "רוויה",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} שקוף`,
  "very dark": "כהה מאוד",
  "very light": "בהיר מאוד",
  vibrant: "תוסס",
  white: "לבן",
  yellow: "צהוב",
  "yellow green": "צהוב ירוק"
};
var c0 = {};
c0 = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavo ljubičasta",
  brightness: "Svjetlina",
  brown: "smeđa",
  "brown yellow": "smeđe žuta",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasto",
  green: "Zelena",
  "green cyan": "zelena cijan",
  hue: "Nijansa",
  light: "svjetlo",
  lightness: "Osvijetljenost",
  magenta: "magenta",
  "magenta pink": "magentno ružičasta",
  orange: "narančasta",
  "orange yellow": "narančasto žuta",
  pale: "blijeda",
  pink: "ružičasta",
  "pink red": "ružičasto crvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crveno narančasta",
  saturation: "Zasićenost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozirnosti`,
  "very dark": "jako tamna",
  "very light": "vrlo svijetlo",
  vibrant: "vibrantna",
  white: "bijela",
  yellow: "žuto",
  "yellow green": "žuto zelena"
};
var f0 = {};
f0 = {
  alpha: "Alfa",
  black: "fekete",
  blue: "Kék",
  "blue purple": "kék lila",
  brightness: "Fényesség",
  brown: "barna",
  "brown yellow": "barna sárga",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciánkék",
  "cyan blue": "ciánkék",
  dark: "sötét",
  gray: "szürke",
  grayish: "szürkés",
  green: "Zöld",
  "green cyan": "zöld ciánkék",
  hue: "Színárnyalat",
  light: "világos",
  lightness: "Világosság",
  magenta: "bíbor",
  "magenta pink": "bíbor rózsaszín",
  orange: "narancs",
  "orange yellow": "narancssárga",
  pale: "halvány",
  pink: "rózsaszín",
  "pink red": "rózsaszín piros",
  purple: "lila",
  "purple magenta": "lila bíbor",
  red: "Piros",
  "red orange": "piros narancs",
  saturation: "Telítettség",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} átlátszó`,
  "very dark": "nagyon sötét",
  "very light": "nagyon világos",
  vibrant: "élénk",
  white: "fehér",
  yellow: "sárga",
  "yellow green": "sárga zöld"
};
var b0 = {};
b0 = {
  alpha: "Alfa",
  black: "nero",
  blue: "Blu",
  "blue purple": "blu viola",
  brightness: "Luminosità",
  brown: "marrone",
  "brown yellow": "giallo bruno",
  colorName: (e) => `${e.hue} ${e.chroma} ${e.lightness}`,
  cyan: "ciano",
  "cyan blue": "blu ciano",
  dark: "scuro",
  gray: "grigio",
  grayish: "grigiastro",
  green: "Verde",
  "green cyan": "verde ciano",
  hue: "Tonalità",
  light: "chiaro",
  lightness: "Luminosità",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "arancio",
  "orange yellow": "giallo arancio",
  pale: "tenue",
  pink: "rosa",
  "pink red": "rosa rosso",
  purple: "viola",
  "purple magenta": "viola magenta",
  red: "Rosso",
  "red orange": "rosso arancio",
  saturation: "Saturazione",
  transparentColorName: (e) => `${e.hue} ${e.chroma} ${e.lightness}, trasparenza ${e.percentTransparent}`,
  "very dark": "molto scuro",
  "very light": "molto chiaro",
  vibrant: "vivace",
  white: "bianco",
  yellow: "giallo",
  "yellow green": "giallo verde"
};
var p0 = {};
p0 = {
  alpha: "アルファ",
  black: "ブラック",
  blue: "青",
  "blue purple": "ブルーパープル",
  brightness: "明るさ",
  brown: "ブラウン",
  "brown yellow": "ブラウンイエロー",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "シアン",
  "cyan blue": "シアンブルー",
  dark: "ダーク",
  gray: "グレー",
  grayish: "グレイッシュ",
  green: "緑",
  "green cyan": "グリーンシアン",
  hue: "色相",
  light: "ライト",
  lightness: "明度",
  magenta: "マゼンタ",
  "magenta pink": "マゼンタピンク",
  orange: "オレンジ",
  "orange yellow": "オレンジイエロー",
  pale: "ペール",
  pink: "ピンク",
  "pink red": "ピンクレッド",
  purple: "パープル",
  "purple magenta": "パープルマゼンタ",
  red: "赤",
  "red orange": "レッドオレンジ",
  saturation: "彩度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "最も暗い",
  "very light": "ベリーライト",
  vibrant: "鮮やか",
  white: "ホワイト",
  yellow: "イエロー",
  "yellow green": "イエローグリーン"
};
var h0 = {};
h0 = {
  alpha: "알파",
  black: "검은색",
  blue: "파랑",
  "blue purple": "청자색",
  brightness: "명도",
  brown: "갈색",
  "brown yellow": "황갈색",
  colorName: (e) => `${e.lightness}, ${e.chroma}, ${e.hue}`,
  cyan: "청록색",
  "cyan blue": "청록색",
  dark: "다크",
  gray: "회색",
  grayish: "회갈색",
  green: "초록",
  "green cyan": "청록색",
  hue: "색조",
  light: "라이트",
  lightness: "밝기",
  magenta: "자홍색",
  "magenta pink": "마젠타 핑크",
  orange: "주황색",
  "orange yellow": "불그스름한 노랑",
  pale: "흙색",
  pink: "분홍색",
  "pink red": "핑크 레드",
  purple: "자주색",
  "purple magenta": "보라빛 자홍색",
  red: "빨강",
  "red orange": "붉은 주황색",
  saturation: "채도",
  transparentColorName: (e) => `${e.lightness}, ${e.chroma}, ${e.hue}, ${e.percentTransparent} 투명도`,
  "very dark": "매우 어두운",
  "very light": "매우 연함",
  vibrant: "강렬한",
  white: "흰색",
  yellow: "노란색",
  "yellow green": "연두색"
};
var m0 = {};
m0 = {
  alpha: "Alfa",
  black: "juoda",
  blue: "Mėlyna",
  "blue purple": "melsvai violetinė",
  brightness: "Ryškumas",
  brown: "ruda",
  "brown yellow": "rusvai geltona",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "žalsvai mėlyna",
  "cyan blue": "žalsvai mėlyna",
  dark: "tamsi",
  gray: "pilka",
  grayish: "pilkšva",
  green: "Žalia",
  "green cyan": "žalsvai mėlyna",
  hue: "Atspalvis",
  light: "šviesi",
  lightness: "Šviesumas",
  magenta: "rausvai raudona",
  "magenta pink": "purpurinė",
  orange: "oranžinė",
  "orange yellow": "oranžinio atspalvio geltona",
  pale: "blyški",
  pink: "rožinė",
  "pink red": "rožinė raudona",
  purple: "violetinė",
  "purple magenta": "purpurinė rausvai raudona",
  red: "Raudona",
  "red orange": "rausvai oranžinė",
  saturation: "Įsotinimas",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} skaidri`,
  "very dark": "labai tamsi",
  "very light": "labai šviesi",
  vibrant: "ryški",
  white: "balta",
  yellow: "geltona",
  "yellow green": "gelsvai žalia"
};
var v0 = {};
v0 = {
  alpha: "Alfa",
  black: "melns",
  blue: "Zila",
  "blue purple": "zili violets",
  brightness: "Spilgtums",
  brown: "brūns",
  "brown yellow": "brūni dzeltens",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciāns",
  "cyan blue": "ciāna zils",
  dark: "tumšs",
  gray: "pelēks",
  grayish: "pelēcīgs",
  green: "Zaļa",
  "green cyan": "zaļš ciāns",
  hue: "Nokrāsa",
  light: "gaišs",
  lightness: "Gaišums",
  magenta: "fuksiju",
  "magenta pink": "fuksiju rozā",
  orange: "oranžs",
  "orange yellow": "oranži dzeltens",
  pale: "bāls",
  pink: "rozā",
  "pink red": "rozīgi sarkans",
  purple: "violets",
  "purple magenta": "violets fuksiju",
  red: "Sarkana",
  "red orange": "sarkanīgi oranžs",
  saturation: "Piesātinājums",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} caurspīdīgs`,
  "very dark": "ļoti tumšs",
  "very light": "ļoti gaišs",
  vibrant: "košs",
  white: "balts",
  yellow: "dzeltens",
  "yellow green": "dzelteni zaļš"
};
var g0 = {};
g0 = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mørk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grønn",
  "green cyan": "grønncyan",
  hue: "Fargetone",
  light: "lys",
  lightness: "Lyshet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "oransje",
  "orange yellow": "oransjegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosarød",
  purple: "lilla",
  "purple magenta": "lillamagenta",
  red: "Rød",
  "red orange": "rødoransje",
  saturation: "Metning",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} gjennomsiktig`,
  "very dark": "svært mørk",
  "very light": "svært lys",
  vibrant: "levende",
  white: "hvit",
  yellow: "gul",
  "yellow green": "gulgrønn"
};
var y0 = {};
y0 = {
  alpha: "Alfa",
  black: "zwart",
  blue: "Blauw",
  "blue purple": "paarsblauw",
  brightness: "Helderheid",
  brown: "bruin",
  "brown yellow": "bruingeel",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyaan",
  "cyan blue": "cyaanblauw",
  dark: "donker",
  gray: "grijs",
  grayish: "grijsachtig",
  green: "Groen",
  "green cyan": "cyaangroen",
  hue: "Kleurtoon",
  light: "licht",
  lightness: "Lichtsterkte",
  magenta: "magenta",
  "magenta pink": "magentaroze",
  orange: "oranje",
  "orange yellow": "oranjegeel",
  pale: "bleek",
  pink: "roze",
  "pink red": "rozerood",
  purple: "paars",
  "purple magenta": "magentapaars",
  red: "Rood",
  "red orange": "roodoranje",
  saturation: "Verzadiging",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparant`,
  "very dark": "heel donker",
  "very light": "heel licht",
  vibrant: "levendig",
  white: "wit",
  yellow: "geel",
  "yellow green": "geelgroen"
};
var $0 = {};
$0 = {
  alpha: "Alfa",
  black: "czarny",
  blue: "Niebieski",
  "blue purple": "niebiesko-fioletowy",
  brightness: "Jasność",
  brown: "brązowy",
  "brown yellow": "brązowo-żółty",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyjanowy",
  "cyan blue": "cyjanowo-niebieski",
  dark: "ciemny",
  gray: "szary",
  grayish: "szarawy",
  green: "Zielony",
  "green cyan": "zielono-cyjanowy",
  hue: "Odcień",
  light: "jasny",
  lightness: "Jaskrawość",
  magenta: "purpurowy",
  "magenta pink": "purpurowo-różowy",
  orange: "pomarańczowy",
  "orange yellow": "pomarańczowo-żółty",
  pale: "blady",
  pink: "różowy",
  "pink red": "różowo-czerwony",
  purple: "fioletowy",
  "purple magenta": "fioletowo-purpurowy",
  red: "Czerwony",
  "red orange": "czerwono-pomarańczowy",
  saturation: "Nasycenie",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} przezroczystości`,
  "very dark": "bardzo ciemny",
  "very light": "bardzo jasny",
  vibrant: "intensywny",
  white: "biały",
  yellow: "żółty",
  "yellow green": "żółto-zielony"
};
var x0 = {};
x0 = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "roxo azulado",
  brightness: "Brilho",
  brown: "marrom",
  "brown yellow": "marrom amarelado",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinza",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Matiz",
  light: "claro",
  lightness: "Luminosidade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo alaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rosa avermelhado",
  purple: "roxo",
  "purple magenta": "roxo-magenta",
  red: "Vermelho",
  "red orange": "laranja avermelhado",
  saturation: "Saturação",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde amarelado"
};
var D0 = {};
D0 = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "azul-púrpura",
  brightness: "Luminosidade",
  brown: "castanho",
  "brown yellow": "amarelo-castanho",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinzento",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Tonalidade",
  light: "claro",
  lightness: "Claridade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo-laranja",
  pale: "pálido",
  pink: "cor-de-rosa",
  "pink red": "vermelho-rosa",
  purple: "púrpura",
  "purple magenta": "púrpura-magenta",
  red: "Vermelho",
  "red orange": "laranja-vermelho",
  saturation: "Saturação",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde-amarelo"
};
var C0 = {};
C0 = {
  alpha: "Alfa",
  black: "negru",
  blue: "Albastru",
  "blue purple": "albastru-violet",
  brightness: "Luminozitate",
  brown: "maro",
  "brown yellow": "galben maro",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "bleu",
  "cyan blue": "albastru-bleu",
  dark: "închis",
  gray: "gri",
  grayish: "cenușiu",
  green: "Verde",
  "green cyan": "verde bleu",
  hue: "Nuanță",
  light: "deschis",
  lightness: "Luminozitate",
  magenta: "fucsia",
  "magenta pink": "roz-fucsia",
  orange: "portocaliu",
  "orange yellow": "galben-portocaliu",
  pale: "pal",
  pink: "roz",
  "pink red": "roz-roșu",
  purple: "violet",
  "purple magenta": "violet-fucsia",
  red: "Roșu",
  "red orange": "portocaliu-roșu",
  saturation: "Saturație",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "foarte închis",
  "very light": "foarte deschis",
  vibrant: "plin de viață",
  white: "alb",
  yellow: "galben",
  "yellow green": "galben-verde"
};
var E0 = {};
E0 = {
  alpha: "Альфа",
  black: "черный",
  blue: "Синий",
  "blue purple": "сине-фиолетовый",
  brightness: "Яркость",
  brown: "коричневый",
  "brown yellow": "коричнево-желтый",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "голубой",
  "cyan blue": "цвет морской волны",
  dark: "темный",
  gray: "серый",
  grayish: "сероватый",
  green: "Зеленый",
  "green cyan": "сине-зеленый",
  hue: "Оттенок",
  light: "светлый",
  lightness: "Освещенность",
  magenta: "пурпурный",
  "magenta pink": "пурпурно-розовый",
  orange: "оранжевый",
  "orange yellow": "оранжево-желтый",
  pale: "бледный",
  pink: "розовый",
  "pink red": "розово-красный",
  purple: "фиолетовый",
  "purple magenta": "фиолетово-пурпурный",
  red: "Красный",
  "red orange": "красно-оранжевый",
  saturation: "Насыщенность",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, прозрачный на ${e.percentTransparent}`,
  "very dark": "очень темный",
  "very light": "очень светлый",
  vibrant: "яркий",
  white: "белый",
  yellow: "желтый",
  "yellow green": "желто-зеленый"
};
var w0 = {};
w0 = {
  alpha: "Alfa",
  black: "čierna",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnedá",
  "brown yellow": "hnedožltá",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "azúrová",
  "cyan blue": "azúrová modrá",
  dark: "tmavá",
  gray: "sivá",
  grayish: "sivastá",
  green: "Zelená",
  "green cyan": "zelená azúrová",
  hue: "Odtieň",
  light: "svetlá",
  lightness: "Svetlosť",
  magenta: "purpurová",
  "magenta pink": "ružová purpurová",
  orange: "oranžová",
  "orange yellow": "oranžovožltá",
  pale: "bledá",
  pink: "ružová",
  "pink red": "ružovočervená",
  purple: "fialová",
  "purple magenta": "fialová purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sýtosť",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} priehľadná`,
  "very dark": "veľmi tmavá",
  "very light": "veľmi svetlá",
  vibrant: "energická",
  white: "biela",
  yellow: "žltá",
  "yellow green": "žltozelená"
};
var P0 = {};
P0 = {
  alpha: "Alfa",
  black: "črna",
  blue: "Modra",
  "blue purple": "modro vijolična",
  brightness: "Svetlost",
  brown: "rjava",
  "brown yellow": "rjavo rumena",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cian",
  "cyan blue": "cian modra",
  dark: "temna",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zelena cian",
  hue: "Barva",
  light: "svetla",
  lightness: "Lahkost",
  magenta: "škrlatna",
  "magenta pink": "škrlatno roza",
  orange: "oranžna",
  "orange yellow": "oranžno rumena",
  pale: "bleda",
  pink: "roza",
  "pink red": "roza rdeča",
  purple: "vijolična",
  "purple magenta": "vijolično škrlatna",
  red: "Rdeča",
  "red orange": "rdeče oranžna",
  saturation: "Nasičenost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozorna`,
  "very dark": "zelo temna",
  "very light": "zelo svetla",
  vibrant: "živahna",
  white: "bela",
  yellow: "rumena",
  "yellow green": "rumeno zelena"
};
var k0 = {};
k0 = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavoljubičasta",
  brightness: "Osvetljenost",
  brown: "smeđa",
  "brown yellow": "smeđežuta",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zeleno cijan",
  hue: "Nijansa",
  light: "svetla",
  lightness: "Osvetljenje",
  magenta: "purpurnocrvena",
  "magenta pink": "magenta ružičasta",
  orange: "narandžasta",
  "orange yellow": "narandžastožuta",
  pale: "bledo",
  pink: "ružičasta",
  "pink red": "ružičastocrvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crvenonarandžasta",
  saturation: "Zasićenje",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozirna`,
  "very dark": "veoma tamno",
  "very light": "vrlo svetlo",
  vibrant: "živopisna",
  white: "bela",
  yellow: "žuto",
  "yellow green": "žutozelena"
};
var S0 = {};
S0 = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blått",
  "blue purple": "blålila",
  brightness: "Ljusstyrka",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mörk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grönt",
  "green cyan": "grön cyan",
  hue: "Nyans",
  light: "ljus",
  lightness: "Ljushet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosaröd",
  purple: "lila",
  "purple magenta": "lila magenta",
  red: "Rött",
  "red orange": "rödorange",
  saturation: "Mättnad",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} genomskinlig`,
  "very dark": "mycket mörk",
  "very light": "mycket ljus",
  vibrant: "livfull",
  white: "vit",
  yellow: "gul",
  "yellow green": "gulgrön"
};
var B0 = {};
B0 = {
  alpha: "Alfa",
  black: "siyah",
  blue: "Mavi",
  "blue purple": "mavi mor",
  brightness: "Parlaklık",
  brown: "kahverengi",
  "brown yellow": "kahverengi sarı",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "camgöbeği",
  "cyan blue": "camgöbeği mavi",
  dark: "koyu",
  gray: "gri",
  grayish: "grimsi",
  green: "Yeşil",
  "green cyan": "yeşil camgöbeği",
  hue: "Ton",
  light: "açık",
  lightness: "Canlılık",
  magenta: "eflatun",
  "magenta pink": "eflatun pembe",
  orange: "turuncu",
  "orange yellow": "turuncu sarı",
  pale: "solgun",
  pink: "pembe",
  "pink red": "pembe kırmızı",
  purple: "mor",
  "purple magenta": "mor eflatun",
  red: "Kırmızı",
  "red orange": "kırmızı portakal",
  saturation: "Doygunluk",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} saydam`,
  "very dark": "çok koyu",
  "very light": "çok açık",
  vibrant: "canlı",
  white: "beyaz",
  yellow: "sarı",
  "yellow green": "sarı yeşil"
};
var F0 = {};
F0 = {
  alpha: "Альфа",
  black: "чорний",
  blue: "Синій",
  "blue purple": "синьо-фіолетовий",
  brightness: "Яскравість",
  brown: "коричневий",
  "brown yellow": "коричнево-жовтий",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "блакитний",
  "cyan blue": "синьо-блакитний",
  dark: "темний",
  gray: "сірий",
  grayish: "сіруватий",
  green: "Зелений",
  "green cyan": "зелено-блакитний",
  hue: "Тон",
  light: "світлий",
  lightness: "Освітленість",
  magenta: "пурпуровий",
  "magenta pink": "пурпурово-рожевий",
  orange: "помаранчевий",
  "orange yellow": "помаранчево-жовтий",
  pale: "блідий",
  pink: "рожевий",
  "pink red": "рожево-червоний",
  purple: "фіолетовий",
  "purple magenta": "фіолетово-пурпуровий",
  red: "Червоний",
  "red orange": "червоно-помаранчевий",
  saturation: "Насиченість",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, прозорий на ${e.percentTransparent}`,
  "very dark": "дуже темний",
  "very light": "дуже світлий",
  vibrant: "яскравий",
  white: "білий",
  yellow: "жовтий",
  "yellow green": "жовто-зелений"
};
var A0 = {};
A0 = {
  alpha: "Alpha",
  black: "黑色",
  blue: "蓝色",
  "blue purple": "蓝紫色",
  brightness: "亮度",
  brown: "棕色的",
  "brown yellow": "棕黄色",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "蓝绿色",
  "cyan blue": "青蓝色",
  dark: "深色",
  gray: "灰色",
  grayish: "浅灰色的",
  green: "绿色",
  "green cyan": "绿青色",
  hue: "色相",
  light: "浅色",
  lightness: "明亮度",
  magenta: "紫红色",
  "magenta pink": "紫粉色",
  orange: "橙色",
  "orange yellow": "橙黄色",
  pale: "苍白的",
  pink: "粉色",
  "pink red": "粉红色",
  purple: "紫色",
  "purple magenta": "紫洋红色",
  red: "红色",
  "red orange": "红橙色",
  saturation: "饱和度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很浅",
  vibrant: "生机勃勃",
  white: "白色",
  yellow: "黄色",
  "yellow green": "黄色/绿色"
};
var T0 = {};
T0 = {
  alpha: "Alpha",
  black: "黑",
  blue: "藍色",
  "blue purple": "藍紫",
  brightness: "亮度",
  brown: "棕",
  "brown yellow": "棕黃",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "青",
  "cyan blue": "青藍",
  dark: "暗",
  gray: "灰",
  grayish: "偏灰",
  green: "綠色",
  "green cyan": "青綠",
  hue: "色相",
  light: "淺",
  lightness: "明亮",
  magenta: "洋紅",
  "magenta pink": "淺洋紅",
  orange: "橙",
  "orange yellow": "橙黃",
  pale: "淡",
  pink: "粉紅",
  "pink red": "粉紅",
  purple: "紫",
  "purple magenta": "紫洋紅",
  red: "紅色",
  "red orange": "橙紅",
  saturation: "飽和度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很淺",
  vibrant: "鮮豔",
  white: "白",
  yellow: "黃",
  "yellow green": "黃綠"
};
var R0 = {};
R0 = {
  "ar-AE": Qb,
  "bg-BG": e0,
  "cs-CZ": t0,
  "da-DK": n0,
  "de-DE": r0,
  "el-GR": a0,
  "en-US": l0,
  "es-ES": i0,
  "et-EE": o0,
  "fi-FI": u0,
  "fr-FR": s0,
  "he-IL": d0,
  "hr-HR": c0,
  "hu-HU": f0,
  "it-IT": b0,
  "ja-JP": p0,
  "ko-KR": h0,
  "lt-LT": m0,
  "lv-LV": v0,
  "nb-NO": g0,
  "nl-NL": y0,
  "pl-PL": $0,
  "pt-BR": x0,
  "pt-PT": D0,
  "ro-RO": C0,
  "ru-RU": E0,
  "sk-SK": w0,
  "sl-SI": P0,
  "sr-SP": k0,
  "sv-SE": S0,
  "tr-TR": B0,
  "uk-UA": F0,
  "zh-CN": A0,
  "zh-TW": T0
};
function C2(e) {
  return e && e.__esModule ? e.default : e;
}
let ho = new Jt(C2(R0));
function gt(e) {
  let t = tr.parse(e) || nr.parse(e) || rr.parse(e);
  if (t) return t;
  throw new Error("Invalid color value: " + e);
}
function An(e) {
  return typeof e == "string" ? gt(e) : e;
}
function M0(e) {
  return e === 360 ? e : (e % 360 + 360) % 360;
}
const Hd = 0.68, E2 = 0.85, _d = 0.55, Ud = 1e-3, mo = [
  [
    0,
    "pink"
  ],
  [
    15,
    "red"
  ],
  [
    48,
    "orange"
  ],
  [
    94,
    "yellow"
  ],
  [
    135,
    "green"
  ],
  [
    175,
    "cyan"
  ],
  [
    264,
    "blue"
  ],
  [
    284,
    "purple"
  ],
  [
    320,
    "magenta"
  ],
  [
    349,
    "pink"
  ]
];
class rs {
  toHexInt() {
    return this.toFormat("rgb").toHexInt();
  }
  getChannelValue(t) {
    if (t in this) return this[t];
    throw new Error("Unsupported color channel: " + t);
  }
  withChannelValue(t, n) {
    if (t in this) {
      let r = this.clone();
      return r[t] = n, r;
    }
    throw new Error("Unsupported color channel: " + t);
  }
  getChannelName(t, n) {
    return (Jt.getGlobalDictionaryForPackage("@react-stately/color") || ho).getStringForLocale(t, n);
  }
  getColorSpaceAxes(t) {
    let { xChannel: n, yChannel: r } = t, a = n || this.getColorChannels().find((o) => o !== r), l = r || this.getColorChannels().find((o) => o !== a), i = this.getColorChannels().find((o) => o !== a && o !== l);
    return {
      xChannel: a,
      yChannel: l,
      zChannel: i
    };
  }
  getColorName(t) {
    let [n, r, a] = Wd(this), l = Jt.getGlobalDictionaryForPackage("@react-stately/color") || ho;
    if (n > 0.999) return l.getStringForLocale("white", t);
    if (n < 1e-3) return l.getStringForLocale("black", t);
    let i;
    [i, n] = this.getOklchHue(n, r, a, t);
    let o = "", u = "";
    r <= 0.1 && r >= Ud ? n >= 0.7 ? u = "pale" : u = "grayish" : r >= 0.15 && (u = "vibrant"), n < 0.3 ? o = "very dark" : n < _d ? o = "dark" : n < 0.7 || (n < 0.85 ? o = "light" : o = "very light"), u && (u = l.getStringForLocale(u, t)), o && (o = l.getStringForLocale(o, t));
    let s = this.getChannelValue("alpha"), d = new zu(t, l);
    if (s < 1) {
      let c = new ar(t, {
        style: "percent"
      }).format(1 - s);
      return d.format("transparentColorName", {
        lightness: o,
        chroma: u,
        hue: i,
        percentTransparent: c
      }).replace(/\s+/g, " ").trim();
    } else return d.format("colorName", {
      lightness: o,
      chroma: u,
      hue: i
    }).replace(/\s+/g, " ").trim();
  }
  getOklchHue(t, n, r, a) {
    let l = Jt.getGlobalDictionaryForPackage("@react-stately/color") || ho;
    if (n < Ud) return [
      l.getStringForLocale("gray", a),
      t
    ];
    for (let i = 0; i < mo.length; i++) {
      let [o, u] = mo[i], [s, d] = mo[i + 1] || [
        360,
        "pink"
      ];
      if (r >= o && r < s)
        return u === "orange" && (t < Hd ? u = "brown" : t = t - Hd + _d), r > o + (s - o) / 2 && u !== d ? u = `${u} ${d}` : u === "yellow" && t < E2 && (u = "yellow green"), [
          l.getStringForLocale(u, a).toLocaleLowerCase(a),
          t
        ];
    }
    throw new Error("Unexpected hue");
  }
  getHueName(t) {
    let [n, r, a] = Wd(this), [l] = this.getOklchHue(n, r, a, t);
    return l;
  }
}
class tr extends rs {
  static parse(t) {
    let n = [];
    if (/^#[\da-f]+$/i.test(t) && [
      4,
      5,
      7,
      9
    ].includes(t.length)) {
      const l = (t.length < 6 ? t.replace(/[^#]/gi, "$&$&") : t).slice(1).split("");
      for (; l.length > 0; ) n.push(parseInt(l.splice(0, 2).join(""), 16));
      n[3] = n[3] !== void 0 ? n[3] / 255 : void 0;
    }
    const r = t.match(/^rgba?\((.*)\)$/);
    if (r != null && r[1] && (n = r[1].split(",").map((l) => Number(l.trim())), n = n.map((l, i) => Qe(l ?? 0, 0, i < 3 ? 255 : 1))), !(n[0] === void 0 || n[1] === void 0 || n[2] === void 0)) {
      var a;
      return n.length < 3 ? void 0 : new tr(n[0], n[1], n[2], (a = n[3]) !== null && a !== void 0 ? a : 1);
    }
  }
  toString(t = "css") {
    switch (t) {
      case "hex":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
      case "hexa":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
      case "rgb":
        return `rgb(${this.red}, ${this.green}, ${this.blue})`;
      case "css":
      case "rgba":
        return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hex":
      case "hexa":
      case "rgb":
      case "rgba":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "hsl":
      case "hsla":
        return this.toHSL();
      default:
        throw new Error("Unsupported color conversion: rgb -> " + t);
    }
  }
  toHexInt() {
    return this.red << 16 | this.green << 8 | this.blue;
  }
  /**
  * Converts an RGB color value to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  * @returns An HSBColor object.
  */
  toHSB() {
    const t = this.red / 255, n = this.green / 255, r = this.blue / 255, a = Math.min(t, n, r), l = Math.max(t, n, r), i = l - a, o = l === 0 ? 0 : i / l;
    let u = 0;
    if (i !== 0) {
      switch (l) {
        case t:
          u = (n - r) / i + (n < r ? 6 : 0);
          break;
        case n:
          u = (r - t) / i + 2;
          break;
        case r:
          u = (t - n) / i + 4;
          break;
      }
      u /= 6;
    }
    return new nr(it(u * 360, 2), it(o * 100, 2), it(l * 100, 2), this.alpha);
  }
  /**
  * Converts an RGB color value to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  * @returns An HSLColor object.
  */
  toHSL() {
    const t = this.red / 255, n = this.green / 255, r = this.blue / 255, a = Math.min(t, n, r), l = Math.max(t, n, r), i = (l + a) / 2, o = l - a;
    let u, s;
    if (o === 0) u = s = 0;
    else {
      switch (s = o / (i < 0.5 ? l + a : 2 - l - a), l) {
        case t:
          u = (n - r) / o + (n < r ? 6 : 0);
          break;
        case n:
          u = (r - t) / o + 2;
          break;
        case r:
        default:
          u = (t - n) / o + 4;
          break;
      }
      u /= 6;
    }
    return new rr(it(u * 360, 2), it(s * 100, 2), it(i * 100, 2), this.alpha);
  }
  clone() {
    return new tr(this.red, this.green, this.blue, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return {
          minValue: 0,
          maxValue: 255,
          step: 1,
          pageSize: 17
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return {
          style: "decimal"
        };
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return new ar(n, r).format(a);
  }
  getColorSpace() {
    return "rgb";
  }
  getColorChannels() {
    return tr.colorChannels;
  }
  constructor(t, n, r, a) {
    super(), this.red = t, this.green = n, this.blue = r, this.alpha = a;
  }
}
tr.colorChannels = [
  "red",
  "green",
  "blue"
];
const w2 = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class nr extends rs {
  static parse(t) {
    let n;
    if (n = t.match(w2)) {
      var r;
      const [a, l, i, o] = ((r = n[1]) !== null && r !== void 0 ? r : n[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new nr(M0(a), Qe(l, 0, 100), Qe(i, 0, 100), Qe(o ?? 1, 0, 1));
    }
  }
  toString(t = "css") {
    switch (t) {
      case "css":
        return this.toHSL().toString("css");
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsb":
        return `hsb(${this.hue}, ${it(this.saturation, 2)}%, ${it(this.brightness, 2)}%)`;
      case "hsba":
        return `hsba(${this.hue}, ${it(this.saturation, 2)}%, ${it(this.brightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsb":
      case "hsba":
        return this;
      case "hsl":
      case "hsla":
        return this.toHSL();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsb -> " + t);
    }
  }
  /**
  * Converts a HSB color to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
  * @returns An HSLColor object.
  */
  toHSL() {
    let t = this.saturation / 100, n = this.brightness / 100, r = n * (1 - t / 2);
    return t = r === 0 || r === 1 ? 0 : (n - r) / Math.min(r, 1 - r), new rr(it(this.hue, 2), it(t * 100, 2), it(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSV color value to RGB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
  * @returns An RGBColor object.
  */
  toRGB() {
    let t = this.hue, n = this.saturation / 100, r = this.brightness / 100, a = (l, i = (l + t / 60) % 6) => r - n * r * Math.max(Math.min(i, 4 - i, 1), 0);
    return new tr(Math.round(a(5) * 255), Math.round(a(3) * 255), Math.round(a(1) * 255), this.alpha);
  }
  clone() {
    return new nr(this.hue, this.saturation, this.brightness, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "brightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "brightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return (t === "saturation" || t === "brightness") && (a /= 100), new ar(n, r).format(a);
  }
  getColorSpace() {
    return "hsb";
  }
  getColorChannels() {
    return nr.colorChannels;
  }
  constructor(t, n, r, a) {
    super(), this.hue = t, this.saturation = n, this.brightness = r, this.alpha = a;
  }
}
nr.colorChannels = [
  "hue",
  "saturation",
  "brightness"
];
const P2 = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class rr extends rs {
  static parse(t) {
    let n;
    if (n = t.match(P2)) {
      var r;
      const [a, l, i, o] = ((r = n[1]) !== null && r !== void 0 ? r : n[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new rr(M0(a), Qe(l, 0, 100), Qe(i, 0, 100), Qe(o ?? 1, 0, 1));
    }
  }
  toString(t = "css") {
    switch (t) {
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsl":
        return `hsl(${this.hue}, ${it(this.saturation, 2)}%, ${it(this.lightness, 2)}%)`;
      case "css":
      case "hsla":
        return `hsla(${this.hue}, ${it(this.saturation, 2)}%, ${it(this.lightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsl":
      case "hsla":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsl -> " + t);
    }
  }
  /**
  * Converts a HSL color to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
  * @returns An HSBColor object.
  */
  toHSB() {
    let t = this.saturation / 100, n = this.lightness / 100, r = n + t * Math.min(n, 1 - n);
    return t = r === 0 ? 0 : 2 * (1 - n / r), new nr(it(this.hue, 2), it(t * 100, 2), it(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSL color to RGB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
  * @returns An RGBColor object.
  */
  toRGB() {
    let t = this.hue, n = this.saturation / 100, r = this.lightness / 100, a = n * Math.min(r, 1 - r), l = (i, o = (i + t / 30) % 12) => r - a * Math.max(Math.min(o - 3, 9 - o, 1), -1);
    return new tr(Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255), this.alpha);
  }
  clone() {
    return new rr(this.hue, this.saturation, this.lightness, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "lightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "lightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return (t === "saturation" || t === "lightness") && (a /= 100), new ar(n, r).format(a);
  }
  getColorSpace() {
    return "hsl";
  }
  getColorChannels() {
    return rr.colorChannels;
  }
  constructor(t, n, r, a) {
    super(), this.hue = t, this.saturation = n, this.lightness = r, this.alpha = a;
  }
}
rr.colorChannels = [
  "hue",
  "saturation",
  "lightness"
];
function Wd(e) {
  let t = e.toFormat("rgb"), n = t.getChannelValue("red") / 255, r = t.getChannelValue("green") / 255, a = t.getChannelValue("blue") / 255;
  [n, r, a] = S2(n, r, a);
  let [l, i, o] = B2(n, r, a), [u, s, d] = F2(l, i, o);
  return k2(u, s, d);
}
function k2(e, t, n) {
  var r = Math.atan2(n, t) * 180 / Math.PI;
  return [
    e,
    Math.sqrt(t ** 2 + n ** 2),
    r >= 0 ? r : r + 360
    // Hue, in degrees [0 to 360)
  ];
}
function S2(e, t, n) {
  return [
    vo(e),
    vo(t),
    vo(n)
  ];
}
function vo(e) {
  let t = e < 0 ? -1 : 1, n = Math.abs(e);
  return n <= 0.04045 ? e / 12.92 : t * Math.pow((n + 0.055) / 1.055, 2.4);
}
function B2(e, t, n) {
  return nu([
    0.4123907992659595,
    0.35758433938387796,
    0.1804807884018343,
    0.21263900587151036,
    0.7151686787677559,
    0.07219231536073371,
    0.01933081871559185,
    0.11919477979462599,
    0.9505321522496606
  ], e, t, n);
}
function F2(e, t, n) {
  const r = [
    0.819022437996703,
    0.3619062600528904,
    -0.1288737815209879,
    0.0329836539323885,
    0.9292868615863434,
    0.0361446663506424,
    0.0481771893596242,
    0.2642395317527308,
    0.6335478284694309
  ], a = [
    0.210454268309314,
    0.7936177747023054,
    -0.0040720430116193,
    1.9779985324311684,
    -2.42859224204858,
    0.450593709617411,
    0.0259040424655478,
    0.7827717124575296,
    -0.8086757549230774
  ];
  let [l, i, o] = nu(r, e, t, n);
  return nu(a, Math.cbrt(l), Math.cbrt(i), Math.cbrt(o));
}
function nu(e, t, n, r) {
  let a = e[0] * t + e[1] * n + e[2] * r, l = e[3] * t + e[4] * n + e[5] * r, i = e[6] * t + e[7] * n + e[8] * r;
  return [
    a,
    l,
    i
  ];
}
const A2 = gt("#ffffff");
function T2(e) {
  let { value: t, defaultValue: n, colorSpace: r, xChannel: a, yChannel: l, onChange: i, onChangeEnd: o } = e;
  !t && !n && (n = A2), t && (t = An(t)), n && (n = An(n));
  let [u, s] = Me(t, n, i), d = H(() => r && u ? u.toFormat(r) : u, [
    u,
    r
  ]), c = j(d), f = (K) => {
    c.current = K, s(K);
  }, b = H(() => d.getColorSpaceAxes({
    xChannel: a,
    yChannel: l
  }), [
    d,
    a,
    l
  ]), p = d.getChannelRange(b.xChannel), h = d.getChannelRange(b.yChannel), { minValue: m, maxValue: v, step: y, pageSize: w } = p, { minValue: C, maxValue: D, step: P, pageSize: R } = h, [V, L] = q(!1), A = j(!1), $ = d.getChannelValue(b.xChannel), S = d.getChannelValue(b.yChannel), T = (K) => {
    if (K === $) return;
    let g = d.withChannelValue(b.xChannel, K);
    f(g);
  }, M = (K) => {
    if (K === S) return;
    let g = d.withChannelValue(b.yChannel, K);
    f(g);
  };
  return {
    channels: b,
    xChannelStep: y,
    yChannelStep: P,
    xChannelPageStep: w,
    yChannelPageStep: R,
    value: d,
    setValue(K) {
      f(An(K));
    },
    xValue: $,
    setXValue: T,
    yValue: S,
    setYValue: M,
    setColorFromPoint(K, g) {
      let B = m + Qe(K, 0, 1) * (v - m), k = C + (1 - Qe(g, 0, 1)) * (D - C), I;
      B !== $ && (B = lt(B, m, v, y), I = d.withChannelValue(b.xChannel, B)), k !== S && (k = lt(k, C, D, P), I = (I || d).withChannelValue(b.yChannel, k)), I && f(I);
    },
    getThumbPosition() {
      let K = ($ - m) / (v - m), g = 1 - (S - C) / (D - C);
      return {
        x: K,
        y: g
      };
    },
    incrementX(K = 1) {
      T($ + K > v ? v : lt($ + K, m, v, y));
    },
    incrementY(K = 1) {
      M(S + K > D ? D : lt(S + K, C, D, P));
    },
    decrementX(K = 1) {
      T(lt($ - K, m, v, y));
    },
    decrementY(K = 1) {
      M(lt(S - K, C, D, P));
    },
    setDragging(K) {
      let g = A.current;
      A.current = K, o && !K && g && o(c.current), L(K);
    },
    isDragging: V,
    getDisplayColor() {
      return d.withChannelValue("alpha", 1);
    }
  };
}
const R2 = 0, M2 = 100, N2 = 1;
function N0(e) {
  const { isDisabled: t = !1, minValue: n = R2, maxValue: r = M2, numberFormatter: a, step: l = N2, orientation: i = "horizontal" } = e;
  let o = H(() => {
    let F = (r - n) / 10;
    return F = lt(F, 0, F + l, l), Math.max(F, l);
  }, [
    l,
    r,
    n
  ]), u = ie((F) => F == null ? void 0 : F.map((z, Z) => {
    let te = Z === 0 ? n : F[Z - 1], ue = Z === F.length - 1 ? r : F[Z + 1];
    return lt(z, te, ue, l);
  }), [
    n,
    r,
    l
  ]), s = H(() => u(Zd(e.value)), [
    e.value
  ]), d = H(() => {
    var F;
    return u((F = Zd(e.defaultValue)) !== null && F !== void 0 ? F : [
      n
    ]);
  }, [
    e.defaultValue,
    n
  ]), c = Yd(e.value, e.defaultValue, e.onChange), f = Yd(e.value, e.defaultValue, e.onChangeEnd);
  const [b, p] = Me(s, d, c), [h, m] = q(new Array(b.length).fill(!1)), v = j(new Array(b.length).fill(!0)), [y, w] = q(void 0), C = j(b), D = j(h);
  let P = (F) => {
    C.current = F, p(F);
  }, R = (F) => {
    D.current = F, m(F);
  };
  function V(F) {
    return (F - n) / (r - n);
  }
  function L(F) {
    return F === 0 ? n : b[F - 1];
  }
  function A(F) {
    return F === b.length - 1 ? r : b[F + 1];
  }
  function $(F) {
    return v.current[F];
  }
  function S(F, z) {
    v.current[F] = z;
  }
  function T(F, z) {
    if (t || !$(F)) return;
    const Z = L(F), te = A(F);
    z = lt(z, Z, te, l);
    let ue = Gd(C.current, F, z);
    P(ue);
  }
  function M(F, z) {
    if (t || !$(F)) return;
    z && (C.current = b);
    const Z = D.current[F];
    D.current = Gd(D.current, F, z), R(D.current), f && Z && !D.current.some(Boolean) && f(C.current);
  }
  function K(F) {
    return a.format(F);
  }
  function g(F, z) {
    T(F, k(z));
  }
  function B(F) {
    return Math.round((F - n) / l) * l + n;
  }
  function k(F) {
    const z = F * (r - n) + n;
    return Qe(B(z), n, r);
  }
  function I(F, z = 1) {
    let Z = Math.max(z, l);
    T(F, lt(b[F] + Z, n, r, l));
  }
  function O(F, z = 1) {
    let Z = Math.max(z, l);
    T(F, lt(b[F] - Z, n, r, l));
  }
  return {
    values: b,
    getThumbValue: (F) => b[F],
    setThumbValue: T,
    setThumbPercent: g,
    isThumbDragging: (F) => h[F],
    setThumbDragging: M,
    focusedThumb: y,
    setFocusedThumb: w,
    getThumbPercent: (F) => V(b[F]),
    getValuePercent: V,
    getThumbValueLabel: (F) => K(b[F]),
    getFormattedValue: K,
    getThumbMinValue: L,
    getThumbMaxValue: A,
    getPercentValue: k,
    isThumbEditable: $,
    setThumbEditable: S,
    incrementThumb: I,
    decrementThumb: O,
    step: l,
    pageSize: o,
    orientation: i,
    isDisabled: t
  };
}
function Gd(e, t, n) {
  return e[t] === n ? e : [
    ...e.slice(0, t),
    n,
    ...e.slice(t + 1)
  ];
}
function Zd(e) {
  if (e != null)
    return Array.isArray(e) ? e : [
      e
    ];
}
function Yd(e, t, n) {
  return (r) => {
    typeof e == "number" || typeof t == "number" ? n == null || n(r[0]) : n == null || n(r);
  };
}
function V2(e) {
  let { channel: t, colorSpace: n, value: r, defaultValue: a, onChange: l, locale: i, ...o } = e;
  if (r == null && a == null) throw new Error("useColorSliderState requires a value or defaultValue");
  r && (r = An(r)), a && (a = An(a));
  let [u, s] = Me(r, a, l), d = H(() => n && u ? u.toFormat(n) : u, [
    u,
    n
  ]), c = N0({
    ...d.getChannelRange(t),
    ...o,
    // Unused except in getThumbValueLabel, which is overridden below. null to localize the TypeScript error for ignoring.
    // @ts-ignore
    numberFormatter: null,
    value: d.getChannelValue(t),
    onChange(p) {
      s(d.withChannelValue(t, p));
    },
    onChangeEnd(p) {
      e.onChangeEnd && e.onChangeEnd(d.withChannelValue(t, p));
    }
  }), { step: f, pageSize: b } = d.getChannelRange(t);
  return {
    ...c,
    value: d,
    setValue(p) {
      s(An(p));
    },
    getDisplayColor() {
      switch (t) {
        case "hue":
          return gt(`hsl(${d.getChannelValue("hue")}, 100%, 50%)`);
        case "lightness":
        case "brightness":
        case "saturation":
        case "red":
        case "green":
        case "blue":
          return d.withChannelValue("alpha", 1);
        case "alpha":
          return d;
        default:
          throw new Error("Unknown color channel: " + t);
      }
    },
    getThumbValueLabel() {
      return d.formatChannelValue(t, i);
    },
    step: f,
    pageSize: b,
    isDragging: c.isThumbDragging(0)
  };
}
const I2 = gt("hsl(0, 100%, 50%)");
function go(e, t) {
  return Math.round(e / t) * t;
}
function yo(e, t) {
  return (e % t + t) % t;
}
function O2(e) {
  let t = Math.floor(e);
  return t === e ? e - 1 : t;
}
function z2(e) {
  return e * Math.PI / 180;
}
function K2(e) {
  return e * 180 / Math.PI;
}
function j2(e, t) {
  let n = z2(360 - e + 90), r = Math.sin(n) * t, a = Math.cos(n) * t;
  return {
    x: r,
    y: a
  };
}
function L2(e, t, n) {
  return (K2(Math.atan2(t / n, e / n)) + 360) % 360;
}
function H2(e) {
  let { value: t, defaultValue: n, onChange: r, onChangeEnd: a } = e;
  !t && !n && (n = I2), t && (t = An(t)), n && (n = An(n));
  let [l, i] = Me(t, n, r), o = H(() => {
    let C = l.getColorSpace();
    return C === "hsl" || C === "hsb" ? l : l.toFormat("hsl");
  }, [
    l
  ]), u = j(o), s = (C) => {
    u.current = C, i(C);
  }, d = o.getChannelRange("hue"), { minValue: c, maxValue: f, step: b, pageSize: p } = d, [h, m] = q(!1), v = j(!1), y = o.getChannelValue("hue");
  function w(C) {
    if (C > 360 && (C = 0), C = go(yo(C, 360), b), y !== C) {
      let D = o.withChannelValue("hue", C);
      s(D);
    }
  }
  return {
    value: o,
    step: b,
    pageStep: p,
    setValue(C) {
      let D = An(C);
      s(D);
    },
    hue: y,
    setHue: w,
    setHueFromPoint(C, D, P) {
      w(L2(C, D, P));
    },
    getThumbPosition(C) {
      return j2(o.getChannelValue("hue"), C);
    },
    increment(C = 1) {
      let D = Math.max(C, b), P = y + D;
      P >= f && (P = c), w(go(yo(P, 360), D));
    },
    decrement(C = 1) {
      let D = Math.max(C, b);
      w(y === 0 ? O2(360 / D) * D : go(yo(y - D, 360), D));
    },
    setDragging(C) {
      let D = v.current;
      v.current = C, a && !C && D && a(u.current), m(C);
    },
    isDragging: h,
    getDisplayColor() {
      return o.toFormat("hsl").withChannelValue("saturation", 100).withChannelValue("lightness", 50).withChannelValue("alpha", 1);
    },
    isDisabled: e.isDisabled || !1
  };
}
function Cr(e) {
  return H(() => {
    if (typeof e == "string") try {
      return gt(e);
    } catch {
      return;
    }
    return e;
  }, [
    e
  ]);
}
const ni = gt("#000000"), V0 = gt("#FFFFFF"), _2 = ni.toHexInt(), U2 = V0.toHexInt();
function W2(e) {
  let { value: t, defaultValue: n, onChange: r } = e, { step: a } = ni.getChannelRange("red"), l = Cr(t), i = Cr(n), [o, u] = Me(l, i, r), [s, d] = q(() => (t || n) && o ? o.toString("hex") : ""), c = en({
    ...e,
    value: o
  }), f = (P) => {
    if (!o || !P) {
      u(P);
      return;
    }
    if (P.toHexInt() !== o.toHexInt()) {
      u(P);
      return;
    }
  }, [b, p] = q(o);
  b !== o && (d(o ? o.toString("hex") : ""), p(o));
  let h = H(() => {
    let P;
    try {
      P = gt(s.startsWith("#") ? s : `#${s}`);
    } catch {
      P = null;
    }
    return P;
  }, [
    s
  ]);
  return {
    ...c,
    validate: (P) => {
      var R;
      return P === "" || !!(!((R = P.match(/^#?[0-9a-f]{0,6}$/i)) === null || R === void 0) && R[0]);
    },
    colorValue: o,
    inputValue: s,
    setInputValue: d,
    commit: () => {
      if (!s.length) {
        f(null), d(t === void 0 || o === null ? "" : o.toString("hex"));
        return;
      }
      if (h == null) {
        d(o ? o.toString("hex") : "");
        return;
      }
      f(h);
      let P = "";
      o && (P = o.toString("hex")), d(P);
    },
    increment: () => {
      let P = qd(h, a);
      P === o && d(P.toString("hex")), f(P), c.commitValidation();
    },
    incrementToMax: () => f(V0),
    decrement: () => {
      let P = qd(h, -a);
      P === o && d(P.toString("hex")), f(P), c.commitValidation();
    },
    decrementToMin: () => f(ni)
  };
}
function qd(e, t) {
  let n = e || ni, r = n.toHexInt(), a = Math.min(Math.max(r + t, _2), U2);
  if (a !== r) {
    let l = `#${a.toString(16).padStart(6, "0").toUpperCase()}`;
    n = gt(l);
  }
  return n;
}
function I0(e) {
  let { minValue: t, maxValue: n, step: r, formatOptions: a, value: l, defaultValue: i = NaN, onChange: o, locale: u, isDisabled: s, isReadOnly: d } = e;
  l === null && (l = NaN), l !== void 0 && !isNaN(l) && (r !== void 0 && !isNaN(r) ? l = lt(l, t, n, r) : l = Qe(l, t, n)), isNaN(i) || (r !== void 0 && !isNaN(r) ? i = lt(i, t, n, r) : i = Qe(i, t, n));
  let [c, f] = Me(l, isNaN(i) ? NaN : i, o), [b, p] = q(() => isNaN(c) ? "" : new ar(u, a).format(c)), h = H(() => new Xu(u, a), [
    u,
    a
  ]), m = H(() => h.getNumberingSystem(b), [
    h,
    b
  ]), v = H(() => new ar(u, {
    ...a,
    numberingSystem: m
  }), [
    u,
    a,
    m
  ]), y = H(() => v.resolvedOptions(), [
    v
  ]), w = ie((z) => isNaN(z) || z === null ? "" : v.format(z), [
    v
  ]), C = en({
    ...e,
    value: c
  }), D = r !== void 0 && !isNaN(r) ? r : 1;
  y.style === "percent" && (r === void 0 || isNaN(r)) && (D = 0.01);
  let [P, R] = q(c), [V, L] = q(u), [A, $] = q(a);
  (!Object.is(c, P) || u !== V || a !== A) && (p(w(c)), R(c), L(u), $(a));
  let S = H(() => h.parse(b), [
    h,
    b
  ]), T = () => {
    if (!b.length) {
      f(NaN), p(l === void 0 ? "" : w(c));
      return;
    }
    if (isNaN(S)) {
      p(w(c));
      return;
    }
    let z;
    r === void 0 || isNaN(r) ? z = Qe(S, t, n) : z = lt(S, t, n, r), z = h.parse(w(z)), f(z), p(w(l === void 0 ? z : c));
  }, M = (z, Z = 0) => {
    let te = S;
    if (isNaN(te)) {
      let ue = isNaN(Z) ? 0 : Z;
      return lt(ue, t, n, D);
    } else {
      let ue = lt(te, t, n, D);
      return z === "+" && ue > te || z === "-" && ue < te ? ue : lt($o(z, te, D), t, n, D);
    }
  }, K = () => {
    let z = M("+", t);
    z === c && p(w(z)), f(z), C.commitValidation();
  }, g = () => {
    let z = M("-", n);
    z === c && p(w(z)), f(z), C.commitValidation();
  }, B = () => {
    n != null && (f(lt(n, t, n, D)), C.commitValidation());
  }, k = () => {
    t != null && (f(t), C.commitValidation());
  }, I = H(() => !s && !d && (isNaN(S) || n === void 0 || isNaN(n) || lt(S, t, n, D) > S || $o("+", S, D) <= n), [
    s,
    d,
    t,
    n,
    D,
    S
  ]), O = H(() => !s && !d && (isNaN(S) || t === void 0 || isNaN(t) || lt(S, t, n, D) < S || $o("-", S, D) >= t), [
    s,
    d,
    t,
    n,
    D,
    S
  ]);
  return {
    ...C,
    validate: (z) => h.isValidPartialNumber(z, t, n),
    increment: K,
    incrementToMax: B,
    decrement: g,
    decrementToMin: k,
    canIncrement: I,
    canDecrement: O,
    minValue: t,
    maxValue: n,
    numberValue: S,
    setNumberValue: f,
    setInputValue: p,
    inputValue: b,
    commit: T
  };
}
function $o(e, t, n) {
  let r = e === "+" ? t + n : t - n;
  if (t % 1 !== 0 || n % 1 !== 0) {
    const a = t.toString().split("."), l = n.toString().split("."), i = a[1] && a[1].length || 0, o = l[1] && l[1].length || 0, u = Math.pow(10, Math.max(i, o));
    t = Math.round(t * u), n = Math.round(n * u), r = e === "+" ? t + n : t - n, r /= u;
  }
  return r;
}
function G2(e) {
  let { channel: t, colorSpace: n, locale: r } = e, a = Cr("#000"), l = Cr(e.value), i = Cr(e.defaultValue), [o, u] = Me(l, i ?? null, e.onChange), s = H(() => {
    let h = o || a;
    return n && h ? h.toFormat(n) : h;
  }, [
    a,
    o,
    n
  ]), d = s.getChannelValue(t), c = s.getChannelRange(t), f = H(() => s.getChannelFormatOptions(t), [
    s,
    t
  ]), b = f.style === "percent" && c.maxValue === 100 ? 100 : 1;
  return {
    ...I0({
      locale: r,
      value: o === null ? NaN : d / b,
      onChange: (h) => {
        Number.isNaN(h) ? u(null) : u(s.withChannelValue(t, h * b));
      },
      minValue: c.minValue / b,
      maxValue: c.maxValue / b,
      step: c.step / b,
      formatOptions: f
    }),
    colorValue: s
  };
}
function O0(e) {
  let t = Cr(e.value), n = Cr(e.defaultValue || "#000000"), [r, a] = Me(t || void 0, n, e.onChange);
  return {
    color: r,
    setColor(l) {
      l != null && a(l || gt("#000000"));
    }
  };
}
const z0 = (e) => [
  0,
  60,
  120,
  180,
  240,
  300,
  360
].map((t) => e.withChannelValue("hue", t).toString("css")).join(", "), K0 = (e) => `${e.withChannelValue("saturation", 0)}, transparent`, Z2 = {
  hue: z0,
  saturation: K0,
  lightness: () => "black, transparent, white"
}, Y2 = {
  hue: z0,
  saturation: K0,
  brightness: () => "black, transparent"
};
function q2({ direction: e, state: t, zChannel: n, xChannel: r, yChannel: a }) {
  return H(() => {
    let i = e === "rtl" ? "left" : "right", o = {}, u = t.value.getChannelValue(n);
    switch (t.value.getColorSpace()) {
      case "rgb": {
        let f = gt("rgb(0, 0, 0)");
        o = {
          background: [
            // The screen blend mode multiplies the inverse of each channel, e.g. 1 - (1 - a) * (1 - b).
            // Create a layer for each channel, with the other channels as 0. After blending, this should
            // result in the gradients being combined channel by channel.
            `linear-gradient(to ${i}, ${f.withChannelValue(r, 0)}, ${f.withChannelValue(r, 255)})`,
            `linear-gradient(to top, ${f.withChannelValue(a, 0)}, ${f.withChannelValue(a, 255)})`,
            f.withChannelValue(n, u)
          ].join(","),
          backgroundBlendMode: "screen"
        };
        break;
      }
      case "hsl": {
        let f = t.value.getColorChannels(), b = gt("hsl(0, 100%, 50%)").withChannelValue(n, u), p = f.filter((h) => h !== n).map((h) => `linear-gradient(to ${h === r ? i : "top"}, ${Z2[h](b)})`).reverse();
        n === "hue" && p.push(b.toString("css")), o = {
          background: p.join(", ")
        };
        break;
      }
      case "hsb": {
        let f = t.value.getColorChannels(), b = gt("hsb(0, 100%, 100%)").withChannelValue(n, u), p = f.filter((h) => h !== n).map((h) => `linear-gradient(to ${h === r ? i : "top"}, ${Y2[h](b)})`).reverse();
        n === "hue" && p.push(b.toString("css")), o = {
          background: p.join(", ")
        };
        break;
      }
    }
    let { x: s, y: d } = t.getThumbPosition();
    e === "rtl" && (s = 1 - s);
    let c = {
      forcedColorAdjust: "none"
    };
    return {
      colorAreaStyleProps: {
        style: {
          position: "relative",
          touchAction: "none",
          ...c,
          ...o
        }
      },
      thumbStyleProps: {
        style: {
          position: "absolute",
          left: `${s * 100}%`,
          top: `${d * 100}%`,
          transform: "translate(-50%, -50%)",
          touchAction: "none",
          ...c
        }
      }
    };
  }, [
    e,
    t,
    n,
    r,
    a
  ]);
}
const Xd = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function sn(e = {}) {
  let { style: t, isFocusable: n } = e, [r, a] = q(!1), { focusWithinProps: l } = jt({
    isDisabled: !n,
    onFocusWithinChange: (o) => a(o)
  }), i = H(() => r ? t : t ? {
    ...Xd,
    ...t
  } : Xd, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...l,
      style: i
    }
  };
}
function Vn(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: a, ...l } = e, { visuallyHiddenProps: i } = sn(e);
  return /* @__PURE__ */ x.createElement(n, _(l, i), t);
}
function X2(e) {
  return e && e.__esModule ? e.default : e;
}
function J2(e, t) {
  let { isDisabled: n, inputXRef: r, inputYRef: a, containerRef: l, "aria-label": i, xName: o, yName: u } = e, s = Oe(X2(ns), "@react-aria/color"), { addGlobalListener: d, removeGlobalListener: c } = yn(), { direction: f, locale: b } = me(), [p, h] = q(null), m = ie((Q = r) => {
    Q.current && Et(Q.current);
  }, [
    r
  ]);
  zn(r, [
    t.xValue,
    t.yValue
  ], ([Q, ae]) => {
    let ge = t.value.withChannelValue(t.channels.xChannel, Q).withChannelValue(t.channels.yChannel, ae);
    t.setValue(ge);
  });
  let [v, y] = q(!1), [w, C] = q(!1), { xChannel: D, yChannel: P, zChannel: R } = t.channels, V = t.xChannelStep, L = t.yChannelStep, A = j(null), { keyboardProps: $ } = la({
    onKeyDown(Q) {
      if (!/^(PageUp|PageDown|Home|End)$/.test(Q.key)) {
        Q.continuePropagation();
        return;
      }
      Q.preventDefault(), t.setDragging(!0), y(!0);
      let ae;
      switch (Q.key) {
        case "PageUp":
          t.incrementY(t.yChannelPageStep), ae = "y";
          break;
        case "PageDown":
          t.decrementY(t.yChannelPageStep), ae = "y";
          break;
        case "Home":
          f === "rtl" ? t.incrementX(t.xChannelPageStep) : t.decrementX(t.xChannelPageStep), ae = "x";
          break;
        case "End":
          f === "rtl" ? t.decrementX(t.xChannelPageStep) : t.incrementX(t.xChannelPageStep), ae = "x";
          break;
      }
      t.setDragging(!1), ae && (m(ae === "x" ? r : a), h(ae));
    }
  }), S = {
    onMoveStart() {
      A.current = null, t.setDragging(!0);
    },
    onMove({ deltaX: Q, deltaY: ae, pointerType: ge, shiftKey: Se }) {
      var xt;
      let { incrementX: cr, decrementX: Hn, incrementY: Vt, decrementY: _t, xChannelPageStep: It, xChannelStep: fr, yChannelPageStep: _n, yChannelStep: br, getThumbPosition: pa, setColorFromPoint: pt } = t;
      A.current == null && (A.current = pa());
      let { width: pr, height: Zi } = ((xt = l.current) === null || xt === void 0 ? void 0 : xt.getBoundingClientRect()) || {
        width: 0,
        height: 0
      }, ml = Q !== 0 || ae !== 0;
      if (ge === "keyboard") {
        let vl = Se && It > fr ? It : fr, gl = Se && _n > br ? _n : br;
        Q > 0 && f === "ltr" || Q < 0 && f === "rtl" ? cr(vl) : Q < 0 && f === "ltr" || Q > 0 && f === "rtl" ? Hn(vl) : ae > 0 ? _t(gl) : ae < 0 && Vt(gl), y(ml), p = ml && Math.abs(ae) > Math.abs(Q) ? "y" : "x", h(p);
      } else
        A.current.x += (f === "rtl" ? -1 : 1) * Q / pr, A.current.y += ae / Zi, pt(A.current.x, A.current.y);
    },
    onMoveEnd() {
      g.current = !1, t.setDragging(!1), m(p === "x" ? r : a);
    }
  }, { moveProps: T } = Sr(S), { focusWithinProps: M } = jt({
    onFocusWithinChange: (Q) => {
      Q || (y(!1), C(!1));
    }
  }), K = j(void 0), g = j(!1), { moveProps: B } = Sr({
    onMoveStart() {
      g.current && S.onMoveStart();
    },
    onMove(Q) {
      g.current && S.onMove(Q);
    },
    onMoveEnd() {
      g.current && S.onMoveEnd();
    }
  }), k = (Q) => {
    t.isDragging || (K.current = Q, y(!1), m(), t.setDragging(!0), typeof PointerEvent < "u" ? d(window, "pointerup", I, !1) : (d(window, "mouseup", I, !1), d(window, "touchend", I, !1)));
  }, I = (Q) => {
    var ae, ge;
    ((ge = Q.pointerId) !== null && ge !== void 0 ? ge : (ae = Q.changedTouches) === null || ae === void 0 ? void 0 : ae[0].identifier) === K.current && (y(!1), m(), t.setDragging(!1), K.current = void 0, g.current = !1, typeof PointerEvent < "u" ? c(window, "pointerup", I, !1) : (c(window, "mouseup", I, !1), c(window, "touchend", I, !1)));
  }, O = (Q, ae, ge, Se) => {
    let xt = Q.getBoundingClientRect(), { width: cr, height: Hn } = xt, Vt = (ge - xt.x) / cr, _t = (Se - xt.y) / Hn;
    f === "rtl" && (Vt = 1 - Vt), Vt >= 0 && Vt <= 1 && _t >= 0 && _t <= 1 && !t.isDragging && K.current === void 0 && (g.current = !0, y(!1), K.current = ae, t.setColorFromPoint(Vt, _t), m(), t.setDragging(!0), typeof PointerEvent < "u" ? d(window, "pointerup", F, !1) : (d(window, "mouseup", F, !1), d(window, "touchend", F, !1)));
  }, F = (Q) => {
    var ae, ge;
    let Se = (ge = Q.pointerId) !== null && ge !== void 0 ? ge : (ae = Q.changedTouches) === null || ae === void 0 ? void 0 : ae[0].identifier;
    g.current && Se === K.current && (g.current = !1, y(!1), K.current = void 0, t.setDragging(!1), m(), typeof PointerEvent < "u" ? c(window, "pointerup", F, !1) : (c(window, "mouseup", F, !1), c(window, "touchend", F, !1)));
  }, z = n ? {} : _({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (Q) => {
        Q.pointerType === "mouse" && (Q.button !== 0 || Q.altKey || Q.ctrlKey || Q.metaKey) || O(Q.currentTarget, Q.pointerId, Q.clientX, Q.clientY);
      }
    } : {
      onMouseDown: (Q) => {
        Q.button !== 0 || Q.altKey || Q.ctrlKey || Q.metaKey || O(Q.currentTarget, void 0, Q.clientX, Q.clientY);
      },
      onTouchStart: (Q) => {
        O(Q.currentTarget, Q.changedTouches[0].identifier, Q.changedTouches[0].clientX, Q.changedTouches[0].clientY);
      }
    }
  }, B), Z = n ? {} : _({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (Q) => {
        Q.pointerType === "mouse" && (Q.button !== 0 || Q.altKey || Q.ctrlKey || Q.metaKey) || k(Q.pointerId);
      }
    } : {
      onMouseDown: (Q) => {
        Q.button !== 0 || Q.altKey || Q.ctrlKey || Q.metaKey || k(void 0);
      },
      onTouchStart: (Q) => {
        k(Q.changedTouches[0].identifier);
      }
    }
  }, M, $, T), { focusProps: te } = na({
    onFocus: () => {
      h("x");
    }
  }), { focusProps: ue } = na({
    onFocus: () => {
      h("y");
    }
  });
  const be = (Q) => {
    const { target: ae } = Q;
    C(!0), ae === r.current ? t.setXValue(parseFloat(ae.value)) : ae === a.current && t.setYValue(parseFloat(ae.value));
  };
  let ce = Ar() || Er(), X = t.getDisplayColor();
  const pe = ie((Q) => `${w || v ? s.format("colorNameAndValue", {
    name: X.getChannelName(Q, b),
    value: X.formatChannelValue(Q, b)
  }) : [
    s.format("colorNameAndValue", {
      name: X.getChannelName(Q, b),
      value: X.formatChannelValue(Q, b)
    }),
    s.format("colorNameAndValue", {
      name: X.getChannelName(Q === P ? D : P, b),
      value: X.formatChannelValue(Q === P ? D : P, b)
    }),
    s.format("colorNameAndValue", {
      name: X.getChannelName(R, b),
      value: X.formatChannelValue(R, b)
    })
  ].join(", ")}, ${X.getColorName(b)}`, [
    b,
    X,
    s,
    w,
    v,
    D,
    P,
    R
  ]);
  let ve = s.format("colorPicker"), W = Ot({
    ...e,
    "aria-label": i ? s.format("colorInputLabel", {
      label: i,
      channelLabel: ve
    }) : ve
  }), se = Ot({
    ...e,
    "aria-label": i ? s.format("colorInputLabel", {
      label: i,
      channelLabel: ve
    }) : ve
  }), fe = Ot({
    ...e,
    "aria-label": i ? `${i}, ${ve}` : void 0
  }, ce ? ve : void 0), We = s.format("twoDimensionalSlider"), { visuallyHiddenProps: ye } = sn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  }), { colorAreaStyleProps: st, thumbStyleProps: $t } = q2({
    direction: f,
    state: t,
    xChannel: D,
    yChannel: P,
    zChannel: R
  });
  return {
    colorAreaProps: {
      ...fe,
      ...z,
      ...st,
      role: "group"
    },
    thumbProps: {
      ...Z,
      ...$t,
      role: "presentation"
    },
    xInputProps: {
      ...W,
      ...ye,
      ...te,
      type: "range",
      min: t.value.getChannelRange(D).minValue,
      max: t.value.getChannelRange(D).maxValue,
      step: V,
      "aria-roledescription": We,
      "aria-valuetext": pe(D),
      "aria-orientation": "horizontal",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"],
      disabled: n,
      value: t.value.getChannelValue(D),
      name: o,
      tabIndex: ce || !p || p === "x" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused control when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": ce || !p || p === "x" || v ? void 0 : "true",
      onChange: be
    },
    yInputProps: {
      ...se,
      ...ye,
      ...ue,
      type: "range",
      min: t.value.getChannelRange(P).minValue,
      max: t.value.getChannelRange(P).maxValue,
      step: L,
      "aria-roledescription": We,
      "aria-valuetext": pe(P),
      "aria-orientation": "vertical",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"],
      disabled: n,
      value: t.value.getChannelValue(P),
      name: u,
      tabIndex: ce || p === "y" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused input when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": ce || p === "y" || v ? void 0 : "true",
      onChange: be
    }
  };
}
const as = /* @__PURE__ */ new WeakMap();
function ru(e, t) {
  let n = as.get(e);
  if (!n) throw new Error("Unknown slider state");
  return `${n.id}-${t}`;
}
function j0(e, t, n) {
  let { labelProps: r, fieldProps: a } = il(e), l = e.orientation === "vertical";
  var i;
  as.set(t, {
    id: (i = r.id) !== null && i !== void 0 ? i : a.id,
    "aria-describedby": e["aria-describedby"],
    "aria-details": e["aria-details"]
  });
  let { direction: o } = me(), { addGlobalListener: u, removeGlobalListener: s } = yn();
  const d = j(null), c = o === "rtl", f = j(null), { moveProps: b } = Sr({
    onMoveStart() {
      f.current = null;
    },
    onMove({ deltaX: v, deltaY: y }) {
      if (!n.current) return;
      let { height: w, width: C } = n.current.getBoundingClientRect(), D = l ? w : C;
      f.current == null && d.current != null && (f.current = t.getThumbPercent(d.current) * D);
      let P = l ? y : v;
      if ((l || c) && (P = -P), f.current += P, d.current != null && n.current) {
        const R = Qe(f.current / D, 0, 1);
        t.setThumbPercent(d.current, R);
      }
    },
    onMoveEnd() {
      d.current != null && (t.setThumbDragging(d.current, !1), d.current = null);
    }
  });
  let p = j(void 0), h = (v, y, w, C) => {
    if (n.current && !e.isDisabled && t.values.every((D, P) => !t.isThumbDragging(P))) {
      let { height: D, width: P, top: R, left: V } = n.current.getBoundingClientRect(), L = l ? D : P, T = ((l ? C : w) - (l ? R : V)) / L;
      (o === "rtl" || l) && (T = 1 - T);
      let M = t.getPercentValue(T), K, g = t.values.findIndex((B) => M - B < 0);
      if (g === 0) K = g;
      else if (g === -1) K = t.values.length - 1;
      else {
        let B = t.values[g - 1], k = t.values[g];
        Math.abs(B - M) < Math.abs(k - M) ? K = g - 1 : K = g;
      }
      K >= 0 && t.isThumbEditable(K) ? (v.preventDefault(), d.current = K, t.setFocusedThumb(K), p.current = y, t.setThumbDragging(d.current, !0), t.setThumbValue(K, M), u(window, "mouseup", m, !1), u(window, "touchend", m, !1), u(window, "pointerup", m, !1)) : d.current = null;
    }
  }, m = (v) => {
    var y, w;
    ((w = v.pointerId) !== null && w !== void 0 ? w : (y = v.changedTouches) === null || y === void 0 ? void 0 : y[0].identifier) === p.current && (d.current != null && (t.setThumbDragging(d.current, !1), d.current = null), s(window, "mouseup", m, !1), s(window, "touchend", m, !1), s(window, "pointerup", m, !1));
  };
  return "htmlFor" in r && r.htmlFor && (delete r.htmlFor, r.onClick = () => {
    var v;
    (v = document.getElementById(ru(t, 0))) === null || v === void 0 || v.focus(), Iu("keyboard");
  }), {
    labelProps: r,
    // The root element of the Slider will have role="group" to group together
    // all the thumb inputs in the Slider.  The label of the Slider will
    // be used to label the group.
    groupProps: {
      role: "group",
      ...a
    },
    trackProps: _({
      onMouseDown(v) {
        v.button !== 0 || v.altKey || v.ctrlKey || v.metaKey || h(v, void 0, v.clientX, v.clientY);
      },
      onPointerDown(v) {
        v.pointerType === "mouse" && (v.button !== 0 || v.altKey || v.ctrlKey || v.metaKey) || h(v, v.pointerId, v.clientX, v.clientY);
      },
      onTouchStart(v) {
        h(v, v.changedTouches[0].identifier, v.changedTouches[0].clientX, v.changedTouches[0].clientY);
      },
      style: {
        position: "relative",
        touchAction: "none"
      }
    }, b),
    outputProps: {
      htmlFor: t.values.map((v, y) => ru(t, y)).join(" "),
      "aria-live": "off"
    }
  };
}
function L0(e, t) {
  let { index: n = 0, isRequired: r, validationState: a, isInvalid: l, trackRef: i, inputRef: o, orientation: u = t.orientation, name: s } = e, d = e.isDisabled || t.isDisabled, c = u === "vertical", { direction: f } = me(), { addGlobalListener: b, removeGlobalListener: p } = yn(), h = as.get(t);
  var m;
  const { labelProps: v, fieldProps: y } = il({
    ...e,
    id: ru(t, n),
    "aria-labelledby": `${h.id} ${(m = e["aria-labelledby"]) !== null && m !== void 0 ? m : ""}`.trim()
  }), w = t.values[n], C = ie(() => {
    o.current && Et(o.current);
  }, [
    o
  ]), D = t.focusedThumb === n;
  re(() => {
    D && C();
  }, [
    D,
    C
  ]);
  let P = f === "rtl", R = j(null), { keyboardProps: V } = la({
    onKeyDown(g) {
      let { getThumbMaxValue: B, getThumbMinValue: k, decrementThumb: I, incrementThumb: O, setThumbValue: F, setThumbDragging: z, pageSize: Z } = t;
      if (!/^(PageUp|PageDown|Home|End)$/.test(g.key)) {
        g.continuePropagation();
        return;
      }
      switch (g.preventDefault(), z(n, !0), g.key) {
        case "PageUp":
          O(n, Z);
          break;
        case "PageDown":
          I(n, Z);
          break;
        case "Home":
          F(n, k(n));
          break;
        case "End":
          F(n, B(n));
          break;
      }
      z(n, !1);
    }
  }), { moveProps: L } = Sr({
    onMoveStart() {
      R.current = null, t.setThumbDragging(n, !0);
    },
    onMove({ deltaX: g, deltaY: B, pointerType: k, shiftKey: I }) {
      const { getThumbPercent: O, setThumbPercent: F, decrementThumb: z, incrementThumb: Z, step: te, pageSize: ue } = t;
      if (!i.current) return;
      let { width: be, height: ce } = i.current.getBoundingClientRect(), X = c ? ce : be;
      if (R.current == null && (R.current = O(n) * X), k === "keyboard")
        g > 0 && P || g < 0 && !P || B > 0 ? z(n, I ? ue : te) : Z(n, I ? ue : te);
      else {
        let pe = c ? B : g;
        (c || P) && (pe = -pe), R.current += pe, F(n, Qe(R.current / X, 0, 1));
      }
    },
    onMoveEnd() {
      t.setThumbDragging(n, !1);
    }
  });
  t.setThumbEditable(n, !d);
  const { focusableProps: A } = un(_(e, {
    onFocus: () => t.setFocusedThumb(n),
    onBlur: () => t.setFocusedThumb(void 0)
  }), o);
  let $ = j(void 0), S = (g) => {
    C(), $.current = g, t.setThumbDragging(n, !0), b(window, "mouseup", T, !1), b(window, "touchend", T, !1), b(window, "pointerup", T, !1);
  }, T = (g) => {
    var B, k;
    ((k = g.pointerId) !== null && k !== void 0 ? k : (B = g.changedTouches) === null || B === void 0 ? void 0 : B[0].identifier) === $.current && (C(), t.setThumbDragging(n, !1), p(window, "mouseup", T, !1), p(window, "touchend", T, !1), p(window, "pointerup", T, !1));
  }, M = t.getThumbPercent(n);
  (c || f === "rtl") && (M = 1 - M);
  let K = d ? {} : _(V, L, {
    onMouseDown: (g) => {
      g.button !== 0 || g.altKey || g.ctrlKey || g.metaKey || S();
    },
    onPointerDown: (g) => {
      g.button !== 0 || g.altKey || g.ctrlKey || g.metaKey || S(g.pointerId);
    },
    onTouchStart: (g) => {
      S(g.changedTouches[0].identifier);
    }
  });
  return zn(o, w, (g) => {
    t.setThumbValue(n, g);
  }), {
    inputProps: _(A, y, {
      type: "range",
      tabIndex: d ? void 0 : 0,
      min: t.getThumbMinValue(n),
      max: t.getThumbMaxValue(n),
      step: t.step,
      value: w,
      name: s,
      disabled: d,
      "aria-orientation": u,
      "aria-valuetext": t.getThumbValueLabel(n),
      "aria-required": r || void 0,
      "aria-invalid": l || a === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-describedby": [
        h["aria-describedby"],
        e["aria-describedby"]
      ].filter(Boolean).join(" "),
      "aria-details": [
        h["aria-details"],
        e["aria-details"]
      ].filter(Boolean).join(" "),
      onChange: (g) => {
        t.setThumbValue(n, parseFloat(g.target.value));
      }
    }),
    thumbProps: {
      ...K,
      style: {
        position: "absolute",
        [c ? "top" : "left"]: `${M * 100}%`,
        transform: "translate(-50%, -50%)",
        touchAction: "none"
      }
    },
    labelProps: v,
    isDragging: t.isThumbDragging(n),
    isDisabled: d,
    isFocused: D
  };
}
function Q2(e, t) {
  let { trackRef: n, inputRef: r, orientation: a, channel: l, "aria-label": i, name: o } = e, { locale: u, direction: s } = me();
  !e.label && !i && !e["aria-labelledby"] && (i = t.value.getChannelName(l, u));
  let { groupProps: d, trackProps: c, labelProps: f, outputProps: b } = j0({
    ...e,
    "aria-label": i
  }, t, n), { inputProps: p, thumbProps: h } = L0({
    index: 0,
    orientation: a,
    isDisabled: e.isDisabled,
    name: o,
    trackRef: n,
    inputRef: r
  }, t), m = t.getDisplayColor(), v = () => {
    let C;
    switch (a === "vertical" ? C = "top" : s === "ltr" ? C = "right" : C = "left", l) {
      case "hue": {
        let D = [
          0,
          60,
          120,
          180,
          240,
          300,
          360
        ].map((P) => m.withChannelValue("hue", P).toString("css")).join(", ");
        return `linear-gradient(to ${C}, ${D})`;
      }
      case "lightness": {
        let D = t.getThumbMinValue(0), P = t.getThumbMaxValue(0), R = m.withChannelValue(l, D).toString("css"), V = m.withChannelValue(l, (P - D) / 2).toString("css"), L = m.withChannelValue(l, P).toString("css");
        return `linear-gradient(to ${C}, ${R}, ${V}, ${L})`;
      }
      case "saturation":
      case "brightness":
      case "red":
      case "green":
      case "blue":
      case "alpha": {
        let D = m.withChannelValue(l, t.getThumbMinValue(0)).toString("css"), P = m.withChannelValue(l, t.getThumbMaxValue(0)).toString("css");
        return `linear-gradient(to ${C}, ${D}, ${P})`;
      }
      default:
        throw new Error("Unknown color channel: " + l);
    }
  }, y = {
    forcedColorAdjust: "none"
  };
  l === "hue" ? p["aria-valuetext"] += `, ${m.getHueName(u)}` : l !== "alpha" && (p["aria-valuetext"] += `, ${m.getColorName(u)}`);
  let { visuallyHiddenProps: w } = sn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  });
  return {
    trackProps: {
      ..._(d, c),
      style: {
        ...c.style,
        ...y,
        background: v()
      }
    },
    inputProps: {
      ...p,
      style: {
        ...p.style,
        ...w.style
      }
    },
    thumbProps: {
      ...h,
      style: {
        ...h.style,
        ...y
      }
    },
    labelProps: f,
    outputProps: b
  };
}
function e7(e, t, n) {
  let { isDisabled: r, innerRadius: a, outerRadius: l, "aria-label": i, name: o } = e, { addGlobalListener: u, removeGlobalListener: s } = yn(), d = (a + l) / 2, c = ie(() => {
    n.current && Et(n.current);
  }, [
    n
  ]);
  zn(n, t.hue, t.setHue);
  let f = j(null), { keyboardProps: b } = la({
    onKeyDown(k) {
      if (!/^(PageUp|PageDown)$/.test(k.key)) {
        k.continuePropagation();
        return;
      }
      switch (k.preventDefault(), t.setDragging(!0), k.key) {
        case "PageUp":
          k.preventDefault(), t.increment(t.pageStep);
          break;
        case "PageDown":
          k.preventDefault(), t.decrement(t.pageStep);
          break;
      }
      t.setDragging(!1);
    }
  }), p = {
    onMoveStart() {
      f.current = null, t.setDragging(!0);
    },
    onMove({ deltaX: k, deltaY: I, pointerType: O, shiftKey: F }) {
      f.current == null && (f.current = t.getThumbPosition(d)), f.current.x += k, f.current.y += I, O === "keyboard" ? k > 0 || I < 0 ? t.increment(F ? t.pageStep : t.step) : (k < 0 || I > 0) && t.decrement(F ? t.pageStep : t.step) : t.setHueFromPoint(f.current.x, f.current.y, d);
    },
    onMoveEnd() {
      v.current = !1, t.setDragging(!1), c();
    }
  }, { moveProps: h } = Sr(p), m = j(void 0), v = j(!1), { moveProps: y } = Sr({
    onMoveStart() {
      v.current && p.onMoveStart();
    },
    onMove(k) {
      v.current && p.onMove(k);
    },
    onMoveEnd() {
      v.current && p.onMoveEnd();
    }
  }), w = (k) => {
    t.isDragging || (m.current = k, c(), t.setDragging(!0), typeof PointerEvent < "u" ? u(window, "pointerup", C, !1) : (u(window, "mouseup", C, !1), u(window, "touchend", C, !1)));
  }, C = (k) => {
    var I, O;
    ((O = k.pointerId) !== null && O !== void 0 ? O : (I = k.changedTouches) === null || I === void 0 ? void 0 : I[0].identifier) === m.current && (c(), t.setDragging(!1), m.current = void 0, v.current = !1, typeof PointerEvent < "u" ? s(window, "pointerup", C, !1) : (s(window, "mouseup", C, !1), s(window, "touchend", C, !1)));
  }, D = (k, I, O, F) => {
    let z = k.getBoundingClientRect(), Z = O - z.x - z.width / 2, te = F - z.y - z.height / 2, ue = Math.sqrt(Z * Z + te * te);
    a < ue && ue < l && !t.isDragging && m.current === void 0 && (v.current = !0, m.current = I, t.setHueFromPoint(Z, te, ue), c(), t.setDragging(!0), typeof PointerEvent < "u" ? u(window, "pointerup", P, !1) : (u(window, "mouseup", P, !1), u(window, "touchend", P, !1)));
  }, P = (k) => {
    var I, O;
    let F = (O = k.pointerId) !== null && O !== void 0 ? O : (I = k.changedTouches) === null || I === void 0 ? void 0 : I[0].identifier;
    v.current && F === m.current && (v.current = !1, m.current = void 0, t.setDragging(!1), c(), typeof PointerEvent < "u" ? s(window, "pointerup", P, !1) : (s(window, "mouseup", P, !1), s(window, "touchend", P, !1)));
  }, R = r ? {} : _({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (k) => {
        k.pointerType === "mouse" && (k.button !== 0 || k.altKey || k.ctrlKey || k.metaKey) || D(k.currentTarget, k.pointerId, k.clientX, k.clientY);
      }
    } : {
      onMouseDown: (k) => {
        k.button !== 0 || k.altKey || k.ctrlKey || k.metaKey || D(k.currentTarget, void 0, k.clientX, k.clientY);
      },
      onTouchStart: (k) => {
        D(k.currentTarget, k.changedTouches[0].identifier, k.changedTouches[0].clientX, k.changedTouches[0].clientY);
      }
    }
  }, y), V = r ? {} : _({
    onMouseDown: (k) => {
      k.button !== 0 || k.altKey || k.ctrlKey || k.metaKey || w(void 0);
    },
    onPointerDown: (k) => {
      k.pointerType === "mouse" && (k.button !== 0 || k.altKey || k.ctrlKey || k.metaKey) || w(k.pointerId);
    },
    onTouchStart: (k) => {
      w(k.changedTouches[0].identifier);
    }
  }, b, h), { x: L, y: A } = t.getThumbPosition(d), { locale: $ } = me();
  i == null && e["aria-labelledby"] == null && (i = t.value.getChannelName("hue", $));
  let S = Ot({
    ...e,
    "aria-label": i
  }), { minValue: T, maxValue: M, step: K } = t.value.getChannelRange("hue"), g = {
    forcedColorAdjust: "none"
  }, { visuallyHiddenProps: B } = sn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  });
  return {
    trackProps: {
      ...R,
      style: {
        position: "relative",
        touchAction: "none",
        width: l * 2,
        height: l * 2,
        background: `
          conic-gradient(
            from 90deg,
            hsl(0, 100%, 50%),
            hsl(30, 100%, 50%),
            hsl(60, 100%, 50%),
            hsl(90, 100%, 50%),
            hsl(120, 100%, 50%),
            hsl(150, 100%, 50%),
            hsl(180, 100%, 50%),
            hsl(210, 100%, 50%),
            hsl(240, 100%, 50%),
            hsl(270, 100%, 50%),
            hsl(300, 100%, 50%),
            hsl(330, 100%, 50%),
            hsl(360, 100%, 50%)
          )
        `,
        clipPath: `path(evenodd, "${Jd(l, l, l)} ${Jd(l, l, a)}")`,
        ...g
      }
    },
    thumbProps: {
      ...V,
      style: {
        position: "absolute",
        left: l + L,
        top: l + A,
        transform: "translate(-50%, -50%)",
        touchAction: "none",
        ...g
      }
    },
    inputProps: _(S, {
      type: "range",
      min: String(T),
      max: String(M),
      step: String(K),
      "aria-valuetext": `${t.value.formatChannelValue("hue", $)}, ${t.value.getHueName($)}`,
      disabled: r,
      value: `${t.value.getChannelValue("hue")}`,
      name: o,
      onChange: (k) => {
        t.setHue(parseFloat(k.target.value));
      },
      style: B.style,
      "aria-errormessage": e["aria-errormessage"],
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"]
    })
  };
}
function Jd(e, t, n) {
  return `M ${e}, ${t} m ${-n}, 0 a ${n}, ${n}, 0, 1, 0, ${n * 2}, 0 a ${n}, ${n}, 0, 1, 0 ${-n * 2}, 0`;
}
function Ei(e, t) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: a = !1, isReadOnly: l = !1, type: i = "text", validationBehavior: o = "aria" } = e, [u, s] = Me(e.value, e.defaultValue || "", e.onChange), { focusableProps: d } = un(e, t), c = en({
    ...e,
    value: u
  }), { isInvalid: f, validationErrors: b, validationDetails: p } = c.displayValidation, { labelProps: h, fieldProps: m, descriptionProps: v, errorMessageProps: y } = or({
    ...e,
    isInvalid: f,
    errorMessage: e.errorMessage || b
  }), w = J(e, {
    labelable: !0
  });
  const C = {
    type: i,
    pattern: e.pattern
  };
  return zn(t, u, s), ll(e, c, t), re(() => {
    if (t.current instanceof vt(t.current).HTMLTextAreaElement) {
      let D = t.current;
      Object.defineProperty(D, "defaultValue", {
        get: () => D.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: h,
    inputProps: _(w, n === "input" ? C : void 0, {
      disabled: r,
      readOnly: l,
      required: a && o === "native",
      "aria-required": a && o === "aria" || void 0,
      "aria-invalid": f || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      "aria-controls": e["aria-controls"],
      value: u,
      onChange: (D) => s(D.target.value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      autoCorrect: e.autoCorrect,
      spellCheck: e.spellCheck,
      [parseInt(x.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: e.enterKeyHint,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...d,
      ...m
    }),
    descriptionProps: v,
    errorMessageProps: y,
    isInvalid: f,
    validationErrors: b,
    validationDetails: p
  };
}
function Qd() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function H0(e, t, n) {
  let r = Re((c) => {
    let f = n.current;
    if (!f) return;
    let b = null;
    switch (c.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        b = f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentForward":
        b = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd + 1) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentBackward":
        b = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart - 1) + f.value.slice(f.selectionStart) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        b = f.value.slice(f.selectionStart);
        break;
      default:
        c.data != null && (b = f.value.slice(0, f.selectionStart) + c.data + f.value.slice(f.selectionEnd));
        break;
    }
    (b == null || !t.validate(b)) && c.preventDefault();
  });
  re(() => {
    if (!Qd() || !n.current) return;
    let c = n.current;
    return c.addEventListener("beforeinput", r, !1), () => {
      c.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n,
    r
  ]);
  let a = Qd() ? null : (c) => {
    let f = c.target.value.slice(0, c.target.selectionStart) + c.data + c.target.value.slice(c.target.selectionEnd);
    t.validate(f) || c.preventDefault();
  }, { labelProps: l, inputProps: i, descriptionProps: o, errorMessageProps: u, ...s } = Ei(e, n), d = j(null);
  return {
    inputProps: _(i, {
      onBeforeInput: a,
      onCompositionStart() {
        let { value: c, selectionStart: f, selectionEnd: b } = n.current;
        d.current = {
          value: c,
          selectionStart: f,
          selectionEnd: b
        };
      },
      onCompositionEnd() {
        if (n.current && !t.validate(n.current.value)) {
          let { value: c, selectionStart: f, selectionEnd: b } = d.current;
          n.current.value = c, n.current.setSelectionRange(f, b), t.setInputValue(c);
        }
      }
    }),
    labelProps: l,
    descriptionProps: o,
    errorMessageProps: u,
    ...s
  };
}
var _0 = {};
_0 = {
  Empty: "فارغ"
};
var U0 = {};
U0 = {
  Empty: "Изпразни"
};
var W0 = {};
W0 = {
  Empty: "Prázdné"
};
var G0 = {};
G0 = {
  Empty: "Tom"
};
var Z0 = {};
Z0 = {
  Empty: "Leer"
};
var Y0 = {};
Y0 = {
  Empty: "Άδειο"
};
var q0 = {};
q0 = {
  Empty: "Empty"
};
var X0 = {};
X0 = {
  Empty: "Vacío"
};
var J0 = {};
J0 = {
  Empty: "Tühjenda"
};
var Q0 = {};
Q0 = {
  Empty: "Tyhjä"
};
var ep = {};
ep = {
  Empty: "Vide"
};
var tp = {};
tp = {
  Empty: "ריק"
};
var np = {};
np = {
  Empty: "Prazno"
};
var rp = {};
rp = {
  Empty: "Üres"
};
var ap = {};
ap = {
  Empty: "Vuoto"
};
var lp = {};
lp = {
  Empty: "空"
};
var ip = {};
ip = {
  Empty: "비어 있음"
};
var op = {};
op = {
  Empty: "Tuščias"
};
var up = {};
up = {
  Empty: "Tukšs"
};
var sp = {};
sp = {
  Empty: "Tom"
};
var dp = {};
dp = {
  Empty: "Leeg"
};
var cp = {};
cp = {
  Empty: "Pusty"
};
var fp = {};
fp = {
  Empty: "Vazio"
};
var bp = {};
bp = {
  Empty: "Vazio"
};
var pp = {};
pp = {
  Empty: "Gol"
};
var hp = {};
hp = {
  Empty: "Не заполнено"
};
var mp = {};
mp = {
  Empty: "Prázdne"
};
var vp = {};
vp = {
  Empty: "Prazen"
};
var gp = {};
gp = {
  Empty: "Prazno"
};
var yp = {};
yp = {
  Empty: "Tomt"
};
var $p = {};
$p = {
  Empty: "Boş"
};
var xp = {};
xp = {
  Empty: "Пусто"
};
var Dp = {};
Dp = {
  Empty: "空"
};
var Cp = {};
Cp = {
  Empty: "空白"
};
var Ep = {};
Ep = {
  "ar-AE": _0,
  "bg-BG": U0,
  "cs-CZ": W0,
  "da-DK": G0,
  "de-DE": Z0,
  "el-GR": Y0,
  "en-US": q0,
  "es-ES": X0,
  "et-EE": J0,
  "fi-FI": Q0,
  "fr-FR": ep,
  "he-IL": tp,
  "hr-HR": np,
  "hu-HU": rp,
  "it-IT": ap,
  "ja-JP": lp,
  "ko-KR": ip,
  "lt-LT": op,
  "lv-LV": up,
  "nb-NO": sp,
  "nl-NL": dp,
  "pl-PL": cp,
  "pt-BR": fp,
  "pt-PT": bp,
  "ro-RO": pp,
  "ru-RU": hp,
  "sk-SK": mp,
  "sl-SI": vp,
  "sr-SP": gp,
  "sv-SE": yp,
  "tr-TR": $p,
  "uk-UA": xp,
  "zh-CN": Dp,
  "zh-TW": Cp
};
function t7(e) {
  return e && e.__esModule ? e.default : e;
}
function ls(e) {
  const t = j(void 0);
  let { value: n, textValue: r, minValue: a, maxValue: l, isDisabled: i, isReadOnly: o, isRequired: u, onIncrement: s, onIncrementPage: d, onDecrement: c, onDecrementPage: f, onDecrementToMin: b, onIncrementToMax: p } = e;
  const h = Oe(t7(Ep), "@react-aria/spinbutton"), m = () => clearTimeout(t.current);
  re(() => () => m(), []);
  let v = ($) => {
    if (!($.ctrlKey || $.metaKey || $.shiftKey || $.altKey || o))
      switch ($.key) {
        case "PageUp":
          if (d) {
            $.preventDefault(), d == null || d();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          s && ($.preventDefault(), s == null || s());
          break;
        case "PageDown":
          if (f) {
            $.preventDefault(), f == null || f();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          c && ($.preventDefault(), c == null || c());
          break;
        case "Home":
          b && ($.preventDefault(), b == null || b());
          break;
        case "End":
          p && ($.preventDefault(), p == null || p());
          break;
      }
  }, y = j(!1), w = () => {
    y.current = !0;
  }, C = () => {
    y.current = !1;
  }, D = r === "" ? h.format("Empty") : (r || `${n}`).replace("-", "−");
  re(() => {
    y.current && (o2("assertive"), hn(D, "assertive"));
  }, [
    D
  ]);
  const P = Re(($) => {
    m(), s == null || s(), t.current = window.setTimeout(() => {
      (l === void 0 || isNaN(l) || n === void 0 || isNaN(n) || n < l) && P(60);
    }, $);
  }), R = Re(($) => {
    m(), c == null || c(), t.current = window.setTimeout(() => {
      (a === void 0 || isNaN(a) || n === void 0 || isNaN(n) || n > a) && R(60);
    }, $);
  });
  let V = ($) => {
    $.preventDefault();
  }, { addGlobalListener: L, removeAllGlobalListeners: A } = yn();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": D,
      "aria-valuemin": a,
      "aria-valuemax": l,
      "aria-disabled": i || void 0,
      "aria-readonly": o || void 0,
      "aria-required": u || void 0,
      onKeyDown: v,
      onFocus: w,
      onBlur: C
    },
    incrementButtonProps: {
      onPressStart: () => {
        P(400), L(window, "contextmenu", V);
      },
      onPressEnd: () => {
        m(), A();
      },
      onFocus: w,
      onBlur: C
    },
    decrementButtonProps: {
      onPressStart: () => {
        R(400), L(window, "contextmenu", V);
      },
      onPressEnd: () => {
        m(), A();
      },
      onFocus: w,
      onBlur: C
    }
  };
}
function n7(e, t, n) {
  let { isDisabled: r, isReadOnly: a, isRequired: l, isWheelDisabled: i, validationBehavior: o = "aria" } = e, { colorValue: u, inputValue: s, increment: d, decrement: c, incrementToMax: f, decrementToMin: b, commit: p } = t, h = Ee(), { spinButtonProps: m } = ls({
    isDisabled: r,
    isReadOnly: a,
    isRequired: l,
    maxValue: 16777215,
    minValue: 0,
    onIncrement: d,
    onIncrementToMax: f,
    onDecrement: c,
    onDecrementToMin: b,
    value: u ? u.toHexInt() : void 0,
    textValue: u ? u.toString("hex") : void 0
  }), [v, y] = q(!1), { focusWithinProps: w } = jt({
    isDisabled: r,
    onFocusWithinChange: y
  }), C = ie((L) => {
    Math.abs(L.deltaY) <= Math.abs(L.deltaX) || (L.deltaY > 0 ? d() : L.deltaY < 0 && c());
  }, [
    c,
    d
  ]);
  cf({
    onScroll: C,
    isDisabled: i || r || a || !v
  }, n);
  let P = (L) => {
    t.validate(L) && t.setInputValue(L);
  }, { inputProps: R, ...V } = H0({
    ...e,
    id: h,
    value: s,
    defaultValue: void 0,
    validate: void 0,
    [mn]: t,
    type: "text",
    autoComplete: "off",
    onChange: P
  }, t, n);
  return R = _(R, m, w, {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false",
    onBlur: p
  }), o === "native" && (R["aria-required"] = void 0), {
    inputProps: R,
    ...V
  };
}
function r7(e) {
  return e && e.__esModule ? e.default : e;
}
function a7(e) {
  let { color: t, colorName: n } = e, r = t || "#fff0", a = H(() => typeof r == "string" ? gt(r) : r, [
    r
  ]), { locale: l } = me(), i = J(e, {
    labelable: !0
  }), o = Oe(r7(ns), "@react-aria/color"), u = Ee(e.id);
  return n || (n = a.getChannelValue("alpha") === 0 ? o.format("transparent") : a.getColorName(l)), {
    colorSwatchProps: {
      ...i,
      role: "img",
      "aria-roledescription": o.format("colorSwatch"),
      "aria-label": [
        n,
        e["aria-label"] || ""
      ].filter(Boolean).join(", "),
      "aria-labelledby": e["aria-labelledby"] ? `${u} ${e["aria-labelledby"]}` : void 0,
      id: u,
      style: {
        backgroundColor: a.toString("css"),
        // @ts-ignore
        forcedColorAdjust: "none"
      }
    },
    color: a || null
  };
}
var wp = {};
wp = {
  decrease: (e) => `خفض ${e.fieldLabel}`,
  increase: (e) => `زيادة ${e.fieldLabel}`,
  numberField: "حقل رقمي"
};
var Pp = {};
Pp = {
  decrease: (e) => `Намаляване ${e.fieldLabel}`,
  increase: (e) => `Усилване ${e.fieldLabel}`,
  numberField: "Номер на полето"
};
var kp = {};
kp = {
  decrease: (e) => `Snížit ${e.fieldLabel}`,
  increase: (e) => `Zvýšit ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Sp = {};
Sp = {
  decrease: (e) => `Reducer ${e.fieldLabel}`,
  increase: (e) => `Øg ${e.fieldLabel}`,
  numberField: "Talfelt"
};
var Bp = {};
Bp = {
  decrease: (e) => `${e.fieldLabel} verringern`,
  increase: (e) => `${e.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var Fp = {};
Fp = {
  decrease: (e) => `Μείωση ${e.fieldLabel}`,
  increase: (e) => `Αύξηση ${e.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var Ap = {};
Ap = {
  decrease: (e) => `Decrease ${e.fieldLabel}`,
  increase: (e) => `Increase ${e.fieldLabel}`,
  numberField: "Number field"
};
var Tp = {};
Tp = {
  decrease: (e) => `Reducir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Rp = {};
Rp = {
  decrease: (e) => `Vähenda ${e.fieldLabel}`,
  increase: (e) => `Suurenda ${e.fieldLabel}`,
  numberField: "Numbri väli"
};
var Mp = {};
Mp = {
  decrease: (e) => `Vähennä ${e.fieldLabel}`,
  increase: (e) => `Lisää ${e.fieldLabel}`,
  numberField: "Numerokenttä"
};
var Np = {};
Np = {
  decrease: (e) => `Diminuer ${e.fieldLabel}`,
  increase: (e) => `Augmenter ${e.fieldLabel}`,
  numberField: "Champ de nombre"
};
var Vp = {};
Vp = {
  decrease: (e) => `הקטן ${e.fieldLabel}`,
  increase: (e) => `הגדל ${e.fieldLabel}`,
  numberField: "שדה מספר"
};
var Ip = {};
Ip = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Op = {};
Op = {
  decrease: (e) => `${e.fieldLabel} csökkentése`,
  increase: (e) => `${e.fieldLabel} növelése`,
  numberField: "Számmező"
};
var zp = {};
zp = {
  decrease: (e) => `Riduci ${e.fieldLabel}`,
  increase: (e) => `Aumenta ${e.fieldLabel}`,
  numberField: "Campo numero"
};
var Kp = {};
Kp = {
  decrease: (e) => `${e.fieldLabel}を縮小`,
  increase: (e) => `${e.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var jp = {};
jp = {
  decrease: (e) => `${e.fieldLabel} 감소`,
  increase: (e) => `${e.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var Lp = {};
Lp = {
  decrease: (e) => `Sumažinti ${e.fieldLabel}`,
  increase: (e) => `Padidinti ${e.fieldLabel}`,
  numberField: "Numerio laukas"
};
var Hp = {};
Hp = {
  decrease: (e) => `Samazināšana ${e.fieldLabel}`,
  increase: (e) => `Palielināšana ${e.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var _p = {};
_p = {
  decrease: (e) => `Reduser ${e.fieldLabel}`,
  increase: (e) => `Øk ${e.fieldLabel}`,
  numberField: "Tallfelt"
};
var Up = {};
Up = {
  decrease: (e) => `${e.fieldLabel} verlagen`,
  increase: (e) => `${e.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var Wp = {};
Wp = {
  decrease: (e) => `Zmniejsz ${e.fieldLabel}`,
  increase: (e) => `Zwiększ ${e.fieldLabel}`,
  numberField: "Pole numeru"
};
var Gp = {};
Gp = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Zp = {};
Zp = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo numérico"
};
var Yp = {};
Yp = {
  decrease: (e) => `Scădere ${e.fieldLabel}`,
  increase: (e) => `Creștere ${e.fieldLabel}`,
  numberField: "Câmp numeric"
};
var qp = {};
qp = {
  decrease: (e) => `Уменьшение ${e.fieldLabel}`,
  increase: (e) => `Увеличение ${e.fieldLabel}`,
  numberField: "Числовое поле"
};
var Xp = {};
Xp = {
  decrease: (e) => `Znížiť ${e.fieldLabel}`,
  increase: (e) => `Zvýšiť ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Jp = {};
Jp = {
  decrease: (e) => `Upadati ${e.fieldLabel}`,
  increase: (e) => `Povečajte ${e.fieldLabel}`,
  numberField: "Številčno polje"
};
var Qp = {};
Qp = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var eh = {};
eh = {
  decrease: (e) => `Minska ${e.fieldLabel}`,
  increase: (e) => `Öka ${e.fieldLabel}`,
  numberField: "Nummerfält"
};
var th = {};
th = {
  decrease: (e) => `${e.fieldLabel} azalt`,
  increase: (e) => `${e.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var nh = {};
nh = {
  decrease: (e) => `Зменшити ${e.fieldLabel}`,
  increase: (e) => `Збільшити ${e.fieldLabel}`,
  numberField: "Поле номера"
};
var rh = {};
rh = {
  decrease: (e) => `降低 ${e.fieldLabel}`,
  increase: (e) => `提高 ${e.fieldLabel}`,
  numberField: "数字字段"
};
var ah = {};
ah = {
  decrease: (e) => `縮小 ${e.fieldLabel}`,
  increase: (e) => `放大 ${e.fieldLabel}`,
  numberField: "數字欄位"
};
var lh = {};
lh = {
  "ar-AE": wp,
  "bg-BG": Pp,
  "cs-CZ": kp,
  "da-DK": Sp,
  "de-DE": Bp,
  "el-GR": Fp,
  "en-US": Ap,
  "es-ES": Tp,
  "et-EE": Rp,
  "fi-FI": Mp,
  "fr-FR": Np,
  "he-IL": Vp,
  "hr-HR": Ip,
  "hu-HU": Op,
  "it-IT": zp,
  "ja-JP": Kp,
  "ko-KR": jp,
  "lt-LT": Lp,
  "lv-LV": Hp,
  "nb-NO": _p,
  "nl-NL": Up,
  "pl-PL": Wp,
  "pt-BR": Gp,
  "pt-PT": Zp,
  "ro-RO": Yp,
  "ru-RU": qp,
  "sk-SK": Xp,
  "sl-SI": Jp,
  "sr-SP": Qp,
  "sv-SE": eh,
  "tr-TR": th,
  "uk-UA": nh,
  "zh-CN": rh,
  "zh-TW": ah
};
function l7(e) {
  return e && e.__esModule ? e.default : e;
}
function ih(e, t, n) {
  let { id: r, decrementAriaLabel: a, incrementAriaLabel: l, isDisabled: i, isReadOnly: o, isRequired: u, minValue: s, maxValue: d, autoFocus: c, label: f, formatOptions: b, onBlur: p = () => {
  }, onFocus: h, onFocusChange: m, onKeyDown: v, onKeyUp: y, description: w, errorMessage: C, isWheelDisabled: D, ...P } = e, { increment: R, incrementToMax: V, decrement: L, decrementToMin: A, numberValue: $, inputValue: S, commit: T, commitValidation: M } = t;
  const K = Oe(l7(lh), "@react-aria/numberfield");
  let g = Ee(r), { focusProps: B } = na({
    onBlur() {
      T();
    }
  }), k = ei(b), I = H(() => k.resolvedOptions(), [
    k
  ]), O = ei({
    ...b,
    currencySign: void 0
  }), F = H(() => isNaN($) ? "" : O.format($), [
    O,
    $
  ]), { spinButtonProps: z, incrementButtonProps: Z, decrementButtonProps: te } = ls({
    isDisabled: i,
    isReadOnly: o,
    isRequired: u,
    maxValue: d,
    minValue: s,
    onIncrement: R,
    onIncrementToMax: V,
    onDecrement: L,
    onDecrementToMin: A,
    value: $,
    textValue: F
  }), [ue, be] = q(!1), { focusWithinProps: ce } = jt({
    isDisabled: i,
    onFocusWithinChange: be
  }), X = ie((pt) => {
    Math.abs(pt.deltaY) <= Math.abs(pt.deltaX) || (pt.deltaY > 0 ? R() : pt.deltaY < 0 && L());
  }, [
    L,
    R
  ]);
  cf({
    onScroll: X,
    isDisabled: D || i || o || !ue
  }, n);
  var ve;
  let W = ((ve = I.maximumFractionDigits) !== null && ve !== void 0 ? ve : 0) > 0, se = t.minValue === void 0 || isNaN(t.minValue) || t.minValue < 0, fe = "numeric";
  Yc() ? se ? fe = "text" : W && (fe = "decimal") : Er() && (se ? fe = "numeric" : W && (fe = "decimal"));
  let We = (pt) => {
    t.validate(pt) && t.setInputValue(pt);
  }, ye = J(e), st = ie((pt) => {
    pt.key === "Enter" ? (T(), M()) : pt.continuePropagation();
  }, [
    T,
    M
  ]), { isInvalid: $t, validationErrors: Q, validationDetails: ae } = t.displayValidation, { labelProps: ge, inputProps: Se, descriptionProps: xt, errorMessageProps: cr } = H0({
    ...P,
    ...ye,
    name: void 0,
    label: f,
    autoFocus: c,
    isDisabled: i,
    isReadOnly: o,
    isRequired: u,
    validate: void 0,
    [mn]: t,
    value: S,
    defaultValue: void 0,
    autoComplete: "off",
    "aria-label": e["aria-label"] || void 0,
    "aria-labelledby": e["aria-labelledby"] || void 0,
    id: g,
    type: "text",
    inputMode: fe,
    onChange: We,
    onBlur: p,
    onFocus: h,
    onFocusChange: m,
    onKeyDown: H(() => At(st, v), [
      st,
      v
    ]),
    onKeyUp: y,
    description: w,
    errorMessage: C
  }, t, n);
  zn(n, t.numberValue, t.setNumberValue);
  let Hn = _(z, B, Se, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": Ar() ? null : K.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  e.validationBehavior === "native" && (Hn["aria-required"] = void 0);
  let Vt = (pt) => {
    var pr;
    document.activeElement !== n.current && (pt.pointerType === "mouse" ? (pr = n.current) === null || pr === void 0 || pr.focus() : pt.target.focus());
  }, _t = e["aria-label"] || (typeof e.label == "string" ? e.label : ""), It;
  _t || (It = e.label != null ? ge.id : e["aria-labelledby"]);
  let fr = Ee(), _n = Ee(), br = _(Z, {
    "aria-label": l || K.format("increase", {
      fieldLabel: _t
    }).trim(),
    id: It && !l ? fr : null,
    "aria-labelledby": It && !l ? `${fr} ${It}` : null,
    "aria-controls": g,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canIncrement,
    onPressStart: Vt
  }), pa = _(te, {
    "aria-label": a || K.format("decrease", {
      fieldLabel: _t
    }).trim(),
    id: It && !a ? _n : null,
    "aria-labelledby": It && !a ? `${_n} ${It}` : null,
    "aria-controls": g,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canDecrement,
    onPressStart: Vt
  });
  return {
    groupProps: {
      ...ce,
      role: "group",
      "aria-disabled": i,
      "aria-invalid": $t ? "true" : void 0
    },
    labelProps: ge,
    inputProps: Hn,
    incrementButtonProps: br,
    decrementButtonProps: pa,
    errorMessageProps: cr,
    descriptionProps: xt,
    isInvalid: $t,
    validationErrors: Q,
    validationDetails: ae
  };
}
function i7(e, t, n) {
  let { locale: r } = me();
  return ih({
    ...e,
    value: void 0,
    defaultValue: void 0,
    onChange: void 0,
    validate: void 0,
    // Provide a default aria-label if no other label is provided.
    "aria-label": e["aria-label"] || (e.label || e["aria-labelledby"] ? void 0 : t.colorValue.getChannelName(e.channel, r))
  }, t, n);
}
var oh = {};
oh = {
  buttonLabel: "عرض المقترحات",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} خيار`,
    other: () => `${t.number(e.optionCount)} خيارات`
  })} متاحة.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `المجموعة المدخلة ${e.groupTitle}, مع ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} خيار`,
      other: () => `${t.number(e.groupCount)} خيارات`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", محدد",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "مقترحات",
  selectedAnnouncement: (e) => `${e.optionText}، محدد`
};
var uh = {};
uh = {
  buttonLabel: "Покажи предложения",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} опция`,
    other: () => `${t.number(e.optionCount)} опции`
  })} на разположение.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Въведена група ${e.groupTitle}, с ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} опция`,
      other: () => `${t.number(e.groupCount)} опции`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", избрани",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Предложения",
  selectedAnnouncement: (e) => `${e.optionText}, избрани`
};
var sh = {};
sh = {
  buttonLabel: "Zobrazit doporučení",
  countAnnouncement: (e, t) => `K dispozici ${t.plural(e.optionCount, {
    one: () => `je ${t.number(e.optionCount)} možnost`,
    other: () => `jsou/je ${t.number(e.optionCount)} možnosti/-í`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Zadaná skupina „${e.groupTitle}“ ${t.plural(e.groupCount, {
      one: () => `s ${t.number(e.groupCount)} možností`,
      other: () => `se ${t.number(e.groupCount)} možnostmi`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: " (vybráno)",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Návrhy",
  selectedAnnouncement: (e) => `${e.optionText}, vybráno`
};
var dh = {};
dh = {
  buttonLabel: "Vis forslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} mulighed tilgængelig`,
    other: () => `${t.number(e.optionCount)} muligheder tilgængelige`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Angivet gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} mulighed`,
      other: () => `${t.number(e.groupCount)} muligheder`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valgt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Forslag",
  selectedAnnouncement: (e) => `${e.optionText}, valgt`
};
var ch = {};
ch = {
  buttonLabel: "Empfehlungen anzeigen",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} Option`,
    other: () => `${t.number(e.optionCount)} Optionen`
  })} verfügbar.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Eingetretene Gruppe ${e.groupTitle}, mit ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} Option`,
      other: () => `${t.number(e.groupCount)} Optionen`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", ausgewählt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Empfehlungen",
  selectedAnnouncement: (e) => `${e.optionText}, ausgewählt`
};
var fh = {};
fh = {
  buttonLabel: "Προβολή προτάσεων",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} επιλογή`,
    other: () => `${t.number(e.optionCount)} επιλογές `
  })} διαθέσιμες.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Εισαγμένη ομάδα ${e.groupTitle}, με ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} επιλογή`,
      other: () => `${t.number(e.groupCount)} επιλογές`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", επιλεγμένο",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Προτάσεις",
  selectedAnnouncement: (e) => `${e.optionText}, επιλέχθηκε`
};
var bh = {};
bh = {
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Entered group ${e.groupTitle}, with ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} option`,
      other: () => `${t.number(e.groupCount)} options`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selected",
    other: ""
  }, e.isSelected)}`,
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} option`,
    other: () => `${t.number(e.optionCount)} options`
  })} available.`,
  selectedAnnouncement: (e) => `${e.optionText}, selected`,
  buttonLabel: "Show suggestions",
  listboxLabel: "Suggestions"
};
var ph = {};
ph = {
  buttonLabel: "Mostrar sugerencias",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opción`,
    other: () => `${t.number(e.optionCount)} opciones`
  })} disponible(s).`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Se ha unido al grupo ${e.groupTitle}, con ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opción`,
      other: () => `${t.number(e.groupCount)} opciones`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", seleccionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugerencias",
  selectedAnnouncement: (e) => `${e.optionText}, seleccionado`
};
var hh = {};
hh = {
  buttonLabel: "Kuva soovitused",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} valik`,
    other: () => `${t.number(e.optionCount)} valikud`
  })} saadaval.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Sisestatud rühm ${e.groupTitle}, valikuga ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} valik`,
      other: () => `${t.number(e.groupCount)} valikud`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valitud",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Soovitused",
  selectedAnnouncement: (e) => `${e.optionText}, valitud`
};
var mh = {};
mh = {
  buttonLabel: "Näytä ehdotukset",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} vaihtoehto`,
    other: () => `${t.number(e.optionCount)} vaihtoehdot`
  })} saatavilla.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Mentiin ryhmään ${e.groupTitle}, ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} vaihtoehdon`,
      other: () => `${t.number(e.groupCount)} vaihtoehdon`
    })} kanssa.`,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valittu",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Ehdotukset",
  selectedAnnouncement: (e) => `${e.optionText}, valittu`
};
var vh = {};
vh = {
  buttonLabel: "Afficher les suggestions",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} option`,
    other: () => `${t.number(e.optionCount)} options`
  })} disponible(s).`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Groupe ${e.groupTitle} rejoint, avec ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} option`,
      other: () => `${t.number(e.groupCount)} options`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", sélectionné(s)",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggestions",
  selectedAnnouncement: (e) => `${e.optionText}, sélectionné`
};
var gh = {};
gh = {
  buttonLabel: "הצג הצעות",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `אפשרות ${t.number(e.optionCount)}`,
    other: () => `${t.number(e.optionCount)} אפשרויות`
  })} במצב זמין.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `נכנס לקבוצה ${e.groupTitle}, עם ${t.plural(e.groupCount, {
      one: () => `אפשרות ${t.number(e.groupCount)}`,
      other: () => `${t.number(e.groupCount)} אפשרויות`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", נבחר",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "הצעות",
  selectedAnnouncement: (e) => `${e.optionText}, נבחר`
};
var yh = {};
yh = {
  buttonLabel: "Prikaži prijedloge",
  countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije/a`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Unesena skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcijom`,
      other: () => `${t.number(e.groupCount)} opcije/a`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", odabranih",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Prijedlozi",
  selectedAnnouncement: (e) => `${e.optionText}, odabrano`
};
var $h = {};
$h = {
  buttonLabel: "Javaslatok megjelenítése",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} lehetőség`,
    other: () => `${t.number(e.optionCount)} lehetőség`
  })} áll rendelkezésre.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Belépett a(z) ${e.groupTitle} csoportba, amely ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} lehetőséget`,
      other: () => `${t.number(e.groupCount)} lehetőséget`
    })} tartalmaz. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", kijelölve",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Javaslatok",
  selectedAnnouncement: (e) => `${e.optionText}, kijelölve`
};
var xh = {};
xh = {
  buttonLabel: "Mostra suggerimenti",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opzione disponibile`,
    other: () => `${t.number(e.optionCount)} opzioni disponibili`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ingresso nel gruppo ${e.groupTitle}, con ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opzione`,
      other: () => `${t.number(e.groupCount)} opzioni`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selezionato",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggerimenti",
  selectedAnnouncement: (e) => `${e.optionText}, selezionato`
};
var Dh = {};
Dh = {
  buttonLabel: "候補を表示",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 個のオプション`,
    other: () => `${t.number(e.optionCount)} 個のオプション`
  })}を利用できます。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `入力されたグループ ${e.groupTitle}、${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 個のオプション`,
      other: () => `${t.number(e.groupCount)} 個のオプション`
    })}を含む。`,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: "、選択済み",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "候補",
  selectedAnnouncement: (e) => `${e.optionText}、選択済み`
};
var Ch = {};
Ch = {
  buttonLabel: "제안 사항 표시",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)}개 옵션`,
    other: () => `${t.number(e.optionCount)}개 옵션`
  })}을 사용할 수 있습니다.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `입력한 그룹 ${e.groupTitle}, ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)}개 옵션`,
      other: () => `${t.number(e.groupCount)}개 옵션`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 선택됨",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "제안",
  selectedAnnouncement: (e) => `${e.optionText}, 선택됨`
};
var Eh = {};
Eh = {
  buttonLabel: "Rodyti pasiūlymus",
  countAnnouncement: (e, t) => `Yra ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} parinktis`,
    other: () => `${t.number(e.optionCount)} parinktys (-ių)`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Įvesta grupė ${e.groupTitle}, su ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} parinktimi`,
      other: () => `${t.number(e.groupCount)} parinktimis (-ių)`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", pasirinkta",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Pasiūlymai",
  selectedAnnouncement: (e) => `${e.optionText}, pasirinkta`
};
var wh = {};
wh = {
  buttonLabel: "Rādīt ieteikumus",
  countAnnouncement: (e, t) => `Pieejamo opciju skaits: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcijas`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ievadīta grupa ${e.groupTitle}, ar ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opciju`,
      other: () => `${t.number(e.groupCount)} opcijām`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", atlasīta",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Ieteikumi",
  selectedAnnouncement: (e) => `${e.optionText}, atlasīta`
};
var Ph = {};
Ph = {
  buttonLabel: "Vis forslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} alternativ`,
    other: () => `${t.number(e.optionCount)} alternativer`
  })} finnes.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Angitt gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} alternativ`,
      other: () => `${t.number(e.groupCount)} alternativer`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valgt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Forslag",
  selectedAnnouncement: (e) => `${e.optionText}, valgt`
};
var kh = {};
kh = {
  buttonLabel: "Suggesties weergeven",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} optie`,
    other: () => `${t.number(e.optionCount)} opties`
  })} beschikbaar.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Groep ${e.groupTitle} ingevoerd met ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} optie`,
      other: () => `${t.number(e.groupCount)} opties`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", geselecteerd",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggesties",
  selectedAnnouncement: (e) => `${e.optionText}, geselecteerd`
};
var Sh = {};
Sh = {
  buttonLabel: "Wyświetlaj sugestie",
  countAnnouncement: (e, t) => `dostępna/dostępne(-nych) ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcja`,
    other: () => `${t.number(e.optionCount)} opcje(-i)`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Dołączono do grupy ${e.groupTitle}, z ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcją`,
      other: () => `${t.number(e.groupCount)} opcjami`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", wybrano",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestie",
  selectedAnnouncement: (e) => `${e.optionText}, wybrano`
};
var Bh = {};
Bh = {
  buttonLabel: "Mostrar sugestões",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opção`,
    other: () => `${t.number(e.optionCount)} opções`
  })} disponível.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grupo inserido ${e.groupTitle}, com ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opção`,
      other: () => `${t.number(e.groupCount)} opções`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selecionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestões",
  selectedAnnouncement: (e) => `${e.optionText}, selecionado`
};
var Fh = {};
Fh = {
  buttonLabel: "Apresentar sugestões",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opção`,
    other: () => `${t.number(e.optionCount)} opções`
  })} disponível.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grupo introduzido ${e.groupTitle}, com ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opção`,
      other: () => `${t.number(e.groupCount)} opções`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selecionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestões",
  selectedAnnouncement: (e) => `${e.optionText}, selecionado`
};
var Ah = {};
Ah = {
  buttonLabel: "Afișare sugestii",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opțiune`,
    other: () => `${t.number(e.optionCount)} opțiuni`
  })} disponibile.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grup ${e.groupTitle} introdus, cu ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opțiune`,
      other: () => `${t.number(e.groupCount)} opțiuni`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selectat",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestii",
  selectedAnnouncement: (e) => `${e.optionText}, selectat`
};
var Th = {};
Th = {
  buttonLabel: "Показать предложения",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} параметр`,
    other: () => `${t.number(e.optionCount)} параметров`
  })} доступно.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Введенная группа ${e.groupTitle}, с ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} параметром`,
      other: () => `${t.number(e.groupCount)} параметрами`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", выбранными",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Предложения",
  selectedAnnouncement: (e) => `${e.optionText}, выбрано`
};
var Rh = {};
Rh = {
  buttonLabel: "Zobraziť návrhy",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} možnosť`,
    other: () => `${t.number(e.optionCount)} možnosti/-í`
  })} k dispozícii.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Zadaná skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} možnosťou`,
      other: () => `${t.number(e.groupCount)} možnosťami`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", vybraté",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Návrhy",
  selectedAnnouncement: (e) => `${e.optionText}, vybraté`
};
var Mh = {};
Mh = {
  buttonLabel: "Prikaži predloge",
  countAnnouncement: (e, t) => `Na voljo je ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Vnesena skupina ${e.groupTitle}, z ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcija`,
      other: () => `${t.number(e.groupCount)} opcije`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", izbrano",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Predlogi",
  selectedAnnouncement: (e) => `${e.optionText}, izbrano`
};
var Nh = {};
Nh = {
  buttonLabel: "Prikaži predloge",
  countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije/a`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Unesena grupa ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcijom`,
      other: () => `${t.number(e.groupCount)} optione/a`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", izabranih",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Predlozi",
  selectedAnnouncement: (e) => `${e.optionText}, izabrano`
};
var Vh = {};
Vh = {
  buttonLabel: "Visa förslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} alternativ`,
    other: () => `${t.number(e.optionCount)} alternativ`
  })} tillgängliga.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ingick i gruppen ${e.groupTitle} med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} alternativ`,
      other: () => `${t.number(e.groupCount)} alternativ`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valda",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Förslag",
  selectedAnnouncement: (e) => `${e.optionText}, valda`
};
var Ih = {};
Ih = {
  buttonLabel: "Önerileri göster",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} seçenek`,
    other: () => `${t.number(e.optionCount)} seçenekler`
  })} kullanılabilir.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Girilen grup ${e.groupTitle}, ile ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} seçenek`,
      other: () => `${t.number(e.groupCount)} seçenekler`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", seçildi",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Öneriler",
  selectedAnnouncement: (e) => `${e.optionText}, seçildi`
};
var Oh = {};
Oh = {
  buttonLabel: "Показати пропозиції",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} параметр`,
    other: () => `${t.number(e.optionCount)} параметри(-ів)`
  })} доступно.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Введена група ${e.groupTitle}, з ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} параметр`,
      other: () => `${t.number(e.groupCount)} параметри(-ів)`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", вибрано",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Пропозиції",
  selectedAnnouncement: (e) => `${e.optionText}, вибрано`
};
var zh = {};
zh = {
  buttonLabel: "显示建议",
  countAnnouncement: (e, t) => `有 ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 个选项`,
    other: () => `${t.number(e.optionCount)} 个选项`
  })}可用。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `进入了 ${e.groupTitle} 组，其中有 ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 个选项`,
      other: () => `${t.number(e.groupCount)} 个选项`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 已选择",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "建议",
  selectedAnnouncement: (e) => `${e.optionText}, 已选择`
};
var Kh = {};
Kh = {
  buttonLabel: "顯示建議",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 選項`,
    other: () => `${t.number(e.optionCount)} 選項`
  })} 可用。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `輸入的群組 ${e.groupTitle}, 有 ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 選項`,
      other: () => `${t.number(e.groupCount)} 選項`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 已選取",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "建議",
  selectedAnnouncement: (e) => `${e.optionText}, 已選取`
};
var jh = {};
jh = {
  "ar-AE": oh,
  "bg-BG": uh,
  "cs-CZ": sh,
  "da-DK": dh,
  "de-DE": ch,
  "el-GR": fh,
  "en-US": bh,
  "es-ES": ph,
  "et-EE": hh,
  "fi-FI": mh,
  "fr-FR": vh,
  "he-IL": gh,
  "hr-HR": yh,
  "hu-HU": $h,
  "it-IT": xh,
  "ja-JP": Dh,
  "ko-KR": Ch,
  "lt-LT": Eh,
  "lv-LV": wh,
  "nb-NO": Ph,
  "nl-NL": kh,
  "pl-PL": Sh,
  "pt-BR": Bh,
  "pt-PT": Fh,
  "ro-RO": Ah,
  "ru-RU": Th,
  "sk-SK": Rh,
  "sl-SI": Mh,
  "sr-SP": Nh,
  "sv-SE": Vh,
  "tr-TR": Ih,
  "uk-UA": Oh,
  "zh-CN": zh,
  "zh-TW": Kh
};
const bn = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, ri = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, o7 = {
  top: "left",
  left: "top"
}, au = {
  top: "height",
  left: "width"
}, Lh = {
  width: "totalWidth",
  height: "totalHeight"
}, kl = {};
let ct = typeof document < "u" ? window.visualViewport : null;
function ec(e) {
  let t = 0, n = 0, r = 0, a = 0, l = 0, i = 0, o = {};
  var u;
  let s = ((u = ct == null ? void 0 : ct.scale) !== null && u !== void 0 ? u : 1) > 1;
  if (e.tagName === "BODY") {
    let p = document.documentElement;
    r = p.clientWidth, a = p.clientHeight;
    var d;
    t = (d = ct == null ? void 0 : ct.width) !== null && d !== void 0 ? d : r;
    var c;
    n = (c = ct == null ? void 0 : ct.height) !== null && c !== void 0 ? c : a, o.top = p.scrollTop || e.scrollTop, o.left = p.scrollLeft || e.scrollLeft, ct && (l = ct.offsetTop, i = ct.offsetLeft);
  } else
    ({ width: t, height: n, top: l, left: i } = qr(e)), o.top = e.scrollTop, o.left = e.scrollLeft, r = t, a = n;
  if (Fu() && (e.tagName === "BODY" || e.tagName === "HTML") && s) {
    o.top = 0, o.left = 0;
    var f;
    l = (f = ct == null ? void 0 : ct.pageTop) !== null && f !== void 0 ? f : 0;
    var b;
    i = (b = ct == null ? void 0 : ct.pageLeft) !== null && b !== void 0 ? b : 0;
  }
  return {
    width: t,
    height: n,
    totalWidth: r,
    totalHeight: a,
    scroll: o,
    top: l,
    left: i
  };
}
function u7(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function tc(e, t, n, r, a, l, i) {
  var o;
  let u = (o = a.scroll[e]) !== null && o !== void 0 ? o : 0, s = r[au[e]], d = r.scroll[bn[e]] + l, c = s + r.scroll[bn[e]] - l, f = t - u + i[e] - r[bn[e]], b = t - u + n + i[e] - r[bn[e]];
  return f < d ? d - f : b > c ? Math.max(c - b, d - f) : 0;
}
function s7(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function nc(e) {
  if (kl[e]) return kl[e];
  let [t, n] = e.split(" "), r = bn[t] || "right", a = o7[r];
  bn[n] || (n = "center");
  let l = au[r], i = au[a];
  return kl[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: a,
    size: l,
    crossSize: i
  }, kl[e];
}
function xo(e, t, n, r, a, l, i, o, u, s) {
  let { placement: d, crossPlacement: c, axis: f, crossAxis: b, size: p, crossSize: h } = r, m = {};
  var v;
  m[b] = (v = e[b]) !== null && v !== void 0 ? v : 0;
  var y, w, C, D;
  c === "center" ? m[b] += (((y = e[h]) !== null && y !== void 0 ? y : 0) - ((w = n[h]) !== null && w !== void 0 ? w : 0)) / 2 : c !== b && (m[b] += ((C = e[h]) !== null && C !== void 0 ? C : 0) - ((D = n[h]) !== null && D !== void 0 ? D : 0)), m[b] += l;
  const P = e[b] - n[h] + u + s, R = e[b] + e[h] - u - s;
  if (m[b] = Qe(m[b], P, R), d === f) {
    const V = o ? i[p] : t[Lh[p]];
    m[ri[f]] = Math.floor(V - e[f] + a);
  } else m[f] = Math.floor(e[f] + e[p] + a);
  return m;
}
function d7(e, t, n, r, a, l, i, o) {
  const u = r ? n.height : t[Lh.height];
  var s;
  let d = e.top != null ? n.top + e.top : n.top + (u - ((s = e.bottom) !== null && s !== void 0 ? s : 0) - i);
  var c, f, b, p, h, m;
  let v = o !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, t.height + t.top + ((c = t.scroll.top) !== null && c !== void 0 ? c : 0) - d - (((f = a.top) !== null && f !== void 0 ? f : 0) + ((b = a.bottom) !== null && b !== void 0 ? b : 0) + l))
  ) : Math.max(0, d + i - (t.top + ((p = t.scroll.top) !== null && p !== void 0 ? p : 0)) - (((h = a.top) !== null && h !== void 0 ? h : 0) + ((m = a.bottom) !== null && m !== void 0 ? m : 0) + l));
  return Math.min(t.height - l * 2, v);
}
function rc(e, t, n, r, a, l) {
  let { placement: i, axis: o, size: u } = l;
  var s, d;
  if (i === o) return Math.max(0, n[o] - e[o] - ((s = e.scroll[o]) !== null && s !== void 0 ? s : 0) + t[o] - ((d = r[o]) !== null && d !== void 0 ? d : 0) - r[ri[o]] - a);
  var c;
  return Math.max(0, e[u] + e[o] + e.scroll[o] - t[o] - n[o] - n[u] - ((c = r[o]) !== null && c !== void 0 ? c : 0) - r[ri[o]] - a);
}
function c7(e, t, n, r, a, l, i, o, u, s, d, c, f, b, p, h) {
  let m = nc(e), { size: v, crossAxis: y, crossSize: w, placement: C, crossPlacement: D } = m, P = xo(t, o, n, m, d, c, s, f, p, h), R = d, V = rc(o, s, t, a, l + d, m);
  if (i && r[v] > V) {
    let te = nc(`${ri[C]} ${D}`), ue = xo(t, o, n, te, d, c, s, f, p, h);
    rc(o, s, t, a, l + d, te) > V && (m = te, P = ue, R = d);
  }
  let L = "bottom";
  m.axis === "top" ? m.placement === "top" ? L = "top" : m.placement === "bottom" && (L = "bottom") : m.crossAxis === "top" && (m.crossPlacement === "top" ? L = "bottom" : m.crossPlacement === "bottom" && (L = "top"));
  let A = tc(y, P[y], n[w], o, u, l, s);
  P[y] += A;
  let $ = d7(P, o, s, f, a, l, n.height, L);
  b && b < $ && ($ = b), n.height = Math.min(n.height, $), P = xo(t, o, n, m, R, c, s, f, p, h), A = tc(y, P[y], n[w], o, u, l, s), P[y] += A;
  let S = {}, T = t[y] + 0.5 * t[w] - P[y] - a[bn[y]];
  const M = p / 2 + h;
  var K, g, B, k;
  const I = bn[y] === "left" ? ((K = a.left) !== null && K !== void 0 ? K : 0) + ((g = a.right) !== null && g !== void 0 ? g : 0) : ((B = a.top) !== null && B !== void 0 ? B : 0) + ((k = a.bottom) !== null && k !== void 0 ? k : 0), O = n[w] - I - p / 2 - h, F = t[y] + p / 2 - (P[y] + a[bn[y]]), z = t[y] + t[w] - p / 2 - (P[y] + a[bn[y]]), Z = Qe(T, F, z);
  return S[y] = Qe(Z, M, O), {
    position: P,
    maxHeight: $,
    arrowOffsetLeft: S.left,
    arrowOffsetTop: S.top,
    placement: m.placement
  };
}
function f7(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: a, padding: l, shouldFlip: i, boundaryElement: o, offset: u, crossOffset: s, maxHeight: d, arrowSize: c = 0, arrowBoundaryOffset: f = 0 } = e, b = r instanceof HTMLElement ? b7(r) : document.documentElement, p = b === document.documentElement;
  const h = window.getComputedStyle(b).position;
  let m = !!h && h !== "static", v = p ? qr(n) : ac(n, b);
  if (!p) {
    let { marginTop: S, marginLeft: T } = window.getComputedStyle(n);
    v.top += parseInt(S, 10) || 0, v.left += parseInt(T, 10) || 0;
  }
  let y = qr(r), w = s7(r);
  var C, D;
  y.width += ((C = w.left) !== null && C !== void 0 ? C : 0) + ((D = w.right) !== null && D !== void 0 ? D : 0);
  var P, R;
  y.height += ((P = w.top) !== null && P !== void 0 ? P : 0) + ((R = w.bottom) !== null && R !== void 0 ? R : 0);
  let V = u7(a), L = ec(o), A = ec(b), $ = o.tagName === "BODY" ? qr(b) : ac(b, o);
  return b.tagName === "HTML" && o.tagName === "BODY" && (A.scroll.top = 0, A.scroll.left = 0), c7(t, v, y, V, w, l, i, L, A, $, u, s, m, d, c, f);
}
function qr(e) {
  let { top: t, left: n, width: r, height: a } = e.getBoundingClientRect(), { scrollTop: l, scrollLeft: i, clientTop: o, clientLeft: u } = document.documentElement;
  return {
    top: t + l - o,
    left: n + i - u,
    width: r,
    height: a
  };
}
function ac(e, t) {
  let n = window.getComputedStyle(e), r;
  if (n.position === "fixed") {
    let { top: a, left: l, width: i, height: o } = e.getBoundingClientRect();
    r = {
      top: a,
      left: l,
      width: i,
      height: o
    };
  } else {
    r = qr(e);
    let a = qr(t), l = window.getComputedStyle(t);
    a.top += (parseInt(l.borderTopWidth, 10) || 0) - t.scrollTop, a.left += (parseInt(l.borderLeftWidth, 10) || 0) - t.scrollLeft, r.top -= a.top, r.left -= a.left;
  }
  return r.top -= parseInt(n.marginTop, 10) || 0, r.left -= parseInt(n.marginLeft, 10) || 0, r;
}
function b7(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !lc(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !lc(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function lc(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const Hh = /* @__PURE__ */ new WeakMap();
function p7(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  re(() => {
    if (!n || r === null) return;
    let a = (l) => {
      let i = l.target;
      if (!t.current || i instanceof Node && !i.contains(t.current) || l.target instanceof HTMLInputElement || l.target instanceof HTMLTextAreaElement) return;
      let o = r || Hh.get(t.current);
      o && o();
    };
    return window.addEventListener("scroll", a, !0), () => {
      window.removeEventListener("scroll", a, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
let qe = typeof document < "u" ? window.visualViewport : null;
function _h(e) {
  let { direction: t } = me(), { arrowSize: n = 0, targetRef: r, overlayRef: a, scrollRef: l = a, placement: i = "bottom", containerPadding: o = 12, shouldFlip: u = !0, boundaryElement: s = typeof document < "u" ? document.body : null, offset: d = 0, crossOffset: c = 0, shouldUpdatePosition: f = !0, isOpen: b = !0, onClose: p, maxHeight: h, arrowBoundaryOffset: m = 0 } = e, [v, y] = q(null), w = [
    f,
    i,
    a.current,
    r.current,
    l.current,
    o,
    u,
    s,
    d,
    c,
    b,
    t,
    h,
    m,
    n
  ], C = j(qe == null ? void 0 : qe.scale);
  re(() => {
    b && (C.current = qe == null ? void 0 : qe.scale);
  }, [
    b
  ]);
  let D = ie(() => {
    if (f === !1 || !b || !a.current || !r.current || !s || (qe == null ? void 0 : qe.scale) !== C.current) return;
    let A = null;
    if (l.current && l.current.contains(document.activeElement)) {
      var $;
      let k = ($ = document.activeElement) === null || $ === void 0 ? void 0 : $.getBoundingClientRect(), I = l.current.getBoundingClientRect();
      var S;
      if (A = {
        type: "top",
        offset: ((S = k == null ? void 0 : k.top) !== null && S !== void 0 ? S : 0) - I.top
      }, A.offset > I.height / 2) {
        A.type = "bottom";
        var T;
        A.offset = ((T = k == null ? void 0 : k.bottom) !== null && T !== void 0 ? T : 0) - I.bottom;
      }
    }
    let M = a.current;
    if (!h && a.current) {
      var K;
      M.style.top = "0px", M.style.bottom = "";
      var g;
      M.style.maxHeight = ((g = (K = window.visualViewport) === null || K === void 0 ? void 0 : K.height) !== null && g !== void 0 ? g : window.innerHeight) + "px";
    }
    let B = f7({
      placement: m7(i, t),
      overlayNode: a.current,
      targetNode: r.current,
      scrollNode: l.current || a.current,
      padding: o,
      shouldFlip: u,
      boundaryElement: s,
      offset: d,
      crossOffset: c,
      maxHeight: h,
      arrowSize: n,
      arrowBoundaryOffset: m
    });
    if (B.position) {
      if (M.style.top = "", M.style.bottom = "", M.style.left = "", M.style.right = "", Object.keys(B.position).forEach((k) => M.style[k] = B.position[k] + "px"), M.style.maxHeight = B.maxHeight != null ? B.maxHeight + "px" : "", A && document.activeElement && l.current) {
        let k = document.activeElement.getBoundingClientRect(), I = l.current.getBoundingClientRect(), O = k[A.type] - I[A.type];
        l.current.scrollTop += O - A.offset;
      }
      y(B);
    }
  }, w);
  Ce(D, w), h7(D), Pr({
    ref: a,
    onResize: D
  }), Pr({
    ref: r,
    onResize: D
  });
  let P = j(!1);
  Ce(() => {
    let A, $ = () => {
      P.current = !0, clearTimeout(A), A = setTimeout(() => {
        P.current = !1;
      }, 500), D();
    }, S = () => {
      P.current && $();
    };
    return qe == null || qe.addEventListener("resize", $), qe == null || qe.addEventListener("scroll", S), () => {
      qe == null || qe.removeEventListener("resize", $), qe == null || qe.removeEventListener("scroll", S);
    };
  }, [
    D
  ]);
  let R = ie(() => {
    P.current || p == null || p();
  }, [
    p,
    P
  ]);
  p7({
    triggerRef: r,
    isOpen: b,
    onClose: p && R
  });
  var V, L;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...v == null ? void 0 : v.position,
        maxHeight: (V = v == null ? void 0 : v.maxHeight) !== null && V !== void 0 ? V : "100vh"
      }
    },
    placement: (L = v == null ? void 0 : v.placement) !== null && L !== void 0 ? L : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: v == null ? void 0 : v.arrowOffsetLeft,
        top: v == null ? void 0 : v.arrowOffsetTop
      }
    },
    updatePosition: D
  };
}
function h7(e) {
  Ce(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function m7(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
const cn = [];
function Uh(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: a, isDismissable: l = !1, isKeyboardDismissDisabled: i = !1, shouldCloseOnInteractOutside: o } = e;
  re(() => {
    if (a && !cn.includes(t))
      return cn.push(t), () => {
        let p = cn.indexOf(t);
        p >= 0 && cn.splice(p, 1);
      };
  }, [
    a,
    t
  ]);
  let u = () => {
    cn[cn.length - 1] === t && n && n();
  }, s = (p) => {
    (!o || o(p.target)) && cn[cn.length - 1] === t && (p.stopPropagation(), p.preventDefault());
  }, d = (p) => {
    (!o || o(p.target)) && (cn[cn.length - 1] === t && (p.stopPropagation(), p.preventDefault()), u());
  }, c = (p) => {
    p.key === "Escape" && !i && !p.nativeEvent.isComposing && (p.stopPropagation(), p.preventDefault(), u());
  };
  S6({
    ref: t,
    onInteractOutside: l && a ? d : void 0,
    onInteractOutsideStart: s
  });
  let { focusWithinProps: f } = jt({
    isDisabled: !r,
    onBlurWithin: (p) => {
      !p.relatedTarget || XD(p.relatedTarget) || (!o || o(p.relatedTarget)) && (n == null || n());
    }
  }), b = (p) => {
    p.target === p.currentTarget && p.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: c,
      ...f
    },
    underlayProps: {
      onPointerDown: b
    }
  };
}
function Wh(e, t, n) {
  let { type: r } = e, { isOpen: a } = t;
  re(() => {
    n && n.current && Hh.set(n.current, t.close);
  });
  let l;
  r === "menu" ? l = !0 : r === "listbox" && (l = "listbox");
  let i = Ee();
  return {
    triggerProps: {
      "aria-haspopup": l,
      "aria-expanded": a,
      "aria-controls": a ? i : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: i
    }
  };
}
const Do = typeof document < "u" && window.visualViewport, v7 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Sl = 0, Co;
function Gh(e = {}) {
  let { isDisabled: t } = e;
  Ce(() => {
    if (!t)
      return Sl++, Sl === 1 && (Ar() ? Co = y7() : Co = g7()), () => {
        Sl--, Sl === 0 && Co();
      };
  }, [
    t
  ]);
}
function g7() {
  return At(_r(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), _r(document.documentElement, "overflow", "hidden"));
}
function y7() {
  let e, t, n = (s) => {
    e = ht(s.target, !0), !(e === document.documentElement && e === document.body) && e instanceof HTMLElement && window.getComputedStyle(e).overscrollBehavior === "auto" && (t = _r(e, "overscrollBehavior", "contain"));
  }, r = (s) => {
    if (!e || e === document.documentElement || e === document.body) {
      s.preventDefault();
      return;
    }
    e.scrollHeight === e.clientHeight && e.scrollWidth === e.clientWidth && s.preventDefault();
  }, a = () => {
    t && t();
  }, l = (s) => {
    let d = s.target;
    $7(d) && (o(), d.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      d.style.transform = "", Do && (Do.height < window.innerHeight ? requestAnimationFrame(() => {
        ic(d);
      }) : Do.addEventListener("resize", () => ic(d), {
        once: !0
      }));
    }));
  }, i = null, o = () => {
    if (i) return;
    let s = () => {
      window.scrollTo(0, 0);
    }, d = window.pageXOffset, c = window.pageYOffset;
    i = At(ya(window, "scroll", s), _r(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), _r(document.documentElement, "overflow", "hidden"), _r(document.body, "marginTop", `-${c}px`), () => {
      window.scrollTo(d, c);
    }), window.scrollTo(0, 0);
  }, u = At(ya(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), ya(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), ya(document, "touchend", a, {
    passive: !1,
    capture: !0
  }), ya(document, "focus", l, !0));
  return () => {
    t == null || t(), i == null || i(), u();
  };
}
function _r(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function ya(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function ic(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = ht(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let a = r.getBoundingClientRect().top, l = n.getBoundingClientRect().top;
      l > a + n.clientHeight && (r.scrollTop += l - a);
    }
    n = r.parentElement;
  }
}
function $7(e) {
  return e instanceof HTMLInputElement && !v7.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
const x7 = /* @__PURE__ */ G({});
function Zh() {
  var e;
  return (e = U(x7)) !== null && e !== void 0 ? e : {};
}
const lu = /* @__PURE__ */ x.createContext(null);
function D7(e) {
  let { children: t } = e, n = U(lu), [r, a] = q(0), l = H(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      a((i) => i + 1), n && n.addModal();
    },
    removeModal() {
      a((i) => i - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ x.createElement(lu.Provider, {
    value: l
  }, t);
}
function C7() {
  let e = U(lu);
  return {
    modalProviderProps: {
      "aria-hidden": e && e.modalCount > 0 ? !0 : void 0
    }
  };
}
function E7(e) {
  let { modalProviderProps: t } = C7();
  return /* @__PURE__ */ x.createElement("div", {
    "data-overlay-container": !0,
    ...e,
    ...t
  });
}
function w7(e) {
  return /* @__PURE__ */ x.createElement(D7, null, /* @__PURE__ */ x.createElement(E7, e));
}
function P7(e) {
  let t = vn(), { portalContainer: n = t ? null : document.body, ...r } = e, { getContainer: a } = Zh();
  if (!e.portalContainer && a && (n = a()), x.useEffect(() => {
    if (n != null && n.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let l = /* @__PURE__ */ x.createElement(w7, r);
  return /* @__PURE__ */ Pu.createPortal(l, n);
}
var Yh = {};
Yh = {
  dismiss: "تجاهل"
};
var qh = {};
qh = {
  dismiss: "Отхвърляне"
};
var Xh = {};
Xh = {
  dismiss: "Odstranit"
};
var Jh = {};
Jh = {
  dismiss: "Luk"
};
var Qh = {};
Qh = {
  dismiss: "Schließen"
};
var e3 = {};
e3 = {
  dismiss: "Απόρριψη"
};
var t3 = {};
t3 = {
  dismiss: "Dismiss"
};
var n3 = {};
n3 = {
  dismiss: "Descartar"
};
var r3 = {};
r3 = {
  dismiss: "Lõpeta"
};
var a3 = {};
a3 = {
  dismiss: "Hylkää"
};
var l3 = {};
l3 = {
  dismiss: "Rejeter"
};
var i3 = {};
i3 = {
  dismiss: "התעלם"
};
var o3 = {};
o3 = {
  dismiss: "Odbaci"
};
var u3 = {};
u3 = {
  dismiss: "Elutasítás"
};
var s3 = {};
s3 = {
  dismiss: "Ignora"
};
var d3 = {};
d3 = {
  dismiss: "閉じる"
};
var c3 = {};
c3 = {
  dismiss: "무시"
};
var f3 = {};
f3 = {
  dismiss: "Atmesti"
};
var b3 = {};
b3 = {
  dismiss: "Nerādīt"
};
var p3 = {};
p3 = {
  dismiss: "Lukk"
};
var h3 = {};
h3 = {
  dismiss: "Negeren"
};
var m3 = {};
m3 = {
  dismiss: "Zignoruj"
};
var v3 = {};
v3 = {
  dismiss: "Descartar"
};
var g3 = {};
g3 = {
  dismiss: "Dispensar"
};
var y3 = {};
y3 = {
  dismiss: "Revocare"
};
var $3 = {};
$3 = {
  dismiss: "Пропустить"
};
var x3 = {};
x3 = {
  dismiss: "Zrušiť"
};
var D3 = {};
D3 = {
  dismiss: "Opusti"
};
var C3 = {};
C3 = {
  dismiss: "Odbaci"
};
var E3 = {};
E3 = {
  dismiss: "Avvisa"
};
var w3 = {};
w3 = {
  dismiss: "Kapat"
};
var P3 = {};
P3 = {
  dismiss: "Скасувати"
};
var k3 = {};
k3 = {
  dismiss: "取消"
};
var S3 = {};
S3 = {
  dismiss: "關閉"
};
var B3 = {};
B3 = {
  "ar-AE": Yh,
  "bg-BG": qh,
  "cs-CZ": Xh,
  "da-DK": Jh,
  "de-DE": Qh,
  "el-GR": e3,
  "en-US": t3,
  "es-ES": n3,
  "et-EE": r3,
  "fi-FI": a3,
  "fr-FR": l3,
  "he-IL": i3,
  "hr-HR": o3,
  "hu-HU": u3,
  "it-IT": s3,
  "ja-JP": d3,
  "ko-KR": c3,
  "lt-LT": f3,
  "lv-LV": b3,
  "nb-NO": p3,
  "nl-NL": h3,
  "pl-PL": m3,
  "pt-BR": v3,
  "pt-PT": g3,
  "ro-RO": y3,
  "ru-RU": $3,
  "sk-SK": x3,
  "sl-SI": D3,
  "sr-SP": C3,
  "sv-SE": E3,
  "tr-TR": w3,
  "uk-UA": P3,
  "zh-CN": k3,
  "zh-TW": S3
};
function k7(e) {
  return e && e.__esModule ? e.default : e;
}
function iu(e) {
  let { onDismiss: t, ...n } = e, r = Oe(k7(B3), "@react-aria/overlays"), a = Ot(n, r.format("dismiss")), l = () => {
    t && t();
  };
  return /* @__PURE__ */ x.createElement(Vn, null, /* @__PURE__ */ x.createElement("button", {
    ...a,
    tabIndex: -1,
    onClick: l,
    style: {
      width: 1,
      height: 1
    }
  }));
}
let $a = /* @__PURE__ */ new WeakMap(), Bt = [];
function is(e, t = document.body) {
  let n = new Set(e), r = /* @__PURE__ */ new Set(), a = (u) => {
    for (let f of u.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) n.add(f);
    let s = (f) => {
      if (n.has(f) || f.parentElement && r.has(f.parentElement) && f.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let b of n)
        if (f.contains(b)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, d = document.createTreeWalker(u, NodeFilter.SHOW_ELEMENT, {
      acceptNode: s
    }), c = s(u);
    if (c === NodeFilter.FILTER_ACCEPT && l(u), c !== NodeFilter.FILTER_REJECT) {
      let f = d.nextNode();
      for (; f != null; )
        l(f), f = d.nextNode();
    }
  }, l = (u) => {
    var s;
    let d = (s = $a.get(u)) !== null && s !== void 0 ? s : 0;
    u.getAttribute("aria-hidden") === "true" && d === 0 || (d === 0 && u.setAttribute("aria-hidden", "true"), r.add(u), $a.set(u, d + 1));
  };
  Bt.length && Bt[Bt.length - 1].disconnect(), a(t);
  let i = new MutationObserver((u) => {
    for (let s of u)
      if (!(s.type !== "childList" || s.addedNodes.length === 0) && ![
        ...n,
        ...r
      ].some((d) => d.contains(s.target))) {
        for (let d of s.removedNodes) d instanceof Element && (n.delete(d), r.delete(d));
        for (let d of s.addedNodes)
          (d instanceof HTMLElement || d instanceof SVGElement) && (d.dataset.liveAnnouncer === "true" || d.dataset.reactAriaTopLayer === "true") ? n.add(d) : d instanceof Element && a(d);
      }
  });
  i.observe(t, {
    childList: !0,
    subtree: !0
  });
  let o = {
    visibleNodes: n,
    hiddenNodes: r,
    observe() {
      i.observe(t, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      i.disconnect();
    }
  };
  return Bt.push(o), () => {
    i.disconnect();
    for (let u of r) {
      let s = $a.get(u);
      s != null && (s === 1 ? (u.removeAttribute("aria-hidden"), $a.delete(u)) : $a.set(u, s - 1));
    }
    o === Bt[Bt.length - 1] ? (Bt.pop(), Bt.length && Bt[Bt.length - 1].observe()) : Bt.splice(Bt.indexOf(o), 1);
  };
}
function S7(e) {
  let t = Bt[Bt.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
function B7(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: a, isNonModal: l, isKeyboardDismissDisabled: i, shouldCloseOnInteractOutside: o, ...u } = e, s = u.trigger === "SubmenuTrigger", { overlayProps: d, underlayProps: c } = Uh({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !l || s,
    isKeyboardDismissDisabled: i,
    shouldCloseOnInteractOutside: o
  }, a ?? r), { overlayProps: f, arrowProps: b, placement: p } = _h({
    ...u,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: l && !s ? t.close : null
  });
  return Gh({
    isDisabled: l || !t.isOpen
  }), Ce(() => {
    if (t.isOpen && r.current) {
      var h, m;
      return l ? S7((h = a == null ? void 0 : a.current) !== null && h !== void 0 ? h : r.current) : is([
        (m = a == null ? void 0 : a.current) !== null && m !== void 0 ? m : r.current
      ]);
    }
  }, [
    l,
    t.isOpen,
    r,
    a
  ]), {
    popoverProps: _(d, f),
    arrowProps: b,
    underlayProps: c,
    placement: p
  };
}
const F3 = /* @__PURE__ */ x.createContext(null);
function ou(e) {
  let t = vn(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [a, l] = q(!1), i = H(() => ({
    contain: a,
    setContain: l
  }), [
    a,
    l
  ]), { getContainer: o } = Zh();
  if (!e.portalContainer && o && (n = o()), !n) return null;
  let u = e.children;
  return e.disableFocusManagement || (u = /* @__PURE__ */ x.createElement(rl, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || a) && !r
  }, u)), u = /* @__PURE__ */ x.createElement(F3.Provider, {
    value: i
  }, /* @__PURE__ */ x.createElement(P6, null, u)), /* @__PURE__ */ Pu.createPortal(u, n);
}
function A3() {
  let e = U(F3), t = e == null ? void 0 : e.setContain;
  Ce(() => {
    t == null || t(!0);
  }, [
    t
  ]);
}
function F7(e, t, n) {
  let { overlayProps: r, underlayProps: a } = Uh({
    ...e,
    isOpen: t.isOpen,
    onClose: t.close
  }, n);
  return Gh({
    isDisabled: !t.isOpen
  }), A3(), re(() => {
    if (t.isOpen && n.current) return is([
      n.current
    ]);
  }, [
    t.isOpen,
    n
  ]), {
    modalProps: _(r),
    underlayProps: a
  };
}
const wi = /* @__PURE__ */ new WeakMap();
function A7(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function T3(e, t) {
  let n = wi.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${A7(t)}`;
}
function uu(e) {
  return Al() ? e.altKey : e.ctrlKey;
}
function Il(e, t) {
  var n, r;
  let a = `[data-key="${CSS.escape(String(t))}"]`, l = (n = e.current) === null || n === void 0 ? void 0 : n.dataset.collection;
  return l && (a = `[data-collection="${CSS.escape(l)}"]${a}`), (r = e.current) === null || r === void 0 ? void 0 : r.querySelector(a);
}
const R3 = /* @__PURE__ */ new WeakMap();
function T7(e) {
  let t = Ee();
  return R3.set(e, t), t;
}
function R7(e) {
  return R3.get(e);
}
const M7 = 1e3;
function M3(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, a = j({
    search: "",
    timeout: void 0
  }).current, l = (i) => {
    let o = N7(i.key);
    if (!(!o || i.ctrlKey || i.metaKey || !i.currentTarget.contains(i.target))) {
      if (o === " " && a.search.trim().length > 0 && (i.preventDefault(), "continuePropagation" in i || i.stopPropagation()), a.search += o, t.getKeyForSearch != null) {
        let u = t.getKeyForSearch(a.search, n.focusedKey);
        u == null && (u = t.getKeyForSearch(a.search)), u != null && (n.setFocusedKey(u), r && r(u));
      }
      clearTimeout(a.timeout), a.timeout = setTimeout(() => {
        a.search = "";
      }, M7);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? l : void 0
    }
  };
}
function N7(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function Pi(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: a = !1, shouldFocusWrap: l = !1, disallowEmptySelection: i = !1, disallowSelectAll: o = !1, escapeKeyBehavior: u = "clearSelection", selectOnFocus: s = t.selectionBehavior === "replace", disallowTypeAhead: d = !1, shouldUseVirtualFocus: c, allowsTabNavigation: f = !1, isVirtualized: b, scrollRef: p = r, linkBehavior: h = "action" } = e, { direction: m } = me(), v = Tr(), y = (g) => {
    var B;
    if (g.altKey && g.key === "Tab" && g.preventDefault(), !(!((B = r.current) === null || B === void 0) && B.contains(g.target))) return;
    const k = (W, se) => {
      if (W != null) {
        if (t.isLink(W) && h === "selection" && s && !uu(g)) {
          di(() => {
            t.setFocusedKey(W, se);
          });
          let fe = Il(r, W), We = t.getItemProps(W);
          fe && v.open(fe, g, We.href, We.routerOptions);
          return;
        }
        if (t.setFocusedKey(W, se), t.isLink(W) && h === "override") return;
        g.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(W) : s && !uu(g) && t.replaceSelection(W);
      }
    };
    switch (g.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var I, O, F;
          let W = t.focusedKey != null ? (I = n.getKeyBelow) === null || I === void 0 ? void 0 : I.call(n, t.focusedKey) : (O = n.getFirstKey) === null || O === void 0 ? void 0 : O.call(n);
          W == null && l && (W = (F = n.getFirstKey) === null || F === void 0 ? void 0 : F.call(n, t.focusedKey)), W != null && (g.preventDefault(), k(W));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var z, Z, te;
          let W = t.focusedKey != null ? (z = n.getKeyAbove) === null || z === void 0 ? void 0 : z.call(n, t.focusedKey) : (Z = n.getLastKey) === null || Z === void 0 ? void 0 : Z.call(n);
          W == null && l && (W = (te = n.getLastKey) === null || te === void 0 ? void 0 : te.call(n, t.focusedKey)), W != null && (g.preventDefault(), k(W));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var ue, be, ce;
          let W = t.focusedKey != null ? (ue = n.getKeyLeftOf) === null || ue === void 0 ? void 0 : ue.call(n, t.focusedKey) : null;
          W == null && l && (W = m === "rtl" ? (be = n.getFirstKey) === null || be === void 0 ? void 0 : be.call(n, t.focusedKey) : (ce = n.getLastKey) === null || ce === void 0 ? void 0 : ce.call(n, t.focusedKey)), W != null && (g.preventDefault(), k(W, m === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var X, pe, ve;
          let W = t.focusedKey != null ? (X = n.getKeyRightOf) === null || X === void 0 ? void 0 : X.call(n, t.focusedKey) : null;
          W == null && l && (W = m === "rtl" ? (pe = n.getLastKey) === null || pe === void 0 ? void 0 : pe.call(n, t.focusedKey) : (ve = n.getFirstKey) === null || ve === void 0 ? void 0 : ve.call(n, t.focusedKey)), W != null && (g.preventDefault(), k(W, m === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && g.shiftKey) return;
          g.preventDefault();
          let W = n.getFirstKey(t.focusedKey, Lr(g));
          t.setFocusedKey(W), W != null && (Lr(g) && g.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(W) : s && t.replaceSelection(W));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && g.shiftKey) return;
          g.preventDefault();
          let W = n.getLastKey(t.focusedKey, Lr(g));
          t.setFocusedKey(W), W != null && (Lr(g) && g.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(W) : s && t.replaceSelection(W));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let W = n.getKeyPageBelow(t.focusedKey);
          W != null && (g.preventDefault(), k(W));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let W = n.getKeyPageAbove(t.focusedKey);
          W != null && (g.preventDefault(), k(W));
        }
        break;
      case "a":
        Lr(g) && t.selectionMode === "multiple" && o !== !0 && (g.preventDefault(), t.selectAll());
        break;
      case "Escape":
        u === "clearSelection" && !i && t.selectedKeys.size !== 0 && (g.stopPropagation(), g.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!f) {
          if (g.shiftKey) r.current.focus();
          else {
            let W = Je(r.current, {
              tabbable: !0
            }), se, fe;
            do
              fe = W.lastChild(), fe && (se = fe);
            while (fe);
            se && !se.contains(document.activeElement) && Et(se);
          }
          break;
        }
    }
  }, w = j({
    top: 0,
    left: 0
  });
  qt(p, "scroll", b ? void 0 : () => {
    var g, B, k, I;
    w.current = {
      top: (k = (g = p.current) === null || g === void 0 ? void 0 : g.scrollTop) !== null && k !== void 0 ? k : 0,
      left: (I = (B = p.current) === null || B === void 0 ? void 0 : B.scrollLeft) !== null && I !== void 0 ? I : 0
    };
  });
  let C = (g) => {
    if (t.isFocused) {
      g.currentTarget.contains(g.target) || t.setFocused(!1);
      return;
    }
    if (g.currentTarget.contains(g.target)) {
      if (t.setFocused(!0), t.focusedKey == null) {
        var B, k;
        let F = (Z) => {
          Z != null && (t.setFocusedKey(Z), s && !t.isSelected(Z) && t.replaceSelection(Z));
        }, z = g.relatedTarget;
        var I, O;
        z && g.currentTarget.compareDocumentPosition(z) & Node.DOCUMENT_POSITION_FOLLOWING ? F((I = t.lastSelectedKey) !== null && I !== void 0 ? I : (B = n.getLastKey) === null || B === void 0 ? void 0 : B.call(n)) : F((O = t.firstSelectedKey) !== null && O !== void 0 ? O : (k = n.getFirstKey) === null || k === void 0 ? void 0 : k.call(n));
      } else !b && p.current && (p.current.scrollTop = w.current.top, p.current.scrollLeft = w.current.left);
      if (t.focusedKey != null && p.current) {
        let F = Il(r, t.focusedKey);
        F instanceof HTMLElement && (!F.contains(document.activeElement) && !c && Et(F), ta() === "keyboard" && mt(F, {
          containingElement: r.current
        }));
      }
    }
  }, D = (g) => {
    g.currentTarget.contains(g.relatedTarget) || t.setFocused(!1);
  }, P = j(!1);
  qt(r, n6, c ? (g) => {
    let { detail: B } = g;
    g.stopPropagation(), t.setFocused(!0), (B == null ? void 0 : B.focusStrategy) === "first" && (P.current = !0);
  } : void 0);
  let R = Re(() => {
    var g, B;
    let k = (B = (g = n.getFirstKey) === null || g === void 0 ? void 0 : g.call(n)) !== null && B !== void 0 ? B : null;
    k == null ? (B4(r.current), t.collection.size > 0 && (P.current = !1)) : (t.setFocusedKey(k), P.current = !1);
  });
  td(() => {
    P.current && R();
  }, [
    t.collection,
    R
  ]);
  let V = Re(() => {
    t.collection.size > 0 && (P.current = !1);
  });
  td(() => {
    V();
  }, [
    t.focusedKey,
    V
  ]), qt(r, t6, c ? (g) => {
    var B;
    g.stopPropagation(), t.setFocused(!1), !((B = g.detail) === null || B === void 0) && B.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const L = j(a), A = j(!1);
  re(() => {
    if (L.current) {
      var g, B;
      let O = null;
      var k;
      a === "first" && (O = (k = (g = n.getFirstKey) === null || g === void 0 ? void 0 : g.call(n)) !== null && k !== void 0 ? k : null);
      var I;
      a === "last" && (O = (I = (B = n.getLastKey) === null || B === void 0 ? void 0 : B.call(n)) !== null && I !== void 0 ? I : null);
      let F = t.selectedKeys;
      if (F.size) {
        for (let z of F) if (t.canSelectItem(z)) {
          O = z;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(O), O == null && !c && r.current && He(r.current), t.collection.size > 0 && (L.current = !1, A.current = !0);
    }
  });
  let $ = j(t.focusedKey);
  re(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== $.current || A.current) && p.current && r.current) {
      let g = ta(), B = Il(r, t.focusedKey);
      if (!(B instanceof HTMLElement))
        return;
      (g === "keyboard" || A.current) && (Qc(p.current, B), g !== "virtual" && mt(B, {
        containingElement: r.current
      }));
    }
    !c && t.isFocused && t.focusedKey == null && $.current != null && r.current && He(r.current), $.current = t.focusedKey, A.current = !1;
  }), qt(r, "react-aria-focus-scope-restore", (g) => {
    g.preventDefault(), t.setFocused(!0);
  });
  let S = {
    onKeyDown: y,
    onFocus: C,
    onBlur: D,
    onMouseDown(g) {
      p.current === g.target && g.preventDefault();
    }
  }, { typeSelectProps: T } = M3({
    keyboardDelegate: n,
    selectionManager: t
  });
  d || (S = _(T, S));
  let M;
  c || (M = t.focusedKey == null ? 0 : -1);
  let K = T7(t.collection);
  return {
    collectionProps: _(S, {
      tabIndex: M,
      "data-collection": K
    })
  };
}
function oa(e) {
  let { id: t, selectionManager: n, key: r, ref: a, shouldSelectOnPressUp: l, shouldUseVirtualFocus: i, focus: o, isDisabled: u, onAction: s, allowsDifferentPressOrigin: d, linkBehavior: c = "action" } = e, f = Tr();
  t = Ee(t);
  let b = (k) => {
    if (k.pointerType === "keyboard" && uu(k)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (c === "selection" && a.current) {
          let I = n.getItemProps(r);
          f.open(a.current, k, I.href, I.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (c === "override" || c === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : k && k.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || k && (Lr(k) || k.pointerType === "touch" || k.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  re(() => {
    r === n.focusedKey && n.isFocused && (i ? B4(a.current) : o ? o() : document.activeElement !== a.current && a.current && He(a.current));
  }, [
    a,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    i
  ]), u = u || n.isDisabled(r);
  let p = {};
  !i && !u ? p = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(k) {
      k.target === a.current && n.setFocusedKey(r);
    }
  } : u && (p.onMouseDown = (k) => {
    k.preventDefault();
  });
  let h = n.isLink(r) && c === "override", m = n.isLink(r) && c !== "selection" && c !== "none", v = !u && n.canSelectItem(r) && !h, y = (s || m) && !u, w = y && (n.selectionBehavior === "replace" ? !v : !v || n.isEmpty), C = y && v && n.selectionBehavior === "replace", D = w || C, P = j(null), R = D && v, V = j(!1), L = j(!1), A = (k) => {
    if (s && s(), m && a.current) {
      let I = n.getItemProps(r);
      f.open(a.current, k, I.href, I.routerOptions);
    }
  }, $ = {
    ref: a
  };
  l ? ($.onPressStart = (k) => {
    P.current = k.pointerType, V.current = R, k.pointerType === "keyboard" && (!D || uc()) && b(k);
  }, d ? ($.onPressUp = w ? void 0 : (k) => {
    k.pointerType === "mouse" && v && b(k);
  }, $.onPress = w ? A : (k) => {
    k.pointerType !== "keyboard" && k.pointerType !== "mouse" && v && b(k);
  }) : $.onPress = (k) => {
    if (w || C && k.pointerType !== "mouse") {
      if (k.pointerType === "keyboard" && !oc()) return;
      A(k);
    } else k.pointerType !== "keyboard" && v && b(k);
  }) : ($.onPressStart = (k) => {
    P.current = k.pointerType, V.current = R, L.current = w, v && (k.pointerType === "mouse" && !w || k.pointerType === "keyboard" && (!y || uc())) && b(k);
  }, $.onPress = (k) => {
    (k.pointerType === "touch" || k.pointerType === "pen" || k.pointerType === "virtual" || k.pointerType === "keyboard" && D && oc() || k.pointerType === "mouse" && L.current) && (D ? A(k) : v && b(k));
  }), p["data-collection"] = R7(n.collection), p["data-key"] = r, $.preventFocusOnPress = i, i && ($ = _($, {
    onPressStart(k) {
      k.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(k) {
      k.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  }));
  let { pressProps: S, isPressed: T } = Tt($), M = C ? (k) => {
    P.current === "mouse" && (k.stopPropagation(), k.preventDefault(), A(k));
  } : void 0, { longPressProps: K } = ff({
    isDisabled: !R,
    onLongPress(k) {
      k.pointerType === "touch" && (b(k), n.setSelectionBehavior("toggle"));
    }
  }), g = (k) => {
    P.current === "touch" && V.current && k.preventDefault();
  }, B = n.isLink(r) ? (k) => {
    wr.isOpening || k.preventDefault();
  } : void 0;
  return {
    itemProps: _(
      p,
      v || w || i ? S : {},
      R ? K : {},
      {
        onDoubleClick: M,
        onDragStartCapture: g,
        onClick: B,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      i ? {
        onMouseDown: (k) => k.preventDefault()
      } : void 0
    ),
    isPressed: T,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: u,
    allowsSelection: v,
    hasAction: D
  };
}
function oc() {
  let e = window.event;
  return (e == null ? void 0 : e.key) === "Enter";
}
function uc() {
  let e = window.event;
  return (e == null ? void 0 : e.key) === " " || (e == null ? void 0 : e.code) === "Space";
}
class su {
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? Il(this.ref, t) : null;
    if (!r) return null;
    let a = n.getBoundingClientRect(), l = r.getBoundingClientRect();
    return {
      x: l.left - a.left + n.scrollLeft,
      y: l.top - a.top + n.scrollTop,
      width: l.width,
      height: l.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    var n, r;
    return {
      width: (n = t == null ? void 0 : t.scrollWidth) !== null && n !== void 0 ? n : 0,
      height: (r = t == null ? void 0 : t.scrollHeight) !== null && r !== void 0 ? r : 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    var n, r, a, l;
    return {
      x: (n = t == null ? void 0 : t.scrollLeft) !== null && n !== void 0 ? n : 0,
      y: (r = t == null ? void 0 : t.scrollTop) !== null && r !== void 0 ? r : 0,
      width: (a = t == null ? void 0 : t.offsetWidth) !== null && a !== void 0 ? a : 0,
      height: (l = t == null ? void 0 : t.offsetHeight) !== null && l !== void 0 ? l : 0
    };
  }
  constructor(t) {
    this.ref = t;
  }
}
class lr {
  isDisabled(t) {
    var n;
    return this.disabledBehavior === "all" && (((n = t.props) === null || n === void 0 ? void 0 : n.isDisabled) || this.disabledKeys.has(t.key));
  }
  findNextNonDisabled(t, n) {
    let r = t;
    for (; r != null; ) {
      let a = this.collection.getItem(r);
      if ((a == null ? void 0 : a.type) === "item" && !this.isDisabled(a)) return r;
      r = n(r);
    }
    return null;
  }
  getNextKey(t) {
    let n = t;
    return n = this.collection.getKeyAfter(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyAfter(r));
  }
  getPreviousKey(t) {
    let n = t;
    return n = this.collection.getKeyBefore(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyBefore(r));
  }
  findKey(t, n, r) {
    let a = t, l = this.layoutDelegate.getItemRect(a);
    if (!l || a == null) return null;
    let i = l;
    do {
      if (a = n(a), a == null) break;
      l = this.layoutDelegate.getItemRect(a);
    } while (l && r(i, l) && a != null);
    return a;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  getKeyBelow(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getNextKey(n), this.isSameRow) : this.getNextKey(t);
  }
  getKeyAbove(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getPreviousKey(n), this.isSameRow) : this.getPreviousKey(t);
  }
  getNextColumn(t, n) {
    return n ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  getKeyRightOf(t) {
    let n = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[n] ? (t = this.layoutDelegate[n](t), this.findNextNonDisabled(t, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl") : null;
  }
  getKeyLeftOf(t) {
    let n = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[n] ? (t = this.layoutDelegate[n](t), this.findNextNonDisabled(t, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    if (n && !ea(n)) return this.getFirstKey();
    let a = t;
    if (this.orientation === "horizontal") {
      let l = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > l && a != null; )
        a = this.getKeyAbove(a), r = a == null ? null : this.layoutDelegate.getItemRect(a);
    } else {
      let l = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y > l && a != null; )
        a = this.getKeyAbove(a), r = a == null ? null : this.layoutDelegate.getItemRect(a);
    }
    return a ?? this.getFirstKey();
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    if (n && !ea(n)) return this.getLastKey();
    let a = t;
    if (this.orientation === "horizontal") {
      let l = Math.min(this.layoutDelegate.getContentSize().width, r.y - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < l && a != null; )
        a = this.getKeyBelow(a), r = a == null ? null : this.layoutDelegate.getItemRect(a);
    } else {
      let l = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < l && a != null; )
        a = this.getKeyBelow(a), r = a == null ? null : this.layoutDelegate.getItemRect(a);
    }
    return a ?? this.getLastKey();
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, a = n || this.getFirstKey();
    for (; a != null; ) {
      let l = r.getItem(a);
      if (!l) return null;
      let i = l.textValue.slice(0, t.length);
      if (l.textValue && this.collator.compare(i, t) === 0) return a;
      a = this.getNextKey(a);
    }
    return null;
  }
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new su(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new su(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function os(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: a, keyboardDelegate: l, layoutDelegate: i } = e, o = Rr({
    usage: "search",
    sensitivity: "base"
  }), u = t.disabledBehavior, s = H(() => l || new lr({
    collection: n,
    disabledKeys: r,
    disabledBehavior: u,
    ref: a,
    collator: o,
    layoutDelegate: i
  }), [
    l,
    i,
    n,
    r,
    a,
    o,
    u
  ]), { collectionProps: d } = Pi({
    ...e,
    ref: a,
    selectionManager: t,
    keyboardDelegate: s
  });
  return {
    listProps: d
  };
}
function V7(e, t, n) {
  let r = J(e, {
    labelable: !0
  }), a = e.selectionBehavior || "toggle", l = e.linkBehavior || (a === "replace" ? "action" : "override");
  a === "toggle" && l === "action" && (l = "override");
  let { listProps: i } = os({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: l
  }), { focusWithinProps: o } = jt({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), u = Ee(e.id);
  wi.set(t, {
    id: u,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: l
  });
  let { labelProps: s, fieldProps: d } = il({
    ...e,
    id: u,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: s,
    listBoxProps: _(r, o, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ..._(d, i)
    })
  };
}
class I7 {
  build(t, n) {
    return this.context = n, sc(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (x.isValidElement(n) && n.type === x.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let a = 0;
      for (let l of r)
        yield* this.getFullNode({
          value: l,
          index: a
        }, {
          renderer: n
        }), a++;
    } else {
      let a = [];
      x.Children.forEach(n, (i) => {
        i && a.push(i);
      });
      let l = 0;
      for (let i of a) {
        let o = this.getFullNode({
          element: i,
          index: l
        }, {});
        for (let u of o)
          l++, yield u;
      }
    }
  }
  getKey(t, n, r, a) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${a}${n.key}`;
    let l = n.value;
    if (l != null) {
      var i;
      let o = (i = l.key) !== null && i !== void 0 ? i : l.id;
      if (o == null) throw new Error("No key found for item");
      return o;
    }
    return a ? `${a}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, a) {
    if (x.isValidElement(t.element) && t.element.type === x.Fragment) {
      let m = [];
      x.Children.forEach(t.element.props.children, (y) => {
        m.push(y);
      });
      var l;
      let v = (l = t.index) !== null && l !== void 0 ? l : 0;
      for (const y of m) yield* this.getFullNode({
        element: y,
        index: v++
      }, n, r, a);
      return;
    }
    let i = t.element;
    if (!i && t.value && n && n.renderer) {
      let m = this.cache.get(t.value);
      if (m && (!m.shouldInvalidate || !m.shouldInvalidate(this.context))) {
        m.index = t.index, m.parentKey = a ? a.key : null, yield m;
        return;
      }
      i = n.renderer(t.value);
    }
    if (x.isValidElement(i)) {
      let m = i.type;
      if (typeof m != "function" && typeof m.getCollectionNode != "function") {
        let C = i.type;
        throw new Error(`Unknown element <${C}> in collection.`);
      }
      let v = m.getCollectionNode(i.props, this.context);
      var o;
      let y = (o = t.index) !== null && o !== void 0 ? o : 0, w = v.next();
      for (; !w.done && w.value; ) {
        let C = w.value;
        t.index = y;
        var u;
        let D = (u = C.key) !== null && u !== void 0 ? u : null;
        D == null && (D = C.element ? null : this.getKey(i, t, n, r));
        let R = [
          ...this.getFullNode({
            ...C,
            key: D,
            index: y,
            wrapper: O7(t.wrapper, C.wrapper)
          }, this.getChildState(n, C), r ? `${r}${i.key}` : i.key, a)
        ];
        for (let V of R) {
          var s, d;
          V.value = (d = (s = C.value) !== null && s !== void 0 ? s : t.value) !== null && d !== void 0 ? d : null, V.value && this.cache.set(V.value, V);
          var c;
          if (t.type && V.type !== t.type) throw new Error(`Unsupported type <${Eo(V.type)}> in <${Eo((c = a == null ? void 0 : a.type) !== null && c !== void 0 ? c : "unknown parent type")}>. Only <${Eo(t.type)}> is supported.`);
          y++, yield V;
        }
        w = v.next(R);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let f = this;
    var b, p;
    let h = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: a ? a.key : null,
      value: (b = t.value) !== null && b !== void 0 ? b : null,
      level: a ? a.level + 1 : 0,
      index: t.index,
      rendered: t.rendered,
      textValue: (p = t.textValue) !== null && p !== void 0 ? p : "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: sc(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let m = 0;
        for (let v of t.childNodes()) {
          v.key != null && (v.key = `${h.key}${v.key}`);
          let y = f.getFullNode({
            ...v,
            index: m
          }, f.getChildState(n, v), h.key, h);
          for (let w of y)
            m++, yield w;
        }
      })
    };
    yield h;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function sc(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function O7(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function Eo(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function us(e, t, n) {
  let r = H(() => new I7(), []), { children: a, items: l, collection: i } = e;
  return H(() => {
    if (i) return i;
    let u = r.build({
      children: a,
      items: l
    }, n);
    return t(u);
  }, [
    r,
    a,
    l,
    i,
    n,
    t
  ]);
}
function at(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function kn(e) {
  return Ra(e, 0);
}
function Ra(e, t) {
  if (t < 0) return;
  let n = 0;
  for (let r of e) {
    if (n === t) return r;
    n++;
  }
}
function Fn(e) {
  let t;
  for (let n of e) t = n;
  return t;
}
function wo(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...dc(e, t),
    t
  ], a = [
    ...dc(e, n),
    n
  ], l = r.slice(0, a.length).findIndex((i, o) => i !== a[o]);
  return l !== -1 ? (t = r[l], n = a[l], t.index - n.index) : r.findIndex((i) => i === n) >= 0 ? 1 : (a.findIndex((i) => i === t) >= 0, -1);
}
function dc(e, t) {
  let n = [], r = t;
  for (; (r == null ? void 0 : r.parentKey) != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const cc = /* @__PURE__ */ new WeakMap();
function ss(e) {
  let t = cc.get(e);
  if (t != null) return t;
  let n = 0, r = (a) => {
    for (let l of a) l.type === "section" ? r(at(l, e)) : n++;
  };
  return r(e), cc.set(e, n), n;
}
function z7(e, t, n) {
  var r, a;
  let { key: l } = e, i = wi.get(t);
  var o;
  let u = (o = e.isDisabled) !== null && o !== void 0 ? o : t.selectionManager.isDisabled(l);
  var s;
  let d = (s = e.isSelected) !== null && s !== void 0 ? s : t.selectionManager.isSelected(l);
  var c;
  let f = (c = e.shouldSelectOnPressUp) !== null && c !== void 0 ? c : i == null ? void 0 : i.shouldSelectOnPressUp;
  var b;
  let p = (b = e.shouldFocusOnHover) !== null && b !== void 0 ? b : i == null ? void 0 : i.shouldFocusOnHover;
  var h;
  let m = (h = e.shouldUseVirtualFocus) !== null && h !== void 0 ? h : i == null ? void 0 : i.shouldUseVirtualFocus;
  var v;
  let y = (v = e.isVirtualized) !== null && v !== void 0 ? v : i == null ? void 0 : i.isVirtualized, w = pn(), C = pn(), D = {
    role: "option",
    "aria-disabled": u || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? d : void 0
  };
  Rn() && Fu() || (D["aria-label"] = e["aria-label"], D["aria-labelledby"] = w, D["aria-describedby"] = C);
  let P = t.collection.getItem(l);
  if (y) {
    let B = Number(P == null ? void 0 : P.index);
    D["aria-posinset"] = Number.isNaN(B) ? void 0 : B + 1, D["aria-setsize"] = ss(t.collection);
  }
  let R = i != null && i.onAction ? () => {
    var B;
    return i == null || (B = i.onAction) === null || B === void 0 ? void 0 : B.call(i, l);
  } : void 0, V = T3(t, l), { itemProps: L, isPressed: A, isFocused: $, hasAction: S, allowsSelection: T } = oa({
    selectionManager: t.selectionManager,
    key: l,
    ref: n,
    shouldSelectOnPressUp: f,
    allowsDifferentPressOrigin: f && p,
    isVirtualized: y,
    shouldUseVirtualFocus: m,
    isDisabled: u,
    onAction: R || !(P == null || (r = P.props) === null || r === void 0) && r.onAction ? At(P == null || (a = P.props) === null || a === void 0 ? void 0 : a.onAction, R) : void 0,
    linkBehavior: i == null ? void 0 : i.linkBehavior,
    id: V
  }), { hoverProps: M } = Ie({
    isDisabled: u || !p,
    onHoverStart() {
      Nn() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(l));
    }
  }), K = J(P == null ? void 0 : P.props);
  delete K.id;
  let g = bi(P == null ? void 0 : P.props);
  return {
    optionProps: {
      ...D,
      ..._(K, L, M, g),
      id: V
    },
    labelProps: {
      id: w
    },
    descriptionProps: {
      id: C
    },
    isFocused: $,
    isFocusVisible: $ && t.selectionManager.isFocused && Nn(),
    isSelected: d,
    isDisabled: u,
    isPressed: A,
    allowsSelection: T,
    hasAction: S
  };
}
function K7(e) {
  let { heading: t, "aria-label": n } = e, r = Ee();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
var N3 = {};
N3 = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var V3 = {};
V3 = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var I3 = {};
I3 = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var O3 = {};
O3 = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var z3 = {};
z3 = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var K3 = {};
K3 = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var j3 = {};
j3 = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var L3 = {};
L3 = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var H3 = {};
H3 = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var _3 = {};
_3 = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var U3 = {};
U3 = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var W3 = {};
W3 = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var G3 = {};
G3 = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Z3 = {};
Z3 = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Y3 = {};
Y3 = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var q3 = {};
q3 = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var X3 = {};
X3 = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var J3 = {};
J3 = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var Q3 = {};
Q3 = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var em = {};
em = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var tm = {};
tm = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var nm = {};
nm = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var rm = {};
rm = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var am = {};
am = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var lm = {};
lm = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var im = {};
im = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var om = {};
om = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var um = {};
um = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var sm = {};
sm = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var dm = {};
dm = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var cm = {};
cm = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var fm = {};
fm = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var bm = {};
bm = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var pm = {};
pm = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var hm = {};
hm = {
  "ar-AE": N3,
  "bg-BG": V3,
  "cs-CZ": I3,
  "da-DK": O3,
  "de-DE": z3,
  "el-GR": K3,
  "en-US": j3,
  "es-ES": L3,
  "et-EE": H3,
  "fi-FI": _3,
  "fr-FR": U3,
  "he-IL": W3,
  "hr-HR": G3,
  "hu-HU": Z3,
  "it-IT": Y3,
  "ja-JP": q3,
  "ko-KR": X3,
  "lt-LT": J3,
  "lv-LV": Q3,
  "nb-NO": em,
  "nl-NL": tm,
  "pl-PL": nm,
  "pt-BR": rm,
  "pt-PT": am,
  "ro-RO": lm,
  "ru-RU": im,
  "sk-SK": om,
  "sl-SI": um,
  "sr-SP": sm,
  "sv-SE": dm,
  "tr-TR": cm,
  "uk-UA": fm,
  "zh-CN": bm,
  "zh-TW": pm
};
function j7(e) {
  return e && e.__esModule ? e.default : e;
}
function mm(e, t, n) {
  let { type: r = "menu", isDisabled: a, trigger: l = "press" } = e, i = Ee(), { triggerProps: o, overlayProps: u } = Wh({
    type: r
  }, t, n), s = (b) => {
    if (!a && !(l === "longPress" && !b.altKey) && n && n.current)
      switch (b.key) {
        case "Enter":
        case " ":
          if (l === "longPress") return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in b || b.stopPropagation(), b.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in b || b.stopPropagation(), b.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in b && b.continuePropagation();
      }
  }, d = Oe(j7(hm), "@react-aria/menu"), { longPressProps: c } = ff({
    isDisabled: a || l !== "longPress",
    accessibilityDescription: d.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), f = {
    preventFocusOnPress: !0,
    onPressStart(b) {
      b.pointerType !== "touch" && b.pointerType !== "keyboard" && !a && (Et(b.target), t.open(b.pointerType === "virtual" ? "first" : null));
    },
    onPress(b) {
      b.pointerType === "touch" && !a && (Et(b.target), t.toggle());
    }
  };
  return delete o.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...o,
      ...l === "press" ? f : c,
      id: i,
      onKeyDown: s
    },
    menuProps: {
      ...u,
      "aria-labelledby": i,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const vm = /* @__PURE__ */ new WeakMap();
function L7(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: a, onKeyUp: l, ...i } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let o = J(e, {
    labelable: !0
  }), { listProps: u } = os({
    ...i,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return vm.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: _(o, {
      onKeyDown: a,
      onKeyUp: l
    }, {
      role: "menu",
      ...u,
      onKeyDown: (s) => {
        var d;
        (s.key !== "Escape" || e.shouldUseVirtualFocus) && ((d = u.onKeyDown) === null || d === void 0 || d.call(u, s));
      }
    })
  };
}
function H7(e, t, n) {
  let { id: r, key: a, closeOnSelect: l, isVirtualized: i, "aria-haspopup": o, onPressStart: u, onPressUp: s, onPress: d, onPressChange: c, onPressEnd: f, onHoverStart: b, onHoverChange: p, onHoverEnd: h, onKeyDown: m, onKeyUp: v, onFocus: y, onFocusChange: w, onBlur: C, selectionManager: D = t.selectionManager } = e, P = !!o, R = P && e["aria-expanded"] === "true";
  var V;
  let L = (V = e.isDisabled) !== null && V !== void 0 ? V : D.isDisabled(a);
  var A;
  let $ = (A = e.isSelected) !== null && A !== void 0 ? A : D.isSelected(a), S = vm.get(t), T = t.collection.getItem(a), M = e.onClose || S.onClose, K = Tr(), g = (ye) => {
    var st;
    if (!P) {
      if (!(T == null || (st = T.props) === null || st === void 0) && st.onAction ? T.props.onAction() : e.onAction && e.onAction(a), S.onAction) {
        let $t = S.onAction;
        $t(a);
      }
      ye.target instanceof HTMLAnchorElement && T && K.open(ye.target, ye, T.props.href, T.props.routerOptions);
    }
  }, B = "menuitem";
  P || (D.selectionMode === "single" ? B = "menuitemradio" : D.selectionMode === "multiple" && (B = "menuitemcheckbox"));
  let k = pn(), I = pn(), O = pn(), F = {
    id: r,
    "aria-disabled": L || void 0,
    role: B,
    "aria-label": e["aria-label"],
    "aria-labelledby": k,
    "aria-describedby": [
      I,
      O
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": o,
    "aria-expanded": e["aria-expanded"]
  };
  D.selectionMode !== "none" && !P && (F["aria-checked"] = $), i && (F["aria-posinset"] = T == null ? void 0 : T.index, F["aria-setsize"] = ss(t.collection));
  let z = (ye) => {
    ye.pointerType === "keyboard" && g(ye), u == null || u(ye);
  }, Z = () => {
    !P && M && (l ?? (D.selectionMode !== "multiple" || D.isLink(a))) && M();
  }, te = (ye) => {
    ye.pointerType === "mouse" && (g(ye), Z()), s == null || s(ye);
  }, ue = (ye) => {
    ye.pointerType !== "keyboard" && ye.pointerType !== "mouse" && (g(ye), Z()), d == null || d(ye);
  }, { itemProps: be, isFocused: ce } = oa({
    id: r,
    selectionManager: D,
    key: a,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: S.shouldUseVirtualFocus
  }), { pressProps: X, isPressed: pe } = Tt({
    onPressStart: z,
    onPress: ue,
    onPressUp: te,
    onPressChange: c,
    onPressEnd: f,
    isDisabled: L
  }), { hoverProps: ve } = Ie({
    isDisabled: L,
    onHoverStart(ye) {
      !Nn() && !(R && o) && (D.setFocused(!0), D.setFocusedKey(a)), b == null || b(ye);
    },
    onHoverChange: p,
    onHoverEnd: h
  }), { keyboardProps: W } = la({
    onKeyDown: (ye) => {
      if (ye.repeat) {
        ye.continuePropagation();
        return;
      }
      switch (ye.key) {
        case " ":
          !L && D.selectionMode === "none" && !P && l !== !1 && M && M();
          break;
        case "Enter":
          !L && l !== !1 && !P && M && M();
          break;
        default:
          P || ye.continuePropagation(), m == null || m(ye);
          break;
      }
    },
    onKeyUp: v
  }), { focusProps: se } = na({
    onBlur: C,
    onFocus: y,
    onFocusChange: w
  }), fe = J(T == null ? void 0 : T.props);
  delete fe.id;
  let We = bi(T == null ? void 0 : T.props);
  return {
    menuItemProps: {
      ...F,
      ..._(
        fe,
        We,
        P ? {
          onFocus: be.onFocus,
          "data-collection": be["data-collection"],
          "data-key": be["data-key"]
        } : be,
        X,
        ve,
        W,
        se,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        S.shouldUseVirtualFocus || P ? {
          onMouseDown: (ye) => ye.preventDefault()
        } : void 0
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: be.tabIndex != null && R && !S.shouldUseVirtualFocus ? -1 : be.tabIndex
    },
    labelProps: {
      id: k
    },
    descriptionProps: {
      id: I
    },
    keyboardShortcutProps: {
      id: O
    },
    isFocused: ce,
    isFocusVisible: ce && D.isFocused && Nn() && !R,
    isSelected: $,
    isPressed: pe,
    isDisabled: L
  };
}
function _7(e) {
  let { heading: t, "aria-label": n } = e, r = Ee();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function U7(e) {
  return e && e.__esModule ? e.default : e;
}
function W7(e, t) {
  let { buttonRef: n, popoverRef: r, inputRef: a, listBoxRef: l, keyboardDelegate: i, layoutDelegate: o, shouldFocusWrap: u, isReadOnly: s, isDisabled: d } = e, c = j(null);
  n = n ?? c;
  let f = Oe(U7(jh), "@react-aria/combobox"), { menuTriggerProps: b, menuProps: p } = mm({
    type: "listbox",
    isDisabled: d || s
  }, t, n);
  wi.set(t, {
    id: p.id
  });
  let { collection: h } = t, { disabledKeys: m } = t.selectionManager, v = H(() => i || new lr({
    collection: h,
    disabledKeys: m,
    ref: l,
    layoutDelegate: o
  }), [
    i,
    o,
    h,
    m,
    l
  ]), { collectionProps: y } = Pi({
    selectionManager: t.selectionManager,
    keyboardDelegate: v,
    disallowTypeAhead: !0,
    disallowEmptySelection: !0,
    shouldFocusWrap: u,
    ref: a,
    // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
    isVirtualized: !0
  }), w = Tr(), C = (W) => {
    if (!W.nativeEvent.isComposing)
      switch (W.key) {
        case "Enter":
        case "Tab":
          if (t.isOpen && W.key === "Enter" && W.preventDefault(), t.isOpen && l.current && t.selectionManager.focusedKey != null && t.selectionManager.isLink(t.selectionManager.focusedKey)) {
            let se = l.current.querySelector(`[data-key="${CSS.escape(t.selectionManager.focusedKey.toString())}"]`);
            if (W.key === "Enter" && se instanceof HTMLAnchorElement) {
              let fe = t.collection.getItem(t.selectionManager.focusedKey);
              fe && w.open(se, W, fe.props.href, fe.props.routerOptions);
            }
            t.close();
          } else t.commit();
          break;
        case "Escape":
          (t.selectedKey !== null || t.inputValue === "" || e.allowsCustomValue) && W.continuePropagation(), t.revert();
          break;
        case "ArrowDown":
          t.open("first", "manual");
          break;
        case "ArrowUp":
          t.open("last", "manual");
          break;
        case "ArrowLeft":
        case "ArrowRight":
          t.selectionManager.setFocusedKey(null);
          break;
      }
  }, D = (W) => {
    var se;
    let fe = (n == null ? void 0 : n.current) && n.current === W.relatedTarget, We = (se = r.current) === null || se === void 0 ? void 0 : se.contains(W.relatedTarget);
    fe || We || (e.onBlur && e.onBlur(W), t.setFocused(!1));
  }, P = (W) => {
    t.isFocused || (e.onFocus && e.onFocus(W), t.setFocused(!0));
  }, { isInvalid: R, validationErrors: V, validationDetails: L } = t.displayValidation, { labelProps: A, inputProps: $, descriptionProps: S, errorMessageProps: T } = Ei({
    ...e,
    onChange: t.setInputValue,
    onKeyDown: s ? e.onKeyDown : At(t.isOpen && y.onKeyDown, C, e.onKeyDown),
    onBlur: D,
    value: t.inputValue,
    onFocus: P,
    autoComplete: "off",
    validate: void 0,
    [mn]: t
  }, a), M = (W) => {
    if (W.pointerType === "touch") {
      var se;
      (se = a.current) === null || se === void 0 || se.focus(), t.toggle(null, "manual");
    }
  }, K = (W) => {
    if (W.pointerType !== "touch") {
      var se;
      (se = a.current) === null || se === void 0 || se.focus(), t.toggle(W.pointerType === "keyboard" || W.pointerType === "virtual" ? "first" : null, "manual");
    }
  }, g = Ot({
    id: b.id,
    "aria-label": f.format("buttonLabel"),
    "aria-labelledby": e["aria-labelledby"] || A.id
  }), B = Ot({
    id: p.id,
    "aria-label": f.format("listboxLabel"),
    "aria-labelledby": e["aria-labelledby"] || A.id
  }), k = j(0), I = (W) => {
    if (d || s) return;
    if (W.timeStamp - k.current < 500) {
      var se;
      W.preventDefault(), (se = a.current) === null || se === void 0 || se.focus();
      return;
    }
    let fe = W.target.getBoundingClientRect(), We = W.changedTouches[0], ye = Math.ceil(fe.left + 0.5 * fe.width), st = Math.ceil(fe.top + 0.5 * fe.height);
    if (We.clientX === ye && We.clientY === st) {
      var $t;
      W.preventDefault(), ($t = a.current) === null || $t === void 0 || $t.focus(), t.toggle(null, "manual"), k.current = W.timeStamp;
    }
  }, O = t.selectionManager.focusedKey != null && t.isOpen ? t.collection.getItem(t.selectionManager.focusedKey) : void 0;
  var F;
  let z = (F = O == null ? void 0 : O.parentKey) !== null && F !== void 0 ? F : null;
  var Z;
  let te = (Z = t.selectionManager.focusedKey) !== null && Z !== void 0 ? Z : null, ue = j(z), be = j(te);
  re(() => {
    if (Al() && O != null && te != null && te !== be.current) {
      let se = t.selectionManager.isSelected(te), fe = z != null ? t.collection.getItem(z) : null, We = (fe == null ? void 0 : fe["aria-label"]) || (typeof (fe == null ? void 0 : fe.rendered) == "string" ? fe.rendered : "") || "";
      var W;
      let ye = f.format("focusAnnouncement", {
        isGroupChange: (W = fe && z !== ue.current) !== null && W !== void 0 ? W : !1,
        groupTitle: We,
        groupCount: fe ? [
          ...at(fe, t.collection)
        ].length : 0,
        optionText: O["aria-label"] || O.textValue || "",
        isSelected: se
      });
      hn(ye);
    }
    ue.current = z, be.current = te;
  });
  let ce = ss(t.collection), X = j(ce), pe = j(t.isOpen);
  re(() => {
    let W = t.isOpen !== pe.current && (t.selectionManager.focusedKey == null || Al());
    if (t.isOpen && (W || ce !== X.current)) {
      let se = f.format("countAnnouncement", {
        optionCount: ce
      });
      hn(se);
    }
    X.current = ce, pe.current = t.isOpen;
  });
  let ve = j(t.selectedKey);
  return re(() => {
    if (Al() && t.isFocused && t.selectedItem && t.selectedKey !== ve.current) {
      let W = t.selectedItem["aria-label"] || t.selectedItem.textValue || "", se = f.format("selectedAnnouncement", {
        optionText: W
      });
      hn(se);
    }
    ve.current = t.selectedKey;
  }), re(() => {
    if (t.isOpen) return is([
      a.current,
      r.current
    ].filter((W) => W != null));
  }, [
    t.isOpen,
    a,
    r
  ]), za(() => {
    !O && a.current && ft(ke(a.current)) === a.current && F4(a.current, null);
  }, [
    O
  ]), {
    labelProps: A,
    buttonProps: {
      ...b,
      ...g,
      excludeFromTabOrder: !0,
      preventFocusOnPress: !0,
      onPress: M,
      onPressStart: K,
      isDisabled: d || s
    },
    inputProps: _($, {
      role: "combobox",
      "aria-expanded": b["aria-expanded"],
      "aria-controls": t.isOpen ? p.id : void 0,
      // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
      "aria-autocomplete": "list",
      "aria-activedescendant": O ? T3(t, O.key) : void 0,
      onTouchEnd: I,
      // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
      autoCorrect: "off",
      // This disable's the macOS Safari spell check auto corrections.
      spellCheck: "false"
    }),
    listBoxProps: _(p, B, {
      autoFocus: t.focusStrategy,
      shouldUseVirtualFocus: !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      linkBehavior: "selection"
    }),
    descriptionProps: S,
    errorMessageProps: T,
    isInvalid: R,
    validationErrors: V,
    validationDetails: L
  };
}
var gm = {};
gm = {
  calendar: "التقويم",
  day: "يوم",
  dayPeriod: "ص/م",
  endDate: "تاريخ الانتهاء",
  era: "العصر",
  hour: "الساعات",
  minute: "الدقائق",
  month: "الشهر",
  second: "الثواني",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
  selectedTimeDescription: (e) => `الوقت المحدد: ${e.time}`,
  startDate: "تاريخ البدء",
  timeZoneName: "التوقيت",
  weekday: "اليوم",
  year: "السنة"
};
var ym = {};
ym = {
  calendar: "Календар",
  day: "ден",
  dayPeriod: "пр.об./сл.об.",
  endDate: "Крайна дата",
  era: "ера",
  hour: "час",
  minute: "минута",
  month: "месец",
  second: "секунда",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
  selectedTimeDescription: (e) => `Избрано време: ${e.time}`,
  startDate: "Начална дата",
  timeZoneName: "часова зона",
  weekday: "ден от седмицата",
  year: "година"
};
var $m = {};
$m = {
  calendar: "Kalendář",
  day: "den",
  dayPeriod: "část dne",
  endDate: "Konečné datum",
  era: "letopočet",
  hour: "hodina",
  minute: "minuta",
  month: "měsíc",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.startDate} až ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybraný čas: ${e.time}`,
  startDate: "Počáteční datum",
  timeZoneName: "časové pásmo",
  weekday: "den v týdnu",
  year: "rok"
};
var xm = {};
xm = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "AM/PM",
  endDate: "Slutdato",
  era: "æra",
  hour: "time",
  minute: "minut",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tidspunkt: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidszone",
  weekday: "ugedag",
  year: "år"
};
var Dm = {};
Dm = {
  calendar: "Kalender",
  day: "Tag",
  dayPeriod: "Tageshälfte",
  endDate: "Enddatum",
  era: "Epoche",
  hour: "Stunde",
  minute: "Minute",
  month: "Monat",
  second: "Sekunde",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
  selectedTimeDescription: (e) => `Ausgewählte Zeit: ${e.time}`,
  startDate: "Anfangsdatum",
  timeZoneName: "Zeitzone",
  weekday: "Wochentag",
  year: "Jahr"
};
var Cm = {};
Cm = {
  calendar: "Ημερολόγιο",
  day: "ημέρα",
  dayPeriod: "π.μ./μ.μ.",
  endDate: "Ημερομηνία λήξης",
  era: "περίοδος",
  hour: "ώρα",
  minute: "λεπτό",
  month: "μήνας",
  second: "δευτερόλεπτο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
  selectedTimeDescription: (e) => `Επιλεγμένη ώρα: ${e.time}`,
  startDate: "Ημερομηνία έναρξης",
  timeZoneName: "ζώνη ώρας",
  weekday: "καθημερινή",
  year: "έτος"
};
var Em = {};
Em = {
  era: "era",
  year: "year",
  month: "month",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  dayPeriod: "AM/PM",
  calendar: "Calendar",
  startDate: "Start Date",
  endDate: "End Date",
  weekday: "day of the week",
  timeZoneName: "time zone",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.startDate} to ${e.endDate}`,
  selectedTimeDescription: (e) => `Selected Time: ${e.time}`
};
var wm = {};
wm = {
  calendar: "Calendario",
  day: "día",
  dayPeriod: "a. m./p. m.",
  endDate: "Fecha final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mes",
  second: "segundo",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora seleccionada: ${e.time}`,
  startDate: "Fecha de inicio",
  timeZoneName: "zona horaria",
  weekday: "día de la semana",
  year: "año"
};
var Pm = {};
Pm = {
  calendar: "Kalender",
  day: "päev",
  dayPeriod: "enne/pärast lõunat",
  endDate: "Lõppkuupäev",
  era: "ajastu",
  hour: "tund",
  minute: "minut",
  month: "kuu",
  second: "sekund",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
  selectedTimeDescription: (e) => `Valitud aeg: ${e.time}`,
  startDate: "Alguskuupäev",
  timeZoneName: "ajavöönd",
  weekday: "nädalapäev",
  year: "aasta"
};
var km = {};
km = {
  calendar: "Kalenteri",
  day: "päivä",
  dayPeriod: "vuorokaudenaika",
  endDate: "Päättymispäivä",
  era: "aikakausi",
  hour: "tunti",
  minute: "minuutti",
  month: "kuukausi",
  second: "sekunti",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
  selectedTimeDescription: (e) => `Valittu aika: ${e.time}`,
  startDate: "Alkamispäivä",
  timeZoneName: "aikavyöhyke",
  weekday: "viikonpäivä",
  year: "vuosi"
};
var Sm = {};
Sm = {
  calendar: "Calendrier",
  day: "jour",
  dayPeriod: "cadran",
  endDate: "Date de fin",
  era: "ère",
  hour: "heure",
  minute: "minute",
  month: "mois",
  second: "seconde",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
  selectedTimeDescription: (e) => `Heure choisie : ${e.time}`,
  startDate: "Date de début",
  timeZoneName: "fuseau horaire",
  weekday: "jour de la semaine",
  year: "année"
};
var Bm = {};
Bm = {
  calendar: "לוח שנה",
  day: "יום",
  dayPeriod: "לפנה״צ/אחה״צ",
  endDate: "תאריך סיום",
  era: "תקופה",
  hour: "שעה",
  minute: "דקה",
  month: "חודש",
  second: "שנייה",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
  selectedTimeDescription: (e) => `זמן נבחר: ${e.time}`,
  startDate: "תאריך התחלה",
  timeZoneName: "אזור זמן",
  weekday: "יום בשבוע",
  year: "שנה"
};
var Fm = {};
Fm = {
  calendar: "Kalendar",
  day: "dan",
  dayPeriod: "AM/PM",
  endDate: "Datum završetka",
  era: "era",
  hour: "sat",
  minute: "minuta",
  month: "mjesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Odabrano vrijeme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "vremenska zona",
  weekday: "dan u tjednu",
  year: "godina"
};
var Am = {};
Am = {
  calendar: "Naptár",
  day: "nap",
  dayPeriod: "napszak",
  endDate: "Befejező dátum",
  era: "éra",
  hour: "óra",
  minute: "perc",
  month: "hónap",
  second: "másodperc",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
  selectedTimeDescription: (e) => `Kijelölt idő: ${e.time}`,
  startDate: "Kezdő dátum",
  timeZoneName: "időzóna",
  weekday: "hét napja",
  year: "év"
};
var Tm = {};
Tm = {
  calendar: "Calendario",
  day: "giorno",
  dayPeriod: "AM/PM",
  endDate: "Data finale",
  era: "era",
  hour: "ora",
  minute: "minuto",
  month: "mese",
  second: "secondo",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selezionata: ${e.time}`,
  startDate: "Data iniziale",
  timeZoneName: "fuso orario",
  weekday: "giorno della settimana",
  year: "anno"
};
var Rm = {};
Rm = {
  calendar: "カレンダー",
  day: "日",
  dayPeriod: "午前/午後",
  endDate: "終了日",
  era: "時代",
  hour: "時",
  minute: "分",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.startDate} から ${e.endDate}`,
  selectedTimeDescription: (e) => `選択した時間 : ${e.time}`,
  startDate: "開始日",
  timeZoneName: "タイムゾーン",
  weekday: "曜日",
  year: "年"
};
var Mm = {};
Mm = {
  calendar: "달력",
  day: "일",
  dayPeriod: "오전/오후",
  endDate: "종료일",
  era: "연호",
  hour: "시",
  minute: "분",
  month: "월",
  second: "초",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
  selectedTimeDescription: (e) => `선택 시간: ${e.time}`,
  startDate: "시작일",
  timeZoneName: "시간대",
  weekday: "요일",
  year: "년"
};
var Nm = {};
Nm = {
  calendar: "Kalendorius",
  day: "diena",
  dayPeriod: "iki pietų / po pietų",
  endDate: "Pabaigos data",
  era: "era",
  hour: "valanda",
  minute: "minutė",
  month: "mėnuo",
  second: "sekundė",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
  selectedTimeDescription: (e) => `Pasirinktas laikas: ${e.time}`,
  startDate: "Pradžios data",
  timeZoneName: "laiko juosta",
  weekday: "savaitės diena",
  year: "metai"
};
var Vm = {};
Vm = {
  calendar: "Kalendārs",
  day: "diena",
  dayPeriod: "priekšpusdienā/pēcpusdienā",
  endDate: "Beigu datums",
  era: "ēra",
  hour: "stundas",
  minute: "minūtes",
  month: "mēnesis",
  second: "sekundes",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
  selectedTimeDescription: (e) => `Atlasītais laiks: ${e.time}`,
  startDate: "Sākuma datums",
  timeZoneName: "laika josla",
  weekday: "nedēļas diena",
  year: "gads"
};
var Im = {};
Im = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Sluttdato",
  era: "tidsalder",
  hour: "time",
  minute: "minutt",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tid: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidssone",
  weekday: "ukedag",
  year: "år"
};
var Om = {};
Om = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Einddatum",
  era: "tijdperk",
  hour: "uur",
  minute: "minuut",
  month: "maand",
  second: "seconde",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
  selectedTimeDescription: (e) => `Geselecteerde tijd: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tijdzone",
  weekday: "dag van de week",
  year: "jaar"
};
var zm = {};
zm = {
  calendar: "Kalendarz",
  day: "dzień",
  dayPeriod: "rano / po południu / wieczorem",
  endDate: "Data końcowa",
  era: "era",
  hour: "godzina",
  minute: "minuta",
  month: "miesiąc",
  second: "sekunda",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Wybrany czas: ${e.time}`,
  startDate: "Data początkowa",
  timeZoneName: "strefa czasowa",
  weekday: "dzień tygodnia",
  year: "rok"
};
var Km = {};
Km = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "AM/PM",
  endDate: "Data final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data inicial",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var jm = {};
jm = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "am/pm",
  endDate: "Data de Término",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data de Início",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var Lm = {};
Lm = {
  calendar: "Calendar",
  day: "zi",
  dayPeriod: "a.m/p.m.",
  endDate: "Dată final",
  era: "eră",
  hour: "oră",
  minute: "minut",
  month: "lună",
  second: "secundă",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selectată: ${e.time}`,
  startDate: "Dată început",
  timeZoneName: "fus orar",
  weekday: "ziua din săptămână",
  year: "an"
};
var Hm = {};
Hm = {
  calendar: "Календарь",
  day: "день",
  dayPeriod: "AM/PM",
  endDate: "Дата окончания",
  era: "эра",
  hour: "час",
  minute: "минута",
  month: "месяц",
  second: "секунда",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
  selectedTimeDescription: (e) => `Выбранное время: ${e.time}`,
  startDate: "Дата начала",
  timeZoneName: "часовой пояс",
  weekday: "день недели",
  year: "год"
};
var _m = {};
_m = {
  calendar: "Kalendár",
  day: "deň",
  dayPeriod: "AM/PM",
  endDate: "Dátum ukončenia",
  era: "letopočet",
  hour: "hodina",
  minute: "minúta",
  month: "mesiac",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybratý čas: ${e.time}`,
  startDate: "Dátum začatia",
  timeZoneName: "časové pásmo",
  weekday: "deň týždňa",
  year: "rok"
};
var Um = {};
Um = {
  calendar: "Koledar",
  day: "dan",
  dayPeriod: "dop/pop",
  endDate: "Datum konca",
  era: "doba",
  hour: "ura",
  minute: "minuta",
  month: "mesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izbrani čas: ${e.time}`,
  startDate: "Datum začetka",
  timeZoneName: "časovni pas",
  weekday: "dan v tednu",
  year: "leto"
};
var Wm = {};
Wm = {
  calendar: "Kalendar",
  day: "дан",
  dayPeriod: "пре подне/по подне",
  endDate: "Datum završetka",
  era: "ера",
  hour: "сат",
  minute: "минут",
  month: "месец",
  second: "секунд",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izabrano vreme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "временска зона",
  weekday: "дан у недељи",
  year: "година"
};
var Gm = {};
Gm = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "fm/em",
  endDate: "Slutdatum",
  era: "era",
  hour: "timme",
  minute: "minut",
  month: "månad",
  second: "sekund",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.startDate} till ${e.endDate}`,
  selectedTimeDescription: (e) => `Vald tid: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tidszon",
  weekday: "veckodag",
  year: "år"
};
var Zm = {};
Zm = {
  calendar: "Takvim",
  day: "gün",
  dayPeriod: "ÖÖ/ÖS",
  endDate: "Bitiş Tarihi",
  era: "çağ",
  hour: "saat",
  minute: "dakika",
  month: "ay",
  second: "saniye",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
  selectedTimeDescription: (e) => `Seçilen Zaman: ${e.time}`,
  startDate: "Başlangıç Tarihi",
  timeZoneName: "saat dilimi",
  weekday: "haftanın günü",
  year: "yıl"
};
var Ym = {};
Ym = {
  calendar: "Календар",
  day: "день",
  dayPeriod: "дп/пп",
  endDate: "Дата завершення",
  era: "ера",
  hour: "година",
  minute: "хвилина",
  month: "місяць",
  second: "секунда",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
  selectedTimeDescription: (e) => `Вибраний час: ${e.time}`,
  startDate: "Дата початку",
  timeZoneName: "часовий пояс",
  weekday: "день тижня",
  year: "рік"
};
var qm = {};
qm = {
  calendar: "日历",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "结束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `选定的时间：${e.time}`,
  startDate: "开始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Xm = {};
Xm = {
  calendar: "日曆",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "結束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `選定的時間：${e.time}`,
  startDate: "開始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var ol = {};
ol = {
  "ar-AE": gm,
  "bg-BG": ym,
  "cs-CZ": $m,
  "da-DK": xm,
  "de-DE": Dm,
  "el-GR": Cm,
  "en-US": Em,
  "es-ES": wm,
  "et-EE": Pm,
  "fi-FI": km,
  "fr-FR": Sm,
  "he-IL": Bm,
  "hr-HR": Fm,
  "hu-HU": Am,
  "it-IT": Tm,
  "ja-JP": Rm,
  "ko-KR": Mm,
  "lt-LT": Nm,
  "lv-LV": Vm,
  "nb-NO": Im,
  "nl-NL": Om,
  "pl-PL": zm,
  "pt-BR": Km,
  "pt-PT": jm,
  "ro-RO": Lm,
  "ru-RU": Hm,
  "sk-SK": _m,
  "sl-SI": Um,
  "sr-SP": Wm,
  "sv-SE": Gm,
  "tr-TR": Zm,
  "uk-UA": Ym,
  "zh-CN": qm,
  "zh-TW": Xm
};
function ds(e, t, n) {
  let { direction: r } = me(), a = H(() => ia(t), [
    t
  ]), l = (u) => {
    if (u.currentTarget.contains(u.target) && (u.altKey && (u.key === "ArrowDown" || u.key === "ArrowUp") && "setOpen" in e && (u.preventDefault(), u.stopPropagation(), e.setOpen(!0)), !n))
      switch (u.key) {
        case "ArrowLeft":
          if (u.preventDefault(), u.stopPropagation(), r === "rtl") {
            if (t.current) {
              let s = u.target, d = fc(t.current, s.getBoundingClientRect().left, -1);
              d && d.focus();
            }
          } else a.focusPrevious();
          break;
        case "ArrowRight":
          if (u.preventDefault(), u.stopPropagation(), r === "rtl") {
            if (t.current) {
              let s = u.target, d = fc(t.current, s.getBoundingClientRect().left, 1);
              d && d.focus();
            }
          } else a.focusNext();
          break;
      }
  }, i = () => {
    var u;
    if (!t.current) return;
    let s = (u = window.event) === null || u === void 0 ? void 0 : u.target, d = Je(t.current, {
      tabbable: !0
    });
    if (s && (d.currentNode = s, s = d.previousNode()), !s) {
      let c;
      do
        c = d.lastChild(), c && (s = c);
      while (c);
    }
    for (; s != null && s.hasAttribute("data-placeholder"); ) {
      let c = d.previousNode();
      if (c && c.hasAttribute("data-placeholder")) s = c;
      else break;
    }
    s && s.focus();
  }, { pressProps: o } = Tt({
    preventFocusOnPress: !0,
    allowTextSelectionOnPress: !0,
    onPressStart(u) {
      u.pointerType === "mouse" && i();
    },
    onPress(u) {
      u.pointerType !== "mouse" && i();
    }
  });
  return _(o, {
    onKeyDown: l
  });
}
function fc(e, t, n) {
  let r = Je(e, {
    tabbable: !0
  }), a = r.nextNode(), l = null, i = 1 / 0;
  for (; a; ) {
    let u = a.getBoundingClientRect().left - t, s = Math.abs(u);
    Math.sign(u) === n && s < i && (l = a, i = s), a = r.nextNode();
  }
  return l;
}
function G7(e) {
  return e && e.__esModule ? e.default : e;
}
const Jm = /* @__PURE__ */ new WeakMap(), Ia = "__role_" + Date.now(), Qm = "__focusManager_" + Date.now();
function cs(e, t, n) {
  var r;
  let { isInvalid: a, validationErrors: l, validationDetails: i } = t.displayValidation, { labelProps: o, fieldProps: u, descriptionProps: s, errorMessageProps: d } = or({
    ...e,
    labelElementType: "span",
    isInvalid: a,
    errorMessage: e.errorMessage || l
  }), c = j(null), { focusWithinProps: f } = jt({
    ...e,
    onFocusWithin(A) {
      var $;
      c.current = t.value, ($ = e.onFocus) === null || $ === void 0 || $.call(e, A);
    },
    onBlurWithin: (A) => {
      var $;
      t.confirmPlaceholder(), t.value !== c.current && t.commitValidation(), ($ = e.onBlur) === null || $ === void 0 || $.call(e, A);
    },
    onFocusWithinChange: e.onFocusChange
  }), b = Oe(G7(ol), "@react-aria/datepicker"), p = t.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription", h = t.maxGranularity === "hour" ? "time" : "date", m = t.value ? b.format(p, {
    [h]: t.formatValue({
      month: "long"
    })
  }) : "", v = $n(m), y = e[Ia] === "presentation" ? u["aria-describedby"] : [
    v["aria-describedby"],
    u["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, w = e[Qm], C = H(() => w || ia(n), [
    w,
    n
  ]), D = ds(t, n, e[Ia] === "presentation");
  Jm.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: [
      o.id,
      e["aria-labelledby"]
    ].filter(Boolean).join(" ") || void 0,
    ariaDescribedBy: y,
    focusManager: C
  });
  let P = j(e.autoFocus), R;
  e[Ia] === "presentation" ? R = {
    role: "presentation"
  } : R = _(u, {
    role: "group",
    "aria-disabled": e.isDisabled || void 0,
    "aria-describedby": y
  }), re(() => {
    P.current && C.focusFirst(), P.current = !1;
  }, [
    C
  ]), zn(e.inputRef, t.value, t.setValue), ll({
    ...e,
    focus() {
      C.focusFirst();
    }
  }, t, e.inputRef);
  let V = {
    type: "hidden",
    name: e.name,
    value: ((r = t.value) === null || r === void 0 ? void 0 : r.toString()) || "",
    disabled: e.isDisabled
  };
  e.validationBehavior === "native" && (V.type = "text", V.hidden = !0, V.required = e.isRequired, V.onChange = () => {
  });
  let L = J(e);
  return {
    labelProps: {
      ...o,
      onClick: () => {
        C.focusFirst();
      }
    },
    fieldProps: _(L, R, D, f, {
      onKeyDown(A) {
        e.onKeyDown && e.onKeyDown(A);
      },
      onKeyUp(A) {
        e.onKeyUp && e.onKeyUp(A);
      },
      style: {
        unicodeBidi: "isolate"
      }
    }),
    inputProps: V,
    descriptionProps: s,
    errorMessageProps: d,
    isInvalid: a,
    validationErrors: l,
    validationDetails: i
  };
}
function Z7(e, t, n) {
  var r;
  let a = cs(e, t, n);
  return a.inputProps.value = ((r = t.timeValue) === null || r === void 0 ? void 0 : r.toString()) || "", a;
}
function Y7(e) {
  return e && e.__esModule ? e.default : e;
}
function q7(e, t, n) {
  let r = Ee(), a = Ee(), l = Ee(), i = Oe(Y7(ol), "@react-aria/datepicker"), { isInvalid: o, validationErrors: u, validationDetails: s } = t.displayValidation, { labelProps: d, fieldProps: c, descriptionProps: f, errorMessageProps: b } = or({
    ...e,
    labelElementType: "span",
    isInvalid: o,
    errorMessage: e.errorMessage || u
  }), p = ds(t, n), h = c["aria-labelledby"] || c.id, { locale: m } = me(), v = t.formatValue(m, {
    month: "long"
  }), y = v ? i.format("selectedDateDescription", {
    date: v
  }) : "", w = $n(y), C = [
    w["aria-describedby"],
    c["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, D = J(e), P = H(() => ia(n), [
    n
  ]), R = j(!1), { focusWithinProps: V } = jt({
    ...e,
    isDisabled: t.isOpen,
    onBlurWithin: (L) => {
      let A = document.getElementById(a);
      if (!(A != null && A.contains(L.relatedTarget))) {
        var $, S;
        R.current = !1, ($ = e.onBlur) === null || $ === void 0 || $.call(e, L), (S = e.onFocusChange) === null || S === void 0 || S.call(e, !1);
      }
    },
    onFocusWithin: (L) => {
      if (!R.current) {
        var A, $;
        R.current = !0, (A = e.onFocus) === null || A === void 0 || A.call(e, L), ($ = e.onFocusChange) === null || $ === void 0 || $.call(e, !0);
      }
    }
  });
  return {
    groupProps: _(D, p, c, w, V, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-labelledby": h,
      "aria-describedby": C,
      onKeyDown(L) {
        t.isOpen || e.onKeyDown && e.onKeyDown(L);
      },
      onKeyUp(L) {
        t.isOpen || e.onKeyUp && e.onKeyUp(L);
      }
    }),
    labelProps: {
      ...d,
      onClick: () => {
        P.focusFirst();
      }
    },
    fieldProps: {
      ...c,
      id: l,
      [Ia]: "presentation",
      "aria-describedby": C,
      value: t.value,
      onChange: t.setValue,
      placeholderValue: e.placeholderValue,
      hideTimeZone: e.hideTimeZone,
      hourCycle: e.hourCycle,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros,
      granularity: e.granularity,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isRequired: e.isRequired,
      validationBehavior: e.validationBehavior,
      // DatePicker owns the validation state for the date field.
      [mn]: t,
      autoFocus: e.autoFocus,
      name: e.name
    },
    descriptionProps: f,
    errorMessageProps: b,
    buttonProps: {
      ...w,
      id: r,
      "aria-haspopup": "dialog",
      "aria-label": i.format("calendar"),
      "aria-labelledby": `${r} ${h}`,
      "aria-describedby": C,
      "aria-expanded": t.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => t.setOpen(!0)
    },
    dialogProps: {
      id: a,
      "aria-labelledby": `${r} ${h}`
    },
    calendarProps: {
      autoFocus: !0,
      value: t.dateValue,
      onChange: t.setDateValue,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      defaultFocusedValue: t.dateValue ? void 0 : e.placeholderValue,
      isInvalid: t.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(t.displayValidation) : e.errorMessage || t.displayValidation.validationErrors.join(" ")
    },
    isInvalid: o,
    validationErrors: u,
    validationDetails: s
  };
}
function X7(e) {
  return e && e.__esModule ? e.default : e;
}
function J7() {
  let { locale: e } = me(), t = Yf(X7(ol), "@react-aria/datepicker");
  return H(() => {
    try {
      return new Intl.DisplayNames(e, {
        type: "dateTimeField"
      });
    } catch {
      return new Q7(e, t);
    }
  }, [
    e,
    t
  ]);
}
class Q7 {
  of(t) {
    return this.dictionary.getStringForLocale(t, this.locale);
  }
  constructor(t, n) {
    this.locale = t, this.dictionary = n;
  }
}
function eC(e, t, n) {
  let r = j(""), { locale: a, direction: l } = me(), i = J7(), { ariaLabel: o, ariaLabelledBy: u, ariaDescribedBy: s, focusManager: d } = Jm.get(t), c = e.isPlaceholder ? "" : e.text, f = H(() => t.dateFormatter.resolvedOptions(), [
    t.dateFormatter
  ]), b = fn({
    month: "long",
    timeZone: f.timeZone
  }), p = fn({
    hour: "numeric",
    hour12: f.hour12,
    timeZone: f.timeZone
  });
  if (e.type === "month" && !e.isPlaceholder) {
    let O = b.format(t.dateValue);
    c = O !== c ? `${c} – ${O}` : O;
  } else e.type === "hour" && !e.isPlaceholder && (c = p.format(t.dateValue));
  let { spinButtonProps: h } = ls({
    // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
    // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
    // https://github.com/dequelabs/axe-core/issues/3505
    value: e.value,
    textValue: c,
    minValue: e.minValue,
    maxValue: e.maxValue,
    isDisabled: t.isDisabled,
    isReadOnly: t.isReadOnly || !e.isEditable,
    isRequired: t.isRequired,
    onIncrement: () => {
      r.current = "", t.increment(e.type);
    },
    onDecrement: () => {
      r.current = "", t.decrement(e.type);
    },
    onIncrementPage: () => {
      r.current = "", t.incrementPage(e.type);
    },
    onDecrementPage: () => {
      r.current = "", t.decrementPage(e.type);
    },
    onIncrementToMax: () => {
      r.current = "", e.maxValue !== void 0 && t.setSegment(e.type, e.maxValue);
    },
    onDecrementToMin: () => {
      r.current = "", e.minValue !== void 0 && t.setSegment(e.type, e.minValue);
    }
  }), m = H(() => new Xu(a, {
    maximumFractionDigits: 0
  }), [
    a
  ]), v = () => {
    if (e.text === e.placeholder && d.focusPrevious(), m.isValidPartialNumber(e.text) && !t.isReadOnly && !e.isPlaceholder) {
      let O = e.text.slice(0, -1), F = m.parse(O);
      O = F === 0 ? "" : O, O.length === 0 || F === 0 ? t.clearSegment(e.type) : t.setSegment(e.type, F), r.current = O;
    } else e.type === "dayPeriod" && t.clearSegment(e.type);
  }, y = (O) => {
    if (O.key === "a" && (Rn() ? O.metaKey : O.ctrlKey) && O.preventDefault(), !(O.ctrlKey || O.metaKey || O.shiftKey || O.altKey))
      switch (O.key) {
        case "Backspace":
        case "Delete":
          O.preventDefault(), O.stopPropagation(), v();
          break;
      }
  }, { startsWith: w } = E4({
    sensitivity: "base"
  }), C = fn({
    hour: "numeric",
    hour12: !0
  }), D = H(() => {
    let O = /* @__PURE__ */ new Date();
    return O.setHours(0), C.formatToParts(O).find((F) => F.type === "dayPeriod").value;
  }, [
    C
  ]), P = H(() => {
    let O = /* @__PURE__ */ new Date();
    return O.setHours(12), C.formatToParts(O).find((F) => F.type === "dayPeriod").value;
  }, [
    C
  ]), R = fn({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  }), V = H(() => {
    if (e.type !== "era") return [];
    let O = Ue(new ot(1, 1, 1), t.calendar), F = t.calendar.getEras().map((Z) => {
      let te = O.set({
        year: 1,
        month: 1,
        day: 1,
        era: Z
      }).toDate("UTC"), be = R.formatToParts(te).find((ce) => ce.type === "era").value;
      return {
        era: Z,
        formatted: be
      };
    }), z = tC(F.map((Z) => Z.formatted));
    if (z) for (let Z of F) Z.formatted = Z.formatted.slice(z);
    return F;
  }, [
    R,
    t.calendar,
    e.type
  ]), L = (O) => {
    if (t.isDisabled || t.isReadOnly) return;
    let F = r.current + O;
    switch (e.type) {
      case "dayPeriod":
        if (w(D, O)) t.setSegment("dayPeriod", 0);
        else if (w(P, O)) t.setSegment("dayPeriod", 12);
        else break;
        d.focusNext();
        break;
      case "era": {
        let z = V.find((Z) => w(Z.formatted, O));
        z && (t.setSegment("era", z.era), d.focusNext());
        break;
      }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year": {
        if (!m.isValidPartialNumber(F)) return;
        let z = m.parse(F), Z = z, te = e.minValue === 0;
        if (e.type === "hour" && t.dateFormatter.resolvedOptions().hour12) {
          switch (t.dateFormatter.resolvedOptions().hourCycle) {
            case "h11":
              z > 11 && (Z = m.parse(O));
              break;
            case "h12":
              te = !1, z > 12 && (Z = m.parse(O));
              break;
          }
          e.value !== void 0 && e.value >= 12 && z > 1 && (z += 12);
        } else e.maxValue !== void 0 && z > e.maxValue && (Z = m.parse(O));
        if (isNaN(z)) return;
        let ue = Z !== 0 || te;
        ue && t.setSegment(e.type, Z), e.maxValue !== void 0 && (+(z + "0") > e.maxValue || F.length >= String(e.maxValue).length) ? (r.current = "", ue && d.focusNext()) : r.current = F;
        break;
      }
    }
  }, A = () => {
    r.current = "", n.current && mt(n.current, {
      containingElement: ht(n.current)
    });
    let O = window.getSelection();
    O == null || O.collapse(n.current);
  }, $ = j(typeof document < "u" ? document : null);
  qt($, "selectionchange", () => {
    var O;
    let F = window.getSelection();
    F != null && F.anchorNode && (!((O = n.current) === null || O === void 0) && O.contains(F == null ? void 0 : F.anchorNode)) && F.collapse(n.current);
  });
  let S = j("");
  qt(n, "beforeinput", (O) => {
    if (n.current)
      switch (O.preventDefault(), O.inputType) {
        case "deleteContentBackward":
        case "deleteContentForward":
          m.isValidPartialNumber(e.text) && !t.isReadOnly && v();
          break;
        case "insertCompositionText":
          S.current = n.current.textContent, n.current.textContent = n.current.textContent;
          break;
        default:
          O.data != null && L(O.data);
          break;
      }
  }), qt(n, "input", (O) => {
    let { inputType: F, data: z } = O;
    switch (F) {
      case "insertCompositionText":
        n.current && (n.current.textContent = S.current), z != null && (w(D, z) || w(P, z)) && L(z);
        break;
    }
  }), Ce(() => {
    let O = n.current;
    return () => {
      document.activeElement === O && (d.focusPrevious() || d.focusNext());
    };
  }, [
    n,
    d
  ]);
  let T = Ar() || e.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {}, M = H(() => t.segments.find((O) => O.isEditable), [
    t.segments
  ]);
  e !== M && !t.isInvalid && (s = void 0);
  let K = Ee(), g = !t.isDisabled && !t.isReadOnly && e.isEditable, B = e.type === "literal" ? "" : i.of(e.type), k = Ot({
    "aria-label": `${B}${o ? `, ${o}` : ""}${u ? ", " : ""}`,
    "aria-labelledby": u
  });
  if (e.type === "literal") return {
    segmentProps: {
      "aria-hidden": !0
    }
  };
  let I = {
    caretColor: "transparent"
  };
  if (l === "rtl") {
    I.unicodeBidi = "embed";
    let O = f[e.type];
    (O === "numeric" || O === "2-digit") && (I.direction = "ltr");
  }
  return {
    segmentProps: _(h, k, {
      id: K,
      ...T,
      "aria-invalid": t.isInvalid ? "true" : void 0,
      "aria-describedby": s,
      "aria-readonly": t.isReadOnly || !e.isEditable ? "true" : void 0,
      "data-placeholder": e.isPlaceholder || void 0,
      contentEditable: g,
      suppressContentEditableWarning: g,
      spellCheck: g ? "false" : void 0,
      autoCorrect: g ? "off" : void 0,
      // Capitalization was changed in React 17...
      [parseInt(x.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: g ? "next" : void 0,
      inputMode: t.isDisabled || e.type === "dayPeriod" || e.type === "era" || !g ? void 0 : "numeric",
      tabIndex: t.isDisabled ? void 0 : 0,
      onKeyDown: y,
      onFocus: A,
      style: I,
      // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
      onPointerDown(O) {
        O.stopPropagation();
      },
      onMouseDown(O) {
        O.stopPropagation();
      }
    })
  };
}
function tC(e) {
  e.sort();
  let t = e[0], n = e[e.length - 1];
  for (let r = 0; r < t.length; r++)
    if (t[r] !== n[r]) return r;
  return 0;
}
function nC(e) {
  return e && e.__esModule ? e.default : e;
}
function rC(e, t, n) {
  var r, a, l;
  let i = Oe(nC(ol), "@react-aria/datepicker"), { isInvalid: o, validationErrors: u, validationDetails: s } = t.displayValidation, { labelProps: d, fieldProps: c, descriptionProps: f, errorMessageProps: b } = or({
    ...e,
    labelElementType: "span",
    isInvalid: o,
    errorMessage: e.errorMessage || u
  }), p = c["aria-labelledby"] || c.id, { locale: h } = me(), m = t.formatValue(h, {
    month: "long"
  }), v = m ? i.format("selectedRangeDescription", {
    startDate: m.start,
    endDate: m.end
  }) : "", y = $n(v), w = {
    "aria-label": i.format("startDate"),
    "aria-labelledby": p
  }, C = {
    "aria-label": i.format("endDate"),
    "aria-labelledby": p
  }, D = Ee(), P = Ee(), R = ds(t, n), V = [
    y["aria-describedby"],
    c["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, L = H(() => ia(n, {
    // Exclude the button from the focus manager.
    accept: (k) => k.id !== D
  }), [
    n,
    D
  ]), A = {
    [Qm]: L,
    [Ia]: "presentation",
    "aria-describedby": V,
    placeholderValue: e.placeholderValue,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    granularity: e.granularity,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    isDisabled: e.isDisabled,
    isReadOnly: e.isReadOnly,
    isRequired: e.isRequired,
    validationBehavior: e.validationBehavior
  }, $ = J(e), S = j(!1), { focusWithinProps: T } = jt({
    ...e,
    isDisabled: t.isOpen,
    onBlurWithin: (k) => {
      let I = document.getElementById(P);
      if (!(I != null && I.contains(k.relatedTarget))) {
        var O, F;
        S.current = !1, (O = e.onBlur) === null || O === void 0 || O.call(e, k), (F = e.onFocusChange) === null || F === void 0 || F.call(e, !1);
      }
    },
    onFocusWithin: (k) => {
      if (!S.current) {
        var I, O;
        S.current = !0, (I = e.onFocus) === null || I === void 0 || I.call(e, k), (O = e.onFocusChange) === null || O === void 0 || O.call(e, !0);
      }
    }
  }), M = j(Jn), K = j(Jn);
  var g, B;
  return {
    groupProps: _($, R, c, y, T, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-describedby": V,
      onKeyDown(k) {
        t.isOpen || e.onKeyDown && e.onKeyDown(k);
      },
      onKeyUp(k) {
        t.isOpen || e.onKeyUp && e.onKeyUp(k);
      }
    }),
    labelProps: {
      ...d,
      onClick: () => {
        L.focusFirst();
      }
    },
    buttonProps: {
      ...y,
      id: D,
      "aria-haspopup": "dialog",
      "aria-label": i.format("calendar"),
      "aria-labelledby": `${D} ${p}`,
      "aria-describedby": V,
      "aria-expanded": t.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => t.setOpen(!0)
    },
    dialogProps: {
      id: P,
      "aria-labelledby": `${D} ${p}`
    },
    startFieldProps: {
      ...w,
      ...A,
      value: (g = (r = t.value) === null || r === void 0 ? void 0 : r.start) !== null && g !== void 0 ? g : null,
      onChange: (k) => t.setDateTime("start", k),
      autoFocus: e.autoFocus,
      name: e.startName,
      [mn]: {
        realtimeValidation: t.realtimeValidation,
        displayValidation: t.displayValidation,
        updateValidation(k) {
          M.current = k, t.updateValidation(Wa(k, K.current));
        },
        resetValidation: t.resetValidation,
        commitValidation: t.commitValidation
      }
    },
    endFieldProps: {
      ...C,
      ...A,
      value: (B = (a = t.value) === null || a === void 0 ? void 0 : a.end) !== null && B !== void 0 ? B : null,
      onChange: (k) => t.setDateTime("end", k),
      name: e.endName,
      [mn]: {
        realtimeValidation: t.realtimeValidation,
        displayValidation: t.displayValidation,
        updateValidation(k) {
          K.current = k, t.updateValidation(Wa(M.current, k));
        },
        resetValidation: t.resetValidation,
        commitValidation: t.commitValidation
      }
    },
    descriptionProps: f,
    errorMessageProps: b,
    calendarProps: {
      autoFocus: !0,
      value: !((l = t.dateRange) === null || l === void 0) && l.start && t.dateRange.end ? t.dateRange : null,
      onChange: t.setDateRange,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      allowsNonContiguousRanges: e.allowsNonContiguousRanges,
      defaultFocusedValue: t.dateRange ? void 0 : e.placeholderValue,
      isInvalid: t.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(t.displayValidation) : e.errorMessage || t.displayValidation.validationErrors.join(" ")
    },
    isInvalid: o,
    validationErrors: u,
    validationDetails: s
  };
}
function aC(e, t) {
  let { role: n = "dialog" } = e, r = pn();
  r = e["aria-label"] ? void 0 : r;
  let a = j(!1);
  return re(() => {
    if (t.current && !t.current.contains(document.activeElement)) {
      He(t.current);
      let l = setTimeout(() => {
        document.activeElement === t.current && (a.current = !0, t.current && (t.current.blur(), He(t.current)), a.current = !1);
      }, 500);
      return () => {
        clearTimeout(l);
      };
    }
  }, [
    t
  ]), A3(), {
    dialogProps: {
      ...J(e, {
        labelable: !0
      }),
      role: n,
      tabIndex: -1,
      "aria-labelledby": e["aria-labelledby"] || r,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (l) => {
        a.current && l.stopPropagation();
      }
    },
    titleProps: {
      id: r
    }
  };
}
function lC(e, t, n) {
  let { isDisabled: r } = e, a = Ee(), l = Ee(), o = !vn() && "onbeforematch" in document.body, u = j(null), s = ie(() => {
    u.current = requestAnimationFrame(() => {
      n.current && n.current.setAttribute("hidden", "until-found");
    }), di(() => {
      t.toggle();
    });
  }, [
    n,
    t
  ]);
  return qt(n, "beforematch", o ? s : null), Ce(() => {
    u.current && cancelAnimationFrame(u.current), o && n.current && !r && (t.isExpanded ? n.current.removeAttribute("hidden") : n.current.setAttribute("hidden", "until-found"));
  }, [
    r,
    n,
    t.isExpanded,
    o
  ]), re(() => () => {
    u.current && cancelAnimationFrame(u.current);
  }, []), {
    buttonProps: {
      id: a,
      "aria-expanded": t.isExpanded,
      "aria-controls": l,
      onPress: (d) => {
        !r && d.pointerType !== "keyboard" && t.toggle();
      },
      isDisabled: r,
      onPressStart(d) {
        d.pointerType === "keyboard" && !r && t.toggle();
      }
    },
    panelProps: {
      id: l,
      // This can be overridden at the panel element level.
      role: "group",
      "aria-labelledby": a,
      "aria-hidden": !t.isExpanded,
      hidden: o ? !0 : !t.isExpanded
    }
  };
}
const fs = /* @__PURE__ */ new WeakMap();
function du(e, t) {
  var n;
  let { id: r } = (n = fs.get(e)) !== null && n !== void 0 ? n : {};
  if (!r) throw new Error("Unknown list");
  return `${r}-${iC(t)}`;
}
function iC(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
class ev {
  isCell(t) {
    return t.type === "cell";
  }
  isRow(t) {
    return t.type === "row" || t.type === "item";
  }
  isDisabled(t) {
    var n;
    return this.disabledBehavior === "all" && (((n = t.props) === null || n === void 0 ? void 0 : n.isDisabled) || this.disabledKeys.has(t.key));
  }
  findPreviousKey(t, n) {
    let r = t != null ? this.collection.getKeyBefore(t) : this.collection.getLastKey();
    for (; r != null; ) {
      let a = this.collection.getItem(r);
      if (!a) return null;
      if (!this.isDisabled(a) && (!n || n(a))) return r;
      r = this.collection.getKeyBefore(r);
    }
    return null;
  }
  findNextKey(t, n) {
    let r = t != null ? this.collection.getKeyAfter(t) : this.collection.getFirstKey();
    for (; r != null; ) {
      let a = this.collection.getItem(r);
      if (!a) return null;
      if (!this.isDisabled(a) && (!n || n(a))) return r;
      if (r = this.collection.getKeyAfter(r), r == null) return null;
    }
    return null;
  }
  getKeyForItemInRowByIndex(t, n = 0) {
    if (n < 0) return null;
    let r = this.collection.getItem(t);
    if (!r) return null;
    let a = 0;
    for (let o of at(r, this.collection)) {
      var l;
      if (o.colSpan && o.colSpan + a > n) return (l = o.key) !== null && l !== void 0 ? l : null;
      o.colSpan && (a = a + o.colSpan - 1);
      var i;
      if (a === n) return (i = o.key) !== null && i !== void 0 ? i : null;
      a++;
    }
    return null;
  }
  getKeyBelow(t) {
    let n = t, r = this.collection.getItem(n);
    if (!r) return null;
    var a;
    if (this.isCell(r) && (n = (a = r.parentKey) !== null && a !== void 0 ? a : null), n == null) return null;
    if (n = this.findNextKey(n, (l) => l.type === "item"), n != null) {
      if (this.isCell(r)) {
        let l = r.colIndex ? r.colIndex : r.index;
        return this.getKeyForItemInRowByIndex(n, l);
      }
      if (this.focusMode === "row") return n;
    }
    return null;
  }
  getKeyAbove(t) {
    let n = t, r = this.collection.getItem(n);
    if (!r) return null;
    var a;
    if (this.isCell(r) && (n = (a = r.parentKey) !== null && a !== void 0 ? a : null), n == null) return null;
    if (n = this.findPreviousKey(n, (l) => l.type === "item"), n != null) {
      if (this.isCell(r)) {
        let l = r.colIndex ? r.colIndex : r.index;
        return this.getKeyForItemInRowByIndex(n, l);
      }
      if (this.focusMode === "row") return n;
    }
    return null;
  }
  getKeyRightOf(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (this.isRow(n)) {
      var r, a;
      let d = at(n, this.collection);
      var l;
      return (l = this.direction === "rtl" ? (r = Fn(d)) === null || r === void 0 ? void 0 : r.key : (a = kn(d)) === null || a === void 0 ? void 0 : a.key) !== null && l !== void 0 ? l : null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let d = this.collection.getItem(n.parentKey);
      if (!d) return null;
      let c = at(d, this.collection);
      var i;
      let f = (i = this.direction === "rtl" ? Ra(c, n.index - 1) : Ra(c, n.index + 1)) !== null && i !== void 0 ? i : null;
      var o;
      if (f) return (o = f.key) !== null && o !== void 0 ? o : null;
      var u;
      if (this.focusMode === "row") return (u = n.parentKey) !== null && u !== void 0 ? u : null;
      var s;
      return (s = this.direction === "rtl" ? this.getFirstKey(t) : this.getLastKey(t)) !== null && s !== void 0 ? s : null;
    }
    return null;
  }
  getKeyLeftOf(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (this.isRow(n)) {
      var r, a;
      let d = at(n, this.collection);
      var l;
      return (l = this.direction === "rtl" ? (r = kn(d)) === null || r === void 0 ? void 0 : r.key : (a = Fn(d)) === null || a === void 0 ? void 0 : a.key) !== null && l !== void 0 ? l : null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let d = this.collection.getItem(n.parentKey);
      if (!d) return null;
      let c = at(d, this.collection);
      var i;
      let f = (i = this.direction === "rtl" ? Ra(c, n.index + 1) : Ra(c, n.index - 1)) !== null && i !== void 0 ? i : null;
      var o;
      if (f) return (o = f.key) !== null && o !== void 0 ? o : null;
      var u;
      if (this.focusMode === "row") return (u = n.parentKey) !== null && u !== void 0 ? u : null;
      var s;
      return (s = this.direction === "rtl" ? this.getLastKey(t) : this.getFirstKey(t)) !== null && s !== void 0 ? s : null;
    }
    return null;
  }
  getFirstKey(t, n) {
    let r = t ?? null, a;
    if (r != null) {
      if (a = this.collection.getItem(r), !a) return null;
      if (this.isCell(a) && !n && a.parentKey != null) {
        var l;
        let s = this.collection.getItem(a.parentKey);
        if (!s) return null;
        var i;
        return (i = (l = kn(at(s, this.collection))) === null || l === void 0 ? void 0 : l.key) !== null && i !== void 0 ? i : null;
      }
    }
    if (r = this.findNextKey(void 0, (s) => s.type === "item"), r != null && (a && this.isCell(a) && n || this.focusMode === "cell")) {
      var o;
      let s = this.collection.getItem(r);
      if (!s) return null;
      var u;
      r = (u = (o = kn(at(s, this.collection))) === null || o === void 0 ? void 0 : o.key) !== null && u !== void 0 ? u : null;
    }
    return r;
  }
  getLastKey(t, n) {
    let r = t ?? null, a;
    if (r != null) {
      if (a = this.collection.getItem(r), !a) return null;
      if (this.isCell(a) && !n && a.parentKey != null) {
        var l;
        let s = this.collection.getItem(a.parentKey);
        if (!s) return null;
        let d = at(s, this.collection);
        var i;
        return (i = (l = Fn(d)) === null || l === void 0 ? void 0 : l.key) !== null && i !== void 0 ? i : null;
      }
    }
    if (r = this.findPreviousKey(void 0, (s) => s.type === "item"), r != null && (a && this.isCell(a) && n || this.focusMode === "cell")) {
      var o;
      let s = this.collection.getItem(r);
      if (!s) return null;
      let d = at(s, this.collection);
      var u;
      r = (u = (o = Fn(d)) === null || o === void 0 ? void 0 : o.key) !== null && u !== void 0 ? u : null;
    }
    return r;
  }
  getKeyPageAbove(t) {
    let n = t, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let a = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
    for (; r && r.y > a && n != null; ) {
      var l;
      if (n = (l = this.getKeyAbove(n)) !== null && l !== void 0 ? l : null, n == null) break;
      r = this.layoutDelegate.getItemRect(n);
    }
    return n;
  }
  getKeyPageBelow(t) {
    let n = t, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let a = this.layoutDelegate.getVisibleRect().height, l = Math.min(this.layoutDelegate.getContentSize().height, r.y + a);
    for (; r && r.y + r.height < l; ) {
      let i = this.getKeyBelow(n);
      if (i == null) break;
      r = this.layoutDelegate.getItemRect(i), n = i;
    }
    return n;
  }
  getKeyForSearch(t, n) {
    let r = n ?? null;
    if (!this.collator) return null;
    let a = this.collection;
    if (r = n ?? this.getFirstKey(), r == null) return null;
    let l = a.getItem(r);
    if (!l) return null;
    var i;
    l.type === "cell" && (r = (i = l.parentKey) !== null && i !== void 0 ? i : null);
    let o = !1;
    for (; r != null; ) {
      let d = a.getItem(r);
      if (!d) return null;
      if (d.textValue) {
        let c = d.textValue.slice(0, t.length);
        if (this.collator.compare(c, t) === 0) {
          var u, s;
          return this.isRow(d) && this.focusMode === "cell" ? (s = (u = kn(at(d, this.collection))) === null || u === void 0 ? void 0 : u.key) !== null && s !== void 0 ? s : null : d.key;
        }
      }
      r = this.findNextKey(r, (c) => c.type === "item"), r == null && !o && (r = this.getFirstKey(), o = !0);
    }
    return null;
  }
  constructor(t) {
    if (this.collection = t.collection, this.disabledKeys = t.disabledKeys, this.disabledBehavior = t.disabledBehavior || "all", this.direction = t.direction, this.collator = t.collator, !t.layout && !t.ref) throw new Error("Either a layout or a ref must be specified.");
    this.layoutDelegate = t.layoutDelegate || (t.layout ? new oC(t.layout) : new su(t.ref)), this.focusMode = t.focusMode || "row";
  }
}
class oC {
  getContentSize() {
    return this.layout.getContentSize();
  }
  getItemRect(t) {
    var n;
    return ((n = this.layout.getLayoutInfo(t)) === null || n === void 0 ? void 0 : n.rect) || null;
  }
  getVisibleRect() {
    return this.layout.virtualizer.visibleRect;
  }
  constructor(t) {
    this.layout = t;
  }
}
const bs = /* @__PURE__ */ new WeakMap();
var tv = {};
tv = {
  deselectedItem: (e) => `${e.item} غير المحدد`,
  longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
  select: "تحديد",
  selectedAll: "جميع العناصر المحددة.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "لم يتم تحديد عناصر",
    one: () => `${t.number(e.count)} عنصر محدد`,
    other: () => `${t.number(e.count)} عنصر محدد`
  })}.`,
  selectedItem: (e) => `${e.item} المحدد`
};
var nv = {};
nv = {
  deselectedItem: (e) => `${e.item} не е избран.`,
  longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
  select: "Изберете",
  selectedAll: "Всички елементи са избрани.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Няма избрани елементи",
    one: () => `${t.number(e.count)} избран елемент`,
    other: () => `${t.number(e.count)} избрани елементи`
  })}.`,
  selectedItem: (e) => `${e.item} избран.`
};
var rv = {};
rv = {
  deselectedItem: (e) => `Položka ${e.item} není vybrána.`,
  longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
  select: "Vybrat",
  selectedAll: "Vybrány všechny položky.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nevybrány žádné položky",
    one: () => `Vybrána ${t.number(e.count)} položka`,
    other: () => `Vybráno ${t.number(e.count)} položek`
  })}.`,
  selectedItem: (e) => `Vybrána položka ${e.item}.`
};
var av = {};
av = {
  deselectedItem: (e) => `${e.item} ikke valgt.`,
  longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
  select: "Vælg",
  selectedAll: "Alle elementer valgt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ingen elementer valgt",
    one: () => `${t.number(e.count)} element valgt`,
    other: () => `${t.number(e.count)} elementer valgt`
  })}.`,
  selectedItem: (e) => `${e.item} valgt.`
};
var lv = {};
lv = {
  deselectedItem: (e) => `${e.item} nicht ausgewählt.`,
  longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
  select: "Auswählen",
  selectedAll: "Alle Elemente ausgewählt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Keine Elemente ausgewählt",
    one: () => `${t.number(e.count)} Element ausgewählt`,
    other: () => `${t.number(e.count)} Elemente ausgewählt`
  })}.`,
  selectedItem: (e) => `${e.item} ausgewählt.`
};
var iv = {};
iv = {
  deselectedItem: (e) => `Δεν επιλέχθηκε το στοιχείο ${e.item}.`,
  longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
  select: "Επιλογή",
  selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Δεν επιλέχθηκαν στοιχεία",
    one: () => `Επιλέχθηκε ${t.number(e.count)} στοιχείο`,
    other: () => `Επιλέχθηκαν ${t.number(e.count)} στοιχεία`
  })}.`,
  selectedItem: (e) => `Επιλέχθηκε το στοιχείο ${e.item}.`
};
var ov = {};
ov = {
  deselectedItem: (e) => `${e.item} not selected.`,
  select: "Select",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "No items selected",
    one: () => `${t.number(e.count)} item selected`,
    other: () => `${t.number(e.count)} items selected`
  })}.`,
  selectedAll: "All items selected.",
  selectedItem: (e) => `${e.item} selected.`,
  longPressToSelect: "Long press to enter selection mode."
};
var uv = {};
uv = {
  deselectedItem: (e) => `${e.item} no seleccionado.`,
  longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
  select: "Seleccionar",
  selectedAll: "Todos los elementos seleccionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ningún elemento seleccionado",
    one: () => `${t.number(e.count)} elemento seleccionado`,
    other: () => `${t.number(e.count)} elementos seleccionados`
  })}.`,
  selectedItem: (e) => `${e.item} seleccionado.`
};
var sv = {};
sv = {
  deselectedItem: (e) => `${e.item} pole valitud.`,
  longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
  select: "Vali",
  selectedAll: "Kõik üksused valitud.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Üksusi pole valitud",
    one: () => `${t.number(e.count)} üksus valitud`,
    other: () => `${t.number(e.count)} üksust valitud`
  })}.`,
  selectedItem: (e) => `${e.item} valitud.`
};
var dv = {};
dv = {
  deselectedItem: (e) => `Kohdetta ${e.item} ei valittu.`,
  longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
  select: "Valitse",
  selectedAll: "Kaikki kohteet valittu.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ei yhtään kohdetta valittu",
    one: () => `${t.number(e.count)} kohde valittu`,
    other: () => `${t.number(e.count)} kohdetta valittu`
  })}.`,
  selectedItem: (e) => `${e.item} valittu.`
};
var cv = {};
cv = {
  deselectedItem: (e) => `${e.item} non sélectionné.`,
  longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
  select: "Sélectionner",
  selectedAll: "Tous les éléments sélectionnés.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Aucun élément sélectionné",
    one: () => `${t.number(e.count)} élément sélectionné`,
    other: () => `${t.number(e.count)} éléments sélectionnés`
  })}.`,
  selectedItem: (e) => `${e.item} sélectionné.`
};
var fv = {};
fv = {
  deselectedItem: (e) => `${e.item} לא נבחר.`,
  longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
  select: "בחר",
  selectedAll: "כל הפריטים נבחרו.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "לא נבחרו פריטים",
    one: () => `פריט ${t.number(e.count)} נבחר`,
    other: () => `${t.number(e.count)} פריטים נבחרו`
  })}.`,
  selectedItem: (e) => `${e.item} נבחר.`
};
var bv = {};
bv = {
  deselectedItem: (e) => `Stavka ${e.item} nije odabrana.`,
  longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
  select: "Odaberite",
  selectedAll: "Odabrane su sve stavke.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => `Odabrana je ${t.number(e.count)} stavka`,
    other: () => `Odabrano je ${t.number(e.count)} stavki`
  })}.`,
  selectedItem: (e) => `Stavka ${e.item} je odabrana.`
};
var pv = {};
pv = {
  deselectedItem: (e) => `${e.item} nincs kijelölve.`,
  longPressToSelect: "Nyomja hosszan a kijelöléshez.",
  select: "Kijelölés",
  selectedAll: "Az összes elem kijelölve.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Egy elem sincs kijelölve",
    one: () => `${t.number(e.count)} elem kijelölve`,
    other: () => `${t.number(e.count)} elem kijelölve`
  })}.`,
  selectedItem: (e) => `${e.item} kijelölve.`
};
var hv = {};
hv = {
  deselectedItem: (e) => `${e.item} non selezionato.`,
  longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
  select: "Seleziona",
  selectedAll: "Tutti gli elementi selezionati.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nessun elemento selezionato",
    one: () => `${t.number(e.count)} elemento selezionato`,
    other: () => `${t.number(e.count)} elementi selezionati`
  })}.`,
  selectedItem: (e) => `${e.item} selezionato.`
};
var mv = {};
mv = {
  deselectedItem: (e) => `${e.item} が選択されていません。`,
  longPressToSelect: "長押しして選択モードを開きます。",
  select: "選択",
  selectedAll: "すべての項目を選択しました。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "項目が選択されていません",
    one: () => `${t.number(e.count)} 項目を選択しました`,
    other: () => `${t.number(e.count)} 項目を選択しました`
  })}。`,
  selectedItem: (e) => `${e.item} を選択しました。`
};
var vv = {};
vv = {
  deselectedItem: (e) => `${e.item}이(가) 선택되지 않았습니다.`,
  longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
  select: "선택",
  selectedAll: "모든 항목이 선택되었습니다.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "선택된 항목이 없습니다",
    one: () => `${t.number(e.count)}개 항목이 선택되었습니다`,
    other: () => `${t.number(e.count)}개 항목이 선택되었습니다`
  })}.`,
  selectedItem: (e) => `${e.item}이(가) 선택되었습니다.`
};
var gv = {};
gv = {
  deselectedItem: (e) => `${e.item} nepasirinkta.`,
  longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
  select: "Pasirinkti",
  selectedAll: "Pasirinkti visi elementai.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nepasirinktas nė vienas elementas",
    one: () => `Pasirinktas ${t.number(e.count)} elementas`,
    other: () => `Pasirinkta elementų: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Pasirinkta: ${e.item}.`
};
var yv = {};
yv = {
  deselectedItem: (e) => `Vienums ${e.item} nav atlasīts.`,
  longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
  select: "Atlasīt",
  selectedAll: "Atlasīti visi vienumi.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nav atlasīts neviens vienums",
    one: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`,
    other: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Atlasīts vienums ${e.item}.`
};
var $v = {};
$v = {
  deselectedItem: (e) => `${e.item} er ikke valgt.`,
  longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
  select: "Velg",
  selectedAll: "Alle elementer er valgt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ingen elementer er valgt",
    one: () => `${t.number(e.count)} element er valgt`,
    other: () => `${t.number(e.count)} elementer er valgt`
  })}.`,
  selectedItem: (e) => `${e.item} er valgt.`
};
var xv = {};
xv = {
  deselectedItem: (e) => `${e.item} niet geselecteerd.`,
  longPressToSelect: "Druk lang om de selectiemodus te openen.",
  select: "Selecteren",
  selectedAll: "Alle items geselecteerd.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Geen items geselecteerd",
    one: () => `${t.number(e.count)} item geselecteerd`,
    other: () => `${t.number(e.count)} items geselecteerd`
  })}.`,
  selectedItem: (e) => `${e.item} geselecteerd.`
};
var Dv = {};
Dv = {
  deselectedItem: (e) => `Nie zaznaczono ${e.item}.`,
  longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
  select: "Zaznacz",
  selectedAll: "Wszystkie zaznaczone elementy.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nie zaznaczono żadnych elementów",
    one: () => `${t.number(e.count)} zaznaczony element`,
    other: () => `${t.number(e.count)} zaznaczonych elementów`
  })}.`,
  selectedItem: (e) => `Zaznaczono ${e.item}.`
};
var Cv = {};
Cv = {
  deselectedItem: (e) => `${e.item} não selecionado.`,
  longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${t.number(e.count)} item selecionado`,
    other: () => `${t.number(e.count)} itens selecionados`
  })}.`,
  selectedItem: (e) => `${e.item} selecionado.`
};
var Ev = {};
Ev = {
  deselectedItem: (e) => `${e.item} não selecionado.`,
  longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${t.number(e.count)} item selecionado`,
    other: () => `${t.number(e.count)} itens selecionados`
  })}.`,
  selectedItem: (e) => `${e.item} selecionado.`
};
var wv = {};
wv = {
  deselectedItem: (e) => `${e.item} neselectat.`,
  longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
  select: "Selectare",
  selectedAll: "Toate elementele selectate.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Niciun element selectat",
    one: () => `${t.number(e.count)} element selectat`,
    other: () => `${t.number(e.count)} elemente selectate`
  })}.`,
  selectedItem: (e) => `${e.item} selectat.`
};
var Pv = {};
Pv = {
  deselectedItem: (e) => `${e.item} не выбрано.`,
  longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
  select: "Выбрать",
  selectedAll: "Выбраны все элементы.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Нет выбранных элементов",
    one: () => `${t.number(e.count)} элемент выбран`,
    other: () => `${t.number(e.count)} элементов выбрано`
  })}.`,
  selectedItem: (e) => `${e.item} выбрано.`
};
var kv = {};
kv = {
  deselectedItem: (e) => `Nevybraté položky: ${e.item}.`,
  longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
  select: "Vybrať",
  selectedAll: "Všetky vybraté položky.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Žiadne vybraté položky",
    one: () => `${t.number(e.count)} vybratá položka`,
    other: () => `Počet vybratých položiek:${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Vybraté položky: ${e.item}.`
};
var Sv = {};
Sv = {
  deselectedItem: (e) => `Element ${e.item} ni izbran.`,
  longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
  select: "Izberite",
  selectedAll: "Vsi elementi so izbrani.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Noben element ni izbran",
    one: () => `${t.number(e.count)} element je izbran`,
    other: () => `${t.number(e.count)} elementov je izbranih`
  })}.`,
  selectedItem: (e) => `Element ${e.item} je izbran.`
};
var Bv = {};
Bv = {
  deselectedItem: (e) => `${e.item} nije izabrano.`,
  longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
  select: "Izaberite",
  selectedAll: "Izabrane su sve stavke.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => `Izabrana je ${t.number(e.count)} stavka`,
    other: () => `Izabrano je ${t.number(e.count)} stavki`
  })}.`,
  selectedItem: (e) => `${e.item} je izabrano.`
};
var Fv = {};
Fv = {
  deselectedItem: (e) => `${e.item} ej markerat.`,
  longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
  select: "Markera",
  selectedAll: "Alla markerade objekt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Inga markerade objekt",
    one: () => `${t.number(e.count)} markerat objekt`,
    other: () => `${t.number(e.count)} markerade objekt`
  })}.`,
  selectedItem: (e) => `${e.item} markerat.`
};
var Av = {};
Av = {
  deselectedItem: (e) => `${e.item} seçilmedi.`,
  longPressToSelect: "Seçim moduna girmek için uzun basın.",
  select: "Seç",
  selectedAll: "Tüm ögeler seçildi.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Hiçbir öge seçilmedi",
    one: () => `${t.number(e.count)} öge seçildi`,
    other: () => `${t.number(e.count)} öge seçildi`
  })}.`,
  selectedItem: (e) => `${e.item} seçildi.`
};
var Tv = {};
Tv = {
  deselectedItem: (e) => `${e.item} не вибрано.`,
  longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
  select: "Вибрати",
  selectedAll: "Усі елементи вибрано.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Жодних елементів не вибрано",
    one: () => `${t.number(e.count)} елемент вибрано`,
    other: () => `Вибрано елементів: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `${e.item} вибрано.`
};
var Rv = {};
Rv = {
  deselectedItem: (e) => `未选择 ${e.item}。`,
  longPressToSelect: "长按以进入选择模式。",
  select: "选择",
  selectedAll: "已选择所有项目。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "未选择项目",
    one: () => `已选择 ${t.number(e.count)} 个项目`,
    other: () => `已选择 ${t.number(e.count)} 个项目`
  })}。`,
  selectedItem: (e) => `已选择 ${e.item}。`
};
var Mv = {};
Mv = {
  deselectedItem: (e) => `未選取「${e.item}」。`,
  longPressToSelect: "長按以進入選擇模式。",
  select: "選取",
  selectedAll: "已選取所有項目。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "未選取任何項目",
    one: () => `已選取 ${t.number(e.count)} 個項目`,
    other: () => `已選取 ${t.number(e.count)} 個項目`
  })}。`,
  selectedItem: (e) => `已選取「${e.item}」。`
};
var ki = {};
ki = {
  "ar-AE": tv,
  "bg-BG": nv,
  "cs-CZ": rv,
  "da-DK": av,
  "de-DE": lv,
  "el-GR": iv,
  "en-US": ov,
  "es-ES": uv,
  "et-EE": sv,
  "fi-FI": dv,
  "fr-FR": cv,
  "he-IL": fv,
  "hr-HR": bv,
  "hu-HU": pv,
  "it-IT": hv,
  "ja-JP": mv,
  "ko-KR": vv,
  "lt-LT": gv,
  "lv-LV": yv,
  "nb-NO": $v,
  "nl-NL": xv,
  "pl-PL": Dv,
  "pt-BR": Cv,
  "pt-PT": Ev,
  "ro-RO": wv,
  "ru-RU": Pv,
  "sk-SK": kv,
  "sl-SI": Sv,
  "sr-SP": Bv,
  "sv-SE": Fv,
  "tr-TR": Av,
  "uk-UA": Tv,
  "zh-CN": Rv,
  "zh-TW": Mv
};
function uC(e) {
  return e && e.__esModule ? e.default : e;
}
function Nv(e, t) {
  let { getRowText: n = (o) => {
    var u, s, d, c;
    return (c = (u = (s = t.collection).getTextValue) === null || u === void 0 ? void 0 : u.call(s, o)) !== null && c !== void 0 ? c : (d = t.collection.getItem(o)) === null || d === void 0 ? void 0 : d.textValue;
  } } = e, r = Oe(uC(ki), "@react-aria/grid"), a = t.selectionManager.rawSelection, l = j(a), i = Re(() => {
    var o;
    if (!t.selectionManager.isFocused || a === l.current) {
      l.current = a;
      return;
    }
    let u = bc(a, l.current), s = bc(l.current, a), d = t.selectionManager.selectionBehavior === "replace", c = [];
    if (t.selectionManager.selectedKeys.size === 1 && d) {
      if (t.collection.getItem(t.selectionManager.selectedKeys.keys().next().value)) {
        let f = n(t.selectionManager.selectedKeys.keys().next().value);
        f && c.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (u.size === 1 && s.size === 0) {
      let f = n(u.keys().next().value);
      f && c.push(r.format("selectedItem", {
        item: f
      }));
    } else if (s.size === 1 && u.size === 0 && t.collection.getItem(s.keys().next().value)) {
      let f = n(s.keys().next().value);
      f && c.push(r.format("deselectedItem", {
        item: f
      }));
    }
    t.selectionManager.selectionMode === "multiple" && (c.length === 0 || a === "all" || a.size > 1 || l.current === "all" || ((o = l.current) === null || o === void 0 ? void 0 : o.size) > 1) && c.push(a === "all" ? r.format("selectedAll") : r.format("selectedCount", {
      count: a.size
    })), c.length > 0 && hn(c.join(" ")), l.current = a;
  });
  za(() => {
    if (t.selectionManager.isFocused) i();
    else {
      let o = requestAnimationFrame(i);
      return () => cancelAnimationFrame(o);
    }
  }, [
    a,
    t.selectionManager.isFocused
  ]);
}
function bc(e, t) {
  let n = /* @__PURE__ */ new Set();
  if (e === "all" || t === "all") return n;
  for (let r of e.keys()) t.has(r) || n.add(r);
  return n;
}
function sC(e) {
  return e && e.__esModule ? e.default : e;
}
function Vv(e) {
  let t = Oe(sC(ki), "@react-aria/grid"), n = Ou(), r = (n === "pointer" || n === "virtual" || n == null) && typeof window < "u" && "ontouchstart" in window, a = H(() => {
    let i = e.selectionManager.selectionMode, o = e.selectionManager.selectionBehavior, u;
    return r && (u = t.format("longPressToSelect")), o === "replace" && i !== "none" && e.hasItemActions ? u : void 0;
  }, [
    e.selectionManager.selectionMode,
    e.selectionManager.selectionBehavior,
    e.hasItemActions,
    t,
    r
  ]);
  return $n(a);
}
function dC(e, t, n) {
  let { isVirtualized: r, disallowTypeAhead: a, keyboardDelegate: l, focusMode: i, scrollRef: o, getRowText: u, onRowAction: s, onCellAction: d, escapeKeyBehavior: c = "clearSelection" } = e, { selectionManager: f } = t;
  !e["aria-label"] && !e["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let b = Rr({
    usage: "search",
    sensitivity: "base"
  }), { direction: p } = me(), h = t.selectionManager.disabledBehavior, m = H(() => l || new ev({
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    disabledBehavior: h,
    ref: n,
    direction: p,
    collator: b,
    focusMode: i
  }), [
    l,
    t.collection,
    t.disabledKeys,
    h,
    n,
    p,
    b,
    i
  ]), { collectionProps: v } = Pi({
    ref: n,
    selectionManager: f,
    keyboardDelegate: m,
    isVirtualized: r,
    scrollRef: o,
    disallowTypeAhead: a,
    escapeKeyBehavior: c
  }), y = Ee(e.id);
  bs.set(t, {
    keyboardDelegate: m,
    actions: {
      onRowAction: s,
      onCellAction: d
    }
  });
  let w = Vv({
    selectionManager: f,
    hasItemActions: !!(s || d)
  }), C = J(e, {
    labelable: !0
  }), D = ie((L) => {
    if (f.isFocused) {
      L.currentTarget.contains(L.target) || f.setFocused(!1);
      return;
    }
    L.currentTarget.contains(L.target) && f.setFocused(!0);
  }, [
    f
  ]), P = H(() => ({
    onBlur: v.onBlur,
    onFocus: D
  }), [
    D,
    v.onBlur
  ]), R = es(n, {
    isDisabled: t.collection.size !== 0
  }), V = _(
    C,
    {
      role: "grid",
      id: y,
      "aria-multiselectable": f.selectionMode === "multiple" ? "true" : void 0
    },
    t.isKeyboardNavigationDisabled ? P : v,
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    t.collection.size === 0 && {
      tabIndex: R ? -1 : 0
    } || void 0,
    w
  );
  return r && (V["aria-rowcount"] = t.collection.size, V["aria-colcount"] = t.collection.columnCount), Nv({
    getRowText: u
  }, t), {
    gridProps: V
  };
}
function cC() {
  return {
    rowGroupProps: {
      role: "rowgroup"
    }
  };
}
function fC(e, t, n) {
  var r, a;
  let { node: l, isVirtualized: i, shouldSelectOnPressUp: o, onAction: u } = e, { actions: s } = bs.get(t), d = s.onRowAction ? () => {
    var h;
    return (h = s.onRowAction) === null || h === void 0 ? void 0 : h.call(s, l.key);
  } : u, { itemProps: c, ...f } = oa({
    selectionManager: t.selectionManager,
    key: l.key,
    ref: n,
    isVirtualized: i,
    shouldSelectOnPressUp: o,
    onAction: d || !(l == null || (r = l.props) === null || r === void 0) && r.onAction ? At(l == null || (a = l.props) === null || a === void 0 ? void 0 : a.onAction, d) : void 0,
    isDisabled: t.collection.size === 0
  }), b = t.selectionManager.isSelected(l.key), p = {
    role: "row",
    "aria-selected": t.selectionManager.selectionMode !== "none" ? b : void 0,
    "aria-disabled": f.isDisabled || void 0,
    ...c
  };
  return i && (p["aria-rowindex"] = l.index + 1), {
    rowProps: p,
    ...f
  };
}
function Iv(e, t, n) {
  let { node: r, isVirtualized: a, focusMode: l = "child", shouldSelectOnPressUp: i, onAction: o } = e, { direction: u } = me(), { keyboardDelegate: s, actions: { onCellAction: d } } = bs.get(t), c = j(null), f = () => {
    if (n.current) {
      let w = Je(n.current);
      if (l === "child") {
        if (n.current.contains(document.activeElement) && n.current !== document.activeElement) return;
        let C = t.selectionManager.childFocusStrategy === "last" ? Po(w) : w.firstChild();
        if (C) {
          He(C);
          return;
        }
      }
      (c.current != null && r.key !== c.current || !n.current.contains(document.activeElement)) && He(n.current);
    }
  }, { itemProps: b, isPressed: p } = oa({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    focus: f,
    shouldSelectOnPressUp: i,
    onAction: d ? () => d(r.key) : o,
    isDisabled: t.collection.size === 0
  }), h = (w) => {
    if (!w.currentTarget.contains(w.target) || t.isKeyboardNavigationDisabled || !n.current || !document.activeElement) return;
    let C = Je(n.current);
    switch (C.currentNode = document.activeElement, w.key) {
      case "ArrowLeft": {
        let A = u === "rtl" ? C.nextNode() : C.previousNode();
        if (l === "child" && A === n.current && (A = null), w.preventDefault(), w.stopPropagation(), A)
          He(A), mt(A, {
            containingElement: ht(n.current)
          });
        else {
          var D;
          if (((D = s.getKeyLeftOf) === null || D === void 0 ? void 0 : D.call(s, r.key)) !== r.key) {
            var P;
            (P = n.current.parentElement) === null || P === void 0 || P.dispatchEvent(new KeyboardEvent(w.nativeEvent.type, w.nativeEvent));
            break;
          }
          l === "cell" && u === "rtl" ? (He(n.current), mt(n.current, {
            containingElement: ht(n.current)
          })) : (C.currentNode = n.current, A = u === "rtl" ? C.firstChild() : Po(C), A && (He(A), mt(A, {
            containingElement: ht(n.current)
          })));
        }
        break;
      }
      case "ArrowRight": {
        let A = u === "rtl" ? C.previousNode() : C.nextNode();
        if (l === "child" && A === n.current && (A = null), w.preventDefault(), w.stopPropagation(), A)
          He(A), mt(A, {
            containingElement: ht(n.current)
          });
        else {
          var R;
          if (((R = s.getKeyRightOf) === null || R === void 0 ? void 0 : R.call(s, r.key)) !== r.key) {
            var V;
            (V = n.current.parentElement) === null || V === void 0 || V.dispatchEvent(new KeyboardEvent(w.nativeEvent.type, w.nativeEvent));
            break;
          }
          l === "cell" && u === "ltr" ? (He(n.current), mt(n.current, {
            containingElement: ht(n.current)
          })) : (C.currentNode = n.current, A = u === "rtl" ? Po(C) : C.firstChild(), A && (He(A), mt(A, {
            containingElement: ht(n.current)
          })));
        }
        break;
      }
      case "ArrowUp":
      case "ArrowDown":
        if (!w.altKey && n.current.contains(w.target)) {
          var L;
          w.stopPropagation(), w.preventDefault(), (L = n.current.parentElement) === null || L === void 0 || L.dispatchEvent(new KeyboardEvent(w.nativeEvent.type, w.nativeEvent));
        }
        break;
    }
  }, m = (w) => {
    if (c.current = r.key, w.target !== n.current) {
      Nn() || t.selectionManager.setFocusedKey(r.key);
      return;
    }
    requestAnimationFrame(() => {
      l === "child" && document.activeElement === n.current && f();
    });
  }, v = _(b, {
    role: "gridcell",
    onKeyDownCapture: h,
    "aria-colspan": r.colSpan,
    "aria-colindex": r.colIndex != null ? r.colIndex + 1 : void 0,
    colSpan: a ? void 0 : r.colSpan,
    onFocus: m
  });
  var y;
  return a && (v["aria-colindex"] = ((y = r.colIndex) !== null && y !== void 0 ? y : r.index) + 1), i && v.tabIndex != null && v.onPointerDown == null && (v.onPointerDown = (w) => {
    let C = w.currentTarget, D = C.getAttribute("tabindex");
    C.removeAttribute("tabindex"), requestAnimationFrame(() => {
      D != null && C.setAttribute("tabindex", D);
    });
  }), {
    gridCellProps: v,
    isPressed: p
  };
}
function Po(e) {
  let t = null, n = null;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
function bC(e) {
  return e && e.__esModule ? e.default : e;
}
function Ov(e, t) {
  let { key: n } = e, r = t.selectionManager, a = Ee(), l = !t.selectionManager.canSelectItem(n), i = t.selectionManager.isSelected(n), o = () => r.toggleSelection(n);
  const u = Oe(bC(ki), "@react-aria/grid");
  return {
    checkboxProps: {
      id: a,
      "aria-label": u.format("select"),
      isSelected: i,
      isDisabled: l,
      onChange: o
    }
  };
}
function zv(e, t, n) {
  let { isVirtualized: r, keyboardDelegate: a, layoutDelegate: l, onAction: i, disallowTypeAhead: o, linkBehavior: u = "action", keyboardNavigationBehavior: s = "arrow", escapeKeyBehavior: d = "clearSelection" } = e;
  !e["aria-label"] && !e["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let { listProps: c } = os({
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    ref: n,
    keyboardDelegate: a,
    layoutDelegate: l,
    isVirtualized: r,
    selectOnFocus: t.selectionManager.selectionBehavior === "replace",
    shouldFocusWrap: e.shouldFocusWrap,
    linkBehavior: u,
    disallowTypeAhead: o,
    autoFocus: e.autoFocus,
    escapeKeyBehavior: d
  }), f = Ee(e.id);
  fs.set(t, {
    id: f,
    onAction: i,
    linkBehavior: u,
    keyboardNavigationBehavior: s
  });
  let b = Vv({
    selectionManager: t.selectionManager,
    hasItemActions: !!i
  }), p = es(n, {
    isDisabled: t.collection.size !== 0
  }), h = J(e, {
    labelable: !0
  }), m = _(
    h,
    {
      role: "grid",
      id: f,
      "aria-multiselectable": t.selectionManager.selectionMode === "multiple" ? "true" : void 0
    },
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    t.collection.size === 0 ? {
      tabIndex: p ? -1 : 0
    } : c,
    b
  );
  return r && (m["aria-rowcount"] = t.collection.size, m["aria-colcount"] = 1), Nv({}, t), {
    gridProps: m
  };
}
const pc = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function Kv(e, t, n) {
  var r, a;
  let { node: l, isVirtualized: i, shouldSelectOnPressUp: o } = e, { direction: u } = me(), { onAction: s, linkBehavior: d, keyboardNavigationBehavior: c } = fs.get(t), f = pn(), b = j(null), p = () => {
    var g;
    n.current !== null && (b.current != null && l.key !== b.current || !(!((g = n.current) === null || g === void 0) && g.contains(document.activeElement))) && He(n.current);
  }, h = {}, m = e.hasChildItems, v = t.selectionManager.isLink(l.key);
  if (l != null && "expandedKeys" in t) {
    var y, w, C;
    let g = (y = (w = t.collection).getChildren) === null || y === void 0 ? void 0 : y.call(w, l.key);
    m = m || [
      ...g ?? []
    ].length > 1, s == null && !v && t.selectionManager.selectionMode === "none" && m && (s = () => t.toggleKey(l.key));
    let B = m ? t.expandedKeys.has(l.key) : void 0, k = 1;
    var D;
    if (l.level > 0 && (l == null ? void 0 : l.parentKey) != null) {
      let I = t.collection.getItem(l.parentKey);
      if (I) {
        var P, R;
        let O = (P = (R = t.collection).getChildren) === null || P === void 0 ? void 0 : P.call(R, I.key);
        k = Fn(O).index + 1;
      }
    } else k = ((D = (C = [
      ...t.collection
    ].filter((I) => I.level === 0).at(-1)) === null || C === void 0 ? void 0 : C.index) !== null && D !== void 0 ? D : 0) + 1;
    h = {
      "aria-expanded": B,
      "aria-level": l.level + 1,
      "aria-posinset": (l == null ? void 0 : l.index) + 1,
      "aria-setsize": k
    };
  }
  let { itemProps: V, ...L } = oa({
    selectionManager: t.selectionManager,
    key: l.key,
    ref: n,
    isVirtualized: i,
    shouldSelectOnPressUp: o,
    onAction: s || !((r = l.props) === null || r === void 0) && r.onAction ? At((a = l.props) === null || a === void 0 ? void 0 : a.onAction, s ? () => s(l.key) : void 0) : void 0,
    focus: p,
    linkBehavior: d
  }), A = (g) => {
    if (!g.currentTarget.contains(g.target) || !n.current || !document.activeElement) return;
    let B = Je(n.current);
    if (B.currentNode = document.activeElement, "expandedKeys" in t && document.activeElement === n.current) {
      if (g.key === pc.expand[u] && t.selectionManager.focusedKey === l.key && m && !t.expandedKeys.has(l.key)) {
        t.toggleKey(l.key), g.stopPropagation();
        return;
      } else if (g.key === pc.collapse[u] && t.selectionManager.focusedKey === l.key && m && t.expandedKeys.has(l.key)) {
        t.toggleKey(l.key), g.stopPropagation();
        return;
      }
    }
    switch (g.key) {
      case "ArrowLeft":
        if (c === "arrow") {
          let I = u === "rtl" ? B.nextNode() : B.previousNode();
          if (I)
            g.preventDefault(), g.stopPropagation(), He(I), mt(I, {
              containingElement: ht(n.current)
            });
          else if (g.preventDefault(), g.stopPropagation(), u === "rtl")
            He(n.current), mt(n.current, {
              containingElement: ht(n.current)
            });
          else {
            B.currentNode = n.current;
            let O = hc(B);
            O && (He(O), mt(O, {
              containingElement: ht(n.current)
            }));
          }
        }
        break;
      case "ArrowRight":
        if (c === "arrow") {
          let I = u === "rtl" ? B.previousNode() : B.nextNode();
          if (I)
            g.preventDefault(), g.stopPropagation(), He(I), mt(I, {
              containingElement: ht(n.current)
            });
          else if (g.preventDefault(), g.stopPropagation(), u === "ltr")
            He(n.current), mt(n.current, {
              containingElement: ht(n.current)
            });
          else {
            B.currentNode = n.current;
            let O = hc(B);
            O && (He(O), mt(O, {
              containingElement: ht(n.current)
            }));
          }
        }
        break;
      case "ArrowUp":
      case "ArrowDown":
        if (!g.altKey && n.current.contains(g.target)) {
          var k;
          g.stopPropagation(), g.preventDefault(), (k = n.current.parentElement) === null || k === void 0 || k.dispatchEvent(new KeyboardEvent(g.nativeEvent.type, g.nativeEvent));
        }
        break;
      case "Tab":
        if (c === "tab") {
          let I = Je(n.current, {
            tabbable: !0
          });
          I.currentNode = document.activeElement, (g.shiftKey ? I.previousNode() : I.nextNode()) && g.stopPropagation();
        }
    }
  }, $ = (g) => {
    if (b.current = l.key, g.target !== n.current) {
      Nn() || t.selectionManager.setFocusedKey(l.key);
      return;
    }
  }, S = Au(l.props), T = L.hasAction ? S : {}, M = _(V, T, {
    role: "row",
    onKeyDownCapture: A,
    onFocus: $,
    // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
    "aria-label": l.textValue || void 0,
    "aria-selected": t.selectionManager.canSelectItem(l.key) ? t.selectionManager.isSelected(l.key) : void 0,
    "aria-disabled": t.selectionManager.isDisabled(l.key) || void 0,
    "aria-labelledby": f && l.textValue ? `${du(t, l.key)} ${f}` : void 0,
    id: du(t, l.key)
  });
  i && (M["aria-rowindex"] = l.index + 1);
  let K = {
    role: "gridcell",
    "aria-colindex": 1
  };
  return {
    rowProps: {
      ..._(M, h)
    },
    gridCellProps: K,
    descriptionProps: {
      id: f
    },
    ...L
  };
}
function hc(e) {
  let t = null, n = null;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
function pC(e, t) {
  let { key: n } = e;
  const { checkboxProps: r } = Ov(e, t);
  return {
    checkboxProps: {
      ...r,
      "aria-labelledby": `${r.id} ${du(t, n)}`
    }
  };
}
function jv(e) {
  let { value: t = 0, minValue: n = 0, maxValue: r = 100, valueLabel: a, isIndeterminate: l, formatOptions: i = {
    style: "percent"
  } } = e, o = J(e, {
    labelable: !0
  }), { labelProps: u, fieldProps: s } = il({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = Qe(t, n, r);
  let d = (t - n) / (r - n), c = ei(i);
  if (!l && !a) {
    let f = i.style === "percent" ? d : t;
    a = c.format(f);
  }
  return {
    progressBarProps: _(o, {
      ...s,
      "aria-valuenow": l ? void 0 : t,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": l ? void 0 : a,
      role: "progressbar"
    }),
    labelProps: u
  };
}
function hC(e) {
  let { progressBarProps: t, labelProps: n } = jv(e);
  return {
    meterProps: {
      ...t,
      // Use the meter role if available, but fall back to progressbar if not
      // Chrome currently falls back from meter automatically, and Firefox
      // does not support meter at all. Safari 13+ seems to support meter properly.
      // https://bugs.chromium.org/p/chromium/issues/detail?id=944542
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1460378
      role: "meter progressbar"
    },
    labelProps: n
  };
}
const Lv = /* @__PURE__ */ new WeakMap();
function mC(e, t, n) {
  let { value: r, children: a, "aria-label": l, "aria-labelledby": i } = e;
  const o = e.isDisabled || t.isDisabled;
  let u = a != null, s = l != null || i != null;
  !u && !s && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let d = t.selectedValue === r, c = (V) => {
    V.stopPropagation(), t.setSelectedValue(r);
  }, { pressProps: f, isPressed: b } = Tt({
    isDisabled: o
  }), { pressProps: p, isPressed: h } = Tt({
    isDisabled: o,
    onPress() {
      var V;
      t.setSelectedValue(r), (V = n.current) === null || V === void 0 || V.focus();
    }
  }), { focusableProps: m } = un(_(e, {
    onFocus: () => t.setLastFocusedValue(r)
  }), n), v = _(f, m), y = J(e, {
    labelable: !0
  }), w = -1;
  t.selectedValue != null ? t.selectedValue === r && (w = 0) : (t.lastFocusedValue === r || t.lastFocusedValue == null) && (w = 0), o && (w = void 0);
  let { name: C, descriptionId: D, errorMessageId: P, validationBehavior: R } = Lv.get(t);
  return zn(n, t.selectedValue, t.setSelectedValue), ll({
    validationBehavior: R
  }, t, n), {
    labelProps: _(p, {
      onClick: (V) => V.preventDefault()
    }),
    inputProps: _(y, {
      ...v,
      type: "radio",
      name: C,
      tabIndex: w,
      disabled: o,
      required: t.isRequired && R === "native",
      checked: d,
      value: r,
      onChange: c,
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? P : null,
        D
      ].filter(Boolean).join(" ") || void 0
    }),
    isDisabled: o,
    isSelected: d,
    isPressed: b || h
  };
}
function vC(e, t) {
  let { name: n, isReadOnly: r, isRequired: a, isDisabled: l, orientation: i = "vertical", validationBehavior: o = "aria" } = e, { direction: u } = me(), { isInvalid: s, validationErrors: d, validationDetails: c } = t.displayValidation, { labelProps: f, fieldProps: b, descriptionProps: p, errorMessageProps: h } = or({
    ...e,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: t.isInvalid,
    errorMessage: e.errorMessage || d
  }), m = J(e, {
    labelable: !0
  }), { focusWithinProps: v } = jt({
    onBlurWithin(C) {
      var D;
      (D = e.onBlur) === null || D === void 0 || D.call(e, C), t.selectedValue || t.setLastFocusedValue(null);
    },
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), y = (C) => {
    let D;
    switch (C.key) {
      case "ArrowRight":
        u === "rtl" && i !== "vertical" ? D = "prev" : D = "next";
        break;
      case "ArrowLeft":
        u === "rtl" && i !== "vertical" ? D = "next" : D = "prev";
        break;
      case "ArrowDown":
        D = "next";
        break;
      case "ArrowUp":
        D = "prev";
        break;
      default:
        return;
    }
    C.preventDefault();
    let P = Je(C.currentTarget, {
      from: C.target
    }), R;
    D === "next" ? (R = P.nextNode(), R || (P.currentNode = C.currentTarget, R = P.firstChild())) : (R = P.previousNode(), R || (P.currentNode = C.currentTarget, R = P.lastChild())), R && (R.focus(), t.setSelectedValue(R.value));
  }, w = Ee(n);
  return Lv.set(t, {
    name: w,
    descriptionId: p.id,
    errorMessageId: h.id,
    validationBehavior: o
  }), {
    radioGroupProps: _(m, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown: y,
      "aria-invalid": t.isInvalid || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-readonly": r || void 0,
      "aria-required": a || void 0,
      "aria-disabled": l || void 0,
      "aria-orientation": i,
      ...b,
      ...v
    }),
    labelProps: f,
    descriptionProps: p,
    errorMessageProps: h,
    isInvalid: s,
    validationErrors: d,
    validationDetails: c
  };
}
var Hv = {};
Hv = {
  "Clear search": "مسح البحث"
};
var _v = {};
_v = {
  "Clear search": "Изчистване на търсене"
};
var Uv = {};
Uv = {
  "Clear search": "Vymazat hledání"
};
var Wv = {};
Wv = {
  "Clear search": "Ryd søgning"
};
var Gv = {};
Gv = {
  "Clear search": "Suche zurücksetzen"
};
var Zv = {};
Zv = {
  "Clear search": "Απαλοιφή αναζήτησης"
};
var Yv = {};
Yv = {
  "Clear search": "Clear search"
};
var qv = {};
qv = {
  "Clear search": "Borrar búsqueda"
};
var Xv = {};
Xv = {
  "Clear search": "Tühjenda otsing"
};
var Jv = {};
Jv = {
  "Clear search": "Tyhjennä haku"
};
var Qv = {};
Qv = {
  "Clear search": "Effacer la recherche"
};
var eg = {};
eg = {
  "Clear search": "נקה חיפוש"
};
var tg = {};
tg = {
  "Clear search": "Obriši pretragu"
};
var ng = {};
ng = {
  "Clear search": "Keresés törlése"
};
var rg = {};
rg = {
  "Clear search": "Cancella ricerca"
};
var ag = {};
ag = {
  "Clear search": "検索をクリア"
};
var lg = {};
lg = {
  "Clear search": "검색 지우기"
};
var ig = {};
ig = {
  "Clear search": "Išvalyti iešką"
};
var og = {};
og = {
  "Clear search": "Notīrīt meklēšanu"
};
var ug = {};
ug = {
  "Clear search": "Tøm søk"
};
var sg = {};
sg = {
  "Clear search": "Zoekactie wissen"
};
var dg = {};
dg = {
  "Clear search": "Wyczyść zawartość wyszukiwania"
};
var cg = {};
cg = {
  "Clear search": "Limpar pesquisa"
};
var fg = {};
fg = {
  "Clear search": "Limpar pesquisa"
};
var bg = {};
bg = {
  "Clear search": "Ştergeţi căutarea"
};
var pg = {};
pg = {
  "Clear search": "Очистить поиск"
};
var hg = {};
hg = {
  "Clear search": "Vymazať vyhľadávanie"
};
var mg = {};
mg = {
  "Clear search": "Počisti iskanje"
};
var vg = {};
vg = {
  "Clear search": "Obriši pretragu"
};
var gg = {};
gg = {
  "Clear search": "Rensa sökning"
};
var yg = {};
yg = {
  "Clear search": "Aramayı temizle"
};
var $g = {};
$g = {
  "Clear search": "Очистити пошук"
};
var xg = {};
xg = {
  "Clear search": "清除搜索"
};
var Dg = {};
Dg = {
  "Clear search": "清除搜尋條件"
};
var Cg = {};
Cg = {
  "ar-AE": Hv,
  "bg-BG": _v,
  "cs-CZ": Uv,
  "da-DK": Wv,
  "de-DE": Gv,
  "el-GR": Zv,
  "en-US": Yv,
  "es-ES": qv,
  "et-EE": Xv,
  "fi-FI": Jv,
  "fr-FR": Qv,
  "he-IL": eg,
  "hr-HR": tg,
  "hu-HU": ng,
  "it-IT": rg,
  "ja-JP": ag,
  "ko-KR": lg,
  "lt-LT": ig,
  "lv-LV": og,
  "nb-NO": ug,
  "nl-NL": sg,
  "pl-PL": dg,
  "pt-BR": cg,
  "pt-PT": fg,
  "ro-RO": bg,
  "ru-RU": pg,
  "sk-SK": hg,
  "sl-SI": mg,
  "sr-SP": vg,
  "sv-SE": gg,
  "tr-TR": yg,
  "uk-UA": $g,
  "zh-CN": xg,
  "zh-TW": Dg
};
function gC(e) {
  return e && e.__esModule ? e.default : e;
}
function yC(e, t, n) {
  let r = Oe(gC(Cg), "@react-aria/searchfield"), { isDisabled: a, isReadOnly: l, onSubmit: i, onClear: o, type: u = "search" } = e, s = (v) => {
    const y = v.key;
    y === "Enter" && (a || l) && v.preventDefault(), !(a || l) && (y === "Enter" && i && (v.preventDefault(), i(t.value)), y === "Escape" && (t.value === "" && (!n.current || n.current.value === "") ? v.continuePropagation() : (v.preventDefault(), t.setValue(""), o && o())));
  }, d = () => {
    t.setValue(""), o && o();
  }, c = () => {
    var v;
    (v = n.current) === null || v === void 0 || v.focus();
  }, { labelProps: f, inputProps: b, descriptionProps: p, errorMessageProps: h, ...m } = Ei({
    ...e,
    value: t.value,
    onChange: t.setValue,
    onKeyDown: l ? e.onKeyDown : At(s, e.onKeyDown),
    type: u
  }, n);
  return {
    labelProps: f,
    inputProps: {
      ...b,
      // already handled by useSearchFieldState
      defaultValue: void 0
    },
    clearButtonProps: {
      "aria-label": r.format("Clear search"),
      excludeFromTabOrder: !0,
      preventFocusOnPress: !0,
      isDisabled: a || l,
      onPress: d,
      onPressStart: c
    },
    descriptionProps: p,
    errorMessageProps: h,
    ...m
  };
}
const Eg = /* @__PURE__ */ new WeakMap();
function $C(e, t, n) {
  let { keyboardDelegate: r, isDisabled: a, isRequired: l, name: i, validationBehavior: o = "aria" } = e, u = Rr({
    usage: "search",
    sensitivity: "base"
  }), s = H(() => r || new lr(t.collection, t.disabledKeys, n, u), [
    r,
    t.collection,
    t.disabledKeys,
    u,
    n
  ]), { menuTriggerProps: d, menuProps: c } = mm({
    isDisabled: a,
    type: "listbox"
  }, t, n), f = (V) => {
    switch (V.key) {
      case "ArrowLeft": {
        var L, A;
        V.preventDefault();
        let T = t.selectedKey != null ? (L = s.getKeyAbove) === null || L === void 0 ? void 0 : L.call(s, t.selectedKey) : (A = s.getFirstKey) === null || A === void 0 ? void 0 : A.call(s);
        T && t.setSelectedKey(T);
        break;
      }
      case "ArrowRight": {
        var $, S;
        V.preventDefault();
        let T = t.selectedKey != null ? ($ = s.getKeyBelow) === null || $ === void 0 ? void 0 : $.call(s, t.selectedKey) : (S = s.getFirstKey) === null || S === void 0 ? void 0 : S.call(s);
        T && t.setSelectedKey(T);
        break;
      }
    }
  }, { typeSelectProps: b } = M3({
    keyboardDelegate: s,
    selectionManager: t.selectionManager,
    onTypeSelect(V) {
      t.setSelectedKey(V);
    }
  }), { isInvalid: p, validationErrors: h, validationDetails: m } = t.displayValidation, { labelProps: v, fieldProps: y, descriptionProps: w, errorMessageProps: C } = or({
    ...e,
    labelElementType: "span",
    isInvalid: p,
    errorMessage: e.errorMessage || h
  });
  b.onKeyDown = b.onKeyDownCapture, delete b.onKeyDownCapture;
  let D = J(e, {
    labelable: !0
  }), P = _(b, d, y), R = Ee();
  return Eg.set(t, {
    isDisabled: a,
    isRequired: l,
    name: i,
    validationBehavior: o
  }), {
    labelProps: {
      ...v,
      onClick: () => {
        if (!e.isDisabled) {
          var V;
          (V = n.current) === null || V === void 0 || V.focus(), Iu("keyboard");
        }
      }
    },
    triggerProps: _(D, {
      ...P,
      isDisabled: a,
      onKeyDown: At(P.onKeyDown, f, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        R,
        P["aria-labelledby"],
        P["aria-label"] && !P["aria-labelledby"] ? P.id : null
      ].filter(Boolean).join(" "),
      onFocus(V) {
        t.isFocused || (e.onFocus && e.onFocus(V), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(V) {
        t.isOpen || (e.onBlur && e.onBlur(V), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: R
    },
    menuProps: {
      ...c,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (V) => {
        V.currentTarget.contains(V.relatedTarget) || (e.onBlur && e.onBlur(V), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        y["aria-labelledby"],
        P["aria-label"] && !y["aria-labelledby"] ? P.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: w,
    errorMessageProps: C,
    isInvalid: p,
    validationErrors: h,
    validationDetails: m
  };
}
function xC(e, t, n) {
  let r = Eg.get(t) || {}, { autoComplete: a, name: l = r.name, isDisabled: i = r.isDisabled } = e, { validationBehavior: o, isRequired: u } = r, { visuallyHiddenProps: s } = sn();
  zn(e.selectRef, t.selectedKey, t.setSelectedKey), ll({
    validationBehavior: o,
    focus: () => {
      var c;
      return (c = n.current) === null || c === void 0 ? void 0 : c.focus();
    }
  }, t, e.selectRef);
  var d;
  return {
    containerProps: {
      ...s,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: a,
      disabled: i,
      required: o === "native" && u,
      name: l,
      value: (d = t.selectedKey) !== null && d !== void 0 ? d : void 0,
      onChange: (c) => t.setSelectedKey(c.target.value)
    }
  };
}
function DC(e) {
  let { state: t, triggerRef: n, label: r, name: a, isDisabled: l } = e, i = j(null), { containerProps: o, selectProps: u } = xC({
    ...e,
    selectRef: i
  }, t, n);
  var s;
  return t.collection.size <= 300 ? /* @__PURE__ */ x.createElement("div", {
    ...o,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ x.createElement("label", null, r, /* @__PURE__ */ x.createElement("select", {
    ...u,
    ref: i
  }, /* @__PURE__ */ x.createElement("option", null), [
    ...t.collection.getKeys()
  ].map((d) => {
    let c = t.collection.getItem(d);
    if (c && c.type === "item") return /* @__PURE__ */ x.createElement("option", {
      key: c.key,
      value: c.key
    }, c.textValue);
  })))) : a ? /* @__PURE__ */ x.createElement("input", {
    type: "hidden",
    autoComplete: u.autoComplete,
    name: a,
    disabled: l,
    value: (s = t.selectedKey) !== null && s !== void 0 ? s : ""
  }) : null;
}
function CC(e) {
  let t = J(e, {
    labelable: !0
  }), n;
  return e.orientation === "vertical" && (n = "vertical"), e.elementType !== "hr" ? {
    separatorProps: {
      ...t,
      role: "separator",
      "aria-orientation": n
    }
  } : {
    separatorProps: t
  };
}
function EC(e, t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isPressed: i, isDisabled: o, isReadOnly: u } = mb(e, t, n);
  return {
    labelProps: r,
    inputProps: {
      ...a,
      role: "switch",
      checked: l
    },
    isSelected: l,
    isPressed: i,
    isDisabled: o,
    isReadOnly: u
  };
}
const ps = /* @__PURE__ */ new WeakMap();
function cu(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function wg(e, t) {
  let n = ps.get(e);
  if (!n) throw new Error("Unknown grid");
  return `${n}-${cu(t)}`;
}
function Pg(e, t, n) {
  let r = ps.get(e);
  if (!r) throw new Error("Unknown grid");
  return `${r}-${cu(t)}-${cu(n)}`;
}
function kg(e, t) {
  return [
    ...e.collection.rowHeaderColumnKeys
  ].map((n) => Pg(e, t, n)).join(" ");
}
var Sg = {};
Sg = {
  ascending: "تصاعدي",
  ascendingSort: (e) => `ترتيب حسب العمود ${e.columnName} بترتيب تصاعدي`,
  columnSize: (e) => `${e.value} بالبكسل`,
  descending: "تنازلي",
  descendingSort: (e) => `ترتيب حسب العمود ${e.columnName} بترتيب تنازلي`,
  resizerDescription: "اضغط على مفتاح Enter لبدء تغيير الحجم",
  select: "تحديد",
  selectAll: "تحديد الكل",
  sortable: "عمود قابل للترتيب"
};
var Bg = {};
Bg = {
  ascending: "възходящ",
  ascendingSort: (e) => `сортирано по колона ${e.columnName} във възходящ ред`,
  columnSize: (e) => `${e.value} пиксела`,
  descending: "низходящ",
  descendingSort: (e) => `сортирано по колона ${e.columnName} в низходящ ред`,
  resizerDescription: "Натиснете „Enter“, за да започнете да преоразмерявате",
  select: "Изберете",
  selectAll: "Изберете всичко",
  sortable: "сортираща колона"
};
var Fg = {};
Fg = {
  ascending: "vzestupně",
  ascendingSort: (e) => `řazeno vzestupně podle sloupce ${e.columnName}`,
  columnSize: (e) => `${e.value} pixelů`,
  descending: "sestupně",
  descendingSort: (e) => `řazeno sestupně podle sloupce ${e.columnName}`,
  resizerDescription: "Stisknutím klávesy Enter začnete měnit velikost",
  select: "Vybrat",
  selectAll: "Vybrat vše",
  sortable: "sloupec s možností řazení"
};
var Ag = {};
Ag = {
  ascending: "stigende",
  ascendingSort: (e) => `sorteret efter kolonne ${e.columnName} i stigende rækkefølge`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "faldende",
  descendingSort: (e) => `sorteret efter kolonne ${e.columnName} i faldende rækkefølge`,
  resizerDescription: "Tryk på Enter for at ændre størrelse",
  select: "Vælg",
  selectAll: "Vælg alle",
  sortable: "sorterbar kolonne"
};
var Tg = {};
Tg = {
  ascending: "aufsteigend",
  ascendingSort: (e) => `sortiert nach Spalte ${e.columnName} in aufsteigender Reihenfolge`,
  columnSize: (e) => `${e.value} Pixel`,
  descending: "absteigend",
  descendingSort: (e) => `sortiert nach Spalte ${e.columnName} in absteigender Reihenfolge`,
  resizerDescription: "Eingabetaste zum Starten der Größenänderung drücken",
  select: "Auswählen",
  selectAll: "Alles auswählen",
  sortable: "sortierbare Spalte"
};
var Rg = {};
Rg = {
  ascending: "αύξουσα",
  ascendingSort: (e) => `διαλογή ανά στήλη ${e.columnName} σε αύξουσα σειρά`,
  columnSize: (e) => `${e.value} pixel`,
  descending: "φθίνουσα",
  descendingSort: (e) => `διαλογή ανά στήλη ${e.columnName} σε φθίνουσα σειρά`,
  resizerDescription: "Πατήστε Enter για έναρξη της αλλαγής μεγέθους",
  select: "Επιλογή",
  selectAll: "Επιλογή όλων",
  sortable: "Στήλη διαλογής"
};
var Mg = {};
Mg = {
  select: "Select",
  selectAll: "Select All",
  sortable: "sortable column",
  ascending: "ascending",
  descending: "descending",
  ascendingSort: (e) => `sorted by column ${e.columnName} in ascending order`,
  descendingSort: (e) => `sorted by column ${e.columnName} in descending order`,
  columnSize: (e) => `${e.value} pixels`,
  resizerDescription: "Press Enter to start resizing"
};
var Ng = {};
Ng = {
  ascending: "ascendente",
  ascendingSort: (e) => `ordenado por columna ${e.columnName} en sentido ascendente`,
  columnSize: (e) => `${e.value} píxeles`,
  descending: "descendente",
  descendingSort: (e) => `ordenado por columna ${e.columnName} en orden descendente`,
  resizerDescription: "Pulse Intro para empezar a redimensionar",
  select: "Seleccionar",
  selectAll: "Seleccionar todos",
  sortable: "columna ordenable"
};
var Vg = {};
Vg = {
  ascending: "tõusev järjestus",
  ascendingSort: (e) => `sorditud veeru järgi ${e.columnName} tõusvas järjestuses`,
  columnSize: (e) => `${e.value} pikslit`,
  descending: "laskuv järjestus",
  descendingSort: (e) => `sorditud veeru järgi ${e.columnName} laskuvas järjestuses`,
  resizerDescription: "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  select: "Vali",
  selectAll: "Vali kõik",
  sortable: "sorditav veerg"
};
var Ig = {};
Ig = {
  ascending: "nouseva",
  ascendingSort: (e) => `lajiteltu sarakkeen ${e.columnName} mukaan nousevassa järjestyksessä`,
  columnSize: (e) => `${e.value} pikseliä`,
  descending: "laskeva",
  descendingSort: (e) => `lajiteltu sarakkeen ${e.columnName} mukaan laskevassa järjestyksessä`,
  resizerDescription: "Aloita koon muutos painamalla Enter-näppäintä",
  select: "Valitse",
  selectAll: "Valitse kaikki",
  sortable: "lajiteltava sarake"
};
var Og = {};
Og = {
  ascending: "croissant",
  ascendingSort: (e) => `trié en fonction de la colonne ${e.columnName} par ordre croissant`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "décroissant",
  descendingSort: (e) => `trié en fonction de la colonne ${e.columnName} par ordre décroissant`,
  resizerDescription: "Appuyez sur Entrée pour commencer le redimensionnement.",
  select: "Sélectionner",
  selectAll: "Sélectionner tout",
  sortable: "colonne triable"
};
var zg = {};
zg = {
  ascending: "עולה",
  ascendingSort: (e) => `מוין לפי עמודה ${e.columnName} בסדר עולה`,
  columnSize: (e) => `${e.value} פיקסלים`,
  descending: "יורד",
  descendingSort: (e) => `מוין לפי עמודה ${e.columnName} בסדר יורד`,
  resizerDescription: "הקש Enter כדי לשנות את הגודל",
  select: "בחר",
  selectAll: "בחר הכול",
  sortable: "עמודה שניתן למיין"
};
var Kg = {};
Kg = {
  ascending: "rastući",
  ascendingSort: (e) => `razvrstano po stupcima ${e.columnName} rastućem redoslijedom`,
  columnSize: (e) => `${e.value} piksela`,
  descending: "padajući",
  descendingSort: (e) => `razvrstano po stupcima ${e.columnName} padajućim redoslijedom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Odaberite",
  selectAll: "Odaberite sve",
  sortable: "stupac koji se može razvrstati"
};
var jg = {};
jg = {
  ascending: "növekvő",
  ascendingSort: (e) => `rendezve a(z) ${e.columnName} oszlop szerint, növekvő sorrendben`,
  columnSize: (e) => `${e.value} képpont`,
  descending: "csökkenő",
  descendingSort: (e) => `rendezve a(z) ${e.columnName} oszlop szerint, csökkenő sorrendben`,
  resizerDescription: "Nyomja le az Enter billentyűt az átméretezés megkezdéséhez",
  select: "Kijelölés",
  selectAll: "Összes kijelölése",
  sortable: "rendezendő oszlop"
};
var Lg = {};
Lg = {
  ascending: "crescente",
  ascendingSort: (e) => `in ordine crescente in base alla colonna ${e.columnName}`,
  columnSize: (e) => `${e.value} pixel`,
  descending: "decrescente",
  descendingSort: (e) => `in ordine decrescente in base alla colonna ${e.columnName}`,
  resizerDescription: "Premi Invio per iniziare a ridimensionare",
  select: "Seleziona",
  selectAll: "Seleziona tutto",
  sortable: "colonna ordinabile"
};
var Hg = {};
Hg = {
  ascending: "昇順",
  ascendingSort: (e) => `列 ${e.columnName} を昇順で並べ替え`,
  columnSize: (e) => `${e.value} ピクセル`,
  descending: "降順",
  descendingSort: (e) => `列 ${e.columnName} を降順で並べ替え`,
  resizerDescription: "Enter キーを押してサイズ変更を開始",
  select: "選択",
  selectAll: "すべて選択",
  sortable: "並べ替え可能な列"
};
var _g = {};
_g = {
  ascending: "오름차순",
  ascendingSort: (e) => `${e.columnName} 열을 기준으로 오름차순으로 정렬됨`,
  columnSize: (e) => `${e.value} 픽셀`,
  descending: "내림차순",
  descendingSort: (e) => `${e.columnName} 열을 기준으로 내림차순으로 정렬됨`,
  resizerDescription: "크기 조정을 시작하려면 Enter를 누르세요.",
  select: "선택",
  selectAll: "모두 선택",
  sortable: "정렬 가능한 열"
};
var Ug = {};
Ug = {
  ascending: "didėjančia tvarka",
  ascendingSort: (e) => `surikiuota pagal stulpelį ${e.columnName} didėjančia tvarka`,
  columnSize: (e) => `${e.value} piks.`,
  descending: "mažėjančia tvarka",
  descendingSort: (e) => `surikiuota pagal stulpelį ${e.columnName} mažėjančia tvarka`,
  resizerDescription: "Paspauskite „Enter“, kad pradėtumėte keisti dydį",
  select: "Pasirinkti",
  selectAll: "Pasirinkti viską",
  sortable: "rikiuojamas stulpelis"
};
var Wg = {};
Wg = {
  ascending: "augošā secībā",
  ascendingSort: (e) => `kārtots pēc kolonnas ${e.columnName} augošā secībā`,
  columnSize: (e) => `${e.value} pikseļi`,
  descending: "dilstošā secībā",
  descendingSort: (e) => `kārtots pēc kolonnas ${e.columnName} dilstošā secībā`,
  resizerDescription: "Nospiediet Enter, lai sāktu izmēru mainīšanu",
  select: "Atlasīt",
  selectAll: "Atlasīt visu",
  sortable: "kārtojamā kolonna"
};
var Gg = {};
Gg = {
  ascending: "stigende",
  ascendingSort: (e) => `sortert etter kolonne ${e.columnName} i stigende rekkefølge`,
  columnSize: (e) => `${e.value} piksler`,
  descending: "synkende",
  descendingSort: (e) => `sortert etter kolonne ${e.columnName} i synkende rekkefølge`,
  resizerDescription: "Trykk på Enter for å starte størrelsesendring",
  select: "Velg",
  selectAll: "Velg alle",
  sortable: "kolonne som kan sorteres"
};
var Zg = {};
Zg = {
  ascending: "oplopend",
  ascendingSort: (e) => `gesorteerd in oplopende volgorde in kolom ${e.columnName}`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "aflopend",
  descendingSort: (e) => `gesorteerd in aflopende volgorde in kolom ${e.columnName}`,
  resizerDescription: "Druk op Enter om het formaat te wijzigen",
  select: "Selecteren",
  selectAll: "Alles selecteren",
  sortable: "sorteerbare kolom"
};
var Yg = {};
Yg = {
  ascending: "rosnąco",
  ascendingSort: (e) => `posortowano według kolumny ${e.columnName} w porządku rosnącym`,
  columnSize: (e) => `Liczba pikseli: ${e.value}`,
  descending: "malejąco",
  descendingSort: (e) => `posortowano według kolumny ${e.columnName} w porządku malejącym`,
  resizerDescription: "Naciśnij Enter, aby rozpocząć zmienianie rozmiaru",
  select: "Zaznacz",
  selectAll: "Zaznacz wszystko",
  sortable: "kolumna z możliwością sortowania"
};
var qg = {};
qg = {
  ascending: "crescente",
  ascendingSort: (e) => `classificado pela coluna ${e.columnName} em ordem crescente`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "decrescente",
  descendingSort: (e) => `classificado pela coluna ${e.columnName} em ordem decrescente`,
  resizerDescription: "Pressione Enter para começar a redimensionar",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "coluna classificável"
};
var Xg = {};
Xg = {
  ascending: "ascendente",
  ascendingSort: (e) => `Ordenar por coluna ${e.columnName} em ordem ascendente`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "descendente",
  descendingSort: (e) => `Ordenar por coluna ${e.columnName} em ordem descendente`,
  resizerDescription: "Prima Enter para iniciar o redimensionamento",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "Coluna ordenável"
};
var Jg = {};
Jg = {
  ascending: "crescătoare",
  ascendingSort: (e) => `sortate după coloana ${e.columnName} în ordine crescătoare`,
  columnSize: (e) => `${e.value} pixeli`,
  descending: "descrescătoare",
  descendingSort: (e) => `sortate după coloana ${e.columnName} în ordine descrescătoare`,
  resizerDescription: "Apăsați pe Enter pentru a începe redimensionarea",
  select: "Selectare",
  selectAll: "Selectare totală",
  sortable: "coloană sortabilă"
};
var Qg = {};
Qg = {
  ascending: "возрастание",
  ascendingSort: (e) => `сортировать столбец ${e.columnName} в порядке возрастания`,
  columnSize: (e) => `${e.value} пикс.`,
  descending: "убывание",
  descendingSort: (e) => `сортировать столбец ${e.columnName} в порядке убывания`,
  resizerDescription: "Нажмите клавишу Enter для начала изменения размеров",
  select: "Выбрать",
  selectAll: "Выбрать все",
  sortable: "сортируемый столбец"
};
var ey = {};
ey = {
  ascending: "vzostupne",
  ascendingSort: (e) => `zoradené zostupne podľa stĺpca ${e.columnName}`,
  columnSize: (e) => `Počet pixelov: ${e.value}`,
  descending: "zostupne",
  descendingSort: (e) => `zoradené zostupne podľa stĺpca ${e.columnName}`,
  resizerDescription: "Stlačením klávesu Enter začnete zmenu veľkosti",
  select: "Vybrať",
  selectAll: "Vybrať všetko",
  sortable: "zoraditeľný stĺpec"
};
var ty = {};
ty = {
  ascending: "naraščajoče",
  ascendingSort: (e) => `razvrščeno po stolpcu ${e.columnName} v naraščajočem vrstnem redu`,
  columnSize: (e) => `${e.value} slikovnih pik`,
  descending: "padajoče",
  descendingSort: (e) => `razvrščeno po stolpcu ${e.columnName} v padajočem vrstnem redu`,
  resizerDescription: "Pritisnite tipko Enter da začnete spreminjati velikost",
  select: "Izberite",
  selectAll: "Izberite vse",
  sortable: "razvrstljivi stolpec"
};
var ny = {};
ny = {
  ascending: "rastući",
  ascendingSort: (e) => `sortirano po kolonama ${e.columnName} rastućim redosledom`,
  columnSize: (e) => `${e.value} piksela`,
  descending: "padajući",
  descendingSort: (e) => `sortirano po kolonama ${e.columnName} padajućim redosledom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Izaberite",
  selectAll: "Izaberite sve",
  sortable: "kolona koja se može sortirati"
};
var ry = {};
ry = {
  ascending: "stigande",
  ascendingSort: (e) => `sorterat på kolumn ${e.columnName} i stigande ordning`,
  columnSize: (e) => `${e.value} pixlar`,
  descending: "fallande",
  descendingSort: (e) => `sorterat på kolumn ${e.columnName} i fallande ordning`,
  resizerDescription: "Tryck på Retur för att börja ändra storlek",
  select: "Markera",
  selectAll: "Markera allt",
  sortable: "sorterbar kolumn"
};
var ay = {};
ay = {
  ascending: "artan sırada",
  ascendingSort: (e) => `${e.columnName} sütuna göre artan düzende sırala`,
  columnSize: (e) => `${e.value} piksel`,
  descending: "azalan sırada",
  descendingSort: (e) => `${e.columnName} sütuna göre azalan düzende sırala`,
  resizerDescription: "Yeniden boyutlandırmak için Enter'a basın",
  select: "Seç",
  selectAll: "Tümünü Seç",
  sortable: "Sıralanabilir sütun"
};
var ly = {};
ly = {
  ascending: "висхідний",
  ascendingSort: (e) => `відсортовано за стовпцем ${e.columnName} у висхідному порядку`,
  columnSize: (e) => `${e.value} пікс.`,
  descending: "низхідний",
  descendingSort: (e) => `відсортовано за стовпцем ${e.columnName} у низхідному порядку`,
  resizerDescription: "Натисніть Enter, щоб почати зміну розміру",
  select: "Вибрати",
  selectAll: "Вибрати все",
  sortable: "сортувальний стовпець"
};
var iy = {};
iy = {
  ascending: "升序",
  ascendingSort: (e) => `按列 ${e.columnName} 升序排序`,
  columnSize: (e) => `${e.value} 像素`,
  descending: "降序",
  descendingSort: (e) => `按列 ${e.columnName} 降序排序`,
  resizerDescription: "按“输入”键开始调整大小。",
  select: "选择",
  selectAll: "全选",
  sortable: "可排序的列"
};
var oy = {};
oy = {
  ascending: "遞增",
  ascendingSort: (e) => `已依據「${e.columnName}」欄遞增排序`,
  columnSize: (e) => `${e.value} 像素`,
  descending: "遞減",
  descendingSort: (e) => `已依據「${e.columnName}」欄遞減排序`,
  resizerDescription: "按 Enter 鍵以開始調整大小",
  select: "選取",
  selectAll: "全選",
  sortable: "可排序的欄"
};
var ul = {};
ul = {
  "ar-AE": Sg,
  "bg-BG": Bg,
  "cs-CZ": Fg,
  "da-DK": Ag,
  "de-DE": Tg,
  "el-GR": Rg,
  "en-US": Mg,
  "es-ES": Ng,
  "et-EE": Vg,
  "fi-FI": Ig,
  "fr-FR": Og,
  "he-IL": zg,
  "hr-HR": Kg,
  "hu-HU": jg,
  "it-IT": Lg,
  "ja-JP": Hg,
  "ko-KR": _g,
  "lt-LT": Ug,
  "lv-LV": Wg,
  "nb-NO": Gg,
  "nl-NL": Zg,
  "pl-PL": Yg,
  "pt-BR": qg,
  "pt-PT": Xg,
  "ro-RO": Jg,
  "ru-RU": Qg,
  "sk-SK": ey,
  "sl-SI": ty,
  "sr-SP": ny,
  "sv-SE": ry,
  "tr-TR": ay,
  "uk-UA": ly,
  "zh-CN": iy,
  "zh-TW": oy
};
class wC extends ev {
  isCell(t) {
    return t.type === "cell" || t.type === "rowheader" || t.type === "column";
  }
  getKeyBelow(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (n.type === "column") {
      let r = kn(at(n, this.collection));
      if (r) return r.key;
      let a = this.getFirstKey();
      return a == null || !this.collection.getItem(a) ? null : super.getKeyForItemInRowByIndex(a, n.index);
    }
    return super.getKeyBelow(t);
  }
  getKeyAbove(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (n.type === "column") {
      let l = n.parentKey != null ? this.collection.getItem(n.parentKey) : null;
      return l && l.type === "column" ? l.key : null;
    }
    let r = super.getKeyAbove(t), a = r != null ? this.collection.getItem(r) : null;
    return a && a.type !== "headerrow" ? r : this.isCell(n) ? this.collection.columns[n.index].key : this.collection.columns[0].key;
  }
  findNextColumnKey(t) {
    let n = this.findNextKey(t.key, (a) => a.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[t.level];
    for (let a of at(r, this.collection))
      if (a.type === "column") return a.key;
    return null;
  }
  findPreviousColumnKey(t) {
    let n = this.findPreviousKey(t.key, (l) => l.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[t.level], a = [
      ...at(r, this.collection)
    ];
    for (let l = a.length - 1; l >= 0; l--) {
      let i = a[l];
      if (i.type === "column") return i.key;
    }
    return null;
  }
  getKeyRightOf(t) {
    let n = this.collection.getItem(t);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findPreviousColumnKey(n) : this.findNextColumnKey(n) : super.getKeyRightOf(t) : null;
  }
  getKeyLeftOf(t) {
    let n = this.collection.getItem(t);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findNextColumnKey(n) : this.findPreviousColumnKey(n) : super.getKeyLeftOf(t) : null;
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, a = n ?? this.getFirstKey();
    if (a == null) return null;
    let l = r.getItem(a);
    var i;
    (l == null ? void 0 : l.type) === "cell" && (a = (i = l.parentKey) !== null && i !== void 0 ? i : null);
    let o = !1;
    for (; a != null; ) {
      let u = r.getItem(a);
      if (!u) return null;
      if (u.textValue) {
        let s = u.textValue.slice(0, t.length);
        if (this.collator.compare(s, t) === 0) return u.key;
      }
      for (let s of at(u, this.collection)) {
        let d = r.columns[s.index];
        if (r.rowHeaderColumnKeys.has(d.key) && s.textValue) {
          let c = s.textValue.slice(0, t.length);
          if (this.collator.compare(c, t) === 0) {
            let f = n != null ? r.getItem(n) : l;
            return (f == null ? void 0 : f.type) === "cell" ? s.key : u.key;
          }
        }
      }
      a = this.getKeyBelow(a), a == null && !o && (a = this.getFirstKey(), o = !0);
    }
    return null;
  }
}
function PC(e) {
  return e && e.__esModule ? e.default : e;
}
function kC(e, t, n) {
  let { keyboardDelegate: r, isVirtualized: a, layoutDelegate: l, layout: i } = e, o = Rr({
    usage: "search",
    sensitivity: "base"
  }), { direction: u } = me(), s = t.selectionManager.disabledBehavior, d = H(() => r || new wC({
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    disabledBehavior: s,
    ref: n,
    direction: u,
    collator: o,
    layoutDelegate: l,
    layout: i
  }), [
    r,
    t.collection,
    t.disabledKeys,
    s,
    n,
    u,
    o,
    l,
    i
  ]), c = Ee(e.id);
  ps.set(t, c);
  let { gridProps: f } = dC({
    ...e,
    id: c,
    keyboardDelegate: d
  }, t, n);
  a && (f["aria-rowcount"] = t.collection.size + t.collection.headerRows.length), Kl() && "expandedKeys" in t && (f.role = "treegrid");
  let { column: b, direction: p } = t.sortDescriptor || {}, h = Oe(PC(ul), "@react-aria/table"), m = H(() => {
    var y, w;
    let C = (w = (y = t.collection.columns.find((D) => D.key === b)) === null || y === void 0 ? void 0 : y.textValue) !== null && w !== void 0 ? w : "";
    return p && b ? h.format(`${p}Sort`, {
      columnName: C
    }) : void 0;
  }, [
    p,
    b,
    t.collection.columns
  ]), v = $n(m);
  return za(() => {
    m && hn(m, "assertive", 500);
  }, [
    m
  ]), {
    gridProps: _(f, v, {
      // merge sort description with long press information
      "aria-describedby": [
        v["aria-describedby"],
        f["aria-describedby"]
      ].filter(Boolean).join(" ")
    })
  };
}
function SC(e) {
  return e && e.__esModule ? e.default : e;
}
function BC(e, t, n) {
  var r, a;
  let { node: l } = e, i = l.props.allowsSorting, { gridCellProps: o } = Iv({
    ...e,
    focusMode: "child"
  }, t, n), u = l.props.isSelectionCell && t.selectionManager.selectionMode === "single", { pressProps: s } = Tt({
    isDisabled: !i || u,
    onPress() {
      t.sort(l.key);
    },
    ref: n
  }), { focusableProps: d } = un({}, n), c, f = ((r = t.sortDescriptor) === null || r === void 0 ? void 0 : r.column) === l.key, b = (a = t.sortDescriptor) === null || a === void 0 ? void 0 : a.direction;
  l.props.allowsSorting && !Er() && (c = f ? b : "none");
  let p = Oe(SC(ul), "@react-aria/table"), h;
  i && (h = `${p.format("sortable")}`, f && b && Er() && (h = `${h}, ${p.format(b)}`));
  let m = $n(h), v = t.collection.size === 0;
  return re(() => {
    v && t.selectionManager.focusedKey === l.key && t.selectionManager.setFocusedKey(null);
  }, [
    v,
    t.selectionManager,
    l.key
  ]), {
    columnHeaderProps: {
      ..._(
        d,
        o,
        s,
        m,
        // If the table is empty, make all column headers untabbable
        v ? {
          tabIndex: -1
        } : null
      ),
      role: "columnheader",
      id: wg(t, l.key),
      "aria-colspan": l.colSpan && l.colSpan > 1 ? l.colSpan : void 0,
      "aria-sort": c
    }
  };
}
const mc = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function FC(e, t, n) {
  let { node: r, isVirtualized: a } = e, { rowProps: l, ...i } = fC(e, t, n), { direction: o } = me();
  a && !(Kl() && "expandedKeys" in t) ? l["aria-rowindex"] = r.index + 1 + t.collection.headerRows.length : delete l["aria-rowindex"];
  let u = {};
  if (Kl() && "expandedKeys" in t) {
    let D = t.keyMap.get(r.key);
    if (D != null) {
      var s, d, c, f, b, p;
      let P = ((s = D.props) === null || s === void 0 ? void 0 : s.UNSTABLE_childItems) || ((c = D.props) === null || c === void 0 || (d = c.children) === null || d === void 0 ? void 0 : d.length) > t.userColumnCount;
      var h, m, v, y;
      u = {
        onKeyDown: (R) => {
          (R.key === mc.expand[o] && t.selectionManager.focusedKey === D.key && P && t.expandedKeys !== "all" && !t.expandedKeys.has(D.key) || R.key === mc.collapse[o] && t.selectionManager.focusedKey === D.key && P && (t.expandedKeys === "all" || t.expandedKeys.has(D.key))) && (t.toggleKey(D.key), R.stopPropagation());
        },
        "aria-expanded": P ? t.expandedKeys === "all" || t.expandedKeys.has(r.key) : void 0,
        "aria-level": D.level,
        "aria-posinset": ((h = D.indexOfType) !== null && h !== void 0 ? h : 0) + 1,
        "aria-setsize": D.level > 1 ? ((v = (f = Fn((m = (b = t.keyMap.get(D.parentKey)) === null || b === void 0 ? void 0 : b.childNodes) !== null && m !== void 0 ? m : [])) === null || f === void 0 ? void 0 : f.indexOfType) !== null && v !== void 0 ? v : 0) + 1 : ((y = (p = Fn(t.collection.body.childNodes)) === null || p === void 0 ? void 0 : p.indexOfType) !== null && y !== void 0 ? y : 0) + 1
      };
    }
  }
  let w = Au(r.props), C = i.hasAction ? w : {};
  return {
    rowProps: {
      ..._(l, u, C),
      "aria-labelledby": kg(t, r.key)
    },
    ...i
  };
}
function AC(e, t, n) {
  let { node: r, isVirtualized: a } = e, l = {
    role: "row"
  };
  return a && !(Kl() && "expandedKeys" in t) && (l["aria-rowindex"] = r.index + 1), {
    rowProps: l
  };
}
function TC(e, t, n) {
  var r;
  let { gridCellProps: a, isPressed: l } = Iv(e, t, n), i = (r = e.node.column) === null || r === void 0 ? void 0 : r.key;
  return i != null && t.collection.rowHeaderColumnKeys.has(i) && (a.role = "rowheader", a.id = Pg(t, e.node.parentKey, i)), {
    gridCellProps: a,
    isPressed: l
  };
}
function RC(e) {
  return e && e.__esModule ? e.default : e;
}
function MC(e, t) {
  let { key: n } = e;
  const { checkboxProps: r } = Ov(e, t);
  return {
    checkboxProps: {
      ...r,
      "aria-labelledby": `${r.id} ${kg(t, n)}`
    }
  };
}
function NC(e) {
  let { isEmpty: t, isSelectAll: n, selectionMode: r } = e.selectionManager;
  return {
    checkboxProps: {
      "aria-label": Oe(RC(ul), "@react-aria/table").format(r === "single" ? "select" : "selectAll"),
      isSelected: n,
      isDisabled: r !== "multiple" || e.collection.size === 0,
      isIndeterminate: !t && !n,
      onChange: () => e.selectionManager.toggleSelectAll()
    }
  };
}
function VC(e) {
  return e && e.__esModule ? e.default : e;
}
function IC(e, t, n) {
  let { column: r, triggerRef: a, isDisabled: l, onResizeStart: i, onResize: o, onResizeEnd: u, "aria-label": s } = e;
  const d = Oe(VC(ul), "@react-aria/table");
  let c = Ee(), f = t.resizingColumn === r.key, b = j(f), p = j(null), h = j(!1), m = t.tableState.isKeyboardNavigationDisabled, { direction: v } = me(), { keyboardProps: y } = la({
    onKeyDown: (z) => {
      m ? (z.key === "Escape" || z.key === "Enter" || z.key === " " || z.key === "Tab") && (z.preventDefault(), D(r)) : (z.continuePropagation(), z.key === "Enter" && w(r));
    }
  }), w = Re((z) => {
    b.current || (p.current = t.updateResizedColumns(z.key, t.getColumnWidth(z.key)), t.startResize(z.key), t.tableState.setKeyboardNavigationDisabled(!0), i == null || i(p.current)), b.current = !0;
  }), C = Re((z, Z) => {
    let te = t.updateResizedColumns(z.key, Z);
    o == null || o(te), p.current = te;
  }), D = Re((z) => {
    b.current && (p.current == null && (p.current = t.updateResizedColumns(z.key, t.getColumnWidth(z.key))), t.endResize(), t.tableState.setKeyboardNavigationDisabled(!1), u == null || u(p.current), b.current = !1, a != null && a.current && !h.current && He(a.current)), p.current = null;
  });
  const P = j(0), { moveProps: R } = Sr({
    onMoveStart() {
      P.current = t.getColumnWidth(r.key), w(r);
    },
    onMove(z) {
      let { deltaX: Z, deltaY: te, pointerType: ue } = z;
      v === "rtl" && (Z *= -1), ue === "keyboard" && (te !== 0 && Z === 0 && (Z = te * -1), Z *= 10), Z !== 0 && (P.current += Z, C(r, P.current));
    },
    onMoveEnd(z) {
      let { pointerType: Z } = z;
      P.current = 0, (Z === "mouse" || Z === "touch" && h.current) && D(r);
    }
  });
  let V = ie((z) => {
    var Z;
    m && ((Z = R.onKeyDown) === null || Z === void 0 || Z.call(R, z));
  }, [
    m,
    R
  ]), L = Math.floor(t.getColumnMinWidth(r.key)), A = Math.floor(t.getColumnMaxWidth(r.key));
  A === 1 / 0 && (A = Number.MAX_SAFE_INTEGER);
  let $ = Math.floor(t.getColumnWidth(r.key)), S = Ou();
  S === "virtual" && typeof window < "u" && "ontouchstart" in window && (S = "touch");
  let T = (a == null ? void 0 : a.current) == null && (S === "keyboard" || S === "virtual") && !f ? d.format("resizerDescription") : void 0, M = $n(T), K = {
    "aria-label": s,
    "aria-orientation": "horizontal",
    "aria-labelledby": `${c} ${wg(t.tableState, r.key)}`,
    "aria-valuetext": d.format("columnSize", {
      value: $
    }),
    type: "range",
    min: L,
    max: A,
    value: $,
    ...M
  };
  const g = ie(() => {
    n.current && He(n.current);
  }, [
    n
  ]);
  let B = t.resizingColumn, k = j(null);
  re(() => {
    if (k.current !== B && B != null && B === r.key) {
      h.current = document.activeElement === n.current, w(r);
      let z = setTimeout(() => g(), 0), Z = setTimeout(g, 400);
      return () => {
        clearTimeout(z), clearTimeout(Z);
      };
    }
    k.current = B;
  }, [
    B,
    r,
    g,
    n,
    w
  ]);
  let I = (z) => {
    let Z = t.getColumnWidth(r.key), te = parseFloat(z.target.value);
    te > Z ? te = Z + 10 : te = Z - 10, C(r, te);
  }, { pressProps: O } = Tt({
    preventFocusOnPress: !0,
    onPressStart: (z) => {
      if (!(z.ctrlKey || z.altKey || z.metaKey || z.shiftKey || z.pointerType === "keyboard")) {
        if (z.pointerType === "virtual" && t.resizingColumn != null) {
          D(r);
          return;
        }
        g(), z.pointerType !== "virtual" && w(r);
      }
    },
    onPress: (z) => {
      (z.pointerType === "touch" && h.current || z.pointerType === "mouse") && t.resizingColumn != null && D(r);
    }
  }), { visuallyHiddenProps: F } = sn();
  return {
    resizerProps: _(y, {
      ...R,
      onKeyDown: V
    }, O, {
      style: {
        touchAction: "none"
      }
    }),
    inputProps: _(F, {
      id: c,
      onBlur: () => {
        D(r);
      },
      onChange: I,
      disabled: l
    }, K),
    isResizing: f
  };
}
function OC() {
  return cC();
}
const uy = /* @__PURE__ */ new WeakMap();
function ai(e, t, n) {
  return e ? (typeof t == "string" && (t = t.replace(/\s+/g, "")), `${uy.get(e)}-${n}-${t}`) : "";
}
function zC(e, t, n) {
  let { key: r, isDisabled: a, shouldSelectOnPressUp: l } = e, { selectionManager: i, selectedKey: o } = t, u = r === o, s = a || t.isDisabled || t.selectionManager.isDisabled(r), { itemProps: d, isPressed: c } = oa({
    selectionManager: i,
    key: r,
    ref: n,
    isDisabled: s,
    shouldSelectOnPressUp: l,
    linkBehavior: "selection"
  }), f = ai(t, r, "tab"), b = ai(t, r, "tabpanel"), { tabIndex: p } = d, h = t.collection.getItem(r), m = J(h == null ? void 0 : h.props, {
    labelable: !0
  });
  delete m.id;
  let v = bi(h == null ? void 0 : h.props), { focusableProps: y } = un({
    isDisabled: s
  }, n);
  return {
    tabProps: _(m, y, v, d, {
      id: f,
      "aria-selected": u,
      "aria-disabled": s || void 0,
      "aria-controls": u ? b : void 0,
      tabIndex: s ? void 0 : p,
      role: "tab"
    }),
    isSelected: u,
    isDisabled: s,
    isPressed: c
  };
}
function KC(e, t, n) {
  let r = es(n) ? void 0 : 0;
  var a;
  const l = ai(t, (a = e.id) !== null && a !== void 0 ? a : t == null ? void 0 : t.selectedKey, "tabpanel"), i = Ot({
    ...e,
    id: l,
    "aria-labelledby": ai(t, t == null ? void 0 : t.selectedKey, "tab")
  });
  return {
    tabPanelProps: _(i, {
      tabIndex: r,
      role: "tabpanel",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"]
    })
  };
}
class jC {
  getKeyLeftOf(t) {
    return this.flipDirection ? this.getNextKey(t) : this.getPreviousKey(t);
  }
  getKeyRightOf(t) {
    return this.flipDirection ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  isDisabled(t) {
    var n, r;
    return this.disabledKeys.has(t) || !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.isDisabled);
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return t != null && this.isDisabled(t) && (t = this.getNextKey(t)), t;
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return t != null && this.isDisabled(t) && (t = this.getPreviousKey(t)), t;
  }
  getKeyAbove(t) {
    return this.tabDirection ? null : this.getPreviousKey(t);
  }
  getKeyBelow(t) {
    return this.tabDirection ? null : this.getNextKey(t);
  }
  getNextKey(t) {
    let n = t;
    do
      n = this.collection.getKeyAfter(n), n == null && (n = this.collection.getFirstKey());
    while (n != null && this.isDisabled(n));
    return n;
  }
  getPreviousKey(t) {
    let n = t;
    do
      n = this.collection.getKeyBefore(n), n == null && (n = this.collection.getLastKey());
    while (n != null && this.isDisabled(n));
    return n;
  }
  constructor(t, n, r, a = /* @__PURE__ */ new Set()) {
    this.collection = t, this.flipDirection = n === "rtl" && r === "horizontal", this.disabledKeys = a, this.tabDirection = r === "horizontal";
  }
}
function LC(e, t, n) {
  let { orientation: r = "horizontal", keyboardActivation: a = "automatic" } = e, { collection: l, selectionManager: i, disabledKeys: o } = t, { direction: u } = me(), s = H(() => new jC(l, u, r, o), [
    l,
    o,
    r,
    u
  ]), { collectionProps: d } = Pi({
    ref: n,
    selectionManager: i,
    keyboardDelegate: s,
    selectOnFocus: a === "automatic",
    disallowEmptySelection: !0,
    scrollRef: n,
    linkBehavior: "selection"
  }), c = Ee();
  uy.set(t, c);
  let f = Ot({
    ...e,
    id: c
  });
  return {
    tabListProps: {
      ..._(d, f),
      role: "tablist",
      "aria-orientation": r,
      tabIndex: void 0
    }
  };
}
const sy = /* @__PURE__ */ new WeakMap();
function HC(e, t, n) {
  let { direction: r } = me(), a = e.keyboardDelegate || new lr({
    collection: t.collection,
    ref: n,
    orientation: "horizontal",
    direction: r,
    disabledKeys: t.disabledKeys,
    disabledBehavior: t.selectionManager.disabledBehavior
  }), { labelProps: l, fieldProps: i, descriptionProps: o, errorMessageProps: u } = or({
    ...e,
    labelElementType: "span"
  }), { gridProps: s } = zv({
    ...e,
    ...i,
    keyboardDelegate: a,
    shouldFocusWrap: !0,
    linkBehavior: "override"
  }, t, n), [d, c] = q(!1), { focusWithinProps: f } = jt({
    onFocusWithinChange: c
  }), b = J(e), p = j(t.collection.size);
  return re(() => {
    n.current && p.current > 0 && t.collection.size === 0 && d && n.current.focus(), p.current = t.collection.size;
  }, [
    t.collection.size,
    d,
    n
  ]), sy.set(t, {
    onRemove: e.onRemove
  }), {
    gridProps: _(s, b, {
      role: t.collection.size ? "grid" : null,
      "aria-atomic": !1,
      "aria-relevant": "additions",
      "aria-live": d ? "polite" : "off",
      ...f,
      ...i
    }),
    labelProps: l,
    descriptionProps: o,
    errorMessageProps: u
  };
}
var dy = {};
dy = {
  removeButtonLabel: "إزالة",
  removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
};
var cy = {};
cy = {
  removeButtonLabel: "Премахване",
  removeDescription: "Натиснете Delete, за да премахнете маркера."
};
var fy = {};
fy = {
  removeButtonLabel: "Odebrat",
  removeDescription: "Stisknutím klávesy Delete odeberete značku."
};
var by = {};
by = {
  removeButtonLabel: "Fjern",
  removeDescription: "Tryk på Slet for at fjerne tag."
};
var py = {};
py = {
  removeButtonLabel: "Entfernen",
  removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
};
var hy = {};
hy = {
  removeButtonLabel: "Κατάργηση",
  removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
};
var my = {};
my = {
  removeDescription: "Press Delete to remove tag.",
  removeButtonLabel: "Remove"
};
var vy = {};
vy = {
  removeButtonLabel: "Quitar",
  removeDescription: "Pulse Eliminar para quitar la etiqueta."
};
var gy = {};
gy = {
  removeButtonLabel: "Eemalda",
  removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var yy = {};
yy = {
  removeButtonLabel: "Poista",
  removeDescription: "Poista tunniste painamalla Poista-painiketta."
};
var $y = {};
$y = {
  removeButtonLabel: "Supprimer",
  removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
};
var xy = {};
xy = {
  removeButtonLabel: "הסר",
  removeDescription: "לחץ על מחק כדי להסיר תג."
};
var Dy = {};
Dy = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Delete za uklanjanje oznake."
};
var Cy = {};
Cy = {
  removeButtonLabel: "Eltávolítás",
  removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
};
var Ey = {};
Ey = {
  removeButtonLabel: "Rimuovi",
  removeDescription: "Premi Elimina per rimuovere il tag."
};
var wy = {};
wy = {
  removeButtonLabel: "削除",
  removeDescription: "タグを削除するには、Delete キーを押します。"
};
var Py = {};
Py = {
  removeButtonLabel: "제거",
  removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
};
var ky = {};
ky = {
  removeButtonLabel: "Pašalinti",
  removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
};
var Sy = {};
Sy = {
  removeButtonLabel: "Noņemt",
  removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
};
var By = {};
By = {
  removeButtonLabel: "Fjern",
  removeDescription: "Trykk på Slett for å fjerne taggen."
};
var Fy = {};
Fy = {
  removeButtonLabel: "Verwijderen",
  removeDescription: "Druk op Verwijderen om de tag te verwijderen."
};
var Ay = {};
Ay = {
  removeButtonLabel: "Usuń",
  removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
};
var Ty = {};
Ty = {
  removeButtonLabel: "Remover",
  removeDescription: "Pressione Delete para remover a tag."
};
var Ry = {};
Ry = {
  removeButtonLabel: "Eliminar",
  removeDescription: "Prima Delete para eliminar a tag."
};
var My = {};
My = {
  removeButtonLabel: "Îndepărtaţi",
  removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
};
var Ny = {};
Ny = {
  removeButtonLabel: "Удалить",
  removeDescription: "Нажмите DELETE, чтобы удалить тег."
};
var Vy = {};
Vy = {
  removeButtonLabel: "Odstrániť",
  removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
};
var Iy = {};
Iy = {
  removeButtonLabel: "Odstrani",
  removeDescription: "Pritisnite Delete, da odstranite oznako."
};
var Oy = {};
Oy = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
};
var zy = {};
zy = {
  removeButtonLabel: "Ta bort",
  removeDescription: "Tryck på Radera för att ta bort taggen."
};
var Ky = {};
Ky = {
  removeButtonLabel: "Kaldır",
  removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
};
var jy = {};
jy = {
  removeButtonLabel: "Вилучити",
  removeDescription: "Натисніть Delete, щоб вилучити тег."
};
var Ly = {};
Ly = {
  removeButtonLabel: "删除",
  removeDescription: "按下“删除”以删除标记。"
};
var Hy = {};
Hy = {
  removeButtonLabel: "移除",
  removeDescription: "按 Delete 鍵以移除標記。"
};
var _y = {};
_y = {
  "ar-AE": dy,
  "bg-BG": cy,
  "cs-CZ": fy,
  "da-DK": by,
  "de-DE": py,
  "el-GR": hy,
  "en-US": my,
  "es-ES": vy,
  "et-EE": gy,
  "fi-FI": yy,
  "fr-FR": $y,
  "he-IL": xy,
  "hr-HR": Dy,
  "hu-HU": Cy,
  "it-IT": Ey,
  "ja-JP": wy,
  "ko-KR": Py,
  "lt-LT": ky,
  "lv-LV": Sy,
  "nb-NO": By,
  "nl-NL": Fy,
  "pl-PL": Ay,
  "pt-BR": Ty,
  "pt-PT": Ry,
  "ro-RO": My,
  "ru-RU": Ny,
  "sk-SK": Vy,
  "sl-SI": Iy,
  "sr-SP": Oy,
  "sv-SE": zy,
  "tr-TR": Ky,
  "uk-UA": jy,
  "zh-CN": Ly,
  "zh-TW": Hy
};
function _C(e) {
  return e && e.__esModule ? e.default : e;
}
function UC(e, t, n) {
  let { item: r } = e, a = Oe(_C(_y), "@react-aria/tag"), l = Ee(), { onRemove: i } = sy.get(t) || {}, { rowProps: o, gridCellProps: u, ...s } = Kv({
    node: r
  }, t, n);
  delete o.onKeyDownCapture;
  let { descriptionProps: d, ...c } = s, f = t.disabledKeys.has(r.key) || r.props.isDisabled, b = (R) => {
    if (R.key === "Delete" || R.key === "Backspace") {
      if (f) return;
      R.preventDefault(), t.selectionManager.isSelected(r.key) ? i == null || i(new Set(t.selectionManager.selectedKeys)) : i == null || i(/* @__PURE__ */ new Set([
        r.key
      ]));
    }
  }, p = Ou();
  p === "virtual" && typeof window < "u" && "ontouchstart" in window && (p = "pointer");
  let h = i && (p === "keyboard" || p === "virtual") ? a.format("removeDescription") : "", m = $n(h), v = r.key === t.selectionManager.focusedKey, y = t.selectionManager.focusedKey != null, w = -1;
  !f && (v || !y) && (w = 0);
  let C = J(r.props), D = Au(r.props), { focusableProps: P } = un({
    isDisabled: f
  }, n);
  return {
    removeButtonProps: {
      "aria-label": a.format("removeButtonLabel"),
      "aria-labelledby": `${l} ${o.id}`,
      isDisabled: f,
      id: l,
      onPress: () => i ? i(/* @__PURE__ */ new Set([
        r.key
      ])) : null,
      excludeFromTabOrder: !0
    },
    rowProps: _(P, o, C, D, {
      tabIndex: w,
      onKeyDown: i ? b : void 0,
      "aria-describedby": m["aria-describedby"]
    }),
    gridCellProps: _(u, {
      "aria-errormessage": e["aria-errormessage"],
      "aria-label": e["aria-label"]
    }),
    ...c,
    allowsRemoving: !!i
  };
}
function WC(e, t) {
  let n = J(e, {
    labelable: !0
  }), { hoverProps: r } = Ie({
    onHoverStart: () => t == null ? void 0 : t.open(!0),
    onHoverEnd: () => t == null ? void 0 : t.close()
  });
  return {
    tooltipProps: _(n, r, {
      role: "tooltip"
    })
  };
}
function GC(e, t, n) {
  let { isDisabled: r, trigger: a } = e, l = Ee(), i = j(!1), o = j(!1), u = () => {
    (i.current || o.current) && t.open(o.current);
  }, s = (v) => {
    !i.current && !o.current && t.close(v);
  };
  re(() => {
    let v = (y) => {
      n && n.current && y.key === "Escape" && (y.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", v, !0), () => {
        document.removeEventListener("keydown", v, !0);
      };
  }, [
    n,
    t
  ]);
  let d = () => {
    a !== "focus" && (ta() === "pointer" ? i.current = !0 : i.current = !1, u());
  }, c = () => {
    a !== "focus" && (o.current = !1, i.current = !1, s());
  }, f = () => {
    o.current = !1, i.current = !1, s(!0);
  }, b = () => {
    Nn() && (o.current = !0, u());
  }, p = () => {
    o.current = !1, i.current = !1, s(!0);
  }, { hoverProps: h } = Ie({
    isDisabled: r,
    onHoverStart: d,
    onHoverEnd: c
  }), { focusableProps: m } = un({
    isDisabled: r,
    onFocus: b,
    onBlur: p
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? l : void 0,
      ..._(m, h, {
        onPointerDown: f,
        onKeyDown: f,
        tabIndex: void 0
      })
    },
    tooltipProps: {
      id: l
    }
  };
}
const Si = G(null), Uy = G(null), Wy = G(null), Gy = G(null), Zy = G(null), Bi = G({}), rn = Symbol("default");
function $e({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ x.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function ne(e) {
  let { className: t, style: n, children: r, defaultClassName: a, defaultChildren: l, defaultStyle: i, values: o } = e;
  return H(() => {
    let u, s, d;
    return typeof t == "function" ? u = t({
      ...o,
      defaultClassName: a
    }) : u = t, typeof n == "function" ? s = n({
      ...o,
      defaultStyle: i || {}
    }) : s = n, typeof r == "function" ? d = r({
      ...o,
      defaultChildren: l
    }) : r == null ? d = l : d = r, {
      className: u ?? a,
      style: s || i ? {
        ...i,
        ...s
      } : void 0,
      children: d ?? l,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    a,
    l,
    i,
    o
  ]);
}
function et(e, t) {
  return (n) => t(typeof e == "function" ? e(n) : e, n);
}
function Ge(e, t) {
  let n = U(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || rn;
    if (!n.slots[r]) {
      let a = new Intl.ListFormat().format(Object.keys(n.slots).map((i) => `"${i}"`)), l = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${l} Valid slot names are ${a}.`);
    }
    return n.slots[r];
  }
  return n;
}
function oe(e, t, n) {
  let r = Ge(n, e.slot) || {}, { ref: a, ...l } = r, i = Ne(H(() => gn(t, a), [
    t,
    a
  ])), o = _(l, e);
  return "style" in l && l.style && "style" in e && e.style && (typeof l.style == "function" || typeof e.style == "function" ? o.style = (u) => {
    let s = typeof l.style == "function" ? l.style(u) : l.style, d = {
      ...u.defaultStyle,
      ...s
    }, c = typeof e.style == "function" ? e.style({
      ...u,
      defaultStyle: d
    }) : e.style;
    return {
      ...d,
      ...c
    };
  } : o.style = {
    ...l.style,
    ...e.style
  }), [
    o,
    i
  ];
}
function tt(e = !0) {
  let [t, n] = q(e), r = j(!1), a = ie((l) => {
    r.current = !0, n(!!l);
  }, []);
  return Ce(() => {
    r.current || n(!1);
  }, []), [
    a,
    t
  ];
}
function yt(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
class Ga {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new Ga(this.type, this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  constructor(t, n) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = t, this.key = n;
  }
}
class Fi {
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), a = (r == null ? void 0 : r.firstChildKey) != null ? n.get(r.firstChildKey) : null;
        for (; a; )
          yield a, a = a.nextKey != null ? n.get(a.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      var r;
      return (r = n == null ? void 0 : n.key) !== null && r !== void 0 ? r : null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; (t == null ? void 0 : t.lastChildKey) != null; ) t = this.keyMap.get(t.lastChildKey);
    var n;
    return (n = t == null ? void 0 : t.key) !== null && n !== void 0 ? n : null;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    this.keyMap.set(t.key, t);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  // TODO: this is pretty specific to menu, will need to check if it is generic enough
  // Will need to handle varying levels I assume but will revisit after I get searchable menu working for base menu
  // TODO: an alternative is to simply walk the collection and add all item nodes that match the filter and any sections/separators we encounter
  // to an array, then walk that new array and fix all the next/Prev keys while adding them to the new collection
  UNSTABLE_filter(t) {
    let n = new Fi(), r = null;
    for (let a of this)
      if (a.type === "section" && a.hasChildNodes) {
        let l = a.clone(), i = null;
        for (let o of this.getChildren(a.key)) if (vc(o, t, this, n)) {
          let u = o.clone();
          i == null && (l.firstChildKey = u.key), n.firstKey == null && (n.firstKey = l.key), i && i.parentKey === u.parentKey ? (i.nextKey = u.key, u.prevKey = i.key) : u.prevKey = null, u.nextKey = null, n.addNode(u), i = u;
        }
        i && (i.type !== "header" ? (l.lastChildKey = i.key, r == null ? l.prevKey = null : (r.type === "section" || r.type === "separator") && (r.nextKey = l.key, l.prevKey = r.key), l.nextKey = null, r = l, n.addNode(l)) : (n.firstKey === l.key && (n.firstKey = null), n.removeNode(i.key)));
      } else if (a.type === "separator") {
        let l = a.clone();
        l.nextKey = null, (r == null ? void 0 : r.type) === "section" && (r.nextKey = l.key, l.prevKey = r.key, r = l, n.addNode(l));
      } else {
        let l = a.clone();
        vc(l, t, this, n) && (n.firstKey == null && (n.firstKey = l.key), r != null && r.type !== "section" && r.type !== "separator" && r.parentKey === l.parentKey ? (r.nextKey = l.key, l.prevKey = r.key) : l.prevKey = null, l.nextKey = null, n.addNode(l), r = l);
      }
    if ((r == null ? void 0 : r.type) === "separator" && r.nextKey === null) {
      let a;
      r.prevKey != null && (a = n.getItem(r.prevKey), a.nextKey = null), n.removeNode(r.key), r = a;
    }
    return n.lastKey = (r == null ? void 0 : r.key) || null, n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1;
  }
}
function vc(e, t, n, r) {
  if (e.type === "subdialogtrigger" || e.type === "submenutrigger") {
    let a = [
      ...n.getChildren(e.key)
    ][0];
    if (a && t(a.textValue)) {
      let l = a.clone();
      return r.addNode(l), !0;
    } else return !1;
  } else return e.type === "header" ? !0 : t(e.textValue);
}
class Yy {
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var t;
    return ((t = this.parentNode) === null || t === void 0 ? void 0 : t.isConnected) || !1;
  }
  appendChild(t) {
    this.ownerDocument.startTransaction(), t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), t.hasSetProps && this.ownerDocument.addNode(t), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    this.ownerDocument.startTransaction(), t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode;
    let r = n;
    for (; r; )
      r.index++, r = r.nextSibling;
    t.hasSetProps && this.ownerDocument.addNode(t), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    if (t.parentNode !== this || !this.ownerDocument.isMounted) return;
    this.ownerDocument.startTransaction();
    let n = t.nextSibling;
    for (; n; )
      n.index--, n = n.nextSibling;
    t.nextSibling && (t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.removeNode(t), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this.ownerDocument = t;
  }
}
class Za extends Yy {
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof Za ? this.parentNode.level + (this.node.type === "item" ? 1 : 0) : 0;
  }
  updateNode() {
    var t, n, r, a;
    let l = this.ownerDocument.getMutableNode(this);
    l.index = this.index, l.level = this.level, l.parentKey = this.parentNode instanceof Za ? this.parentNode.node.key : null;
    var i;
    l.prevKey = (i = (t = this.previousSibling) === null || t === void 0 ? void 0 : t.node.key) !== null && i !== void 0 ? i : null;
    var o;
    l.nextKey = (o = (n = this.nextSibling) === null || n === void 0 ? void 0 : n.node.key) !== null && o !== void 0 ? o : null, l.hasChildNodes = !!this.firstChild;
    var u;
    l.firstChildKey = (u = (r = this.firstChild) === null || r === void 0 ? void 0 : r.node.key) !== null && u !== void 0 ? u : null;
    var s;
    if (l.lastChildKey = (s = (a = this.lastChild) === null || a === void 0 ? void 0 : a.node.key) !== null && s !== void 0 ? s : null, (l.colSpan != null || l.colIndex != null) && this.nextSibling) {
      var d, c;
      let f = ((d = l.colIndex) !== null && d !== void 0 ? d : l.index) + ((c = l.colSpan) !== null && c !== void 0 ? c : 1);
      if (f !== this.nextSibling.node.colIndex) {
        let b = this.ownerDocument.getMutableNode(this.nextSibling);
        b.colIndex = f;
      }
    }
  }
  setProps(t, n, r, a) {
    let l = this.ownerDocument.getMutableNode(this), { value: i, textValue: o, id: u, ...s } = t;
    if (s.ref = n, l.props = s, l.rendered = r, l.render = a, l.value = i, l.textValue = o || (typeof s.children == "string" ? s.children : "") || t["aria-label"] || "", u != null && u !== l.key) {
      if (this.hasSetProps) throw new Error("Cannot change the id of an item");
      l.key = u;
    }
    s.colSpan != null && (l.colSpan = s.colSpan), this.hasSetProps || (this.ownerDocument.addNode(this), this.ownerDocument.endTransaction(), this.hasSetProps = !0), this.ownerDocument.queueUpdate();
  }
  get style() {
    return {};
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(t, n) {
    super(n), this.nodeType = 8, this._index = 0, this.hasSetProps = !1, this.node = new Ga(t, `react-aria-${++n.nodeId}`), this.ownerDocument.startTransaction();
  }
}
class ZC extends Yy {
  get isConnected() {
    return this.isMounted;
  }
  createElement(t) {
    return new Za(t, this);
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode(t) {
    let n = t.node;
    return this.mutatedNodes.has(t) || (n = t.node.clone(), this.mutatedNodes.add(t), t.node = n), this.markDirty(t), n;
  }
  getMutableCollection() {
    return !this.isSSR && !this.collectionMutated && (this.collection = this.collection.clone(), this.collectionMutated = !0), this.collection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  startTransaction() {
    this.transactionCount++;
  }
  endTransaction() {
    this.transactionCount--;
  }
  addNode(t) {
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) {
      n.addNode(t.node);
      for (let r of t) this.addNode(r);
    }
    this.markDirty(t);
  }
  removeNode(t) {
    for (let r of t) this.removeNode(r);
    this.getMutableCollection().removeNode(t.node.key), this.markDirty(t);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.transactionCount > 0 ? this.collection : (this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let l of this.dirtyNodes) l instanceof Za && l.isConnected && l.updateNode();
    if (this.dirtyNodes.clear(), this.mutatedNodes.size || this.collectionMutated) {
      var t, n;
      let l = this.getMutableCollection();
      for (let i of this.mutatedNodes) i.isConnected && l.addNode(i.node);
      this.mutatedNodes.clear();
      var r, a;
      l.commit((r = (t = this.firstChild) === null || t === void 0 ? void 0 : t.node.key) !== null && r !== void 0 ? r : null, (a = (n = this.lastChild) === null || n === void 0 ? void 0 : n.node.key) !== null && a !== void 0 ? a : null, this.isSSR);
    }
    this.collectionMutated = !1;
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.transactionCount > 0))
      for (let t of this.subscriptions) t();
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.isMounted = !0, this.mutatedNodes = /* @__PURE__ */ new Set(), this.subscriptions = /* @__PURE__ */ new Set(), this.transactionCount = 0, this.collection = t, this.collectionMutated = !0;
  }
}
function hs(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: a, dependencies: l = [] } = e, i = H(() => /* @__PURE__ */ new WeakMap(), l);
  return H(() => {
    if (n && typeof t == "function") {
      let s = [];
      for (let d of n) {
        let c = i.get(d);
        if (!c) {
          c = t(d);
          var o, u;
          let f = (u = (o = c.props.id) !== null && o !== void 0 ? o : d.key) !== null && u !== void 0 ? u : d.id;
          if (f == null) throw new Error("Could not determine key for item");
          r && (f = r + ":" + f), c = _c(c, a ? {
            key: f,
            id: f,
            value: d
          } : {
            key: f
          }), i.set(d, c);
        }
        s.push(c);
      }
      return s;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    i,
    r,
    a
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const li = /* @__PURE__ */ G(!1);
function YC(e) {
  if (U(li))
    return /* @__PURE__ */ x.createElement(x.Fragment, null, e.children);
  let n = /* @__PURE__ */ x.createElement(li.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ x.createElement("template", {
    "data-react-aria-hidden": !0
  }, n);
}
function ua(e) {
  let t = (n, r) => U(li) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, ee(t);
}
function qC() {
  return U(li);
}
var Bl = { exports: {} }, ko = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gc;
function XC() {
  if (gc) return ko;
  gc = 1;
  var e = x;
  function t(c, f) {
    return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, a = e.useEffect, l = e.useLayoutEffect, i = e.useDebugValue;
  function o(c, f) {
    var b = f(), p = r({ inst: { value: b, getSnapshot: f } }), h = p[0].inst, m = p[1];
    return l(
      function() {
        h.value = b, h.getSnapshot = f, u(h) && m({ inst: h });
      },
      [c, b, f]
    ), a(
      function() {
        return u(h) && m({ inst: h }), c(function() {
          u(h) && m({ inst: h });
        });
      },
      [c]
    ), i(b), b;
  }
  function u(c) {
    var f = c.getSnapshot;
    c = c.value;
    try {
      var b = f();
      return !n(c, b);
    } catch {
      return !0;
    }
  }
  function s(c, f) {
    return f();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? s : o;
  return ko.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, ko;
}
var So = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yc;
function JC() {
  return yc || (yc = 1, process.env.NODE_ENV !== "production" && function() {
    function e(b, p) {
      return b === p && (b !== 0 || 1 / b === 1 / p) || b !== b && p !== p;
    }
    function t(b, p) {
      d || a.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = p();
      if (!c) {
        var m = p();
        l(h, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      m = i({
        inst: { value: h, getSnapshot: p }
      });
      var v = m[0].inst, y = m[1];
      return u(
        function() {
          v.value = h, v.getSnapshot = p, n(v) && y({ inst: v });
        },
        [b, h, p]
      ), o(
        function() {
          return n(v) && y({ inst: v }), b(function() {
            n(v) && y({ inst: v });
          });
        },
        [b]
      ), s(h), h;
    }
    function n(b) {
      var p = b.getSnapshot;
      b = b.value;
      try {
        var h = p();
        return !l(b, h);
      } catch {
        return !0;
      }
    }
    function r(b, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = x, l = typeof Object.is == "function" ? Object.is : e, i = a.useState, o = a.useEffect, u = a.useLayoutEffect, s = a.useDebugValue, d = !1, c = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    So.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), So;
}
var $c;
function QC() {
  return $c || ($c = 1, process.env.NODE_ENV === "production" ? Bl.exports = XC() : Bl.exports = JC()), Bl.exports;
}
var e8 = QC();
const qy = /* @__PURE__ */ G(!1), Ya = /* @__PURE__ */ G(null);
function Kn(e) {
  if (U(Ya))
    return e.content;
  let { collection: n, document: r } = a8(e.createCollection);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(YC, null, /* @__PURE__ */ x.createElement(Ya.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ x.createElement(t8, {
    render: e.children,
    collection: n
  }));
}
function t8({ collection: e, render: t }) {
  return t(e);
}
function n8(e, t, n) {
  let r = vn(), a = j(r);
  a.current = r;
  let l = ie(() => a.current ? n() : t(), [
    t,
    n
  ]);
  return e8.useSyncExternalStore(e, l);
}
const r8 = typeof x.useSyncExternalStore == "function" ? x.useSyncExternalStore : n8;
function a8(e) {
  let [t] = q(() => new ZC((e == null ? void 0 : e()) || new Fi())), n = ie((i) => t.subscribe(i), [
    t
  ]), r = ie(() => {
    let i = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), i;
  }, [
    t
  ]), a = ie(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]), l = r8(n, r, a);
  return Ce(() => (t.isMounted = !0, () => {
    t.isMounted = !1;
  }), [
    t
  ]), {
    collection: l,
    document: t
  };
}
const fu = /* @__PURE__ */ G(null);
function Xy(e, t, n, r, a, l) {
  let i = ie((u) => {
    u == null || u.setProps(t, n, r, l);
  }, [
    t,
    n,
    r,
    l
  ]), o = U(fu);
  if (o) {
    let u = o.ownerDocument.nodesByProps.get(t);
    return u || (u = o.ownerDocument.createElement(e), u.setProps(t, n, r, l), o.appendChild(u), o.ownerDocument.updateCollection(), o.ownerDocument.nodesByProps.set(t, u)), a ? /* @__PURE__ */ x.createElement(fu.Provider, {
      value: u
    }, a) : null;
  }
  return /* @__PURE__ */ x.createElement(e, {
    ref: i
  }, a);
}
function dn(e, t) {
  let n = ({ node: a }) => t(a.props, a.props.ref, a), r = ee((a, l) => {
    let i = U(Ul);
    if (!U(qy)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(a, l);
    }
    return Xy(e, a, l, "children" in a ? a.children : null, null, (u) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ x.createElement(Ul.Provider, {
        value: i
      }, /* @__PURE__ */ x.createElement(n, {
        node: u
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function Ai(e, t, n = Jy) {
  let r = ({ node: l }) => t(l.props, l.props.ref, l), a = ee((l, i) => {
    let o = n(l);
    var u;
    return (u = Xy(e, l, i, null, o, (s) => /* @__PURE__ */ x.createElement(r, {
      node: s
    }))) !== null && u !== void 0 ? u : /* @__PURE__ */ x.createElement(x.Fragment, null);
  });
  return a.displayName = t.name, a;
}
function Jy(e) {
  return hs({
    ...e,
    addIdAndValue: !0
  });
}
const xc = /* @__PURE__ */ G(null);
function Lt(e) {
  let t = U(xc), n = ((t == null ? void 0 : t.dependencies) || []).concat(e.dependencies), r = e.idScope || (t == null ? void 0 : t.idScope), a = Jy({
    ...e,
    idScope: r,
    dependencies: n
  });
  return U(Ya) && (a = /* @__PURE__ */ x.createElement(l8, null, a)), t = H(() => ({
    dependencies: n,
    idScope: r
  }), [
    r,
    ...n
  ]), /* @__PURE__ */ x.createElement(xc.Provider, {
    value: t
  }, a);
}
function l8({ children: e }) {
  let t = U(Ya), n = H(() => /* @__PURE__ */ x.createElement(Ya.Provider, {
    value: null
  }, /* @__PURE__ */ x.createElement(qy.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return vn() ? /* @__PURE__ */ x.createElement(fu.Provider, {
    value: t
  }, n) : /* @__PURE__ */ U5(n, t);
}
const ln = /* @__PURE__ */ G({});
let i8 = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...a } = e;
  return a;
};
const Qy = /* @__PURE__ */ ua(function(t, n) {
  [t, n] = oe(t, n, ln);
  let { hoverProps: r, isHovered: a } = Ie(t), { isFocused: l, isFocusVisible: i, focusProps: o } = Fe({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), u = !!t["aria-invalid"] && t["aria-invalid"] !== "false", s = ne({
    ...t,
    values: {
      isHovered: a,
      isFocused: l,
      isFocusVisible: i,
      isDisabled: t.disabled || !1,
      isInvalid: u
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ x.createElement("input", {
    ..._(i8(t), o, r),
    ...s,
    ref: n,
    "data-focused": l || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": a || void 0,
    "data-focus-visible": i || void 0,
    "data-invalid": u || void 0
  });
}), dt = /* @__PURE__ */ G({}), o8 = /* @__PURE__ */ ua(function(t, n) {
  [t, n] = oe(t, n, dt);
  let { elementType: r = "label", ...a } = t;
  return /* @__PURE__ */ x.createElement(r, {
    className: "react-aria-Label",
    ...a,
    ref: n
  });
}), e$ = /* @__PURE__ */ G(null), t$ = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, e$);
  let { value: r = 0, minValue: a = 0, maxValue: l = 100, isIndeterminate: i = !1 } = t;
  r = Qe(r, a, l);
  let [o, u] = tt(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: s, labelProps: d } = jv({
    ...t,
    label: u
  }), c = i ? void 0 : (r - a) / (l - a) * 100, f = ne({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: c,
      valueText: s["aria-valuetext"],
      isIndeterminate: i
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...s,
    ...f,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ x.createElement(dt.Provider, {
    value: {
      ...d,
      ref: o,
      elementType: "span"
    }
  }, f.children));
}), u8 = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), Pt = /* @__PURE__ */ G({}), ur = /* @__PURE__ */ ua(function(t, n) {
  [t, n] = oe(t, n, Pt), t = s8(t);
  let r = t, { isPending: a } = r, { buttonProps: l, isPressed: i } = Ju(t, n), { focusProps: o, isFocused: u, isFocusVisible: s } = Fe(t), { hoverProps: d, isHovered: c } = Ie({
    ...t,
    isDisabled: t.isDisabled || a
  }), f = {
    isHovered: c,
    isPressed: (r.isPressed || i) && !a,
    isFocused: u,
    isFocusVisible: s,
    isDisabled: t.isDisabled || !1,
    isPending: a ?? !1
  }, b = ne({
    ...t,
    values: f,
    defaultClassName: "react-aria-Button"
  }), p = Ee(l.id), h = Ee(), m = l["aria-labelledby"];
  a && (m ? m = `${m} ${h}` : l["aria-label"] && (m = `${p} ${h}`));
  let v = j(a);
  return re(() => {
    let y = {
      "aria-labelledby": m || p
    };
    (!v.current && u && a || v.current && u && !a) && hn(y, "assertive"), v.current = a;
  }, [
    a,
    u,
    m,
    p
  ]), /* @__PURE__ */ x.createElement("button", {
    ...J(t, {
      propNames: u8
    }),
    ..._(l, o, d),
    ...b,
    type: l.type === "submit" && a ? "button" : l.type,
    id: p,
    ref: n,
    "aria-labelledby": m,
    slot: t.slot || void 0,
    "aria-disabled": a ? "true" : l["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-hovered": c || void 0,
    "data-focused": u || void 0,
    "data-pending": a || void 0,
    "data-focus-visible": s || void 0
  }, /* @__PURE__ */ x.createElement(e$.Provider, {
    value: {
      id: h
    }
  }, b.children));
});
function s8(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
const ut = /* @__PURE__ */ G({}), sl = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, ut);
  let { elementType: r = "span", ...a } = t;
  return /* @__PURE__ */ x.createElement(r, {
    className: "react-aria-Text",
    ...a,
    ref: n
  });
}), Mt = /* @__PURE__ */ G(null), d8 = /* @__PURE__ */ ee(function(t, n) {
  let r = U(Mt);
  return r != null && r.isInvalid ? /* @__PURE__ */ x.createElement(c8, {
    ...t,
    ref: n
  }) : null;
}), c8 = /* @__PURE__ */ ee((e, t) => {
  let n = U(Mt), r = J(e), a = ne({
    ...e,
    defaultClassName: "react-aria-FieldError",
    defaultChildren: n.validationErrors.length === 0 ? void 0 : n.validationErrors.join(" "),
    values: n
  });
  return a.children == null ? null : /* @__PURE__ */ x.createElement(sl, {
    slot: "errorMessage",
    ...r,
    ...a,
    ref: t
  });
});
function Xr(e, t, n) {
  return t != null && e.compare(t) < 0 || n != null && e.compare(n) > 0;
}
function bu(e, t, n, r, a) {
  let l = {};
  for (let o in t)
    l[o] = Math.floor(t[o] / 2), l[o] > 0 && t[o] % 2 === 0 && l[o]--;
  let i = Dr(e, t, n).subtract(l);
  return qa(e, i, t, n, r, a);
}
function Dr(e, t, n, r, a) {
  let l = e;
  return t.years ? l = G6(e) : t.months ? l = Br(e) : t.weeks && (l = La(e, n)), qa(e, l, t, n, r, a);
}
function pu(e, t, n, r, a) {
  let l = {
    ...t
  };
  l.days ? l.days-- : l.weeks ? l.weeks-- : l.months ? l.months-- : l.years && l.years--;
  let i = Dr(e, t, n).subtract(l);
  return qa(e, i, t, n, r, a);
}
function qa(e, t, n, r, a, l) {
  if (a && e.compare(a) >= 0) {
    let i = Lu(t, Dr(Ct(a), n, r));
    i && (t = i);
  }
  if (l && e.compare(l) <= 0) {
    let i = ju(t, pu(Ct(l), n, r));
    i && (t = i);
  }
  return t;
}
function qn(e, t, n) {
  if (t) {
    let r = Lu(e, Ct(t));
    r && (e = r);
  }
  if (n) {
    let r = ju(e, Ct(n));
    r && (e = r);
  }
  return e;
}
function n$(e, t, n) {
  if (!n) return e;
  for (; e.compare(t) >= 0 && n(e); ) e = e.subtract({
    days: 1
  });
  return e.compare(t) >= 0 ? e : null;
}
function r$(e) {
  let t = H(() => new Xt(e.locale), [
    e.locale
  ]), n = H(() => t.resolvedOptions(), [
    t
  ]), { locale: r, createCalendar: a, visibleDuration: l = {
    months: 1
  }, minValue: i, maxValue: o, selectionAlignment: u, isDateUnavailable: s, pageBehavior: d = "visible", firstDayOfWeek: c } = e, f = H(() => a(n.calendar), [
    a,
    n.calendar
  ]);
  var b;
  let [p, h] = Me(e.value, (b = e.defaultValue) !== null && b !== void 0 ? b : null, e.onChange), m = H(() => p ? Ue(Ct(p), f) : null, [
    p,
    f
  ]), v = H(() => p && "timeZone" in p ? p.timeZone : n.timeZone, [
    p,
    n.timeZone
  ]), y = H(() => e.focusedValue ? qn(Ue(Ct(e.focusedValue), f), i, o) : void 0, [
    e.focusedValue,
    f,
    i,
    o
  ]), w = H(() => qn(e.defaultFocusedValue ? Ue(Ct(e.defaultFocusedValue), f) : m || Ue(gi(v), f), i, o), [
    e.defaultFocusedValue,
    m,
    v,
    f,
    i,
    o
  ]), [C, D] = Me(y, w, e.onFocusChange), [P, R] = q(() => {
    switch (u) {
      case "start":
        return Dr(C, l, r, i, o);
      case "end":
        return pu(C, l, r, i, o);
      case "center":
      default:
        return bu(C, l, r, i, o);
    }
  }), [V, L] = q(e.autoFocus || !1), A = H(() => {
    let F = {
      ...l
    };
    return F.days ? F.days-- : F.days = -1, P.add(F);
  }, [
    P,
    l
  ]), [$, S] = q(f);
  if (!vi(f, $)) {
    let F = Ue(C, f);
    R(bu(F, l, r, i, o)), D(F), S(f);
  }
  Xr(C, i, o) ? D(qn(C, i, o)) : C.compare(P) < 0 ? R(pu(C, l, r, i, o)) : C.compare(A) > 0 && R(Dr(C, l, r, i, o));
  function T(F) {
    F = qn(F, i, o), D(F);
  }
  function M(F) {
    if (!e.isDisabled && !e.isReadOnly) {
      let z = F;
      if (z === null) {
        h(null);
        return;
      }
      if (z = qn(z, i, o), z = n$(z, P, s), !z) return;
      z = Ue(z, (p == null ? void 0 : p.calendar) || new wt()), p && "hour" in p ? h(p.set(z)) : h(z);
    }
  }
  let K = H(() => m ? s && s(m) ? !0 : Xr(m, i, o) : !1, [
    m,
    s,
    i,
    o
  ]), g = e.isInvalid || e.validationState === "invalid" || K, B = g ? "invalid" : null, k = H(() => d === "visible" ? l : Bo(l), [
    d,
    l
  ]);
  var I, O;
  return {
    isDisabled: (I = e.isDisabled) !== null && I !== void 0 ? I : !1,
    isReadOnly: (O = e.isReadOnly) !== null && O !== void 0 ? O : !1,
    value: m,
    setValue: M,
    visibleRange: {
      start: P,
      end: A
    },
    minValue: i,
    maxValue: o,
    focusedDate: C,
    timeZone: v,
    validationState: B,
    isValueInvalid: g,
    setFocusedDate(F) {
      T(F), L(!0);
    },
    focusNextDay() {
      T(C.add({
        days: 1
      }));
    },
    focusPreviousDay() {
      T(C.subtract({
        days: 1
      }));
    },
    focusNextRow() {
      l.days ? this.focusNextPage() : (l.weeks || l.months || l.years) && T(C.add({
        weeks: 1
      }));
    },
    focusPreviousRow() {
      l.days ? this.focusPreviousPage() : (l.weeks || l.months || l.years) && T(C.subtract({
        weeks: 1
      }));
    },
    focusNextPage() {
      let F = P.add(k);
      D(qn(C.add(k), i, o)), R(Dr(qa(C, F, k, r, i, o), k, r));
    },
    focusPreviousPage() {
      let F = P.subtract(k);
      D(qn(C.subtract(k), i, o)), R(Dr(qa(C, F, k, r, i, o), k, r));
    },
    focusSectionStart() {
      l.days ? T(P) : l.weeks ? T(La(C, r)) : (l.months || l.years) && T(Br(C));
    },
    focusSectionEnd() {
      l.days ? T(A) : l.weeks ? T(q6(C, r)) : (l.months || l.years) && T(Gl(C));
    },
    focusNextSection(F) {
      if (!F && !l.days) {
        T(C.add(Bo(l)));
        return;
      }
      l.days ? this.focusNextPage() : l.weeks ? T(C.add({
        months: 1
      })) : (l.months || l.years) && T(C.add({
        years: 1
      }));
    },
    focusPreviousSection(F) {
      if (!F && !l.days) {
        T(C.subtract(Bo(l)));
        return;
      }
      l.days ? this.focusPreviousPage() : l.weeks ? T(C.subtract({
        months: 1
      })) : (l.months || l.years) && T(C.subtract({
        years: 1
      }));
    },
    selectFocusedDate() {
      s && s(C) || M(C);
    },
    selectDate(F) {
      M(F);
    },
    isFocused: V,
    setFocused: L,
    isInvalid(F) {
      return Xr(F, i, o);
    },
    isSelected(F) {
      return m != null && Xe(F, m) && !this.isCellDisabled(F) && !this.isCellUnavailable(F);
    },
    isCellFocused(F) {
      return V && C && Xe(F, C);
    },
    isCellDisabled(F) {
      return e.isDisabled || F.compare(P) < 0 || F.compare(A) > 0 || this.isInvalid(F);
    },
    isCellUnavailable(F) {
      return e.isDateUnavailable ? e.isDateUnavailable(F) : !1;
    },
    isPreviousVisibleRangeInvalid() {
      let F = P.subtract({
        days: 1
      });
      return Xe(F, P) || this.isInvalid(F);
    },
    isNextVisibleRangeInvalid() {
      let F = A.add({
        days: 1
      });
      return Xe(F, A) || this.isInvalid(F);
    },
    getDatesInWeek(F, z = P) {
      let Z = z.add({
        weeks: F
      }), te = [];
      Z = La(Z, r, c);
      let ue = Ku(Z, r, c);
      for (let be = 0; be < ue; be++) te.push(null);
      for (; te.length < 7; ) {
        te.push(Z);
        let be = Z.add({
          days: 1
        });
        if (Xe(Z, be)) break;
        Z = be;
      }
      for (; te.length < 7; ) te.push(null);
      return te;
    }
  };
}
function Bo(e) {
  let t = {
    ...e
  };
  for (let n in e) t[n] = 1;
  return t;
}
function f8(e) {
  let { value: t, defaultValue: n, onChange: r, createCalendar: a, locale: l, visibleDuration: i = {
    months: 1
  }, minValue: o, maxValue: u, ...s } = e, [d, c] = Me(t, n || null, r), [f, b] = q(null), p = "center";
  if (d && d.start && d.end) {
    let k = bu(Ct(d.start), i, l, o, u).add(i).subtract({
      days: 1
    });
    d.end.compare(k) > 0 && (p = "start");
  }
  let h = j(null), [m, v] = q(null), y = H(() => Lu(o, m == null ? void 0 : m.start), [
    o,
    m
  ]), w = H(() => ju(u, m == null ? void 0 : m.end), [
    u,
    m
  ]), C = r$({
    ...s,
    value: d && d.start,
    createCalendar: a,
    locale: l,
    visibleDuration: i,
    minValue: y,
    maxValue: w,
    selectionAlignment: p
  }), D = (B) => {
    if (B && e.isDateUnavailable && !e.allowsNonContiguousRanges) {
      const k = Cc(B, C, -1), I = Cc(B, C, 1);
      h.current = {
        start: k,
        end: I
      }, v(h.current);
    } else
      h.current = null, v(null);
  }, [P, R] = q(C.visibleRange);
  (!Lo(C.visibleRange.start, P.start) || !Lo(C.visibleRange.end, P.end)) && (D(f), R(C.visibleRange));
  let V = (B) => {
    B ? (b(B), D(B)) : (b(null), D(null));
  }, L = f ? Fo(f, C.focusedDate) : d && Fo(d.start, d.end), A = (B) => {
    if (e.isReadOnly) return;
    const k = qn(B, y, w), I = n$(k, C.visibleRange.start, e.isDateUnavailable);
    if (I)
      if (!f) V(I);
      else {
        let O = Fo(f, I);
        O && c({
          start: Dc(O.start, d == null ? void 0 : d.start),
          end: Dc(O.end, d == null ? void 0 : d.end)
        }), V(null);
      }
  }, [$, S] = q(!1), { isDateUnavailable: T } = e, M = H(() => !d || f ? !1 : T && (T(d.start) || T(d.end)) ? !0 : Xr(d.start, o, u) || Xr(d.end, o, u), [
    T,
    d,
    f,
    o,
    u
  ]), K = e.isInvalid || e.validationState === "invalid" || M;
  return {
    ...C,
    value: d,
    setValue: c,
    anchorDate: f,
    setAnchorDate: V,
    highlightedRange: L,
    validationState: K ? "invalid" : null,
    isValueInvalid: K,
    selectFocusedDate() {
      A(C.focusedDate);
    },
    selectDate: A,
    highlightDate(B) {
      f && C.setFocusedDate(B);
    },
    isSelected(B) {
      return !!(L && B.compare(L.start) >= 0 && B.compare(L.end) <= 0 && !C.isCellDisabled(B) && !C.isCellUnavailable(B));
    },
    isInvalid(B) {
      var k, I;
      return C.isInvalid(B) || Xr(B, (k = h.current) === null || k === void 0 ? void 0 : k.start, (I = h.current) === null || I === void 0 ? void 0 : I.end);
    },
    isDragging: $,
    setDragging: S
  };
}
function Fo(e, t) {
  return !e || !t ? null : (t.compare(e) < 0 && ([e, t] = [
    t,
    e
  ]), {
    start: Ct(e),
    end: Ct(t)
  });
}
function Dc(e, t) {
  return e = Ue(e, (t == null ? void 0 : t.calendar) || new wt()), t && "hour" in t ? t.set(e) : e;
}
function Cc(e, t, n) {
  let r = e.add({
    days: n
  });
  for (; (n < 0 ? r.compare(t.visibleRange.start) >= 0 : r.compare(t.visibleRange.end) <= 0) && !t.isCellUnavailable(r); ) r = r.add({
    days: n
  });
  if (t.isCellUnavailable(r)) return r.add({
    days: -n
  });
}
function b8(e = {}) {
  let [t, n] = Me(e.value, e.defaultValue || [], e.onChange), r = !!e.isRequired && t.length === 0, a = j(/* @__PURE__ */ new Map()), l = en({
    ...e,
    value: t
  }), i = l.displayValidation.isInvalid;
  var o;
  return {
    ...l,
    value: t,
    setValue(s) {
      e.isReadOnly || e.isDisabled || n(s);
    },
    isDisabled: e.isDisabled || !1,
    isReadOnly: e.isReadOnly || !1,
    isSelected(s) {
      return t.includes(s);
    },
    addValue(s) {
      e.isReadOnly || e.isDisabled || t.includes(s) || n(t.concat(s));
    },
    removeValue(s) {
      e.isReadOnly || e.isDisabled || t.includes(s) && n(t.filter((d) => d !== s));
    },
    toggleValue(s) {
      e.isReadOnly || e.isDisabled || (t.includes(s) ? n(t.filter((d) => d !== s)) : n(t.concat(s)));
    },
    setInvalid(s, d) {
      let c = new Map(a.current);
      d.isInvalid ? c.set(s, d) : c.delete(s), a.current = c, l.updateValidation(Wa(...c.values()));
    },
    validationState: (o = e.validationState) !== null && o !== void 0 ? o : i ? "invalid" : null,
    isInvalid: i,
    isRequired: r
  };
}
class hu {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    let n = this.keyMap.get(t);
    return (n == null ? void 0 : n.childNodes) || [];
  }
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (i) => {
      if (this.keyMap.set(i.key, i), i.childNodes && i.type === "section") for (let o of i.childNodes) n(o);
    };
    for (let i of t) n(i);
    let r = null, a = 0;
    for (let [i, o] of this.keyMap)
      r ? (r.nextKey = i, o.prevKey = r.key) : (this.firstKey = i, o.prevKey = void 0), o.type === "item" && (o.index = a++), r = o, r.nextKey = void 0;
    var l;
    this.lastKey = (l = r == null ? void 0 : r.key) !== null && l !== void 0 ? l : null;
  }
}
class nn extends Set {
  constructor(t, n, r) {
    super(t), t instanceof nn ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function p8(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function dl(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: a = "toggle", disabledBehavior: l = "all" } = e, i = j(!1), [, o] = q(!1), u = j(null), s = j(null), [, d] = q(null), c = H(() => Ec(e.selectedKeys), [
    e.selectedKeys
  ]), f = H(() => Ec(e.defaultSelectedKeys, new nn()), [
    e.defaultSelectedKeys
  ]), [b, p] = Me(c, f, e.onSelectionChange), h = H(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [m, v] = q(a);
  a === "replace" && m === "toggle" && typeof b == "object" && b.size === 0 && v("replace");
  let y = j(a);
  return re(() => {
    a !== y.current && (v(a), y.current = a);
  }, [
    a
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: m,
    setSelectionBehavior: v,
    get isFocused() {
      return i.current;
    },
    setFocused(w) {
      i.current = w, o(w);
    },
    get focusedKey() {
      return u.current;
    },
    get childFocusStrategy() {
      return s.current;
    },
    setFocusedKey(w, C = "first") {
      u.current = w, s.current = C, d(w);
    },
    selectedKeys: b,
    setSelectedKeys(w) {
      (r || !p8(w, b)) && p(w);
    },
    disabledKeys: h,
    disabledBehavior: l
  };
}
function Ec(e, t) {
  return e ? e === "all" ? "all" : new nn(e) : t;
}
class sa {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let a = this.collection.getItem(r);
      (!t || a && wo(this.collection, a, t) < 0) && (t = a);
    }
    var n;
    return (n = t == null ? void 0 : t.key) !== null && n !== void 0 ? n : null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let a = this.collection.getItem(r);
      (!t || a && wo(this.collection, a, t) > 0) && (t = a);
    }
    var n;
    return (n = t == null ? void 0 : t.key) !== null && n !== void 0 ? n : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new nn([
      n
    ], n, n);
    else {
      let i = this.state.selectedKeys;
      var a;
      let o = (a = i.anchorKey) !== null && a !== void 0 ? a : n;
      r = new nn(i, o, n);
      var l;
      for (let u of this.getKeyRange(o, (l = i.currentKey) !== null && l !== void 0 ? l : n)) r.delete(u);
      for (let u of this.getKeyRange(n, o)) this.canSelectItem(u) && r.add(u);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), a = this.collection.getItem(n);
    return r && a ? wo(this.collection, r, a) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    var r;
    if (!((r = this.layoutDelegate) === null || r === void 0) && r.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let a = [], l = t;
    for (; l != null; ) {
      let i = this.collection.getItem(l);
      if (i && (i.type === "item" || i.type === "cell" && this.allowsCellSelection) && a.push(l), l === n) return a;
      l = this.collection.getKeyAfter(l);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new nn(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new nn([
      n
    ], n, n) : new nn();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new nn();
    for (let r of t) {
      let a = this.getKey(r);
      if (a != null && (n.add(a), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = [], n = (r) => {
      for (; r != null; ) {
        if (this.canSelectItem(r)) {
          var a;
          let i = this.collection.getItem(r);
          (i == null ? void 0 : i.type) === "item" && t.push(r);
          var l;
          i != null && i.hasChildNodes && (this.allowsCellSelection || i.type !== "item") && n((l = (a = kn(at(i, this.collection))) === null || a === void 0 ? void 0 : a.key) !== null && l !== void 0 ? l : null);
        }
        r = this.collection.getKeyAfter(r);
      }
    };
    return n(this.collection.getFirstKey()), t;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new nn());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    var n;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = this.collection.getItem(t);
    return !(!r || !(r == null || (n = r.props) === null || n === void 0) && n.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    var n, r;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.isDisabled));
  }
  isLink(t) {
    var n, r;
    return !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.href);
  }
  getItemProps(t) {
    var n;
    return (n = this.collection.getItem(t)) === null || n === void 0 ? void 0 : n.props;
  }
  withCollection(t) {
    return new sa(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0
    });
  }
  constructor(t, n, r) {
    this.collection = t, this.state = n;
    var a;
    this.allowsCellSelection = (a = r == null ? void 0 : r.allowsCellSelection) !== null && a !== void 0 ? a : !1, this._isSelectAll = null, this.layoutDelegate = (r == null ? void 0 : r.layoutDelegate) || null;
  }
}
function Ti(e) {
  let { filter: t, layoutDelegate: n } = e, r = dl(e), a = H(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), l = ie((s) => t ? new hu(t(s)) : new hu(s), [
    t
  ]), i = H(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), o = us(e, l, i), u = H(() => new sa(o, r, {
    layoutDelegate: n
  }), [
    o,
    r,
    n
  ]);
  return a$(o, u), {
    collection: o,
    disabledKeys: a,
    selectionManager: u
  };
}
function h8(e, t) {
  let n = H(() => t ? e.collection.UNSTABLE_filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return a$(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function a$(e, t) {
  const n = j(null);
  re(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      const d = n.current.getItem(t.focusedKey), c = [
        ...n.current.getKeys()
      ].map((v) => {
        const y = n.current.getItem(v);
        return (y == null ? void 0 : y.type) === "item" ? y : null;
      }).filter((v) => v !== null), f = [
        ...e.getKeys()
      ].map((v) => {
        const y = e.getItem(v);
        return (y == null ? void 0 : y.type) === "item" ? y : null;
      }).filter((v) => v !== null);
      var r, a;
      const b = ((r = c == null ? void 0 : c.length) !== null && r !== void 0 ? r : 0) - ((a = f == null ? void 0 : f.length) !== null && a !== void 0 ? a : 0);
      var l, i, o;
      let p = Math.min(b > 1 ? Math.max(((l = d == null ? void 0 : d.index) !== null && l !== void 0 ? l : 0) - b + 1, 0) : (i = d == null ? void 0 : d.index) !== null && i !== void 0 ? i : 0, ((o = f == null ? void 0 : f.length) !== null && o !== void 0 ? o : 0) - 1), h = null, m = !1;
      for (; p >= 0; ) {
        if (!t.isDisabled(f[p].key)) {
          h = f[p];
          break;
        }
        if (p < f.length - 1 && !m) p++;
        else {
          m = !0;
          var u, s;
          p > ((u = d == null ? void 0 : d.index) !== null && u !== void 0 ? u : 0) && (p = (s = d == null ? void 0 : d.index) !== null && s !== void 0 ? s : 0), p--;
        }
      }
      t.setFocusedKey(h ? h.key : null);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function ms(e) {
  var t;
  let [n, r] = Me(e.selectedKey, (t = e.defaultSelectedKey) !== null && t !== void 0 ? t : null, e.onSelectionChange), a = H(() => n != null ? [
    n
  ] : [], [
    n
  ]), { collection: l, disabledKeys: i, selectionManager: o } = Ti({
    ...e,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: a,
    onSelectionChange: (s) => {
      if (s === "all") return;
      var d;
      let c = (d = s.values().next().value) !== null && d !== void 0 ? d : null;
      c === n && e.onSelectionChange && e.onSelectionChange(c), r(c);
    }
  }), u = n != null ? l.getItem(n) : null;
  return {
    collection: l,
    disabledKeys: i,
    selectionManager: o,
    selectedKey: n,
    setSelectedKey: r,
    selectedItem: u
  };
}
function jn(e) {
  let [t, n] = Me(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = ie(() => {
    n(!0);
  }, [
    n
  ]), a = ie(() => {
    n(!1);
  }, [
    n
  ]), l = ie(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: a,
    toggle: l
  };
}
function m8(e) {
  var t;
  let { defaultFilter: n, menuTrigger: r = "input", allowsEmptyCollection: a = !1, allowsCustomValue: l, shouldCloseOnBlur: i = !0 } = e, [o, u] = q(!1), [s, d] = q(!1), [c, f] = q(null), b = (ae) => {
    e.onSelectionChange && e.onSelectionChange(ae), ae === v && (te(), F());
  };
  var p;
  let { collection: h, selectionManager: m, selectedKey: v, setSelectedKey: y, selectedItem: w, disabledKeys: C } = ms({
    ...e,
    onSelectionChange: b,
    items: (p = e.items) !== null && p !== void 0 ? p : e.defaultItems
  }), D = e.defaultInputValue;
  if (D == null) {
    var P, R;
    v == null ? D = "" : D = (R = (P = h.getItem(v)) === null || P === void 0 ? void 0 : P.textValue) !== null && R !== void 0 ? R : "";
  }
  let [V, L] = Me(e.inputValue, D, e.onInputChange), A = h, $ = H(() => (
    // No default filter if items are controlled.
    e.items != null || !n ? h : v8(h, V, n)
  ), [
    h,
    V,
    n,
    e.items
  ]), [S, T] = q($), M = j("focus"), g = jn({
    ...e,
    onOpenChange: (ae) => {
      e.onOpenChange && e.onOpenChange(ae, ae ? M.current : void 0), m.setFocused(ae), ae || m.setFocusedKey(null);
    },
    isOpen: void 0,
    defaultOpen: void 0
  }), B = (ae = null, ge) => {
    let Se = ge === "manual" || ge === "focus" && r === "focus";
    (a || $.size > 0 || Se && A.size > 0 || e.items) && (Se && !g.isOpen && e.items === void 0 && u(!0), M.current = ge, f(ae), g.open());
  }, k = (ae = null, ge) => {
    let Se = ge === "manual" || ge === "focus" && r === "focus";
    !(a || $.size > 0 || Se && A.size > 0 || e.items) && !g.isOpen || (Se && !g.isOpen && e.items === void 0 && u(!0), g.isOpen || (M.current = ge), O(ae));
  }, I = ie(() => {
    T(o ? A : $);
  }, [
    o,
    A,
    $
  ]), O = ie((ae = null) => {
    g.isOpen && I(), f(ae), g.toggle();
  }, [
    g,
    I
  ]), F = ie(() => {
    g.isOpen && (I(), g.close());
  }, [
    g,
    I
  ]), [z, Z] = q(V), te = () => {
    var ae, ge;
    let Se = v != null && (ge = (ae = h.getItem(v)) === null || ae === void 0 ? void 0 : ae.textValue) !== null && ge !== void 0 ? ge : "";
    Z(Se), L(Se);
  };
  var ue, be;
  let ce = j((be = (ue = e.selectedKey) !== null && ue !== void 0 ? ue : e.defaultSelectedKey) !== null && be !== void 0 ? be : null);
  var X;
  let pe = j(v != null && (X = (t = h.getItem(v)) === null || t === void 0 ? void 0 : t.textValue) !== null && X !== void 0 ? X : "");
  re(() => {
    var ae;
    s && ($.size > 0 || a) && !g.isOpen && V !== z && r !== "manual" && B(null, "input"), !o && !a && g.isOpen && $.size === 0 && F(), v != null && v !== ce.current && F(), V !== z && (m.setFocusedKey(null), u(!1), V === "" && (e.inputValue === void 0 || e.selectedKey === void 0) && y(null)), v !== ce.current && (e.inputValue === void 0 || e.selectedKey === void 0) ? te() : z !== V && Z(V);
    var ge;
    let Se = v != null && (ge = (ae = h.getItem(v)) === null || ae === void 0 ? void 0 : ae.textValue) !== null && ge !== void 0 ? ge : "";
    !s && v != null && e.inputValue === void 0 && v === ce.current && pe.current !== Se && (Z(Se), L(Se)), ce.current = v, pe.current = Se;
  });
  let ve = en({
    ...e,
    value: H(() => ({
      inputValue: V,
      selectedKey: v
    }), [
      V,
      v
    ])
  }), W = () => {
    l && v == null ? se() : fe();
  }, se = () => {
    ce.current = null, y(null), F();
  }, fe = () => {
    if (e.selectedKey !== void 0 && e.inputValue !== void 0) {
      var ae, ge;
      (ae = e.onSelectionChange) === null || ae === void 0 || ae.call(e, v);
      var Se;
      let xt = v != null && (Se = (ge = h.getItem(v)) === null || ge === void 0 ? void 0 : ge.textValue) !== null && Se !== void 0 ? Se : "";
      Z(xt), F();
    } else
      te(), F();
  };
  const We = () => {
    if (l) {
      var ae, ge;
      const Se = v != null && (ge = (ae = h.getItem(v)) === null || ae === void 0 ? void 0 : ae.textValue) !== null && ge !== void 0 ? ge : "";
      V === Se ? fe() : se();
    } else
      fe();
  };
  let ye = () => {
    g.isOpen && m.focusedKey != null ? v === m.focusedKey ? fe() : y(m.focusedKey) : We();
  }, st = j(V), $t = (ae) => {
    ae ? (st.current = V, r === "focus" && !e.isReadOnly && B(null, "focus")) : (i && We(), V !== st.current && ve.commitValidation()), d(ae);
  }, Q = H(() => g.isOpen ? o ? A : $ : S, [
    g.isOpen,
    A,
    $,
    o,
    S
  ]);
  return {
    ...ve,
    ...g,
    focusStrategy: c,
    toggle: k,
    open: B,
    close: We,
    selectionManager: m,
    selectedKey: v,
    setSelectedKey: y,
    disabledKeys: C,
    isFocused: s,
    setFocused: $t,
    selectedItem: w,
    collection: Q,
    inputValue: V,
    setInputValue: L,
    commit: ye,
    revert: W
  };
}
function v8(e, t, n) {
  return new hu(l$(e, e, t, n));
}
function l$(e, t, n, r) {
  let a = [];
  for (let l of t)
    if (l.type === "section" && l.hasChildNodes) {
      let i = l$(e, at(l, e), n, r);
      [
        ...i
      ].some((o) => o.type === "item") && a.push({
        ...l,
        childNodes: i
      });
    } else l.type === "item" && r(l.textValue, n) ? a.push({
      ...l
    }) : l.type !== "item" && a.push({
      ...l
    });
  return a;
}
var i$ = {};
i$ = {
  rangeOverflow: (e) => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
  rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
  rangeUnderflow: (e) => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
  unavailableDate: "البيانات المحددة غير متاحة."
};
var o$ = {};
o$ = {
  rangeOverflow: (e) => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
  rangeReversed: "Началната дата трябва да е преди крайната.",
  rangeUnderflow: (e) => `Стойността трябва да е ${e.minValue} или по-късно.`,
  unavailableDate: "Избраната дата не е налична."
};
var u$ = {};
u$ = {
  rangeOverflow: (e) => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
  rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
  rangeUnderflow: (e) => `Hodnota musí být ${e.minValue} nebo pozdější.`,
  unavailableDate: "Vybrané datum není k dispozici."
};
var s$ = {};
s$ = {
  rangeOverflow: (e) => `Værdien skal være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen skal være før slutdatoen.",
  rangeUnderflow: (e) => `Værdien skal være ${e.minValue} eller nyere.`,
  unavailableDate: "Den valgte dato er ikke tilgængelig."
};
var d$ = {};
d$ = {
  rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder früher sein.`,
  rangeReversed: "Das Anfangsdatum muss vor dem Enddatum liegen.",
  rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder später sein.`,
  unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
var c$ = {};
c$ = {
  rangeOverflow: (e) => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
  rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  rangeUnderflow: (e) => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
  unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
var f$ = {};
f$ = {
  rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
  rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
  rangeReversed: "Start date must be before end date.",
  unavailableDate: "Selected date unavailable."
};
var b$ = {};
b$ = {
  rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
  rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
  unavailableDate: "Fecha seleccionada no disponible."
};
var p$ = {};
p$ = {
  rangeOverflow: (e) => `Väärtus peab olema ${e.maxValue} või varasem.`,
  rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
  rangeUnderflow: (e) => `Väärtus peab olema ${e.minValue} või hilisem.`,
  unavailableDate: "Valitud kuupäev pole saadaval."
};
var h$ = {};
h$ = {
  rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
  rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
  rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
  unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
var m$ = {};
m$ = {
  rangeOverflow: (e) => `La valeur doit être ${e.maxValue} ou antérieure.`,
  rangeReversed: "La date de début doit être antérieure à la date de fin.",
  rangeUnderflow: (e) => `La valeur doit être ${e.minValue} ou ultérieure.`,
  unavailableDate: "La date sélectionnée n’est pas disponible."
};
var v$ = {};
v$ = {
  rangeOverflow: (e) => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
  rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
  rangeUnderflow: (e) => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
  unavailableDate: "התאריך הנבחר אינו זמין."
};
var g$ = {};
g$ = {
  rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
  rangeReversed: "Datum početka mora biti prije datuma završetka.",
  rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
  unavailableDate: "Odabrani datum nije dostupan."
};
var y$ = {};
y$ = {
  rangeOverflow: (e) => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
  rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
  rangeUnderflow: (e) => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
  unavailableDate: "A kiválasztott dátum nem érhető el."
};
var $$ = {};
$$ = {
  rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
  rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
  rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
  unavailableDate: "Data selezionata non disponibile."
};
var x$ = {};
x$ = {
  rangeOverflow: (e) => `値は ${e.maxValue} 以下にする必要があります。`,
  rangeReversed: "開始日は終了日より前にする必要があります。",
  rangeUnderflow: (e) => `値は ${e.minValue} 以上にする必要があります。`,
  unavailableDate: "選択した日付は使用できません。"
};
var D$ = {};
D$ = {
  rangeOverflow: (e) => `값은 ${e.maxValue} 이전이어야 합니다.`,
  rangeReversed: "시작일은 종료일 이전이어야 합니다.",
  rangeUnderflow: (e) => `값은 ${e.minValue} 이상이어야 합니다.`,
  unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
var C$ = {};
C$ = {
  rangeOverflow: (e) => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
  rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
  rangeUnderflow: (e) => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
  unavailableDate: "Pasirinkta data nepasiekiama."
};
var E$ = {};
E$ = {
  rangeOverflow: (e) => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
  rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
  rangeUnderflow: (e) => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
  unavailableDate: "Atlasītais datums nav pieejams."
};
var w$ = {};
w$ = {
  rangeOverflow: (e) => `Verdien må være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen må være før sluttdatoen.",
  rangeUnderflow: (e) => `Verdien må være ${e.minValue} eller senere.`,
  unavailableDate: "Valgt dato utilgjengelig."
};
var P$ = {};
P$ = {
  rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
  rangeReversed: "De startdatum moet voor de einddatum liggen.",
  rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
  unavailableDate: "Geselecteerde datum niet beschikbaar."
};
var k$ = {};
k$ = {
  rangeOverflow: (e) => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
  rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
  rangeUnderflow: (e) => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
  unavailableDate: "Wybrana data jest niedostępna."
};
var S$ = {};
S$ = {
  rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data inicial deve ser anterior à data final.",
  rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var B$ = {};
B$ = {
  rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data de início deve ser anterior à data de fim.",
  rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var F$ = {};
F$ = {
  rangeOverflow: (e) => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
  rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
  rangeUnderflow: (e) => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
  unavailableDate: "Data selectată nu este disponibilă."
};
var A$ = {};
A$ = {
  rangeOverflow: (e) => `Значение должно быть не позже ${e.maxValue}.`,
  rangeReversed: "Дата начала должна предшествовать дате окончания.",
  rangeUnderflow: (e) => `Значение должно быть не раньше ${e.minValue}.`,
  unavailableDate: "Выбранная дата недоступна."
};
var T$ = {};
T$ = {
  rangeOverflow: (e) => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
  rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
  rangeUnderflow: (e) => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
  unavailableDate: "Vybratý dátum je nedostupný."
};
var R$ = {};
R$ = {
  rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starejša.`,
  rangeReversed: "Začetni datum mora biti pred končnim datumom.",
  rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novejša.`,
  unavailableDate: "Izbrani datum ni na voljo."
};
var M$ = {};
M$ = {
  rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
  rangeReversed: "Datum početka mora biti pre datuma završetka.",
  rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
  unavailableDate: "Izabrani datum nije dostupan."
};
var N$ = {};
N$ = {
  rangeOverflow: (e) => `Värdet måste vara ${e.maxValue} eller tidigare.`,
  rangeReversed: "Startdatumet måste vara före slutdatumet.",
  rangeUnderflow: (e) => `Värdet måste vara ${e.minValue} eller senare.`,
  unavailableDate: "Det valda datumet är inte tillgängligt."
};
var V$ = {};
V$ = {
  rangeOverflow: (e) => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
  rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
  rangeUnderflow: (e) => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
  unavailableDate: "Seçilen tarih kullanılamıyor."
};
var I$ = {};
I$ = {
  rangeOverflow: (e) => `Значення має бути не пізніше ${e.maxValue}.`,
  rangeReversed: "Дата початку має передувати даті завершення.",
  rangeUnderflow: (e) => `Значення має бути не раніше ${e.minValue}.`,
  unavailableDate: "Вибрана дата недоступна."
};
var O$ = {};
O$ = {
  rangeOverflow: (e) => `值必须是 ${e.maxValue} 或更早日期。`,
  rangeReversed: "开始日期必须早于结束日期。",
  rangeUnderflow: (e) => `值必须是 ${e.minValue} 或更晚日期。`,
  unavailableDate: "所选日期不可用。"
};
var z$ = {};
z$ = {
  rangeOverflow: (e) => `值必須是 ${e.maxValue} 或更早。`,
  rangeReversed: "開始日期必須在結束日期之前。",
  rangeUnderflow: (e) => `值必須是 ${e.minValue} 或更晚。`,
  unavailableDate: "所選日期無法使用。"
};
var K$ = {};
K$ = {
  "ar-AE": i$,
  "bg-BG": o$,
  "cs-CZ": u$,
  "da-DK": s$,
  "de-DE": d$,
  "el-GR": c$,
  "en-US": f$,
  "es-ES": b$,
  "et-EE": p$,
  "fi-FI": h$,
  "fr-FR": m$,
  "he-IL": v$,
  "hr-HR": g$,
  "hu-HU": y$,
  "it-IT": $$,
  "ja-JP": x$,
  "ko-KR": D$,
  "lt-LT": C$,
  "lv-LV": E$,
  "nb-NO": w$,
  "nl-NL": P$,
  "pl-PL": k$,
  "pt-BR": S$,
  "pt-PT": B$,
  "ro-RO": F$,
  "ru-RU": A$,
  "sk-SK": T$,
  "sl-SI": R$,
  "sr-SP": M$,
  "sv-SE": N$,
  "tr-TR": V$,
  "uk-UA": I$,
  "zh-CN": O$,
  "zh-TW": z$
};
function g8(e) {
  return e && e.__esModule ? e.default : e;
}
const j$ = new Jt(g8(K$));
function L$() {
  return typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
}
function ii(e, t, n, r, a) {
  let l = e != null && n != null && e.compare(n) > 0, i = e != null && t != null && e.compare(t) < 0, o = e != null && (r == null ? void 0 : r(e)) || !1, u = l || i || o, s = [];
  if (u) {
    let d = L$(), c = Jt.getGlobalDictionaryForPackage("@react-stately/datepicker") || j$, f = new zu(d, c), b = new Xt(d, Tn({}, a)), p = b.resolvedOptions().timeZone;
    i && t != null && s.push(f.format("rangeUnderflow", {
      minValue: b.format(t.toDate(p))
    })), l && n != null && s.push(f.format("rangeOverflow", {
      maxValue: b.format(n.toDate(p))
    })), o && s.push(f.format("unavailableDate"));
  }
  return {
    isInvalid: u,
    validationErrors: s,
    validationDetails: {
      badInput: o,
      customError: !1,
      patternMismatch: !1,
      rangeOverflow: l,
      rangeUnderflow: i,
      stepMismatch: !1,
      tooLong: !1,
      tooShort: !1,
      typeMismatch: !1,
      valueMissing: !1,
      valid: !u
    }
  };
}
function y8(e, t, n, r, a) {
  var l;
  let i = ii((l = e == null ? void 0 : e.start) !== null && l !== void 0 ? l : null, t, n, r, a);
  var o;
  let u = ii((o = e == null ? void 0 : e.end) !== null && o !== void 0 ? o : null, t, n, r, a), s = Wa(i, u);
  if ((e == null ? void 0 : e.end) != null && e.start != null && e.end.compare(e.start) < 0) {
    let d = Jt.getGlobalDictionaryForPackage("@react-stately/datepicker") || j$;
    s = Wa(s, {
      isInvalid: !0,
      validationErrors: [
        d.getStringForLocale("rangeReversed", L$())
      ],
      validationDetails: {
        ...Di,
        rangeUnderflow: !0,
        rangeOverflow: !0,
        valid: !1
      }
    });
  }
  return s;
}
const $8 = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}, x8 = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
function Tn(e, t) {
  e = {
    ...t.shouldForceLeadingZeros ? x8 : $8,
    ...e
  };
  let r = t.granularity || "minute", a = Object.keys(e);
  var l;
  let i = a.indexOf((l = t.maxGranularity) !== null && l !== void 0 ? l : "year");
  i < 0 && (i = 0);
  let o = a.indexOf(r);
  if (o < 0 && (o = 2), i > o) throw new Error("maxGranularity must be greater than granularity");
  let u = a.slice(i, o + 1).reduce((d, c) => (d[c] = e[c], d), {});
  return t.hourCycle != null && (u.hour12 = t.hourCycle === 12), u.timeZone = t.timeZone || "UTC", (r === "hour" || r === "minute" || r === "second") && t.timeZone && !t.hideTimeZone && (u.timeZoneName = "short"), t.showEra && i === 0 && (u.era = "short"), u;
}
function Ur(e) {
  return e && "hour" in e ? e : new nl();
}
function H$(e, t) {
  if (e === null) return null;
  if (e)
    return Ue(e, t);
}
function xa(e, t, n, r) {
  if (e) return H$(e, n);
  let a = Ue(Xf(r ?? yi()).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), n);
  return t === "year" || t === "month" || t === "day" ? Ct(a) : r ? a : an(a);
}
function vs(e, t) {
  let n = e && "timeZone" in e ? e.timeZone : void 0, r = e && "minute" in e ? "minute" : "day";
  if (e && t && !(t in e)) throw new Error("Invalid granularity " + t + " for value " + e.toString());
  let [a, l] = q([
    r,
    n
  ]);
  e && (a[0] !== r || a[1] !== n) && l([
    r,
    n
  ]), t || (t = e ? r : a[0]);
  let i = e ? n : a[1];
  return [
    t,
    i
  ];
}
function D8(e) {
  let t = jn(e), [n, r] = Me(e.value, e.defaultValue || null, e.onChange), a = n || e.placeholderValue || null, [l, i] = vs(a, e.granularity), o = n != null ? n.toDate(i ?? "UTC") : null, u = l === "hour" || l === "minute" || l === "second";
  var s;
  let d = (s = e.shouldCloseOnSelect) !== null && s !== void 0 ? s : !0, [c, f] = q(null), [b, p] = q(null);
  if (n && (c = n, "hour" in n && (b = n)), a && !(l in a)) throw new Error("Invalid granularity " + l + " for value " + a.toString());
  let h = (n == null ? void 0 : n.calendar.identifier) === "gregory" && n.era === "BC", m = H(() => ({
    granularity: l,
    timeZone: i,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: h
  }), [
    l,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    i,
    e.hideTimeZone,
    h
  ]), { minValue: v, maxValue: y, isDateUnavailable: w } = e, C = H(() => ii(n, v, y, w, m), [
    n,
    v,
    y,
    w,
    m
  ]), D = en({
    ...e,
    value: n,
    builtinValidation: C
  }), P = D.displayValidation.isInvalid, R = e.validationState || (P ? "invalid" : null), V = ($, S) => {
    r("timeZone" in S ? S.set(Ct($)) : an($, S)), f(null), p(null), D.commitValidation();
  };
  return {
    ...D,
    value: n,
    setValue: r,
    dateValue: c,
    timeValue: b,
    setDateValue: ($) => {
      let S = typeof d == "function" ? d() : d;
      u ? b || S ? V($, b || Ur(e.defaultValue || e.placeholderValue)) : f($) : (r($), D.commitValidation()), S && t.setOpen(!1);
    },
    setTimeValue: ($) => {
      c && $ ? V(c, $) : p($);
    },
    granularity: l,
    hasTime: u,
    ...t,
    setOpen($) {
      !$ && !n && c && u && V(c, b || Ur(e.defaultValue || e.placeholderValue)), t.setOpen($);
    },
    validationState: R,
    isInvalid: P,
    formatValue($, S) {
      if (!o) return "";
      let T = Tn(S, m);
      return new Xt($, T).format(o);
    },
    getDateFormatter($, S) {
      let T = {
        ...m,
        ...S
      }, M = Tn({}, T);
      return new Xt($, M);
    }
  };
}
const C8 = new Jt({
  ach: {
    year: "mwaka",
    month: "dwe",
    day: "nino"
  },
  af: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  am: {
    year: "ዓዓዓዓ",
    month: "ሚሜ",
    day: "ቀቀ"
  },
  an: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ar: {
    year: "سنة",
    month: "شهر",
    day: "يوم"
  },
  ast: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  az: {
    year: "iiii",
    month: "aa",
    day: "gg"
  },
  be: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bg: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bn: {
    year: "yyyy",
    month: "মিমি",
    day: "dd"
  },
  br: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  bs: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  ca: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  cak: {
    year: "jjjj",
    month: "ii",
    day: "q'q'"
  },
  ckb: {
    year: "ساڵ",
    month: "مانگ",
    day: "ڕۆژ"
  },
  cs: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  cy: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  da: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  de: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  dsb: {
    year: "llll",
    month: "mm",
    day: "źź"
  },
  el: {
    year: "εεεε",
    month: "μμ",
    day: "ηη"
  },
  en: {
    year: "yyyy",
    month: "mm",
    day: "dd"
  },
  eo: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  es: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  et: {
    year: "aaaa",
    month: "kk",
    day: "pp"
  },
  eu: {
    year: "uuuu",
    month: "hh",
    day: "ee"
  },
  fa: {
    year: "سال",
    month: "ماه",
    day: "روز"
  },
  ff: {
    year: "hhhh",
    month: "ll",
    day: "ññ"
  },
  fi: {
    year: "vvvv",
    month: "kk",
    day: "pp"
  },
  fr: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  fy: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  ga: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gd: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gl: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  he: {
    year: "שנה",
    month: "חודש",
    day: "יום"
  },
  hr: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  hsb: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  hu: {
    year: "éééé",
    month: "hh",
    day: "nn"
  },
  ia: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  id: {
    year: "tttt",
    month: "bb",
    day: "hh"
  },
  it: {
    year: "aaaa",
    month: "mm",
    day: "gg"
  },
  ja: {
    year: "年",
    month: "月",
    day: "日"
  },
  ka: {
    year: "წწწწ",
    month: "თთ",
    day: "რრ"
  },
  kk: {
    year: "жжжж",
    month: "аа",
    day: "кк"
  },
  kn: {
    year: "ವವವವ",
    month: "ಮಿಮೀ",
    day: "ದಿದಿ"
  },
  ko: {
    year: "연도",
    month: "월",
    day: "일"
  },
  lb: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  lo: {
    year: "ປປປປ",
    month: "ດດ",
    day: "ວວ"
  },
  lt: {
    year: "mmmm",
    month: "mm",
    day: "dd"
  },
  lv: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  meh: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ml: {
    year: "വർഷം",
    month: "മാസം",
    day: "തീയതി"
  },
  ms: {
    year: "tttt",
    month: "mm",
    day: "hh"
  },
  nl: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  nn: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  no: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  oc: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  pl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  pt: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  rm: {
    year: "oooo",
    month: "mm",
    day: "dd"
  },
  ro: {
    year: "aaaa",
    month: "ll",
    day: "zz"
  },
  ru: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sc: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  scn: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  sk: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  sl: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  sr: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sv: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  szl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  tg: {
    year: "сссс",
    month: "мм",
    day: "рр"
  },
  th: {
    year: "ปปปป",
    month: "ดด",
    day: "วว"
  },
  tr: {
    year: "yyyy",
    month: "aa",
    day: "gg"
  },
  uk: {
    year: "рррр",
    month: "мм",
    day: "дд"
  },
  "zh-CN": {
    year: "年",
    month: "月",
    day: "日"
  },
  "zh-TW": {
    year: "年",
    month: "月",
    day: "日"
  }
}, "en");
function E8(e, t, n) {
  return e === "era" || e === "dayPeriod" ? t : e === "year" || e === "month" || e === "day" ? C8.getStringForLocale(e, n) : "––";
}
const Ol = {
  year: !0,
  month: !0,
  day: !0,
  hour: !0,
  minute: !0,
  second: !0,
  dayPeriod: !0,
  era: !0
}, wc = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
}, w8 = {
  dayperiod: "dayPeriod"
};
function gs(e) {
  let { locale: t, createCalendar: n, hideTimeZone: r, isDisabled: a = !1, isReadOnly: l = !1, isRequired: i = !1, minValue: o, maxValue: u, isDateUnavailable: s } = e, d = e.value || e.defaultValue || e.placeholderValue || null, [c, f] = vs(d, e.granularity), b = f || "UTC";
  if (d && !(c in d)) throw new Error("Invalid granularity " + c + " for value " + d.toString());
  let p = H(() => new Xt(t), [
    t
  ]), h = H(() => n(p.resolvedOptions().calendar), [
    n,
    p
  ]);
  var m;
  let [v, y] = Me(e.value, (m = e.defaultValue) !== null && m !== void 0 ? m : null, e.onChange), w = H(() => {
    var X;
    return (X = H$(v, h)) !== null && X !== void 0 ? X : null;
  }, [
    v,
    h
  ]), [C, D] = q(() => xa(e.placeholderValue, c, h, f)), P = w || C, R = h.identifier === "gregory" && P.era === "BC", V = H(() => {
    var X;
    return {
      granularity: c,
      maxGranularity: (X = e.maxGranularity) !== null && X !== void 0 ? X : "year",
      timeZone: f,
      hideTimeZone: r,
      hourCycle: e.hourCycle,
      showEra: R,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros
    };
  }, [
    e.maxGranularity,
    c,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    f,
    r,
    R
  ]), L = H(() => Tn({}, V), [
    V
  ]), A = H(() => new Xt(t, L), [
    t,
    L
  ]), $ = H(() => A.resolvedOptions(), [
    A
  ]), S = H(() => A.formatToParts(/* @__PURE__ */ new Date()).filter((X) => Ol[X.type]).reduce((X, pe) => (X[pe.type] = !0, X), {}), [
    A
  ]), [T, M] = q(() => e.value || e.defaultValue ? {
    ...S
  } : {}), K = j(null), g = j(h);
  re(() => {
    vi(h, g.current) || (g.current = h, D((X) => Object.keys(T).length > 0 ? Ue(X, h) : xa(e.placeholderValue, c, h, f)));
  }, [
    h,
    c,
    T,
    f,
    e.placeholderValue
  ]), v && Object.keys(T).length < Object.keys(S).length && (T = {
    ...S
  }, M(T)), v == null && Object.keys(T).length === Object.keys(S).length && (T = {}, M(T), D(xa(e.placeholderValue, c, h, f)));
  let B = w && Object.keys(T).length >= Object.keys(S).length ? w : C, k = (X) => {
    if (e.isDisabled || e.isReadOnly) return;
    let pe = Object.keys(T), ve = Object.keys(S);
    X == null ? (y(null), D(xa(e.placeholderValue, c, h, f)), M({})) : pe.length >= ve.length || pe.length === ve.length - 1 && S.dayPeriod && !T.dayPeriod && K.current !== "dayPeriod" ? (X = Ue(X, (d == null ? void 0 : d.calendar) || new wt()), y(X)) : D(X), K.current = null;
  }, I = H(() => B.toDate(b), [
    B,
    b
  ]), O = H(() => P8(I, T, A, $, B, h, t, c), [
    I,
    T,
    A,
    $,
    B,
    h,
    t,
    c
  ]);
  S.era && T.year && !T.era ? (T.era = !0, M({
    ...T
  })) : !S.era && T.era && (delete T.era, M({
    ...T
  }));
  let F = (X) => {
    T[X] = !0, X === "year" && S.era && (T.era = !0), M({
      ...T
    });
  }, z = (X, pe) => {
    if (T[X])
      k(k8(B, X, pe, $));
    else {
      F(X);
      let ve = Object.keys(T), W = Object.keys(S);
      (ve.length >= W.length || ve.length === W.length - 1 && S.dayPeriod && !T.dayPeriod) && k(B);
    }
  }, Z = H(() => ii(v, o, u, s, V), [
    v,
    o,
    u,
    s,
    V
  ]), te = en({
    ...e,
    value: v,
    builtinValidation: Z
  }), ue = te.displayValidation.isInvalid, be = e.validationState || (ue ? "invalid" : null);
  var ce;
  return {
    ...te,
    value: w,
    dateValue: I,
    calendar: h,
    setValue: k,
    segments: O,
    dateFormatter: A,
    validationState: be,
    isInvalid: ue,
    granularity: c,
    maxGranularity: (ce = e.maxGranularity) !== null && ce !== void 0 ? ce : "year",
    isDisabled: a,
    isReadOnly: l,
    isRequired: i,
    increment(X) {
      z(X, 1);
    },
    decrement(X) {
      z(X, -1);
    },
    incrementPage(X) {
      z(X, wc[X] || 1);
    },
    decrementPage(X) {
      z(X, -(wc[X] || 1));
    },
    setSegment(X, pe) {
      F(X), k(S8(B, X, pe, $));
    },
    confirmPlaceholder() {
      if (e.isDisabled || e.isReadOnly) return;
      let X = Object.keys(T), pe = Object.keys(S);
      X.length === pe.length - 1 && S.dayPeriod && !T.dayPeriod && (T = {
        ...S
      }, M(T), k(B.copy()));
    },
    clearSegment(X) {
      delete T[X], K.current = X, M({
        ...T
      });
      let pe = xa(e.placeholderValue, c, h, f), ve = B;
      if (X === "dayPeriod" && "hour" in B && "hour" in pe) {
        let W = B.hour >= 12, se = pe.hour >= 12;
        W && !se ? ve = B.set({
          hour: B.hour - 12
        }) : !W && se && (ve = B.set({
          hour: B.hour + 12
        }));
      } else X === "hour" && "hour" in B && B.hour >= 12 && T.dayPeriod ? ve = B.set({
        hour: pe.hour + 12
      }) : X in B && (ve = B.set({
        [X]: pe[X]
      }));
      y(null), k(ve);
    },
    formatValue(X) {
      if (!w) return "";
      let pe = Tn(X, V);
      return new Xt(t, pe).format(I);
    },
    getDateFormatter(X, pe) {
      let ve = {
        ...V,
        ...pe
      }, W = Tn({}, ve);
      return new Xt(X, W);
    }
  };
}
function P8(e, t, n, r, a, l, i, o) {
  let u = [
    "hour",
    "minute",
    "second"
  ], s = n.formatToParts(e), d = [];
  for (let c of s) {
    let f = Ol[c.type];
    c.type === "era" && l.getEras().length === 1 && (f = !1);
    let b = Ol[c.type] && !t[c.type], p = Ol[c.type] ? E8(c.type, c.value, i) : null, h = {
      type: w8[c.type] || c.type,
      text: b ? p : c.value,
      ...Fl(a, c.type, r),
      isPlaceholder: b,
      placeholder: p,
      isEditable: f
    };
    c.type === "hour" ? (d.push({
      type: "literal",
      text: "⁦",
      ...Fl(a, "literal", r),
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    }), d.push(h), c.type === o && d.push({
      type: "literal",
      text: "⁩",
      ...Fl(a, "literal", r),
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    })) : u.includes(c.type) && c.type === o ? (d.push(h), d.push({
      type: "literal",
      text: "⁩",
      ...Fl(a, "literal", r),
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    })) : d.push(h);
  }
  return d;
}
function Fl(e, t, n) {
  switch (t) {
    case "era": {
      let r = e.calendar.getEras();
      return {
        value: r.indexOf(e.era),
        minValue: 0,
        maxValue: r.length - 1
      };
    }
    case "year":
      return {
        value: e.year,
        minValue: 1,
        maxValue: e.calendar.getYearsInEra(e)
      };
    case "month":
      return {
        value: e.month,
        minValue: Z6(e),
        maxValue: e.calendar.getMonthsInYear(e)
      };
    case "day":
      return {
        value: e.day,
        minValue: Y6(e),
        maxValue: e.calendar.getDaysInMonth(e)
      };
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod":
      return {
        value: e.hour >= 12 ? 12 : 0,
        minValue: 0,
        maxValue: 12
      };
    case "hour":
      if (n.hour12) {
        let r = e.hour >= 12;
        return {
          value: e.hour,
          minValue: r ? 12 : 0,
          maxValue: r ? 23 : 11
        };
      }
      return {
        value: e.hour,
        minValue: 0,
        maxValue: 23
      };
    case "minute":
      return {
        value: e.minute,
        minValue: 0,
        maxValue: 59
      };
    case "second":
      return {
        value: e.second,
        minValue: 0,
        maxValue: 59
      };
  }
  return {};
}
function k8(e, t, n, r) {
  switch (t) {
    case "era":
    case "year":
    case "month":
    case "day":
      return e.cycle(t, n, {
        round: t === "year"
      });
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod": {
      let a = e.hour, l = a >= 12;
      return e.set({
        hour: l ? a - 12 : a + 12
      });
    }
    case "hour":
    case "minute":
    case "second":
      return e.cycle(t, n, {
        round: t !== "hour",
        hourCycle: r.hour12 ? 12 : 24
      });
  }
  throw new Error("Unknown segment: " + t);
}
function S8(e, t, n, r) {
  switch (t) {
    case "day":
    case "month":
    case "year":
    case "era":
      return e.set({
        [t]: n
      });
  }
  if ("hour" in e && typeof n == "number") switch (t) {
    case "dayPeriod": {
      let a = e.hour, l = a >= 12;
      return n >= 12 === l ? e : e.set({
        hour: l ? a - 12 : a + 12
      });
    }
    case "hour":
      if (r.hour12) {
        let l = e.hour >= 12;
        !l && n === 12 && (n = 0), l && n < 12 && (n += 12);
      }
    // fallthrough
    case "minute":
    case "second":
      return e.set({
        [t]: n
      });
  }
  throw new Error("Unknown segment: " + t);
}
function B8(e) {
  var t, n;
  let r = jn(e), [a, l] = Me(e.value, e.defaultValue || null, e.onChange), [i, o] = q(() => a || {
    start: null,
    end: null
  });
  a == null && i.start && i.end && (i = {
    start: null,
    end: null
  }, o(i));
  let u = a || i, s = (g) => {
    o(g || {
      start: null,
      end: null
    }), mr(g) ? l(g) : l(null);
  }, d = (u == null ? void 0 : u.start) || (u == null ? void 0 : u.end) || e.placeholderValue || null, [c, f] = vs(d, e.granularity), b = c === "hour" || c === "minute" || c === "second";
  var p;
  let h = (p = e.shouldCloseOnSelect) !== null && p !== void 0 ? p : !0, [m, v] = q(null), [y, w] = q(null);
  u && mr(u) && (m = u, "hour" in u.start && (y = u));
  let C = (g, B) => {
    s({
      start: "timeZone" in B.start ? B.start.set(Ct(g.start)) : an(g.start, B.start),
      end: "timeZone" in B.end ? B.end.set(Ct(g.end)) : an(g.end, B.end)
    }), v(null), w(null), T.commitValidation();
  }, D = (g) => {
    let B = typeof h == "function" ? h() : h;
    b ? mr(g) && (y != null && y.start) && (y != null && y.end) ? C(g, {
      start: (y == null ? void 0 : y.start) || Ur(e.placeholderValue),
      end: (y == null ? void 0 : y.end) || Ur(e.placeholderValue)
    }) : v(g) : mr(g) ? (s(g), T.commitValidation()) : v(g), B && r.setOpen(!1);
  }, P = (g) => {
    mr(m) && mr(g) ? C(m, g) : w(g);
  }, R = (u == null || (t = u.start) === null || t === void 0 ? void 0 : t.calendar.identifier) === "gregory" && u.start.era === "BC" || (u == null || (n = u.end) === null || n === void 0 ? void 0 : n.calendar.identifier) === "gregory" && u.end.era === "BC", V = H(() => ({
    granularity: c,
    timeZone: f,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: R
  }), [
    c,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    f,
    e.hideTimeZone,
    R
  ]), { minValue: L, maxValue: A, isDateUnavailable: $ } = e, S = H(() => y8(u, L, A, $, V), [
    u,
    L,
    A,
    $,
    V
  ]), T = en({
    ...e,
    value: a,
    name: H(() => [
      e.startName,
      e.endName
    ].filter((g) => g != null), [
      e.startName,
      e.endName
    ]),
    builtinValidation: S
  }), M = T.displayValidation.isInvalid, K = e.validationState || (M ? "invalid" : null);
  return {
    ...T,
    value: u,
    setValue: s,
    dateRange: m,
    timeRange: y,
    granularity: c,
    hasTime: b,
    setDate(g, B) {
      var k, I;
      D(g === "start" ? {
        start: B,
        end: (k = m == null ? void 0 : m.end) !== null && k !== void 0 ? k : null
      } : {
        start: (I = m == null ? void 0 : m.start) !== null && I !== void 0 ? I : null,
        end: B
      });
    },
    setTime(g, B) {
      var k, I;
      P(g === "start" ? {
        start: B,
        end: (k = y == null ? void 0 : y.end) !== null && k !== void 0 ? k : null
      } : {
        start: (I = y == null ? void 0 : y.start) !== null && I !== void 0 ? I : null,
        end: B
      });
    },
    setDateTime(g, B) {
      var k, I;
      s(g === "start" ? {
        start: B,
        end: (k = u == null ? void 0 : u.end) !== null && k !== void 0 ? k : null
      } : {
        start: (I = u == null ? void 0 : u.start) !== null && I !== void 0 ? I : null,
        end: B
      });
    },
    setDateRange: D,
    setTimeRange: P,
    ...r,
    setOpen(g) {
      !g && !(u != null && u.start && (u != null && u.end)) && mr(m) && b && C(m, {
        start: (y == null ? void 0 : y.start) || Ur(e.placeholderValue),
        end: (y == null ? void 0 : y.end) || Ur(e.placeholderValue)
      }), r.setOpen(g);
    },
    validationState: K,
    isInvalid: M,
    formatValue(g, B) {
      if (!u || !u.start || !u.end) return null;
      let k = "timeZone" in u.start ? u.start.timeZone : void 0, I = e.granularity || (u.start && "minute" in u.start ? "minute" : "day"), O = "timeZone" in u.end ? u.end.timeZone : void 0, F = e.granularity || (u.end && "minute" in u.end ? "minute" : "day"), z = Tn(B, {
        granularity: I,
        timeZone: k,
        hideTimeZone: e.hideTimeZone,
        hourCycle: e.hourCycle,
        showEra: u.start.calendar.identifier === "gregory" && u.start.era === "BC" || u.end.calendar.identifier === "gregory" && u.end.era === "BC"
      }), Z = u.start.toDate(k || "UTC"), te = u.end.toDate(O || "UTC"), ue = new Xt(g, z), be;
      if (k === O && I === F && u.start.compare(u.end) !== 0) {
        try {
          let ce = ue.formatRangeToParts(Z, te), X = -1;
          for (let W = 0; W < ce.length; W++) {
            let se = ce[W];
            if (se.source === "shared" && se.type === "literal") X = W;
            else if (se.source === "endRange") break;
          }
          let pe = "", ve = "";
          for (let W = 0; W < ce.length; W++)
            W < X ? pe += ce[W].value : W > X && (ve += ce[W].value);
          return {
            start: pe,
            end: ve
          };
        } catch {
        }
        be = ue;
      } else {
        let ce = Tn(B, {
          granularity: F,
          timeZone: O,
          hideTimeZone: e.hideTimeZone,
          hourCycle: e.hourCycle
        });
        be = new Xt(g, ce);
      }
      return {
        start: ue.format(Z),
        end: be.format(te)
      };
    },
    getDateFormatter(g, B) {
      let k = {
        ...V,
        ...B
      }, I = Tn({}, k);
      return new Xt(g, I);
    }
  };
}
function mr(e) {
  return (e == null ? void 0 : e.start) != null && e.end != null;
}
function F8(e) {
  let { placeholderValue: t = new nl(), minValue: n, maxValue: r, granularity: a, validate: l } = e;
  var i;
  let [o, u] = Me(e.value, (i = e.defaultValue) !== null && i !== void 0 ? i : null, e.onChange), s = o || t, d = s && "day" in s ? s : void 0, c = e.defaultValue && "timeZone" in e.defaultValue ? e.defaultValue.timeZone : void 0, f = H(() => {
    let w = s && "timeZone" in s ? s.timeZone : void 0;
    return (w || c) && t ? a4(Da(t), w || c) : Da(t);
  }, [
    t,
    s,
    c
  ]), b = H(() => Da(n, d), [
    n,
    d
  ]), p = H(() => Da(r, d), [
    r,
    d
  ]), h = H(() => o && "day" in o ? $d(o) : o, [
    o
  ]), m = H(() => o == null ? null : Da(o), [
    o
  ]);
  return {
    ...gs({
      ...e,
      value: m,
      defaultValue: void 0,
      minValue: b,
      maxValue: p,
      onChange: (w) => {
        u(d || c ? w : w && $d(w));
      },
      granularity: a || "minute",
      maxGranularity: "hour",
      placeholderValue: f ?? void 0,
      // Calendar should not matter for time fields.
      createCalendar: () => new wt(),
      validate: ie(() => l == null ? void 0 : l(o), [
        l,
        o
      ])
    }),
    timeValue: h
  };
}
function Da(e, t = gi(yi())) {
  return e ? "day" in e ? e : an(t, e) : null;
}
function A8(e) {
  let [t, n] = Me(e.isExpanded, e.defaultExpanded || !1, e.onExpandedChange);
  const r = ie(() => {
    n(!0);
  }, [
    n
  ]), a = ie(() => {
    n(!1);
  }, [
    n
  ]), l = ie(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isExpanded: t,
    setExpanded: n,
    expand: r,
    collapse: a,
    toggle: l
  };
}
function T8(e) {
  let { allowsMultipleExpanded: t = !1, isDisabled: n = !1 } = e, [r, a] = Me(H(() => e.expandedKeys ? new Set(e.expandedKeys) : void 0, [
    e.expandedKeys
  ]), H(() => e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), [
    e.defaultExpandedKeys
  ]), e.onExpandedChange);
  return re(() => {
    !t && r.size > 1 && a(/* @__PURE__ */ new Set([
      r.values().next().value
    ]));
  }), {
    allowsMultipleExpanded: t,
    isDisabled: n,
    expandedKeys: r,
    setExpandedKeys: a,
    toggleKey(l) {
      let i;
      t ? (i = new Set(r), i.has(l) ? i.delete(l) : i.add(l)) : i = new Set(r.has(l) ? [] : [
        l
      ]), a(i);
    }
  };
}
function _$(e) {
  let t = jn(e), [n, r] = q(null), [a, l] = q([]), i = () => {
    l([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(s = null) {
      r(s), t.open();
    },
    toggle(s = null) {
      r(s), t.toggle();
    },
    close() {
      i();
    },
    expandedKeysStack: a,
    openSubmenu: (s, d) => {
      l((c) => d > c.length ? c : [
        ...c.slice(0, d),
        s
      ]);
    },
    closeSubmenu: (s, d) => {
      l((c) => c[d] === s ? c.slice(0, d) : c);
    }
  };
}
let R8 = Math.round(Math.random() * 1e10), M8 = 0;
function N8(e) {
  let t = H(() => e.name || `radio-group-${R8}-${++M8}`, [
    e.name
  ]);
  var n;
  let [r, a] = Me(e.value, (n = e.defaultValue) !== null && n !== void 0 ? n : null, e.onChange), [l, i] = q(null), o = en({
    ...e,
    value: r
  }), u = (d) => {
    !e.isReadOnly && !e.isDisabled && (a(d), o.commitValidation());
  }, s = o.displayValidation.isInvalid;
  return {
    ...o,
    name: t,
    selectedValue: r,
    setSelectedValue: u,
    lastFocusedValue: l,
    setLastFocusedValue: i,
    isDisabled: e.isDisabled || !1,
    isReadOnly: e.isReadOnly || !1,
    isRequired: e.isRequired || !1,
    validationState: e.validationState || (s ? "invalid" : null),
    isInvalid: s
  };
}
function V8(e) {
  let [t, n] = Me(Pc(e.value), Pc(e.defaultValue) || "", e.onChange);
  return {
    value: t,
    setValue: n
  };
}
function Pc(e) {
  if (e != null)
    return e.toString();
}
function I8(e) {
  let t = jn(e), [n, r] = q(null), a = ms({
    ...e,
    onSelectionChange: (u) => {
      e.onSelectionChange != null && e.onSelectionChange(u), t.close(), l.commitValidation();
    }
  }), l = en({
    ...e,
    value: a.selectedKey
  }), [i, o] = q(!1);
  return {
    ...l,
    ...a,
    ...t,
    focusStrategy: n,
    open(u = null) {
      a.collection.size !== 0 && (r(u), t.open());
    },
    toggle(u = null) {
      a.collection.size !== 0 && (r(u), t.toggle());
    },
    isFocused: i,
    setFocused: o
  };
}
function O8(e) {
  return e != null && (!isNaN(e) || String(e).match(/^(\d+)(?=%$)/) !== null);
}
function z8(e) {
  if (!e || typeof e == "number") return 1;
  let t = e.match(/^(.+)(?=fr$)/);
  return t ? parseFloat(t[0]) : (process.env.NODE_ENV !== "production" && console.warn(`width: ${e} is not a supported format, width should be a number (ex. 150), percentage (ex. '50%') or fr unit (ex. '2fr')`, "defaulting to '1fr'"), 1);
}
function ys(e, t) {
  if (typeof e == "string") {
    let n = e.match(/^(\d+)(?=%$)/);
    if (!n) throw new Error("Only percentages or numbers are supported for static column widths");
    return t * (parseFloat(n[0]) / 100);
  }
  return e;
}
function U$(e, t) {
  return e != null ? ys(e, t) : Number.MAX_SAFE_INTEGER;
}
function W$(e, t) {
  return e != null ? ys(e, t) : 0;
}
function K8(e, t, n, r, a) {
  let l = !1, i = t.map((o, u) => {
    var s, d, c, f;
    let b = n.get(o.key) != null ? (s = n.get(o.key)) !== null && s !== void 0 ? s : "1fr" : (f = (c = (d = o.width) !== null && d !== void 0 ? d : o.defaultWidth) !== null && c !== void 0 ? c : r == null ? void 0 : r(u)) !== null && f !== void 0 ? f : "1fr", p = !1, h = 0, m = 0, v = 0;
    O8(b) ? (h = ys(b, e), p = !0) : (m = z8(b), m <= 0 && (p = !0));
    var y, w;
    let C = W$((w = (y = o.minWidth) !== null && y !== void 0 ? y : a == null ? void 0 : a(u)) !== null && w !== void 0 ? w : 0, e), D = U$(o.maxWidth, e), P = Math.max(C, Math.min(h, D));
    return p ? v = P : h > P && (p = !0, v = P), p || (l = !0), {
      frozen: p,
      baseSize: h,
      hypotheticalMainSize: P,
      min: C,
      max: D,
      flex: m,
      targetMainSize: v,
      violation: 0
    };
  });
  for (; l; ) {
    let o = 0, u = 0;
    i.forEach((c) => {
      c.frozen ? o += c.targetMainSize : (o += c.baseSize, u += c.flex);
    });
    let s = e - o;
    s > 0 && i.forEach((c) => {
      if (!c.frozen) {
        let f = c.flex / u;
        c.targetMainSize = c.baseSize + f * s;
      }
    });
    let d = 0;
    i.forEach((c) => {
      if (c.violation = 0, !c.frozen) {
        let { min: f, max: b, targetMainSize: p } = c;
        c.targetMainSize = Math.max(f, Math.min(p, b)), c.violation = c.targetMainSize - p, d += c.violation;
      }
    }), l = !1, i.forEach((c) => {
      d === 0 || Math.sign(d) === Math.sign(c.violation) ? c.frozen = !0 : c.frozen || (l = !0);
    });
  }
  return j8(i);
}
function j8(e) {
  let t = 0, n = 0, r = [];
  return e.forEach(function(a) {
    let l = a.targetMainSize, i = Math.round(l + t) - n;
    t += l, n += i, r.push(i);
  }), r;
}
class L8 {
  /** Takes an array of columns and splits it into 2 maps of columns with controlled and columns with uncontrolled widths. */
  splitColumnsIntoControlledAndUncontrolled(t) {
    return t.reduce((n, r) => (r.props.width != null ? n[0].set(r.key, r) : n[1].set(r.key, r), n), [
      /* @__PURE__ */ new Map(),
      /* @__PURE__ */ new Map()
    ]);
  }
  /** Takes uncontrolled and controlled widths and joins them into a single Map. */
  recombineColumns(t, n, r, a) {
    return new Map(t.map((l) => r.has(l.key) ? [
      l.key,
      n.get(l.key)
    ] : [
      l.key,
      a.get(l.key).props.width
    ]));
  }
  /** Used to make an initial Map of the uncontrolled widths based on default widths. */
  getInitialUncontrolledWidths(t) {
    return new Map(Array.from(t).map(([n, r]) => {
      var a, l, i, o;
      return [
        n,
        (o = (i = r.props.defaultWidth) !== null && i !== void 0 ? i : (a = (l = this).getDefaultWidth) === null || a === void 0 ? void 0 : a.call(l, r)) !== null && o !== void 0 ? o : "1fr"
      ];
    }));
  }
  getColumnWidth(t) {
    var n;
    return (n = this.columnWidths.get(t)) !== null && n !== void 0 ? n : 0;
  }
  getColumnMinWidth(t) {
    var n;
    return (n = this.columnMinWidths.get(t)) !== null && n !== void 0 ? n : 0;
  }
  getColumnMaxWidth(t) {
    var n;
    return (n = this.columnMaxWidths.get(t)) !== null && n !== void 0 ? n : 0;
  }
  resizeColumnWidth(t, n, r, a) {
    let l = this.columnWidths, i = !0, o = /* @__PURE__ */ new Map();
    return a = Math.max(this.getColumnMinWidth(r), Math.min(this.getColumnMaxWidth(r), Math.floor(a))), t.columns.forEach((u) => {
      var s, d;
      u.key === r ? (o.set(u.key, a), i = !1) : i ? o.set(u.key, (s = l.get(u.key)) !== null && s !== void 0 ? s : 0) : o.set(u.key, (d = u.props.width) !== null && d !== void 0 ? d : n.get(u.key));
    }), o;
  }
  buildColumnWidths(t, n, r) {
    return this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), K8(t, n.columns.map((l) => ({
      ...l.props,
      key: l.key
    })), r, (l) => this.getDefaultWidth(n.columns[l]), (l) => this.getDefaultMinWidth(n.columns[l])).forEach((l, i) => {
      let o = n.columns[i].key, u = n.columns[i];
      this.columnWidths.set(o, l);
      var s;
      this.columnMinWidths.set(o, W$((s = u.props.minWidth) !== null && s !== void 0 ? s : this.getDefaultMinWidth(u), t)), this.columnMaxWidths.set(o, U$(u.props.maxWidth, t));
    }), this.columnWidths;
  }
  constructor(t) {
    this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map();
    var n;
    this.getDefaultWidth = (n = t == null ? void 0 : t.getDefaultWidth) !== null && n !== void 0 ? n : () => "1fr";
    var r;
    this.getDefaultMinWidth = (r = t == null ? void 0 : t.getDefaultMinWidth) !== null && r !== void 0 ? r : () => 75;
  }
}
function H8(e, t) {
  let { getDefaultWidth: n, getDefaultMinWidth: r, tableWidth: a = 0 } = e, [l, i] = q(null), o = H(() => new L8({
    getDefaultWidth: n,
    getDefaultMinWidth: r
  }), [
    n,
    r
  ]), [u, s] = H(() => o.splitColumnsIntoControlledAndUncontrolled(t.collection.columns), [
    t.collection.columns,
    o
  ]), [d, c] = q(() => o.getInitialUncontrolledWidths(s)), [f, b] = q(t.collection.columns);
  if (t.collection.columns !== f) {
    if (t.collection.columns.length !== f.length || t.collection.columns.some((w, C) => w.key !== f[C].key)) {
      let w = o.getInitialUncontrolledWidths(s);
      c(w);
    }
    b(t.collection.columns);
  }
  let p = H(() => o.recombineColumns(t.collection.columns, d, s, u), [
    t.collection.columns,
    d,
    s,
    u,
    o
  ]), h = ie((w) => {
    i(w);
  }, [
    i
  ]), m = ie((w, C) => {
    let D = o.resizeColumnWidth(t.collection, d, w, C), P = new Map(Array.from(s).map(([R]) => [
      R,
      D.get(R)
    ]));
    return P.set(w, C), c(P), D;
  }, [
    s,
    c,
    o,
    t.collection,
    d
  ]), v = ie(() => {
    i(null);
  }, [
    i
  ]), y = H(() => o.buildColumnWidths(a, t.collection, p), [
    a,
    t.collection,
    p,
    o
  ]);
  return H(() => ({
    resizingColumn: l,
    updateResizedColumns: m,
    startResize: h,
    endResize: v,
    getColumnWidth: (w) => o.getColumnWidth(w),
    getColumnMinWidth: (w) => o.getColumnMinWidth(w),
    getColumnMaxWidth: (w) => o.getColumnMaxWidth(w),
    tableState: t,
    columnWidths: y
  }), [
    o,
    y,
    l,
    m,
    h,
    v,
    t
  ]);
}
function _8(e) {
  let { collection: t, focusMode: n } = e, r = e.UNSAFE_selectionState || dl(e), a = H(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), l = r.setFocusedKey;
  r.setFocusedKey = (u, s) => {
    if (n === "cell" && u != null) {
      let p = t.getItem(u);
      if ((p == null ? void 0 : p.type) === "item") {
        var d, c;
        let h = at(p, t);
        var f, b;
        s === "last" ? u = (f = (d = Fn(h)) === null || d === void 0 ? void 0 : d.key) !== null && f !== void 0 ? f : null : u = (b = (c = kn(h)) === null || c === void 0 ? void 0 : c.key) !== null && b !== void 0 ? b : null;
      }
    }
    l(u, s);
  };
  let i = H(() => new sa(t, r), [
    t,
    r
  ]);
  const o = j(null);
  return re(() => {
    if (r.focusedKey != null && o.current && !t.getItem(r.focusedKey)) {
      const u = o.current.getItem(r.focusedKey), s = (u == null ? void 0 : u.parentKey) != null && (u.type === "cell" || u.type === "rowheader" || u.type === "column") ? o.current.getItem(u.parentKey) : u;
      if (!s) {
        r.setFocusedKey(null);
        return;
      }
      const d = o.current.rows, c = t.rows, f = d.length - c.length;
      let b = Math.min(f > 1 ? Math.max(s.index - f + 1, 0) : s.index, c.length - 1), p = null;
      for (; b >= 0; ) {
        if (!i.isDisabled(c[b].key) && c[b].type !== "headerrow") {
          p = c[b];
          break;
        }
        b < c.length - 1 ? b++ : (b > s.index && (b = s.index), b--);
      }
      if (p) {
        const h = p.hasChildNodes ? [
          ...at(p, t)
        ] : [], m = p.hasChildNodes && s !== u && u && u.index < h.length ? h[u.index].key : p.key;
        r.setFocusedKey(m);
      } else r.setFocusedKey(null);
    }
    o.current = t;
  }, [
    t,
    i,
    r,
    r.focusedKey
  ]), {
    collection: t,
    disabledKeys: a,
    isKeyboardNavigationDisabled: !1,
    selectionManager: i
  };
}
class U8 {
  *[Symbol.iterator]() {
    yield* [
      ...this.rows
    ];
  }
  get size() {
    return [
      ...this.rows
    ].length;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    var t;
    return (t = [
      ...this.rows
    ][0]) === null || t === void 0 ? void 0 : t.key;
  }
  getLastKey() {
    var t;
    let n = [
      ...this.rows
    ];
    return (t = n[n.length - 1]) === null || t === void 0 ? void 0 : t.key;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    let n = this.keyMap.get(t);
    return (n == null ? void 0 : n.childNodes) || [];
  }
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.keyMap = /* @__PURE__ */ new Map(), this.columnCount = t == null ? void 0 : t.columnCount, this.rows = [];
    let n = (c) => {
      let f = this.keyMap.get(c.key);
      t.visitNode && (c = t.visitNode(c)), this.keyMap.set(c.key, c);
      let b = /* @__PURE__ */ new Set(), p = null, h = !1;
      if (c.type === "item") {
        var m;
        for (let D of c.childNodes) if (((m = D.props) === null || m === void 0 ? void 0 : m.colSpan) !== void 0) {
          h = !0;
          break;
        }
      }
      for (let D of c.childNodes) {
        if (D.type === "cell" && h) {
          var v, y;
          D.colspan = (v = D.props) === null || v === void 0 ? void 0 : v.colSpan, D.colSpan = (y = D.props) === null || y === void 0 ? void 0 : y.colSpan;
          var w, C;
          D.colIndex = p ? ((w = p.colIndex) !== null && w !== void 0 ? w : p.index) + ((C = p.colSpan) !== null && C !== void 0 ? C : 1) : D.index;
        }
        D.type === "cell" && D.parentKey == null && (D.parentKey = c.key), b.add(D.key), p ? (p.nextKey = D.key, D.prevKey = p.key) : D.prevKey = null, n(D), p = D;
      }
      if (p && (p.nextKey = null), f)
        for (let D of f.childNodes) b.has(D.key) || r(D);
    }, r = (c) => {
      this.keyMap.delete(c.key);
      for (let f of c.childNodes) this.keyMap.get(f.key) === f && r(f);
    }, a = null;
    for (let [c, f] of t.items.entries()) {
      var l, i, o, u, s, d;
      let b = {
        ...f,
        level: (l = f.level) !== null && l !== void 0 ? l : 0,
        key: (i = f.key) !== null && i !== void 0 ? i : "row-" + c,
        type: (o = f.type) !== null && o !== void 0 ? o : "row",
        value: (u = f.value) !== null && u !== void 0 ? u : null,
        hasChildNodes: !0,
        childNodes: [
          ...f.childNodes
        ],
        rendered: f.rendered,
        textValue: (s = f.textValue) !== null && s !== void 0 ? s : "",
        index: (d = f.index) !== null && d !== void 0 ? d : c
      };
      a ? (a.nextKey = b.key, b.prevKey = a.key) : b.prevKey = null, this.rows.push(b), n(b), a = b;
    }
    a && (a.nextKey = null);
  }
}
const G$ = "row-header-column-" + Math.random().toString(36).slice(2);
let mu = "row-header-column-" + Math.random().toString(36).slice(2);
for (; G$ === mu; ) mu = "row-header-column-" + Math.random().toString(36).slice(2);
function Z$(e, t) {
  if (t.length === 0) return [];
  let n = [], r = /* @__PURE__ */ new Map();
  for (let d of t) {
    let c = d.parentKey, f = [
      d
    ];
    for (; c; ) {
      let b = e.get(c);
      if (!b) break;
      if (r.has(b)) {
        var a, l;
        (l = (a = b).colSpan) !== null && l !== void 0 || (a.colSpan = 0), b.colSpan++, b.colspan = b.colSpan;
        let { column: p, index: h } = r.get(b);
        if (h > f.length) break;
        for (let m = h; m < f.length; m++) p.splice(m, 0, null);
        for (let m = f.length; m < p.length; m++)
          p[m] && r.has(p[m]) && (r.get(p[m]).index = m);
      } else
        b.colSpan = 1, b.colspan = 1, f.push(b), r.set(b, {
          column: f,
          index: f.length - 1
        });
      c = b.parentKey;
    }
    n.push(f), d.index = n.length - 1;
  }
  let i = Math.max(...n.map((d) => d.length)), o = Array(i).fill(0).map(() => []), u = 0;
  for (let d of n) {
    let c = i - 1;
    for (let f of d) {
      if (f) {
        let b = o[c], p = b.reduce((h, m) => {
          var v;
          return h + ((v = m.colSpan) !== null && v !== void 0 ? v : 1);
        }, 0);
        if (p < u) {
          let h = {
            type: "placeholder",
            key: "placeholder-" + f.key,
            colspan: u - p,
            colSpan: u - p,
            index: p,
            value: null,
            rendered: null,
            level: c,
            hasChildNodes: !1,
            childNodes: [],
            textValue: ""
          };
          b.length > 0 && (b[b.length - 1].nextKey = h.key, h.prevKey = b[b.length - 1].key), b.push(h);
        }
        b.length > 0 && (b[b.length - 1].nextKey = f.key, f.prevKey = b[b.length - 1].key), f.level = c, f.colIndex = u, b.push(f);
      }
      c--;
    }
    u++;
  }
  let s = 0;
  for (let d of o) {
    let c = d.reduce((f, b) => {
      var p;
      return f + ((p = b.colSpan) !== null && p !== void 0 ? p : 1);
    }, 0);
    if (c < t.length) {
      let f = {
        type: "placeholder",
        key: "placeholder-" + d[d.length - 1].key,
        colSpan: t.length - c,
        colspan: t.length - c,
        index: c,
        value: null,
        rendered: null,
        level: s,
        hasChildNodes: !1,
        childNodes: [],
        textValue: "",
        prevKey: d[d.length - 1].key
      };
      d.push(f);
    }
    s++;
  }
  return o.map((d, c) => ({
    type: "headerrow",
    key: "headerrow-" + c,
    index: c,
    value: null,
    rendered: null,
    level: 0,
    hasChildNodes: !0,
    childNodes: d,
    textValue: ""
  }));
}
class W8 extends U8 {
  *[Symbol.iterator]() {
    yield* this.body.childNodes;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return (r = n == null ? void 0 : n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return (r = n == null ? void 0 : n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    var t, n;
    return (n = (t = kn(this.body.childNodes)) === null || t === void 0 ? void 0 : t.key) !== null && n !== void 0 ? n : null;
  }
  getLastKey() {
    var t, n;
    return (n = (t = Fn(this.body.childNodes)) === null || t === void 0 ? void 0 : t.key) !== null && n !== void 0 ? n : null;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return t === this.body.key ? this.body.childNodes : super.getChildren(t);
  }
  getTextValue(t) {
    let n = this.getItem(t);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys;
    if (r) {
      let a = [];
      for (let l of n.childNodes) {
        let i = this.columns[l.index];
        if (r.has(i.key) && l.textValue && a.push(l.textValue), a.length === r.size) break;
      }
      return a.join(" ");
    }
    return "";
  }
  constructor(t, n, r) {
    let a = /* @__PURE__ */ new Set(), l = null, i = [];
    if (r != null && r.showSelectionCheckboxes) {
      let c = {
        type: "column",
        key: G$,
        value: null,
        textValue: "",
        level: 0,
        index: r != null && r.showDragButtons ? 1 : 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isSelectionCell: !0
        }
      };
      i.unshift(c);
    }
    if (r != null && r.showDragButtons) {
      let c = {
        type: "column",
        key: mu,
        value: null,
        textValue: "",
        level: 0,
        index: 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isDragButtonCell: !0
        }
      };
      i.unshift(c);
    }
    let o = [], u = /* @__PURE__ */ new Map(), s = (c) => {
      switch (c.type) {
        case "body":
          l = c;
          break;
        case "column":
          u.set(c.key, c), c.hasChildNodes || (i.push(c), c.props.isRowHeader && a.add(c.key));
          break;
        case "item":
          o.push(c);
          return;
      }
      for (let f of c.childNodes) s(f);
    };
    for (let c of t) s(c);
    let d = Z$(u, i);
    if (d.forEach((c, f) => o.splice(f, 0, c)), super({
      columnCount: i.length,
      items: o,
      visitNode: (c) => (c.column = i[c.index], c)
    }), this._size = 0, this.columns = i, this.rowHeaderColumnKeys = a, this.body = l, this.headerRows = d, this._size = [
      ...l.childNodes
    ].length, this.rowHeaderColumnKeys.size === 0) {
      let c = this.columns.find((f) => {
        var b, p;
        return !(!((b = f.props) === null || b === void 0) && b.isDragButtonCell) && !(!((p = f.props) === null || p === void 0) && p.isSelectionCell);
      });
      c && this.rowHeaderColumnKeys.add(c.key);
    }
  }
}
const G8 = {
  ascending: "descending",
  descending: "ascending"
};
function Z8(e) {
  let [t, n] = q(!1), { selectionMode: r = "none", showSelectionCheckboxes: a, showDragButtons: l } = e, i = H(() => ({
    showSelectionCheckboxes: a && r !== "none",
    showDragButtons: l,
    selectionMode: r,
    columns: []
  }), [
    e.children,
    a,
    r,
    l
  ]), o = us(e, ie((c) => new W8(c, null, i), [
    i
  ]), i), { disabledKeys: u, selectionManager: s } = _8({
    ...e,
    collection: o,
    disabledBehavior: e.disabledBehavior || "selection"
  });
  var d;
  return {
    collection: o,
    disabledKeys: u,
    selectionManager: s,
    showSelectionCheckboxes: e.showSelectionCheckboxes || !1,
    sortDescriptor: (d = e.sortDescriptor) !== null && d !== void 0 ? d : null,
    isKeyboardNavigationDisabled: o.size === 0 || t,
    setKeyboardNavigationDisabled: n,
    sort(c, f) {
      var b, p;
      (p = e.onSortChange) === null || p === void 0 || p.call(e, {
        column: c,
        direction: f ?? (((b = e.sortDescriptor) === null || b === void 0 ? void 0 : b.column) === c ? G8[e.sortDescriptor.direction] : "ascending")
      });
    }
  };
}
function Y8(e) {
  var t, n;
  let r = ms({
    ...e,
    suppressTextValueWarning: !0,
    defaultSelectedKey: (n = (t = e.defaultSelectedKey) !== null && t !== void 0 ? t : kc(e.collection, e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set())) !== null && n !== void 0 ? n : void 0
  }), { selectionManager: a, collection: l, selectedKey: i } = r, o = j(i);
  return re(() => {
    let u = i;
    e.selectedKey == null && (a.isEmpty || u == null || !l.getItem(u)) && (u = kc(l, r.disabledKeys), u != null && a.setSelectedKeys([
      u
    ])), (u != null && a.focusedKey == null || !a.isFocused && u !== o.current) && a.setFocusedKey(u), o.current = u;
  }), {
    ...r,
    isDisabled: e.isDisabled || !1
  };
}
function kc(e, t) {
  let n = null;
  if (e) {
    var r, a, l, i;
    for (n = e.getFirstKey(); n != null && (t.has(n) || !((a = e.getItem(n)) === null || a === void 0 || (r = a.props) === null || r === void 0) && r.isDisabled) && n !== e.getLastKey(); ) n = e.getKeyAfter(n);
    n != null && (t.has(n) || !((i = e.getItem(n)) === null || i === void 0 || (l = i.props) === null || l === void 0) && l.isDisabled) && n === e.getLastKey() && (n = e.getFirstKey());
  }
  return n;
}
const q8 = 1500, Sc = 500;
let vr = {}, X8 = 0, Ca = !1, Dn = null, gr = null;
function Y$(e = {}) {
  let { delay: t = q8, closeDelay: n = Sc } = e, { isOpen: r, open: a, close: l } = jn(e), i = H(() => `${++X8}`, []), o = j(null), u = j(l), s = () => {
    vr[i] = f;
  }, d = () => {
    for (let p in vr) p !== i && (vr[p](!0), delete vr[p]);
  }, c = () => {
    o.current && clearTimeout(o.current), o.current = null, d(), s(), Ca = !0, a(), Dn && (clearTimeout(Dn), Dn = null), gr && (clearTimeout(gr), gr = null);
  }, f = (p) => {
    p || n <= 0 ? (o.current && clearTimeout(o.current), o.current = null, u.current()) : o.current || (o.current = setTimeout(() => {
      o.current = null, u.current();
    }, n)), Dn && (clearTimeout(Dn), Dn = null), Ca && (gr && clearTimeout(gr), gr = setTimeout(() => {
      delete vr[i], gr = null, Ca = !1;
    }, Math.max(Sc, n)));
  }, b = () => {
    d(), s(), !r && !Dn && !Ca ? Dn = setTimeout(() => {
      Dn = null, Ca = !0, c();
    }, t) : r || c();
  };
  return re(() => {
    u.current = l;
  }, [
    l
  ]), re(() => () => {
    o.current && clearTimeout(o.current), vr[i] && delete vr[i];
  }, [
    i
  ]), {
    isOpen: r,
    open: (p) => {
      !p && t > 0 && !o.current ? b() : c();
    },
    close: f
  };
}
class J8 {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (o) => {
      if (this.keyMap.set(o.key, o), o.childNodes && (o.type === "section" || n.has(o.key))) for (let u of o.childNodes) r(u);
    };
    for (let o of t) r(o);
    let a = null, l = 0;
    for (let [o, u] of this.keyMap)
      a ? (a.nextKey = o, u.prevKey = a.key) : (this.firstKey = o, u.prevKey = void 0), u.type === "item" && (u.index = l++), a = u, a.nextKey = void 0;
    var i;
    this.lastKey = (i = a == null ? void 0 : a.key) !== null && i !== void 0 ? i : null;
  }
}
function Q8(e) {
  let { onExpandedChange: t } = e, [n, r] = Me(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), a = dl(e), l = H(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), i = us(e, ie((u) => new J8(u, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return re(() => {
    a.focusedKey != null && !i.getItem(a.focusedKey) && a.setFocusedKey(null);
  }, [
    i,
    a.focusedKey
  ]), {
    collection: i,
    expandedKeys: n,
    disabledKeys: l,
    toggleKey: (u) => {
      r(e9(n, u));
    },
    setExpandedKeys: r,
    selectionManager: new sa(i, a)
  };
}
function e9(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const Rt = /* @__PURE__ */ G(null), t9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Rt);
  let { validationErrors: r, validationBehavior: a = "native", children: l, className: i, ...o } = t;
  return /* @__PURE__ */ x.createElement("form", {
    noValidate: a !== "native",
    ...o,
    ref: n,
    className: i || "react-aria-Form"
  }, /* @__PURE__ */ x.createElement(Rt.Provider, {
    value: {
      ...t,
      validationBehavior: a
    }
  }, /* @__PURE__ */ x.createElement(hb.Provider, {
    value: r ?? {}
  }, l)));
}), Ln = /* @__PURE__ */ G({}), Ri = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Ln);
  let { isDisabled: r, isInvalid: a, onHoverStart: l, onHoverChange: i, onHoverEnd: o, ...u } = t, { hoverProps: s, isHovered: d } = Ie({
    onHoverStart: l,
    onHoverChange: i,
    onHoverEnd: o,
    isDisabled: r
  }), { isFocused: c, isFocusVisible: f, focusProps: b } = Fe({
    within: !0
  });
  r ?? (r = !!t["aria-disabled"] && t["aria-disabled"] !== "false"), a ?? (a = !!t["aria-invalid"] && t["aria-invalid"] !== "false");
  let p = ne({
    ...t,
    values: {
      isHovered: d,
      isFocusWithin: c,
      isFocusVisible: f,
      isDisabled: r,
      isInvalid: a
    },
    defaultClassName: "react-aria-Group"
  });
  var h, m;
  return /* @__PURE__ */ x.createElement("div", {
    ..._(u, b, s),
    ...p,
    ref: n,
    role: (h = t.role) !== null && h !== void 0 ? h : "group",
    slot: (m = t.slot) !== null && m !== void 0 ? m : void 0,
    "data-focus-within": c || void 0,
    "data-hovered": d || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": r || void 0,
    "data-invalid": a || void 0
  }, p.children);
}), n9 = /* @__PURE__ */ G(null), r9 = /* @__PURE__ */ ua(function(t, n) {
  [t, n] = oe(t, n, n9);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = j(null), [u, s] = oe({}, o, ln), [d, c] = tt(!t["aria-label"] && !t["aria-labelledby"]), f = V8({
    ...t,
    validationBehavior: i
  }), { labelProps: b, inputProps: p, clearButtonProps: h, descriptionProps: m, errorMessageProps: v, ...y } = yC({
    ...yt(t),
    label: c,
    validationBehavior: i
  }, f, s), w = ne({
    ...t,
    values: {
      isEmpty: f.value === "",
      isDisabled: t.isDisabled || !1,
      isInvalid: y.isInvalid || !1,
      state: f
    },
    defaultClassName: "react-aria-SearchField"
  }), C = J(t);
  return delete C.id, /* @__PURE__ */ x.createElement("div", {
    ...C,
    ...w,
    ref: n,
    slot: t.slot || void 0,
    "data-empty": f.value === "" || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": y.isInvalid || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        dt,
        {
          ...b,
          ref: d
        }
      ],
      [
        ln,
        {
          ..._(p, u),
          ref: s
        }
      ],
      [
        Pt,
        h
      ],
      [
        ut,
        {
          slots: {
            description: m,
            errorMessage: v
          }
        }
      ],
      [
        Ln,
        {
          isInvalid: y.isInvalid,
          isDisabled: t.isDisabled || !1
        }
      ],
      [
        Mt,
        y
      ]
    ]
  }, w.children));
}), a9 = /* @__PURE__ */ G({}), l9 = /* @__PURE__ */ G(null), i9 = /* @__PURE__ */ ua(function(t, n) {
  [t, n] = oe(t, n, l9);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = j(null), [u, s] = oe({}, o, ln), [d, c] = tt(!t["aria-label"] && !t["aria-labelledby"]), [f, b] = q("input"), { labelProps: p, inputProps: h, descriptionProps: m, errorMessageProps: v, ...y } = Ei({
    ...yt(t),
    inputElementType: f,
    label: c,
    validationBehavior: i
  }, s), w = ie((P) => {
    s.current = P, P && b(P instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, [
    s
  ]), C = ne({
    ...t,
    values: {
      isDisabled: t.isDisabled || !1,
      isInvalid: y.isInvalid,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-TextField"
  }), D = J(t);
  return delete D.id, /* @__PURE__ */ x.createElement("div", {
    ...D,
    ...C,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": y.isInvalid || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        dt,
        {
          ...p,
          ref: d
        }
      ],
      [
        ln,
        {
          ..._(h, u),
          ref: w
        }
      ],
      [
        a9,
        {
          ...h,
          ref: w
        }
      ],
      [
        ut,
        {
          slots: {
            description: m,
            errorMessage: v
          }
        }
      ],
      [
        Mt,
        y
      ]
    ]
  }, C.children));
}), vu = /* @__PURE__ */ G(null), q$ = /* @__PURE__ */ G(null), da = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return Bc(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return Bc(e, t, n);
  }
};
function Bc(e, t, n) {
  return hs({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      var a;
      let l = r.render(r);
      if (!n || r.type !== "item") return l;
      let i = r.key, o = e.getKeyAfter(i);
      return /* @__PURE__ */ x.createElement(x.Fragment, null, n({
        type: "item",
        key: i,
        dropPosition: "before"
      }), l, (o == null || ((a = e.getItem(o)) === null || a === void 0 ? void 0 : a.type) !== "item") && n({
        type: "item",
        key: i,
        dropPosition: "after"
      }));
    }
  });
}
const Ze = /* @__PURE__ */ G(da);
function $s(e) {
  return H(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
const X$ = /* @__PURE__ */ G(null), o9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, X$);
  let r = t.href && !t.isDisabled ? "a" : "span", { linkProps: a, isPressed: l } = F6({
    ...t,
    elementType: r
  }, n), { hoverProps: i, isHovered: o } = Ie(t), { focusProps: u, isFocused: s, isFocusVisible: d } = Fe(), c = ne({
    ...t,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!t["aria-current"],
      isDisabled: t.isDisabled || !1,
      isPressed: l,
      isHovered: o,
      isFocused: s,
      isFocusVisible: d
    }
  });
  return /* @__PURE__ */ x.createElement(r, {
    ref: n,
    slot: t.slot || void 0,
    ..._(c, a, i, u),
    "data-focused": s || void 0,
    "data-hovered": o || void 0,
    "data-pressed": l || void 0,
    "data-focus-visible": d || void 0,
    "data-current": !!t["aria-current"] || void 0,
    "data-disabled": t.isDisabled || void 0
  }, c.children);
}), gu = /* @__PURE__ */ G(null), u9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, gu);
  let { CollectionRoot: r } = U(Ze), { navProps: a } = WD(t);
  return /* @__PURE__ */ x.createElement(Kn, {
    content: /* @__PURE__ */ x.createElement(Lt, t)
  }, (l) => {
    var i;
    return /* @__PURE__ */ x.createElement("ol", {
      ref: n,
      ...a,
      slot: t.slot || void 0,
      style: t.style,
      className: (i = t.className) !== null && i !== void 0 ? i : "react-aria-Breadcrumbs"
    }, /* @__PURE__ */ x.createElement(gu.Provider, {
      value: t
    }, /* @__PURE__ */ x.createElement(r, {
      collection: l
    })));
  });
}), s9 = /* @__PURE__ */ dn("item", function(t, n, r) {
  let a = r.nextKey == null, { isDisabled: l, onAction: i } = Ge(gu), o = {
    "aria-current": a ? "page" : null,
    isDisabled: l || a,
    onPress: () => i == null ? void 0 : i(r.key)
  }, u = ne({
    ...r.props,
    children: r.rendered,
    values: {
      isDisabled: l || a,
      isCurrent: a
    },
    defaultClassName: "react-aria-Breadcrumb"
  });
  return /* @__PURE__ */ x.createElement("li", {
    ...J(t),
    ...u,
    ref: n,
    "data-disabled": l || a || void 0,
    "data-current": a || void 0
  }, /* @__PURE__ */ x.createElement(X$.Provider, {
    value: o
  }, u.children));
}), oi = /* @__PURE__ */ G(null), ui = /* @__PURE__ */ G(null), Mi = /* @__PURE__ */ G(null), Ni = /* @__PURE__ */ G(null), d9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, oi);
  let { locale: r } = me(), a = r$({
    ...t,
    locale: r,
    createCalendar: xi
  }), { calendarProps: l, prevButtonProps: i, nextButtonProps: o, errorMessageProps: u, title: s } = d2(t, a), d = ne({
    ...t,
    values: {
      state: a,
      isDisabled: t.isDisabled || !1,
      isInvalid: a.isValueInvalid
    },
    defaultClassName: "react-aria-Calendar"
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...d,
    ...l,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": a.isValueInvalid || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Pt,
        {
          slots: {
            previous: i,
            next: o
          }
        }
      ],
      [
        Bi,
        {
          "aria-hidden": !0,
          level: 2,
          children: s
        }
      ],
      [
        Mi,
        a
      ],
      [
        oi,
        t
      ],
      [
        ut,
        {
          slots: {
            errorMessage: u
          }
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(Vn, null, /* @__PURE__ */ x.createElement("h2", null, l["aria-label"])), d.children, /* @__PURE__ */ x.createElement(Vn, null, /* @__PURE__ */ x.createElement("button", {
    "aria-label": o["aria-label"],
    disabled: o.isDisabled,
    onClick: () => a.focusNextPage(),
    tabIndex: -1
  }))));
}), c9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, ui);
  let { locale: r } = me(), a = f8({
    ...t,
    locale: r,
    createCalendar: xi
  }), { calendarProps: l, prevButtonProps: i, nextButtonProps: o, errorMessageProps: u, title: s } = c2(t, a, n), d = ne({
    ...t,
    values: {
      state: a,
      isDisabled: t.isDisabled || !1,
      isInvalid: a.isValueInvalid
    },
    defaultClassName: "react-aria-RangeCalendar"
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...d,
    ...l,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": a.isValueInvalid || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Pt,
        {
          slots: {
            previous: i,
            next: o
          }
        }
      ],
      [
        Bi,
        {
          "aria-hidden": !0,
          level: 2,
          children: s
        }
      ],
      [
        Ni,
        a
      ],
      [
        ui,
        t
      ],
      [
        ut,
        {
          slots: {
            errorMessage: u
          }
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(Vn, null, /* @__PURE__ */ x.createElement("h2", null, l["aria-label"])), d.children, /* @__PURE__ */ x.createElement(Vn, null, /* @__PURE__ */ x.createElement("button", {
    "aria-label": o["aria-label"],
    disabled: o.isDisabled,
    onClick: () => a.focusNextPage(),
    tabIndex: -1
  }))));
}), Vi = /* @__PURE__ */ G(null), J$ = /* @__PURE__ */ ee(function(t, n) {
  let r = U(Mi), a = U(Ni), l = Ge(oi), i = Ge(ui), o = r ?? a, u = o.visibleRange.start;
  t.offset && (u = u.add(t.offset));
  var s;
  let d = (s = l == null ? void 0 : l.firstDayOfWeek) !== null && s !== void 0 ? s : i == null ? void 0 : i.firstDayOfWeek, { gridProps: c, headerProps: f, weekDays: b } = f2({
    startDate: u,
    endDate: Gl(u),
    weekdayStyle: t.weekdayStyle,
    firstDayOfWeek: d
  }, o);
  var p;
  return /* @__PURE__ */ x.createElement(Vi.Provider, {
    value: {
      headerProps: f,
      weekDays: b,
      startDate: u,
      firstDayOfWeek: d
    }
  }, /* @__PURE__ */ x.createElement("table", {
    ...J(t),
    ...c,
    ref: n,
    style: t.style,
    className: (p = t.className) !== null && p !== void 0 ? p : "react-aria-CalendarGrid"
  }, typeof t.children != "function" ? t.children : /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Q$, null, (h) => /* @__PURE__ */ x.createElement(e1, null, h)), /* @__PURE__ */ x.createElement(xs, null, t.children))));
});
function f9(e, t) {
  let { children: n, style: r, className: a } = e, { headerProps: l, weekDays: i } = U(Vi);
  return /* @__PURE__ */ x.createElement("thead", {
    ...J(e),
    ...l,
    ref: t,
    style: r,
    className: a || "react-aria-CalendarGridHeader"
  }, /* @__PURE__ */ x.createElement("tr", null, i.map((o, u) => /* @__PURE__ */ x.cloneElement(n(o), {
    key: u
  }))));
}
const Q$ = /* @__PURE__ */ ee(f9);
function b9(e, t) {
  let { children: n, style: r, className: a } = e;
  return /* @__PURE__ */ x.createElement("th", {
    ...J(e),
    ref: t,
    style: r,
    className: a || "react-aria-CalendarHeaderCell"
  }, n);
}
const e1 = /* @__PURE__ */ ee(b9);
function p9(e, t) {
  let { children: n, style: r, className: a } = e, l = U(Mi), i = U(Ni), o = l ?? i, { startDate: u, firstDayOfWeek: s } = U(Vi), { locale: d } = me(), c = e4(u, d, s);
  return /* @__PURE__ */ x.createElement("tbody", {
    ...J(e),
    ref: t,
    style: r,
    className: a || "react-aria-CalendarGridBody"
  }, [
    ...new Array(c).keys()
  ].map((f) => /* @__PURE__ */ x.createElement("tr", {
    key: f
  }, o.getDatesInWeek(f, u).map((b, p) => b ? /* @__PURE__ */ x.cloneElement(n(b), {
    key: p
  }) : /* @__PURE__ */ x.createElement("td", {
    key: p
  })))));
}
const xs = /* @__PURE__ */ ee(p9), t1 = /* @__PURE__ */ ee(function({ date: t, ...n }, r) {
  let a = U(Mi), l = U(Ni), i = a ?? l;
  var o;
  let { startDate: u } = (o = U(Vi)) !== null && o !== void 0 ? o : {
    startDate: i.visibleRange.start
  }, s = j(null), { cellProps: d, buttonProps: c, ...f } = p2({
    date: t
  }, i, s), { hoverProps: b, isHovered: p } = Ie({
    ...n,
    isDisabled: f.isDisabled
  }), { focusProps: h, isFocusVisible: m } = Fe();
  m && (m = f.isFocused);
  let v = !_6(u, t), y = !1, w = !1;
  "highlightedRange" in i && i.highlightedRange && (y = Xe(t, i.highlightedRange.start), w = Xe(t, i.highlightedRange.end));
  let C = ne({
    ...n,
    defaultChildren: f.formattedDate,
    defaultClassName: "react-aria-CalendarCell",
    values: {
      date: t,
      isHovered: p,
      isOutsideMonth: v,
      isFocusVisible: m,
      isSelectionStart: y,
      isSelectionEnd: w,
      ...f
    }
  }), D = {
    "data-focused": f.isFocused || void 0,
    "data-hovered": p || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-unavailable": f.isUnavailable || void 0,
    "data-disabled": f.isDisabled || void 0,
    "data-focus-visible": m || void 0,
    "data-outside-visible-range": f.isOutsideVisibleRange || void 0,
    "data-outside-month": v || void 0,
    "data-selected": f.isSelected || void 0,
    "data-selection-start": y || void 0,
    "data-selection-end": w || void 0,
    "data-invalid": f.isInvalid || void 0
  };
  return /* @__PURE__ */ x.createElement("td", {
    ...d,
    ref: r
  }, /* @__PURE__ */ x.createElement("div", {
    ..._(J(n), c, h, b, D, C),
    ref: s
  }));
}), h9 = /* @__PURE__ */ G(null), n1 = /* @__PURE__ */ G(null), m9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, h9);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = b8({
    ...t,
    validationBehavior: i
  }), [u, s] = tt(!t["aria-label"] && !t["aria-labelledby"]), { groupProps: d, labelProps: c, descriptionProps: f, errorMessageProps: b, ...p } = $2({
    ...t,
    label: s,
    validationBehavior: i
  }, o), h = ne({
    ...t,
    values: {
      isDisabled: o.isDisabled,
      isReadOnly: o.isReadOnly,
      isRequired: t.isRequired || !1,
      isInvalid: o.isInvalid,
      state: o
    },
    defaultClassName: "react-aria-CheckboxGroup"
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...d,
    ...h,
    ref: n,
    slot: t.slot || void 0,
    "data-readonly": o.isReadOnly || void 0,
    "data-required": t.isRequired || void 0,
    "data-invalid": o.isInvalid || void 0,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        n1,
        o
      ],
      [
        dt,
        {
          ...c,
          ref: u,
          elementType: "span"
        }
      ],
      [
        ut,
        {
          slots: {
            description: f,
            errorMessage: b
          }
        }
      ],
      [
        Mt,
        p
      ]
    ]
  }, h.children));
}), v9 = /* @__PURE__ */ ee(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, Si);
  let { validationBehavior: l } = Ge(Rt) || {};
  var i, o;
  let u = (o = (i = t.validationBehavior) !== null && i !== void 0 ? i : l) !== null && o !== void 0 ? o : "native", s = U(n1), d = Ne(gn(r, t.inputRef !== void 0 ? t.inputRef : null)), { labelProps: c, inputProps: f, isSelected: b, isDisabled: p, isReadOnly: h, isPressed: m, isInvalid: v } = s ? D2({
    ...yt(t),
    // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
    // it's passed explicitly here to avoid typescript error (requires ignore).
    // @ts-ignore
    value: t.value,
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, s, d) : vb({
    ...yt(t),
    children: typeof t.children == "function" ? !0 : t.children,
    validationBehavior: u
  }, Ci(t), d), { isFocused: y, isFocusVisible: w, focusProps: C } = Fe(), D = p || h, { hoverProps: P, isHovered: R } = Ie({
    ...t,
    isDisabled: D
  }), V = ne({
    ...t,
    defaultClassName: "react-aria-Checkbox",
    values: {
      isSelected: b,
      isIndeterminate: t.isIndeterminate || !1,
      isPressed: m,
      isHovered: R,
      isFocused: y,
      isFocusVisible: w,
      isDisabled: p,
      isReadOnly: h,
      isInvalid: v,
      isRequired: t.isRequired || !1
    }
  }), L = J(t);
  return delete L.id, /* @__PURE__ */ x.createElement("label", {
    ..._(L, c, P, V),
    ref: n,
    slot: t.slot || void 0,
    "data-selected": b || void 0,
    "data-indeterminate": t.isIndeterminate || void 0,
    "data-pressed": m || void 0,
    "data-hovered": R || void 0,
    "data-focused": y || void 0,
    "data-focus-visible": w || void 0,
    "data-disabled": p || void 0,
    "data-readonly": h || void 0,
    "data-invalid": v || void 0,
    "data-required": t.isRequired || void 0
  }, /* @__PURE__ */ x.createElement(Vn, {
    elementType: "span"
  }, /* @__PURE__ */ x.createElement("input", {
    ..._(f, C),
    ref: d
  })), V.children);
}), Ii = /* @__PURE__ */ G(null), g9 = /* @__PURE__ */ ee(function(t, n) {
  let { state: r, thumbProps: a, inputXRef: l, inputYRef: i, xInputProps: o, yInputProps: u, isDisabled: s = !1 } = U(Ii), { focusProps: d, isFocused: c, isFocusVisible: f } = Fe(), { hoverProps: b, isHovered: p } = Ie(t), h = ne({
    ...t,
    defaultClassName: "react-aria-ColorThumb",
    defaultStyle: {
      ...a.style,
      backgroundColor: r.getDisplayColor().toString()
    },
    values: {
      color: r.getDisplayColor(),
      isHovered: p,
      isDragging: r.isDragging,
      isFocused: c,
      isFocusVisible: f,
      isDisabled: s
    }
  }), m = J(t);
  return delete m.id, /* @__PURE__ */ x.createElement("div", {
    ..._(a, b, m),
    ...h,
    ref: n,
    "data-hovered": p || void 0,
    "data-dragging": r.isDragging || void 0,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": s || void 0
  }, /* @__PURE__ */ x.createElement("input", {
    ref: l,
    ...o,
    ...d
  }), u && /* @__PURE__ */ x.createElement("input", {
    ref: i,
    ...u,
    ...d
  }), h.children);
}), y9 = /* @__PURE__ */ G(null), $9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Uy);
  let r = j(null), a = j(null), l = T2(t), { colorAreaProps: i, xInputProps: o, yInputProps: u, thumbProps: s } = J2({
    ...t,
    inputXRef: r,
    inputYRef: a,
    containerRef: n
  }, l), d = ne({
    ...t,
    defaultClassName: "react-aria-ColorArea",
    defaultStyle: i.style,
    values: {
      state: l,
      isDisabled: t.isDisabled || !1
    }
  }), c = J(t);
  return delete c.id, /* @__PURE__ */ x.createElement("div", {
    ref: n,
    ...i,
    ...c,
    ...d,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        y9,
        l
      ],
      [
        Ii,
        {
          state: l,
          thumbProps: s,
          inputXRef: r,
          xInputProps: o,
          inputYRef: a,
          yInputProps: u,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, d.children));
}), x9 = /* @__PURE__ */ G(null), D9 = /* @__PURE__ */ ee(function(t, n) {
  return [t, n] = oe(t, n, Wy), t.channel ? /* @__PURE__ */ x.createElement(C9, {
    ...t,
    channel: t.channel,
    forwardedRef: n
  }) : /* @__PURE__ */ x.createElement(E9, {
    ...t,
    forwardedRef: n
  });
});
function C9(e) {
  let { locale: t } = me(), n = G2({
    ...e,
    locale: t
  }), r = j(null), [a, l] = tt(!e["aria-label"] && !e["aria-labelledby"]);
  var i;
  let { labelProps: o, inputProps: u, descriptionProps: s, errorMessageProps: d, ...c } = i7({
    ...yt(e),
    label: l,
    validationBehavior: (i = e.validationBehavior) !== null && i !== void 0 ? i : "native"
  }, n, r);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, r1(e, n, e.forwardedRef, u, r, o, a, s, d, c), e.name && /* @__PURE__ */ x.createElement("input", {
    type: "hidden",
    name: e.name,
    value: isNaN(n.numberValue) ? "" : n.numberValue
  }));
}
function E9(e) {
  var t;
  let n = W2({
    ...e,
    validationBehavior: (t = e.validationBehavior) !== null && t !== void 0 ? t : "native"
  }), r = j(null), [a, l] = tt(!e["aria-label"] && !e["aria-labelledby"]);
  var i;
  let { labelProps: o, inputProps: u, descriptionProps: s, errorMessageProps: d, ...c } = n7({
    ...yt(e),
    label: l,
    validationBehavior: (i = e.validationBehavior) !== null && i !== void 0 ? i : "native"
  }, n, r);
  return r1(e, n, e.forwardedRef, u, r, o, a, s, d, c);
}
function r1(e, t, n, r, a, l, i, o, u, s) {
  let d = ne({
    ...e,
    values: {
      state: t,
      channel: e.channel || "hex",
      isDisabled: e.isDisabled || !1,
      isInvalid: s.isInvalid || !1
    },
    defaultClassName: "react-aria-ColorField"
  }), c = J(e);
  return delete c.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        x9,
        t
      ],
      [
        ln,
        {
          ...r,
          ref: a
        }
      ],
      [
        dt,
        {
          ...l,
          ref: i
        }
      ],
      [
        ut,
        {
          slots: {
            description: o,
            errorMessage: u
          }
        }
      ],
      [
        Mt,
        s
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...c,
    ...d,
    ref: n,
    slot: e.slot || void 0,
    "data-channel": e.channel || "hex",
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": s.isInvalid || void 0
  }));
}
const Ds = /* @__PURE__ */ G(null), w9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Ds);
  let { colorSwatchProps: r, color: a } = a7(t), l = ne({
    ...t,
    defaultClassName: "react-aria-ColorSwatch",
    defaultStyle: r.style,
    values: {
      color: a
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...r,
    ...l,
    slot: t.slot || void 0,
    ref: n
  });
});
var a1 = {};
a1 = {
  colorSwatchPicker: "تغييرات الألوان",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "حدد عنصرًا",
  tableResizer: "أداة تغيير الحجم"
};
var l1 = {};
l1 = {
  colorSwatchPicker: "Цветови мостри",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Изберете предмет",
  tableResizer: "Преоразмерител"
};
var i1 = {};
i1 = {
  colorSwatchPicker: "Vzorky barev",
  dropzoneLabel: "Místo pro přetažení",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Změna velikosti"
};
var o1 = {};
o1 = {
  colorSwatchPicker: "Farveprøver",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vælg et element",
  tableResizer: "Størrelsesændring"
};
var u1 = {};
u1 = {
  colorSwatchPicker: "Farbfelder",
  dropzoneLabel: "Ablegebereich",
  selectPlaceholder: "Element wählen",
  tableResizer: "Größenanpassung"
};
var s1 = {};
s1 = {
  colorSwatchPicker: "Χρωματικά δείγματα",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Επιλέξτε ένα αντικείμενο",
  tableResizer: "Αλλαγή μεγέθους"
};
var d1 = {};
d1 = {
  selectPlaceholder: "Select an item",
  tableResizer: "Resizer",
  dropzoneLabel: "DropZone",
  colorSwatchPicker: "Color swatches"
};
var c1 = {};
c1 = {
  colorSwatchPicker: "Muestras de colores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Seleccionar un artículo",
  tableResizer: "Cambiador de tamaño"
};
var f1 = {};
f1 = {
  colorSwatchPicker: "Värvinäidised",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valige üksus",
  tableResizer: "Suuruse muutja"
};
var b1 = {};
b1 = {
  colorSwatchPicker: "Värimallit",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valitse kohde",
  tableResizer: "Koon muuttaja"
};
var p1 = {};
p1 = {
  colorSwatchPicker: "Échantillons de couleurs",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Sélectionner un élément",
  tableResizer: "Redimensionneur"
};
var h1 = {};
h1 = {
  colorSwatchPicker: "דוגמיות צבע",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "בחר פריט",
  tableResizer: "שינוי גודל"
};
var m1 = {};
m1 = {
  colorSwatchPicker: "Uzorci boja",
  dropzoneLabel: "Zona spuštanja",
  selectPlaceholder: "Odaberite stavku",
  tableResizer: "Promjena veličine"
};
var v1 = {};
v1 = {
  colorSwatchPicker: "Színtárak",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Válasszon ki egy elemet",
  tableResizer: "Átméretező"
};
var g1 = {};
g1 = {
  colorSwatchPicker: "Campioni di colore",
  dropzoneLabel: "Zona di rilascio",
  selectPlaceholder: "Seleziona un elemento",
  tableResizer: "Ridimensionamento"
};
var y1 = {};
y1 = {
  colorSwatchPicker: "カラースウォッチ",
  dropzoneLabel: "ドロップゾーン",
  selectPlaceholder: "項目を選択",
  tableResizer: "サイズ変更ツール"
};
var $1 = {};
$1 = {
  colorSwatchPicker: "색상 견본",
  dropzoneLabel: "드롭 영역",
  selectPlaceholder: "항목 선택",
  tableResizer: "크기 조정기"
};
var x1 = {};
x1 = {
  colorSwatchPicker: "Spalvų pavyzdžiai",
  dropzoneLabel: "„DropZone“",
  selectPlaceholder: "Pasirinkite elementą",
  tableResizer: "Dydžio keitiklis"
};
var D1 = {};
D1 = {
  colorSwatchPicker: "Krāsu paraugi",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izvēlēties vienumu",
  tableResizer: "Izmēra mainītājs"
};
var C1 = {};
C1 = {
  colorSwatchPicker: "Fargekart",
  dropzoneLabel: "Droppsone",
  selectPlaceholder: "Velg et element",
  tableResizer: "Størrelsesendrer"
};
var E1 = {};
E1 = {
  colorSwatchPicker: "kleurstalen",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecteer een item",
  tableResizer: "Resizer"
};
var w1 = {};
w1 = {
  colorSwatchPicker: "Próbki kolorów",
  dropzoneLabel: "Strefa upuszczania",
  selectPlaceholder: "Wybierz element",
  tableResizer: "Zmiana rozmiaru"
};
var P1 = {};
P1 = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var k1 = {};
k1 = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var S1 = {};
S1 = {
  colorSwatchPicker: "Specimene de culoare",
  dropzoneLabel: "Zonă de plasare",
  selectPlaceholder: "Selectați un element",
  tableResizer: "Instrument de redimensionare"
};
var B1 = {};
B1 = {
  colorSwatchPicker: "Цветовые образцы",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Выберите элемент",
  tableResizer: "Средство изменения размера"
};
var F1 = {};
F1 = {
  colorSwatchPicker: "Vzorkovníky farieb",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Nástroj na zmenu veľkosti"
};
var A1 = {};
A1 = {
  colorSwatchPicker: "Barvne palete",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izberite element",
  tableResizer: "Spreminjanje velikosti"
};
var T1 = {};
T1 = {
  colorSwatchPicker: "Uzorci boje",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izaberite stavku",
  tableResizer: "Promena veličine"
};
var R1 = {};
R1 = {
  colorSwatchPicker: "Färgrutor",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Välj en artikel",
  tableResizer: "Storleksändrare"
};
var M1 = {};
M1 = {
  colorSwatchPicker: "Renk örnekleri",
  dropzoneLabel: "Bırakma Bölgesi",
  selectPlaceholder: "Bir öğe seçin",
  tableResizer: "Yeniden boyutlandırıcı"
};
var N1 = {};
N1 = {
  colorSwatchPicker: "Зразки кольорів",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Виберіть елемент",
  tableResizer: "Засіб змінення розміру"
};
var V1 = {};
V1 = {
  colorSwatchPicker: "颜色色板",
  dropzoneLabel: "放置区域",
  selectPlaceholder: "选择一个项目",
  tableResizer: "尺寸调整器"
};
var I1 = {};
I1 = {
  colorSwatchPicker: "色票",
  dropzoneLabel: "放置區",
  selectPlaceholder: "選取項目",
  tableResizer: "大小調整器"
};
var Oi = {};
Oi = {
  "ar-AE": a1,
  "bg-BG": l1,
  "cs-CZ": i1,
  "da-DK": o1,
  "de-DE": u1,
  "el-GR": s1,
  "en-US": d1,
  "es-ES": c1,
  "et-EE": f1,
  "fi-FI": b1,
  "fr-FR": p1,
  "he-IL": h1,
  "hr-HR": m1,
  "hu-HU": v1,
  "it-IT": g1,
  "ja-JP": y1,
  "ko-KR": $1,
  "lt-LT": x1,
  "lv-LV": D1,
  "nb-NO": C1,
  "nl-NL": E1,
  "pl-PL": w1,
  "pt-BR": P1,
  "pt-PT": k1,
  "ro-RO": S1,
  "ru-RU": B1,
  "sk-SK": F1,
  "sl-SI": A1,
  "sr-SP": T1,
  "sv-SE": R1,
  "tr-TR": M1,
  "uk-UA": N1,
  "zh-CN": V1,
  "zh-TW": I1
};
const tn = /* @__PURE__ */ G({}), zi = /* @__PURE__ */ G(null), P9 = /* @__PURE__ */ ee(function(t, n) {
  let { render: r } = U(zi);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, r(t, n));
});
function Cs(e, t) {
  var n;
  let r = e == null ? void 0 : e.renderDropIndicator, a = e == null || (n = e.isVirtualDragging) === null || n === void 0 ? void 0 : n.call(e), l = ie((i) => {
    if (a || t != null && t.isDropTarget(i)) return r ? r(i) : /* @__PURE__ */ x.createElement(P9, {
      target: i
    });
  }, [
    t == null ? void 0 : t.target,
    a,
    r
  ]);
  return e != null && e.useDropIndicator ? l : void 0;
}
function Es(e, t, n) {
  var r, a;
  let l = e.focusedKey, i = null;
  if (!(t == null || (r = t.isVirtualDragging) === null || r === void 0) && r.call(t) && (n == null || (a = n.target) === null || a === void 0 ? void 0 : a.type) === "item") {
    i = n.target.key;
    var o;
    n.target.dropPosition === "after" && (i = (o = n.collection.getKeyAfter(i)) !== null && o !== void 0 ? o : i);
  }
  return H(() => new Set([
    l,
    i
  ].filter((u) => u != null)), [
    l,
    i
  ]);
}
const ws = /* @__PURE__ */ G({}), O1 = /* @__PURE__ */ dn("header", function(t, n) {
  return [t, n] = oe(t, n, ws), /* @__PURE__ */ x.createElement("header", {
    className: "react-aria-Header",
    ...t,
    ref: n
  }, t.children);
}), Ps = /* @__PURE__ */ G({}), z1 = /* @__PURE__ */ dn("separator", function(t, n) {
  [t, n] = oe(t, n, Ps);
  let { elementType: r, orientation: a, style: l, className: i } = t, o = r || "hr";
  o === "hr" && a === "vertical" && (o = "div");
  let { separatorProps: u } = CC({
    elementType: r,
    orientation: a
  });
  return /* @__PURE__ */ x.createElement(o, {
    ...J(t),
    ...u,
    style: l,
    className: i ?? "react-aria-Separator",
    ref: n,
    slot: t.slot || void 0
  });
}), cl = /* @__PURE__ */ G(null), zt = /* @__PURE__ */ G(null), fl = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, cl);
  let r = U(zt);
  return r ? /* @__PURE__ */ x.createElement(K1, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ x.createElement(Kn, {
    content: /* @__PURE__ */ x.createElement(Lt, t)
  }, (a) => /* @__PURE__ */ x.createElement(k9, {
    props: t,
    listBoxRef: n,
    collection: a
  }));
});
function k9({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = U(Ze), a = Ti({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ x.createElement(K1, {
    state: a,
    props: e,
    listBoxRef: t
  });
}
function K1({ state: e, props: t, listBoxRef: n }) {
  let { filter: r, collectionProps: a, collectionRef: l } = U(vu) || {};
  t = H(() => a ? {
    ...t,
    ...a
  } : t, [
    t,
    a
  ]);
  let { dragAndDropHooks: i, layout: o = "stack", orientation: u = "vertical" } = t;
  n = Ne(H(() => gn(n, l !== void 0 ? l : null), [
    l,
    n
  ]));
  let s = h8(e, r), { collection: d, selectionManager: c } = s, f = !!(i != null && i.useDraggableCollectionState), b = !!(i != null && i.useDroppableCollectionState), { direction: p } = me(), { disabledBehavior: h, disabledKeys: m } = c, v = Rr({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: y, layoutDelegate: w, dropTargetDelegate: C, CollectionRoot: D } = U(Ze), P = H(() => t.keyboardDelegate || new lr({
    collection: d,
    collator: v,
    ref: n,
    disabledKeys: m,
    disabledBehavior: h,
    layout: o,
    orientation: u,
    direction: p,
    layoutDelegate: w
  }), [
    d,
    v,
    n,
    h,
    m,
    u,
    p,
    t.keyboardDelegate,
    o,
    w
  ]), { listBoxProps: R } = V7({
    ...t,
    shouldSelectOnPressUp: f || t.shouldSelectOnPressUp,
    keyboardDelegate: P,
    isVirtualized: y
  }, s, n), V = j(f), L = j(b);
  re(() => {
    V.current !== f && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), L.current !== b && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    f,
    b
  ]);
  let A, $, S, T = !1, M = null, K = j(null);
  if (f && i) {
    A = i.useDraggableCollectionState({
      collection: d,
      selectionManager: c,
      preview: i.renderDragPreview ? K : void 0
    }), i.useDraggableCollection({}, A, n);
    let z = i.DragPreview;
    M = i.renderDragPreview ? /* @__PURE__ */ x.createElement(z, {
      ref: K
    }, i.renderDragPreview) : null;
  }
  if (b && i) {
    $ = i.useDroppableCollectionState({
      collection: d,
      selectionManager: c
    });
    let z = i.dropTargetDelegate || C || new i.ListDropTargetDelegate(d, n, {
      orientation: u,
      layout: o,
      direction: p
    });
    S = i.useDroppableCollection({
      keyboardDelegate: P,
      dropTargetDelegate: z
    }, $, n), T = $.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: g, isFocused: B, isFocusVisible: k } = Fe(), I = {
    isDropTarget: T,
    isEmpty: s.collection.size === 0,
    isFocused: B,
    isFocusVisible: k,
    layout: t.layout || "stack",
    state: s
  }, O = ne({
    className: t.className,
    style: t.style,
    defaultClassName: "react-aria-ListBox",
    values: I
  }), F = null;
  return s.collection.size === 0 && t.renderEmptyState && (F = /* @__PURE__ */ x.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(I))), /* @__PURE__ */ x.createElement(rl, null, /* @__PURE__ */ x.createElement("div", {
    ...J(t),
    ..._(R, g, S == null ? void 0 : S.collectionProps),
    ...O,
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": T || void 0,
    "data-empty": s.collection.size === 0 || void 0,
    "data-focused": B || void 0,
    "data-focus-visible": k || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": t.orientation || "vertical"
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        cl,
        t
      ],
      [
        zt,
        s
      ],
      [
        tn,
        {
          dragAndDropHooks: i,
          dragState: A,
          dropState: $
        }
      ],
      [
        Ps,
        {
          elementType: "div"
        }
      ],
      [
        zi,
        {
          render: B9
        }
      ],
      [
        q$,
        {
          name: "ListBoxSection",
          render: j1
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(D, {
    collection: d,
    scrollRef: n,
    persistedKeys: Es(c, i, $),
    renderDropIndicator: Cs(i, $)
  })), F, M));
}
function j1(e, t, n, r = "react-aria-ListBoxSection") {
  let a = U(zt), { dragAndDropHooks: l, dropState: i } = U(tn), { CollectionBranch: o } = U(Ze), [u, s] = tt();
  var d;
  let { headingProps: c, groupProps: f } = K7({
    heading: s,
    "aria-label": (d = e["aria-label"]) !== null && d !== void 0 ? d : void 0
  }), b = ne({
    defaultClassName: r,
    className: e.className,
    style: e.style,
    values: {}
  });
  return /* @__PURE__ */ x.createElement("section", {
    ...J(e),
    ...f,
    ...b,
    ref: t
  }, /* @__PURE__ */ x.createElement(ws.Provider, {
    value: {
      ...c,
      ref: u
    }
  }, /* @__PURE__ */ x.createElement(o, {
    collection: a.collection,
    parent: n,
    renderDropIndicator: Cs(l, i)
  })));
}
const S9 = /* @__PURE__ */ Ai("section", j1), ks = /* @__PURE__ */ dn("item", function(t, n, r) {
  let a = Ne(n), l = U(zt), { dragAndDropHooks: i, dragState: o, dropState: u } = U(tn), { optionProps: s, labelProps: d, descriptionProps: c, ...f } = z7({
    key: r.key,
    "aria-label": t == null ? void 0 : t["aria-label"]
  }, l, a), { hoverProps: b, isHovered: p } = Ie({
    isDisabled: !f.allowsSelection && !f.hasAction,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), h = null;
  o && i && (h = i.useDraggableItem({
    key: r.key
  }, o));
  let m = null;
  u && i && (m = i.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, u, a));
  let v = o && o.isDragging(r.key), y = ne({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...f,
      isHovered: p,
      selectionMode: l.selectionManager.selectionMode,
      selectionBehavior: l.selectionManager.selectionBehavior,
      allowsDragging: !!o,
      isDragging: v,
      isDropTarget: m == null ? void 0 : m.isDropTarget
    }
  });
  re(() => {
    r.textValue || console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let w = t.href ? "a" : "div";
  return /* @__PURE__ */ x.createElement(w, {
    ..._(s, b, h == null ? void 0 : h.dragProps, m == null ? void 0 : m.dropProps),
    ...y,
    ref: a,
    "data-allows-dragging": !!o || void 0,
    "data-selected": f.isSelected || void 0,
    "data-disabled": f.isDisabled || void 0,
    "data-hovered": p || void 0,
    "data-focused": f.isFocused || void 0,
    "data-focus-visible": f.isFocusVisible || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-dragging": v || void 0,
    "data-drop-target": (m == null ? void 0 : m.isDropTarget) || void 0,
    "data-selection-mode": l.selectionManager.selectionMode === "none" ? void 0 : l.selectionManager.selectionMode
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        ut,
        {
          slots: {
            [rn]: d,
            label: d,
            description: c
          }
        }
      ]
    ]
  }, y.children));
});
function B9(e, t) {
  t = Ne(t);
  let { dragAndDropHooks: n, dropState: r } = U(tn), { dropIndicatorProps: a, isHidden: l, isDropTarget: i } = n.useDropIndicator(e, r, t);
  return l ? null : /* @__PURE__ */ x.createElement(A9, {
    ...e,
    dropIndicatorProps: a,
    isDropTarget: i,
    ref: t
  });
}
function F9(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...a } = e, l = ne({
    ...a,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...n,
    ...l,
    // eslint-disable-next-line
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  });
}
const A9 = /* @__PURE__ */ ee(F9);
function T9(e) {
  return e && e.__esModule ? e.default : e;
}
const L1 = /* @__PURE__ */ G(null), H1 = /* @__PURE__ */ G(null), R9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, L1);
  let r = O0(t), a = H(() => /* @__PURE__ */ new Map(), []), l = Oe(T9(Oi), "react-aria-components");
  return /* @__PURE__ */ x.createElement(fl, {
    ...J(t, {
      labelable: !0
    }),
    ref: n,
    className: t.className || "react-aria-ColorSwatchPicker",
    style: t.style,
    "aria-label": t["aria-label"] || (t["aria-labelledby"] ? void 0 : l.format("colorSwatchPicker")),
    layout: t.layout || "grid",
    selectionMode: "single",
    selectedKeys: [
      r.color.toString("hexa")
    ],
    onSelectionChange: (i) => {
      i !== "all" && r.setColor(a.get([
        ...i
      ][0]));
    },
    disallowEmptySelection: !0
  }, /* @__PURE__ */ x.createElement(H1.Provider, {
    value: a
  }, t.children));
}), M9 = /* @__PURE__ */ ee(function(t, n) {
  let r = t.color || "#0000", a = H(() => typeof r == "string" ? gt(r) : r, [
    r
  ]), { locale: l } = me(), i = U(H1);
  re(() => {
    let u = a.toString("hexa");
    return i.set(u, a), () => {
      i.delete(u);
    };
  }, [
    a,
    i
  ]);
  let o = (u) => typeof u == "function" ? (s) => u({
    ...s,
    color: a
  }) : u;
  return /* @__PURE__ */ x.createElement(ks, {
    ...t,
    ref: n,
    id: a.toString("hexa"),
    textValue: a.getColorName(l),
    className: o(t.className || "react-aria-ColorSwatchPickerItem"),
    style: o(t.style)
  }, et(o(t.children), (u) => /* @__PURE__ */ x.createElement(Ds.Provider, {
    value: {
      color: a
    }
  }, u)));
}), N9 = /* @__PURE__ */ G(null), V9 = /* @__PURE__ */ G(null);
function I9(e) {
  let t = Ge(N9, e.slot);
  e = _(t, e);
  let n = O0(e), r = ne({
    ...e,
    values: {
      color: n.color
    }
  });
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        V9,
        n
      ],
      [
        Gy,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Uy,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Zy,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Wy,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Ds,
        {
          color: n.color
        }
      ],
      [
        L1,
        {
          value: n.color,
          onChange: n.setColor
        }
      ]
    ]
  }, r.children);
}
const O9 = /* @__PURE__ */ G(null), bl = /* @__PURE__ */ G(null), Ki = /* @__PURE__ */ G(null), Ss = /* @__PURE__ */ G(null), z9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, O9);
  let r = j(null), a = ei(t.formatOptions), l = N0({
    ...t,
    numberFormatter: a
  }), [i, o] = tt(!t["aria-label"] && !t["aria-labelledby"]), { groupProps: u, trackProps: s, labelProps: d, outputProps: c } = j0({
    ...t,
    label: o
  }, l, r), f = ne({
    ...t,
    values: {
      orientation: l.orientation,
      isDisabled: l.isDisabled,
      state: l
    },
    defaultClassName: "react-aria-Slider"
  }), b = J(t);
  return delete b.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        bl,
        l
      ],
      [
        Ki,
        {
          ...s,
          ref: r
        }
      ],
      [
        Ss,
        c
      ],
      [
        dt,
        {
          ...d,
          ref: i
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...b,
    ...u,
    ...f,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": l.orientation,
    "data-disabled": l.isDisabled || void 0
  }));
}), Bs = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Ss);
  let { children: r, style: a, className: l, ...i } = t, o = U(bl), u = ne({
    className: l,
    style: a,
    children: r,
    defaultChildren: o.getThumbValueLabel(0),
    defaultClassName: "react-aria-SliderOutput",
    values: {
      orientation: o.orientation,
      isDisabled: o.isDisabled,
      state: o
    }
  });
  return /* @__PURE__ */ x.createElement("output", {
    ...i,
    ...u,
    ref: n,
    "data-orientation": o.orientation || void 0,
    "data-disabled": o.isDisabled || void 0
  });
}), Fs = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Ki);
  let r = U(bl), { onHoverStart: a, onHoverEnd: l, onHoverChange: i, ...o } = t, { hoverProps: u, isHovered: s } = Ie({
    onHoverStart: a,
    onHoverEnd: l,
    onHoverChange: i
  }), d = ne({
    ...t,
    defaultClassName: "react-aria-SliderTrack",
    values: {
      orientation: r.orientation,
      isDisabled: r.isDisabled,
      isHovered: s,
      state: r
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ..._(o, u),
    ...d,
    ref: n,
    "data-hovered": s || void 0,
    "data-orientation": r.orientation || void 0,
    "data-disabled": r.isDisabled || void 0
  });
}), K9 = /* @__PURE__ */ ee(function(t, n) {
  let { inputRef: r = null } = t, a = U(bl), { ref: l } = Ge(Ki), { index: i = 0 } = t, o = j(null), u = r || o, [s, d] = tt(!t["aria-label"] && !t["aria-labelledby"]), { thumbProps: c, inputProps: f, labelProps: b, isDragging: p, isFocused: h, isDisabled: m } = L0({
    ...t,
    index: i,
    trackRef: l,
    inputRef: u,
    label: d
  }, a), { focusProps: v, isFocusVisible: y } = Fe(), { hoverProps: w, isHovered: C } = Ie(t), D = ne({
    ...t,
    defaultClassName: "react-aria-SliderThumb",
    values: {
      state: a,
      isHovered: C,
      isDragging: p,
      isFocused: h,
      isFocusVisible: y,
      isDisabled: m
    }
  }), P = J(t);
  return delete P.id, /* @__PURE__ */ x.createElement("div", {
    ..._(P, c, w),
    ...D,
    ref: n,
    style: {
      ...c.style,
      ...D.style
    },
    "data-hovered": C || void 0,
    "data-dragging": p || void 0,
    "data-focused": h || void 0,
    "data-focus-visible": y || void 0,
    "data-disabled": m || void 0
  }, /* @__PURE__ */ x.createElement(Vn, null, /* @__PURE__ */ x.createElement("input", {
    ref: u,
    ..._(f, v)
  })), /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        dt,
        {
          ...b,
          ref: s
        }
      ]
    ]
  }, D.children));
}), j9 = /* @__PURE__ */ G(null), _1 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Gy);
  let { locale: r } = me(), a = V2({
    ...t,
    locale: r
  }), l = x.useRef(null), i = x.useRef(null), [o, u] = tt(!t["aria-label"] && !t["aria-labelledby"]), { trackProps: s, thumbProps: d, inputProps: c, labelProps: f, outputProps: b } = Q2({
    ...t,
    label: u,
    trackRef: l,
    inputRef: i
  }, a), p = ne({
    ...t,
    values: {
      orientation: a.orientation,
      isDisabled: a.isDisabled,
      state: a
    },
    defaultClassName: "react-aria-ColorSlider"
  }), h = J(t);
  return delete h.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        j9,
        a
      ],
      [
        bl,
        a
      ],
      [
        Ki,
        {
          ...s,
          ref: l
        }
      ],
      [
        Ss,
        b
      ],
      [
        dt,
        {
          ...f,
          ref: o,
          children: a.value.getChannelName(t.channel, r)
        }
      ],
      [
        Ii,
        {
          state: a,
          thumbProps: d,
          inputXRef: i,
          xInputProps: c,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...h,
    ...p,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": a.orientation,
    "data-disabled": a.isDisabled || void 0
  }));
}), U1 = /* @__PURE__ */ G(null), L9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Zy);
  let r = H2(t), a = j(null), { trackProps: l, inputProps: i, thumbProps: o } = e7(t, r, a), u = ne({
    ...t,
    values: {
      state: r,
      isDisabled: t.isDisabled || !1
    },
    defaultClassName: "react-aria-ColorWheel",
    defaultStyle: {
      position: "relative"
    }
  }), s = J(t);
  return delete s.id, /* @__PURE__ */ x.createElement("div", {
    ...s,
    ...u,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        U1,
        r
      ],
      [
        W1,
        l
      ],
      [
        Ii,
        {
          state: r,
          thumbProps: o,
          inputXRef: a,
          xInputProps: i,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, u.children));
}), W1 = /* @__PURE__ */ G(null), H9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, W1);
  let r = U(U1), a = ne({
    ...t,
    defaultClassName: "react-aria-ColorWheelTrack",
    values: {
      isDisabled: r.isDisabled,
      state: r
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...t,
    ...a,
    ref: n,
    "data-disabled": r.isDisabled || void 0
  });
}), As = /* @__PURE__ */ G({
  placement: "bottom"
}), G1 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, As);
  let r = t.placement, a = {
    position: "absolute",
    transform: r === "top" || r === "bottom" ? "translateX(-50%)" : "translateY(-50%)"
  };
  r != null && (a[r] = "100%");
  let l = ne({
    ...t,
    defaultClassName: "react-aria-OverlayArrow",
    values: {
      placement: r
    }
  });
  return l.style && Object.keys(l.style).forEach((i) => l.style[i] === void 0 && delete l.style[i]), /* @__PURE__ */ x.createElement("div", {
    ...t,
    ...l,
    style: {
      ...a,
      ...l.style
    },
    ref: n,
    "data-placement": r
  });
}), Mr = /* @__PURE__ */ G(null), Fc = /* @__PURE__ */ G(null), _9 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Mr);
  let r = U(xn), a = jn(t), l = t.isOpen != null || t.defaultOpen != null || !r ? a : r, i = jl(n, l.isOpen) || t.isExiting || !1, o = qC(), { direction: u } = me();
  if (o) {
    let s = t.children;
    return typeof s == "function" && (s = s({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ x.createElement(x.Fragment, null, s);
  }
  return l && !l.isOpen && !i ? null : /* @__PURE__ */ x.createElement(U9, {
    ...t,
    triggerRef: t.triggerRef,
    state: l,
    popoverRef: n,
    isExiting: i,
    dir: u
  });
});
function U9({ state: e, isExiting: t, UNSTABLE_portalContainer: n, ...r }) {
  let a = j(null), [l, i] = q(0), o = j(null), u = U(Fc), s = u && r.trigger === "SubmenuTrigger";
  Ce(() => {
    a.current && e.isOpen && i(a.current.getBoundingClientRect().width);
  }, [
    e.isOpen,
    a
  ]);
  var d;
  let { popoverProps: c, underlayProps: f, arrowProps: b, placement: p } = B7({
    ...r,
    offset: (d = r.offset) !== null && d !== void 0 ? d : 8,
    arrowSize: l,
    // If this is a submenu/subdialog, use the root popover's container 
    // to detect outside interaction and add aria-hidden.
    groupRef: s ? u : o
  }, e), h = r.popoverRef, m = pi(h, !!p) || r.isEntering || !1, v = ne({
    ...r,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: r.trigger || null,
      placement: p,
      isEntering: m,
      isExiting: t
    }
  }), y = !r.isNonModal || r.trigger === "SubmenuTrigger", [w, C] = q(!1);
  Ce(() => {
    h.current && C(y && !h.current.querySelector("[role=dialog]"));
  }, [
    h,
    y
  ]), re(() => {
    w && h.current && !h.current.contains(document.activeElement) && He(h.current);
  }, [
    w,
    h
  ]);
  let D = {
    ...c.style,
    ...v.style
  }, P = /* @__PURE__ */ x.createElement("div", {
    ..._(J(r), c),
    ...v,
    role: w ? "dialog" : void 0,
    tabIndex: w ? -1 : void 0,
    "aria-label": r["aria-label"],
    "aria-labelledby": r["aria-labelledby"],
    ref: h,
    slot: r.slot || void 0,
    style: D,
    dir: r.dir,
    "data-trigger": r.trigger,
    "data-placement": p,
    "data-entering": m || void 0,
    "data-exiting": t || void 0
  }, !r.isNonModal && /* @__PURE__ */ x.createElement(iu, {
    onDismiss: e.close
  }), /* @__PURE__ */ x.createElement(As.Provider, {
    value: {
      ...b,
      placement: p,
      ref: a
    }
  }, v.children), /* @__PURE__ */ x.createElement(iu, {
    onDismiss: e.close
  }));
  if (!s) return /* @__PURE__ */ x.createElement(ou, {
    ...r,
    shouldContainFocus: w,
    isExiting: t,
    portalContainer: n
  }, !r.isNonModal && e.isOpen && /* @__PURE__ */ x.createElement("div", {
    "data-testid": "underlay",
    ...f,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ x.createElement("div", {
    ref: o,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ x.createElement(Fc.Provider, {
    value: o
  }, P)));
  var R;
  return /* @__PURE__ */ x.createElement(ou, {
    ...r,
    shouldContainFocus: w,
    isExiting: t,
    portalContainer: (R = n ?? (u == null ? void 0 : u.current)) !== null && R !== void 0 ? R : void 0
  }, P);
}
const W9 = /* @__PURE__ */ G({}), G9 = /* @__PURE__ */ G(null), Ts = /* @__PURE__ */ G(null), yu = /* @__PURE__ */ G(null), si = /* @__PURE__ */ G(null), Z9 = /* @__PURE__ */ G(null), Y9 = /* @__PURE__ */ ee(function(t, n) {
  return [t, n] = oe(t, n, G9), /* @__PURE__ */ x.createElement(Kn, {
    content: /* @__PURE__ */ x.createElement(Lt, t)
  }, (r) => /* @__PURE__ */ x.createElement(q9, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function q9({ props: e, collection: t, menuRef: n }) {
  let { filter: r, collectionProps: a, collectionRef: l } = U(vu) || {};
  n = Ne(H(() => gn(n, l !== void 0 ? l : null), [
    l,
    n
  ]));
  let i = H(() => r ? t.UNSTABLE_filter(r) : t, [
    t,
    r
  ]), o = Q8({
    ...e,
    collection: i,
    children: void 0
  }), u = U(yu), { isVirtualized: s, CollectionRoot: d } = U(Ze), { menuProps: c } = L7({
    ...e,
    ...a,
    isVirtualized: s,
    onClose: e.onClose || (u == null ? void 0 : u.close)
  }, o, n), f = ne({
    defaultClassName: "react-aria-Menu",
    className: e.className,
    style: e.style,
    values: {
      isEmpty: o.collection.size === 0
    }
  }), b = null;
  return o.collection.size === 0 && e.renderEmptyState && (b = /* @__PURE__ */ x.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState())), /* @__PURE__ */ x.createElement(rl, null, /* @__PURE__ */ x.createElement("div", {
    ...J(e),
    ...c,
    ...f,
    ref: n,
    slot: e.slot || void 0,
    "data-empty": o.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Ts,
        o
      ],
      [
        Ps,
        {
          elementType: "div"
        }
      ],
      [
        q$,
        {
          name: "MenuSection",
          render: Z1
        }
      ],
      [
        Z9,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: a == null ? void 0 : a.shouldUseVirtualFocus
        }
      ],
      [
        $u,
        null
      ],
      [
        vu,
        null
      ],
      [
        si,
        o.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        yu,
        u ?? _$({})
      ]
    ]
  }, /* @__PURE__ */ x.createElement(d, {
    collection: o.collection,
    persistedKeys: $s(o.selectionManager.focusedKey),
    scrollRef: n
  })), b));
}
class X9 extends sa {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
}
function Z1(e, t, n, r = "react-aria-MenuSection") {
  var a, l;
  let i = U(Ts), { CollectionBranch: o } = U(Ze), [u, s] = tt();
  var d;
  let { headingProps: c, groupProps: f } = _7({
    heading: s,
    "aria-label": (d = n.props["aria-label"]) !== null && d !== void 0 ? d : void 0
  }), b = ne({
    defaultClassName: r,
    className: (a = n.props) === null || a === void 0 ? void 0 : a.className,
    style: (l = n.props) === null || l === void 0 ? void 0 : l.style,
    values: {}
  }), p = U(si), h = dl(e), m = e.selectionMode != null ? new X9(p, h) : p;
  return /* @__PURE__ */ x.createElement("section", {
    ...J(e),
    ...f,
    ...b,
    ref: t
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        ws,
        {
          ...c,
          ref: u
        }
      ],
      [
        si,
        m
      ]
    ]
  }, /* @__PURE__ */ x.createElement(o, {
    collection: i.collection,
    parent: n
  })));
}
const J9 = /* @__PURE__ */ Ai("section", Z1), $u = /* @__PURE__ */ G(null), Q9 = /* @__PURE__ */ dn("item", function(t, n, r) {
  var a;
  [t, n] = oe(t, n, $u);
  let l = (a = Ge($u)) === null || a === void 0 ? void 0 : a.id, i = U(Ts), o = Ne(n), u = U(si), { menuItemProps: s, labelProps: d, descriptionProps: c, keyboardShortcutProps: f, ...b } = H7({
    ...t,
    id: l,
    key: r.key,
    selectionManager: u
  }, i, o), { hoverProps: p, isHovered: h } = Ie({
    isDisabled: b.isDisabled
  }), m = ne({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...b,
      isHovered: h,
      isFocusVisible: b.isFocusVisible,
      selectionMode: u.selectionMode,
      selectionBehavior: u.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), v = t.href ? "a" : "div";
  return /* @__PURE__ */ x.createElement(v, {
    ..._(s, p),
    ...m,
    ref: o,
    "data-disabled": b.isDisabled || void 0,
    "data-hovered": h || void 0,
    "data-focused": b.isFocused || void 0,
    "data-focus-visible": b.isFocusVisible || void 0,
    "data-pressed": b.isPressed || void 0,
    "data-selected": b.isSelected || void 0,
    "data-selection-mode": u.selectionMode === "none" ? void 0 : u.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        ut,
        {
          slots: {
            [rn]: d,
            label: d,
            description: c
          }
        }
      ],
      [
        W9,
        f
      ]
    ]
  }, m.children));
}), ji = /* @__PURE__ */ G(null), xn = /* @__PURE__ */ G(null);
function eE(e) {
  let t = _$(e), n = j(null), { triggerProps: r, overlayProps: a } = Wh({
    type: "dialog"
  }, t, n);
  return r.id = Ee(), a["aria-labelledby"] = r.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        xn,
        t
      ],
      [
        yu,
        t
      ],
      [
        ji,
        a
      ],
      [
        Mr,
        {
          trigger: "DialogTrigger",
          triggerRef: n,
          "aria-labelledby": a["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(w6, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const tE = /* @__PURE__ */ ee(function(t, n) {
  let r = t["aria-labelledby"];
  [t, n] = oe(t, n, ji);
  let { dialogProps: a, titleProps: l } = aC({
    ...t,
    // Only pass aria-labelledby from props, not context.
    // Context is used as a fallback below.
    "aria-labelledby": r
  }, n), i = U(xn);
  !a["aria-label"] && !a["aria-labelledby"] && (t["aria-labelledby"] ? a["aria-labelledby"] = t["aria-labelledby"] : console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.'));
  let o = ne({
    defaultClassName: "react-aria-Dialog",
    className: t.className,
    style: t.style,
    children: t.children,
    values: {
      close: (i == null ? void 0 : i.close) || (() => {
      })
    }
  });
  return /* @__PURE__ */ x.createElement("section", {
    ...J(t),
    ...a,
    ...o,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Bi,
        {
          slots: {
            [rn]: {},
            title: {
              ...l,
              level: 2
            }
          }
        }
      ],
      [
        Pt,
        {
          slots: {
            [rn]: {},
            close: {
              onPress: () => i == null ? void 0 : i.close()
            }
          }
        }
      ]
    ]
  }, o.children));
}), nE = /* @__PURE__ */ G(null), rE = /* @__PURE__ */ G(null), Y1 = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, nE);
  let { children: r, isDisabled: a = !1, isInvalid: l = !1, isRequired: i = !1 } = t, o = H(() => {
    var u;
    return /* @__PURE__ */ x.createElement(cl.Provider, {
      value: {
        items: (u = t.items) !== null && u !== void 0 ? u : t.defaultItems
      }
    }, typeof r == "function" ? r({
      isOpen: !1,
      isDisabled: a,
      isInvalid: l,
      isRequired: i,
      defaultChildren: null
    }) : r);
  }, [
    r,
    a,
    l,
    i,
    t.items,
    t.defaultItems
  ]);
  return /* @__PURE__ */ x.createElement(Kn, {
    content: o
  }, (u) => /* @__PURE__ */ x.createElement(aE, {
    props: t,
    collection: u,
    comboBoxRef: n
  }));
});
function aE({ props: e, collection: t, comboBoxRef: n }) {
  let { name: r, formValue: a = "key", allowsCustomValue: l } = e;
  l && (a = "text");
  let { validationBehavior: i } = Ge(Rt) || {};
  var o, u;
  let s = (u = (o = e.validationBehavior) !== null && o !== void 0 ? o : i) !== null && u !== void 0 ? u : "native", { contains: d } = E4({
    sensitivity: "base"
  }), c = m8({
    defaultFilter: e.defaultFilter || d,
    ...e,
    // If props.items isn't provided, rely on collection filtering (aka listbox.items is provided or defaultItems provided to Combobox)
    items: e.items,
    children: void 0,
    collection: t,
    validationBehavior: s
  }), f = j(null), b = j(null), p = j(null), h = j(null), [m, v] = tt(!e["aria-label"] && !e["aria-labelledby"]), { buttonProps: y, inputProps: w, listBoxProps: C, labelProps: D, descriptionProps: P, errorMessageProps: R, ...V } = W7({
    ...yt(e),
    label: v,
    inputRef: b,
    buttonRef: f,
    listBoxRef: p,
    popoverRef: h,
    name: a === "text" ? r : void 0,
    validationBehavior: s
  }, c), [L, A] = q(null), $ = ie(() => {
    if (b.current) {
      var g;
      let B = (g = f.current) === null || g === void 0 ? void 0 : g.getBoundingClientRect(), k = b.current.getBoundingClientRect(), I = B ? Math.min(B.left, k.left) : k.left, O = B ? Math.max(B.right, k.right) : k.right;
      A(O - I + "px");
    }
  }, [
    f,
    b,
    A
  ]);
  Pr({
    ref: b,
    onResize: $
  });
  let S = H(() => ({
    isOpen: c.isOpen,
    isDisabled: e.isDisabled || !1,
    isInvalid: V.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    c.isOpen,
    e.isDisabled,
    V.isInvalid,
    e.isRequired
  ]), T = ne({
    ...e,
    values: S,
    defaultClassName: "react-aria-ComboBox"
  }), M = J(e);
  delete M.id;
  var K;
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        rE,
        c
      ],
      [
        dt,
        {
          ...D,
          ref: m
        }
      ],
      [
        Pt,
        {
          ...y,
          ref: f,
          isPressed: c.isOpen
        }
      ],
      [
        ln,
        {
          ...w,
          ref: b
        }
      ],
      [
        xn,
        c
      ],
      [
        Mr,
        {
          ref: h,
          triggerRef: b,
          scrollRef: p,
          placement: "bottom start",
          isNonModal: !0,
          trigger: "ComboBox",
          style: {
            "--trigger-width": L
          }
        }
      ],
      [
        cl,
        {
          ...C,
          ref: p
        }
      ],
      [
        zt,
        c
      ],
      [
        ut,
        {
          slots: {
            description: P,
            errorMessage: R
          }
        }
      ],
      [
        Ln,
        {
          isInvalid: V.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        Mt,
        V
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...M,
    ...T,
    ref: n,
    slot: e.slot || void 0,
    "data-focused": c.isFocused || void 0,
    "data-open": c.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": V.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }), r && a === "key" && /* @__PURE__ */ x.createElement("input", {
    type: "hidden",
    name: r,
    value: (K = c.selectedKey) !== null && K !== void 0 ? K : ""
  }));
}
const Li = /* @__PURE__ */ G(null), lE = /* @__PURE__ */ G(null), pl = /* @__PURE__ */ G(null), Hi = /* @__PURE__ */ G(null), iE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Li);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", { locale: o } = me(), u = gs({
    ...t,
    locale: o,
    createCalendar: xi,
    validationBehavior: i
  }), s = j(null), [d, c] = tt(!t["aria-label"] && !t["aria-labelledby"]), f = j(null), { labelProps: b, fieldProps: p, inputProps: h, descriptionProps: m, errorMessageProps: v, ...y } = cs({
    ...yt(t),
    label: c,
    inputRef: f,
    validationBehavior: i
  }, u, s), w = ne({
    ...yt(t),
    values: {
      state: u,
      isInvalid: u.isInvalid,
      isDisabled: u.isDisabled
    },
    defaultClassName: "react-aria-DateField"
  }), C = J(t);
  return delete C.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        pl,
        u
      ],
      [
        Ln,
        {
          ...p,
          ref: s,
          isInvalid: u.isInvalid
        }
      ],
      [
        ln,
        {
          ...h,
          ref: f
        }
      ],
      [
        dt,
        {
          ...b,
          ref: d,
          elementType: "span"
        }
      ],
      [
        ut,
        {
          slots: {
            description: m,
            errorMessage: v
          }
        }
      ],
      [
        Mt,
        y
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...C,
    ...w,
    ref: n,
    slot: t.slot || void 0,
    "data-invalid": u.isInvalid || void 0
  }));
}), oE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, lE);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", { locale: o } = me(), u = F8({
    ...t,
    locale: o,
    validationBehavior: i
  }), s = j(null), [d, c] = tt(!t["aria-label"] && !t["aria-labelledby"]), f = j(null), { labelProps: b, fieldProps: p, inputProps: h, descriptionProps: m, errorMessageProps: v, ...y } = Z7({
    ...yt(t),
    label: c,
    inputRef: f,
    validationBehavior: i
  }, u, s), w = ne({
    ...t,
    values: {
      state: u,
      isInvalid: u.isInvalid,
      isDisabled: u.isDisabled
    },
    defaultClassName: "react-aria-TimeField"
  }), C = J(t);
  return delete C.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Hi,
        u
      ],
      [
        Ln,
        {
          ...p,
          ref: s,
          isInvalid: u.isInvalid
        }
      ],
      [
        ln,
        {
          ...h,
          ref: f
        }
      ],
      [
        dt,
        {
          ...b,
          ref: d,
          elementType: "span"
        }
      ],
      [
        ut,
        {
          slots: {
            description: m,
            errorMessage: v
          }
        }
      ],
      [
        Mt,
        y
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...C,
    ...w,
    ref: n,
    slot: t.slot || void 0,
    "data-invalid": u.isInvalid || void 0
  }));
}), uE = /* @__PURE__ */ ee(function(t, n) {
  let r = U(pl), a = U(Hi);
  return r || a ? /* @__PURE__ */ x.createElement(q1, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ x.createElement(sE, {
    ...t,
    ref: n
  });
}), sE = /* @__PURE__ */ ee((e, t) => {
  let [n, r] = oe({
    slot: e.slot
  }, t, Li), { locale: a } = me(), l = gs({
    ...n,
    locale: a,
    createCalendar: xi
  }), i = j(null), { fieldProps: o, inputProps: u } = cs({
    ...n,
    inputRef: i
  }, l, r);
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        pl,
        l
      ],
      [
        ln,
        {
          ...u,
          ref: i
        }
      ],
      [
        Ln,
        {
          ...o,
          ref: r,
          isInvalid: l.isInvalid
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(q1, e));
}), q1 = /* @__PURE__ */ ee((e, t) => {
  let { className: n, children: r } = e, a = U(pl), l = U(Hi), i = a ?? l;
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Ri, {
    ...e,
    ref: t,
    slot: e.slot || void 0,
    className: n ?? "react-aria-DateInput",
    isInvalid: i.isInvalid
  }, i.segments.map((o, u) => /* @__PURE__ */ _c(r(o), {
    key: u
  }))), /* @__PURE__ */ x.createElement(Qy, null));
}), dE = /* @__PURE__ */ ee(function({ segment: t, ...n }, r) {
  let a = U(pl), l = U(Hi), i = a ?? l, o = Ne(r), { segmentProps: u } = eC(t, i, o), { focusProps: s, isFocused: d, isFocusVisible: c } = Fe(), { hoverProps: f, isHovered: b } = Ie({
    ...n,
    isDisabled: i.isDisabled || t.type === "literal"
  }), p = ne({
    ...n,
    values: {
      ...t,
      isReadOnly: !t.isEditable,
      isInvalid: i.isInvalid,
      isDisabled: i.isDisabled,
      isHovered: b,
      isFocused: d,
      isFocusVisible: c
    },
    defaultChildren: t.text,
    defaultClassName: "react-aria-DateSegment"
  });
  return /* @__PURE__ */ x.createElement("span", {
    ..._(J(n), u, s, f),
    ...p,
    style: u.style,
    ref: o,
    "data-placeholder": t.isPlaceholder || void 0,
    "data-invalid": i.isInvalid || void 0,
    "data-readonly": !t.isEditable || void 0,
    "data-disabled": i.isDisabled || void 0,
    "data-type": t.type,
    "data-hovered": b || void 0,
    "data-focused": d || void 0,
    "data-focus-visible": c || void 0
  });
}), cE = /* @__PURE__ */ G(null), fE = /* @__PURE__ */ G(null), bE = /* @__PURE__ */ G(null), pE = /* @__PURE__ */ G(null), hE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, cE);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = D8({
    ...t,
    validationBehavior: i
  }), u = j(null), [s, d] = tt(!t["aria-label"] && !t["aria-labelledby"]), { groupProps: c, labelProps: f, fieldProps: b, buttonProps: p, dialogProps: h, calendarProps: m, descriptionProps: v, errorMessageProps: y, ...w } = q7({
    ...yt(t),
    label: d,
    validationBehavior: i
  }, o, u), [C, D] = q(null), P = ie(() => {
    u.current && D(u.current.offsetWidth + "px");
  }, []);
  Pr({
    ref: u,
    onResize: P
  });
  let { focusProps: R, isFocused: V, isFocusVisible: L } = Fe({
    within: !0
  }), A = ne({
    ...t,
    values: {
      state: o,
      isFocusWithin: V,
      isFocusVisible: L,
      isDisabled: t.isDisabled || !1,
      isInvalid: o.isInvalid,
      isOpen: o.isOpen
    },
    defaultClassName: "react-aria-DatePicker"
  }), $ = J(t);
  return delete $.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        bE,
        o
      ],
      [
        Ln,
        {
          ...c,
          ref: u,
          isInvalid: o.isInvalid
        }
      ],
      [
        Li,
        b
      ],
      [
        Pt,
        {
          ...p,
          isPressed: o.isOpen
        }
      ],
      [
        dt,
        {
          ...f,
          ref: s,
          elementType: "span"
        }
      ],
      [
        oi,
        m
      ],
      [
        xn,
        o
      ],
      [
        Mr,
        {
          trigger: "DatePicker",
          triggerRef: u,
          placement: "bottom start",
          style: {
            "--trigger-width": C
          }
        }
      ],
      [
        ji,
        h
      ],
      [
        ut,
        {
          slots: {
            description: v,
            errorMessage: y
          }
        }
      ],
      [
        Mt,
        w
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...R,
    ...$,
    ...A,
    ref: n,
    slot: t.slot || void 0,
    "data-focus-within": V || void 0,
    "data-invalid": o.isInvalid || void 0,
    "data-focus-visible": L || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-open": o.isOpen || void 0
  }));
}), mE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, fE);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = B8({
    ...t,
    validationBehavior: i
  }), u = j(null), [s, d] = tt(!t["aria-label"] && !t["aria-labelledby"]), { groupProps: c, labelProps: f, startFieldProps: b, endFieldProps: p, buttonProps: h, dialogProps: m, calendarProps: v, descriptionProps: y, errorMessageProps: w, ...C } = rC({
    ...yt(t),
    label: d,
    validationBehavior: i
  }, o, u), [D, P] = q(null), R = ie(() => {
    u.current && P(u.current.offsetWidth + "px");
  }, []);
  Pr({
    ref: u,
    onResize: R
  });
  let { focusProps: V, isFocused: L, isFocusVisible: A } = Fe({
    within: !0
  }), $ = ne({
    ...t,
    values: {
      state: o,
      isFocusWithin: L,
      isFocusVisible: A,
      isDisabled: t.isDisabled || !1,
      isInvalid: o.isInvalid,
      isOpen: o.isOpen
    },
    defaultClassName: "react-aria-DateRangePicker"
  }), S = J(t);
  return delete S.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        pE,
        o
      ],
      [
        Ln,
        {
          ...c,
          ref: u,
          isInvalid: o.isInvalid
        }
      ],
      [
        Pt,
        {
          ...h,
          isPressed: o.isOpen
        }
      ],
      [
        dt,
        {
          ...f,
          ref: s,
          elementType: "span"
        }
      ],
      [
        ui,
        v
      ],
      [
        xn,
        o
      ],
      [
        Mr,
        {
          trigger: "DateRangePicker",
          triggerRef: u,
          placement: "bottom start",
          style: {
            "--trigger-width": D
          }
        }
      ],
      [
        ji,
        m
      ],
      [
        Li,
        {
          slots: {
            start: b,
            end: p
          }
        }
      ],
      [
        ut,
        {
          slots: {
            description: y,
            errorMessage: w
          }
        }
      ],
      [
        Mt,
        C
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...V,
    ...S,
    ...$,
    ref: n,
    slot: t.slot || void 0,
    "data-focus-within": L || void 0,
    "data-invalid": o.isInvalid || void 0,
    "data-focus-visible": A || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-open": o.isOpen || void 0
  }));
}), _i = /* @__PURE__ */ G(null), vE = /* @__PURE__ */ ee(function(t, n) {
  let r = T8(t), a = ne({
    ...t,
    defaultClassName: "react-aria-DisclosureGroup",
    values: {
      isDisabled: r.isDisabled,
      state: r
    }
  }), l = J(t);
  return /* @__PURE__ */ x.createElement("div", {
    ...l,
    ...a,
    ref: n,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement(_i.Provider, {
    value: r
  }, a.children));
}), gE = /* @__PURE__ */ G(null), X1 = /* @__PURE__ */ G(null), J1 = /* @__PURE__ */ G(null), yE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, gE);
  let r = U(_i), { id: a, ...l } = t, i = Ee();
  a || (a = i);
  let o = r ? r.expandedKeys.has(a) : t.isExpanded, u = A8({
    ...t,
    isExpanded: o,
    onExpandedChange(v) {
      var y;
      r && r.toggleKey(a), (y = t.onExpandedChange) === null || y === void 0 || y.call(t, v);
    }
  }), s = x.useRef(null), d = t.isDisabled || (r == null ? void 0 : r.isDisabled) || !1, { buttonProps: c, panelProps: f } = lC({
    ...t,
    isExpanded: o,
    isDisabled: d
  }, u, s), { isFocusVisible: b, focusProps: p } = Fe({
    within: !0
  }), h = ne({
    ...t,
    id: void 0,
    defaultClassName: "react-aria-Disclosure",
    values: {
      isExpanded: u.isExpanded,
      isDisabled: d,
      isFocusVisibleWithin: b,
      state: u
    }
  }), m = J(l);
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Pt,
        {
          slots: {
            [rn]: {},
            trigger: c
          }
        }
      ],
      [
        J1,
        {
          panelProps: f,
          panelRef: s
        }
      ],
      [
        X1,
        u
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ref: n,
    "data-expanded": u.isExpanded || void 0,
    "data-disabled": d || void 0,
    "data-focus-visible-within": b || void 0,
    ...m,
    ...p,
    ...h
  }, h.children));
}), $E = /* @__PURE__ */ ee(function(t, n) {
  let { role: r = "group" } = t, { panelProps: a, panelRef: l } = U(J1), { isFocusVisible: i, focusProps: o } = Fe({
    within: !0
  }), u = ne({
    ...t,
    defaultClassName: "react-aria-DisclosurePanel",
    values: {
      isFocusVisibleWithin: i
    }
  }), s = J(t);
  return /* @__PURE__ */ x.createElement("div", {
    ...s,
    ref: gn(n, l),
    ..._(a, o),
    ...u,
    role: r,
    "data-focus-visible-within": i || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Pt,
        null
      ]
    ]
  }, t.children));
}), xE = /* @__PURE__ */ G(null), DE = /* @__PURE__ */ ee(function(t, n) {
  return [t, n] = oe(t, n, xE), /* @__PURE__ */ x.createElement(Kn, {
    content: /* @__PURE__ */ x.createElement(Lt, t)
  }, (r) => /* @__PURE__ */ x.createElement(CE, {
    props: t,
    collection: r,
    gridListRef: n
  }));
});
function CE({ props: e, collection: t, gridListRef: n }) {
  let { dragAndDropHooks: r, keyboardNavigationBehavior: a = "arrow", layout: l = "stack" } = e, { CollectionRoot: i, isVirtualized: o, layoutDelegate: u, dropTargetDelegate: s } = U(Ze), d = Ti({
    ...e,
    collection: t,
    children: void 0,
    layoutDelegate: u
  }), c = Rr({
    usage: "search",
    sensitivity: "base"
  }), { disabledBehavior: f, disabledKeys: b } = d.selectionManager, { direction: p } = me(), h = H(() => new lr({
    collection: t,
    collator: c,
    ref: n,
    disabledKeys: b,
    disabledBehavior: f,
    layoutDelegate: u,
    layout: l,
    direction: p
  }), [
    t,
    n,
    l,
    b,
    f,
    u,
    c,
    p
  ]), { gridProps: m } = zv({
    ...e,
    keyboardDelegate: h,
    // Only tab navigation is supported in grid layout.
    keyboardNavigationBehavior: l === "grid" ? "tab" : a,
    isVirtualized: o
  }, d, n), v = d.selectionManager, y = !!(r != null && r.useDraggableCollectionState), w = !!(r != null && r.useDroppableCollectionState), C = j(y), D = j(w);
  re(() => {
    C.current !== y && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), D.current !== w && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    y,
    w
  ]);
  let P, R, V, L = !1, A = null, $ = j(null);
  if (y && r) {
    P = r.useDraggableCollectionState({
      collection: t,
      selectionManager: v,
      preview: r.renderDragPreview ? $ : void 0
    }), r.useDraggableCollection({}, P, n);
    let I = r.DragPreview;
    A = r.renderDragPreview ? /* @__PURE__ */ x.createElement(I, {
      ref: $
    }, r.renderDragPreview) : null;
  }
  if (w && r) {
    R = r.useDroppableCollectionState({
      collection: t,
      selectionManager: v
    });
    let I = new lr({
      collection: t,
      disabledKeys: v.disabledKeys,
      disabledBehavior: v.disabledBehavior,
      ref: n
    }), O = r.dropTargetDelegate || s || new r.ListDropTargetDelegate(t, n, {
      layout: l,
      direction: p
    });
    V = r.useDroppableCollection({
      keyboardDelegate: I,
      dropTargetDelegate: O
    }, R, n), L = R.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: S, isFocused: T, isFocusVisible: M } = Fe(), K = {
    isDropTarget: L,
    isEmpty: d.collection.size === 0,
    isFocused: T,
    isFocusVisible: M,
    layout: l,
    state: d
  }, g = ne({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-GridList",
    values: K
  }), B = null, k = null;
  if (d.collection.size === 0 && e.renderEmptyState) {
    let I = e.renderEmptyState(K);
    B = /* @__PURE__ */ x.createElement("div", {
      role: "row",
      style: {
        display: "contents"
      }
    }, /* @__PURE__ */ x.createElement("div", {
      role: "gridcell",
      style: {
        display: "contents"
      }
    }, I));
  }
  return /* @__PURE__ */ x.createElement(rl, null, /* @__PURE__ */ x.createElement("div", {
    ...J(e),
    ...g,
    ..._(m, S, V == null ? void 0 : V.collectionProps, k),
    ref: n,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-drop-target": L || void 0,
    "data-empty": d.collection.size === 0 || void 0,
    "data-focused": T || void 0,
    "data-focus-visible": M || void 0,
    "data-layout": l
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        zt,
        d
      ],
      [
        tn,
        {
          dragAndDropHooks: r,
          dragState: P,
          dropState: R
        }
      ],
      [
        zi,
        {
          render: wE
        }
      ]
    ]
  }, w && /* @__PURE__ */ x.createElement(SE, null), /* @__PURE__ */ x.createElement(i, {
    collection: t,
    scrollRef: n,
    persistedKeys: Es(v, r, R),
    renderDropIndicator: Cs(r, R)
  })), B, A));
}
const EE = /* @__PURE__ */ dn("item", function(t, n, r) {
  let a = U(zt), { dragAndDropHooks: l, dragState: i, dropState: o } = U(tn), u = Ne(n), { isVirtualized: s } = U(Ze), { rowProps: d, gridCellProps: c, descriptionProps: f, ...b } = Kv({
    node: r,
    shouldSelectOnPressUp: !!i,
    isVirtualized: s
  }, a, u), { hoverProps: p, isHovered: h } = Ie({
    isDisabled: !b.allowsSelection && !b.hasAction,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { isFocusVisible: m, focusProps: v } = Fe(), { checkboxProps: y } = pC({
    key: r.key
  }, a), w = a.selectionManager.disabledBehavior === "all" && b.isDisabled ? {
    isDisabled: !0
  } : {}, C = null;
  i && l && (C = l.useDraggableItem({
    key: r.key,
    hasDragButton: !0
  }, i));
  let D = null, P = j(null), { visuallyHiddenProps: R } = sn();
  o && l && (D = l.useDropIndicator({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, o, P));
  let V = i && i.isDragging(r.key), L = ne({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-GridListItem",
    values: {
      ...b,
      isHovered: h,
      isFocusVisible: m,
      selectionMode: a.selectionManager.selectionMode,
      selectionBehavior: a.selectionManager.selectionBehavior,
      allowsDragging: !!i,
      isDragging: V,
      isDropTarget: D == null ? void 0 : D.isDropTarget
    }
  }), A = j(null);
  return re(() => {
    i && !A.current && console.warn('Draggable items in a GridList must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
  }, []), re(() => {
    r.textValue || console.warn("A `textValue` prop is required for <GridListItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]), /* @__PURE__ */ x.createElement(x.Fragment, null, D && !D.isHidden && /* @__PURE__ */ x.createElement("div", {
    role: "row",
    style: {
      position: "absolute"
    }
  }, /* @__PURE__ */ x.createElement("div", {
    role: "gridcell"
  }, /* @__PURE__ */ x.createElement("div", {
    role: "button",
    ...R,
    ...D == null ? void 0 : D.dropIndicatorProps,
    ref: P
  }))), /* @__PURE__ */ x.createElement("div", {
    ..._(J(t), d, v, p, C == null ? void 0 : C.dragProps),
    ...L,
    ref: u,
    "data-selected": b.isSelected || void 0,
    "data-disabled": b.isDisabled || void 0,
    "data-hovered": h || void 0,
    "data-focused": b.isFocused || void 0,
    "data-focus-visible": m || void 0,
    "data-pressed": b.isPressed || void 0,
    "data-allows-dragging": !!i || void 0,
    "data-dragging": V || void 0,
    "data-drop-target": (D == null ? void 0 : D.isDropTarget) || void 0,
    "data-selection-mode": a.selectionManager.selectionMode === "none" ? void 0 : a.selectionManager.selectionMode
  }, /* @__PURE__ */ x.createElement("div", {
    ...c,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Si,
        {
          slots: {
            [rn]: {},
            selection: y
          }
        }
      ],
      [
        Pt,
        {
          slots: {
            [rn]: w,
            drag: {
              ...C == null ? void 0 : C.dragButtonProps,
              ref: A,
              style: {
                pointerEvents: "none"
              }
            }
          }
        }
      ],
      [
        ut,
        {
          slots: {
            [rn]: {},
            description: f
          }
        }
      ],
      [
        Ze,
        da
      ],
      [
        zt,
        null
      ]
    ]
  }, L.children))));
});
function wE(e, t) {
  t = Ne(t);
  let { dragAndDropHooks: n, dropState: r } = U(tn), a = j(null), { dropIndicatorProps: l, isHidden: i, isDropTarget: o } = n.useDropIndicator(e, r, a);
  return i ? null : /* @__PURE__ */ x.createElement(kE, {
    ...e,
    dropIndicatorProps: l,
    isDropTarget: o,
    buttonRef: a,
    ref: t
  });
}
function PE(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, buttonRef: a, ...l } = e, { visuallyHiddenProps: i } = sn(), o = ne({
    ...l,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...o,
    role: "row",
    ref: t,
    "data-drop-target": r || void 0
  }, /* @__PURE__ */ x.createElement("div", {
    role: "gridcell"
  }, /* @__PURE__ */ x.createElement("div", {
    ...i,
    role: "button",
    ...n,
    ref: a
  }), o.children));
}
const kE = /* @__PURE__ */ ee(PE);
function SE() {
  let { dragAndDropHooks: e, dropState: t } = U(tn), n = j(null), { dropIndicatorProps: r } = e.useDropIndicator({
    target: {
      type: "root"
    }
  }, t, n), a = t.isDropTarget({
    type: "root"
  }), { visuallyHiddenProps: l } = sn();
  return !a && r["aria-hidden"] ? null : /* @__PURE__ */ x.createElement("div", {
    role: "row",
    "aria-hidden": r["aria-hidden"],
    style: {
      position: "absolute"
    }
  }, /* @__PURE__ */ x.createElement("div", {
    role: "gridcell"
  }, /* @__PURE__ */ x.createElement("div", {
    role: "button",
    ...l,
    ...r,
    ref: n
  })));
}
const Rs = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Bi);
  let { children: r, level: a = 3, className: l, ...i } = t, o = `h${a}`;
  return /* @__PURE__ */ x.createElement(o, {
    ...i,
    ref: n,
    className: l ?? "react-aria-Heading"
  }, r);
}), BE = /* @__PURE__ */ G(null), FE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, BE);
  let { value: r = 0, minValue: a = 0, maxValue: l = 100 } = t;
  r = Qe(r, a, l);
  let [i, o] = tt(!t["aria-label"] && !t["aria-labelledby"]), { meterProps: u, labelProps: s } = hC({
    ...t,
    label: o
  }), d = (r - a) / (l - a) * 100, c = ne({
    ...t,
    defaultClassName: "react-aria-Meter",
    values: {
      percentage: d,
      valueText: u["aria-valuetext"]
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...u,
    ...c,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ x.createElement(dt.Provider, {
    value: {
      ...s,
      ref: i,
      elementType: "span"
    }
  }, c.children));
}), AE = /* @__PURE__ */ G(null), Ms = /* @__PURE__ */ G(null), TE = /* @__PURE__ */ ee(function(t, n) {
  if (U(Ms)) return /* @__PURE__ */ x.createElement(Ac, {
    ...t,
    modalRef: n
  }, t.children);
  let { isDismissable: a, isKeyboardDismissDisabled: l, isOpen: i, defaultOpen: o, onOpenChange: u, children: s, isEntering: d, isExiting: c, UNSTABLE_portalContainer: f, shouldCloseOnInteractOutside: b, ...p } = t;
  return /* @__PURE__ */ x.createElement(Q1, {
    isDismissable: a,
    isKeyboardDismissDisabled: l,
    isOpen: i,
    defaultOpen: o,
    onOpenChange: u,
    isEntering: d,
    isExiting: c,
    UNSTABLE_portalContainer: f,
    shouldCloseOnInteractOutside: b
  }, /* @__PURE__ */ x.createElement(Ac, {
    ...p,
    modalRef: n
  }, s));
});
function RE(e, t) {
  [e, t] = oe(e, t, AE);
  let n = U(xn), r = jn(e), a = e.isOpen != null || e.defaultOpen != null || !n ? r : n, l = Ne(t), i = j(null), o = jl(l, a.isOpen), u = jl(i, a.isOpen), s = o || u || e.isExiting || !1, d = vn();
  return !a.isOpen && !s || d ? null : /* @__PURE__ */ x.createElement(ME, {
    ...e,
    state: a,
    isExiting: s,
    overlayRef: l,
    modalRef: i
  });
}
const Q1 = /* @__PURE__ */ ee(RE);
function ME({ UNSTABLE_portalContainer: e, ...t }) {
  let n = t.modalRef, { state: r } = t, { modalProps: a, underlayProps: l } = F7(t, r, n), i = pi(t.overlayRef) || t.isEntering || !1, o = ne({
    ...t,
    defaultClassName: "react-aria-ModalOverlay",
    values: {
      isEntering: i,
      isExiting: t.isExiting,
      state: r
    }
  }), u = Xx(), s = {
    ...o.style,
    "--visual-viewport-height": u.height + "px"
  };
  return /* @__PURE__ */ x.createElement(ou, {
    isExiting: t.isExiting,
    portalContainer: e
  }, /* @__PURE__ */ x.createElement("div", {
    ..._(J(t), l),
    ...o,
    style: s,
    ref: t.overlayRef,
    "data-entering": i || void 0,
    "data-exiting": t.isExiting || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Ms,
        {
          modalProps: a,
          modalRef: n,
          isExiting: t.isExiting,
          isDismissable: t.isDismissable
        }
      ],
      [
        xn,
        r
      ]
    ]
  }, o.children)));
}
function Ac(e) {
  let { modalProps: t, modalRef: n, isExiting: r, isDismissable: a } = U(Ms), l = U(xn), i = H(() => gn(e.modalRef, n), [
    e.modalRef,
    n
  ]), o = Ne(i), u = pi(o), s = ne({
    ...e,
    defaultClassName: "react-aria-Modal",
    values: {
      isEntering: u,
      isExiting: r,
      state: l
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ..._(J(e), t),
    ...s,
    ref: o,
    "data-entering": u || void 0,
    "data-exiting": r || void 0
  }, a && /* @__PURE__ */ x.createElement(iu, {
    onDismiss: l.close
  }), s.children);
}
const NE = /* @__PURE__ */ G(null), VE = /* @__PURE__ */ G(null), IE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, NE);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", { locale: o } = me(), u = I0({
    ...t,
    locale: o,
    validationBehavior: i
  }), s = j(null), [d, c] = tt(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: f, groupProps: b, inputProps: p, incrementButtonProps: h, decrementButtonProps: m, descriptionProps: v, errorMessageProps: y, ...w } = ih({
    ...yt(t),
    label: c,
    validationBehavior: i
  }, u, s), C = ne({
    ...t,
    values: {
      state: u,
      isDisabled: t.isDisabled || !1,
      isInvalid: w.isInvalid || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), D = J(t);
  return delete D.id, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        VE,
        u
      ],
      [
        Ln,
        b
      ],
      [
        ln,
        {
          ...p,
          ref: s
        }
      ],
      [
        dt,
        {
          ...f,
          ref: d
        }
      ],
      [
        Pt,
        {
          slots: {
            increment: h,
            decrement: m
          }
        }
      ],
      [
        ut,
        {
          slots: {
            description: v,
            errorMessage: y
          }
        }
      ],
      [
        Mt,
        w
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...D,
    ...C,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-required": t.isRequired || void 0,
    "data-invalid": w.isInvalid || void 0
  }), t.name && /* @__PURE__ */ x.createElement("input", {
    type: "hidden",
    name: t.name,
    value: isNaN(u.numberValue) ? "" : u.numberValue
  }));
}), OE = /* @__PURE__ */ G(null), zE = /* @__PURE__ */ G(null), e5 = /* @__PURE__ */ G(null), KE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, OE);
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = t.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = N8({
    ...t,
    validationBehavior: i
  }), [u, s] = tt(!t["aria-label"] && !t["aria-labelledby"]), { radioGroupProps: d, labelProps: c, descriptionProps: f, errorMessageProps: b, ...p } = vC({
    ...t,
    label: s,
    validationBehavior: i
  }, o), h = ne({
    ...t,
    values: {
      orientation: t.orientation || "vertical",
      isDisabled: o.isDisabled,
      isReadOnly: o.isReadOnly,
      isRequired: o.isRequired,
      isInvalid: o.isInvalid,
      state: o
    },
    defaultClassName: "react-aria-RadioGroup"
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...d,
    ...h,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "vertical",
    "data-invalid": o.isInvalid || void 0,
    "data-disabled": o.isDisabled || void 0,
    "data-readonly": o.isReadOnly || void 0,
    "data-required": o.isRequired || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        e5,
        o
      ],
      [
        dt,
        {
          ...c,
          ref: u,
          elementType: "span"
        }
      ],
      [
        ut,
        {
          slots: {
            description: f,
            errorMessage: b
          }
        }
      ],
      [
        Mt,
        p
      ]
    ]
  }, h.children));
}), jE = /* @__PURE__ */ ee(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, zE);
  let l = x.useContext(e5), i = Ne(gn(r, t.inputRef !== void 0 ? t.inputRef : null)), { labelProps: o, inputProps: u, isSelected: s, isDisabled: d, isPressed: c } = mC({
    ...yt(t),
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, l, i), { isFocused: f, isFocusVisible: b, focusProps: p } = Fe(), h = d || l.isReadOnly, { hoverProps: m, isHovered: v } = Ie({
    ...t,
    isDisabled: h
  }), y = ne({
    ...t,
    defaultClassName: "react-aria-Radio",
    values: {
      isSelected: s,
      isPressed: c,
      isHovered: v,
      isFocused: f,
      isFocusVisible: b,
      isDisabled: d,
      isReadOnly: l.isReadOnly,
      isInvalid: l.isInvalid,
      isRequired: l.isRequired
    }
  }), w = J(t);
  return delete w.id, /* @__PURE__ */ x.createElement("label", {
    ..._(w, o, m, y),
    ref: n,
    "data-selected": s || void 0,
    "data-pressed": c || void 0,
    "data-hovered": v || void 0,
    "data-focused": f || void 0,
    "data-focus-visible": b || void 0,
    "data-disabled": d || void 0,
    "data-readonly": l.isReadOnly || void 0,
    "data-invalid": l.isInvalid || void 0,
    "data-required": l.isRequired || void 0
  }, /* @__PURE__ */ x.createElement(Vn, {
    elementType: "span"
  }, /* @__PURE__ */ x.createElement("input", {
    ..._(u, p),
    ref: i
  })), y.children);
});
function LE(e) {
  return e && e.__esModule ? e.default : e;
}
const Ns = /* @__PURE__ */ G(null), t5 = /* @__PURE__ */ G(null), HE = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Ns);
  let { children: r, isDisabled: a = !1, isInvalid: l = !1, isRequired: i = !1 } = t, o = H(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: a,
    isInvalid: l,
    isRequired: i,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    a,
    l,
    i
  ]);
  return /* @__PURE__ */ x.createElement(Kn, {
    content: o
  }, (u) => /* @__PURE__ */ x.createElement(_E, {
    props: t,
    collection: u,
    selectRef: n
  }));
});
function _E({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = Ge(Rt) || {};
  var a, l;
  let i = (l = (a = e.validationBehavior) !== null && a !== void 0 ? a : r) !== null && l !== void 0 ? l : "native", o = I8({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: i
  }), { isFocusVisible: u, focusProps: s } = Fe({
    within: !0
  }), d = j(null), [c, f] = tt(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: b, triggerProps: p, valueProps: h, menuProps: m, descriptionProps: v, errorMessageProps: y, ...w } = $C({
    ...yt(e),
    label: f,
    validationBehavior: i
  }, o, d), [C, D] = q(null), P = ie(() => {
    d.current && D(d.current.offsetWidth + "px");
  }, [
    d
  ]);
  Pr({
    ref: d,
    onResize: P
  });
  let R = H(() => ({
    isOpen: o.isOpen,
    isFocused: o.isFocused,
    isFocusVisible: u,
    isDisabled: e.isDisabled || !1,
    isInvalid: w.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    o.isOpen,
    o.isFocused,
    u,
    e.isDisabled,
    w.isInvalid,
    e.isRequired
  ]), V = ne({
    ...e,
    values: R,
    defaultClassName: "react-aria-Select"
  }), L = J(e);
  delete L.id;
  let A = j(null);
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Ns,
        e
      ],
      [
        t5,
        o
      ],
      [
        n5,
        h
      ],
      [
        dt,
        {
          ...b,
          ref: c,
          elementType: "span"
        }
      ],
      [
        Pt,
        {
          ...p,
          ref: d,
          isPressed: o.isOpen
        }
      ],
      [
        xn,
        o
      ],
      [
        Mr,
        {
          trigger: "Select",
          triggerRef: d,
          scrollRef: A,
          placement: "bottom start",
          style: {
            "--trigger-width": C
          },
          "aria-labelledby": m["aria-labelledby"]
        }
      ],
      [
        cl,
        {
          ...m,
          ref: A
        }
      ],
      [
        zt,
        o
      ],
      [
        ut,
        {
          slots: {
            description: v,
            errorMessage: y
          }
        }
      ],
      [
        Mt,
        w
      ]
    ]
  }, /* @__PURE__ */ x.createElement("div", {
    ...L,
    ...V,
    ...s,
    ref: t,
    slot: e.slot || void 0,
    "data-focused": o.isFocused || void 0,
    "data-focus-visible": u || void 0,
    "data-open": o.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": w.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }), /* @__PURE__ */ x.createElement(DC, {
    autoComplete: e.autoComplete,
    state: o,
    triggerRef: d,
    label: f,
    name: e.name,
    isDisabled: e.isDisabled
  }));
}
const n5 = /* @__PURE__ */ G(null), UE = /* @__PURE__ */ ee(function(t, n) {
  var r, a;
  [t, n] = oe(t, n, n5);
  let l = U(t5), { placeholder: i } = Ge(Ns), o = l.selectedKey != null ? l.collection.getItem(l.selectedKey) : null, u = o == null ? void 0 : o.props.children;
  typeof u == "function" && (u = u({
    isHovered: !1,
    isPressed: !1,
    isSelected: !1,
    isFocused: !1,
    isFocusVisible: !1,
    isDisabled: !1,
    selectionMode: "single",
    selectionBehavior: "toggle"
  }));
  let s = Oe(LE(Oi), "react-aria-components");
  var d, c, f;
  let b = ne({
    ...t,
    defaultChildren: (d = u ?? i) !== null && d !== void 0 ? d : s.format("selectPlaceholder"),
    defaultClassName: "react-aria-SelectValue",
    values: {
      selectedItem: (c = (r = l.selectedItem) === null || r === void 0 ? void 0 : r.value) !== null && c !== void 0 ? c : null,
      selectedText: (f = (a = l.selectedItem) === null || a === void 0 ? void 0 : a.textValue) !== null && f !== void 0 ? f : null,
      isPlaceholder: !o
    }
  }), p = J(t);
  return /* @__PURE__ */ x.createElement("span", {
    ref: n,
    ...p,
    ...b,
    "data-placeholder": !o || void 0
  }, /* @__PURE__ */ x.createElement(ut.Provider, {
    value: void 0
  }, b.children));
}), WE = /* @__PURE__ */ G(null), GE = /* @__PURE__ */ ee(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, WE);
  let l = Ne(gn(r, t.inputRef !== void 0 ? t.inputRef : null)), i = Ci(t), { labelProps: o, inputProps: u, isSelected: s, isDisabled: d, isReadOnly: c, isPressed: f } = EC({
    ...yt(t),
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, i, l), { isFocused: b, isFocusVisible: p, focusProps: h } = Fe(), m = t.isDisabled || t.isReadOnly, { hoverProps: v, isHovered: y } = Ie({
    ...t,
    isDisabled: m
  }), w = ne({
    ...t,
    defaultClassName: "react-aria-Switch",
    values: {
      isSelected: s,
      isPressed: f,
      isHovered: y,
      isFocused: b,
      isFocusVisible: p,
      isDisabled: d,
      isReadOnly: c,
      state: i
    }
  }), C = J(t);
  return delete C.id, /* @__PURE__ */ x.createElement("label", {
    ..._(C, o, v, w),
    ref: n,
    slot: t.slot || void 0,
    "data-selected": s || void 0,
    "data-pressed": f || void 0,
    "data-hovered": y || void 0,
    "data-focused": b || void 0,
    "data-focus-visible": p || void 0,
    "data-disabled": d || void 0,
    "data-readonly": c || void 0
  }, /* @__PURE__ */ x.createElement(Vn, {
    elementType: "span"
  }, /* @__PURE__ */ x.createElement("input", {
    ..._(u, h),
    ref: l
  })), w.children);
});
function ZE(e) {
  return e && e.__esModule ? e.default : e;
}
class YE extends Fi {
  addNode(t) {
    super.addNode(t), this.columnsDirty || (this.columnsDirty = t.type === "column"), t.type === "tableheader" && (this.head = t), t.type === "tablebody" && (this.body = t);
  }
  commit(t, n, r = !1) {
    this.updateColumns(r), this.rows = [];
    for (let i of this.getChildren(this.body.key)) {
      let o = i.lastChildKey;
      if (o != null) {
        let u = this.getItem(o);
        var a, l;
        let s = ((a = u.colIndex) !== null && a !== void 0 ? a : u.index) + ((l = u.colSpan) !== null && l !== void 0 ? l : 1);
        if (s !== this.columns.length && !r) throw new Error(`Cell count must match column count. Found ${s} cells and ${this.columns.length} columns.`);
      }
      this.rows.push(i);
    }
    super.commit(t, n, r);
  }
  updateColumns(t) {
    if (!this.columnsDirty) return;
    this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.columns = [];
    let n = /* @__PURE__ */ new Map(), r = (a) => {
      switch (a.type) {
        case "column":
          n.set(a.key, a), a.hasChildNodes || (a.index = this.columns.length, this.columns.push(a), a.props.isRowHeader && this.rowHeaderColumnKeys.add(a.key));
          break;
      }
      for (let l of this.getChildren(a.key)) r(l);
    };
    for (let a of this.getChildren(this.head.key)) r(a);
    if (this.headerRows = Z$(n, this.columns), this.columnsDirty = !1, this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !t) throw new Error("A table must have at least one Column with the isRowHeader prop set to true");
  }
  get columnCount() {
    return this.columns.length;
  }
  *[Symbol.iterator]() {
    this.head.key !== -1 && (yield this.head, yield this.body);
  }
  get size() {
    return this.rows.length;
  }
  getFirstKey() {
    return this.body.firstChildKey;
  }
  getLastKey() {
    return this.body.lastChildKey;
  }
  getKeyAfter(t) {
    let n = this.getItem(t);
    var r;
    return (n == null ? void 0 : n.type) === "column" ? (r = n.nextKey) !== null && r !== void 0 ? r : null : super.getKeyAfter(t);
  }
  getKeyBefore(t) {
    var n;
    let r = this.getItem(t);
    var a;
    if ((r == null ? void 0 : r.type) === "column") return (a = r.prevKey) !== null && a !== void 0 ? a : null;
    let l = super.getKeyBefore(t);
    return l != null && ((n = this.getItem(l)) === null || n === void 0 ? void 0 : n.type) === "tablebody" ? null : l;
  }
  getChildren(t) {
    if (!this.getItem(t)) {
      for (let n of this.headerRows)
        if (n.key === t) return n.childNodes;
    }
    return super.getChildren(t);
  }
  clone() {
    let t = super.clone();
    return t.headerRows = this.headerRows, t.columns = this.columns, t.rowHeaderColumnKeys = this.rowHeaderColumnKeys, t.head = this.head, t.body = this.body, t;
  }
  getTextValue(t) {
    let n = this.getItem(t);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys, a = [];
    for (let l of this.getChildren(t)) {
      let i = this.columns[l.index];
      if (r.has(i.key) && l.textValue && a.push(l.textValue), a.length === r.size) break;
    }
    return a.join(" ");
  }
  constructor(...t) {
    super(...t), this.headerRows = [], this.columns = [], this.rows = [], this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.head = new Ga("tableheader", -1), this.body = new Ga("tablebody", -2), this.columnsDirty = !0;
  }
}
const Vs = /* @__PURE__ */ G(null), qE = /* @__PURE__ */ ee(function(t, n) {
  let r = Ne(n), a = j(null), l = j(null), [i, o] = q(0);
  Ce(() => {
    let s = a.current;
    for (; s && s !== r.current && !ea(s); ) s = s.parentElement;
    l.current = s;
  }, [
    r
  ]), Pr({
    ref: l,
    box: "border-box",
    onResize() {
      var s, d;
      o((d = (s = l.current) === null || s === void 0 ? void 0 : s.clientWidth) !== null && d !== void 0 ? d : 0);
    }
  }), Ce(() => {
    var s, d;
    o((d = (s = l.current) === null || s === void 0 ? void 0 : s.clientWidth) !== null && d !== void 0 ? d : 0);
  }, []);
  let u = H(() => ({
    tableRef: a,
    scrollRef: l,
    tableWidth: i,
    useTableColumnResizeState: H8,
    onResizeStart: t.onResizeStart,
    onResize: t.onResize,
    onResizeEnd: t.onResizeEnd
  }), [
    a,
    i,
    t.onResizeStart,
    t.onResize,
    t.onResizeEnd
  ]);
  return /* @__PURE__ */ x.createElement("div", {
    ...J(t),
    ref: r,
    className: t.className || "react-aria-ResizableTableContainer",
    style: t.style,
    onScroll: t.onScroll
  }, /* @__PURE__ */ x.createElement(Vs.Provider, {
    value: u
  }, t.children));
}), XE = /* @__PURE__ */ G(null), sr = /* @__PURE__ */ G(null), Is = /* @__PURE__ */ G(null), JE = /* @__PURE__ */ ee(function(t, n) {
  var r;
  [t, n] = oe(t, n, XE);
  let a = dl(t), { selectionBehavior: l, selectionMode: i, disallowEmptySelection: o } = a, u = !!(!((r = t.dragAndDropHooks) === null || r === void 0) && r.useDraggableCollectionState), s = H(() => ({
    selectionBehavior: i === "none" ? null : l,
    selectionMode: i,
    disallowEmptySelection: o,
    allowsDragging: u
  }), [
    l,
    i,
    o,
    u
  ]), d = /* @__PURE__ */ x.createElement(r5.Provider, {
    value: s
  }, /* @__PURE__ */ x.createElement(Lt, t));
  return /* @__PURE__ */ x.createElement(Kn, {
    content: d,
    createCollection: () => new YE()
  }, (c) => /* @__PURE__ */ x.createElement(QE, {
    props: t,
    forwardedRef: n,
    selectionState: a,
    collection: c
  }));
});
function QE({ props: e, forwardedRef: t, selectionState: n, collection: r }) {
  let a = U(Vs);
  t = Ne(H(() => gn(t, a == null ? void 0 : a.tableRef), [
    t,
    a == null ? void 0 : a.tableRef
  ]));
  let l = Z8({
    ...e,
    collection: r,
    children: void 0,
    UNSAFE_selectionState: n
  }), { isVirtualized: i, layoutDelegate: o, dropTargetDelegate: u, CollectionRoot: s } = U(Ze), { dragAndDropHooks: d } = e, { gridProps: c } = kC({
    ...e,
    layoutDelegate: o,
    isVirtualized: i
  }, l, t), f = l.selectionManager, b = !!(d != null && d.useDraggableCollectionState), p = !!(d != null && d.useDroppableCollectionState), h = j(b), m = j(p);
  re(() => {
    h.current !== b && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), m.current !== p && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    b,
    p
  ]);
  let v, y, w, C = !1, D = null, P = j(null);
  if (b && d) {
    v = d.useDraggableCollectionState({
      collection: r,
      selectionManager: f,
      preview: d.renderDragPreview ? P : void 0
    }), d.useDraggableCollection({}, v, t);
    let g = d.DragPreview;
    D = d.renderDragPreview ? /* @__PURE__ */ x.createElement(g, {
      ref: P
    }, d.renderDragPreview) : null;
  }
  if (p && d) {
    y = d.useDroppableCollectionState({
      collection: r,
      selectionManager: f
    });
    let g = new lr({
      collection: r,
      disabledKeys: f.disabledKeys,
      disabledBehavior: f.disabledBehavior,
      ref: t,
      layoutDelegate: o
    }), B = d.dropTargetDelegate || u || new d.ListDropTargetDelegate(r.rows, t);
    w = d.useDroppableCollection({
      keyboardDelegate: g,
      dropTargetDelegate: B
    }, y, t), C = y.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: R, isFocused: V, isFocusVisible: L } = Fe(), A = ne({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-Table",
    values: {
      isDropTarget: C,
      isFocused: V,
      isFocusVisible: L,
      state: l
    }
  }), $ = !!(b && !(v != null && v.isDisabled)), S = A.style, T = null;
  a && (T = a.useTableColumnResizeState({
    tableWidth: a.tableWidth
  }, l), i || (S = {
    ...S,
    tableLayout: "fixed",
    width: "fit-content"
  }));
  let M = on("table");
  var K;
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        sr,
        l
      ],
      [
        Is,
        T
      ],
      [
        tn,
        {
          dragAndDropHooks: d,
          dragState: v,
          dropState: y
        }
      ],
      [
        zi,
        {
          render: lw
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(rl, null, /* @__PURE__ */ x.createElement(M, {
    ...J(e),
    ...A,
    ..._(c, R, w == null ? void 0 : w.collectionProps),
    style: S,
    ref: t,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-allows-dragging": $ || void 0,
    "data-drop-target": C || void 0,
    "data-focused": V || void 0,
    "data-focus-visible": L || void 0
  }, /* @__PURE__ */ x.createElement(s, {
    collection: r,
    scrollRef: (K = a == null ? void 0 : a.scrollRef) !== null && K !== void 0 ? K : t,
    persistedKeys: Es(f, d, y)
  }))), D);
}
function on(e) {
  let { isVirtualized: t } = U(Ze);
  return t ? "div" : e;
}
const r5 = /* @__PURE__ */ G(null);
function a5() {
  return U(r5);
}
const ew = /* @__PURE__ */ Ai("tableheader", (e, t) => {
  let n = U(sr).collection, r = hs({
    items: n.headerRows,
    children: ie((s) => {
      switch (s.type) {
        case "headerrow":
          return /* @__PURE__ */ x.createElement(tw, {
            item: s
          });
        default:
          throw new Error("Unsupported node type in TableHeader: " + s.type);
      }
    }, [])
  }), a = on("thead"), { rowGroupProps: l } = OC(), { hoverProps: i, isHovered: o } = Ie({
    onHoverStart: e.onHoverStart,
    onHoverChange: e.onHoverChange,
    onHoverEnd: e.onHoverEnd
  }), u = ne({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-TableHeader",
    values: {
      isHovered: o
    }
  });
  return /* @__PURE__ */ x.createElement(a, {
    ..._(J(e), l, i),
    ...u,
    ref: t,
    "data-hovered": o || void 0
  }, r);
}, (e) => /* @__PURE__ */ x.createElement(Lt, {
  dependencies: e.dependencies,
  items: e.columns
}, e.children));
function tw({ item: e }) {
  let t = j(null), n = U(sr), { isVirtualized: r, CollectionBranch: a } = U(Ze), { rowProps: l } = AC({
    node: e,
    isVirtualized: r
  }, n, t), { checkboxProps: i } = NC(n), o = on("tr");
  return /* @__PURE__ */ x.createElement(o, {
    ...l,
    ref: t
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Si,
        {
          slots: {
            selection: i
          }
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(a, {
    collection: n.collection,
    parent: e
  })));
}
const l5 = /* @__PURE__ */ dn("column", (e, t, n) => {
  var r, a;
  let l = Ne(t), i = U(sr), { isVirtualized: o } = U(Ze), { columnHeaderProps: u } = BC({
    node: n,
    isVirtualized: o
  }, i, l), { isFocused: s, isFocusVisible: d, focusProps: c } = Fe(), f = U(Is), b = !1;
  if (f) b = f.resizingColumn === n.key;
  else
    for (let w in [
      "width",
      "defaultWidth",
      "minWidth",
      "maxWidth"
    ]) w in n.props && console.warn(`The ${w} prop on a <Column> only applies when a <Table> is wrapped in a <ResizableTableContainer>. If you aren't using column resizing, you can set the width of a column with CSS.`);
  let { hoverProps: p, isHovered: h } = Ie({
    isDisabled: !e.allowsSorting
  }), m = ne({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Column",
    values: {
      isHovered: h,
      isFocused: s,
      isFocusVisible: d,
      allowsSorting: n.props.allowsSorting,
      sortDirection: ((r = i.sortDescriptor) === null || r === void 0 ? void 0 : r.column) === n.key ? i.sortDescriptor.direction : void 0,
      isResizing: b,
      startResize: () => {
        if (f)
          f.startResize(n.key), i.setKeyboardNavigationDisabled(!0);
        else throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
      },
      sort: (w) => {
        i.sort(n.key, w);
      }
    }
  }), v = m.style;
  f && (v = {
    ...v,
    width: f.getColumnWidth(n.key)
  });
  let y = on("th");
  return /* @__PURE__ */ x.createElement(y, {
    ..._(J(e), u, c, p),
    ...m,
    style: v,
    ref: l,
    "data-hovered": h || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": d || void 0,
    "data-resizing": b || void 0,
    "data-allows-sorting": n.props.allowsSorting || void 0,
    "data-sort-direction": ((a = i.sortDescriptor) === null || a === void 0 ? void 0 : a.column) === n.key ? i.sortDescriptor.direction : void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        i5,
        {
          column: n,
          triggerRef: l
        }
      ],
      [
        Ze,
        da
      ]
    ]
  }, m.children));
}), i5 = /* @__PURE__ */ G(null), nw = /* @__PURE__ */ ee(function(t, n) {
  let r = U(Is);
  if (!r) throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
  let a = Oe(ZE(Oi), "react-aria-components"), { onResizeStart: l, onResize: i, onResizeEnd: o } = U(Vs), { column: u, triggerRef: s } = U(i5), d = j(null), { resizerProps: c, inputProps: f, isResizing: b } = IC({
    column: u,
    "aria-label": t["aria-label"] || a.format("tableResizer"),
    onResizeStart: l,
    onResize: i,
    onResizeEnd: o,
    triggerRef: s
  }, r, d), { focusProps: p, isFocused: h, isFocusVisible: m } = Fe(), { hoverProps: v, isHovered: y } = Ie(t), w = r.getColumnMinWidth(u.key) >= r.getColumnWidth(u.key), C = r.getColumnMaxWidth(u.key) <= r.getColumnWidth(u.key), { direction: D } = me(), P = "both";
  w ? P = D === "rtl" ? "right" : "left" : C ? P = D === "rtl" ? "left" : "right" : P = "both";
  let R = Ne(n), [V, L] = q("");
  re(() => {
    if (!R.current) return;
    let M = window.getComputedStyle(R.current);
    L(M.cursor);
  }, [
    R,
    P
  ]);
  let A = ne({
    ...t,
    defaultClassName: "react-aria-ColumnResizer",
    values: {
      isFocused: h,
      isFocusVisible: m,
      isResizing: b,
      isHovered: y,
      resizableDirection: P
    }
  }), [$, S] = q(!1), T = (M) => {
    M.pointerType === "mouse" && S(!0);
  };
  return !b && $ && S(!1), /* @__PURE__ */ x.createElement("div", {
    ref: R,
    role: "presentation",
    ...J(t),
    ...A,
    ..._(c, {
      onPointerDown: T
    }, v),
    "data-hovered": y || void 0,
    "data-focused": h || void 0,
    "data-focus-visible": m || void 0,
    "data-resizing": b || void 0,
    "data-resizable-direction": P
  }, A.children, /* @__PURE__ */ x.createElement("input", {
    ref: d,
    ..._(f, p)
  }), b && $ && /* @__PURE__ */ Pu.createPortal(/* @__PURE__ */ x.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      cursor: V
    }
  }), document.body));
}), rw = /* @__PURE__ */ Ai("item", (e, t, n) => {
  let r = Ne(t), a = U(sr), { dragAndDropHooks: l, dragState: i, dropState: o } = U(tn), { isVirtualized: u, CollectionBranch: s } = U(Ze), { rowProps: d, ...c } = FC({
    node: n,
    shouldSelectOnPressUp: !!i,
    isVirtualized: u
  }, a, r), { isFocused: f, isFocusVisible: b, focusProps: p } = Fe(), { isFocusVisible: h, focusProps: m } = Fe({
    within: !0
  }), { hoverProps: v, isHovered: y } = Ie({
    isDisabled: !c.allowsSelection && !c.hasAction,
    onHoverStart: e.onHoverStart,
    onHoverChange: e.onHoverChange,
    onHoverEnd: e.onHoverEnd
  }), { checkboxProps: w } = MC({
    key: n.key
  }, a), C;
  i && l && (C = l.useDraggableItem({
    key: n.key,
    hasDragButton: !0
  }, i));
  let D, P = j(null), { visuallyHiddenProps: R } = sn();
  o && l && (D = l.useDropIndicator({
    target: {
      type: "item",
      key: n.key,
      dropPosition: "on"
    }
  }, o, P));
  let V = j(null);
  re(() => {
    i && !V.current && console.warn('Draggable items in a Table must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
  }, []);
  let L = i && i.isDragging(n.key), { children: A, ...$ } = e, S = ne({
    ...$,
    id: void 0,
    defaultClassName: "react-aria-Row",
    values: {
      ...c,
      isHovered: y,
      isFocused: f,
      isFocusVisible: b,
      selectionMode: a.selectionManager.selectionMode,
      selectionBehavior: a.selectionManager.selectionBehavior,
      isDragging: L,
      isDropTarget: D == null ? void 0 : D.isDropTarget,
      isFocusVisibleWithin: h,
      id: n.key
    }
  }), T = on("tr"), M = on("td");
  return /* @__PURE__ */ x.createElement(x.Fragment, null, D && !D.isHidden && /* @__PURE__ */ x.createElement(T, {
    role: "row",
    style: {
      height: 0
    }
  }, /* @__PURE__ */ x.createElement(M, {
    role: "gridcell",
    colSpan: a.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ x.createElement("div", {
    role: "button",
    ...R,
    ...D.dropIndicatorProps,
    ref: P
  }))), /* @__PURE__ */ x.createElement(T, {
    ..._(J(e), d, p, v, C == null ? void 0 : C.dragProps, m),
    ...S,
    ref: r,
    "data-disabled": c.isDisabled || void 0,
    "data-selected": c.isSelected || void 0,
    "data-hovered": y || void 0,
    "data-focused": c.isFocused || void 0,
    "data-focus-visible": b || void 0,
    "data-pressed": c.isPressed || void 0,
    "data-dragging": L || void 0,
    "data-drop-target": (D == null ? void 0 : D.isDropTarget) || void 0,
    "data-selection-mode": a.selectionManager.selectionMode === "none" ? void 0 : a.selectionManager.selectionMode,
    "data-focus-visible-within": h || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Si,
        {
          slots: {
            [rn]: {},
            selection: w
          }
        }
      ],
      [
        Pt,
        {
          slots: {
            [rn]: {},
            drag: {
              ...C == null ? void 0 : C.dragButtonProps,
              ref: V,
              style: {
                pointerEvents: "none"
              }
            }
          }
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(s, {
    collection: a.collection,
    parent: n
  }))));
}, (e) => {
  if (e.id == null && typeof e.children == "function") throw new Error("No id detected for the Row element. The Row element requires a id to be provided to it when the cells are rendered dynamically.");
  let t = [
    e.value
  ].concat(e.dependencies);
  return /* @__PURE__ */ x.createElement(Lt, {
    dependencies: t,
    items: e.columns,
    idScope: e.id
  }, e.children);
}), aw = /* @__PURE__ */ dn("cell", (e, t, n) => {
  let r = Ne(t), a = U(sr), { dragState: l } = U(tn), { isVirtualized: i } = U(Ze);
  n.column = a.collection.columns[n.index];
  let { gridCellProps: o, isPressed: u } = TC({
    node: n,
    shouldSelectOnPressUp: !!l,
    isVirtualized: i
  }, a, r), { isFocused: s, isFocusVisible: d, focusProps: c } = Fe(), { hoverProps: f, isHovered: b } = Ie({}), p = ne({
    ...e,
    id: void 0,
    defaultClassName: "react-aria-Cell",
    values: {
      isFocused: s,
      isFocusVisible: d,
      isPressed: u,
      isHovered: b,
      id: n.key
    }
  }), h = on("td");
  return /* @__PURE__ */ x.createElement(h, {
    ..._(J(e), o, c, f),
    ...p,
    ref: r,
    "data-focused": s || void 0,
    "data-focus-visible": d || void 0,
    "data-pressed": u || void 0
  }, /* @__PURE__ */ x.createElement(Ze.Provider, {
    value: da
  }, p.children));
});
function lw(e, t) {
  t = Ne(t);
  let { dragAndDropHooks: n, dropState: r } = U(tn), a = j(null), { dropIndicatorProps: l, isHidden: i, isDropTarget: o } = n.useDropIndicator(e, r, a);
  return i ? null : /* @__PURE__ */ x.createElement(ow, {
    ...e,
    dropIndicatorProps: l,
    isDropTarget: o,
    buttonRef: a,
    ref: t
  });
}
function iw(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, buttonRef: a, ...l } = e, i = U(sr), { visuallyHiddenProps: o } = sn(), u = ne({
    ...l,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  }), s = on("tr"), d = on("td");
  return /* @__PURE__ */ x.createElement(s, {
    ...J(e),
    ...u,
    role: "row",
    ref: t,
    "data-drop-target": r || void 0
  }, /* @__PURE__ */ x.createElement(d, {
    role: "gridcell",
    colSpan: i.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ x.createElement("div", {
    ...o,
    role: "button",
    ...n,
    ref: a
  }), u.children));
}
const ow = /* @__PURE__ */ ee(iw);
dn("loader", function(t, n, r) {
  let a = U(sr), { isVirtualized: l } = U(Ze), i = a.collection.columns.length, o = ne({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-TableLoadingIndicator",
    values: null
  }), u = on("tr"), s = on("td"), d = {}, c = {}, f = {};
  return l ? (d["aria-rowindex"] = a.collection.headerRows.length + a.collection.size, c["aria-colspan"] = i, f = {
    display: "contents"
  }) : c.colSpan = i, /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(u, {
    role: "row",
    ref: n,
    ..._(J(t), d),
    ...o
  }, /* @__PURE__ */ x.createElement(s, {
    role: "rowheader",
    ...c,
    style: f
  }, o.children)));
});
const Ui = /* @__PURE__ */ G(null), aa = /* @__PURE__ */ G(null), uw = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Ui);
  let { children: r, orientation: a = "horizontal" } = t;
  return r = H(() => typeof r == "function" ? r({
    orientation: a,
    defaultChildren: null
  }) : r, [
    r,
    a
  ]), /* @__PURE__ */ x.createElement(Kn, {
    content: r
  }, (l) => /* @__PURE__ */ x.createElement(sw, {
    props: t,
    collection: l,
    tabsRef: n
  }));
});
function sw({ props: e, tabsRef: t, collection: n }) {
  let { orientation: r = "horizontal" } = e, a = Y8({
    ...e,
    collection: n,
    children: void 0
  }), { focusProps: l, isFocused: i, isFocusVisible: o } = Fe({
    within: !0
  }), u = H(() => ({
    orientation: r,
    isFocusWithin: i,
    isFocusVisible: o
  }), [
    r,
    i,
    o
  ]), s = ne({
    ...e,
    defaultClassName: "react-aria-Tabs",
    values: u
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...J(e),
    ...l,
    ...s,
    ref: t,
    slot: e.slot || void 0,
    "data-focused": i || void 0,
    "data-orientation": r,
    "data-focus-visible": o || void 0,
    "data-disabled": a.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Ui,
        e
      ],
      [
        aa,
        a
      ]
    ]
  }, s.children));
}
const dw = /* @__PURE__ */ ee(function(t, n) {
  return U(aa) ? /* @__PURE__ */ x.createElement(cw, {
    props: t,
    forwardedRef: n
  }) : /* @__PURE__ */ x.createElement(Lt, t);
});
function cw({ props: e, forwardedRef: t }) {
  let n = U(aa), { CollectionRoot: r } = U(Ze), { orientation: a = "horizontal", keyboardActivation: l = "automatic" } = Ge(Ui), i = Ne(t), { tabListProps: o } = LC({
    ...e,
    orientation: a,
    keyboardActivation: l
  }, n, i), u = ne({
    ...e,
    children: null,
    defaultClassName: "react-aria-TabList",
    values: {
      orientation: a,
      state: n
    }
  }), s = J(e);
  return delete s.id, /* @__PURE__ */ x.createElement("div", {
    ...s,
    ...o,
    ref: i,
    ...u,
    "data-orientation": a || void 0
  }, /* @__PURE__ */ x.createElement(r, {
    collection: n.collection,
    persistedKeys: $s(n.selectionManager.focusedKey)
  }));
}
const fw = /* @__PURE__ */ dn("item", (e, t, n) => {
  let r = U(aa), a = Ne(t), { tabProps: l, isSelected: i, isDisabled: o, isPressed: u } = zC({
    key: n.key,
    ...e
  }, r, a), { focusProps: s, isFocused: d, isFocusVisible: c } = Fe(), { hoverProps: f, isHovered: b } = Ie({
    isDisabled: o,
    onHoverStart: e.onHoverStart,
    onHoverEnd: e.onHoverEnd,
    onHoverChange: e.onHoverChange
  }), p = ne({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tab",
    values: {
      isSelected: i,
      isDisabled: o,
      isFocused: d,
      isFocusVisible: c,
      isPressed: u,
      isHovered: b
    }
  }), h = n.props.href ? "a" : "div";
  return /* @__PURE__ */ x.createElement(h, {
    ..._(l, s, f, p),
    ref: a,
    "data-selected": i || void 0,
    "data-disabled": o || void 0,
    "data-focused": d || void 0,
    "data-focus-visible": c || void 0,
    "data-pressed": u || void 0,
    "data-hovered": b || void 0
  }, p.children);
}), bw = /* @__PURE__ */ ua(function(t, n) {
  const r = U(aa);
  let a = Ne(n), { tabPanelProps: l } = KC(t, r, a), { focusProps: i, isFocused: o, isFocusVisible: u } = Fe(), s = r.selectedKey === t.id, d = ne({
    ...t,
    defaultClassName: "react-aria-TabPanel",
    values: {
      isFocused: o,
      isFocusVisible: u,
      isInert: !s,
      state: r
    }
  });
  if (!s && !t.shouldForceMount) return null;
  let c = J(t);
  delete c.id;
  let f = s ? _(c, l, i, d) : d;
  return /* @__PURE__ */ x.createElement("div", {
    ...f,
    ref: a,
    "data-focused": o || void 0,
    "data-focus-visible": u || void 0,
    // @ts-ignore
    inert: e6(!s),
    "data-inert": s ? void 0 : "true"
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Ui,
        null
      ],
      [
        aa,
        null
      ]
    ]
  }, /* @__PURE__ */ x.createElement(Ze.Provider, {
    value: da
  }, d.children)));
}), pw = /* @__PURE__ */ G(null), o5 = /* @__PURE__ */ G(null), hw = /* @__PURE__ */ ee(function(t, n) {
  return [t, n] = oe(t, n, pw), /* @__PURE__ */ x.createElement(Kn, {
    content: t.children
  }, (r) => /* @__PURE__ */ x.createElement(mw, {
    props: t,
    forwardedRef: n,
    collection: r
  }));
});
function mw({ props: e, forwardedRef: t, collection: n }) {
  let r = j(null), [a, l] = tt(!e["aria-label"] && !e["aria-labelledby"]), i = Ti({
    ...e,
    children: void 0,
    collection: n
  }), o = J(e), u = Object.fromEntries(Object.entries(o).map(([p]) => [
    p,
    void 0
  ])), { gridProps: s, labelProps: d, descriptionProps: c, errorMessageProps: f } = HC({
    ...e,
    ...u,
    label: l
  }, i, r);
  var b;
  return /* @__PURE__ */ x.createElement("div", {
    ...o,
    ref: t,
    slot: e.slot || void 0,
    className: (b = e.className) !== null && b !== void 0 ? b : "react-aria-TagGroup",
    style: e.style
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        dt,
        {
          ...d,
          elementType: "span",
          ref: a
        }
      ],
      [
        o5,
        {
          ...s,
          ref: r
        }
      ],
      [
        zt,
        i
      ],
      [
        ut,
        {
          slots: {
            description: c,
            errorMessage: f
          }
        }
      ]
    ]
  }, e.children));
}
const vw = /* @__PURE__ */ ee(function(t, n) {
  return U(zt) ? /* @__PURE__ */ x.createElement(gw, {
    props: t,
    forwardedRef: n
  }) : /* @__PURE__ */ x.createElement(Lt, t);
});
function gw({ props: e, forwardedRef: t }) {
  let n = U(zt), { CollectionRoot: r } = U(Ze), [a, l] = oe(e, t, o5);
  delete a.items, delete a.renderEmptyState;
  let { focusProps: i, isFocused: o, isFocusVisible: u } = Fe(), s = {
    isEmpty: n.collection.size === 0,
    isFocused: o,
    isFocusVisible: u,
    state: n
  }, d = ne({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-TagList",
    values: s
  }), c = $s(n.selectionManager.focusedKey);
  return /* @__PURE__ */ x.createElement("div", {
    ..._(a, i),
    ...d,
    ref: l,
    "data-empty": n.collection.size === 0 || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": u || void 0
  }, n.collection.size === 0 && e.renderEmptyState ? e.renderEmptyState(s) : /* @__PURE__ */ x.createElement(r, {
    collection: n.collection,
    persistedKeys: c
  }));
}
const yw = /* @__PURE__ */ dn("item", (e, t, n) => {
  let r = U(zt), a = Ne(t), { focusProps: l, isFocusVisible: i } = Fe({
    within: !0
  }), { rowProps: o, gridCellProps: u, removeButtonProps: s, ...d } = UC({
    item: n
  }, r, a), { hoverProps: c, isHovered: f } = Ie({
    isDisabled: !d.allowsSelection,
    onHoverStart: n.props.onHoverStart,
    onHoverChange: n.props.onHoverChange,
    onHoverEnd: n.props.onHoverEnd
  }), b = ne({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tag",
    values: {
      ...d,
      isFocusVisible: i,
      isHovered: f,
      selectionMode: r.selectionManager.selectionMode,
      selectionBehavior: r.selectionManager.selectionBehavior
    }
  });
  return re(() => {
    n.textValue || console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
  }, [
    n.textValue
  ]), /* @__PURE__ */ x.createElement("div", {
    ref: a,
    ...b,
    ..._(J(e), o, l, c),
    "data-selected": d.isSelected || void 0,
    "data-disabled": d.isDisabled || void 0,
    "data-hovered": f || void 0,
    "data-focused": d.isFocused || void 0,
    "data-focus-visible": i || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-allows-removing": d.allowsRemoving || void 0,
    "data-selection-mode": r.selectionManager.selectionMode === "none" ? void 0 : r.selectionManager.selectionMode
  }, /* @__PURE__ */ x.createElement("div", {
    ...u,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Pt,
        {
          slots: {
            remove: s
          }
        }
      ],
      [
        Ze,
        da
      ]
    ]
  }, b.children)));
}), $w = /* @__PURE__ */ G({}), u5 = /* @__PURE__ */ G(null), xw = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, $w);
  let r = x2(t), { groupProps: a } = a2(t, r, n), l = ne({
    ...t,
    values: {
      isDisabled: r.isDisabled,
      state: r
    },
    defaultClassName: "react-aria-ToggleButtonGroup"
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...a,
    ...l,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "horizontal",
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ x.createElement(u5.Provider, {
    value: r
  }, l.children));
}), Dw = /* @__PURE__ */ G({}), Cw = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, Dw);
  let r = U(u5), a = Ci(r && t.id != null ? {
    isSelected: r.selectedKeys.has(t.id),
    onChange(h) {
      r.setSelected(t.id, h);
    }
  } : t), { buttonProps: l, isPressed: i, isSelected: o, isDisabled: u } = r && t.id != null ? l2({
    ...t,
    id: t.id
  }, r, n) : w4({
    ...t,
    id: t.id != null ? String(t.id) : void 0
  }, a, n), { focusProps: s, isFocused: d, isFocusVisible: c } = Fe(t), { hoverProps: f, isHovered: b } = Ie(t), p = ne({
    ...t,
    id: void 0,
    values: {
      isHovered: b,
      isPressed: i,
      isFocused: d,
      isSelected: a.isSelected,
      isFocusVisible: c,
      isDisabled: u,
      state: a
    },
    defaultClassName: "react-aria-ToggleButton"
  });
  return /* @__PURE__ */ x.createElement("button", {
    ..._(l, s, f),
    ...p,
    ref: n,
    slot: t.slot || void 0,
    "data-focused": d || void 0,
    "data-disabled": u || void 0,
    "data-pressed": i || void 0,
    "data-selected": o || void 0,
    "data-hovered": b || void 0,
    "data-focus-visible": c || void 0
  });
});
function Ew(e, t) {
  const { "aria-label": n, "aria-labelledby": r, orientation: a = "horizontal" } = e;
  let [l, i] = q(!1);
  Ce(() => {
    var p;
    i(!!(t.current && (!((p = t.current.parentElement) === null || p === void 0) && p.closest('[role="toolbar"]'))));
  });
  const { direction: o } = me(), u = o === "rtl" && a === "horizontal";
  let s = ia(t);
  const d = (p) => {
    if (p.currentTarget.contains(p.target)) {
      if (a === "horizontal" && p.key === "ArrowRight" || a === "vertical" && p.key === "ArrowDown")
        u ? s.focusPrevious() : s.focusNext();
      else if (a === "horizontal" && p.key === "ArrowLeft" || a === "vertical" && p.key === "ArrowUp")
        u ? s.focusNext() : s.focusPrevious();
      else if (p.key === "Tab") {
        p.stopPropagation(), c.current = document.activeElement, p.shiftKey ? s.focusFirst() : s.focusLast();
        return;
      } else
        return;
      p.stopPropagation(), p.preventDefault();
    }
  }, c = j(null), f = (p) => {
    !p.currentTarget.contains(p.relatedTarget) && !c.current && (c.current = p.target);
  }, b = (p) => {
    var h;
    if (c.current && !p.currentTarget.contains(p.relatedTarget) && (!((h = t.current) === null || h === void 0) && h.contains(p.target))) {
      var m;
      (m = c.current) === null || m === void 0 || m.focus(), c.current = null;
    }
  };
  return {
    toolbarProps: {
      ...J(e, {
        labelable: !0
      }),
      role: l ? "group" : "toolbar",
      "aria-orientation": a,
      "aria-label": n,
      "aria-labelledby": n == null ? r : void 0,
      onKeyDownCapture: l ? void 0 : d,
      onFocusCapture: l ? void 0 : b,
      onBlurCapture: l ? void 0 : f
    }
  };
}
const ww = /* @__PURE__ */ G({}), Pw = /* @__PURE__ */ ee(function(t, n) {
  [t, n] = oe(t, n, ww);
  let { toolbarProps: r } = Ew(t, n), a = ne({
    ...t,
    values: {
      orientation: t.orientation || "horizontal"
    },
    defaultClassName: "react-aria-Toolbar"
  }), l = J(t);
  return delete l.id, /* @__PURE__ */ x.createElement("div", {
    ..._(r, l),
    ...a,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "horizontal"
  }, a.children);
}), Os = /* @__PURE__ */ G(null), s5 = /* @__PURE__ */ G(null);
function kw(e) {
  let t = Y$(e), n = j(null), { triggerProps: r, tooltipProps: a } = GC(e, t, n);
  return /* @__PURE__ */ x.createElement($e, {
    values: [
      [
        Os,
        t
      ],
      [
        s5,
        {
          ...a,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(C6, {
    ...r,
    ref: n
  }, e.children));
}
const Sw = /* @__PURE__ */ ee(function({ UNSTABLE_portalContainer: t, ...n }, r) {
  [n, r] = oe(n, r, s5);
  let a = U(Os), l = Y$(n), i = n.isOpen != null || n.defaultOpen != null || !a ? l : a, o = jl(r, i.isOpen) || n.isExiting || !1;
  return !i.isOpen && !o ? null : /* @__PURE__ */ x.createElement(P7, {
    portalContainer: t
  }, /* @__PURE__ */ x.createElement(Bw, {
    ...n,
    tooltipRef: r,
    isExiting: o
  }));
});
function Bw(e) {
  let t = U(Os), n = j(null), [r, a] = q(0);
  Ce(() => {
    n.current && t.isOpen && a(n.current.getBoundingClientRect().width);
  }, [
    t.isOpen,
    n
  ]);
  let { overlayProps: l, arrowProps: i, placement: o } = _h({
    placement: e.placement || "top",
    targetRef: e.triggerRef,
    overlayRef: e.tooltipRef,
    offset: e.offset,
    crossOffset: e.crossOffset,
    isOpen: t.isOpen,
    arrowSize: r,
    arrowBoundaryOffset: e.arrowBoundaryOffset,
    shouldFlip: e.shouldFlip,
    onClose: () => t.close(!0)
  }), u = pi(e.tooltipRef, !!o) || e.isEntering || !1, s = ne({
    ...e,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: o,
      isEntering: u,
      isExiting: e.isExiting,
      state: t
    }
  });
  e = _(e, l);
  let { tooltipProps: d } = WC(e, t);
  return /* @__PURE__ */ x.createElement("div", {
    ...d,
    ref: e.tooltipRef,
    ...s,
    style: {
      ...l.style,
      ...s.style
    },
    "data-placement": o ?? void 0,
    "data-entering": u || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ x.createElement(As.Provider, {
    value: {
      ...i,
      placement: o,
      ref: n
    }
  }, s.children));
}
var Tc = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, St = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, Fw = (e, t) => JSON.stringify(e) === JSON.stringify(t);
function d5(e, t) {
  e.forEach(function(n) {
    Array.isArray(n) ? d5(n, t) : t.push(n);
  });
}
function c5(e) {
  let t = [];
  return d5(e, t), t;
}
var f5 = (...e) => c5(e).filter(Boolean), b5 = (e, t) => {
  let n = {}, r = Object.keys(e), a = Object.keys(t);
  for (let l of r) if (a.includes(l)) {
    let i = e[l], o = t[l];
    Array.isArray(i) || Array.isArray(o) ? n[l] = f5(o, i) : typeof i == "object" && typeof o == "object" ? n[l] = b5(i, o) : n[l] = o + " " + i;
  } else n[l] = e[l];
  for (let l of a) r.includes(l) || (n[l] = t[l]);
  return n;
}, Rc = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();
const zs = "-", Aw = (e) => {
  const t = Rw(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (i) => {
      const o = i.split(zs);
      return o[0] === "" && o.length !== 1 && o.shift(), p5(o, t) || Tw(i);
    },
    getConflictingClassGroupIds: (i, o) => {
      const u = n[i] || [];
      return o && r[i] ? [...u, ...r[i]] : u;
    }
  };
}, p5 = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? p5(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const l = e.join(zs);
  return (i = t.validators.find(({
    validator: o
  }) => o(l))) == null ? void 0 : i.classGroupId;
}, Mc = /^\[(.+)\]$/, Tw = (e) => {
  if (Mc.test(e)) {
    const t = Mc.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Rw = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Nw(Object.entries(e.classGroups), n).forEach(([l, i]) => {
    xu(i, r, l, t);
  }), r;
}, xu = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const l = a === "" ? t : Nc(t, a);
      l.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (Mw(a)) {
        xu(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([l, i]) => {
      xu(i, Nc(t, l), n, r);
    });
  });
}, Nc = (e, t) => {
  let n = e;
  return t.split(zs).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Mw = (e) => e.isThemeGetter, Nw = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((l) => typeof l == "string" ? t + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(([i, o]) => [t + i, o])) : l);
  return [n, a];
}) : e, Vw = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (l, i) => {
    n.set(l, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(l) {
      let i = n.get(l);
      if (i !== void 0)
        return i;
      if ((i = r.get(l)) !== void 0)
        return a(l, i), i;
    },
    set(l, i) {
      n.has(l) ? n.set(l, i) : a(l, i);
    }
  };
}, h5 = "!", Iw = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], l = t.length, i = (o) => {
    const u = [];
    let s = 0, d = 0, c;
    for (let m = 0; m < o.length; m++) {
      let v = o[m];
      if (s === 0) {
        if (v === a && (r || o.slice(m, m + l) === t)) {
          u.push(o.slice(d, m)), d = m + l;
          continue;
        }
        if (v === "/") {
          c = m;
          continue;
        }
      }
      v === "[" ? s++ : v === "]" && s--;
    }
    const f = u.length === 0 ? o : o.substring(d), b = f.startsWith(h5), p = b ? f.substring(1) : f, h = c && c > d ? c - d : void 0;
    return {
      modifiers: u,
      hasImportantModifier: b,
      baseClassName: p,
      maybePostfixModifierPosition: h
    };
  };
  return n ? (o) => n({
    className: o,
    parseClassName: i
  }) : i;
}, Ow = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, zw = (e) => ({
  cache: Vw(e.cacheSize),
  parseClassName: Iw(e),
  ...Aw(e)
}), Kw = /\s+/, jw = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, l = [], i = e.trim().split(Kw);
  let o = "";
  for (let u = i.length - 1; u >= 0; u -= 1) {
    const s = i[u], {
      modifiers: d,
      hasImportantModifier: c,
      baseClassName: f,
      maybePostfixModifierPosition: b
    } = n(s);
    let p = !!b, h = r(p ? f.substring(0, b) : f);
    if (!h) {
      if (!p) {
        o = s + (o.length > 0 ? " " + o : o);
        continue;
      }
      if (h = r(f), !h) {
        o = s + (o.length > 0 ? " " + o : o);
        continue;
      }
      p = !1;
    }
    const m = Ow(d).join(":"), v = c ? m + h5 : m, y = v + h;
    if (l.includes(y))
      continue;
    l.push(y);
    const w = a(h, p);
    for (let C = 0; C < w.length; ++C) {
      const D = w[C];
      l.push(v + D);
    }
    o = s + (o.length > 0 ? " " + o : o);
  }
  return o;
};
function Lw() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = m5(t)) && (r && (r += " "), r += n);
  return r;
}
const m5 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = m5(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Du(e, ...t) {
  let n, r, a, l = i;
  function i(u) {
    const s = t.reduce((d, c) => c(d), e());
    return n = zw(s), r = n.cache.get, a = n.cache.set, l = o, o(u);
  }
  function o(u) {
    const s = r(u);
    if (s)
      return s;
    const d = jw(u, n);
    return a(u, d), d;
  }
  return function() {
    return l(Lw.apply(null, arguments));
  };
}
const je = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, v5 = /^\[(?:([a-z-]+):)?(.+)\]$/i, Hw = /^\d+\/\d+$/, _w = /* @__PURE__ */ new Set(["px", "full", "screen"]), Uw = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ww = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Gw = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Zw = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Yw = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Cn = (e) => Jr(e) || _w.has(e) || Hw.test(e), Wn = (e) => ca(e, "length", rP), Jr = (e) => !!e && !Number.isNaN(Number(e)), Ao = (e) => ca(e, "number", Jr), Ea = (e) => !!e && Number.isInteger(Number(e)), qw = (e) => e.endsWith("%") && Jr(e.slice(0, -1)), xe = (e) => v5.test(e), Gn = (e) => Uw.test(e), Xw = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Jw = (e) => ca(e, Xw, g5), Qw = (e) => ca(e, "position", g5), eP = /* @__PURE__ */ new Set(["image", "url"]), tP = (e) => ca(e, eP, lP), nP = (e) => ca(e, "", aP), wa = () => !0, ca = (e, t, n) => {
  const r = v5.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, rP = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Ww.test(e) && !Gw.test(e)
), g5 = () => !1, aP = (e) => Zw.test(e), lP = (e) => Yw.test(e), Cu = () => {
  const e = je("colors"), t = je("spacing"), n = je("blur"), r = je("brightness"), a = je("borderColor"), l = je("borderRadius"), i = je("borderSpacing"), o = je("borderWidth"), u = je("contrast"), s = je("grayscale"), d = je("hueRotate"), c = je("invert"), f = je("gap"), b = je("gradientColorStops"), p = je("gradientColorStopPositions"), h = je("inset"), m = je("margin"), v = je("opacity"), y = je("padding"), w = je("saturate"), C = je("scale"), D = je("sepia"), P = je("skew"), R = je("space"), V = je("translate"), L = () => ["auto", "contain", "none"], A = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", xe, t], S = () => [xe, t], T = () => ["", Cn, Wn], M = () => ["auto", Jr, xe], K = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], g = () => ["solid", "dashed", "dotted", "double", "none"], B = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], k = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], I = () => ["", "0", xe], O = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], F = () => [Jr, xe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [wa],
      spacing: [Cn, Wn],
      blur: ["none", "", Gn, xe],
      brightness: F(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Gn, xe],
      borderSpacing: S(),
      borderWidth: T(),
      contrast: F(),
      grayscale: I(),
      hueRotate: F(),
      invert: I(),
      gap: S(),
      gradientColorStops: [e],
      gradientColorStopPositions: [qw, Wn],
      inset: $(),
      margin: $(),
      opacity: F(),
      padding: S(),
      saturate: F(),
      scale: F(),
      sepia: I(),
      skew: F(),
      space: S(),
      translate: S()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", xe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Gn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": O()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": O()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...K(), xe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ea, xe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", xe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: I()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: I()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ea, xe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [wa]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ea, xe]
        }, xe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": M()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": M()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [wa]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ea, xe]
        }, xe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": M()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": M()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", xe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", xe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...k()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...k(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...k(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [R]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [R]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", xe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [xe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [xe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Gn]
        }, Gn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [xe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [xe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [xe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [xe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Gn, Wn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ao]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [wa]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", xe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Jr, Ao]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Cn, xe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", xe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", xe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...g(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Cn, Wn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Cn, xe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: S()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", xe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", xe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...K(), Qw]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Jw]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, tP]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [b]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [l]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [l]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [l]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [l]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [l]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [l]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [l]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [l]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [l]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [l]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [l]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [l]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [l]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [l]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [l]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [o]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...g(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: g()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...g()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Cn, xe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Cn, Wn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: T()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Cn, Wn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Gn, nP]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [wa]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...B(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": B()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Gn, xe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [s]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [c]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [D]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [s]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [c]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [D]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", xe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: F()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", xe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: F()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", xe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ea, xe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [V]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [V]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [P]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [P]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", xe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", xe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": S()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": S()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": S()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": S()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": S()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": S()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": S()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": S()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": S()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": S()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": S()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": S()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": S()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": S()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": S()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": S()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": S()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": S()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", xe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Cn, Wn, Ao]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, iP = (e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  experimentalParseClassName: a,
  extend: l = {},
  override: i = {}
}) => {
  Ma(e, "cacheSize", t), Ma(e, "prefix", n), Ma(e, "separator", r), Ma(e, "experimentalParseClassName", a);
  for (const o in i)
    oP(e[o], i[o]);
  for (const o in l)
    uP(e[o], l[o]);
  return e;
}, Ma = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, oP = (e, t) => {
  if (t)
    for (const n in t)
      Ma(e, n, t[n]);
}, uP = (e, t) => {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}, sP = (e, ...t) => typeof e == "function" ? Du(Cu, e, ...t) : Du(() => iP(Cu(), e), ...t), dP = /* @__PURE__ */ Du(Cu);
var cP = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, y5 = (e) => e || void 0, Xa = (...e) => y5(c5(e).filter(Boolean).join(" ")), To = null, wn = {}, Eu = !1, Pa = (...e) => (t) => t.twMerge ? ((!To || Eu) && (Eu = !1, To = St(wn) ? dP : sP({ ...wn, extend: { theme: wn.theme, classGroups: wn.classGroups, conflictingClassGroupModifiers: wn.conflictingClassGroupModifiers, conflictingClassGroups: wn.conflictingClassGroups, ...wn.extend } })), y5(To(Xa(e)))) : Xa(e), Vc = (e, t) => {
  for (let n in t) e.hasOwnProperty(n) ? e[n] = Xa(e[n], t[n]) : e[n] = t[n];
  return e;
}, de = (e, t) => {
  let { extend: n = null, slots: r = {}, variants: a = {}, compoundVariants: l = [], compoundSlots: i = [], defaultVariants: o = {} } = e, u = { ...cP, ...t }, s = n != null && n.base ? Xa(n.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, d = n != null && n.variants && !St(n.variants) ? b5(a, n.variants) : a, c = n != null && n.defaultVariants && !St(n.defaultVariants) ? { ...n.defaultVariants, ...o } : o;
  !St(u.twMergeConfig) && !Fw(u.twMergeConfig, wn) && (Eu = !0, wn = u.twMergeConfig);
  let f = St(n == null ? void 0 : n.slots), b = St(r) ? {} : { base: Xa(e == null ? void 0 : e.base, f && (n == null ? void 0 : n.base)), ...r }, p = f ? b : Vc({ ...n == null ? void 0 : n.slots }, St(b) ? { base: e == null ? void 0 : e.base } : b), h = St(n == null ? void 0 : n.compoundVariants) ? l : f5(n == null ? void 0 : n.compoundVariants, l), m = (y) => {
    if (St(d) && St(r) && f) return Pa(s, y == null ? void 0 : y.class, y == null ? void 0 : y.className)(u);
    if (h && !Array.isArray(h)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof h}`);
    if (i && !Array.isArray(i)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof i}`);
    let w = (S, T, M = [], K) => {
      let g = M;
      if (typeof T == "string") g = g.concat(Rc(T).split(" ").map((B) => `${S}:${B}`));
      else if (Array.isArray(T)) g = g.concat(T.reduce((B, k) => B.concat(`${S}:${k}`), []));
      else if (typeof T == "object" && typeof K == "string") {
        for (let B in T) if (T.hasOwnProperty(B) && B === K) {
          let k = T[B];
          if (k && typeof k == "string") {
            let I = Rc(k);
            g[K] ? g[K] = g[K].concat(I.split(" ").map((O) => `${S}:${O}`)) : g[K] = I.split(" ").map((O) => `${S}:${O}`);
          } else Array.isArray(k) && k.length > 0 && (g[K] = k.reduce((I, O) => I.concat(`${S}:${O}`), []));
        }
      }
      return g;
    }, C = (S, T = d, M = null, K = null) => {
      var g;
      let B = T[S];
      if (!B || St(B)) return null;
      let k = (g = K == null ? void 0 : K[S]) != null ? g : y == null ? void 0 : y[S];
      if (k === null) return null;
      let I = Tc(k), O = Array.isArray(u.responsiveVariants) && u.responsiveVariants.length > 0 || u.responsiveVariants === !0, F = c == null ? void 0 : c[S], z = [];
      if (typeof I == "object" && O) for (let [ue, be] of Object.entries(I)) {
        let ce = B[be];
        if (ue === "initial") {
          F = be;
          continue;
        }
        Array.isArray(u.responsiveVariants) && !u.responsiveVariants.includes(ue) || (z = w(ue, ce, z, M));
      }
      let Z = I != null && typeof I != "object" ? I : Tc(F), te = B[Z || "false"];
      return typeof z == "object" && typeof M == "string" && z[M] ? Vc(z, te) : z.length > 0 ? (z.push(te), M === "base" ? z.join(" ") : z) : te;
    }, D = () => d ? Object.keys(d).map((S) => C(S, d)) : null, P = (S, T) => {
      if (!d || typeof d != "object") return null;
      let M = new Array();
      for (let K in d) {
        let g = C(K, d, S, T), B = S === "base" && typeof g == "string" ? g : g && g[S];
        B && (M[M.length] = B);
      }
      return M;
    }, R = {};
    for (let S in y) y[S] !== void 0 && (R[S] = y[S]);
    let V = (S, T) => {
      var M;
      let K = typeof (y == null ? void 0 : y[S]) == "object" ? { [S]: (M = y[S]) == null ? void 0 : M.initial } : {};
      return { ...c, ...R, ...K, ...T };
    }, L = (S = [], T) => {
      let M = [];
      for (let { class: K, className: g, ...B } of S) {
        let k = !0;
        for (let [I, O] of Object.entries(B)) {
          let F = V(I, T)[I];
          if (Array.isArray(O)) {
            if (!O.includes(F)) {
              k = !1;
              break;
            }
          } else {
            let z = (Z) => Z == null || Z === !1;
            if (z(O) && z(F)) continue;
            if (F !== O) {
              k = !1;
              break;
            }
          }
        }
        k && (K && M.push(K), g && M.push(g));
      }
      return M;
    }, A = (S) => {
      let T = L(h, S);
      if (!Array.isArray(T)) return T;
      let M = {};
      for (let K of T) if (typeof K == "string" && (M.base = Pa(M.base, K)(u)), typeof K == "object") for (let [g, B] of Object.entries(K)) M[g] = Pa(M[g], B)(u);
      return M;
    }, $ = (S) => {
      if (i.length < 1) return null;
      let T = {};
      for (let { slots: M = [], class: K, className: g, ...B } of i) {
        if (!St(B)) {
          let k = !0;
          for (let I of Object.keys(B)) {
            let O = V(I, S)[I];
            if (O === void 0 || (Array.isArray(B[I]) ? !B[I].includes(O) : B[I] !== O)) {
              k = !1;
              break;
            }
          }
          if (!k) continue;
        }
        for (let k of M) T[k] = T[k] || [], T[k].push([K, g]);
      }
      return T;
    };
    if (!St(r) || !f) {
      let S = {};
      if (typeof p == "object" && !St(p)) for (let T of Object.keys(p)) S[T] = (M) => {
        var K, g;
        return Pa(p[T], P(T, M), ((K = A(M)) != null ? K : [])[T], ((g = $(M)) != null ? g : [])[T], M == null ? void 0 : M.class, M == null ? void 0 : M.className)(u);
      };
      return S;
    }
    return Pa(s, D(), L(h), y == null ? void 0 : y.class, y == null ? void 0 : y.className)(u);
  }, v = () => {
    if (!(!d || typeof d != "object")) return Object.keys(d);
  };
  return m.variantKeys = v(), m.extend = n, m.base = s, m.slots = p, m.variants = d, m.defaultVariants = c, m.compoundSlots = i, m.compoundVariants = h, m;
};
const Ks = "-", fP = (e) => {
  const t = pP(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (i) => {
      const o = i.split(Ks);
      return o[0] === "" && o.length !== 1 && o.shift(), $5(o, t) || bP(i);
    },
    getConflictingClassGroupIds: (i, o) => {
      const u = n[i] || [];
      return o && r[i] ? [...u, ...r[i]] : u;
    }
  };
}, $5 = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? $5(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const l = e.join(Ks);
  return (i = t.validators.find(({
    validator: o
  }) => o(l))) == null ? void 0 : i.classGroupId;
}, Ic = /^\[(.+)\]$/, bP = (e) => {
  if (Ic.test(e)) {
    const t = Ic.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, pP = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return mP(Object.entries(e.classGroups), n).forEach(([l, i]) => {
    wu(i, r, l, t);
  }), r;
}, wu = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const l = a === "" ? t : Oc(t, a);
      l.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (hP(a)) {
        wu(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([l, i]) => {
      wu(i, Oc(t, l), n, r);
    });
  });
}, Oc = (e, t) => {
  let n = e;
  return t.split(Ks).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, hP = (e) => e.isThemeGetter, mP = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((l) => typeof l == "string" ? t + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(([i, o]) => [t + i, o])) : l);
  return [n, a];
}) : e, vP = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (l, i) => {
    n.set(l, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(l) {
      let i = n.get(l);
      if (i !== void 0)
        return i;
      if ((i = r.get(l)) !== void 0)
        return a(l, i), i;
    },
    set(l, i) {
      n.has(l) ? n.set(l, i) : a(l, i);
    }
  };
}, x5 = "!", gP = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], l = t.length, i = (o) => {
    const u = [];
    let s = 0, d = 0, c;
    for (let m = 0; m < o.length; m++) {
      let v = o[m];
      if (s === 0) {
        if (v === a && (r || o.slice(m, m + l) === t)) {
          u.push(o.slice(d, m)), d = m + l;
          continue;
        }
        if (v === "/") {
          c = m;
          continue;
        }
      }
      v === "[" ? s++ : v === "]" && s--;
    }
    const f = u.length === 0 ? o : o.substring(d), b = f.startsWith(x5), p = b ? f.substring(1) : f, h = c && c > d ? c - d : void 0;
    return {
      modifiers: u,
      hasImportantModifier: b,
      baseClassName: p,
      maybePostfixModifierPosition: h
    };
  };
  return n ? (o) => n({
    className: o,
    parseClassName: i
  }) : i;
}, yP = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, $P = (e) => ({
  cache: vP(e.cacheSize),
  parseClassName: gP(e),
  ...fP(e)
}), xP = /\s+/, DP = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, l = [], i = e.trim().split(xP);
  let o = "";
  for (let u = i.length - 1; u >= 0; u -= 1) {
    const s = i[u], {
      modifiers: d,
      hasImportantModifier: c,
      baseClassName: f,
      maybePostfixModifierPosition: b
    } = n(s);
    let p = !!b, h = r(p ? f.substring(0, b) : f);
    if (!h) {
      if (!p) {
        o = s + (o.length > 0 ? " " + o : o);
        continue;
      }
      if (h = r(f), !h) {
        o = s + (o.length > 0 ? " " + o : o);
        continue;
      }
      p = !1;
    }
    const m = yP(d).join(":"), v = c ? m + x5 : m, y = v + h;
    if (l.includes(y))
      continue;
    l.push(y);
    const w = a(h, p);
    for (let C = 0; C < w.length; ++C) {
      const D = w[C];
      l.push(v + D);
    }
    o = s + (o.length > 0 ? " " + o : o);
  }
  return o;
};
function CP() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = D5(t)) && (r && (r += " "), r += n);
  return r;
}
const D5 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = D5(e[r])) && (n && (n += " "), n += t);
  return n;
};
function EP(e, ...t) {
  let n, r, a, l = i;
  function i(u) {
    const s = t.reduce((d, c) => c(d), e());
    return n = $P(s), r = n.cache.get, a = n.cache.set, l = o, o(u);
  }
  function o(u) {
    const s = r(u);
    if (s)
      return s;
    const d = DP(u, n);
    return a(u, d), d;
  }
  return function() {
    return l(CP.apply(null, arguments));
  };
}
const Le = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, C5 = /^\[(?:([a-z-]+):)?(.+)\]$/i, wP = /^\d+\/\d+$/, PP = /* @__PURE__ */ new Set(["px", "full", "screen"]), kP = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, SP = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, BP = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, FP = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, AP = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, En = (e) => Qr(e) || PP.has(e) || wP.test(e), Zn = (e) => fa(e, "length", zP), Qr = (e) => !!e && !Number.isNaN(Number(e)), Ro = (e) => fa(e, "number", Qr), ka = (e) => !!e && Number.isInteger(Number(e)), TP = (e) => e.endsWith("%") && Qr(e.slice(0, -1)), De = (e) => C5.test(e), Yn = (e) => kP.test(e), RP = /* @__PURE__ */ new Set(["length", "size", "percentage"]), MP = (e) => fa(e, RP, E5), NP = (e) => fa(e, "position", E5), VP = /* @__PURE__ */ new Set(["image", "url"]), IP = (e) => fa(e, VP, jP), OP = (e) => fa(e, "", KP), Sa = () => !0, fa = (e, t, n) => {
  const r = C5.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, zP = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  SP.test(e) && !BP.test(e)
), E5 = () => !1, KP = (e) => FP.test(e), jP = (e) => AP.test(e), LP = () => {
  const e = Le("colors"), t = Le("spacing"), n = Le("blur"), r = Le("brightness"), a = Le("borderColor"), l = Le("borderRadius"), i = Le("borderSpacing"), o = Le("borderWidth"), u = Le("contrast"), s = Le("grayscale"), d = Le("hueRotate"), c = Le("invert"), f = Le("gap"), b = Le("gradientColorStops"), p = Le("gradientColorStopPositions"), h = Le("inset"), m = Le("margin"), v = Le("opacity"), y = Le("padding"), w = Le("saturate"), C = Le("scale"), D = Le("sepia"), P = Le("skew"), R = Le("space"), V = Le("translate"), L = () => ["auto", "contain", "none"], A = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", De, t], S = () => [De, t], T = () => ["", En, Zn], M = () => ["auto", Qr, De], K = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], g = () => ["solid", "dashed", "dotted", "double", "none"], B = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], k = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], I = () => ["", "0", De], O = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], F = () => [Qr, De];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Sa],
      spacing: [En, Zn],
      blur: ["none", "", Yn, De],
      brightness: F(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Yn, De],
      borderSpacing: S(),
      borderWidth: T(),
      contrast: F(),
      grayscale: I(),
      hueRotate: F(),
      invert: I(),
      gap: S(),
      gradientColorStops: [e],
      gradientColorStopPositions: [TP, Zn],
      inset: $(),
      margin: $(),
      opacity: F(),
      padding: S(),
      saturate: F(),
      scale: F(),
      sepia: I(),
      skew: F(),
      space: S(),
      translate: S()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", De]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Yn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": O()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": O()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...K(), De]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ka, De]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", De]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: I()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: I()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ka, De]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Sa]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ka, De]
        }, De]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": M()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": M()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Sa]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ka, De]
        }, De]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": M()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": M()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", De]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", De]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...k()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...k(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...k(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [R]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [R]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", De, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [De, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [De, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Yn]
        }, Yn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [De, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [De, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [De, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [De, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Yn, Zn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ro]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Sa]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", De]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Qr, Ro]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", En, De]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", De]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", De]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...g(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", En, Zn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", En, De]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: S()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", De]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", De]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...K(), NP]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", MP]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, IP]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [b]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [l]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [l]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [l]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [l]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [l]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [l]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [l]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [l]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [l]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [l]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [l]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [l]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [l]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [l]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [l]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [o]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...g(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: g()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...g()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [En, De]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [En, Zn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: T()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [En, Zn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Yn, OP]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Sa]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...B(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": B()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Yn, De]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [s]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [c]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [D]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [s]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [c]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [D]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", De]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: F()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", De]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: F()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", De]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ka, De]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [V]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [V]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [P]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [P]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", De]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", De]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": S()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": S()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": S()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": S()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": S()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": S()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": S()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": S()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": S()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": S()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": S()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": S()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": S()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": S()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": S()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": S()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": S()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": S()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", De]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [En, Zn, Ro]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, dr = /* @__PURE__ */ EP(LP), ze = de({
  base: "outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2",
  variants: {
    isFocusVisible: {
      false: "outline-0",
      true: "outline-2"
    }
  }
});
function Te(e, t) {
  return et(e, (n) => dr(t, n));
}
const HP = de({
  extend: ze,
  base: "px-5 py-2 text-sm text-center transition rounded-lg border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none cursor-default",
  variants: {
    variant: {
      primary: "bg-blue-600 hover:bg-blue-700 pressed:bg-blue-800 text-white",
      secondary: "bg-gray-100 hover:bg-gray-200 pressed:bg-gray-300 text-gray-800 dark:bg-zinc-600 dark:hover:bg-zinc-500 dark:pressed:bg-zinc-400 dark:text-zinc-100",
      destructive: "bg-red-700 hover:bg-red-800 pressed:bg-red-900 text-white",
      icon: "border-0 p-1 flex items-center justify-center text-gray-600 hover:bg-black/[5%] pressed:bg-black/10 dark:text-zinc-400 dark:hover:bg-white/10 dark:pressed:bg-white/20 disabled:bg-transparent",
      nostyle: ""
    },
    isDisabled: {
      true: "bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});
function In(e) {
  return E.jsx(ur, Object.assign({}, e, { className: et(e.className, (t, n) => HP(Object.assign(Object.assign({}, n), { variant: e.variant, className: t }))) }));
}
function Wi(e) {
  return E.jsx(tE, Object.assign({}, e, { className: dr("outline outline-0 p-6 [[data-placement]>&]:p-4 max-h-[inherit] overflow-auto relative", e.className) }));
}
var _P = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function PS(e) {
  var { title: t, variant: n, cancelLabel: r, actionLabel: a, onAction: l, children: i } = e, o = _P(e, ["title", "variant", "cancelLabel", "actionLabel", "onAction", "children"]);
  return E.jsx(Wi, Object.assign({ role: "alertdialog" }, o, { children: ({ close: u }) => E.jsxs(E.Fragment, { children: [E.jsx(Rs, { slot: "title", className: "text-xl font-semibold leading-6 my-0", children: t }), E.jsx("div", { className: `w-6 h-6 absolute right-6 top-6 stroke-2 ${n === "destructive" ? "text-red-500" : "text-blue-500"}`, children: n === "destructive" ? E.jsx(ux, { "aria-hidden": !0 }) : E.jsx(dx, { "aria-hidden": !0 }) }), E.jsx("p", { className: "mt-3 text-slate-500 dark:text-zinc-400", children: i }), E.jsxs("div", { className: "mt-6 flex justify-end gap-2", children: [E.jsx(In, { variant: "secondary", onPress: u, children: r || "Cancel" }), E.jsx(In, { variant: n === "destructive" ? "destructive" : "primary", autoFocus: !0, onPress: At(l, u), children: a })] })] }) }));
}
const UP = de({
  extend: ze,
  base: "underline disabled:no-underline disabled:cursor-default forced-colors:disabled:text-[GrayText] transition rounded",
  variants: {
    variant: {
      primary: "text-blue-600 dark:text-blue-500 underline decoration-blue-600/60 hover:decoration-blue-600 dark:decoration-blue-500/60 dark:hover:decoration-blue-500",
      secondary: "text-gray-700 dark:text-zinc-300 underline decoration-gray-700/50 hover:decoration-gray-700 dark:decoration-zinc-300/70 dark:hover:decoration-zinc-300"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});
function WP(e) {
  return E.jsx(o9, Object.assign({}, e, { className: et(e.className, (t, n) => UP(Object.assign(Object.assign({}, n), { className: t, variant: e.variant }))) }));
}
function kS(e) {
  return E.jsx(u9, Object.assign({}, e, { className: dr("flex gap-1", e.className) }));
}
function SS(e) {
  return E.jsxs(s9, Object.assign({}, e, { className: Te(e.className, "flex items-center gap-1"), children: [E.jsx(WP, Object.assign({ variant: "secondary" }, e)), e.href && E.jsx(Oa, { className: "w-3 h-3 text-gray-600 dark:text-zinc-400" })] }));
}
var GP = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const ZP = de({
  extend: ze,
  base: "w-9 h-9 text-sm cursor-default rounded-full flex items-center justify-center forced-color-adjust-none",
  variants: {
    isSelected: {
      false: "text-zinc-900 dark:text-zinc-200 hover:bg-gray-100 dark:hover:bg-zinc-700 pressed:bg-gray-200 dark:pressed:bg-zinc-600",
      true: "bg-blue-600 invalid:bg-red-600 text-white forced-colors:bg-[Highlight] forced-colors:invalid:bg-[Mark] forced-colors:text-[HighlightText]"
    },
    isDisabled: {
      true: "text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  }
});
function YP(e) {
  var { errorMessage: t } = e, n = GP(e, ["errorMessage"]);
  return E.jsxs(d9, Object.assign({}, n, { children: [E.jsx(w5, {}), E.jsxs(J$, { children: [E.jsx(P5, {}), E.jsx(xs, { children: (r) => E.jsx(t1, { date: r, className: ZP }) })] }), t && E.jsx(sl, { slot: "errorMessage", className: "text-sm text-red-600", children: t })] }));
}
function w5() {
  const { direction: e } = me();
  return E.jsxs("header", { className: "flex items-center gap-1 pb-4 px-1 w-full", children: [E.jsx(In, { variant: "icon", slot: "previous", children: e === "rtl" ? E.jsx(Oa, { "aria-hidden": !0 }) : E.jsx(Qs, { "aria-hidden": !0 }) }), E.jsx(Rs, { className: "flex-1 font-semibold text-xl text-center mx-2 text-zinc-900 dark:text-zinc-200" }), E.jsx(In, { variant: "icon", slot: "next", children: e === "rtl" ? E.jsx(Qs, { "aria-hidden": !0 }) : E.jsx(Oa, { "aria-hidden": !0 }) })] });
}
function P5() {
  return E.jsx(Q$, { children: (e) => E.jsx(e1, { className: "text-xs text-gray-500 font-semibold", children: e }) });
}
function bt(e) {
  return E.jsx(o8, Object.assign({}, e, { className: dr("text-sm text-gray-500 dark:text-zinc-400 font-medium cursor-default w-fit", e.className) }));
}
function Nt(e) {
  return E.jsx(sl, Object.assign({}, e, { slot: "description", className: dr("text-sm text-gray-600", e.className) }));
}
function Ht(e) {
  return E.jsx(d8, Object.assign({}, e, { className: Te(e.className, "text-sm text-red-600 forced-colors:text-[Mark]") }));
}
const ir = de({
  variants: {
    isFocusWithin: {
      false: "border-gray-300 dark:border-zinc-500 forced-colors:border-[ButtonBorder]",
      true: "border-gray-600 dark:border-zinc-300 forced-colors:border-[Highlight]"
    },
    isInvalid: {
      true: "border-red-600 dark:border-red-600 forced-colors:border-[Mark]"
    },
    isDisabled: {
      true: "border-gray-200 dark:border-zinc-700 forced-colors:border-[GrayText]"
    }
  }
}), k5 = de({
  extend: ze,
  base: "group flex items-center h-9 bg-white dark:bg-zinc-900 forced-colors:bg-[Field] border-2 rounded-lg overflow-hidden",
  variants: ir.variants
});
function hl(e) {
  return E.jsx(Ri, Object.assign({}, e, { className: et(e.className, (t, n) => k5(Object.assign(Object.assign({}, n), { className: t }))) }));
}
function ba(e) {
  return E.jsx(Qy, Object.assign({}, e, { className: Te(e.className, "px-2 py-1.5 flex-1 min-w-0 outline outline-0 bg-white dark:bg-zinc-900 text-sm text-gray-800 dark:text-zinc-200 disabled:text-gray-200 dark:disabled:text-zinc-600") }));
}
var qP = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function BS(e) {
  return E.jsxs(m9, Object.assign({}, e, { className: Te(e.className, "flex flex-col gap-2"), children: [E.jsx(bt, { children: e.label }), e.children, e.description && E.jsx(Nt, { children: e.description }), E.jsx(Ht, { children: e.errorMessage })] }));
}
const XP = de({
  base: "flex gap-2 items-center group text-sm transition",
  variants: {
    isDisabled: {
      false: "text-gray-800 dark:text-zinc-200",
      true: "text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  }
}), JP = de({
  extend: ze,
  base: "w-5 h-5 flex-shrink-0 rounded flex items-center justify-center border-2 transition",
  variants: {
    isSelected: {
      false: "bg-white dark:bg-zinc-900 border-[--color] [--color:theme(colors.gray.400)] dark:[--color:colors.zinc-400)] group-pressed:[--color:theme(colors.gray.500)] dark:group-pressed:[--color:theme(colors.zinc.300)]",
      true: "bg-[--color] border-[--color] [--color:theme(colors.gray.700)] group-pressed:[--color:theme(colors.gray.800)] dark:[--color:theme(colors.slate.300)] dark:group-pressed:[--color:theme(colors.slate.200)] forced-colors:![--color:Highlight]"
    },
    isInvalid: {
      true: "[--color:theme(colors.red.700)] dark:[--color:theme(colors.red.600)] forced-colors:![--color:Mark] group-pressed:[--color:theme(colors.red.800)] dark:group-pressed:[--color:theme(colors.red.700)]"
    },
    isDisabled: {
      true: "[--color:theme(colors.gray.200)] dark:[--color:theme(colors.zinc.700)] forced-colors:![--color:GrayText]"
    }
  }
}), zc = "w-4 h-4 text-white group-disabled:text-gray-400 dark:text-slate-900 dark:group-disabled:text-slate-600 forced-colors:text-[HighlightText]";
function js(e) {
  return E.jsx(v9, Object.assign({}, e, { className: et(e.className, (t, n) => XP(Object.assign(Object.assign({}, n), { className: t }))), children: (t) => {
    var { isSelected: n, isIndeterminate: r } = t, a = qP(t, ["isSelected", "isIndeterminate"]);
    return E.jsxs(E.Fragment, { children: [E.jsx("div", { className: JP(Object.assign({ isSelected: n || r }, a)), children: r ? E.jsx(fx, { "aria-hidden": !0, className: zc }) : n ? E.jsx(ku, { "aria-hidden": !0, className: zc }) : null }), e.children] });
  } }));
}
const QP = de({
  base: "w-6 h-6 top-[50%] left-[50%] rounded-full border-2 border-white",
  variants: {
    isFocusVisible: {
      true: "w-8 h-8"
    },
    isDragging: {
      true: "bg-gray-700 dark:bg-gray-300 forced-colors:bg-[ButtonBorder]"
    },
    isDisabled: {
      true: "border-gray-300 dark:border-zinc-700 forced-colors:border-[GrayText] bg-gray-300 dark:bg-zinc-800 forced-colors:bg-[GrayText]"
    }
  }
});
function Gi(e) {
  return E.jsx(g9, Object.assign({}, e, { style: ({ defaultStyle: t, isDisabled: n }) => Object.assign(Object.assign({}, t), { backgroundColor: n ? void 0 : t.backgroundColor, boxShadow: "0 0 0 1px black, inset 0 0 0 1px black" }), className: QP }));
}
function ek(e) {
  return E.jsx($9, Object.assign({}, e, { className: `rounded-lg bg-gray-300 dark:bg-zinc-800 forced-colors:bg-[GrayText] ${e.className}`, style: ({ defaultStyle: t, isDisabled: n }) => Object.assign(Object.assign({}, t), { background: n ? void 0 : t.background }), children: E.jsx(Gi, {}) }));
}
var tk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const nk = de({
  extend: ze,
  base: "border-2 rounded-md",
  variants: Object.assign({ isFocused: ir.variants.isFocusWithin }, ir.variants)
});
function rk(e) {
  var { label: t, description: n, errorMessage: r, customInputStyles: a, value: l } = e, i = tk(e, ["label", "description", "errorMessage", "customInputStyles", "value"]);
  return E.jsxs(D9, Object.assign({}, i, { className: Te(i.className, "flex flex-col gap-1"), children: [t && E.jsx(bt, { children: t }), E.jsx(ba, { className: a ?? nk, value: typeof l == "string" ? l : "" }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r })] }));
}
function S5(e) {
  return E.jsx(w9, Object.assign({}, e, { className: Te(e.className, "w-8 h-8 rounded border border-black/10"), style: ({ color: t }) => ({
    background: `linear-gradient(${t}, ${t}),
          repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px`
  }) }));
}
var ak = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const lk = de({
  base: "group col-span-2 orientation-horizontal:h-6 rounded-lg",
  variants: {
    orientation: {
      horizontal: "w-full h-6",
      vertical: "w-6 h-56 ml-[50%] -translate-x-[50%]"
    },
    isDisabled: {
      true: "bg-gray-300 dark:bg-zinc-800 forced-colors:bg-[GrayText]"
    }
  }
});
function ik(e) {
  var { label: t, hideOutput: n } = e, r = ak(e, ["label", "hideOutput"]);
  return E.jsxs(_1, Object.assign({}, r, { className: Te(r.className, "orientation-horizontal:grid orientation-vertical:flex grid-cols-[1fr_auto] flex-col items-center gap-2 orientation-horizontal:w-56"), children: [!n && E.jsx(Bs, { className: "text-sm text-gray-500 dark:text-zinc-400 font-medium orientation-vertical:hidden" }), E.jsx(Fs, { className: lk, style: ({ defaultStyle: a, isDisabled: l }) => Object.assign(Object.assign({}, a), { background: l ? void 0 : `${a.background}, repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px` }), children: E.jsx(Gi, {}) })] }));
}
var ok = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const uk = de({
  base: "bg-white dark:bg-zinc-900/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] shadow-2xl rounded-xl bg-clip-padding border border-black/10 dark:border-white/[15%] text-slate-700 dark:text-zinc-300",
  variants: {
    isEntering: {
      true: "animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-200"
    },
    isExiting: {
      true: "animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 ease-in duration-150"
    }
  }
});
function Nr(e) {
  var { children: t, showArrow: n, className: r } = e, a = ok(e, ["children", "showArrow", "className"]);
  let l = Ge(Mr), i = (l == null ? void 0 : l.trigger) === "SubmenuTrigger", o = n ? 12 : 8;
  return o = i ? o - 6 : o, E.jsxs(_9, Object.assign({ offset: o }, a, { className: et(r, (u, s) => uk(Object.assign(Object.assign({}, s), { className: u }))), children: [n && E.jsx(G1, { className: "group", children: E.jsx("svg", { width: 12, height: 12, viewBox: "0 0 12 12", className: "block fill-white dark:fill-[#1f1f21] forced-colors:fill-[Canvas] stroke-1 stroke-black/10 dark:stroke-zinc-600 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90", children: E.jsx("path", { d: "M0 0 L6 6 L12 0" }) }) }), t] }));
}
var sk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const dk = de({
  base: "group col-span-2 orientation-horizontal:h-6 rounded-lg",
  variants: {
    orientation: {
      horizontal: "w-full h-6",
      vertical: "w-6 h-56 ml-[50%] -translate-x-[50%]"
    },
    isDisabled: {
      true: "bg-gray-300 dark:bg-zinc-800 forced-colors:bg-[GrayText]"
    }
  }
}), ck = (e) => {
  var { label: t, hideOutput: n } = e, r = sk(e, ["label", "hideOutput"]);
  return E.jsxs(_1, Object.assign({}, r, { children: [!n && E.jsx(Bs, { className: "text-sm text-gray-500 dark:text-zinc-400 font-medium orientation-vertical:hidden" }), E.jsx(Fs, { className: dk, style: ({ defaultStyle: a, isDisabled: l }) => Object.assign(Object.assign({}, a), { background: l ? void 0 : `${a.background}, repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px` }), children: E.jsx(Gi, { className: "w-6 h-6 rounded-full border-2 border-white shadow bg-white" }) })] }));
};
var fk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function FS(e) {
  var { children: t } = e, n = fk(e, ["children"]);
  return E.jsx(fl, Object.assign({}, n, { className: Te(n.className, "outline-0 p-1 border border-gray-300 dark:border-zinc-600 rounded-lg"), children: t }));
}
const bk = de({
  extend: ze,
  base: "group relative flex items-center gap-8 cursor-default select-none py-1.5 px-2.5 rounded-md will-change-transform text-sm forced-color-adjust-none",
  variants: {
    isSelected: {
      false: "text-slate-700 dark:text-zinc-300 hover:bg-slate-200 dark:hover:bg-zinc-700 -outline-offset-2",
      true: "bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]"
    },
    isDisabled: {
      true: "text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  }
});
function pk(e) {
  const t = e.textValue || (typeof e.children == "string" ? e.children : void 0);
  return E.jsx(ks, Object.assign({}, e, { textValue: t, className: bk, children: et(e.children, (n) => E.jsxs(E.Fragment, { children: [n, E.jsx("div", { className: "absolute left-4 right-4 bottom-0 h-px bg-white/20 forced-colors:bg-[HighlightText] hidden [.group[data-selected]:has(+[data-selected])_&]:block" })] })) }));
}
const hk = (e) => {
  var t, n, r, a, l, i;
  return de({
    base: `group flex items-center gap-4 cursor-default select-none py-2 pl-3 pr-1 rounded-lg outline outline-0 text-sm forced-color-adjust-none ${e != null && e.base ? e.base : ""}`,
    variants: {
      isDisabled: {
        false: `text-gray-900 dark:text-zinc-100 ${!((n = (t = e == null ? void 0 : e.variants) === null || t === void 0 ? void 0 : t.isDisabled) === null || n === void 0) && n.false ? e.variants.isDisabled.false : ""}`,
        true: `text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]  ${!((a = (r = e == null ? void 0 : e.variants) === null || r === void 0 ? void 0 : r.isDisabled) === null || a === void 0) && a.true ? e.variants.isDisabled.true : ""}`
      },
      isFocused: {
        true: `bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] ${!((i = (l = e == null ? void 0 : e.variants) === null || l === void 0 ? void 0 : l.isFocused) === null || i === void 0) && i.true ? e.variants.isFocused.true : ""}`
      }
    },
    compoundVariants: [
      {
        isFocused: !1,
        isOpen: !0,
        className: `bg-gray-100 dark:bg-zinc-700/60 ${e != null && e.compoundVariants ? e == null ? void 0 : e.compoundVariants : ""}`
      }
    ]
  });
};
function B5(e) {
  const t = e.textValue || (typeof e.children == "string" ? e.children : void 0);
  return E.jsx(ks, Object.assign({}, e, { textValue: t, className: hk(e == null ? void 0 : e.listBoxItemStyles), children: et(e.children, (n, { isSelected: r }) => E.jsxs(E.Fragment, { children: [E.jsx("span", { className: "flex items-center w-5", children: r && E.jsx(ku, { className: "w-4 h-4" }) }), E.jsx("span", { className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold", children: n })] })) }));
}
function F5(e) {
  return E.jsxs(S9, { className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px]", children: [E.jsx(O1, { className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y dark:border-y-zinc-700 [&+*]:mt-1", children: e.title }), E.jsx(Lt, { items: e.items, children: e.children })] });
}
var mk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const vk = (e) => de({
  extend: ze,
  base: `flex items-center text-start gap-4 w-full cursor-default border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none rounded-lg pl-3 pr-2 py-2 min-w-[150px] transition bg-gray-50 dark:bg-zinc-700 ${e ? e.base : ""}`,
  variants: {
    isDisabled: {
      false: `text-gray-800 dark:text-zinc-300 hover:bg-gray-100 pressed:bg-gray-200 dark:hover:bg-zinc-600 dark:pressed:bg-zinc-500 group-invalid:border-red-600 forced-colors:group-invalid:border-[Mark] ${e != null && e.notDisabled ? e.notDisabled : ""}`,
      true: `text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText] dark:bg-zinc-800 dark:border-white/5 forced-colors:border-[GrayText] ${e != null && e.disabled ? e.disabled : ""}`
    }
  }
});
function gk(e) {
  var { label: t, description: n, errorMessage: r, children: a, items: l, customButtonStyles: i, customListBoxStyles: o, customPopoverStyles: u } = e, s = mk(e, ["label", "description", "errorMessage", "children", "items", "customButtonStyles", "customListBoxStyles", "customPopoverStyles"]);
  return E.jsxs(HE, Object.assign({}, s, { className: Te(s.className, "group flex flex-col gap-1"), children: [t && E.jsx(bt, { children: t }), E.jsxs(ur, { className: vk(i), children: [E.jsx(UE, { className: "flex-1 text-sm placeholder-shown:italic" }), E.jsx(Qa, { "aria-hidden": !0, className: "w-4 h-4 text-gray-600 dark:text-zinc-400 forced-colors:text-[ButtonText] group-disabled:text-gray-200 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]" })] }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r }), E.jsx(Nr, { className: `min-w-[--trigger-width] ${u ?? ""}`, children: E.jsx(fl, { items: l, className: `${o ?? "outline-none p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]"}`, children: a }) })] }));
}
function yk(e) {
  return E.jsx(B5, Object.assign({}, e));
}
function AS(e) {
  return E.jsx(F5, Object.assign({}, e));
}
var $k = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const xk = de({
  extend: ze,
  base: "flex gap-2 items-center cursor-default rounded text-sm text-gray-800 dark:text-gray-200 p-1"
});
function TS(e) {
  var { label: t, children: n, colorSwatchStyles: r, isDisabled: a = !1 } = e, l = $k(e, ["label", "children", "colorSwatchStyles", "isDisabled"]);
  const i = ["Hex", "RGB", "CSS"], [o, u] = q(() => gt("#ff0000")), [s, d] = q("Hex"), [c, f] = q([]), [b, p] = q(!1), h = jn({}), m = (P) => {
    const R = j(null), { buttonProps: V } = Ju(P, R);
    return E.jsx("button", Object.assign({}, V, { className: "text-xl p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700", "aria-label": "Close", ref: R, onClick: h.close, children: E.jsx(Su, { size: 18 }) }));
  }, v = () => E.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15", fill: "none", children: E.jsx("path", { d: "M13.4473 0.6C12.6473 -0.2 11.4473 -0.2 10.6473 0.6L7.84725 3.4L7.04725 2.7C6.64725 2.3 6.04725 2.3 5.64725 2.7C5.24725 3.1 5.24725 3.7 5.64725 4.1L6.34725 4.8L0.547255 10.6C0.147255 11 -0.452745 12.5 0.547255 13.5C1.54725 14.5 3.04725 13.9 3.44725 13.5L9.24725 7.7L9.94725 8.4C10.3473 8.8 10.9473 8.8 11.3473 8.4C11.7473 8 11.7473 7.4 11.3473 7L10.6473 6.3L13.4473 3.5C14.2473 2.6 14.2473 1.4 13.4473 0.6ZM2.54725 12.5H1.54725V11.5L7.34725 5.7L8.34725 6.7C8.24725 6.7 2.54725 12.5 2.54725 12.5Z", fill: "#080808" }) }), y = ({ color: P }) => E.jsx("div", { className: "w-8 h-8 m-2", style: { backgroundColor: P.toString() }, onClick: () => u(P) }), w = (P) => {
    switch (s) {
      case "Hex":
        return `${P.toString("hex")}    ${C(P)}`;
      case "CSS":
        return P.toString("rgba");
      case "RGB":
        const R = P.toString("rgb");
        return `${R.substring(4, R.length - 1).split(", ").join("    ")}        ${C(P)}`;
      default:
        return P.toString("hex");
    }
  }, C = (P) => {
    const R = P.getChannelValue("alpha");
    return `${Math.floor(R * 100).toString()}%`;
  }, D = (P) => {
    f([...c, P]);
  };
  return E.jsx(I9, Object.assign({}, l, { value: o, onChange: u, children: E.jsxs(eE, { isOpen: h.isOpen, onOpenChange: h.setOpen, children: [E.jsx("div", { onMouseEnter: () => p(!0), onMouseLeave: () => p(!1), className: `p-1 border ${b ? "border-[#D4D4D4]" : "border-transparent"}`, children: E.jsx(ur, { className: xk, onPress: h.open, isDisabled: a, children: E.jsxs("div", { className: "flex flex-row items-center", children: [E.jsx(S5, { className: `rounded-none w-20 h-8 ${r ?? ""}` }), t && E.jsx("span", { className: "mx-3", children: t })] }) }) }), h.isOpen && E.jsx(Nr, { placement: "bottom start", children: E.jsx(Wi, { className: "flex flex-col gap-2 [[data-placement]>&]:p-0 p-0 w-96", children: n || E.jsxs(E.Fragment, { children: [E.jsxs("div", { className: "flex flex-row justify-between items-center mx-3", children: [E.jsx("div", { className: "font-semibold", children: "Custom" }), E.jsx(m, {})] }), E.jsx(ek, { colorSpace: "hsb", xChannel: "saturation", yChannel: "brightness", className: "self-center aspect-square w-[100%] mx-0 rounded-none", defaultValue: "#ff0000" }), E.jsxs("div", { className: "flex flex-row items-center justify-center", children: [E.jsx("div", { className: "pr-4 cursor-pointer", onClick: () => D(o), children: E.jsx(v, {}) }), E.jsxs("div", { className: "pl-2 pt-2", children: [E.jsx(ik, { colorSpace: "hsb", channel: "hue", className: "pb-3", hideOutput: !0 }), E.jsx(ck, { channel: "alpha", hideOutput: !0 })] })] }), E.jsxs("div", { className: "flex flex-row justify-between px-3", children: [E.jsx(gk, { customPopoverStyles: "min-w-[0px]", customListBoxStyles: "outline-none p-0 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0)]", customButtonStyles: { base: "border-none bg-white min-w-[0px]", notDisabled: "group-invalid:border-black" }, defaultSelectedKey: "Hex", onSelectionChange: (P) => d(P), children: i.map((P) => E.jsx(yk, { listBoxItemStyles: { base: "bg-black text-white py-0 my-0 rounded-none", variants: { isFocused: { true: "bg-[#909096]" }, isDisabled: { true: "text-white", false: "text-white" } } }, id: P, children: P }, P)) }), E.jsx("div", { className: "self-end", children: E.jsx(rk, { customInputStyles: "border-none text-right dark:text-zinc-400 font-medium orientation-vertical:hidden", isReadOnly: !0, value: w(o) }) })] }), E.jsx("div", { className: "border-t border-[#D8D8DA]" }), E.jsxs("div", { className: "flex flex-row items-center pb-3 mx-3", children: [E.jsx("div", { className: "pr-2 dark:text-zinc-400 font-medium", children: "On this page" }), E.jsx(Qa, { size: 18 })] }), E.jsx("div", { className: "w-full", children: E.jsx("div", { className: "flex flex-row flex-wrap w-full gap-2", children: c.map((P, R) => E.jsx(y, { color: P }, `${P.toString()}-${R}`)) }) })] }) }) })] }) }));
}
var Dk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function RS(e) {
  var { children: t } = e, n = Dk(e, ["children"]);
  return E.jsx(R9, Object.assign({}, n, { className: Te(n.className, "flex gap-1"), children: t }));
}
const Ck = de({
  extend: ze,
  base: "relative rounded"
});
function MS(e) {
  return E.jsx(M9, Object.assign({}, e, { className: Ck, children: ({ isSelected: t }) => E.jsxs(E.Fragment, { children: [E.jsx(S5, {}), t && E.jsx("div", { className: "absolute top-0 left-0 w-full h-full border-2 border-black dark:border-white outline outline-2 outline-white dark:outline-black -outline-offset-4 rounded forced-color-adjust-none" })] }) }));
}
function NS(e) {
  return E.jsxs(L9, Object.assign({}, e, { outerRadius: 100, innerRadius: 74, children: [E.jsx(H9, { className: "disabled:bg-gray-300 disabled:dark:bg-zinc-800 disabled:forced-colors:bg-[GrayText]", style: ({ defaultStyle: t, isDisabled: n }) => Object.assign(Object.assign({}, t), { background: n ? void 0 : `${t.background}, repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px` }) }), E.jsx(Gi, {})] }));
}
var Ek = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function VS(e) {
  var { label: t, description: n, errorMessage: r, children: a, items: l } = e, i = Ek(e, ["label", "description", "errorMessage", "children", "items"]);
  return E.jsxs(Y1, Object.assign({}, i, { className: Te(i.className, "group flex flex-col gap-1"), children: [E.jsx(bt, { children: t }), E.jsxs(hl, { children: [E.jsx(ba, {}), E.jsx(In, { variant: "icon", className: "w-6 mr-1 rounded outline-offset-0 ", children: E.jsx(Qa, { "aria-hidden": !0, className: "w-4 h-4" }) })] }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r }), E.jsx(Nr, { className: "w-[--trigger-width]", children: E.jsx(fl, { items: l, className: "outline-0 p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]", children: a }) })] }));
}
function IS(e) {
  return E.jsx(B5, Object.assign({}, e));
}
function OS(e) {
  return E.jsx(F5, Object.assign({}, e));
}
var wk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function zS(e) {
  var { label: t, description: n, errorMessage: r } = e, a = wk(e, ["label", "description", "errorMessage"]);
  return E.jsxs(iE, Object.assign({}, a, { className: Te(a.className, "flex flex-col gap-1"), children: [t && E.jsx(bt, { children: t }), E.jsx(Ja, {}), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r })] }));
}
const Pk = de({
  base: "inline p-0.5 type-literal:px-0 rounded outline outline-0 forced-color-adjust-none caret-transparent text-gray-800 dark:text-zinc-200 forced-colors:text-[ButtonText]",
  variants: {
    isPlaceholder: {
      true: "text-gray-600 dark:text-zinc-400 italic"
    },
    isDisabled: {
      true: "text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText]"
    },
    isFocused: {
      true: "bg-blue-600 text-white dark:text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]"
    }
  }
});
function Ja(e) {
  return E.jsx(uE, Object.assign({ className: (t) => k5(Object.assign(Object.assign({}, t), { class: "block min-w-[150px] px-2 py-1.5 text-sm" })) }, e, { children: (t) => E.jsx(dE, { segment: t, className: Pk }) }));
}
var kk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function KS(e) {
  var { label: t, description: n, errorMessage: r } = e, a = kk(e, ["label", "description", "errorMessage"]);
  return E.jsxs(hE, Object.assign({}, a, { className: Te(a.className, "group flex flex-col gap-1"), children: [t && E.jsx(bt, { children: t }), E.jsxs(hl, { className: "min-w-[208px] w-auto", children: [E.jsx(Ja, { className: "flex-1 min-w-[150px] px-2 py-1.5 text-sm" }), E.jsx(In, { variant: "icon", className: "w-6 mr-1 rounded outline-offset-0", children: E.jsx(Wc, { "aria-hidden": !0, className: "w-4 h-4" }) })] }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r }), E.jsx(Nr, { children: E.jsx(Wi, { children: E.jsx(YP, {}) }) })] }));
}
var Sk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Bk = de({
  extend: ze,
  base: "w-full h-full flex items-center justify-center rounded-full forced-color-adjust-none text-zinc-900 dark:text-zinc-200",
  variants: {
    selectionState: {
      none: "group-hover:bg-gray-100 dark:group-hover:bg-zinc-700 group-pressed:bg-gray-200 dark:group-pressed:bg-zinc-600",
      middle: [
        "group-hover:bg-blue-200 dark:group-hover:bg-blue-900 forced-colors:group-hover:bg-[Highlight]",
        "group-invalid:group-hover:bg-red-200 dark:group-invalid:group-hover:bg-red-900 forced-colors:group-invalid:group-hover:bg-[Mark]",
        "group-pressed:bg-blue-300 dark:group-pressed:bg-blue-800 forced-colors:group-pressed:bg-[Highlight] forced-colors:text-[HighlightText]",
        "group-invalid:group-pressed:bg-red-300 dark:group-invalid:group-pressed:bg-red-800 forced-colors:group-invalid:group-pressed:bg-[Mark]"
      ],
      cap: "bg-blue-600 group-invalid:bg-red-600 forced-colors:bg-[Highlight] forced-colors:group-invalid:bg-[Mark] text-white forced-colors:text-[HighlightText]"
    },
    isDisabled: {
      true: "text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  }
});
function Fk(e) {
  var { errorMessage: t } = e, n = Sk(e, ["errorMessage"]);
  return E.jsxs(c9, Object.assign({}, n, { children: [E.jsx(w5, {}), E.jsxs(J$, { className: "[&_td]:px-0", children: [E.jsx(P5, {}), E.jsx(xs, { children: (r) => E.jsx(t1, { date: r, className: "group w-9 h-9 text-sm outline outline-0 cursor-default outside-month:text-gray-300 selected:bg-blue-100 dark:selected:bg-blue-700/30 forced-colors:selected:bg-[Highlight] invalid:selected:bg-red-100 dark:invalid:selected:bg-red-700/30 forced-colors:invalid:selected:bg-[Mark] [td:first-child_&]:rounded-s-full selection-start:rounded-s-full [td:last-child_&]:rounded-e-full selection-end:rounded-e-full", children: ({ formattedDate: a, isSelected: l, isSelectionStart: i, isSelectionEnd: o, isFocusVisible: u, isDisabled: s }) => E.jsx("span", { className: Bk({
    selectionState: l && (i || o) ? "cap" : l ? "middle" : "none",
    isDisabled: s,
    isFocusVisible: u
  }), children: a }) }) })] }), t && E.jsx(sl, { slot: "errorMessage", className: "text-sm text-red-600", children: t })] }));
}
var Ak = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function jS(e) {
  var { label: t, description: n, errorMessage: r } = e, a = Ak(e, ["label", "description", "errorMessage"]);
  return E.jsxs(mE, Object.assign({}, a, { className: Te(a.className, "group flex flex-col gap-1"), children: [t && E.jsx(bt, { children: t }), E.jsxs(hl, { className: "min-w-[208px] w-auto", children: [E.jsx(Ja, { slot: "start", className: "px-2 py-1.5 text-sm" }), E.jsx("span", { "aria-hidden": "true", className: "text-gray-800 dark:text-zinc-200 forced-colors:text-[ButtonText] group-disabled:text-gray-200 group-disabled:dark:text-zinc-600 group-disabled:forced-colors:text-[GrayText]", children: "–" }), E.jsx(Ja, { slot: "end", className: "flex-1 px-2 py-1.5 text-sm" }), E.jsx(In, { variant: "icon", className: "w-6 mr-1 rounded outline-offset-0", children: E.jsx(Wc, { "aria-hidden": !0, className: "w-4 h-4" }) })] }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r }), E.jsx(Nr, { children: E.jsx(Wi, { children: E.jsx(Fk, {}) }) })] }));
}
var Ls = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Tk = de({
  base: "group min-w-64 border dark:border-zinc-600 rounded-lg text-gray-900 dark:text-zinc-200",
  variants: {
    isInGroup: {
      true: "border-0 border-b last:border-b-0 rounded-b-none last:rounded-b-lg"
    }
  }
}), Rk = de({
  extend: ze,
  base: "rounded-lg flex gap-2 items-center w-full text-start p-2 cursor-default",
  variants: {
    isDisabled: {
      true: "text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    },
    isInGroup: {
      true: "-outline-offset-2 rounded-none group-first:rounded-t-lg group-last:rounded-b-lg"
    }
  }
}), Mk = de({
  base: "w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform duration-200 ease-in-out",
  variants: {
    isExpanded: {
      true: "transform rotate-90"
    },
    isDisabled: {
      true: "text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  }
});
function LS(e) {
  var { children: t } = e, n = Ls(e, ["children"]);
  const r = U(_i) !== null;
  return E.jsx(yE, Object.assign({}, n, { className: et(n.className, (a, l) => Tk(Object.assign(Object.assign({}, l), { isInGroup: r, className: a }))), children: t }));
}
function HS({ children: e }) {
  const { isExpanded: t } = U(X1), n = U(_i) !== null;
  return E.jsx(Rs, { className: "text-lg font-semibold", children: E.jsx(ur, { slot: "trigger", className: (r) => Rk(Object.assign(Object.assign({}, r), { isInGroup: n })), children: ({ isDisabled: r }) => E.jsxs(E.Fragment, { children: [E.jsx(Oa, { "aria-hidden": !0, className: Mk({ isExpanded: t, isDisabled: r }) }), e] }) }) });
}
function _S(e) {
  var { children: t } = e, n = Ls(e, ["children"]);
  return E.jsx($E, Object.assign({}, n, { className: Te(n.className, "group-data-[expanded]:px-4 group-data-[expanded]:py-2"), children: t }));
}
function US(e) {
  var { children: t } = e, n = Ls(e, ["children"]);
  return E.jsx(vE, Object.assign({}, n, { className: Te(n.className, "border dark:border-zinc-600 rounded-lg"), children: t }));
}
function WS(e) {
  return E.jsx(t9, Object.assign({}, e, { className: dr("flex flex-col gap-4", e.className) }));
}
var A5 = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function GS(e) {
  var { children: t } = e, n = A5(e, ["children"]);
  return E.jsx(DE, Object.assign({}, n, { className: Te(n.className, "overflow-auto relative border dark:border-zinc-600 rounded-lg"), children: t }));
}
const Nk = de({
  extend: ze,
  base: "relative flex gap-3 cursor-default select-none py-2 px-3 text-sm text-gray-900 dark:text-zinc-200 border-y dark:border-y-zinc-700 border-transparent first:border-t-0 last:border-b-0 first:rounded-t-md last:rounded-b-md -mb-px last:mb-0 -outline-offset-2",
  variants: {
    isSelected: {
      false: "hover:bg-gray-100 dark:hover:bg-zinc-700/60",
      true: "bg-blue-100 dark:bg-blue-700/30 hover:bg-blue-200 dark:hover:bg-blue-700/40 border-y-blue-200 dark:border-y-blue-900 z-20"
    },
    isDisabled: {
      true: "text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText] z-10"
    }
  }
});
function ZS(e) {
  var { children: t } = e, n = A5(e, ["children"]);
  const r = typeof t == "string" ? t : void 0;
  return E.jsx(EE, Object.assign({ textValue: r }, n, { className: Nk, children: ({ selectionMode: a, selectionBehavior: l, allowsDragging: i }) => E.jsxs(E.Fragment, { children: [i && E.jsx(ur, { slot: "drag", children: "≡" }), a === "multiple" && l === "toggle" && E.jsx(js, { slot: "selection" }), t] }) }));
}
function YS(e) {
  return E.jsx(Nr, { placement: e.placement, className: "min-w-[150px]", children: E.jsx(Y9, Object.assign({}, e, { className: "p-1 outline outline-0 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]" })) });
}
function qS(e) {
  return E.jsx(Q9, Object.assign({}, e, { children: et(e.children, (t, { selectionMode: n, isSelected: r, hasSubmenu: a }) => E.jsxs(E.Fragment, { children: [n !== "none" && E.jsx("span", { className: "flex items-center w-4", children: r && E.jsx(ku, { "aria-hidden": !0, className: "w-4 h-4" }) }), E.jsx("span", { className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold", children: t }), a && E.jsx(Oa, { "aria-hidden": !0, className: "absolute w-4 h-4 right-2" })] })) }));
}
function XS(e) {
  return E.jsx(z1, Object.assign({}, e, { className: "mx-3 my-1 border-b border-gray-300 dark:border-zinc-700" }));
}
function JS(e) {
  return E.jsxs(J9, { className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px]", children: [E.jsx(O1, { className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y dark:border-y-zinc-700 [&+*]:mt-1", children: e.title }), E.jsx(Lt, { items: e.items, children: e.children })] });
}
var Vk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function QS(e) {
  var { label: t } = e, n = Vk(e, ["label"]);
  return E.jsx(FE, Object.assign({}, n, { className: Te(n.className, "flex flex-col gap-1"), children: ({ percentage: r, valueText: a }) => E.jsxs(E.Fragment, { children: [E.jsxs("div", { className: "flex justify-between gap-2", children: [E.jsx(bt, { children: t }), E.jsxs("span", { className: `text-sm ${r >= 80 ? "text-red-600 dark:text-red-500" : "text-gray-600 dark:text-zinc-400"}`, children: [r >= 80 && E.jsx(mx, { "aria-label": "Alert", className: "inline-block w-4 h-4 align-text-bottom" }), " " + a] })] }), E.jsx("div", { className: "w-64 h-2 rounded-full bg-gray-300 dark:bg-zinc-700 outline outline-1 -outline-offset-1 outline-transparent relative", children: E.jsx("div", { className: `absolute top-0 left-0 h-full rounded-full ${Ik(r)} forced-colors:bg-[Highlight]`, style: { width: r + "%" } }) })] }) }));
}
function Ik(e) {
  return e < 70 ? "bg-green-600" : e < 80 ? "bg-orange-500" : "bg-red-600";
}
const Ok = de({
  base: "fixed top-0 left-0 w-full h-[--visual-viewport-height] isolate z-20 bg-black/[15%] flex items-center justify-center p-4 text-center backdrop-blur-lg",
  variants: {
    isEntering: {
      true: "animate-in fade-in duration-200 ease-out"
    },
    isExiting: {
      true: "animate-out fade-out duration-200 ease-in"
    }
  }
}), zk = de({
  base: "w-full max-w-md max-h-full rounded-2xl bg-white dark:bg-zinc-800/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] text-left align-middle text-slate-700 dark:text-zinc-300 shadow-2xl bg-clip-padding border border-black/10 dark:border-white/10",
  variants: {
    isEntering: {
      true: "animate-in zoom-in-105 ease-out duration-200"
    },
    isExiting: {
      true: "animate-out zoom-out-95 ease-in duration-200"
    }
  }
});
function eB(e) {
  return E.jsx(Q1, Object.assign({}, e, { className: Ok, children: E.jsx(TE, Object.assign({}, e, { className: zk })) }));
}
var T5 = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Kc = {
  gray: "bg-gray-100 text-gray-600 border-gray-200 hover:border-gray-300 dark:bg-zinc-700 dark:text-zinc-300 dark:border-zinc-600 dark:hover:border-zinc-500",
  green: "bg-green-100 text-green-700 border-green-200 hover:border-green-300 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10 dark:hover:border-green-300/20",
  yellow: "bg-yellow-100 text-yellow-700 border-yellow-200 hover:border-yellow-300 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10 dark:hover:border-yellow-300/20",
  blue: "bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10 dark:hover:border-blue-400/20"
}, R5 = G("gray"), Kk = de({
  extend: ze,
  base: "transition cursor-default text-xs rounded-full border px-3 py-0.5 flex items-center max-w-fit gap-1",
  variants: {
    color: {
      gray: "",
      green: "",
      yellow: "",
      blue: ""
    },
    allowsRemoving: {
      true: "pr-1"
    },
    isSelected: {
      true: "bg-blue-600 text-white border-transparent forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] forced-color-adjust-none"
    },
    isDisabled: {
      true: "pr-3 bg-gray-100 dark:bg-transparent dark:border-white/20 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  },
  compoundVariants: Object.keys(Kc).map((e) => ({
    isSelected: !1,
    isDisabled: !1,
    color: e,
    class: Kc[e]
  }))
});
function jk(e) {
  var { label: t, description: n, errorMessage: r, items: a, children: l, renderEmptyState: i } = e, o = T5(e, ["label", "description", "errorMessage", "items", "children", "renderEmptyState"]);
  return E.jsxs(hw, Object.assign({}, o, { className: dr("flex flex-col gap-1", o.className), children: [E.jsx(bt, { children: t }), E.jsx(R5.Provider, { value: o.color || "gray", children: E.jsx(vw, { items: a, renderEmptyState: i, className: "flex flex-wrap gap-1", children: l }) }), n && E.jsx(Nt, { children: n }), r && E.jsx(sl, { slot: "errorMessage", className: "text-sm text-red-600", children: r })] }));
}
const Lk = de({
  extend: ze,
  base: "cursor-default rounded-full transition-[background-color] p-0.5 flex items-center justify-center hover:bg-black/10 dark:hover:bg-white/10 pressed:bg-black/20 dark:pressed:bg-white/20"
});
function Hk(e) {
  var { children: t, color: n, isDisabled: r } = e, a = T5(e, ["children", "color", "isDisabled"]);
  let l = typeof t == "string" ? t : void 0, i = U(R5);
  return E.jsx(yw, Object.assign({}, a, { isDisabled: r, textValue: l, className: et(a.className, (o, u) => Kk(Object.assign(Object.assign({}, u), { className: o, color: n || i }))), children: ({ allowsRemoving: o }) => E.jsxs(E.Fragment, { children: [t, o && !r && E.jsx(ur, { slot: "remove", className: Lk, children: E.jsx(Su, { "aria-hidden": !0, className: "w-3 h-3" }) })] }) }));
}
var _k = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Uk = de({
  extend: ze,
  base: "group flex flex-grow items-center min-h-9 bg-white dark:bg-zinc-900 forced-colors:bg-[Field] border-2 rounded-lg flex-wrap overflow-hidden",
  variants: Object.assign(Object.assign({}, ir.variants), { isDisabled: {
    true: "bg-gray-50 hover:bg-gray-100 text-gray-200"
  } })
});
function tB(e) {
  var { label: t, description: n, errorMessage: r, children: a, items: l, selectedKeys: i, onAdd: o, onRemove: u, isDisabled: s } = e, d = _k(e, ["label", "description", "errorMessage", "children", "items", "selectedKeys", "onAdd", "onRemove", "isDisabled"]);
  const c = Array.from(l || []), f = c.filter((D) => i.includes(D.id)), b = c.filter((D) => !i.includes(D.id)), [p, h] = q({
    selectedKey: null,
    inputValue: ""
  }), m = x.useRef(null), [v, y] = x.useState(0);
  re(() => {
    const D = m.current;
    if (!D)
      return;
    const P = new ResizeObserver((R) => {
      for (const V of R)
        y(V.target.clientWidth);
    });
    return P.observe(D), () => {
      P.unobserve(D);
    };
  }, [m]);
  const w = (D) => {
    if (!(!D || !b.length || i.includes(D))) {
      h({
        selectedKey: D,
        inputValue: ""
      });
      for (const P of b)
        if (P.id === D) {
          o(D);
          break;
        }
    }
  }, C = ie((D) => {
    const P = D.values().next().value;
    !c.length || !P || s || u(P);
  }, [l, u]);
  return E.jsxs("div", { className: "flex flex-col gap-1 flex-grow ", children: [E.jsx(bt, { id: "multi-select-combo-box-label", children: t }), E.jsxs("div", { ref: m, className: Uk({ isDisabled: s }), children: [i.length > 0 && E.jsx(jk, { className: "gap-0 pl-1 py-1", selectionMode: "none", items: f, onSelectionChange: () => {
  }, onRemove: C, children: (D) => E.jsx(Hk, { isDisabled: s, children: D.textValue }) }), E.jsxs(Y1, Object.assign({}, d, { isDisabled: s, className: "flex-grow", "aria-labelledby": "multi-select-combo-box-label", selectedKey: p.selectedKey, inputValue: p.inputValue, onInputChange: (D) => h((P) => ({ inputValue: D, selectedKey: D === "" ? null : P.selectedKey })), onSelectionChange: w, children: [E.jsxs(Ri, { className: "flex flex-row flex-grow gap-1 w-full", children: [E.jsx(ba, { onBlur: () => h({ inputValue: "", selectedKey: null }), className: "flex-1 border-0 flex-grow px-2 py-0 outline-0 focus:ring-0 bg-inherit placeholder-shown:italic" }), E.jsx(In, { variant: "icon", className: "w-6 mr-1 rounded outline-offset-0 ", children: E.jsx(Qa, { "aria-hidden": !0, className: "w-4 h-4" }) })] }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r }), E.jsx(Nr, { style: { width: `${v}px` }, triggerRef: m, className: "w-[--trigger-width]", children: E.jsx(fl, { selectionMode: "multiple", items: b, className: "outline-0 p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]", children: a }) })] }))] })] });
}
const nB = pk;
var Wk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function rB(e) {
  var { label: t, description: n, errorMessage: r } = e, a = Wk(e, ["label", "description", "errorMessage"]);
  return E.jsxs(IE, Object.assign({}, a, { className: Te(a.className, "group flex flex-col gap-1"), children: [E.jsx(bt, { children: t }), E.jsx(hl, { children: (l) => E.jsxs(E.Fragment, { children: [E.jsx(ba, {}), E.jsxs("div", { className: ir(Object.assign(Object.assign({}, l), { class: "flex flex-col border-s-2" })), children: [E.jsx(jc, { slot: "increment", children: E.jsx(ix, { "aria-hidden": !0, className: "w-4 h-4" }) }), E.jsx("div", { className: ir(Object.assign(Object.assign({}, l), { class: "border-b-2" })) }), E.jsx(jc, { slot: "decrement", children: E.jsx(Qa, { "aria-hidden": !0, className: "w-4 h-4" }) })] })] }) }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r })] }));
}
function jc(e) {
  return E.jsx(ur, Object.assign({}, e, { className: "px-0.5 cursor-default text-gray-500 pressed:bg-gray-100 group-disabled:text-gray-200 dark:text-zinc-400 dark:pressed:bg-zinc-800 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]" }));
}
var Gk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function Zk(e) {
  var { label: t, barClassName: n } = e, r = Gk(e, ["label", "barClassName"]);
  return E.jsx(t$, Object.assign({}, r, { className: Te(r.className, "flex flex-col gap-1"), children: ({ percentage: a, valueText: l, isIndeterminate: i }) => E.jsxs(E.Fragment, { children: [E.jsxs("div", { className: "flex justify-between gap-2", children: [E.jsx(bt, { children: t }), E.jsx("span", { className: "text-sm text-gray-600 dark:text-zinc-400", children: l })] }), E.jsx("div", { className: dr("w-64 h-2 rounded-full bg-gray-300 dark:bg-zinc-700 outline outline-1 -outline-offset-1 outline-transparent relative overflow-hidden", n), children: E.jsx("div", { className: `absolute top-0 h-full rounded-full bg-[#2356E7] forced-colors:bg-[Highlight] transition-all ${i ? "animate-[indeterminate_1s_ease-in-out_infinite]" : "left-0"}`, style: Object.assign({ width: i ? "40%" : `${a}%` }, i && {
    animation: "indeterminate 1s ease-in-out infinite",
    "@keyframes indeterminate": {
      "0%": { left: "-40%" },
      "100%": { left: "100%" }
    }
  }) }) })] }) }));
}
var Yk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function qk(e) {
  var { label: t, circleSize: n } = e, r = Yk(e, ["label", "circleSize"]);
  const a = n ?? 40, l = a / 2, i = 4, o = l - i, u = 2 * o * Math.PI;
  return E.jsx(t$, Object.assign({}, r, { className: Te(r.className, "flex flex-col items-center gap-2"), children: ({ percentage: s, valueText: d, isIndeterminate: c }) => E.jsxs(E.Fragment, { children: [E.jsx("div", { className: c ? "animate-spin" : void 0, children: E.jsxs("svg", { width: a, height: a, viewBox: `0 0 ${a} ${a}`, fill: "none", strokeWidth: i, children: [E.jsx("circle", { role: "presentation", cx: l, cy: l, r: o, className: "stroke-gray-300 dark:stroke-zinc-700" }), E.jsx("circle", { role: "presentation", cx: l, cy: l, r: o, className: "stroke-[#2356E7] forced-colors:stroke-[Highlight] transition-all", strokeDasharray: `${u * 0.75} ${u * 0.25}`, transform: `rotate(-90 ${l} ${l})` })] }) }), t && E.jsxs("div", { className: "flex justify-between gap-2", children: [E.jsx(bt, { children: t }), !c && E.jsx("span", { className: "text-sm text-gray-600 dark:text-zinc-400", children: d })] })] }) }));
}
function aB(e) {
  return E.jsxs(KE, Object.assign({}, e, { className: Te(e.className, "group flex flex-col gap-2"), children: [E.jsx(bt, { children: e.label }), E.jsx("div", { className: "flex group-orientation-vertical:flex-col gap-2 group-orientation-horizontal:gap-4", children: e.children }), e.description && E.jsx(Nt, { children: e.description }), E.jsx(Ht, { children: e.errorMessage })] }));
}
const Xk = de({
  extend: ze,
  base: "w-5 h-5 rounded-full border-2 bg-white dark:bg-zinc-900 transition-all",
  variants: {
    isSelected: {
      false: "border-gray-400 dark:border-zinc-400 group-pressed:border-gray-500 dark:group-pressed:border-zinc-300",
      true: "border-[7px] border-gray-700 dark:border-slate-300 forced-colors:!border-[Highlight] group-pressed:border-gray-800 dark:group-pressed:border-slate-200"
    },
    isInvalid: {
      true: "border-red-700 dark:border-red-600 group-pressed:border-red-800 dark:group-pressed:border-red-700 forced-colors:!border-[Mark]"
    },
    isDisabled: {
      true: "border-gray-200 dark:border-zinc-700 forced-colors:!border-[GrayText]"
    }
  }
});
function lB(e) {
  return E.jsx(jE, Object.assign({}, e, { className: Te(e.className, "flex gap-2 items-center group text-gray-800 disabled:text-gray-300 dark:text-zinc-200 dark:disabled:text-zinc-600 forced-colors:disabled:text-[GrayText] text-sm transition"), children: (t) => E.jsxs(E.Fragment, { children: [E.jsx("div", { className: Xk(t) }), e.children] }) }));
}
var Jk = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function iB(e) {
  var { label: t, description: n, errorMessage: r } = e, a = Jk(e, ["label", "description", "errorMessage"]);
  return E.jsxs(r9, Object.assign({}, a, { className: Te(a.className, "group flex flex-col gap-1 min-w-[40px]"), children: [t && E.jsx(bt, { children: t }), E.jsxs(hl, { children: [E.jsx(px, { "aria-hidden": !0, className: "w-4 h-4 ml-2 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText] group-disabled:text-gray-200 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]" }), E.jsx(ba, { className: "[&::-webkit-search-cancel-button]:hidden" }), E.jsx(In, { variant: "icon", className: "mr-1 w-6 group-empty:invisible", children: E.jsx(Su, { "aria-hidden": !0, className: "w-4 h-4" }) })] }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r })] }));
}
const Qk = de({
  base: "bg-gray-300 dark:bg-zinc-600 forced-colors:bg-[ButtonBorder]",
  variants: {
    orientation: {
      horizontal: "h-px w-full",
      vertical: "w-px"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});
function oB(e) {
  return E.jsx(z1, Object.assign({}, e, { className: Qk({ orientation: e.orientation, className: e.className }) }));
}
var Lc = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const eS = de({
  base: "rounded-full",
  variants: {
    orientation: {
      horizontal: "w-full h-[6px]",
      vertical: "h-full w-[6px] ml-[50%] -translate-x-[50%]"
    },
    isDisabled: {
      false: "bg-gray-300 dark:bg-zinc-500 forced-colors:bg-[ButtonBorder]",
      true: "bg-gray-100 dark:bg-zinc-800 forced-colors:bg-[GrayText]"
    }
  }
}), tS = de({
  extend: ze,
  base: "w-6 h-6 group-orientation-horizontal:mt-6 group-orientation-vertical:ml-3 rounded-full bg-gray-50 dark:bg-zinc-900 border-2 border-gray-700 dark:border-gray-300",
  variants: {
    isDragging: {
      true: "bg-gray-700 dark:bg-gray-300 forced-colors:bg-[ButtonBorder]"
    },
    isDisabled: {
      true: "border-gray-300 dark:border-zinc-700 forced-colors:border-[GrayText]"
    }
  }
});
function uB(e) {
  var { label: t, thumbLabels: n } = e, r = Lc(e, ["label", "thumbLabels"]);
  return E.jsxs(z9, Object.assign({}, r, { className: Te(r.className, "orientation-horizontal:grid orientation-vertical:flex grid-cols-[1fr_auto] flex-col items-center gap-2 orientation-horizontal:w-64"), children: [E.jsx(bt, { children: t }), E.jsx(Bs, { className: "text-sm text-gray-500 dark:text-zinc-400 font-medium orientation-vertical:hidden", children: ({ state: a }) => a.values.map((l, i) => a.getThumbValueLabel(i)).join(" – ") }), E.jsx(Fs, { className: "group col-span-2 orientation-horizontal:h-6 orientation-vertical:w-6 orientation-vertical:h-64 flex items-center", children: (a) => {
    var { state: l } = a, i = Lc(a, ["state"]);
    return E.jsxs(E.Fragment, { children: [E.jsx("div", { className: eS(i) }), l.values.map((o, u) => E.jsx(K9, { index: u, "aria-label": n == null ? void 0 : n[u], className: tS }, u))] });
  } })] }));
}
var nS = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const rS = de({
  extend: ze,
  base: "flex h-4 w-7 px-px items-center shrink-0 cursor-default rounded-full transition duration-200 ease-in-out shadow-inner border border-transparent",
  variants: {
    isSelected: {
      false: "bg-gray-400 dark:bg-zinc-400 group-pressed:bg-gray-500 dark:group-pressed:bg-zinc-300",
      true: "bg-gray-700 dark:bg-zinc-300 forced-colors:!bg-[Highlight] group-pressed:bg-gray-800 dark:group-pressed:bg-zinc-200"
    },
    isDisabled: {
      true: "bg-gray-200 dark:bg-zinc-700 forced-colors:group-selected:!bg-[GrayText] forced-colors:border-[GrayText]"
    }
  }
}), aS = de({
  base: "h-3 w-3 transform rounded-full bg-white dark:bg-zinc-900 outline outline-1 -outline-offset-1 outline-transparent shadow transition duration-200 ease-in-out",
  variants: {
    isSelected: {
      false: "translate-x-0",
      true: "translate-x-[100%]"
    },
    isDisabled: {
      true: "forced-colors:outline-[GrayText]"
    }
  }
});
function sB(e) {
  var { children: t } = e, n = nS(e, ["children"]);
  return E.jsx(GE, Object.assign({}, n, { className: Te(n.className, "group flex gap-2 items-center text-gray-800 disabled:text-gray-300 dark:text-zinc-200 dark:disabled:text-zinc-600 forced-colors:disabled:text-[GrayText] text-sm transition"), children: (r) => E.jsxs(E.Fragment, { children: [E.jsx("div", { className: rS(r), children: E.jsx("span", { className: aS(r) }) }), t] }) }));
}
var lS = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function dB(e) {
  return E.jsx(qE, { className: "max-h-[280px] w-[550px] overflow-auto scroll-pt-[2.281rem] relative border dark:border-zinc-600 rounded-lg", children: E.jsx(JE, Object.assign({}, e, { className: "border-separate border-spacing-0" })) });
}
const iS = de({
  extend: ze,
  base: "px-2 h-5 flex-1 flex gap-1 items-center overflow-hidden"
}), oS = de({
  extend: ze,
  base: "w-px px-[8px] translate-x-[8px] box-content py-1 h-5 bg-clip-content bg-gray-400 dark:bg-zinc-500 forced-colors:bg-[ButtonBorder] cursor-col-resize rounded resizing:bg-blue-600 forced-colors:resizing:bg-[Highlight] resizing:w-[2px] resizing:pl-[7px] -outline-offset-2"
});
function uS(e) {
  return E.jsx(l5, Object.assign({}, e, { className: Te(e.className, "[&:hover]:z-20 [&:focus-within]:z-20 text-start text-sm font-semibold text-gray-700 dark:text-zinc-300 cursor-default"), children: et(e.children, (t, { allowsSorting: n, sortDirection: r }) => E.jsxs("div", { className: "flex items-center", children: [E.jsxs(Ri, { role: "presentation", tabIndex: -1, className: iS, children: [E.jsx("span", { className: "truncate", children: t }), n && E.jsx("span", { className: `w-4 h-4 flex items-center justify-center transition ${r === "descending" ? "rotate-180" : ""}`, children: r && E.jsx(Q5, { "aria-hidden": !0, className: "w-4 h-4 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText]" }) })] }), !e.width && E.jsx(nw, { className: oS })] })) }));
}
function cB(e) {
  let { selectionBehavior: t, selectionMode: n, allowsDragging: r } = a5();
  return E.jsxs(ew, Object.assign({}, e, { className: Te(e.className, "sticky top-0 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 dark:supports-[-moz-appearance:none]:bg-zinc-700 forced-colors:bg-[Canvas] rounded-t-lg border-b dark:border-b-zinc-700"), children: [r && E.jsx(uS, {}), t === "toggle" && E.jsx(l5, { width: 36, minWidth: 36, className: "text-start text-sm font-semibold cursor-default p-2", children: n === "multiple" && E.jsx(js, { slot: "selection" }) }), E.jsx(Lt, { items: e.columns, children: e.children })] }));
}
const sS = de({
  extend: ze,
  base: "group/row relative cursor-default select-none -outline-offset-2 text-gray-900 disabled:text-gray-300 dark:text-zinc-200 dark:disabled:text-zinc-600 text-sm hover:bg-gray-100 dark:hover:bg-zinc-700/60 selected:bg-blue-100 selected:hover:bg-blue-200 dark:selected:bg-blue-700/30 dark:selected:hover:bg-blue-700/40"
});
function fB(e) {
  var { id: t, columns: n, children: r } = e, a = lS(e, ["id", "columns", "children"]);
  let { selectionBehavior: l, allowsDragging: i } = a5();
  return E.jsxs(rw, Object.assign({ id: t }, a, { className: sS, children: [i && E.jsx(Hc, { children: E.jsx(ur, { slot: "drag", children: "≡" }) }), l === "toggle" && E.jsx(Hc, { children: E.jsx(js, { slot: "selection" }) }), E.jsx(Lt, { items: n, children: r })] }));
}
const dS = de({
  extend: ze,
  base: "border-b dark:border-b-zinc-700 group-last/row:border-b-0 [--selected-border:theme(colors.blue.200)] dark:[--selected-border:theme(colors.blue.900)] group-selected/row:border-[--selected-border] [:has(+[data-selected])_&]:border-[--selected-border] p-2 truncate -outline-offset-2"
});
function Hc(e) {
  return E.jsx(aw, Object.assign({}, e, { className: dS }));
}
const cS = de({
  base: "flex gap-4",
  variants: {
    orientation: {
      horizontal: "flex-col",
      vertical: "flex-row w-[800px]"
    }
  }
});
function bB(e) {
  return E.jsx(uw, Object.assign({}, e, { className: et(e.className, (t, n) => cS(Object.assign(Object.assign({}, n), { className: t }))) }));
}
const fS = de({
  base: "flex gap-1",
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "flex-col items-start"
    }
  }
});
function pB(e) {
  return E.jsx(dw, Object.assign({}, e, { className: et(e.className, (t, n) => fS(Object.assign(Object.assign({}, n), { className: t }))) }));
}
const bS = de({
  extend: ze,
  base: "flex items-center cursor-default rounded-full px-4 py-1.5 text-sm font-medium transition forced-color-adjust-none",
  variants: {
    isSelected: {
      false: "text-gray-600 dark:text-zinc-300 hover:text-gray-700 pressed:text-gray-700 dark:hover:text-zinc-200 dark:pressed:text-zinc-200 hover:bg-gray-200 dark:hover:bg-zinc-800 pressed:bg-gray-200 dark:pressed:bg-zinc-800",
      true: "text-white dark:text-black forced-colors:text-[HighlightText] bg-gray-800 dark:bg-zinc-200 forced-colors:bg-[Highlight]"
    },
    isDisabled: {
      true: "text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText] selected:text-gray-300 dark:selected:text-zinc-500 forced-colors:selected:text-[HighlightText] selected:bg-gray-200 dark:selected:bg-zinc-600 forced-colors:selected:bg-[GrayText]"
    }
  }
});
function hB(e) {
  return E.jsx(fw, Object.assign({}, e, { className: et(e.className, (t, n) => bS(Object.assign(Object.assign({}, n), { className: t }))) }));
}
const pS = de({
  extend: ze,
  base: "flex-1 p-4 text-sm text-gray-900 dark:text-zinc-100"
});
function mB(e) {
  return E.jsx(bw, Object.assign({}, e, { className: et(e.className, (t, n) => pS(Object.assign(Object.assign({}, n), { className: t }))) }));
}
var hS = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const mS = de({
  extend: ze,
  base: "border-2 rounded-md",
  variants: Object.assign({ isFocused: ir.variants.isFocusWithin }, ir.variants)
});
function vB(e) {
  var { label: t, description: n, errorMessage: r } = e, a = hS(e, ["label", "description", "errorMessage"]);
  return E.jsxs(i9, Object.assign({}, a, { className: Te(a.className, "flex flex-col gap-1"), children: [t && E.jsx(bt, { children: t }), E.jsx(ba, { className: mS }), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r })] }));
}
var vS = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function gB(e) {
  var { label: t, description: n, errorMessage: r } = e, a = vS(e, ["label", "description", "errorMessage"]);
  return E.jsxs(oE, Object.assign({}, a, { children: [E.jsx(bt, { children: t }), E.jsx(Ja, {}), n && E.jsx(Nt, { children: n }), E.jsx(Ht, { children: r })] }));
}
let gS = de({
  extend: ze,
  base: "px-5 py-2 [&:has(svg:only-child)]:px-2 text-sm text-center transition rounded-lg border border-black/10 dark:border-white/10 forced-colors:border-[ButtonBorder] shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none cursor-default forced-color-adjust-none",
  variants: {
    isSelected: {
      false: "bg-gray-100 hover:bg-gray-200 pressed:bg-gray-300 text-gray-800 dark:bg-zinc-600 dark:hover:bg-zinc-500 dark:pressed:bg-zinc-400 dark:text-zinc-100 forced-colors:!bg-[ButtonFace] forced-colors:!text-[ButtonText]",
      true: "bg-gray-700 hover:bg-gray-800 pressed:bg-gray-900 text-white dark:bg-slate-300 dark:hover:bg-slate-200 dark:pressed:bg-slate-100 dark:text-black forced-colors:!bg-[Highlight] forced-colors:!text-[HighlightText]"
    },
    isDisabled: {
      true: "bg-gray-100 dark:bg-zinc-800 forced-colors:!bg-[ButtonFace] text-gray-300 dark:text-zinc-600 forced-colors:!text-[GrayText] border-black/5 dark:border-white/5 forced-colors:border-[GrayText]"
    }
  }
});
function yB(e) {
  return E.jsx(Cw, Object.assign({}, e, { className: et(e.className, (t, n) => gS(Object.assign(Object.assign({}, n), { className: t }))) }));
}
const yS = de({
  base: "flex gap-1",
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "flex-col"
    }
  }
});
function $B(e) {
  return E.jsx(xw, Object.assign({}, e, { className: et(e.className, (t) => yS({ orientation: e.orientation || "horizontal", className: t })) }));
}
const $S = de({
  base: "flex gap-2",
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "flex-col items-start"
    }
  }
});
function xB(e) {
  return E.jsx(Pw, Object.assign({}, e, { className: et(e.className, (t, n) => $S(Object.assign(Object.assign({}, n), { className: t }))) }));
}
var xS = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const DS = de({
  base: "group bg-slate-700 dark:bg-slate-600 border border-slate-800 dark:border-white/10 shadow-[inset_0_1px_0_0_theme(colors.gray.600)] dark:shadow-none text-white text-sm rounded-lg drop-shadow-lg will-change-transform px-3 py-1",
  variants: {
    isEntering: {
      true: "animate-in fade-in placement-bottom:slide-in-from-top-0.5 placement-top:slide-in-from-bottom-0.5 placement-left:slide-in-from-right-0.5 placement-right:slide-in-from-left-0.5 ease-out duration-200"
    },
    isExiting: {
      true: "animate-out fade-out placement-bottom:slide-out-to-top-0.5 placement-top:slide-out-to-bottom-0.5 placement-left:slide-out-to-right-0.5 placement-right:slide-out-to-left-0.5 ease-in duration-150"
    }
  }
});
function CS(e) {
  var { children: t } = e, n = xS(e, ["children"]);
  return E.jsxs(Sw, Object.assign({}, n, { offset: 10, className: et(n.className, (r, a) => DS(Object.assign(Object.assign({}, a), { className: r }))), children: [E.jsx(G1, { children: E.jsx("svg", { width: 8, height: 8, viewBox: "0 0 8 8", className: "fill-slate-700 dark:fill-slate-600 forced-colors:fill-[Canvas] stroke-gray-800 dark:stroke-white/10 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90", children: E.jsx("path", { d: "M0 0 L4 4 L8 0" }) }) }), t] }));
}
function DB({ children: e, content: t, triggerProps: n, tooltipProps: r, tooltipClassName: a }) {
  const l = Te(r == null ? void 0 : r.className, a || "");
  return E.jsxs(kw, Object.assign({}, n, { children: [E.jsx(E6, { children: E.jsx("span", { role: "button", className: "cursor-default", children: e }) }), E.jsx(CS, Object.assign({}, r, { className: l, children: t }))] }));
}
function CB({ label: e = "Loading...", fullScreen: t = !0, className: n, barClassName: r, variant: a = "bar", circleSize: l }) {
  const i = a === "circle" ? qk : Zk;
  return E.jsx("div", { className: [
    "flex items-center justify-center",
    t ? "min-h-screen" : "h-full w-full",
    n
  ].filter(Boolean).join(" "), children: E.jsx(i, Object.assign({ label: e, isIndeterminate: !0 }, a === "bar" ? { barClassName: r } : { circleSize: l })) });
}
export {
  PS as AlertDialog,
  SS as Breadcrumb,
  kS as Breadcrumbs,
  In as Button,
  YP as Calendar,
  P5 as CalendarGridHeader,
  w5 as CalendarHeader,
  Hc as Cell,
  js as Checkbox,
  BS as CheckboxGroup,
  ek as ColorArea,
  rk as ColorField,
  TS as ColorPicker,
  ik as ColorSlider,
  S5 as ColorSwatch,
  RS as ColorSwatchPicker,
  MS as ColorSwatchPickerItem,
  Gi as ColorThumb,
  NS as ColorWheel,
  uS as Column,
  VS as ComboBox,
  IS as ComboBoxItem,
  OS as ComboBoxSection,
  zS as DateField,
  Ja as DateInput,
  KS as DatePicker,
  jS as DateRangePicker,
  Nt as Description,
  Wi as Dialog,
  LS as Disclosure,
  US as DisclosureGroup,
  HS as DisclosureHeader,
  _S as DisclosurePanel,
  B5 as DropdownItem,
  F5 as DropdownSection,
  Ht as FieldError,
  hl as FieldGroup,
  WS as Form,
  GS as GridList,
  ZS as GridListItem,
  ba as Input,
  bt as Label,
  WP as Link,
  FS as ListBox,
  pk as ListBoxItem,
  CB as LoadingFallback,
  YS as Menu,
  qS as MenuItem,
  JS as MenuSection,
  XS as MenuSeparator,
  QS as Meter,
  eB as Modal,
  tB as MultiSelectComboBox,
  nB as MultiSelectComboBoxItem,
  rB as NumberField,
  Nr as Popover,
  Zk as ProgressBar,
  qk as ProgressCircle,
  lB as Radio,
  aB as RadioGroup,
  Fk as RangeCalendar,
  fB as Row,
  iB as SearchField,
  gk as Select,
  yk as SelectItem,
  AS as SelectSection,
  oB as Separator,
  uB as Slider,
  sB as Switch,
  hB as Tab,
  pB as TabList,
  mB as TabPanel,
  dB as Table,
  cB as TableHeader,
  bB as Tabs,
  Hk as Tag,
  jk as TagGroup,
  vB as TextField,
  gB as TimeField,
  yB as ToggleButton,
  $B as ToggleButtonGroup,
  xB as Toolbar,
  CS as Tooltip,
  DB as TooltipWithTrigger,
  hk as dropdownItemStyles,
  ir as fieldBorderStyles,
  k5 as fieldGroupStyles,
  bk as itemStyles
};
//# sourceMappingURL=ui.es.js.map
